export default {
  'pages.layouts.userLayout.title': 'TaoExpress 관리자 시스템',
  'pages.layouts.adminPanel.title': '관리자 패널',
  'pages.login.accountLogin.tab': '계정 로그인',
  'pages.login.accountLogin.errorMessage':
    '잘못된 아이디/비밀번호(admin/ant.design)',
  'pages.login.failure': '로그인 실패, 다시 시도해주세요!',
  'pages.login.success': '로그인 성공!',
  'pages.login.username.placeholder': '아이디: admin 또는 user',
  'pages.login.username.required': '아이디를 입력하세요!',
  'pages.login.password.required': '비밀번호를 입력하세요!',
  'pages.login.phoneLogin.tab': '휴대폰 로그인',
  'pages.login.phoneLogin.errorMessage': '인증 코드 오류',
  'pages.login.phoneNumber.placeholder': '휴대폰 번호',
  'pages.login.phoneNumber.required': '휴대폰 번호를 입력하세요!',
  'pages.login.phoneNumber.invalid': '유효하지 않은 휴대폰 번호입니다!',
  'pages.login.captcha.placeholder': '인증 코드',
  'pages.login.captcha.required': '인증 코드를 입력하세요!',
  'pages.login.phoneLogin.getVerificationCode': '인증코드 받기',
  'pages.getCaptchaSecondText': '초',
  'pages.login.rememberMe': '자동 로그인',
  'pages.login.forgotPassword': '비밀번호 찾기',
  'pages.login.submit': '로그인',
  'pages.login.loginWith': '다른 방법으로 로그인:',
  'pages.login.registerAccount': '회원가입',
  'pages.login.adminCenter': '관리자 센터',
  'pages.login.adminSystem': '관리자 시스템',
  'pages.login.signInTitle': '관리자 로그인',
  'pages.login.signInDescription': 'TodayMall 관리자 패널에 접속합니다',
  'pages.login.identifier.label': '이메일 또는 ID',
  'pages.login.password.label': '비밀번호',
  'pages.login.email.placeholder': '이메일 주소',
  'pages.login.email.required': '이메일을 입력하세요',
  'pages.login.email.invalid': '올바른 이메일 형식이 아닙니다',
  'pages.login.identifier.placeholder': '이메일 또는 회원 ID',
  'pages.login.identifier.required': '이메일 또는 회원 ID를 입력해 주세요',
  'pages.login.password.placeholder': '비밀번호',
  'pages.login.keepLoggedIn': '로그인 상태 유지',
  'pages.login.secureAccessNotice': '승인된 관리자 계정만 접근할 수 있습니다.',
  'pages.login.forgotPasswordQuestion': '비밀번호를 잊으셨나요?',
  'pages.welcome.link': '환영합니다',
  'pages.welcome.alertMessage': '더 빠르고 강력한 컴포넌트가 출시되었습니다.',
  'pages.404.subTitle': '죄송합니다. 방문하신 페이지가 존재하지 않습니다.',
  'pages.404.buttonText': '홈으로',
  'pages.admin.subPage.title': '이 페이지는 관리자만 볼 수 있습니다',
  'pages.admin.subPage.alertMessage':
    'Umi ui가 출시되었습니다. npm run ui로 시작하세요.',
  'pages.searchTable.createForm.newRule': '새 규칙',
  'pages.searchTable.updateForm.ruleConfig': '규칙 구성',
  'pages.searchTable.updateForm.basicConfig': '기본 정보',
  'pages.searchTable.updateForm.ruleName.nameLabel': '규칙 이름',
  'pages.searchTable.updateForm.ruleName.nameRules': '규칙 이름을 입력하세요!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '규칙 설명',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '최소 5자 이상 입력하세요',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '최소 5자 이상의 규칙 설명을 입력하세요!',
  'pages.searchTable.updateForm.ruleProps.title': '속성 구성',
  'pages.searchTable.updateForm.object': '모니터링 대상',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '규칙 템플릿',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '규칙 유형',
  'pages.searchTable.updateForm.schedulingPeriod.title': '스케줄링 기간 설정',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '시작 시간',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '시작 시간을 선택하세요!',
  'pages.searchTable.titleDesc': '설명',
  'pages.searchTable.ruleName': '규칙 이름은 필수입니다',
  'pages.searchTable.titleCallNo': '서비스 호출 횟수',
  'pages.searchTable.titleStatus': '상태',
  'pages.searchTable.nameStatus.default': '기본',
  'pages.searchTable.nameStatus.running': '실행중',
  'pages.searchTable.nameStatus.online': '온라인',
  'pages.searchTable.nameStatus.abnormal': '비정상',
  'pages.searchTable.titleUpdatedAt': '마지막 스케줄',
  'pages.searchTable.exception': '예외 사유를 입력하세요!',
  'pages.searchTable.titleOption': '옵션',
  'pages.searchTable.config': '구성',
  'pages.searchTable.subscribeAlert': '알림 구독',
  'pages.searchTable.title': '조회 폼',
  'pages.searchTable.new': '신규',
  'pages.searchTable.chosen': '선택됨',
  'pages.searchTable.item': '항목',
  'pages.searchTable.totalServiceCalls': '총 서비스 호출 횟수',
  'pages.searchTable.tenThousand': '만',
  'pages.searchTable.batchDeletion': '일괄 삭제',
  'pages.searchTable.batchApproval': '일괄 승인',
  'pages.searchTable.selectItemsToDelete': '삭제할 항목을 선택하세요',
  
  // Home Dashboard
  'pages.home.todayOrders': '오늘 주문수',
  'pages.home.todaySales': '오늘 매출액',
  'pages.home.processingRate': '배송처리율',
  'pages.home.newMembers': '신규회원',
  'pages.home.orderStatus': '현재 주문 상태',
  'pages.home.pendingPayment': '결제대기',
  'pages.home.pendingAddress': '배송지대기',
  'pages.home.inChinaWarehouse': '중국창고',
  'pages.home.inKoreaDelivery': '배송중',
  'pages.home.recentOrders': '실시간 주문 내역',
  'pages.home.pendingTasks': '처리해야 할 작업',
  'pages.home.pendingInquiries': '미답변 1:1 문의',
  'pages.home.salesGrowth': '오늘의 매출 성장률',
  'pages.home.comparedYesterday': '전일 대비 상승',
  'pages.home.goTo': '바로가기',
  'pages.home.count': '건',
  'pages.home.people': '명',
  'pages.home.won': '원',
  
  // Common
  'pages.common.search': '검색',
  'pages.common.reset': '초기화',
  'pages.common.yearN': '{n}년',
  'pages.common.monthN': '{n}월',
  'pages.common.add': '추가',
  'pages.common.edit': '수정',
  'pages.common.upload': '업로드',
  'pages.common.uploadSuccess': '업로드했습니다.',
  'pages.common.uploadFailed': '업로드에 실패했습니다.',
  'pages.common.change': '변경',
  'pages.common.delete': '삭제',
  'pages.common.save': '저장',
  'pages.common.cancel': '취소',
  'pages.common.confirm': '확인',
  'pages.common.actions': '작업',
  'pages.common.pagination.total': '전체 {total}개 중 {range0}-{range1}',
  'pages.common.id': 'ID',
  'pages.common.status': '상태',
  'pages.common.createdAt': '생성일',
  'pages.common.updatedAt': '수정일',
  'pages.common.clearFilter': '필터 초기화',
  'pages.common.export': '내보내기',
  /** 리스트·필터 툴바 엑셀 버튼 공통 라벨 */
  'pages.common.exportExcel': '엑셀 다운로드',
  'pages.common.exportSuccess': '데이터를 내보냈습니다',
  'pages.common.operate': '작업',
  'pages.common.yes': '예',
  'pages.common.no': '아니오',
  'pages.common.won': '₩',
  'pages.common.count': 'ea',
  'pages.common.unit': '개',
  'pages.common.people': '명',
  'pages.common.detail': '상세',
  'pages.common.close': '닫기',
  'pages.common.visible': '표시',
  'pages.common.hidden': '숨김',
  'pages.common.preview': '미리보기',
  'pages.common.view': '보기',
  'pages.common.active': '활성',
  'pages.common.inactive': '비활성',
  'pages.common.refresh': '새로고침',
  'pages.common.required': '필수 항목입니다',
  'pages.common.bold': '굵게',
  'pages.common.italic': '기울임',
  'pages.common.underline': '밑줄',
  'pages.common.alignLeft': '왼쪽 정렬',
  'pages.common.alignCenter': '가운데 정렬',
  'pages.common.alignRight': '오른쪽 정렬',
  'pages.common.image': '이미지',
  'pages.common.link': '링크',
  'pages.common.chooseFile': '파일 선택',
  'pages.common.list': '목록',
  'pages.common.use': '사용',
  'pages.common.notUse': '미사용',
  'pages.common.correction': '수정',
  'pages.common.addSuccess': '추가되었습니다',
  'pages.common.createSuccess': '생성되었습니다',
  'pages.common.createFailed': '생성 실패',
  'pages.common.updateSuccess': '수정되었습니다',
  'pages.common.updateFailed': '수정 실패',
  'pages.common.deleteSuccess': '삭제되었습니다',
  'pages.common.deleteFailed': '삭제 실패',
  'pages.common.saveSuccess': '저장되었습니다',
  'pages.common.deleteConfirm': '삭제 확인',
  
  // Order Status
  'pages.home.status.paymentComplete': '결제완료',
  'pages.home.status.pendingAddress': '배송지입력대기',
  'pages.home.status.inChinaWarehouse': '중국창고입고',
  'pages.home.status.inTransit': '배송중',
  'pages.home.status.delivered': '배송완료',
  
  // Time
  'pages.home.time.minutesAgo': '{minutes}분 전',
  'pages.home.time.hoursAgo': '{hours}시간 전',
  
  // Products List Page
  // Products Operation Data
  'pages.products.operationData.title': '운영 데이터',
  'pages.products.operationData.todayOrderAmount': '오늘 주문 금액',
  'pages.products.operationData.todayOrderCount': '오늘 주문 수',
  'pages.products.operationData.todayPayingUsers': '오늘 결제 인원',
  'pages.products.operationData.yesterday': '어제',
  'pages.products.operationData.monthOnMonthChange': '전월 대비 변화',
  'pages.products.operationData.transactionOverview': '거래 개요',
  'pages.products.operationData.query': '조회',
  'pages.products.operationData.reset': '초기화',
  'pages.products.operationData.orderSales': '주문 매출',
  'pages.products.operationData.totalGoodsPaid': '상품 결제 총액',
  'pages.products.operationData.orderCouponDeduction': '주문 쿠폰 할인 금액',
  'pages.products.operationData.orderPointsDeduction': '주문 포인트 할인 금액',
  'pages.products.operationData.orderRefundAmount': '주문 환불 금액',
  'pages.products.operationData.orderBalance': '주문 잔액',
  'pages.products.operationData.waybillSales': '운송장 매출',
  'pages.products.operationData.waybillCouponDeduction': '운송장 쿠폰 할인 금액',
  'pages.products.operationData.waybillRefundAmount': '운송장 환불 금액',
  'pages.products.operationData.waybillSupplementAmount': '운송장 보충 금액',
  'pages.products.operationData.totalRechargeAmount': '총 충전 금액',
  'pages.products.operationData.commissionRebateAmount': '수수료 리베이트 금액',
  'pages.products.operationData.commissionWithdrawalAmount': '수수료 출금 금액',
  // New Operation Data Metrics
  'pages.products.operationData.productPayment': '상품결제',
  'pages.products.operationData.couponDiscount': '쿠폰할인금액',
  'pages.products.operationData.logisticsAmount': '물류금액',
  'pages.products.operationData.rechargeAmount': '충전금액',
  'pages.products.operationData.refundAmount': '환불금액',
  'pages.products.operationData.rebateAmount': '리베이트금액',
  'pages.products.operationData.couponEarned': '쿠폰획득금액',
  'pages.products.operationData.paymentCount': '결제건수',
  'pages.products.operationData.couponUsageCount': '쿠폰사용건수',
  'pages.products.operationData.logisticsCount': '물류건수',
  'pages.products.operationData.withdrawalAmount': '출금금액',
  'pages.products.operationData.refundCount': '환불건수',
  'pages.products.operationData.rebateCount': '리베이트건수',
  'pages.products.operationData.couponEarnedCount': '쿠폰획득건수',
  'pages.products.operationData.visitCount': '방문량',
  'pages.products.operationData.pointUsage': '포인트사용',
  'pages.products.operationData.pointUsageCount': '포인트사용건수',
  // Charts
  'pages.products.operationData.websiteRevenue': '웹사이트 수익',
  'pages.products.operationData.websiteExpenses': '웹사이트 지출',
  'pages.products.operationData.procurementAnalysis': '조달 분석',
  'pages.products.operationData.commissionTransactions': '수수료 거래',
  'pages.products.operationData.orderStatistics': '주문 통계',
  'pages.products.operationData.waybillStatistics': '운송장 통계',
  'pages.products.operationData.salesAmount': '매출액',
  'pages.products.operationData.paymentOrders': '결제 주문 수',
  'pages.products.operationData.payingUsers': '결제 회원 수',
  'pages.products.operationData.replenishmentAmount': '보충 금액',
  'pages.products.operationData.totalRebateCommission': '총 리베이트 수수료',
  'pages.products.operationData.purchaseOrderCost': '구매 주문 비용',
  'pages.products.operationData.numberOfPurchasedItems': '구매 상품 수',
  'pages.products.operationData.totalPaymentAmountForItems': '상품 총 결제 금액',
  'pages.products.operationData.numberOfPromotedUsers': '프로모션 회원 수',
  'pages.products.operationData.numberOfPromotedUserOrders': '프로모션 회원 주문 수',
  'pages.products.list.title': '상품 목록',
  'pages.products.list.storeListTitle': '스토어 목록',
  'pages.products.list.productsListTitle': '상품 목록',
  'pages.products.list.backToStores': '스토어로 돌아가기',
  'pages.products.list.priceUpdateSuccess': '가격이 성공적으로 업데이트되었습니다',
  'pages.products.list.priceUpdateFailed': '가격 업데이트에 실패했습니다',
  'pages.products.list.importTaobao': '타오바오 가져오기',
  'pages.products.list.importExcel': '엑셀 가져오기',
  'pages.products.list.exportExcel': '엑셀 내보내기',
  'pages.products.list.addProduct': '상품 등록',
  'pages.products.list.thumbnail': '상품이미지',
  'pages.products.list.copyOfferIdHint': '복사한 상품입니다. 위 번호는 원본 상품 번호, 괄호 안 {offerId} 는 이 상품의 내부 번호(주문에 찍히는 번호)입니다. 원본과 재고가 함께 움직입니다.',
  'pages.products.list.productName': '상품명',
  'pages.products.list.category': '카테고리',
  'pages.products.list.price': '판매가',
  'pages.products.list.stock': '재고',
  'pages.products.list.amountOnSale': '판매 수량',
  'pages.products.list.salesCount': '판매량',
  'pages.products.list.productNo': '품번',
  'pages.products.list.productNoHint': '고객 화면에 보이는 품번. 비어 있으면 OfferId 가 품번으로 보입니다.',
  'pages.products.list.sellingSellers': '판매중 셀러',
  'pages.products.list.status': '상태',
  'pages.products.list.createdAt': '등록일',
  'pages.products.list.brand': '브랜드',
  'pages.products.list.priceCny': '위안화단가',
  'pages.products.list.salePrice': '판매가격',
  'pages.products.list.salesPeriod': '판매기간',
  'pages.products.list.categoryType': '상품카테고리구분',
  'pages.products.list.event': '이벤트',
  'pages.products.list.actions': '작업',
  'pages.products.list.edit': '수정',
  'pages.products.list.delete': '삭제',
  'pages.products.list.deleteConfirm': '정말 삭제하시겠습니까?',
  'pages.products.list.deleteSuccess': '삭제되었습니다',
  'pages.products.list.copySuccess': '상품이 복사되었습니다',
  'pages.products.list.copyError': '상품 복사에 실패했습니다',
  'pages.products.list.batchDelete': '일괄 삭제',
  'pages.products.list.batchDeleteConfirm': '{count}개 상품을 삭제하시겠습니까?',
  'pages.products.list.batchDeleteSuccess': '선택 상품 삭제 완료',
  'pages.products.list.batchUpdatePrice': '가격 일괄 수정',
  'pages.products.list.batchUpdateCategory': '카테고리 일괄 수정',
  'pages.products.list.batchUpdatePriceTitle': '판매가 일괄 수정',
  'pages.products.list.batchUpdateCategoryTitle': '카테고리 일괄 수정',
  'pages.products.list.batchUpdatePriceSuccess': '판매가가 성공적으로 업데이트되었습니다',
  'pages.products.list.batchUpdateCategorySuccess': '카테고리가 성공적으로 업데이트되었습니다',
  // 고른 상품을 여러 셀러 페이지에 한꺼번에 올리기
  'pages.products.list.addToSellerPages': '셀러 페이지 추가',
  'pages.products.list.addToSellerPages.title': '셀러 페이지에 상품 추가',
  'pages.products.list.addToSellerPages.confirm': '추가',
  'pages.products.list.addToSellerPages.description': '고른 상품 {count}개를 아래에서 고른 셀러 페이지마다 올립니다.',
  'pages.products.list.addToSellerPages.selectProduct': '상품을 하나 이상 선택해 주세요.',
  'pages.products.list.addToSellerPages.selectSeller': '셀러를 하나 이상 선택해 주세요.',
  'pages.products.list.addToSellerPages.result':
    '셀러 {sellers}곳에 {count}건을 등록했습니다.{skipped, plural, =0 {} other { 이미 올라가 있던 #건은 건너뛰었습니다.}}',
  'pages.products.list.addToSellerPages.partialResult':
    '{count}건 등록{skipped, plural, =0 {} other {, 건너뜀 #건}}, {failed}건 실패 ({reasons})',
  'pages.products.list.addToSellerPages.failed': '등록에 실패했습니다.',
  'pages.products.list.addToSellerPages.failReason.item': '{label} {count}건',
  'pages.products.list.addToSellerPages.failReason.ownedByOtherSeller': '다른 셀러 소유 상품',
  'pages.products.list.addToSellerPages.failReason.notFound': '상품 없음',
  'pages.products.list.addToSellerPages.failReason.createFailed': '등록 오류',
  // 판매중 셀러 칸에서 상품 하나를 여러 셀러에 붙이기
  'pages.products.list.linkSellers': '셀러 연결',
  'pages.products.list.linkSellers.title': '이 상품을 판매할 셀러 고르기',
  'pages.products.list.linkSellers.confirm': '연결',
  'pages.products.list.linkSellers.description':
    '{title} — 지금 {count}명의 셀러가 판매 중입니다. 새로 연결할 셀러를 고르세요. 연결 해제는 셀러 페이지에서 합니다.',
  'pages.products.list.linkSellers.alreadyLinked': '이미 연결됨',
  'pages.products.list.linkSellers.noNewSeller': '이미 연결된 셀러만 골랐습니다. 새로 연결할 셀러를 고르세요.',
  'pages.products.list.batchUpdatePriceNote': '참고: 가격 계산은 각 상품의 현재 판매가를 기준으로 합니다.',
  'pages.products.list.priceOperation': '가격 연산',
  'pages.products.list.multiply': '곱하기',
  'pages.products.list.add': '더하기',
  'pages.products.list.amount': '금액',
  'pages.products.list.amountHint': '곱하기: 2 = ×2, 3 = ×3. 더하기: 1000 = +1000',
  'pages.products.list.selectedProducts': '{count}개 상품 선택됨',
  'pages.products.list.selectCategory': '카테고리 선택',
  'pages.products.list.selectCategoryPlaceholder': '카테고리를 선택해주세요',
  'pages.products.list.totalProducts': '총 {total}개 상품',
  'pages.products.list.preview': '미리보기',
  'pages.products.list.lowStock': '품절임박 ({stock})',
  'pages.products.list.status.selling': '판매중',
  'pages.products.list.status.stopped': '판매정지',
  'pages.products.list.status.outOfStock': '품절',
  'pages.products.list.status.reviewing': '검수중',
  'pages.products.list.status.active': '판매중',
  'pages.products.list.status.onSale': '판매중',
  'pages.products.list.status.offSale': '판매중지',
  'pages.products.list.status.draft': '초안',
  'pages.products.list.displayStatus': '표시 상태',
  'pages.products.list.displayStatus.visible': '표시',
  'pages.products.list.displayStatus.hidden': '숨김',
  'pages.products.list.store.title': '스토어 목록',
  'pages.products.list.store.count': '상품개수',
  'pages.products.list.store.name': '스토어명',
  'pages.products.list.store.image': '이미지',
  'pages.products.list.store.status': '상태',
  'pages.products.list.store.active': '활성',
  'pages.products.list.store.inactive': '비활성',
  'pages.products.list.store.sortOrder': '순서',
  'pages.products.list.store.viewProducts': '상품 보기',
  'pages.products.list.store.backToStores': '스토어 목록으로',
  'pages.products.list.store.totalStores': '총 {total}개 스토어',
  'pages.products.list.store.selectStoreToViewProducts': '스토어를 선택하면 상품 목록을 볼 수 있습니다',
  'pages.products.list.searchProductName': '상품명 검색',
  'pages.products.list.category.fashion': '패션',
  'pages.products.list.category.beauty': '뷰티',
  'pages.products.list.category.living': '리빙',
  'pages.products.list.category.digital': '디지털',
  'pages.products.list.category.food': '식품',
  'pages.products.list.category.sports': '스포츠',
  'pages.products.list.category.toy': '완구',
  'pages.products.list.category.appliance': '가전',
  
  // Product Form Modal
  'pages.products.form.title': '상품 등록',
  'pages.products.form.category': '카테고리',
  'pages.products.form.brand': '브랜드',
  'pages.products.form.productName': '상품명',
  'pages.products.form.originalPrice': '상품 원가',
  'pages.products.form.salePrice': '판매 가격',
  'pages.products.form.productType': '상품 유형',
  'pages.products.form.productType.own': '자사몰',
  'pages.products.form.productType.live': '라방',
  'pages.products.form.salesPeriod': '판매 기간',
  'pages.products.form.startDate': '시작일',
  'pages.products.form.endDate': '종료일',
  'pages.products.form.thumbnailImage': '대표 이미지',
  'pages.products.form.productImages': '상품 이미지',
  'pages.products.form.color': '색상',
  'pages.products.form.size': '사이즈',
  'pages.products.form.siteUrl': '사이트',
  'pages.products.form.originalPlace': '원본 상품',
  'pages.products.form.recommendedCategory': '추천제품 카테고리',
  'pages.products.form.recommendedType': '추천제품 구분',
  'pages.products.form.event': '추천제품 이벤트',
  'pages.products.form.shortDescription': '간략 설명',
  'pages.products.form.siteAddress': '사이트주소',
  'pages.products.form.useStatus': '사용 여부',
  'pages.products.form.detailDescription': '상세 설명',
  'pages.products.form.save': '저장',
  'pages.products.form.close': '닫기',
  'pages.products.form.use': '사용',
  'pages.products.form.notUse': '미사용',
  'pages.products.form.colorSizeHint': '* 색상과 사이즈 여러개 입력할 경우 | 로 구분하여 입력 ex) Black|White|Blue|Green',
  
  // Products Add Page
  'pages.products.add.title': '상품 등록',
  'pages.products.add.preview': '미리보기',
  'pages.products.add.submit': '상품 등록',
  'pages.products.add.uploadSuccess': '업로드 성공',
  'pages.products.add.uploadFailed': '업로드 실패',
  'pages.products.add.descImageUploadHint':
    '이미지를 한 번에 여러 장 업로드하거나, 아래에 이미지 URL을 입력할 수 있습니다(선택).',
  'pages.products.add.descImageUpload': '이미지 업로드',
  'pages.products.add.descImageUploadBtn': '업로드',
  'pages.products.add.descImageUrlLabel': '또는 이미지 URL 1개 입력(선택)',
  'pages.products.add.descImagePreview': '미리보기',
  'pages.products.add.descImageWaitUpload': '모든 이미지 업로드가 끝날 때까지 기다려 주세요.',
  'pages.products.add.descImageNeedOne': '이미지를 한 장 이상 업로드하거나 이미지 URL을 입력해 주세요.',
  'pages.products.add.descImageInserted': '이미지 {count}장이 삽입되었습니다.',
  'pages.products.add.saveProduct': '상품 저장',
  'pages.products.add.cancel': '취소',
  'pages.products.add.scrollToTop': '맨 위로 가기',
  'pages.products.add.success': '상품이 등록되었습니다',
  'pages.products.add.error': '필수 항목을 입력해주세요',
  'pages.products.add.basicInfo': '기본 정보',
  'pages.products.add.productName': '상품명',
  'pages.products.add.productNamePlaceholder': '상품명을 입력하세요',
  'pages.products.add.productNameRequired': '상품명을 입력하세요',
  'pages.products.add.category': '카테고리',
  'pages.products.add.categoryPlaceholder': '카테고리 선택',
  'pages.products.add.categoryRequired': '카테고리를 선택하세요',
  'pages.products.add.brand': '브랜드',
  'pages.products.add.brandPlaceholder': '브랜드명',
  'pages.products.add.description': '상품 설명',
  'pages.products.add.descriptionPlaceholder': '상품에 대한 상세 설명을 입력하세요',
  'pages.products.add.descriptionRequired': '상품 설명을 입력하세요',
  'pages.products.add.price': '판매 가격',
  'pages.products.add.pricePlaceholder': '0',
  'pages.products.add.priceRequired': '가격을 입력하세요',
  'pages.products.add.originalPrice': '정가',
  'pages.products.add.stock': '재고 수량',
  'pages.products.add.sku': 'SKU 코드',
  'pages.products.add.skuPlaceholder': 'SKU-001',
  'pages.products.add.barcode': '바코드',
  'pages.products.add.barcodePlaceholder': '바코드 번호',
  'pages.products.add.options': '상품 옵션',
  'pages.products.add.addOption': '옵션 추가',
  'pages.products.add.optionName': '옵션명',
  'pages.products.add.optionNamePlaceholder': '예: 블랙/M',
  'pages.products.add.optionImage': '옵션 이미지',
  'pages.products.add.optionImageUrlPlaceholder': '이미지 URL 입력',
  'pages.products.add.bulkUploadImage': '전체 업로드',
  'pages.products.add.bulkClearImage': '전체 삭제',
  'pages.products.add.imageBulkUpdated': '이미지가 일괄 업데이트되었습니다',
  'pages.products.add.imageBulkCleared': '이미지가 일괄 삭제되었습니다',
  'pages.products.add.deleteSelected': '선택 삭제',
  'pages.products.add.confirmDeleteSelected': '선택한 행을 삭제하시겠습니까?',
  'pages.products.add.noRowsSelected': '삭제할 행을 선택하세요',
  'pages.products.add.rowsDeleted': '선택한 행이 삭제되었습니다',
  'pages.products.add.tempSave': '임시 저장',
  'pages.products.add.tempSaveSuccess': '임시 저장되었습니다',
  'pages.products.add.tempSaveError': '임시 저장에 실패했습니다',
  'pages.products.add.optionPrice': '추가 가격',
  'pages.products.add.optionStock': '재고',
  'pages.products.add.optionSku': 'SKU',
  'pages.products.add.inputSellingPrice': '판매가 입력',
  'pages.products.add.tagPrice': '태그가',
  'pages.products.add.inputTagPrice': '태그가 입력',
  'pages.products.add.save': '저장',
  'pages.products.add.salePriceTooLow': '판매가는 원가(₩{min}) 이상이어야 합니다',
  'pages.products.add.tagPriceTooLow': '태그가는 판매가(₩{min}) 이상이어야 합니다',
  'pages.products.add.shippingInfo': '배송 정보',
  'pages.products.add.weight': '무게 (kg)',
  'pages.products.add.width': '가로 (cm)',
  'pages.products.add.height': '세로 (cm)',
  'pages.products.add.depth': '높이 (cm)',
  'pages.products.add.shippingMethod': '배송 방법',
  'pages.products.add.shippingMethodPlaceholder': '배송 방법 선택',
  'pages.products.add.additionalInfo': '추가 정보',
  'pages.products.add.tags': '태그',
  'pages.products.add.tagsPlaceholder': '태그 입력 (Enter로 추가)',
  'pages.products.add.keywords': '검색 키워드',
  'pages.products.add.keywordsPlaceholder': '검색 키워드 (쉼표로 구분)',
  'pages.products.add.keywordsTooltip': '키워드를 입력하고 Enter 또는 쉼표(,)로 추가하세요',
  'pages.products.add.memo': '관리자 메모',
  'pages.products.add.memoPlaceholder': '관리자용 메모',
  'pages.products.add.images': '상품 이미지',
  'pages.products.add.uploadImage': '이미지 업로드',
  'pages.products.add.imageRequired': '최소 1개 이상의 이미지를 업로드하세요',
  'pages.products.add.imageNote1': '최대 10개까지 업로드 가능',
  'pages.products.add.imageNote2': '권장 크기: 800x800px',
  'pages.products.add.imageNote3': '첫 번째 이미지가 대표 이미지로 설정됩니다',
  'pages.products.add.salesSettings': '판매 설정',
  'pages.products.add.salesStatus': '판매 상태',
  'pages.products.add.displayStatus': '노출 상태',
  'pages.products.add.featured': '추천 상품',
  'pages.products.add.newArrival': '신상품',
  'pages.products.add.bestSeller': '베스트셀러',
  'pages.products.add.originInfo': '원산지 정보',
  'pages.products.add.origin': '제조국',
  'pages.products.add.originPlaceholder': '제조국 선택',
  'pages.products.add.manufacturer': '제조사',
  'pages.products.add.manufacturerPlaceholder': '제조사명',
  'pages.products.add.importDate': '수입일자',
  'pages.products.add.storeInfo': '스토어 정보',
  'pages.products.add.storeName': '스토어명',
  'pages.products.add.storeNamePlaceholder': '스토어명을 입력하세요',
  'pages.products.add.storeSelect': '스토어 선택',
  'pages.products.add.storeSelectPlaceholder': '스토어를 선택해주세요',
  'pages.products.add.storeRequired': '스토어를 선택해주세요',
  'pages.products.add.review': '리뷰',
  'pages.products.add.reviewPlaceholder': '리뷰 평점 (0-5)',
  'pages.products.add.soldout': '판매량',
  'pages.products.add.soldoutPlaceholder': '판매된 상품 수',
  'pages.products.add.previewModal': '상품 미리보기',
  'pages.products.add.previewDev': '상품 미리보기 기능은 개발 중입니다.',
  'pages.products.add.yes': '예',
  'pages.products.add.no': '아니오',
  'pages.products.add.show': '노출',
  'pages.products.add.hide': '숨김',
  'pages.products.add.category.clothing': '의류',
  'pages.products.add.category.shoes': '신발',
  'pages.products.add.category.bags': '가방',
  'pages.products.add.category.accessories': '액세서리',
  'pages.products.add.category.electronics': '전자제품',
  'pages.products.add.category.home': '홈/리빙',
  'pages.products.add.status.active': '판매중',
  'pages.products.add.status.inactive': '판매중지',
  'pages.products.add.status.soldout': '품절',
  'pages.products.add.status.preparing': '판매준비중',
  'pages.products.add.addSpecification': '규격 추가',
  'pages.products.add.optionRequired': '최소 하나의 옵션을 추가해주세요',
  'pages.products.add.optionCategoryRequired': '먼저 옵션 카테고리 이름을 설정해주세요',
  'pages.products.add.optionCategoryName': '옵션 카테고리 이름',
  'pages.products.add.specificationRequired': '최소 하나의 규격을 추가해주세요',
  'pages.products.add.shipping.air': '항공',
  'pages.products.add.shipping.airExpress': '항공 특송',
  'pages.products.add.shipping.sea': '배',
  'pages.products.add.shipping.seaExpress': '배 특송',
  'pages.products.add.country.CN': '중국',
  'pages.products.add.country.KR': '한국',
  'pages.products.add.country.US': '미국',
  'pages.products.add.country.JP': '일본',
  'pages.products.add.country.EU': '유럽',
  'pages.products.add.tag.new': '신상품',
  'pages.products.add.tag.popular': '인기',
  'pages.products.add.tag.sale': '할인',
  'pages.products.add.tag.recommended': '추천',
  'pages.products.add.promotionLink': '프로모션 링크',
  'pages.products.add.promotionLinkPlaceholder': '프로모션 링크 입력 (예: 타오바오/1688 상품 URL)',
  'pages.products.add.offerId': '상품번호 (Offer ID)',
  'pages.products.add.offerIdPlaceholder': '상품번호(Offer ID) 입력',
  'pages.products.add.offerIdTooltip': '프로모션 링크에서 자동으로 채워지거나 직접 입력할 수 있습니다',
  'pages.products.add.titleKoRequired': '한글 상품명은 필수입니다',
  'pages.products.add.specifications': '상품 스펙',
  'pages.products.add.productDetail': '상품 상세',
  'pages.products.add.sellerInfo': '판매자 정보',
  'pages.products.add.displayMetrics': '표시값',
  'pages.products.add.displayMetricsNotice':
    '고객에게 보이는 표시용 수치입니다. 실제 주문·리뷰 자료와 연결되지 않습니다.',
  'pages.products.add.reviewCount': '리뷰 수',
  'pages.products.add.reviewCountPlaceholder': '리뷰 수 입력',
  'pages.products.add.reviewScore': '평점',
  'pages.products.add.reviewScorePlaceholder': '평점 입력 (0-5)',
  'pages.products.add.repurchaseRate': '재구매율 (%)',
  'pages.products.add.repurchaseRatePlaceholder': '재구매율 입력 (0-100)',
  'pages.products.add.copy': '복사',
  'pages.products.add.paste': '붙여넣기',
  'pages.products.add.companyNamePlaceholder': '회사명',
  'pages.products.add.sellerAddressPlaceholder': '판매자 주소',
  'pages.products.add.sellerPhonePlaceholder': '판매자 전화번호',
  'pages.products.add.sellerOpenIdPlaceholder': '판매자 Open ID / Shop ID',
  'pages.products.add.editor.bold': '굵게',
  'pages.products.add.editor.italic': '기울임',
  'pages.products.add.editor.underline': '밑줄',
  'pages.products.add.editor.alignLeft': '왼쪽 정렬',
  'pages.products.add.editor.alignCenter': '가운데 정렬',
  'pages.products.add.editor.alignRight': '오른쪽 정렬',
  'pages.products.add.editor.orderedList': '번호 목록',
  'pages.products.add.editor.unorderedList': '글머리 목록',
  'pages.products.add.editor.insertImage': '이미지 삽입',
  'pages.products.add.editor.insertLink': '링크 삽입',
  'pages.products.add.editor.insertUrl': 'URL을 입력하세요:',
  'pages.products.add.editor.normal': '본문',
  'pages.products.add.editor.heading1': '제목 1',
  'pages.products.add.editor.heading2': '제목 2',
  'pages.products.add.editor.heading3': '제목 3',
  'pages.products.add.editor.heading4': '제목 4',

  // Products Edit Page
  'pages.products.edit.title': '상품 수정',
  'pages.products.edit.submit': '상품 수정',
  'pages.products.edit.saveProduct': '상품 수정',
  'pages.products.edit.updateSuccess': '상품이 수정되었습니다',
  'pages.products.edit.success': '상품이 수정되었습니다',
  'pages.products.edit.error': '필수 항목을 입력해주세요',
  'pages.products.edit.productIdRequired': '상품 ID가 필요합니다',
  'pages.products.edit.productNotFound': '상품을 찾을 수 없습니다',
  'pages.products.edit.loadSuccess': '상품을 불러왔습니다',
  'pages.products.edit.loadError': '상품 데이터를 불러오는데 실패했습니다',
  'pages.products.edit.loading': '상품 데이터를 불러오는 중...',
  'pages.products.edit.back': '뒤로',
  'pages.products.edit.reset': '원래대로',
  'pages.products.edit.resetSuccess': '상품 데이터가 원래 값으로 복원되었습니다',
  'pages.products.edit.noOriginalData': '복원할 원본 데이터가 없습니다',
  
  // Products Preview
  'pages.products.preview.close': '닫기',
  'pages.products.preview.images': '상품 이미지',
  'pages.products.preview.basicInfo': '기본 정보',
  'pages.products.preview.productName': '상품명',
  'pages.products.preview.category': '카테고리',
  'pages.products.preview.brand': '브랜드',
  'pages.products.preview.description': '상품 설명',
  'pages.products.preview.priceStock': '가격 및 재고',
  'pages.products.preview.price': '판매 가격',
  'pages.products.preview.originalPrice': '정가',
  'pages.products.preview.stock': '재고 수량',
  'pages.products.preview.sku': 'SKU 코드',
  'pages.products.preview.barcode': '바코드',
  'pages.products.preview.options': '상품 옵션',
  'pages.products.preview.optionName': '옵션명',
  'pages.products.preview.optionPrice': '추가 가격',
  'pages.products.preview.optionStock': '재고',
  'pages.products.preview.optionSku': 'SKU',
  'pages.products.preview.shippingInfo': '배송 정보',
  'pages.products.preview.weight': '무게',
  'pages.products.preview.dimensions': '치수',
  'pages.products.preview.shippingMethod': '배송 방법',
  'pages.products.preview.salesSettings': '판매 설정',
  'pages.products.preview.status': '판매 상태',
  'pages.products.preview.displayStatus': '노출 상태',
  'pages.products.preview.featured': '추천 상품',
  'pages.products.preview.newArrival': '신상품',
  'pages.products.preview.bestSeller': '베스트셀러',
  'pages.products.preview.additionalInfo': '추가 정보',
  'pages.products.preview.tags': '태그',
  'pages.products.preview.keywords': '검색 키워드',
  'pages.products.preview.memo': '관리자 메모',
  'pages.products.preview.originInfo': '원산지 정보',
  'pages.products.preview.origin': '제조국',
  'pages.products.preview.manufacturer': '제조사',
  'pages.products.preview.importDate': '수입일자',
  
  // Products Category Management
  'pages.products.category.title': '카테고리 관리',
  'pages.products.store.add': '스토어 추가',
  'pages.products.store.addTitle': '스토어 추가',
  'pages.products.store.name': '스토어명',
  'pages.products.companymallCategory.title': '자사몰 카테고리 관리',
  'pages.products.category.storeName': '스토어명',
  'pages.products.category.selectStore': '스토어 선택',
  'pages.products.category.selectCategory': '카테고리 선택',
  'pages.products.add.attributeNameEn': '속성이름 (영문)',
  'pages.products.add.attributeNameKo': '속성이름 (한글)',
  'pages.products.add.attributeNameCn': '속성이름 (중문)',
  'pages.products.add.attributePlaceholderCn': 'e.g: 颜色',
  'pages.products.add.attributePlaceholderKo': 'e.g: 색상',
  'pages.products.add.attributePlaceholderEn': 'e.g: Color',
  'pages.products.add.attributeValueCn': '속성값 (중문)',
  'pages.products.add.attributeValueKo': '속성값 (한글)',
  'pages.products.add.attributeValueEn': '속성값 (영문)',
  'pages.products.add.attributeValuePlaceholderCn': '예: 红色,蓝色,绿色',
  'pages.products.add.attributeValuePlaceholderKo': '예: 빨강,파랑,초록',
  'pages.products.add.attributeValuePlaceholderEn': '예: Red,Blue,Green',
  'pages.products.add.fillAllAttributes': '속성 이름과 값을 최소 한 가지 언어로 입력해주세요',
  'pages.products.add.attributeSync.result':
    '속성 목록 동기화 완료 — 추가 {added}개, 삭제 {removed}개, 전체 {total}개',
  'pages.products.add.atLeastOneLanguageRequired': '속성 이름과 값은 최소 한 가지 언어로 입력해야 합니다',
  'pages.products.add.addAttribute': '속성 추가',
  'pages.products.category.storeRequired': '스토어는 필수입니다',
  'pages.products.category.categoryRequired': '카테고리는 필수입니다',
  'pages.products.category.id': 'ID',
  'pages.products.category.name': '카테고리명',
  'pages.products.category.level1Placeholder': '1단계 (필수)',
  'pages.products.category.level2Placeholder': '2단계 (필수)',
  'pages.products.category.level2Required': '2단계 카테고리는 필수입니다',
  'pages.products.category.level3Placeholder': '3단계 (선택)',
  'pages.products.category.nameEn': '영문명',
  'pages.products.category.nameCn': '중문명',
  'pages.products.category.parent': '상위 카테고리',
  'pages.products.category.level': '레벨',
  'pages.products.category.order': '노출 순서',
  'pages.products.category.productCount': '상품 수',
  'pages.products.category.status': '상태',
  'pages.products.category.createdAt': '등록일',
  'pages.products.category.actions': '작업',
  'pages.products.category.add': '카테고리 추가',
  'pages.products.category.edit': '수정',
  'pages.products.category.delete': '삭제',
  'pages.products.category.treeView': '트리뷰',
  'pages.products.category.tableView': '테이블뷰',
  'pages.products.category.addTitle': '카테고리 추가',
  'pages.products.category.editTitle': '카테고리 수정',
  'pages.products.category.deleteConfirm': '카테고리 삭제',
  'pages.products.category.deleteContent': '"{name}" 카테고리를 삭제하시겠습니까? {count}',
  'pages.products.category.deleteSuccess': '카테고리가 삭제되었습니다',
  'pages.products.category.updateSuccess': '카테고리가 수정되었습니다',
  'pages.products.category.createSuccess': '카테고리가 등록되었습니다',
  'pages.products.category.loadedFromLocalStorage': '로컬 스토리지에서 카테고리 로드됨 (API 사용 불가)',
  'pages.products.category.platform': '플랫폼',
  'pages.products.category.platformTaobao': '타오바오',
  'pages.products.category.platformVip': 'VVIC',
  'pages.products.category.platformMyCompany': '자사몰',
  'pages.products.category.includeInactive': '비활성 포함',
  'pages.products.category.editImage': '이미지 수정',
  'pages.products.category.editName': '이름 수정',
  'pages.products.category.editStatus': '상태 수정',
  'pages.products.category.editRecommend': '추천 수정',
  'pages.products.category.clickToEditImage': '이미지를 클릭하여 수정',
  'pages.products.category.clickToEditName': '이름을 클릭하여 수정',
  'pages.products.category.clickToEditStatus': '상태를 클릭하여 수정',
  'pages.products.category.clickToEditRecommend': '추천을 클릭하여 수정',
  'pages.products.category.totalCategories': '전체 카테고리',
  'pages.products.category.upload': '업로드',
  'pages.products.category.uploadImageOnly': '이미지 파일만 업로드할 수 있습니다',
  'pages.products.category.imageSizeLimit': '이미지 크기는 10MB 이하여야 합니다',
  'pages.products.category.uploadSuccess': '이미지 업로드 성공',
  'pages.products.category.uploadFailed': '이미지 업로드 실패',
  'pages.products.category.image': '이미지',
  'pages.products.category.externalId': '외부 ID',
  
  // Todayggigu Category Management
  'pages.products.todayggigu.category.title': '카테고리 관리',
  'pages.products.todayggigu.category.addLevel1': '1단계 카테고리 등록',
  'pages.products.todayggigu.category.sortLevel1': '1단계 카테고리 정렬',
  'pages.products.todayggigu.category.level1Title': '1단계 카테고리 등록/수정',
  'pages.products.todayggigu.category.level2Title': '2단계 카테고리 등록/수정',
  'pages.products.todayggigu.category.orderTitle': '카테고리 순서 변경',
  'pages.products.todayggigu.category.parentCategory': '부모 카테고리',
  'pages.products.todayggigu.category.categoryName': '카테고리 이름',
  'pages.products.todayggigu.category.categoryNamePlaceholder': '카테고리 이름을 입력하세요',
  'pages.products.todayggigu.category.categoryNameRequired': '카테고리 이름을 입력하세요',
  'pages.products.todayggigu.category.usage': '사용 여부',
  'pages.products.todayggigu.category.use': '사용',
  'pages.products.todayggigu.category.notUse': '미사용',
  'pages.products.todayggigu.category.no': 'No',
  'pages.products.todayggigu.category.name': '카테고리 이름',
  'pages.products.todayggigu.category.usageStatus': '사용 여부',
  'pages.products.todayggigu.category.registeredAt': '등록일시',
  'pages.products.todayggigu.category.actions': '동작',
  'pages.products.todayggigu.category.register': '등록',
  'pages.products.todayggigu.category.edit': '수정',
  'pages.products.todayggigu.category.order': '순서',
  'pages.products.todayggigu.category.delete': '삭제',
  'pages.products.todayggigu.category.save': '저장',
  'pages.products.todayggigu.category.close': '닫기',
  'pages.products.todayggigu.category.deleteConfirm': '카테고리 삭제',
  'pages.products.todayggigu.category.deleteContent': '"{name}" 카테고리를 삭제하시겠습니까?',
  'pages.products.todayggigu.category.deleteSuccess': '카테고리가 삭제되었습니다',
  'pages.products.todayggigu.category.deleteFailed': '카테고리 삭제에 실패했습니다',
  'pages.products.todayggigu.category.createSuccess': '카테고리가 생성되었습니다',
  'pages.products.todayggigu.category.updateSuccess': '카테고리가 수정되었습니다',
  'pages.products.todayggigu.category.saveFailed': '카테고리 저장에 실패했습니다',
  'pages.products.todayggigu.category.loadFailed': '카테고리 로드에 실패했습니다',
  'pages.products.todayggigu.category.orderSuccess': '순서가 변경되었습니다',
  'pages.products.todayggigu.category.orderFailed': '순서 변경에 실패했습니다',
  'pages.products.todayggigu.category.noSubcategories': '하위 카테고리가 없습니다',
  'pages.products.todayggigu.category.dragToReorder': '드래그하여 순서 변경',
  
  'pages.products.category.nameKo': '카테고리명 (한글)',
  'pages.products.category.nameKoPlaceholder': '예: 의류',
  'pages.products.category.nameKoRequired': '카테고리명을 입력하세요',
  'pages.products.category.nameEnLabel': '카테고리명 (영문)',
  'pages.products.category.nameEnPlaceholder': '예: Clothing',
  'pages.products.category.nameCnLabel': '카테고리명 (중문)',
  'pages.products.category.nameCnPlaceholder': '예: 服装',
  'pages.products.category.parentLabel': '상위 카테고리',
  'pages.products.category.parentPlaceholder': '최상위 카테고리는 선택하지 마세요',
  'pages.products.category.icon': '아이콘',
  'pages.products.category.iconPlaceholder': '예: 👔 (이모지 또는 아이콘 클래스)',
  'pages.products.category.orderLabel': '노출 순서',
  'pages.products.category.orderPlaceholder': '숫자가 작을수록 먼저 노출됩니다',
  'pages.products.category.description': '설명',
  'pages.products.category.descriptionPlaceholder': '카테고리 설명',
  'pages.products.category.statusLabel': '상태',
  'pages.products.category.statusAll': '전체',
  'pages.products.category.active': '활성',
  'pages.products.category.inactive': '비활성',
  'pages.products.category.levelRequired': '레벨을 선택하세요',
  'pages.products.category.levelPlaceholder': '레벨을 선택하세요',
  'pages.products.category.parentRequired': '상위 카테고리를 선택하세요',
  'pages.products.category.topLevel': '최상위',
  'pages.products.category.level1': '대분류',
  'pages.products.category.store': '스토어',
  'pages.products.category.level2': '중분류',
  'pages.products.category.level3': '소분류',
  'pages.products.category.level4': '세분류',
  'pages.products.category.orderUp': '위로',
  'pages.products.category.orderDown': '아래로',
  'pages.products.category.orderMoved': '"{name}" 카테고리 순서가 {direction} 이동되었습니다',
  'pages.products.category.reorderSaved': '카테고리 순서가 저장되었습니다',
  'pages.products.category.reorderSameParentOnly': '같은 상위 카테고리(같은 레벨) 안에서만 순서를 바꿀 수 있습니다',
  'pages.products.category.dragToReorder': '끌어서 순서 변경',
  'pages.products.category.countUnit': '개',
  'pages.products.category.imageUrl': '이미지 URL',
  'pages.products.category.imageUrlPlaceholder': '예: https://example.com/image.jpg',
  'pages.products.category.imageUrlDesktop': '데스크톱 이미지 URL',
  'pages.products.category.imageUrlMobile': '모바일 이미지 URL',
  'pages.products.category.imageUrlDesktopPlaceholder': '예: https://example.com/desktop-image.jpg',
  'pages.products.category.imageUrlMobilePlaceholder': '예: https://example.com/mobile-image.jpg',
  'pages.products.category.updateFailed': '카테고리 수정에 실패했습니다',
  'pages.products.category.selectCategoryFirst': '먼저 카테고리를 선택하세요',
  'pages.products.category.categoryNotFound': '카테고리를 찾을 수 없습니다',
  'pages.products.category.searchNamePlaceholder': '카테고리명으로 검색',
  'pages.products.category.statusRecommend': '상태/추천',
  'pages.products.category.recommended': '추천',
  'pages.products.category.notRecommended': '비추천',
  'pages.products.category.clickToEdit': '클릭하여 수정',
  'pages.products.category.validationError': '유효성 검사 오류',
  'pages.products.category.unauthorized': '인증이 필요합니다',
  
  // Products Import Taobao
  'pages.products.import.title': '타오바오/1688/알리/테무 상품 가져오기',
  'pages.products.import.subtitle': '상품 URL을 입력하면 자동으로 정보를 가져옵니다',
  'pages.products.import.platforms': '지원 플랫폼',
  'pages.products.import.urlPlaceholder': '상품 URL을 입력하세요 (예: https://item.taobao.com/item.htm?id=123456789)',
  'pages.products.import.fetch': '상품 가져오기',
  'pages.products.import.noSpecifications': '스펙 없음',
  'pages.products.import.fetching': '상품 정보를 가져오는 중...',
  'pages.products.import.fetchSuccess': '상품 정보를 가져왔습니다',
  'pages.products.import.urlRequired': 'URL을 입력해주세요',
  'pages.products.import.invalidUrl': '지원하는 플랫폼: 타오바오(티몰), 1688, VVIC',
  'pages.products.import.productIdNotFound': 'URL에서 상품 ID를 추출할 수 없습니다. URL 형식을 확인해주세요.',
  'pages.products.import.fetchError': '상품 정보를 가져오는데 실패했습니다. 다시 시도해주세요.',
  'pages.products.import.productInfo': '상품 정보',
  'pages.products.import.translate': '자동 번역',
  'pages.products.import.translateSuccess': '자동 번역이 완료되었습니다',
  'pages.products.import.translateError': '번역에 실패했습니다',
  'pages.products.import.save': '상품 등록',
  'pages.products.import.saveSuccess': '상품이 등록되었습니다',
  'pages.products.import.saveError': '필수 항목을 입력해주세요',
  'pages.products.import.basicInfo': '기본 정보',
  'pages.products.import.optionsInfo': '옵션 정보',
  'pages.products.import.specsInfo': '상세 스펙',
  'pages.products.import.titleCn': '상품명 (중문)',
  'pages.products.import.titleCnPlaceholder': '중문 상품명을 입력하세요',
  'pages.products.import.titleKo': '상품명 (한글)',
  'pages.products.import.titleKoPlaceholder': '한글 상품명을 입력하세요',
  'pages.products.import.titleEn': '상품명 (영문)',
  'pages.products.import.titleEnPlaceholder': '영문 상품명을 입력하세요',
  'pages.products.import.originalPrice': '원가 (₩)',
  'pages.products.import.sellingPrice': '판매가 (₩)',
  'pages.products.import.realPrice': '실제 가격',
  'pages.products.import.otherPrice': '기타 가격',
  'pages.products.import.tagPrice': '태그 가격',
  'pages.products.import.margin': '마진율',
  'pages.products.import.productType': '상품 유형',
  'pages.products.import.productTypeSelf': '자체',
  'pages.products.import.productTypeLabang': '라방',
  'pages.products.import.labangEndDate': '라방 종료일',
  'pages.products.import.labangEndDateRequired': '라방 종료일을 입력해주세요',
  'pages.products.import.labangPeriod': '라방 기간',
  'pages.products.import.labangPeriodRequired': '라방 기간을 입력해주세요',
  'pages.products.import.days': '일',
  'pages.products.list.productType': '상품 유형',
  'pages.products.import.description': '상품 설명 (HTML)',
  'pages.products.import.descriptionHint': 'HTML 콘텐츠가 지원됩니다. 설명을 직접 편집할 수 있습니다.',
  'pages.products.import.category': '카테고리',
  'pages.products.import.categoryPlaceholder': '카테고리 선택',
  'pages.products.import.optionNameCn': '옵션명 (중문)',
  'pages.products.import.optionNameKo': '옵션명 (한글)',
  'pages.products.import.optionNameEn': '옵션명 (영문)',
  'pages.products.import.optionImage': '옵션 이미지',
  'pages.products.import.optionImageUrlPlaceholder': '이미지 URL 입력',
  'pages.products.import.selectStore': '스토어 선택',
  'pages.products.import.inputAttributes': '속성 입력',
  'pages.products.import.attributeName': '속성명',
  'pages.products.import.attributeValue': '속성값',
  'pages.products.import.synchronizeToPropertyList': '속성 목록에 동기화',
  'pages.products.import.attributeList': '속성 목록',
  'pages.products.import.multipleAttributes': '다중 속성',
  'pages.products.import.rmbCostPrice': '위안 원가',
  'pages.products.import.koreanWonCostPrice': '원화 원가',
  'pages.products.import.originalPriceRMB': '원가 (위안)',
  'pages.products.import.originalPriceKoreanWon': '원가 (원화)',
  'pages.products.import.rmbPrice': '위안 가격',
  'pages.products.import.salesPrice': '판매가',
  'pages.products.import.inStock': '재고',
  'pages.products.import.rebatePercentage': '리베이트 비율',
  'pages.products.import.attributeImages': '속성 이미지',
  'pages.products.import.attributesInfo': '속성 정보',
  'pages.products.import.optionPrice': '제안 가격',
  'pages.products.import.optionPriceCny': '가격 (위안)',
  'pages.products.import.optionPriceKrw': '가격 (원)',
  'pages.products.import.optionStock': '재고',
  'pages.products.import.optionSkuId': 'SKU ID',
  'pages.products.import.optionSpecId': 'Spec ID',
  'pages.products.import.specId': '스펙 ID',
  'pages.products.import.descriptionTab': '상품 설명',
  'pages.products.import.specKeyCn': '속성명 (중문)',
  'pages.products.import.specKeyKo': '속성명 (한글)',
  'pages.products.import.specKeyEn': '속성명 (영문)',
  'pages.products.import.specValueCn': '값 (중문)',
  'pages.products.import.specValueKo': '값 (한글)',
  'pages.products.import.specValueEn': '값 (영문)',
  'pages.products.import.noImagesSelected': '선택된 이미지가 없습니다',
  'pages.products.import.downloading': '{count}개의 이미지를 다운로드하는 중...',
  'pages.products.import.downloadSuccess': '{count}개의 이미지를 성공적으로 다운로드했습니다',
  'pages.products.import.downloadPartial': '{total}개 중 {success}개의 이미지를 다운로드했습니다. 일부 이미지는 CORS 제한으로 인해 새 탭에서 열렸을 수 있습니다.',
  'pages.products.import.downloadError': '이미지 다운로드에 실패했습니다',
  'pages.products.import.availableProducts': '재고 수량',
  'pages.products.import.unit': '개',
  'pages.products.import.category.clothing': '의류',
  'pages.products.import.category.shoes': '신발',
  'pages.products.import.category.bags': '가방',
  'pages.products.import.category.accessories': '액세서리',
  'pages.products.import.category.electronics': '전자제품',
  'pages.products.import.category.home': '홈/리빙',
  'pages.products.import.currency.cny': '위안',
  'pages.products.import.currency.krw': '원',
  'pages.products.import.platform.taobao': '타오바오',
  'pages.products.import.platform.1688': '1688',
  'pages.products.import.platform.tmall': '티몰',
  'pages.products.import.platform.aliexpress': '알리익스프레스',
  'pages.products.import.platform.temu': '테무',
  'pages.products.import.platform.vvic': 'VVIC',
  'pages.products.import.ratingMax': '5.0',
  'pages.products.import.sellerInfo': '판매자 정보',
  'pages.products.import.seller': '판매자',
  'pages.products.import.rating': '평점',
  'pages.products.import.sales': '판매량',
  'pages.products.import.sellerAddress': '판매자 주소',
  'pages.products.import.sellerPhone': '판매자 전화번호',
  'pages.products.import.sellerMailbox': '판매자 우편함',
  'pages.products.import.sellerOpenId': '판매자 오픈 ID',
  'pages.products.import.productRating': '상품 평점',
  'pages.products.import.soldAmount': '판매량',
  'pages.products.import.salesUnit': '건',
  'pages.products.import.images': '상품 이미지',
  'pages.products.import.imagesCount': '상품 이미지 ({count}개)',
  'pages.products.import.download': '다운로드',
  'pages.products.import.downloadStart': '{count}개의 이미지 다운로드를 시작합니다',
  'pages.products.import.imageSelectInfo': '이미지를 드래그하여 순서를 변경할 수 있습니다. 첫 번째 이미지가 자동으로 대표 이미지로 설정됩니다.',
  'pages.products.import.mainImage': '대표',
  'pages.products.imageTranslate.button': '전체 이미지 번역',
  'pages.products.imageTranslate.descriptionButton': '상세설명 이미지 문자 번역',
  'pages.products.imageTranslate.title': '이미지 문자 번역 검수',
  'pages.products.imageTranslate.useTranslated': '번역본 사용',
  'pages.products.imageTranslate.noText': '번역할 문자 없음',
  'pages.products.imageTranslate.original': '원본',
  'pages.products.imageTranslate.translated': '번역본',
  'pages.products.imageTranslate.erased': '지움',
  'pages.products.imageTranslate.editHint': '문구마다 번역·그대로 두기·지우기를 고르고 번역문을 직접 고칠 수 있습니다.',
  'pages.products.imageTranslate.rerender': '다시 그리기',
  'pages.products.imageTranslate.actTranslate': '번역',
  'pages.products.imageTranslate.actKeep': '그대로',
  'pages.products.imageTranslate.actErase': '지우기',
  'pages.products.imageTranslate.autoPlaceholder': '비워 두면 자동 번역',
  'pages.products.imageTranslate.keptPlaceholder': '원문 그대로 둠',
  'pages.products.imageTranslate.tilted': '기울어짐',
  'pages.products.imageTranslate.tiltedHint': '기울어진 글씨(소품에 적힌 글)라 기본으로 그대로 두었습니다.',
  'pages.products.imageTranslate.truncated': '잘림',
  'pages.products.imageTranslate.truncatedHint': '글이 자리에 다 들어가지 않아 "…"로 잘렸습니다. 더 짧게 고쳐 보십시오.',
  'pages.products.imageTranslate.staleHint': '고친 문구가 아직 그림에 반영되지 않은 이미지가 있습니다. "다시 그리기"를 먼저 누르십시오.',
  'pages.products.imageTranslate.reopened': '적용된 번역본 다시 열기',
  'pages.products.imageTranslate.reopenedHint': '이미 번역본이 적용된 이미지입니다. 원본과 지난 결정을 불러왔으니 이어서 고칠 수 있습니다. "번역본 사용"을 끄고 적용하면 원본으로 되돌아갑니다.',
  'pages.products.imageTranslate.selectAll': '번역된 것 모두 선택',
  'pages.products.imageTranslate.selected': '선택',
  'pages.products.imageTranslate.shortcutHint': '← → 이동 · 스페이스 선택',
  'pages.products.imageTranslate.failedHint': '{count}장이 실패했습니다. 목록에서 확인하고 재시도하십시오.',
  'pages.products.imageTranslate.viewLarge': '크게',
  'pages.products.imageTranslate.viewCompact': '작게',
  'pages.products.imageTranslate.failed': '실패',
  'pages.products.imageTranslate.retry': '재시도',
  'pages.products.imageTranslate.apply': '적용 ({count})',
  'pages.products.imageTranslate.cancel': '취소',
  'pages.products.imageTranslate.applied': '{count}개 이미지를 교체했습니다',
  'pages.products.imageTranslate.noImages': '번역할 이미지가 없습니다',
  'pages.products.import.mainImageSet': '대표 이미지가 설정되었습니다',
  'pages.products.import.imagePreview': '이미지 미리보기',
  'pages.products.import.close': '닫기',

  // Orders Common
  'pages.orders.common.orderNumber': '주문번호',
  'pages.orders.shippingMethod.sea': '해운',
  'pages.orders.shippingMethod.air': '항공',
  'pages.orders.shippingMethod.standard': '일반',
  'pages.orders.common.manual': '수동결제',
  'pages.orders.common.auto': '자동결제',
  'pages.orders.common.productType': '[상품구분]',
  'pages.orders.common.platformType': '플랫폼구분',
  'pages.orders.common.shippingMethod': '운송방식',
  'pages.orders.common.shippingMethodNormal': '일반',
  'pages.orders.common.shippingMethodFast': '빠른',
  'pages.orders.common.shippingMethodExpress': '특급',
  'pages.orders.common.shippingStatus': '출고여부',
  'pages.orders.common.warehouseAndTransferMethod': '창고/운송방식',
  'pages.orders.common.paymentMethodShort': '결제방식',
  'pages.orders.common.memberNameWithMailbox': '회원명/(회원사서함)',
  'pages.orders.common.receiverName': '수취인명',
  'pages.orders.common.sellerName': '셀러명',
  'pages.orders.common.sellerMailbox': '셀러사서함',
  'pages.orders.common.sellerNameWithMailbox': '셀러명/(셀러사서함)',
  'pages.orders.common.paymentMethod': '결제방법',
  'pages.orders.common.shipped': '출고',
  'pages.orders.common.notShipped': '미출고',
  'pages.orders.common.membershipCode': '회원명',
  'pages.orders.common.userId': '회원ID',
  'pages.orders.common.userUniqueId': '사서함',
  'pages.orders.common.unpaid': '미결제',
  'pages.ordersz.common.receiver': '수취인',
  'pages.orders.common.trackingCount': '트래킹수',
  'pages.orders.common.warehousedCount': '입고수',
  'pages.orders.common.quantity': '수량',
  'pages.orders.common.firstCost': '1차 비용',
  'pages.orders.common.secondCost': '2차 비용',
  'pages.orders.common.totalAmount': '총액',
  'pages.orders.common.chineseTransportationCost': '[중국운송비]',
  'pages.orders.common.RealCost': '[실제비용]',
  'pages.orders.common.internationalShippingCost': '1차비용',
  'pages.orders.common.firstInternationalShippingCost': '1차 국제운송비',
  'pages.orders.common.appliedWeight': '적용무게',
  'pages.orders.common.realWeight': '실무게',
  'pages.orders.common.receiver': '수취인',
  'pages.orders.common.extraInternationalShippingCost': '2차비용',
  'pages.orders.common.paymentPending': '결제 대기',
  'pages.orders.common.paymentComplete': '결제 완료',
  'pages.orders.common.total': '총 {count}건',
  'pages.orders.common.paidAmount': '결제금액',
  'pages.orders.common.weight': '무게',
  'pages.orders.common.trackingNumber': '운송장번호',
  'pages.orders.common.waybillNumber': '송장번호',
  'pages.orders.common.shipDate': '출고일자',
  'pages.orders.common.rackNumber': '랙번호',
  'pages.orders.common.warehouseStatus': '입고상태',
  'pages.orders.common.progressStatus': '진행상태',
  'pages.orders.common.createdAt': '등록일',
  'pages.orders.common.updatedAt': '수정일',
  'pages.orders.common.inquiryResponder': '문의답변자',
  'pages.orders.common.buyer': '구매담당자',
  'pages.orders.common.warehouseHandler': '창고담당자',
  'pages.orders.common.actions': '기능',
  'pages.orders.common.paymentStatus': '결제상태',
  'pages.orders.common.transferMethod': '운송방식',
  'pages.orders.common.none': '없음',
  'pages.orders.common.notRegistered': '미등록',
  'pages.orders.common.kdexpCarrier': '경동택배',
  'pages.orders.common.kdexpShort': '경동',
  'pages.orders.common.kdexpSentDate': '발송',
  'pages.orders.common.kdexpMore': '외 {count}건',
  'pages.orders.common.items': '개',
  'pages.orders.common.won': '원',
  'pages.orders.common.cny': '위안',
  'pages.orders.common.count': '건',
  'pages.orders.filter.sellerId': '판매자 ID',
  'pages.orders.filter.sellerIdPlaceholder': '라이브 판매자 ID (sellerId)',
  'pages.orders.filter.memberMailbox': '회원 사서함',
  'pages.orders.filter.sellerMailbox': '셀러 사서함',
  
  // Order Status Groups
  'pages.orders.status.purchaseAgency': '구매대행',
  'pages.orders.status.vvicHighpass': 'VVIC 하이패스',
  'pages.orders.status.rocket': '로켓',
  'pages.orders.status.shippingAgency': '배송대행',
  'pages.orders.status.warehouse': '현지입/출고',
  'pages.orders.status.error': '오류',
  'pages.orders.status.return': '반품관리',
  'pages.orders.status.inventory': '재고관리',
  'pages.orders.status.warehoused': '입고완료',
  'pages.orders.status.done': '완료',
  
  // Order Status Items
  'pages.orders.status.tempSave': '임시저장',
  'pages.orders.status.purchaseQuote': '구매견적',
  'pages.orders.status.paymentPending': '구매결제대기',
  'pages.orders.status.paymentComplete': '구매결제완료',
  'pages.orders.status.purchasing': '구매중',
  'pages.orders.status.automaticProcurement': '자동구매중',
  'pages.orders.status.manualProcurement': '수동구매중',
  'pages.orders.status.financialSettlement': '재무결제',
  'pages.orders.status.problemProduct': '문제상품',
  'pages.orders.status.purchaseFinalComplete': '구매완료',
  'pages.orders.status.centerArrivalExpected': '센터도착예정',
  'pages.orders.status.expectedWarehouseIn': '예상입고',
  'pages.orders.status.warehouseInProgress': '입고처리중',
  'pages.orders.status.warehouseInComplete': '입고완료',
  'pages.orders.status.processing': '처리중',
  'pages.orders.status.notWarehoused': '미입고',
  'pages.orders.status.additionalFeePending': '추가비용결제대기',
  'pages.orders.status.additionalFeeComplete': '추가비용결제완료',
  'pages.orders.status.shipmentPending': '출고대기',
  'pages.orders.status.shipmentComplete': '출고완료',
  'pages.orders.status.waitingSettlement': '출고결제대기',
  'pages.orders.status.settlementComplete': '출고결제완료',
  'pages.orders.status.deliveryException': '현지배송지연',
  'pages.orders.status.domesticWarehousePacking': '패킹중',
  'pages.orders.status.errorWarehouse': '오류입고',
  'pages.orders.status.noOrderInfo': '노데이타',
  'pages.orders.status.userRefundRequest': "회원환불신청",
  'pages.orders.status.userRefundProgress': '회원환불진행중',
  'pages.orders.status.userRefundComplete': '회원환불완료',
  'pages.orders.status.platformRefundRequest': '플랫폼환불신청',
  'pages.orders.status.platformRefundComplete': '플랫폼환불완료',
  'pages.orders.status.localRefundRequest': '플랫폼 환불 신청',
  'pages.orders.status.localRefundProgress': '플랫폼 환불 진행중',
  'pages.orders.status.localRefundComplete': '플랫폼 환불 완료',
  'pages.orders.status.orderCancelled': '주문페기',
  'pages.orders.status.errorIgnore': '오류무시',
  'pages.orders.status.returnMove': '반품이동',
  'pages.orders.status.refundProcessing': '환불처리중',
  'pages.orders.status.refundRequest': '현지환불신청',
  'pages.orders.status.cancelRequest': '신청취소',
  'pages.orders.status.refunded': '현지환불완료',
  'pages.orders.status.shipmentHold': '주문페기',
  'pages.orders.status.internationalShipping': '국제운송',
  'pages.orders.status.internationalInOut': '국제입/출고',
  'pages.orders.status.internationalShippingInProgress': '국제운송중',
  'pages.orders.status.internationalShippingComplete': '국제운송완료',
  'pages.orders.status.orderReceived': '주문완료',
  'pages.orders.status.finalRefundRequest': '최종환불신청',
  'pages.orders.status.finalRefundProgress': '최종환불진행중',
  'pages.orders.status.finalRefundComplete': '최종환불완료',
  'pages.orders.status.returnRequest': '반품신청',
  'pages.orders.status.returnComplete': '반품완료',
  'pages.orders.status.inventoryRequest': '재고신청',
  'pages.orders.status.inventoryAvailable': '사용가능',
  'pages.orders.status.inventoryOut': '재고소진',
  'pages.orders.status.applicationReceived': '접수신청',
  'pages.orders.status.receiptApplication': '접수신청',
  'pages.orders.status.deliveryApply': '배송신청',
  
  // In China Warehouse Page
  'pages.orders.inChinaWarehouse.title': '중국창고입고',
  'pages.orders.inChinaWarehouse.regularMember': '일반 회원',
  'pages.orders.inChinaWarehouse.businessMember': '사업자 회원',
  'pages.orders.inChinaWarehouse.waiting': '입고대기',
  'pages.orders.inChinaWarehouse.arrived': '입고완료',
  'pages.orders.inChinaWarehouse.inspecting': '검수중',
  'pages.orders.inChinaWarehouse.count': '건',
  'pages.orders.inChinaWarehouse.warehouseDate': '입고일',
  'pages.orders.inChinaWarehouse.warehouseStatus': '입고상태',
  'pages.orders.inChinaWarehouse.inspectionStatus': '검수상태',
  'pages.orders.inChinaWarehouse.weight': '무게',
  'pages.orders.inChinaWarehouse.volume': '부피',
  'pages.orders.inChinaWarehouse.packageCount': '포장수',
  'pages.orders.inChinaWarehouse.inspectionComplete': '검수완료',
  'pages.orders.inChinaWarehouse.shipmentRequest': '출고요청',
  'pages.orders.inChinaWarehouse.memoNormal': '정상입고',
  'pages.orders.inChinaWarehouse.memoFragile': '파손주의',
  'pages.orders.inChinaWarehouse.memoReinspect': '재검수필요',
  
  // Pending Address Page
  'pages.orders.pendingAddress.title': '배송지입력대기',
  'pages.orders.pendingAddress.regularMember': '일반 회원',
  'pages.orders.pendingAddress.businessMember': '사업자 회원',
  'pages.orders.pendingAddress.noAddress': '배송지 미입력',
  'pages.orders.pendingAddress.addressCompleted': '배송지 입력완료',
  'pages.orders.pendingAddress.filterApplied': '{group} > {label} 필터 적용',
  'pages.orders.pendingAddress.filterCleared': '필터 해제',
  'pages.orders.pendingAddress.addressStatus': '배송지상태',
  'pages.orders.pendingAddress.receiverName': '수취인명',
  'pages.orders.pendingAddress.phone': '연락처',
  'pages.orders.pendingAddress.address': '주소',
  'pages.orders.pendingAddress.zipCode': '우편번호',
  'pages.orders.pendingAddress.memo': '배송메모',
  'pages.orders.pendingAddress.editAddress': '배송지 수정',
  'pages.orders.pendingAddress.saveAddress': '저장',
  'pages.orders.pendingAddress.addressSaved': '배송지 정보가 저장되었습니다',
  'pages.orders.pendingAddress.count': '건',
  'pages.orders.pendingAddress.pending': '미입력',
  'pages.orders.pendingAddress.completed': '입력완료',
  
  // Pending Payment Page
  'pages.orders.pendingPayment.title': '결제확인',
  'pages.orders.pendingPayment.regularMember': '일반 회원',
  'pages.orders.pendingPayment.businessMember': '사업자 회원',
  'pages.orders.pendingPayment.paymentPending': '결제대기',
  'pages.orders.pendingPayment.paymentCompleted': '결제완료',
  'pages.orders.pendingPayment.filterApplied': '{group} > {label} 필터 적용',
  'pages.orders.pendingPayment.filterCleared': '필터 해제',
  'pages.orders.pendingPayment.paymentPhaseLabel': '결제 구분',
  'pages.orders.pendingPayment.paymentPhaseAll': '전체 (1차+2차)',
  'pages.orders.pendingPayment.paymentPhaseFirst': '1차 결제',
  'pages.orders.pendingPayment.paymentPhaseSecond': '2차 결제',
  'pages.orders.pendingPayment.clearPaymentPhase': '결제 구분 초기화',
  'pages.orders.pendingPayment.unmatchedBankOnlyHint': '미매칭 무통장입금 건만 표시됩니다.',
  'pages.orders.pendingPayment.paymentAmount': '결제금액',
  'pages.orders.pendingPayment.totalAmount': '총액',
  'pages.orders.pendingPayment.payerName': '결제자명',
  'pages.orders.pendingPayment.paymentMethod': '결제수단',
  'pages.orders.pendingPayment.paymentDate': '결제일시',
  'pages.orders.pendingPayment.orderDetails': '주문내역',
  'pages.orders.pendingPayment.paymentStatus': '결제상태',
  'pages.orders.pendingPayment.actions': '기능',
  'pages.orders.pendingPayment.confirmPayment': '결제확인',
  'pages.orders.pendingPayment.cancelPayment': '결제취소',
  'pages.orders.pendingPayment.viewDetails': '상세보기',
  'pages.orders.pendingPayment.paymentConfirmed': '주문 {orderNo}의 결제가 확인되었습니다',
  'pages.orders.pendingPayment.paymentConfirmError': '주문 {orderNo}의 결제 확인에 실패했습니다',
  'pages.orders.pendingPayment.orderIdNotFound': '주문 ID를 찾을 수 없습니다',
  'pages.orders.pendingPayment.confirmPaymentTitle': '결제 확인',
  'pages.orders.pendingPayment.confirmPaymentContent': '주문 {orderNo}의 결제를 확인하시겠습니까?',
  'pages.orders.pendingPayment.cancelPaymentTitle': '결제 취소',
  'pages.orders.pendingPayment.cancelPaymentContent': '주문 {orderNo}의 결제를 취소하시겠습니까?',
  'pages.orders.pendingPayment.paymentCancelled': '주문 {orderNo}의 결제가 취소되었습니다',
  'pages.orders.pendingPayment.paymentCancelError': '주문 {orderNo}의 결제 취소에 실패했습니다',
  'pages.orders.pendingPayment.invalidOrderId': '유효하지 않은 주문 ID입니다. 결제를 확인할 수 없습니다.',
  'pages.orders.pendingPayment.depositDiscount': '예치금',
  'pages.orders.pendingPayment.deposit': '예치금',
  'pages.orders.pendingPayment.point': '포인트',
  'pages.orders.pendingPayment.coupon': '쿠폰',
  'pages.orders.pendingPayment.discount': '할인사용',
  'pages.orders.pendingPayment.pointCoupon': '(예치금/포인트/쿠폰)',
  'pages.orders.pendingPayment.regularMemberTag': '일반회원',
  'pages.orders.pendingPayment.businessMemberTag': '사업자',
  'pages.orders.pendingPayment.count': '건',
  'pages.orders.pendingPayment.paymentMethodCard': '신용카드',
  'pages.orders.pendingPayment.paymentMethodTransfer': '계좌이체',
  'pages.orders.pendingPayment.paymentMethodDeposit': '예치금',
  'pages.orders.pendingPayment.paymentMethodBillgate': 'Billgate',
  'pages.orders.pendingPayment.memberName': '회원명',
  'pages.orders.pendingPayment.applicationDate': '신청일',
  'pages.orders.pendingPayment.paymentCost': '결제금액',
  'pages.orders.pendingPayment.depositForUse': '사용예치금',
  'pages.orders.pendingPayment.paymentOrderNumber': '결제주문번호',
  
  // Order Statistics Page
  'pages.orders.statistics.title': '주문 통계',
  'pages.orders.statistics.dateRange': '조회 기간',
  'pages.orders.statistics.last7Days': '최근 7일',
  'pages.orders.statistics.last30Days': '최근 30일',
  'pages.orders.statistics.last90Days': '최근 90일',
  'pages.orders.statistics.totalOrders': '총 주문 수량',
  'pages.orders.statistics.purchaseComplete': '구매 완료',
  'pages.orders.statistics.shipped': '출고 완료',
  'pages.orders.statistics.totalSales': '판매액',
  'pages.orders.statistics.refundCount': '환불 상품 수',
  'pages.orders.statistics.refundAmount': '환불 금액',
  'pages.orders.statistics.trendChart': '영업 추세 그래프',
  'pages.orders.statistics.dailyStats': '일별 통계',
  'pages.orders.statistics.chart.orders': '주문 수',
  'pages.orders.statistics.chart.purchaseComplete': '구매 완료',
  'pages.orders.statistics.chart.shipped': '출고 완료',
  'pages.orders.statistics.chart.revenue': '매출액',
  'pages.orders.statistics.chart.refunds': '환불 수',
  'pages.orders.statistics.chart.refundAmount': '환불 금액',
  'pages.orders.statistics.table.date': '날짜',
  'pages.orders.statistics.table.orderCount': '주문 수',
  'pages.orders.statistics.table.purchaseComplete': '구매 완료',
  'pages.orders.statistics.table.shipped': '출고 완료',
  'pages.orders.statistics.table.revenue': '매출액',
  'pages.orders.statistics.table.refundCount': '환불 수',
  'pages.orders.statistics.table.refundAmount': '환불 금액',
  'pages.orders.statistics.table.total': '총 {total}건',
  'pages.orders.statistics.sourceFilter': '판매 소스',
  'pages.orders.statistics.source.all': '전체',
  'pages.orders.statistics.source.live': '라이브',
  'pages.orders.statistics.source.ownmall': '오운몰 일반',
  'pages.orders.statistics.source.1688': '1688',
  'pages.orders.statistics.source.taobao': '타오바오',
  'pages.orders.statistics.source.vvic': 'VVIC',
  'pages.orders.statistics.sourceBreakdown': '소스별 매출 구성',
  'pages.orders.statistics.sourceOrderCount': '주문 {count}건',
  'pages.orders.statistics.amountChart': '금액 추이 (소스별 매출·환불)',
  'pages.orders.statistics.countChart': '건수 추이',
  'pages.orders.statistics.sellerTop': '셀러별 라이브 매출 TOP 10',
  'pages.orders.statistics.sellerTop.rank': '순위',
  'pages.orders.statistics.sellerTop.seller': '셀러',
  'pages.orders.statistics.sellerTop.orderCount': '결제 주문수',
  'pages.orders.statistics.sellerTop.saleAmount': '매출액',
  'pages.orders.statistics.sellerTop.refundAmount': '환불 금액',
  'pages.orders.statistics.avgOrderValue': '객단가 (₩)',
  'pages.orders.statistics.refundRate': '환불률',
  'pages.orders.statistics.vsPrevPeriod': '직전 기간 대비',
  'pages.orders.statistics.backlog.title': '실시간 처리 현황',
  'pages.orders.statistics.backlog.asOf': '기준',
  'pages.orders.statistics.backlog.stage.payWait': '결제대기',
  'pages.orders.statistics.backlog.stage.purchasing': '구매중',
  'pages.orders.statistics.backlog.stage.inbound': '입고대기',
  'pages.orders.statistics.backlog.stage.warehouse': '창고작업중',
  'pages.orders.statistics.backlog.stage.shipReady': '출고대기',
  'pages.orders.statistics.backlog.stage.shipping': '배송중',
  'pages.orders.statistics.backlog.stage.problem': '문제·오류',
  'pages.orders.statistics.backlog.stage.refundInProgress': '환불 진행중',
  'pages.orders.statistics.backlog.stale': '지연 {count}',
  'pages.orders.statistics.backlog.staleTooltip': '{hours}시간 이상 상태 변화 없는 주문',
  'pages.orders.statistics.backlog.needsAction': '처리가 필요한 주문',
  'pages.orders.statistics.backlog.status.domesticPacking': '현지패킹',
  
  // All Orders Page
  'pages.orders.all.title': '전체주문',
  'pages.orders.all.count': '건',
  'pages.orders.all.filterApplied': '필터 적용',
  'pages.orders.all.filterCleared': '필터 해제',
  'pages.orders.all.bulkProcess': '건 일괄 처리',
  'pages.orders.all.selected': '선택된',
  'pages.orders.all.group.purchase': '구매대행',
  'pages.orders.all.group.vvic': 'VVIC하이패스',
  'pages.orders.all.group.shipping': '배송대행',
  'pages.orders.all.group.warehouse': '입/출고',
  'pages.orders.all.group.error': '오류',
  'pages.orders.all.group.return': '반품관리',
  'pages.orders.all.group.stock': '재고관리',
  'pages.orders.all.status.tempSave': '임시저장',
  'pages.orders.all.status.estimate': '구매견적',
  'pages.orders.all.status.paymentWaiting': '결제대기',
  'pages.orders.all.status.paymentComplete': '결제완료',
  'pages.orders.all.status.purchasing': '구매중',
  'pages.orders.all.status.purchaseComplete': '구매최종완료',
  'pages.orders.all.status.applicationSubmit': '접수신청',
  'pages.orders.all.status.centerArrival': '센터도착예정',
  'pages.orders.all.status.warehouseProcessing': '입고처리중',
  'pages.orders.all.status.warehouseComplete': '입고완료',
  'pages.orders.all.status.shipmentWaiting': '출고대기',
  'pages.orders.all.status.shipmentComplete': '출고완료',
  'pages.orders.all.status.extraFeeWaiting': '추가비용결제대기',
  'pages.orders.all.status.extraFeeComplete': '추가비용결제완료',
  'pages.orders.all.status.errorWarehouse': '오류입고',
  'pages.orders.all.status.noOrderInfo': '노데이타',
  'pages.orders.all.status.errorIgnore': '오류무시',
  'pages.orders.all.status.returnMove': '반품이동',
  'pages.orders.all.status.refundProcessing': '환불처리중',
  'pages.orders.all.status.refundRequest': '환불신청',
  'pages.orders.all.status.cancelRequest': '신청취소',
  'pages.orders.all.status.refundComplete': '환불완료',
  'pages.orders.all.status.shipmentHold': '출고보류',
  'pages.orders.all.status.returnRequest': '반품신청',
  'pages.orders.all.status.returnComplete': '반품완료',
  'pages.orders.all.status.stockRequest': '재고신청',
  'pages.orders.all.status.stockAvailable': '사용가능',
  'pages.orders.all.status.stockOut': '재고소진',
  'pages.orders.all.pageSize': '페이지당 건수',
  'pages.orders.all.center': '센터',
  'pages.orders.all.centerAll': '전체',
  'pages.orders.all.centerWeihai': '(중국)위해',
  'pages.orders.all.centerQingdao': '(중국)청도',
  'pages.orders.all.centerGuangzhou': '(중국)광저우',
  'pages.orders.all.shippingMethod': '운송방식',
  'pages.orders.all.shippingAir': '항공',
  'pages.orders.all.shippingAirExpress': '항공특송',
  'pages.orders.all.shippingSea': '배',
  'pages.orders.all.shippingSeaExpress': '배특송',
  'pages.orders.all.isShipped': '출고여부',
  'pages.orders.all.autoPayment': '자동결제',
  'pages.orders.all.manualPayment': '수동결제',
  'pages.orders.all.registrationDate': '등록일',
  'pages.orders.all.warehouseStatus': '입고상태',
  'pages.orders.all.warehouseExpected': '입고예정',
  'pages.orders.all.warehousePartial': '부분입고',
  'pages.orders.all.warehouseDone': '입고완료',
  'pages.orders.all.receiverType': '수취인 구분',
  'pages.orders.all.receiverPersonal': '개인',
  'pages.orders.all.receiverBusiness': '사업자',
  'pages.orders.all.mailbox': '사서함',
  'pages.orders.all.mailboxPlaceholder': '사서함 번호',
  'pages.orders.all.receiver': '수취인',
  'pages.orders.all.receiverPlaceholder': '수취인명',
  'pages.orders.all.productNo': '상품번호',
  'pages.orders.all.trackingNo': '트래킹번호',
  'pages.orders.all.trackingNoPlaceholder': '중국/국내 트래킹번호',
  'pages.orders.all.orderNoPlaceholder': 'TM2025...',
  'pages.orders.all.krTrackPlaceholder': '국내 운송장번호',
  'pages.orders.all.orderType': '신청구분',
  'pages.orders.all.shippingMethodCol': '운송방식',
  'pages.orders.all.shippedStatus': '출고여부',
  'pages.orders.all.shipped': '출고',
  'pages.orders.all.notShipped': '미출고',
  'pages.orders.all.trackingCount': '트래킹수',
  'pages.orders.all.warehousedCount': '입고수',
  'pages.orders.all.totalAmount': '총액',
  'pages.orders.all.paidAmount': '결제금액',
  'pages.orders.all.weightLabel': '무게',
  'pages.orders.all.krTrackingNumber': '운송장번호',
  'pages.orders.all.shipDateRack': '출고일자/랙번호',
  'pages.orders.all.notRegistered': '미등록',
  'pages.orders.all.progressStatus': '진행상태',
  'pages.orders.all.createdAt': '등록일',
  'pages.orders.all.updatedAt': '수정일',
  'pages.orders.all.inquiryResponder': '문의답변자',
  'pages.orders.all.purchaseManager': '구매담당자',
  'pages.orders.all.none': '없음',
  'pages.orders.all.copyOrder': '주문복사',
  'pages.orders.all.additionalCost': '대행추가비용',
  'pages.orders.all.orderInquiry': '주문문의',
  'pages.orders.all.registerTracking': '운송장등록',
  'pages.orders.all.changeBoxCount': '운송장 박스수 변경',
  'pages.orders.all.printTracking': '운송장 출력',
  'pages.orders.all.reissueTracking': '운송장재발급',
  'pages.orders.all.coupangLabel': '쿠팡라벨',
  'pages.orders.all.return': '반품',
  'pages.orders.all.bulkRegisterTracking': '운송장일괄등록',
  
  // User Orders Page
  'pages.orders.user.title': '일반 회원 주문',
  'pages.orders.user.Picking': '픽업',
  'pages.orders.vvicHighpass.title': 'VVIC 하이패스 주문',
  'pages.orders.rocket.title': '로켓 주문',
  'pages.orders.user.filterApplied': '{group} > {label} 필터 적용 (일반회원)',
  'pages.orders.user.filterCleared': '필터 해제',
  'pages.orders.user.newOrderNotification': '새 주문이 도착했습니다: {orderNumber}',
  'pages.orders.user.paymentCompletedNotification': '결제완료 주문이 {count}건 증가했습니다',
  'pages.orders.user.purchasingNotification': '구매중 주문이 {count}건 증가했습니다',
  'pages.orders.user.viewAll': '전체 보기',
  'pages.orders.user.viewOrdersWithoutTrackingNumber': '운송장번호 없는 주문 보기',
  'pages.orders.user.viewOrder': '주문보기',
  'pages.orders.user.copied': '복사됨',
  'pages.orders.user.log': '로그',
  'pages.orders.user.buyingOrder': '구매 주문:',
  'pages.orders.user.deliveryOrderNumber': '배송 주문 번호:',
  'pages.orders.user.unreadInquiry': '미확인 문의: {count} (주문: {orderNo})',
  'pages.orders.user.regularMember': '일반',
  'pages.orders.user.orderCopy': '주문복사',
  'pages.orders.user.delete': '삭제',
  'pages.orders.user.editQuantity': '수량 수정',
  'pages.orders.user.quantityUpdated': '수량이 업데이트되었습니다',
  'pages.orders.user.quantityUpdateFailed': '수량 업데이트에 실패했습니다',
  'pages.orders.user.quantityRequired': '수량을 입력해주세요',
  'pages.orders.user.quantityMin': '수량은 1 이상이어야 합니다',
  'pages.orders.user.quantityPlaceholder': '수량을 입력하세요',
  'pages.orders.user.deleteCartItem': '장바구니 항목 삭제',
  'pages.orders.user.deleteCartItemConfirm': '이 장바구니 항목을 삭제하시겠습니까?',
  'pages.orders.user.cartItemDeleted': '장바구니 항목이 삭제되었습니다',
  'pages.orders.user.cartItemDeleteFailed': '장바구니 항목 삭제에 실패했습니다',
  'pages.orders.user.split': '나눔',
  'pages.orders.user.waybillRegistration': '운송장 등록',
  'pages.orders.user.waybillIssuance': '운송장 발행',
  'pages.orders.user.waybillReIssuance': '운송장 재발행',
  'pages.orders.user.waybillIssuanceSuccess': '운송장이 발행되었습니다',
  'pages.orders.user.waybillReIssuanceSuccess': '운송장이 재발행되었습니다',
  'pages.orders.user.waybillIssuanceFailed': '운송장 발행에 실패했습니다',
  'pages.orders.user.orderNumberRequired': '주문 번호가 필요합니다',
  'pages.orders.user.additionalCost': '대행추가비용',
  'pages.orders.user.purchaseCost': '구매비용',
  'pages.orders.user.orderInquiry': '주문문의',
  'pages.orders.user.trackingRegister': '운송장등록',
  'pages.orders.user.trackingIssue': '운송장발급',
  'pages.orders.user.noTrackingNumber': '운송장 번호 미입력',
  'pages.orders.user.trackingBoxChange': '운송장 박스수 변경',
  'pages.orders.user.trackingPrint': '운송장 출력',
  'pages.orders.user.trackingReissue': '운송장재발급',
  'pages.orders.user.invoiceDownload': '인보이스 다운로드',
  'pages.orders.user.coupangLabel': '쿠팡라벨',
  'pages.orders.user.inpackingUpload': '인패킹업로드',
  'pages.orders.user.hanjinTrackingPrint': '한진운송장출력',
  'pages.orders.user.hjNotSent': 'HJ미전송',
  'pages.orders.user.hjSuccess': 'HJ성공',
  'pages.orders.user.purchaseCostReset': '구매비용 리셋',
  'pages.orders.user.purchaseCostBankTransfer': '구매비용 무통장 처리',
  'pages.orders.user.fullRefund': '구매전체환불',
  'pages.orders.user.refund': '환불',
  'pages.orders.user.refundCancel': '환불 취소',
  'pages.orders.user.refundCancelConfirm': '이 환불 신청을 취소하시겠습니까?',
  'pages.orders.user.refundCancelSuccess': '환불 신청이 취소되었습니다',
  'pages.orders.user.refundCancelFailed': '환불 신청 취소에 실패했습니다',
  'pages.orders.user.confirmFullRefund': '전체 환불을 진행하시겠습니까? 주문 상태가 플랫폼 환불 신청으로 변경됩니다.',
  'pages.orders.user.returnCost': '반품비용',
  'pages.orders.user.returnCostReset': '반품비용 리셋',
  'pages.orders.user.returnCostBankTransfer': '반품비용 무통장 처리',
  'pages.orders.user.refundSplit': '환불 분할',
  'pages.orders.user.mergeSplitOrders': '분할 주문 병합',
  'pages.orders.user.noSplitOrdersSelected': '분할 주문을 선택하세요 (형식: {ordernumber}-S{splitnumber})',
  'pages.orders.user.mergeRequiresTwoOrders': '병합하려면 최소 2개의 분할 주문을 선택하세요',
  'pages.orders.user.mergeSplitOrdersConfirm': '분할 주문 병합 확인',
  'pages.orders.user.mergeSplitOrdersMessage': '{count}개의 분할 주문을 병합하시겠습니까?',
  'pages.orders.user.mergeSplitOrdersSuccess': '{count}개의 분할 주문이 성공적으로 병합되었습니다',
  'pages.orders.user.mergeSplitOrdersError': '분할 주문 병합 실패',
  'pages.orders.user.noValidOrderIds': '유효한 주문 ID를 찾을 수 없습니다',
  'pages.orders.user.confirmSubOrderRefund': '서브 주문을 환불하시겠습니까?',
  'pages.orders.user.subOrderRefundSuccess': '서브 주문 환불이 처리되었습니다',
  'pages.orders.user.subOrderRefundError': '서브 주문 환불 처리 실패, 다시 시도해주세요',
  'pages.orders.user.orderIdRequired': '주문 ID가 필요합니다',
  'pages.orders.user.confirmReturnCostReset': '반품비용을 리셋하시겠습니까?',
  'pages.orders.user.returnCostResetSuccess': '반품비용이 리셋되었습니다',
  'pages.orders.user.confirmReturnCostBankTransfer': '반품비용을 무통장 처리하시겠습니까?',
  'pages.orders.user.returnCostBankTransferSuccess': '반품비용 무통장 처리가 완료되었습니다',
  'pages.orders.user.viewNoTrackingNumber': '운송장 번호 미입력 주문 보기',
  'pages.orders.user.purchaseFinalComplete': '구매 최종 완료',
  'pages.orders.user.trackingNumberPrint': '운송장 출력',
  'pages.orders.user.purchaseForm': '구매 양식',
  'pages.orders.user.settlementOrders': '결제주문',
  'pages.orders.user.redfAir': 'REDF 항공',
  'pages.orders.user.purchaseFinalCompleteSuccess': '구매 완료 주문이 내보내기되었습니다',
  'pages.orders.user.noPurchaseCompletedOrders': '구매 완료 주문이 없습니다',
  'pages.orders.user.selectOrdersToPrint': '운송장 번호를 인쇄할 주문을 선택하세요',
  'pages.orders.user.noSelectedOrders': '선택된 주문이 없습니다',
  'pages.orders.user.trackingNumbersPrinted': '운송장 번호가 인쇄되었습니다',
  'pages.orders.user.printWaybill': '운송장 인쇄',
  'pages.orders.user.ManiProducts': '매니 상품',
  'pages.orders.user.printWaybillSelectOrders': '운송장을 인쇄하려면 최소 하나의 주문을 선택하거나 주문 상세를 열어주세요',
  'pages.orders.user.printWaybillGenerating': '운송장 생성 중...',
  'pages.orders.user.printWaybillSuccess': '운송장이 생성되었습니다. 인쇄 대화상자가 열렸습니다.',
  'pages.orders.user.printWaybillPopupBlocked': '팝업이 차단되었습니다. 팝업을 허용한 후 다시 시도해주세요.',
  'pages.orders.user.printWaybillNoData': '운송장 생성 실패: PDF 데이터를 받지 못했습니다.',
  'pages.orders.user.printWaybillError': '운송장 생성에 실패했습니다. 다시 시도해주세요.',
  'pages.orders.user.printWaybillOrderIdNotFound': '주문 ID를 찾을 수 없습니다',
  'pages.orders.user.noOrdersToExport': '내보낼 주문이 없습니다',
  'pages.orders.user.purchaseFormExported': '구매 양식이 내보내기되었습니다',
  'pages.orders.user.exportError': '내보내기 중 오류가 발생했습니다',
  'pages.orders.user.bundle': '묶음',
  'pages.orders.user.merge': '합치기',
  'pages.orders.user.shippingCost': '배송비용',
  'pages.orders.user.packing': '포장',
  'pages.orders.user.additionalCostReset': '추가비용 리셋',
  'pages.orders.user.additionalCostBankTransfer': '추가비용 무통장 처리',
  'pages.orders.user.customsCost': '통관비용',
  'pages.orders.user.additionalFee': '추가비용',
  'pages.orders.user.vvicLabelPrint': 'VVIC라벨출력',
  'pages.orders.user.subTrackingEdit': '서브운송장 수정',
  'pages.orders.user.packingSplit': '패킹나눔',
  'pages.orders.user.subOrderRefund': '하위주문 환불',
  'pages.orders.user.labelPrint': '면단 인쇄',
  'pages.orders.user.labelUpload': '면단 업로드',
  'pages.orders.user.labelGenerate': '면단 생성',
  'pages.orders.user.labelRegenerate': '면단 재생성',
  'pages.orders.user.labelBoxChange': '면단 박스 수 수정',
  'pages.orders.user.internationalShippingCostReset': '국제 배송비용 리셋',
  'pages.orders.user.internationalShippingCostBankTransfer': '국제 배송비용 무통장 처리',
  'pages.orders.user.confirmInternationalShippingCostReset': '국제 배송비용을 리셋하시겠습니까?',
  'pages.orders.user.confirmInternationalShippingCostBankTransfer': '국제 배송비용을 무통장 처리하시겠습니까?',
  'pages.orders.user.internationalShippingCostResetSuccess': '국제 배송비용이 리셋되었습니다',
  'pages.orders.user.internationalShippingCostResetFailed': '국제 배송비용 리셋에 실패했습니다',
  'pages.orders.user.internationalShippingCostBankTransferSuccess': '국제 배송비용 무통장 처리가 완료되었습니다',
  'pages.orders.user.confirmPurchaseCostBankTransfer': '구매비용 무통장 처리를 확인하시겠습니까?',
  'pages.orders.user.purchaseCostBankTransferSuccess': '구매비용 무통장 처리가 확인되었습니다',
  'pages.orders.user.confirmPurchaseCostReset': '구매비용을 리셋하시겠습니까?',
  'pages.orders.user.purchaseCostResetSuccess': '구매비용이 리셋되었습니다',
  'pages.orders.user.confirmCopyOrder': '이 주문을 복사하시겠습니까?',
  'pages.orders.user.copyOrderSuccess': '주문이 복사되었습니다',
  'pages.orders.user.confirmDelete': '이 주문을 삭제하시겠습니까?',
  'pages.orders.user.confirmDeleteDescription': '이 작업은 되돌릴 수 없습니다.',
  'pages.orders.user.deleteSuccess': '주문이 삭제되었습니다',
  'pages.orders.user.confirm': '확인',
  'pages.orders.user.cancel': '취소',
  'pages.orders.user.confirmOrderCancelled': '주문 취소 확인',
  'pages.orders.user.confirmOrderCancelledMessage': '이 주문을 취소하시겠습니까? 이 작업은 주문을 취소된 상태로 표시합니다.',
  'pages.orders.user.confirmBatchOrderCancelled': '주문 일괄 취소 확인',
  'pages.orders.user.confirmBatchOrderCancelledMessage': '{count}건의 주문을 취소하시겠습니까? 이 작업은 주문을 취소된 상태로 표시합니다.',
  'pages.orders.user.confirmLabelGenerate': '면단을 생성하시겠습니까?',
  'pages.orders.user.labelGenerateSuccess': '면단이 생성되었습니다',
  'pages.orders.user.confirmLabelRegenerate': '면단을 다시 생성하시겠습니까?',
  'pages.orders.user.labelRegenerateSuccess': '면단이 다시 생성되었습니다',
  'pages.orders.user.return': '반품',
  'pages.orders.user.additionalService': '부가서비스',
  'pages.orders.user.logisticsRequest': '물류센터 요청사항',
  'pages.orders.user.adminMemo': '관리자 메모',
  'pages.orders.user.orderMemo': '주문 메모',
  'pages.orders.user.adminMemoPlaceholder': '관리자 메모를 입력하세요...',
  'pages.orders.user.register': '등록',
  'pages.orders.user.adminMemoRegistered': '관리자 메모가 등록되었습니다',
  'pages.orders.user.statusChanged': '주문 {orderNo}의 상태가 {status}(으)로 변경되었습니다',
  'pages.orders.user.statusChangeNotAllowed': '{current}에서 {new}로 상태를 변경할 수 없습니다',
  'pages.orders.user.noStatusChangesAllowed': '이 필터에 대해 상태 변경이 허용되지 않습니다',
  'pages.orders.user.invoiceDownloaded': '인보이스가 다운로드되었습니다',
  'pages.orders.user.boxInvoiceDownloaded': '박스 인보이스가 다운로드되었습니다',
  'pages.orders.user.trackingSearch': '트래킹번호 {value}로 검색합니다',
  'pages.orders.user.warehouseScan': '입고스캔',
  'pages.orders.user.lsBatchPrintSs': 'SS코드 일괄 인쇄',
  'pages.orders.user.lsPrintSs': 'SS코드 인쇄',
  'pages.orders.user.lsPrintVv': 'VV코드 인쇄',
  'pages.orders.user.lsFeeReport': 'LS 주문 비용 리포트',
  'pages.orders.user.lsShippingList': 'LS 주문 발송 목록',
  'pages.orders.user.lsSelectLsOrders': '주문번호가 LS로 시작하는 주문을 선택해 주세요',
  'pages.orders.user.lsBatchPrintSsLoading': '생성 중…',
  'pages.orders.user.lsBatchPrintSsSuccess': '링크를 열었습니다',
  'pages.orders.user.lsBatchPrintSsFailed': 'SS코드 일괄 인쇄에 실패했습니다',
  'pages.orders.user.lsPrintSsLoading': '생성 중…',
  'pages.orders.user.lsPrintSsSuccess': '링크를 열었습니다',
  'pages.orders.user.lsPrintSsFailed': 'SS코드 인쇄에 실패했습니다',
  'pages.orders.user.lsPrintVvFailed': 'VV코드 인쇄에 실패했습니다',
  'pages.orders.user.lsReportLoading': '불러오는 중…',
  'pages.orders.user.lsReportOpened': '새 탭에서 열었습니다',
  'pages.orders.user.lsReportFailed': 'LS 비용 리포트를 열지 못했습니다',
  'pages.orders.user.lsShippingListFailed': 'LS 발송 목록을 열지 못했습니다',
  'pages.orders.user.rackManagement': '랙 관리',
  'pages.orders.user.noUserId': '회원 ID를 사용할 수 없습니다',

  // Warehouse Receipt Modal
  'pages.orders.warehouseReceipt.loadWarehousesFailed': '창고 목록을 불러오지 못했습니다',
  'pages.orders.warehouseReceipt.enterTrackingNumber': '트래킹번호를 입력해주세요',
  'pages.orders.warehouseReceipt.selectWarehouse': '창고를 선택해주세요',
  'pages.orders.warehouseReceipt.selectWarehousePlaceholder': '창고 선택',
  'pages.orders.warehouseReceipt.scanFailed': '트래킹번호 스캔에 실패했습니다',
  'pages.orders.warehouseReceipt.loadingComplete': '적재가 완료되었습니다',
  'pages.orders.warehouseReceipt.loadingFailed': '적재를 완료하지 못했습니다',
  'pages.orders.warehouseReceipt.rackOccupied': '해당 랙 위치는 이미 사용 중입니다',
  'pages.orders.warehouseReceipt.cameraNotReady': '카메라를 사용할 수 없습니다',
  'pages.orders.warehouseReceipt.captureFailed': '사진 촬영에 실패했습니다',
  'pages.orders.warehouseReceipt.captureSuccess': '사진이 정상적으로 촬영되었습니다',
  'pages.orders.warehouseReceipt.onlyImagesAllowed': '이미지 파일만 업로드할 수 있습니다',
  'pages.orders.warehouseReceipt.imageTooLarge': '이미지 용량은 10MB 이하여야 합니다',
  'pages.orders.warehouseReceipt.noWaybillImage': '운송장 이미지를 1장 이상 업로드해주세요',
  'pages.orders.warehouseReceipt.receiptRegistered': '입고 처리가 완료되었습니다',
  'pages.orders.warehouseReceipt.receiptRegisterFailed': '입고 처리에 실패했습니다',
  'pages.orders.warehouseReceipt.chooseUploadMethod': '업로드 방식을 선택하세요',
  'pages.orders.warehouseReceipt.takePhotoWithCamera': '카메라로 촬영하기',
  'pages.orders.warehouseReceipt.uploadFromFiles': '파일에서 업로드',
  'pages.orders.warehouseReceipt.capture': '촬영',
  'pages.orders.warehouseReceipt.trackingNumber': '트래킹번호',
  'pages.orders.warehouseReceipt.trackingNumberPlaceholder': '트래킹번호를 입력하세요',
  'pages.orders.warehouseReceipt.scan': '스캔',
  'pages.orders.warehouseReceipt.noMatchedOrder': '일치하는 주문이 없습니다',
  'pages.orders.warehouseReceipt.orderNumber': '주문번호:',
  'pages.orders.warehouseReceipt.products': '상품 목록:',
  'pages.orders.warehouseReceipt.quantity': '수량',
  'pages.orders.warehouseReceipt.notes': '메모',
  'pages.orders.warehouseReceipt.designatedShooting': '지정촬영',
  'pages.orders.warehouseReceipt.designatedShootingPhoto': '사진',
  'pages.orders.warehouseReceipt.registerNoData': '주문 없이 입고 등록',
  'pages.orders.warehouseReceipt.register': '입고 등록',
  'pages.orders.warehouseReceipt.reinspection': '재검수',
  'pages.orders.warehouseReceipt.rackDesignation': '랙 지정',
  'pages.orders.warehouseReceipt.rackDesignationTitle': '랙 지정',
  'pages.orders.warehouseReceipt.rackDesignationTracking': '트래킹번호: {trackingNumber}',
  'pages.orders.warehouseReceipt.locationCode': '위치 코드',
  'pages.orders.warehouseReceipt.locationCodePlaceholder':
    '위치 코드를 입력하세요 (예: S-01-01-012)',
  'pages.orders.warehouseReceipt.waybillImagesRequired': '운송장 이미지 (필수)',
  'pages.orders.warehouseReceipt.uploadWaybillImage': '운송장 이미지 업로드',
  'pages.orders.warehouseReceipt.hasIssue': '이슈 여부',
  'pages.orders.warehouseReceipt.issueImages': '이슈 이미지',
  'pages.orders.warehouseReceipt.productImages': '상품 이미지',
  'pages.orders.warehouseReceipt.uploadIssueImage': '이슈 이미지 업로드',
  'pages.orders.warehouseReceipt.uploadProductImage': '상품 이미지 업로드',
  'pages.orders.warehouseReceipt.adminMemo': '관리자 메모',
  'pages.orders.warehouseReceipt.adminMemoPlaceholder': '메모를 입력하세요...',
  'pages.orders.warehouseReceipt.cashOnDeliveryOptional': '착불 금액 (선택사항)',
  'pages.orders.warehouseReceipt.cashOnDeliveryPlaceholder': '착불 금액을 입력하세요',

  // Picking Modal
  'pages.orders.picking.title': '피킹',
  'pages.orders.picking.trackingNumber': '트래킹번호',
  'pages.orders.picking.trackingNumberPlaceholder': '트래킹번호를 입력하세요',
  'pages.orders.picking.scan': '스캔',
  'pages.orders.picking.pick': '피킹',
  'pages.orders.picking.orderNumber': '주문번호:',
  'pages.orders.picking.rackNumber': '랙 번호:',
  'pages.orders.picking.itemsToPick': '피킹할 상품:',
  'pages.orders.picking.productInformation': '상품 정보',
  'pages.orders.picking.quantity': '수량',
  'pages.orders.picking.noOrdersReady': '피킹 가능한 주문이 없습니다',
  'pages.orders.picking.fetchFailed': '피킹 대기 주문을 불러오지 못했습니다',
  'pages.orders.picking.enterTrackingNumber': '트래킹번호를 입력해주세요',
  'pages.orders.picking.noMatchedProduct': '피킹 대상 상품을 찾을 수 없습니다',
  'pages.orders.picking.noMatchedProductWithTracking':
    '해당 트래킹번호로 피킹 대상 상품을 찾을 수 없습니다',
  'pages.orders.picking.orderFound': '피킹 가능한 주문을 찾았습니다',
  'pages.orders.picking.scanFailed': '트래킹번호 스캔에 실패했습니다',
  'pages.orders.picking.noOrderSelected': '피킹할 주문이 선택되지 않았습니다',
  'pages.orders.picking.completed': '피킹이 완료되었습니다',
  'pages.orders.picking.completeFailed': '피킹을 완료하지 못했습니다',

  // Inpacking Upload Modal
  'pages.orders.inpackingUpload.title': '인패킹 업로드 - 주문번호: {orderNo}',
  'pages.orders.inpackingUpload.orderNo': '주문번호',
  'pages.orders.inpackingUpload.fileLabel': '파일 등록',
  'pages.orders.inpackingUpload.chooseFile': '파일 선택',
  'pages.orders.inpackingUpload.register': '등록',
  'pages.orders.inpackingUpload.fileRequired': '업로드할 파일을 선택해주세요',
  'pages.orders.inpackingUpload.registered': '인패킹 파일이 등록되었습니다',
  
  // Product Table
  'pages.orders.productTable.noTrackingNumber': '입력된 트래킹번호가 없습니다',  
  'pages.orders.productTable.designatedShooting': '지정 촬영',
  'pages.orders.productTable.note': '비고',
  'pages.orders.productTable.trackingNumbersSaved': '{count}개의 트래킹번호가 일괄 저장되었습니다',
  'pages.orders.productTable.pleaseEnterAmount': '금액을 입력해주세요',
  'pages.orders.productTable.shippingCostSaved': '배송비용이 저장되었습니다: ¥{value}',
  'pages.orders.productTable.statusUpdated': '상태가 {status}(으)로 변경되었습니다',
  'pages.orders.productTable.pleaseEnterValue': '값을 입력해주세요',
  'pages.orders.productTable.actualPriceSaved': '실지불금액이 저장되었습니다',
  'pages.orders.productTable.actualQuantitySaved': '실수량이 저장되었습니다',
  'pages.orders.productTable.invalidNumber': '유효하지 않은 숫자입니다',
  'pages.orders.productTable.customsClearanceList': '통관목록',
  'pages.orders.productTable.saveFailed': '저장에 실패했습니다',
  'pages.orders.productTable.productNoteSaved': '상품 비고가 저장되었습니다',
  'pages.orders.productTable.productMemoSaved': '상품 메모가 저장되었습니다',
  'pages.orders.productTable.userMemoSaved': '회원 메모가 저장되었습니다',
  'pages.orders.productTable.sellerAddressSaved': '판매자 주소가 저장되었습니다',
  'pages.orders.productTable.pleaseEnterTrackingNumber': '트래킹번호를 입력해주세요',
  'pages.orders.productTable.selectProductsToUpdateTracking': '트래킹번호를 업데이트할 상품을 하나 이상 선택해주세요.',
  'pages.orders.productTable.trackingNumberAppliedToAll': '트래킹번호 "{trackingNumber}"가 모든 상품에 일괄 적용되었습니다',
  'pages.orders.productTable.save': '저장',
  'pages.orders.productTable.trackingNumberSaved': '트래킹번호 "{trackingNumber}"가 저장되었습니다',
  'pages.orders.productTable.trackingNumberRemoved': '트래킹번호가 제거되었습니다',
  'pages.orders.productTable.trackingNumber': '트래킹번호',
  'pages.orders.productTable.viewInRealLife': '실사 이미지 보기',
  'pages.orders.productTable.actualImage': '검수 데이터',
  'pages.orders.productTable.inspectionData': '검수 데이터',
  'pages.orders.productTable.inspectionNumber': '번호',
  'pages.orders.productTable.inspectionImage': '이미지',
  'pages.orders.productTable.inspectionDetail': '검수 상세',
  'pages.orders.productTable.worker': '작업자',
  'pages.orders.productTable.inspectionTime': '검수 시간',
  'pages.orders.productTable.actualDateConfirmationDate': '실사일자/확정일자',
  'pages.orders.productTable.date': '날짜',
  'pages.orders.productTable.preview': '미리보기',
  'pages.orders.productTable.enterTrackingNumber': '트래킹번호 입력',
  'pages.orders.productTable.batchSave': '일괄저장',
  'pages.orders.productTable.checkbox': '체크박스',
  'pages.orders.productTable.number': '번호',
  'pages.orders.productTable.productStatus': '상품상태',
  'pages.orders.productTable.productLog': '상품로그',
  'pages.orders.productTable.image': '이미지',
  'pages.orders.productTable.customsItem': '통관품목',
  'pages.orders.productTable.productImage': '상품 이미지',
  'pages.orders.productTable.productName': '상품명',
  'pages.orders.productTable.color': '색상',
  'pages.orders.productTable.size': '사이즈',
  'pages.orders.productTable.option': '옵션',
  'pages.orders.productTable.attribute': '속성',
  'pages.orders.productTable.productNumber': '품번',
  'pages.orders.productTable.typeOwnmall': 'B - 자사몰',
  'pages.orders.productTable.material': '재질',
  'pages.orders.productTable.sellerInfo': '판매자정보',
  'pages.orders.productTable.orderNo': '외부주문번호',
  'pages.orders.productTable.externalOrderNo': '외부주문번호',
  'pages.orders.productTable.exposureOX': '노출OX',
  'pages.orders.productTable.shippingCost': '배송비용',
  'pages.orders.productTable.actual': '실제',
  'pages.orders.productTable.seller': '판매자',
  'pages.orders.productTable.refundCost': '환불비용',
  'pages.orders.productTable.productType': '상품유형',
  'pages.orders.productTable.member': '회원',
  'pages.orders.productTable.internationalShippingCost': '국제운송비',
  'pages.orders.productTable.extraInternationalShippingCost': '추가국제운송비',
  'pages.orders.productTable.unitPrice': '단가',
  'pages.orders.productTable.quantity': '수량',
  'pages.orders.productTable.totalAmount': '총액',
  'pages.orders.productTable.actualPaidAmount': '실지불금액',
  'pages.orders.productTable.actualQuantity': '실수량',
  'pages.orders.productTable.rackNumber': '랙번호',
  'pages.orders.productTable.rackNumberSaved': '랙번호가 저장되었습니다',
  'pages.orders.productTable.rackNumberSaveError': '랙번호 저장에 실패했습니다',
  'pages.orders.productTable.rackNumberRequired': '랙번호를 입력해주세요',
  'pages.orders.productTable.trackingRequiredForRack': '운송장번호가 없어 랙번호를 저장할 수 없습니다. 운송장번호를 먼저 등록해주세요',
  'pages.orders.productTable.itemAmountSaved': '실지불금액이 저장되었습니다',
  'pages.orders.productTable.itemAmountSaveError': '실지불금액 저장에 실패했습니다',
  'pages.orders.productTable.productMemoSaveError': '상품 메모 저장에 실패했습니다',
  'pages.orders.productTable.orderIdRequired': '주문 ID가 필요합니다',
  'pages.orders.productTable.itemIdRequired': '상품 ID가 필요합니다',
  'pages.orders.productTable.externalOrderIdRequired': '운송장 번호 업데이트를 위해 외부 주문 ID가 필요합니다',
  'pages.orders.productTable.previousRackNumber': '이전 랙번호',
  'pages.orders.productTable.shipped': '출고',
  'pages.orders.productTable.notShipped': '미출고',
  'pages.orders.productTable.log': '로그',
  'pages.orders.productTable.reorder.button': '옵션 바꿔 발주',
  'pages.orders.productTable.reorder.title': '옵션 바꿔 발주',
  'pages.orders.productTable.reorder.current': '지금 줄',
  'pages.orders.productTable.reorder.quantity': '수량 {quantity}',
  'pages.orders.productTable.reorder.unitPrice': '단가',
  'pages.orders.productTable.reorder.rule': '단가가 같은 옵션만 발주할 수 있고, 수량은 바꾸지 않습니다. 고객에게는 알리지 않습니다.',
  'pages.orders.productTable.reorder.offerIdPlaceholder': '다른 상품의 상품번호(offerId)',
  'pages.orders.productTable.reorder.loadProduct': '상품 불러오기',
  'pages.orders.productTable.reorder.offerIdInvalid': '상품번호(숫자)를 입력하세요.',
  'pages.orders.productTable.reorder.colImage': '사진',
  'pages.orders.productTable.reorder.colOption': '옵션',
  'pages.orders.productTable.reorder.colPrice': '단가',
  'pages.orders.productTable.reorder.colStock': '재고',
  'pages.orders.productTable.reorder.samePrice': '같은 가격',
  'pages.orders.productTable.reorder.otherPrice': '가격 다름',
  'pages.orders.productTable.reorder.preview': '미리 확인',
  'pages.orders.productTable.reorder.place': '발주',
  'pages.orders.productTable.reorder.cancel': '취소',
  'pages.orders.productTable.reorder.previewOk': '발주 가능 — 단가 {price} (원래 {original}), 판매처 배송비 {shipping}',
  'pages.orders.productTable.reorder.previewFailed': '미리 확인에 실패했습니다.',
  'pages.orders.productTable.reorder.loadFailed': '상품 옵션을 불러오지 못했습니다.',
  'pages.orders.productTable.reorder.confirmTitle': '실제로 발주합니다',
  'pages.orders.productTable.reorder.confirmBody': '{platform}에 {option} {quantity}개를 단가 {price}로 발주합니다. 되돌릴 수 없습니다.',
  'pages.orders.productTable.reorder.confirmOk': '발주',
  'pages.orders.productTable.reorder.placed': '발주 완료 — 주문번호 {orderNo}',
  'pages.orders.productTable.reorder.placeFailed': '발주에 실패했습니다.',
  'pages.orders.productTable.reorder.unitAlert': '판매처가 {unit}개 단위(최소 {min}개)로만 팔아 고객 주문 {customer}개로는 발주할 수 없습니다.',
  'pages.orders.productTable.reorder.unitRaise': '판매 단위에 맞춰 {quantity}개로 발주 (남는 {extra}개는 회사 부담)',
  'pages.orders.productTable.reorder.previewOkRaised': '발주 가능 — {quantity}개(고객 {customer}개, 남는 {extra}개) · 단가 {price} (원래 {original}) · 추가 비용 {extraCost} · 판매처 배송비 {shipping}',
  'pages.orders.productTable.reorder.confirmBodyRaised': '{platform}에 {option} {quantity}개를 단가 {price}로 발주합니다. 고객 주문은 {customer}개이고 남는 {extra}개(추가 비용 {extraCost})는 회사 부담입니다. 되돌릴 수 없습니다.',
  'pages.orders.productTable.marketplaceQuantity': '발주 {quantity}개 (남는 {extra}개)',
  'pages.orders.productTable.furniture': '가구',
  'pages.orders.productTable.cotton': '면',
  'pages.orders.productTable.sellerA': '판매자A',
  'pages.orders.productTable.exposureO': '노출 O',
  'pages.orders.productTable.actualPaid': '실지불',
  'pages.orders.productTable.totalActualPaid': '실지불총액',
  'pages.orders.productTable.coupon': '쿠폰',
  'pages.orders.productTable.points': '포인트',
  
  // Product Price Modal
  'pages.orders.productPriceModal.title': '1차 결제 상세',
  'pages.orders.productPriceModal.serviceFee': '서비스 수수료',
  'pages.orders.productPriceModal.quantity': '수량',
  'pages.orders.productPriceModal.price': '가격',
  'pages.orders.productPriceModal.realPrice': '실제 가격',
  'pages.orders.productPriceModal.chineseTransportation': '중국 내 운송비',
  'pages.orders.productPriceModal.realChineseTransportation': '실제 중국 내 운송비',
  'pages.orders.productPriceModal.miscellaneousExpenses': '기타 비용',
  'pages.orders.productPriceModal.coupon': '쿠폰',
  'pages.orders.productPriceModal.couponDiscount': '쿠폰 할인',
  'pages.orders.productPriceModal.points': '포인트',  
  'pages.orders.productPriceModal.pointsUsed': '포인트 사용',
  'pages.orders.productPriceModal.firstCostTotal': '1차 비용 합계',
  'pages.orders.productPriceModal.firstInternationalShippingCost': '1차 국제 운송비',
  'pages.orders.productPriceModal.ruralShippingCost': '도서산간비용',
  'pages.orders.productPriceModal.deliveryCoupon': '배송 쿠폰',
  'pages.orders.productPriceModal.deliveryCouponDiscount': '배송 쿠폰 할인',
  'pages.orders.productPriceModal.costSection': '비용 구성',
  'pages.orders.productPriceModal.costSubtotal': '비용 합계',
  'pages.orders.productPriceModal.deductionSection': '차감',
  'pages.orders.productPriceModal.deposit': '예치금',
  'pages.orders.productPriceModal.depositUsed': '예치금 사용',
  'pages.orders.productPriceModal.notApplied': '적용 없음',
  'pages.orders.productPriceModal.paymentMethod': '결제 방식',
  'pages.orders.productPriceModal.totalDeduction': '총 차감',
  'pages.orders.productPriceModal.bankDepositAmount': '뱅크 입금 금액',
  'pages.orders.productPriceModal.cardPaymentAmount': '카드 결제액',
  'pages.orders.productPriceModal.depositOnlyPayment': '예치금 결제액',
  'pages.orders.productPriceModal.sellerReference': '판매자 기준 (참고)',
  // International Shipping Modal
  'pages.orders.internationalShippingModal.title': '국제 운송 상세',
  'pages.orders.internationalShippingModal.weight': '무게',
  'pages.orders.internationalShippingModal.internationalShippingCost': '국제 운송비',
  'pages.orders.internationalShippingModal.extraInternationalShippingCost': '추가 국제 운송비',
  'pages.orders.internationalShippingModal.couponsUsed': '사용된 쿠폰',
  'pages.orders.internationalShippingModal.pointsUsed': '사용된 포인트',
  
  'pages.orders.extraInternationalShippingModal.title': '추가 국제 운송 상세 (2차 비용)',
  'pages.orders.extraInternationalShippingModal.weight': '무게',
  'pages.orders.extraInternationalShippingModal.extraInternationalShippingCost': '국제 운송비',
  'pages.orders.extraInternationalShippingModal.ruralShippingCost': '도서산간비용',
  'pages.orders.extraInternationalShippingModal.addOnServices': '부가 서비스',
  'pages.orders.extraInternationalShippingModal.serviceName': '서비스명',
  'pages.orders.extraInternationalShippingModal.quantity': '수량',
  'pages.orders.extraInternationalShippingModal.unitPrice': '단가',
  'pages.orders.extraInternationalShippingModal.serviceTotal': '합계',
  'pages.orders.extraInternationalShippingModal.subtotal': '소계',
  'pages.orders.extraInternationalShippingModal.couponDiscount': '배송 쿠폰 할인',
  'pages.orders.extraInternationalShippingModal.couponsUsed': '사용된 쿠폰',
  'pages.orders.extraInternationalShippingModal.pointsUsed': '사용된 포인트',
  'pages.orders.extraInternationalShippingModal.total': '2차 비용 총계',  
  'pages.orders.extraInternationalShippingModal.cashOnDelivery': '착불비',
  'pages.orders.productTable.paidInputCny': '실제 결제 (CNY)',
  'pages.orders.productTable.previous': '이전',
  'pages.orders.productTable.error': '오류',
  'pages.orders.productTable.errorReasonTitle': '오류 사유 입력',
  'pages.orders.productTable.errorReason': '오류 사유',
  'pages.orders.productTable.errorReasonPlaceholder': '오류 사유를 입력해주세요',
  'pages.orders.productTable.errorReasonRequired': '오류 사유는 필수입니다',
  'pages.orders.productTable.errorStatusUpdated': '오류 상태가 성공적으로 업데이트되었습니다',
  'pages.orders.productTable.confirmErrorStatus': '상태 변경 확인',
  'pages.orders.productTable.confirmErrorStatusMessage': '제품 상태를 오류로 변경하시겠습니까?',
  'pages.orders.productTable.arrivalExpected': '도착예정',
  'pages.orders.productTable.warehoused': '입고완료',
  'pages.orders.productTable.notWarehoused': '미입고',
  'pages.orders.productTable.processing': '처리중',
  'pages.orders.productTable.partial': '부분입고',
  'pages.orders.productTable.done': '완료',
  'pages.orders.productTable.warehouseStatusUpdated': '입고상태가 {status}(으)로 변경되었습니다',
  'pages.orders.productTable.productMemo': '상품 메모',
  'pages.orders.productTable.enterProductMemo': '상품 메모 입력',
  'pages.orders.productTable.userMemo': '회원 메모',
  'pages.orders.productTable.enterUserMemo': '회원 메모 입력',
  'pages.orders.productTable.sellerAddress': '판매자 주소',
  'pages.orders.productTable.enterSellerAddress': '판매자 주소 입력',
  'pages.orders.productTable.noInspectionData': '검수 데이터가 없습니다.',
  'pages.orders.user.packagingManagement': '포장관리',
  'pages.orders.user.shipmentScan': '출고스캔',
  'pages.orders.user.batchProcess': '선택된 {count}건 일괄 처리',
  'pages.orders.user.excelDownload': '엑셀다운',
  'pages.orders.user.selectOrdersFirst': '주문을 먼저 선택해 주세요.',
  'pages.orders.user.chimingtongNote': '주문을 선택한 후 클릭하세요',
  'pages.orders.user.lsShippingManifest': 'LS 발송 명세서',
  'pages.orders.user.silutongSeaManifest': '실루통 해운',
  'pages.orders.user.chimingtong': '치밍통',
  'pages.orders.user.chimingtongEnCn': '치밍통 EN+CN',
  'pages.orders.user.chimingtongKr': '치밍통 KR',
  'pages.orders.user.exportingOrders': '주문 내보내는 중...',
  'pages.orders.user.exportSuccess': '{count}개 주문을 성공적으로 내보냈습니다',
  'pages.orders.user.trackingBatchRegister': '운송장일괄등록',
  'pages.orders.user.statusChange': '상태변경',
  'pages.orders.user.statusChangeSelect': '= 상태변경',
  'pages.orders.user.totalSelectedPrice': '선택된 총액',
  'pages.orders.user.productPrice': '상품',
  'pages.orders.user.shippingPrice': '배송',
  'pages.orders.user.smsNotSend': 'SMS 발송안함',
  'pages.orders.user.smsSend': 'SMS 발송',
  'pages.orders.user.statusChangeConfirm': '선택된 {count}건의 상태를 변경합니다',
  'pages.orders.user.batchStatusChangeConfirm': '일괄 상태 변경 확인',
  'pages.orders.user.batchStatusChangeMessage': '{count}건의 주문을 "{status}"(으)로 변경하시겠습니까?',
  'pages.orders.user.batchStatusChangeSuccess': '{count}건의 주문이 성공적으로 변경되었습니다',
  'pages.orders.user.batchStatusChangeError': '일부 주문 업데이트에 실패했습니다',
  'pages.orders.user.noOrdersSelected': '최소 하나 이상의 주문을 선택해주세요',
  'pages.orders.user.someStatusChangesNotAllowed': '{count}건의 주문은 이 상태로 변경할 수 없습니다',
  'pages.orders.user.search': '검색',
  'pages.orders.user.reset': '초기화',
  'pages.orders.user.showMore': '더보기 ▼',
  /** User orders search: label hidden; placeholder / native title for selects */
  'pages.orders.user.searchFilterSelectTemplate': '{label} — 선택해 주세요',
  'pages.orders.user.searchFilterTextTemplate': '{label} — {hint}',
  'pages.orders.user.searchFilterDateStartTemplate': '{label} 시작',
  'pages.orders.user.searchFilterDateEndTemplate': '{label} 종료',
  'pages.orders.user.collapse': '접기 ▲',
  'pages.orders.user.total': '총 {total}건',
  // Purchase Cost Modal
  'pages.orders.purchaseCost.title': '구매비용 - 주문번호: {orderNo}',
  'pages.orders.purchaseCost.orderInfo': '주문 정보',
  'pages.orders.purchaseCost.orderNoTracking': '주문번호 / 운송장번호',
  'pages.orders.purchaseCost.totalQuantityCenterReceiver': '총 수량 / 센터 / 수취인',
  'pages.orders.purchaseCost.totalQuantity': '총 수량',
  'pages.orders.purchaseCost.center': '센터',
  'pages.orders.purchaseCost.receiver': '수취인',
  'pages.orders.purchaseCost.totalPrice': '총 상품금액',
  'pages.orders.purchaseCost.productInfo': '상품 정보',
  'pages.orders.purchaseCost.productNo': '품번',
  'pages.orders.purchaseCost.productImage': '이미지',
  'pages.orders.purchaseCost.productName': '상품명',
  'pages.orders.purchaseCost.quantity': '수량',
  'pages.orders.purchaseCost.unitPrice': '단가',
  'pages.orders.purchaseCost.localShippingFee': '현지 배송비',
  'pages.orders.purchaseCost.localShippingFeeTotal': '현지 배송비 합계',
  'pages.orders.purchaseCost.adminNote': '관리자 메모',
  'pages.orders.purchaseCost.adminNotePlaceholder': '관리자 메모를 입력하세요...',
  'pages.orders.purchaseCost.estimate': '구매비용 예상',
  'pages.orders.purchaseCost.exchangeRate': '적용 환율',
  'pages.orders.purchaseCost.exchangeRateSuffix': '¥1 당 원화',
  'pages.orders.purchaseCost.productPurchaseCost': '상품 구매비용',
  'pages.orders.purchaseCost.purchaseFee': '구매대행 수수료',
  'pages.orders.purchaseCost.additionalCosts': '추가 비용',
  'pages.orders.purchaseCost.excessCost': '품목 초과비용',
  'pages.orders.purchaseCost.totalAmount': '총 합계',
  'pages.orders.purchaseCost.currentDeposit': '현재 예치금',
  'pages.orders.purchaseCost.remainingDeposit': '잔여 예치금',
  'pages.orders.purchaseCost.smsNotSend': 'SMS 발송 안함',
  'pages.orders.purchaseCost.smsSend': 'SMS 발송',
  
  // Business Orders Page
  'pages.orders.business.title': '사업자 회원 주문',
  'pages.orders.business.filterApplied': '{group} > {label} 필터 적용 (사업자)',
  'pages.orders.business.businessMember': '사업자',
  'pages.orders.business.businessNumber': '사업자번호',
  'pages.orders.business.businessNumberPlaceholder': '사업자등록번호',
  'pages.orders.business.orderDetails': '주문 상세 정보',
  'pages.orders.business.orderDate': '주문일시',
  'pages.orders.business.paymentMethod': '결제방법',
  'pages.orders.business.deliveryMemo': '배송요청사항',
  'pages.orders.business.productList': '상품 목록',
  'pages.orders.business.image': '이미지',
  'pages.orders.business.productName': '상품명',
  'pages.orders.business.option': '옵션',
  'pages.orders.business.unitPrice': '단가',
  'pages.orders.business.total': '합계',
  
  // Search Filters
  'pages.orders.filter.center': '센터',
  'pages.orders.filter.centerAll': '전체',
  'pages.orders.filter.centerWeihai': '(중국)위해',
  'pages.orders.filter.centerQingdao': '(중국)청도',
  'pages.orders.filter.centerGuangzhou': '(중국)광저우',
  'pages.orders.filter.typeAll': '전체',
  'pages.orders.filter.typeShipping': '배송대행',
  'pages.orders.filter.typePurchase': '구매대행',
  'pages.orders.filter.typeVVIC': 'VVIC하이패스',
  'pages.orders.filter.typeReturn': '반품대행',
  'pages.orders.filter.typeMinimall': '미니몰',
  'pages.orders.filter.platformTypeAll': '전체',
  'pages.orders.filter.platformType1688': '1688',
  'pages.orders.filter.platformTypeTaobao': '타오바오',
  'pages.orders.filter.platformTypeVVIC': 'VVIC',
  'pages.orders.filter.platformTypeWSY': 'WSY',
  'pages.orders.filter.platformTypeVIP': 'VIP',
  'pages.orders.filter.platformTypeSelf': '자체운영',
  'pages.orders.filter.platformTypeLive': '라이브',
  'pages.orders.filter.shippingMethodAll': '전체',
  'pages.orders.filter.shippingMethodAir': '항공',
  'pages.orders.filter.shippingMethodAirExpress': '항공특송',
  'pages.orders.filter.shippingMethodSea': '배',
  'pages.orders.filter.shippingMethodSeaExpress': '배특송',
  'pages.orders.filter.shippedAll': '전체',
  'pages.orders.filter.shippedAuto': '자동결제',
  'pages.orders.filter.shippedAutoNote': '시스템 지갑으로 자동 결제',
  'pages.orders.filter.shippedManual': '수동결제',
  'pages.orders.filter.shippedManualNote': '시스템 지갑에 돈이 없어 회원이 직접 결제해야 함',
  'pages.orders.filter.dateRange': '등록일',
  'pages.orders.filter.registrationDate': '등록일',
  'pages.orders.filter.startDatePlaceholder': '시작일',
  'pages.orders.filter.endDatePlaceholder': '종료일',
  'pages.orders.filter.warehouseStatusAll': '전체',
  'pages.orders.filter.selectDate': '날짜 선택',
  'pages.orders.filter.warehouseStatusExpected': '입고예정',
  'pages.orders.filter.warehouseStatusPartial': '부분입고',
  'pages.orders.filter.warehouseStatusDone': '입고완료',
  'pages.orders.filter.warehouseStatusNotWarehoused': '미입고',
  'pages.orders.filter.warehouseStatusProcessing': '처리중',
  'pages.orders.filter.warehouseStatusWarehoused': '입고완료',
  'pages.orders.filter.paymentStatusAll': '전체',
  'pages.orders.filter.paymentStatusPending': '결제대기',
  'pages.orders.filter.paymentStatusProcessing': '처리중',
  'pages.orders.filter.paymentStatusPaid': '결제완료',
  'pages.orders.filter.paymentStatusFailed': '실패',
  'pages.orders.filter.paymentStatusRefunded': '환불완료',
  'pages.orders.filter.transferMethodAll': '전체',
  'pages.orders.filter.transferMethodShip': '배',
  'pages.orders.filter.transferMethodAir': '항공',
  'pages.orders.filter.transferMethodShipExpress': '배특송',
  'pages.orders.filter.transferMethodAirExpress': '항공특송',
  'pages.orders.filter.userNamePlaceholder': '회원명',
  'pages.orders.filter.mailboxPlaceholder': '사서함 번호',
  'pages.orders.filter.receiverPlaceholder': '수취인명',
  'pages.orders.filter.productNo': '상품번호',
  'pages.orders.filter.productNoPlaceholder': '상품번호/子订单号',
  'pages.orders.filter.memberUniqueNo': 'UID',
  'pages.orders.filter.memberUniqueNoPlaceholder': '회원 UID를 입력하세요',
  'pages.orders.filter.customerPhone': '회원 전화번호',
  'pages.orders.filter.customerPhonePlaceholder': '회원 전화번호를 입력하세요',
  'pages.orders.filter.trackingNo': '트래킹번호',
  'pages.orders.filter.trackingNoPlaceholder': '중국/국내 트래킹번호',
  'pages.orders.filter.orderNoPlaceholder': 'TM2025...',
  'pages.orders.filter.krTrackPlaceholder': '국내 운송장번호',
  'pages.orders.filter.internationalTrackingNo': '국제운송장번호',
  'pages.orders.filter.paidStart': '결제시작시간',
  'pages.orders.filter.paidEnd': '결제마감시간',
  'pages.orders.filter.orderType': '주문 유형',
  'pages.orders.filter.orderTypeAll': '전체',
  'pages.orders.filter.orderTypeGeneral': '일반',
  'pages.orders.filter.orderTypeBuy': '구매',
  'pages.orders.filter.orderTypeDel': '배송',
  'pages.orders.filter.orderTypeVvic': 'VVIC',
  'pages.orders.filter.orderTypeReturn': '반품',
  'pages.orders.filter.orderTypeMinimall': 'Minimall',
  'pages.orders.filter.shippingStatus': '배송 상태',
  'pages.orders.filter.shippingStatusAll': '전체',
  'pages.orders.filter.shippingStatusNotShipped': '미발송',
  'pages.orders.filter.shippingStatusShipped': '발송됨',
  'pages.orders.filter.shippingStatusAuto': '자동',
  'pages.orders.filter.shippingStatusManual': '수동',
  'pages.orders.filter.gyeongdongCod': '경동선착불',
  'pages.orders.filter.closedArea': '파업지역',
  
  // User Profile
  'pages.userProfile.editInfo': '정보 수정',
  'pages.userProfile.logout': '로그아웃',
  'pages.userProfile.modalTitle': '회원 정보 수정',
  'pages.userProfile.userId': '아이디',
  'pages.userProfile.grade': '등급',
  'pages.userProfile.name': '이름',
  'pages.userProfile.namePlaceholder': '이름을 입력하세요',
  'pages.userProfile.nameRequired': '이름을 입력해주세요',
  'pages.userProfile.email': '이메일',
  'pages.userProfile.emailPlaceholder': '이메일을 입력하세요',
  'pages.userProfile.emailRequired': '이메일을 입력해주세요',
  'pages.userProfile.emailInvalid': '올바른 이메일 형식이 아닙니다',
  'pages.userProfile.phone': '전화번호',
  'pages.userProfile.phonePlaceholder': '전화번호를 입력하세요',
  'pages.userProfile.phoneRequired': '전화번호를 입력해주세요',
  'pages.userProfile.newPassword': '새 비밀번호',
  'pages.userProfile.newPasswordPlaceholder': '변경할 비밀번호를 입력하세요 (선택사항)',
  'pages.userProfile.passwordMinLength': '비밀번호는 최소 6자 이상이어야 합니다',
  'pages.userProfile.confirmPassword': '비밀번호 확인',
  'pages.userProfile.confirmPasswordPlaceholder': '비밀번호를 다시 입력하세요',
  'pages.userProfile.passwordMismatch': '비밀번호가 일치하지 않습니다',
  'pages.userProfile.updateSuccess': '정보가 성공적으로 수정되었습니다.',
  'pages.userProfile.updateFailed': '정보 수정에 실패했습니다.',

  // Members List Page
  'pages.members.list.title': '회원 관리',
  'pages.members.list.memberInfo': '회원정보',
  'pages.members.list.level': '등급',
  'pages.members.list.levelAll': '전체',
  'pages.members.list.levelGeneral': '일반',
  'pages.members.list.levelVIP': 'VIP',
  'pages.members.list.levelVVIP': 'VVIP',
  'pages.members.list.levelBlack': '블랙',
  'pages.members.list.levelDormant': '휴면',
  'pages.members.list.levelChanged': '회원 등급이 변경되었습니다',
  'pages.members.list.levelChangeError': '회원 등급 변경에 실패했습니다',
  'pages.members.list.mailbox': '사서함',
  'pages.members.list.totalAmount': '누적금액',
  'pages.members.list.unpaidAmount': '미수금',
  'pages.members.list.orderCount': '주문건수',
  'pages.members.list.lastOrder': '최근주문',
  'pages.members.list.lastLogin': '최근로그인',
  'pages.members.list.joinedAt': '가입일',
  'pages.members.list.registrationTime': '등록 시간',
  'pages.members.list.actions': '작업',
  'pages.members.list.detail': '상세',
  'pages.members.list.edit': '수정',
  'pages.members.list.delete': '삭제',
  'pages.members.list.more': '더보기',
  'pages.members.list.deleteConfirm': '이 회원을 삭제하시겠습니까?',
  'pages.members.list.deleteConfirmDesc': '이 작업은 되돌릴 수 없습니다.',
  'pages.members.list.deleteSuccess': '회원이 삭제되었습니다',
  'pages.members.list.deleteError': '회원 삭제에 실패했습니다',
  'pages.members.list.cancel': '취소',
  'pages.members.list.adjustDeposit': '예치금 조정',
  'pages.members.list.adjustDeposit.amount': '조정 금액',
  'pages.members.list.adjustDeposit.amountHelp': '양수는 증가, 음수는 차감입니다.',
  'pages.members.list.adjustDeposit.amountPlaceholder': '예: 5000',
  'pages.members.list.adjustDeposit.amountRequired': '0보다 큰 금액을 입력해 주세요.',
  'pages.members.list.adjustDeposit.direction': '조정 방향',
  'pages.members.list.adjustDeposit.direction.add': '증가',
  'pages.members.list.adjustDeposit.direction.subtract': '차감',
  'pages.members.list.adjustDeposit.preview': '변경 후 잔액',
  'pages.members.list.adjustDeposit.negativeWarning': '차감 후 잔액이 음수가 됩니다. 서버에서 거절됩니다.',
  'pages.members.list.batchAdjustDeposit': '예치금 일괄 조정',
  'pages.members.list.batchAdjustDepositTitle': '선택한 회원 {count}명의 예치금 일괄 조정',
  'pages.members.list.batchAdjustDeposit.targets': '대상',
  'pages.members.list.batchAdjustDeposit.targetsCount': '{count}명의 회원',
  'pages.members.list.batchAdjustDeposit.amountHelp': '선택한 모든 회원에게 동일한 조정 금액과 사유가 적용됩니다.',
  'pages.members.list.batchAdjustDeposit.noSelection': '회원을 먼저 선택해 주세요.',
  'pages.members.list.batchAdjustDeposit.success': '{count}명의 예치금이 조정되었습니다.',
  'pages.members.list.batchAdjustDeposit.partial': '성공 {ok}건, 실패 {fail}건.',
  'pages.members.list.batchAdjustDeposit.failuresTitle': '일부 회원의 조정이 실패했습니다',
  'pages.members.list.adjustDeposit.reason': '조정 사유',
  'pages.members.list.adjustDeposit.reasonPlaceholder': '예: 이벤트 보상, 오류 차감 등',
  'pages.members.list.adjustDeposit.reasonRequired': '조정 사유를 입력해 주세요.',
  'pages.members.list.adjustDeposit.submit': '조정',
  'pages.members.list.adjustDeposit.success': '예치금이 조정되었습니다.',
  'pages.members.list.adjustDeposit.failed': '예치금 조정에 실패했습니다.',
  'pages.members.list.nickname': '닉네임',
  'pages.members.list.country': '국가',
  'pages.members.list.changePasswordPlaceholder': '새 비밀번호를 입력하세요',
  'pages.members.list.accountBalance': '계정 잔액',
  'pages.members.list.smsNotificationAgreement': 'SMS 알림 동의',
  'pages.members.list.status': '상태',
  'pages.members.list.basicInfo': '기본 정보',
  'pages.members.list.changePassword': '비밀번호 변경',
  'pages.members.list.exportError': '엑셀 내보내기 실패',
  'pages.members.list.accumulatedPoints': '누적 포인트',
  'pages.members.list.kakaotalkAgree': '카카오톡 동의',
  'pages.members.list.smsAgree': 'SMS 동의',
  'pages.members.list.emailAgree': '이메일 동의',
  'pages.members.list.orderInquiryAgree': '주문 조회 동의',
  'pages.members.list.receiveOrderSMS': '주문 SMS',
  'pages.members.list.memoPlaceholder': '메모를 입력하세요',
  'pages.members.list.memo': '메모',
  'pages.members.list.memberStatistics': '회원 통계',
  'pages.members.list.registrationDate': '등록일',
  'pages.members.list.lastLoginDate': '최근 로그인일',
  'pages.members.list.shippedOrders': '배송 완료 주문',
  'pages.members.list.purchaseOrders': '구매 완료 주문',
  'pages.members.list.noData': '데이터 없음',
  'pages.members.list.totalTransportationPaid': '총 운송 비용',
  'pages.members.list.totalPurchasingPaid': '총 구매 비용',
  'pages.members.list.totalAdditionalPaid': '총 추가 비용',
  'pages.members.list.totalCouponUsage': '총 쿠폰 사용',
  'pages.members.list.notPaidOrders': '미결제 주문',
  'pages.members.list.totalNotPaidAmount': '총 미결제 금액',
  'pages.members.list.receive2000SMS': '2000 SMS',
  'pages.members.list.receiveShippingSMS': '배송 SMS',
  'pages.members.list.receiveDeliverySMS': '도착 SMS',
  'pages.members.list.shippingAddress': '배송 주소',
  'pages.members.list.statusActive': '활성',
  'pages.members.list.statusDormant': '휴면',
  'pages.members.list.statusBlacklisted': '블랙리스트',
  'pages.members.list.notes': '비고',
  'pages.members.list.more.orders': '주문 페이지로 이동',
  'pages.members.list.more.recharge': '잔액 충전 페이지로 이동',
  'pages.members.list.more.points': '포인트 충전 페이지로 이동',
  'pages.members.list.editMember': '회원 정보 수정',
  'pages.members.list.updateSuccess': '회원 정보가 업데이트되었습니다',
  'pages.members.list.updateError': '회원 정보 업데이트에 실패했습니다',
  'pages.members.list.totalConsumption': '총 소비 금액',
  'pages.members.list.monthlyOrderCount': '당월 주문 수',
  'pages.members.list.monthlyConsumption': '당월 소비 금액',
  'pages.members.list.purchaseHistory': '구매 이력',
  'pages.members.list.orderNo': '주문번호',
  'pages.members.list.orderDate': '주문일',
  'pages.members.list.referredBy': '추천인',
  'pages.members.list.referredByPlaceholder': '추천인 회원 ID, 고유번호 또는 API에서 요구하는 값',
  'pages.members.list.batchUpdateReferredBy': '추천인 일괄 설정',
  'pages.members.list.batchUpdateReferredByTitle': '추천인 일괄 설정 (선택 {count}명)',
  'pages.members.list.batchUpdateReferredByRequired': '추천인을 입력하세요',
  'pages.members.list.batchUpdateReferredByNoSelection': '선택된 회원이 없습니다',
  'pages.members.list.batchUpdateReferredByResult': '성공 {success}명, 실패 {failed}명',
  'pages.members.list.batchUpdateReferredByAllFailed': '모두 실패했습니다',
  'pages.members.list.referralCode': '추천코드',
  'pages.members.list.orderAmount': '주문금액',
  'pages.members.list.orderStatus': '상태',
  'pages.members.list.message': '메시지',
  'pages.members.list.black': '블랙',
  'pages.members.list.unblack': '해제',
  'pages.members.list.blackConfirm': '블랙 처리하시겠습니까?',
  'pages.members.list.unblackConfirm': '블랙 해제하시겠습니까?',
  'pages.members.list.blackSuccess': '블랙 처리됨',
  'pages.members.list.unblackSuccess': '블랙 해제됨',
  'pages.members.list.totalMembers': '전체 회원',
  'pages.members.list.vipMembers': 'VIP 회원',
  'pages.members.list.newThisMonth': '이번 달 신규',
  'pages.members.list.blackMembers': '블랙 회원',
  'pages.members.list.excelDownload': '엑셀 다운로드',
  'pages.members.list.exportingSelected': '선택한 {count}명의 회원을 내보내는 중...',
  'pages.members.list.exportingAll': '현재 페이지 회원을 내보내는 중...',
  'pages.members.list.noDataToExport': '내보낼 데이터가 없습니다',
  'pages.members.list.exportSuccess': '{count}명의 회원을 성공적으로 내보냈습니다',
  'pages.members.list.blackManagement': '블랙회원 관리',
  'pages.members.list.sendSelectedMessage': '선택 메시지 발송',
  'pages.members.list.bulkBlack': '일괄 블랙',
  'pages.members.list.bulkBlackConfirm': '{count}명을 블랙 처리하시겠습니까?',
  'pages.members.list.detailTitle': '회원 상세 정보',
  'pages.members.list.close': '닫기',
  'pages.members.list.sendMessage': '메시지 보내기',
  'pages.members.list.tabBasic': '기본 정보',
  'pages.members.list.tabOrder': '주문 정보',
  'pages.members.list.tabMemo': '관리자 메모',
  'pages.members.list.memberId': '회원 ID',
  'pages.members.list.memberIdEmail': '회원 ID / 이메일',
  'pages.members.list.id': 'ID',
  'pages.members.list.membershipCode': '멤버십 코드',
  'pages.members.list.userId': '회원ID',
  'pages.members.list.memberName': '회원명',
  'pages.members.list.recipientName': '수취인 이름',
  'pages.members.list.startNumber': '시작 번호',
  'pages.members.list.endNumber': '끝 번호',
  'pages.members.list.applicationAcceptance': '신청 수락',
  'pages.members.list.recommendationPointsAccumulated': '적립 포인트',
  'pages.members.list.personInCharge': '담당자',
  'pages.members.list.adminDesignatedDate': '관리자 지정 일자',
  'pages.members.list.name': '이름',
  'pages.members.list.email': '이메일',
  'pages.members.list.phone': '전화번호',
  'pages.members.list.memberLevel': '회원 등급',
  'pages.members.list.totalOrders': '총 주문 건수',
  'pages.members.list.lastOrderDate': '최근 주문일',
  'pages.members.list.totalPayment': '누적 결제 금액',
  'pages.members.list.unpaid': '미수금',
  'pages.members.list.averageOrder': '평균 주문 금액',
  'pages.members.list.points': '포인트',
  'pages.members.list.pointsUpdated': '포인트가 업데이트되었습니다',
  'pages.members.list.pointsUpdateError': '포인트 업데이트에 실패했습니다',
  'pages.members.list.userUpdated': '회원 정보가 업데이트되었습니다',
  'pages.members.list.adminMemo': '관리자 메모',
  'pages.members.list.adminMemoPlaceholder': '관리자 메모를 입력하세요',
  'pages.members.list.birthday': '생년월일',
  'pages.members.list.birthdayPlaceholder': '생년월일을 선택하세요',
  'pages.members.list.gender': '성별',
  'pages.members.list.genderPlaceholder': '성별을 선택하세요',
  'pages.members.list.male': '남성',
  'pages.members.list.female': '여성',
  'pages.members.list.other': '기타',
  'pages.members.list.save': '저장',
  'pages.members.list.memoSaved': '메모가 저장되었습니다',
  'pages.members.list.sendMessageTitle': '메시지 보내기',
  'pages.members.list.sendMethod': '발송 방법',
  'pages.members.list.sms': 'SMS',
  'pages.members.list.emailMethod': '이메일',
  'pages.members.list.both': 'SMS + 이메일',
  'pages.members.list.subject': '제목',
  'pages.members.list.subjectPlaceholder': '메시지 제목',
  'pages.members.list.content': '내용',
  'pages.members.list.contentPlaceholder': '메시지 내용을 입력하세요',
  'pages.members.list.messageSent': '메시지가 발송되었습니다',
  'pages.members.list.count': '건',
  'pages.members.list.currency': '₩',

  // General Members Page
  'pages.members.general.title': '일반 회원 관리',
  'pages.members.general.memberType': '회원구분',
  'pages.members.general.memberTypeTag': '일반',
  'pages.members.general.totalGeneral': '전체 일반 회원',
  'pages.members.general.total': '총 {total} 명',
  'pages.members.general.dormantMembers': '휴면 회원',
  'pages.members.general.memberTypeLabel': '일반 회원',
  'pages.members.general.searchMemberName': '회원명',
  'pages.members.general.searchMemberNamePlaceholder': '회원명으로 검색',
  'pages.members.general.emailVerification': '이메일 인증',
  'pages.members.general.emailVerified': '인증됨',
  'pages.members.general.emailUnverified': '미인증',
  'pages.members.general.loadMemberDetailsError': '회원 상세 정보를 불러오는데 실패했습니다',
  'pages.members.general.loadMemberListError': '회원 목록을 불러오는데 실패했습니다',
  'pages.members.general.memberName': '회원명',
  'pages.members.general.memberNameSearch': '회원명으로 검색',
  'pages.members.general.allLevels': '전체',

  // Member Document Management Page
  'pages.members.documents.title': '회원 문서 관리',
  'pages.members.documents.documentName': '문서 이름',
  'pages.members.documents.fileName': '파일 이름',
  'pages.members.documents.fileUrl': '파일',
  'pages.members.documents.download': '다운로드',
  'pages.members.documents.createdAt': '등록일',
  'pages.members.documents.updatedAt': '수정일',
  'pages.members.documents.register': '문서 등록',
  'pages.members.documents.documentTemplate': '문서 템플릿',
  'pages.members.documents.selectFile': '파일 선택',
  'pages.members.documents.documentNamePlaceholder': '문서 이름을 입력하세요',
  'pages.members.documents.documentNameKo': '문서 이름 (한국어)',
  'pages.members.documents.documentNameEn': '문서 이름 (영어)',
  'pages.members.documents.documentNameZh': '문서 이름 (중국어)',
  'pages.members.documents.atLeastOneNameRequired': '문서 이름을 한 개 이상 입력해 주세요',
  'pages.members.documents.fileRequired': '업로드할 파일을 선택하세요',
  'pages.members.documents.deleteConfirm': '이 문서를 삭제하시겠습니까?',

  // Order Detail Page
  'pages.orders.detail.title': '주문 상세',
  'pages.orders.detail.close': '닫기',
  'pages.orders.detail.error': '주문 정보를 불러오는데 실패했습니다',
  'pages.orders.detail.paymentAddress': '결제 주소',
  'pages.orders.detail.depositorName': '의뢰인',
  'pages.orders.detail.paymentAmount': '결제 금액',
  'pages.orders.detail.paymentMethod': '결제 방식',
  'pages.orders.detail.paymentTime': '결제 시간',
  'pages.orders.detail.notFound': '주문을 찾을 수 없습니다',
  'pages.orders.detail.goBack': '돌아가기',
  'pages.orders.detail.basicInfo': '주문 기본 정보',
  'pages.orders.detail.orderNumber': '주문번호 / 회원명 / 사서함',
  'pages.orders.detail.product.orderNumber': '주문번호',
  'pages.orders.detail.orderType': '센터',
  'pages.orders.detail.depositAutoPay': '예치금자동결제',
  'pages.orders.detail.depositManualPay': '예치금수동결제',
  'pages.orders.detail.AutoPay': '자동결제',
  'pages.orders.detail.ManualPay': '수동결제',
  'pages.orders.detail.switchToAutoPay': '자동결제로 전환',
  'pages.orders.detail.switchToManualPay': '수동결제로 전환',
  'pages.orders.detail.switchedToAutoPay': '자동결제로 전환되었습니다',
  'pages.orders.detail.switchedToManualPay': '수동결제로 전환되었습니다',
  'pages.orders.detail.updateFailed': '결제 방식 업데이트 실패',
  'pages.orders.detail.progressStatus': '진행상태(상품입고상태)',
  'pages.orders.detail.shippingMethod': '운송방식',
  'pages.orders.detail.orderMemo': '주문 메모',
  'pages.orders.detail.registrationDate': '등록일',
  'pages.orders.detail.modifiedDate': '수정일',
  'pages.orders.detail.purchaseManager': '구매담당자',
  'pages.orders.detail.rackNumber': '랙번호',
  'pages.orders.detail.externalOrderId': '외부 주문 ID',
  'pages.orders.detail.editExternalOrderId': '외부 주문 ID 수정',
  'pages.orders.detail.edit': '수정',
  'pages.orders.detail.externalOrderIdPlaceholder': '외부 주문 ID를 입력하세요',
  'pages.orders.detail.externalOrderIdUpdated': '외부 주문 ID가 성공적으로 업데이트되었습니다',
  'pages.orders.detail.externalOrderIdUpdateFailed': '외부 주문 ID 업데이트에 실패했습니다',
  'pages.orders.detail.memberInfo': '회원 정보',
  'pages.orders.detail.memberName': '회원명',
  'pages.orders.detail.memberId': '회원ID',
  'pages.orders.detail.receiver': '수취인',
  'pages.orders.detail.contact': '연락처',
  'pages.orders.detail.deliveryAddress': '배송지',
  'pages.orders.detail.shippingInfo': '배송센터 및 서비스 유형',
  'pages.orders.detail.centerAndTransferMethodChange': '배송센터 및 운송방식 변경',
  'pages.orders.detail.trackingCount': '트래킹수',
  'pages.orders.detail.warehousedCount': '입고수',
  'pages.orders.detail.trackingNumber': '운송장번호',
  'pages.orders.detail.notRegistered': '미등록',
  'pages.orders.detail.waybillNumberPlaceholder': '운송장번호를 입력하세요',
  'pages.orders.detail.waybillNumberRequired': '운송장번호를 입력해주세요',
  'pages.orders.detail.waybillNumberUpdated': '운송장번호가 수정되었습니다',
  'pages.orders.detail.waybillNumberUnchanged': '운송장번호가 이전과 같습니다',
  'pages.orders.detail.waybillNumberUpdateFailed': '운송장번호 수정에 실패했습니다',
  'pages.orders.detail.waybillNumberDuplicateTitle': '이미 등록된 운송장번호입니다',
  'pages.orders.detail.waybillNumberDuplicateConfirm': '그래도 이 번호로 저장하시겠습니까?',
  'pages.orders.detail.shipmentDate': '출고일자',
  'pages.orders.detail.productInfo': '상품 정보',
  'pages.orders.detail.preview': '미리보기',
  'pages.orders.detail.trackingNo': '트래킹번호',
  'pages.orders.detail.orderSite': '주문 사이트',
  'pages.orders.detail.productName': '상품명',
  'pages.orders.detail.productNumber': '상품번호',
  'pages.orders.detail.orderNo': '오더번호',
  'pages.orders.detail.color': '색상',
  'pages.orders.detail.brandManufacturer': '브랜드/제조',
  'pages.orders.detail.size': '사이즈',
  'pages.orders.detail.warehouseDate': '입고일자',
  'pages.orders.detail.quantityPriceTotal': '수량 × 단가 = 합계',
  'pages.orders.detail.product': '제품',
  'pages.orders.detail.memberProductName': '회원 상품명',
  'pages.orders.detail.productStorage': '상품 보관함',
  'pages.orders.detail.noStorage': '보관 안 함',
  'pages.orders.detail.inspectionStorage': '검수 보관함',
  'pages.orders.detail.noInspection': '검수 안 함',
  'pages.orders.detail.consumerPrice': '소비자 가격',
  'pages.orders.detail.offerId': '오퍼ID',
  'pages.orders.detail.customerRequest': '회원요구',
  'pages.orders.detail.addButton': '추가',
  'pages.orders.detail.copyButton': '복사',
  'pages.orders.detail.copiedToClipboard': '클립보드에 복사되었습니다',
  'pages.orders.detail.editButton': '수정',
  'pages.orders.detail.deleteButton': '삭제',
  'pages.orders.detail.totalQuantity': '총수량',
  'pages.orders.detail.totalAmount': '총금액',
  'pages.orders.detail.items': '개',
  'pages.orders.detail.shipped': '출고',
  'pages.orders.detail.notShipped': '미출고',
  'pages.orders.detail.shipmentComplete': '출고완료',
  'pages.orders.detail.shipmentCompleteSuccess': '출고완료 처리되었습니다',
  'pages.orders.detail.returnProduct': '반품하기',
  'pages.orders.detail.returnInfo': '반품 처리 페이지로 이동',
  'pages.orders.detail.receiverInfo': '수령인 정보입력',
  'pages.orders.detail.nameCompany': '이름(통관부호호)',
  'pages.orders.detail.addressContact': '련락처',
  'pages.orders.detail.businessAddress': '주소',
  'pages.orders.detail.deliveryRequest': '배송요청사항',
  'pages.orders.detail.centerRequest': '센터 요청사항',
  'pages.orders.detail.paymentInfo': '결제 정보',
  'pages.orders.detail.totalProductAmount': '총 상품금액',
  'pages.orders.detail.paidAmount': '결제금액',
  'pages.orders.detail.totalProductPrice': '총 상품금액',
  'pages.orders.detail.realProductAmount': '실지 리용한 금액',
  'pages.orders.detail.shippingCost': '배송비',
  'pages.orders.detail.otherPrice': '잡비',
  'pages.orders.detail.additionalCost': '부가써비스비용',
  'pages.orders.detail.couponDiscount': '쿠폰사용',
  'pages.orders.detail.pointsUsed': '포인트사용',
  'pages.orders.detail.additionalInfo': '추가 정보',
  'pages.orders.detail.additionalService': '부가서비스',
  'pages.orders.detail.logisticsRequest': '물류센터 요청사항',
  'pages.orders.detail.adminMemo': '관리자 메모',
  'pages.orders.detail.none': '없음',
  'pages.orders.detail.selectAll': '전체 선택',
  'pages.orders.detail.englishProductName': '영문 상품명',
  'pages.orders.detail.hsCode': 'HS 코드',
  'pages.orders.detail.noExternalOrderId': '복사할 외부 주문 ID가 없습니다',
  'pages.orders.detail.warehouse': '창고',
  'pages.orders.detail.selectWarehouse': '창고를 선택하세요',
  'pages.orders.detail.selectShippingMethod': '운송 방식을 선택하세요',
  'pages.orders.detail.centerChangeSuccess': '배송센터 및 운송방식이 성공적으로 업데이트되었습니다',
  'pages.orders.detail.centerChangeError': '배송센터 및 운송방식 업데이트에 실패했습니다',
  'pages.orders.detail.productInfoEdit': '상품정보 수정',
  'pages.orders.detail.statusChangeSuccess': '상품 상태가 성공적으로 업데이트되었습니다',
  'pages.orders.detail.statusChangeError': '상품 상태 업데이트에 실패했습니다',
  'pages.orders.detail.redFieldsRequired': '적색 입력 항목은 꼭 입력해주십시오.',
  'pages.orders.detail.yellowFieldsOptional': '황색 입력 항목은 수정을 할 수 없습니다.',
  'pages.orders.detail.imageReplace': '이미지등록',
  'pages.orders.detail.deliveryType': '물건종류',
  'pages.orders.detail.selectDeliveryType': '물건종류 검색',
  'pages.orders.detail.category.clothing': '의류',
  'pages.orders.detail.category.electronics': '전자제품',
  'pages.orders.detail.inputType': '입고상태',
  'pages.orders.detail.quantityPrice': '수량 / 단가',
  'pages.orders.detail.productUrl': '상품URL',
  'pages.orders.detail.colorSize': '색상',
  'pages.orders.detail.brandSeller': '브랜드 / 셀러',
  'pages.orders.detail.material': '재질',
  'pages.orders.detail.managementInfo': '관리자정보',
  'pages.orders.detail.sellerAddress': '셀러 주소',
  'pages.orders.detail.option': '옵션',
  'pages.orders.detail.customsClearance': '통관 정보',
  'pages.orders.detail.customsClearancePlaceholder': '통관 정보를 입력하세요',
  'pages.orders.detail.coEnglishName': 'C/O 영문상품명',
  'pages.orders.detail.coHsCode': 'C/O HS코드',
  'pages.orders.type.vvicHighpass': 'VVIC하이패스',
  'pages.orders.type.minimall': '미니몰',
  'pages.orders.detail.trackingNumberUpdated': '트래킹번호가 성공적으로 업데이트되었습니다',
  'pages.orders.detail.trackingNumberUpdateFailed': '트래킹번호 업데이트에 실패했습니다',
  'pages.orders.detail.trackingNoPlaceholder': '트래킹번호를 입력하세요',
  'pages.orders.detail.additionalServiceChange': '부가서비스 변경',
  'pages.orders.detail.simplifiedCustomClearance': '간이통관',
  'pages.orders.detail.designatedShooting': '지정촬영',
  'pages.orders.detail.additionalServiceUpdated': '부가서비스가 성공적으로 업데이트되었습니다',
  'pages.orders.detail.additionalServiceUpdateFailed': '부가서비스 업데이트에 실패했습니다',
  'pages.orders.detail.changeRecipientAddress': '수취인 주소 변경',
  'pages.orders.detail.recipientName': '이름',
  'pages.orders.detail.koreanName': '한글',
  'pages.orders.detail.englishName': '영문',
  'pages.orders.detail.personalIdNote': '* 실명자 영문명은 반드시 띄어쓰기 포함하여 주세요 (한글발음시나는대로 입력하지 말것)',
  'pages.orders.detail.recipientType': '통관구분',
  'pages.orders.detail.personal': '개인',
  'pages.orders.detail.business': '사업자',
  'pages.orders.detail.foreigner': '외국인',
  'pages.orders.detail.phoneNumber': '연락처',
  'pages.orders.detail.addressAndContact': '주소 및 연락처',
  'pages.orders.detail.zipCodeSearch': '우편번호 검색',
  'pages.orders.detail.zipCodeLabel': '우편번호',
  'pages.orders.detail.addressLabel': '주소',
  'pages.orders.detail.detailAddress': '상세주소',
  'pages.orders.detail.addressNote': '* 도로명 주소를 써주세요. 지번 주소 기재시 서울/대관외 오류로 목록지시 될수가 있습니다.',
  'pages.orders.detail.deliveryMessageLabel': '배송 요청사항',
  'pages.orders.detail.selectDeliveryMessage': '부재시 집앞에 놔주세요',
  'pages.orders.detail.leaveAtDoor': '문앞에 놔주세요',
  'pages.orders.detail.leaveWithSecurity': '경비실에 맡겨주세요',
  'pages.orders.detail.callBeforeDelivery': '배송전 연락주세요',
  'pages.orders.detail.deliveryMessagePlaceholder': '부재시 집앞에 놔주세요',
  'pages.orders.detail.deliveryMessageNote': '* 국내 배송기사 분들이 배송시 하는 요청사항을 남겨주세요(예: 부재시 집앞에 놔주세요, 경비실에 맡겨주세요 등)',
  'pages.orders.detail.recipientAddressUpdated': '수취인 주소가 성공적으로 업데이트되었습니다',
  'pages.orders.detail.recipientAddressUpdateFailed': '수취인 주소 업데이트에 실패했습니다',
  'pages.orders.detail.orderInquiry': '주문 문의',
  'pages.orders.detail.orderInquiryButton': '주문 문의하기',
  'pages.orders.detail.orderInquiryRedirect': '주문 문의 페이지로 이동 중...',
  'pages.orders.detail.orderInquiryModalTitle': '주문 문의',
  'pages.orders.detail.orderInformation': '주문 정보',
  'pages.orders.detail.inquiryTitle': '문의 제목',
  'pages.orders.detail.inquiryTitlePlaceholder': '문의 제목을 입력하세요',
  'pages.orders.detail.inquiryTitleRequired': '문의 제목을 입력해주세요',
  'pages.orders.detail.inquiryContent': '문의 내용',
  'pages.orders.detail.inquiryContentPlaceholder': '문의 내용을 상세히 작성해주세요',
  'pages.orders.detail.inquiryContentRequired': '문의 내용을 입력해주세요',
  'pages.orders.detail.inquirySubmitted': '문의가 성공적으로 등록되었습니다',
  'pages.orders.detail.inquirySubmitFailed': '문의 등록에 실패했습니다',
  'pages.orders.detail.inquiryNote': '* 문의하신 내용은 최대한 빠르게 답변드리겠습니다. CS > 문의 메뉴에서 답변을 확인하실 수 있습니다.',
  'pages.common.submit': '제출',

  // Inventory Management
  'pages.inventory.title': '재고 관리',
  'pages.inventory.logistics': '물류관리',
  'pages.inventory.stockNumber': '재고번호',
  'pages.inventory.inquiry': '재고문의',
  'pages.inventory.center': '센터',
  'pages.inventory.productImage': '상품이미지',
  'pages.inventory.mailbox': '사서함',
  'pages.inventory.memberName': '회원명',
  'pages.inventory.customsItem': '통관품목',
  'pages.inventory.productName': '상품명',
  'pages.inventory.trackingNumber': 'Tracking Number',
  'pages.inventory.color': '색상',
  'pages.inventory.size': '사이즈',
  'pages.inventory.quantity': '수량',
  'pages.inventory.unitPrice': '단가',
  'pages.inventory.totalAmount': '총액',
  'pages.inventory.rackNumber': '랙번호',
  'pages.inventory.previousRackNumber': '이전 랙번호',
  'pages.inventory.previous': '이전',
  'pages.inventory.registrationDate': '등록일',
  'pages.inventory.modificationDate': '수정일',
  'pages.inventory.stockStatus': '재고상태',
  'pages.inventory.productStatus': '상품상태',
  'pages.inventory.mock.center.weihei': '위해',
  'pages.inventory.mock.center.qingdao': '청도',
  'pages.inventory.mock.center.guangzhou': '광저우',
  'pages.inventory.mock.memberName1': '김철수',
  'pages.inventory.mock.memberName2': '이영희',
  'pages.inventory.mock.memberName3': '박민수',
  'pages.inventory.mock.customsItem.doorbell': '【도어벨】',
  'pages.inventory.mock.customsItem.furniture': '【가구】',
  'pages.inventory.mock.customsItem.clothing': '【의류】',
  'pages.inventory.mock.color.black': '블랙',
  'pages.inventory.mock.color.white': '화이트',
  'pages.inventory.mock.color.red': '레드',
  'pages.inventory.stockStatus.available': '사용가능',
  'pages.inventory.stockStatus.inUse': '사용중',
  'pages.inventory.stockStatus.onHold': '보류',
  'pages.inventory.productStatus.normal': '정상',
  'pages.inventory.productStatus.problem': '문제',

  // Business Members Page
  'pages.members.business.title': '사업자 회원 관리',
  'pages.members.business.memberType': '회원구분',
  'pages.members.business.memberTypeTag': '사업자',
  'pages.members.business.businessNumber': '사업자번호',
  'pages.members.business.representative': '대표자',
  'pages.members.business.businessType': '업종',
  'pages.members.business.businessTypeWholesale': '도매',
  'pages.members.business.businessTypeRetail': '소매',
  'pages.members.business.businessTypeImport': '수입',
  'pages.members.business.businessTypeExport': '수출',
  'pages.members.business.totalBusiness': '전체 사업자 회원',
  'pages.members.business.memberTypeLabel': '사업자 회원',
  'pages.members.business.companyName': '상호명',
  'pages.members.business.monthlyAverage': '월 평균 주문',
  'pages.members.business.mock.memberType': '사업자',
  'pages.members.business.memberCode': '회원코드',
  'pages.members.business.memberName': '회원명',
  'pages.members.business.userId': '아이디',
  'pages.members.business.mailboxNumber': '사서함번호',
  'pages.members.business.mobilePhone': '휴대폰번호',
  'pages.members.business.deposit': '예치금(￦)',
  'pages.members.business.businessRegistration': '사업자등록증',
  'pages.members.business.applicationApproval': '신청서 허용여부',
  'pages.members.business.referralCode': '추천인코드',
  'pages.members.business.email': '이메일',
  'pages.members.business.referralPointsAccumulation': '추천포인트 적립여부',
  'pages.members.business.managerName': '담당자명',
  'pages.members.business.applicationCount': '신청서 작성수',
  'pages.members.business.adminAssignmentDate': '관리자지정일자',
  'pages.members.business.lastLogin': '마지막 접속일',
  'pages.members.business.joinDate': '가입일',
  'pages.members.business.actions': '-',

  'pages.members.list.memberNameSearchPlaceholder': '회원명으로 검색',
  'pages.members.list.userUniqueId': 'UID',
  'pages.members.list.emailVerification': '이메일 인증',
  'pages.members.list.emailVerified': '인증됨',
  'pages.members.list.emailUnverified': '미인증',
  'pages.members.list.loadMemberDetailsError': '회원 상세 정보를 불러오는데 실패했습니다',
  'pages.members.list.loadMemberListError': '회원 목록을 불러오는데 실패했습니다',
  'pages.members.list.genderMale': '남성',
  'pages.members.list.genderFemale': '여성',
  'pages.members.list.genderOther': '기타',
  'pages.members.list.deposit': '예치금',
  'pages.members.list.address': '주소',
  'pages.members.list.defaultAddress': '기본',
  'pages.members.list.zipCode': '우편번호',
  'pages.members.list.contact': '연락처',

  // Blacklist Members Page
  'pages.members.blacklist.title': '블랙리스트 회원 관리',
  'pages.members.blacklist.totalBlacklist': '전체 블랙리스트',
  'pages.members.blacklist.generalMembers': '일반 회원',
  'pages.members.blacklist.businessMembers': '사업자 회원',
  'pages.members.blacklist.addedThisMonth': '이번 달 추가',
  'pages.members.blacklist.unblacklistConfirm': '블랙리스트에서 해제하시겠습니까?',
  'pages.members.blacklist.unblacklistSuccess': '블랙리스트에서 해제되었습니다',
  'pages.members.blacklist.unblacklistError': '블랙리스트 해제에 실패했습니다',
  'pages.members.blacklist.unblacklist': '해제',
  'pages.members.blacklist.bulkUnblacklistConfirm': '선택한 {count}명의 회원을 블랙리스트에서 해제하시겠습니까?',
  'pages.members.blacklist.bulkUnblacklistSuccess': '{count}명의 회원이 블랙리스트에서 해제되었습니다',
  'pages.members.blacklist.bulkUnblacklist': '일괄 해제',
  'pages.members.blacklist.unblacklistButton': '블랙리스트 해제',
  'pages.members.blacklist.loadError': '블랙리스트 회원 목록을 불러오는데 실패했습니다',
  'pages.members.blacklist.memberType': '회원 유형',
  'pages.members.blacklist.general': '일반',
  'pages.members.blacklist.business': '사업자',
  'pages.members.blacklist.blacklisted': '블랙리스트',
  'pages.members.blacklist.birthday': '생년월일',
  'pages.members.blacklist.gender': '성별',
  'pages.members.blacklist.genderMale': '남성',
  'pages.members.blacklist.genderFemale': '여성',
  'pages.members.blacklist.genderOther': '기타',
  'pages.members.blacklist.points': '포인트',
  'pages.members.blacklist.deposit': '예치금',
  'pages.members.blacklist.address': '주소',
  'pages.members.blacklist.zipCode': '우편번호',
  'pages.members.blacklist.contact': '연락처',
  'pages.members.blacklist.default': '기본',
  'pages.members.blacklist.levelChanged': '회원 등급이 변경되었습니다',
  'pages.members.blacklist.levelChangeError': '회원 등급 변경에 실패했습니다',
  'pages.members.blacklist.emailVerification': '이메일 인증',
  'pages.members.blacklist.emailVerified': '인증됨',
  'pages.members.blacklist.emailUnverified': '미인증',
  'pages.members.blacklist.searchPlaceholder': '회원명으로 검색',

  // Deposit Management Pages
  'pages.members.depositApplication.description': '예치금 신청 내역 관리',
  'pages.members.depositApplication.subDescription': '회원 예치금 신청 내역 조회 및 관리',
  'pages.members.depositUsage.description': '예치금 사용 내역 관리',
  'pages.members.depositUsage.subDescription': '회원 예치금 사용 내역 조회 및 관리',
  'pages.members.bankbookVerification.description': '통장 자동 인증 관리',
  'pages.members.bankbookVerification.subDescription': '회원 통장 자동 인증 설정 및 관리',
  'pages.members.forexDepositApplication.description': '외화 예치금 신청 내역 관리',
  'pages.members.forexDepositApplication.subDescription': '회원 외화 예치금 신청 내역 조회 및 관리',
  'pages.members.forexDepositUsage.description': '외화 예치금 사용 내역 관리',
  'pages.members.forexDepositUsage.subDescription': '회원 외화 예치금 사용 내역 조회 및 관리',
  'pages.members.forexDepositPayment.description': '외화 예치금 결제 내역 관리',
  'pages.members.forexDepositPayment.subDescription': '회원 외화 예치금 결제 내역 조회 및 관리',

  // Deposit Application Detailed
  'pages.members.depositApplication.memberName': '회원명',
  'pages.members.depositApplication.applicationType': '신청유형',
  'pages.members.depositApplication.typeDeposit': '입금',
  'pages.members.depositApplication.typeRefund': '환불',
  'pages.members.depositApplication.depositAmount': '입금금액',
  'pages.members.depositApplication.refundAmount': '환불금액',
  'pages.members.depositApplication.amount': '신청금액',
  'pages.members.depositApplication.bankInfo': '은행정보',
  'pages.members.depositApplication.depositor': '입금자(계좌주)',
  'pages.members.depositApplication.status': '상태',
  'pages.members.depositApplication.statusPending': '대기',
  'pages.members.depositApplication.statusApproved': '승인',
  'pages.members.depositApplication.statusRejected': '거절',
  'pages.members.depositApplication.applicationDate': '신청일',
  'pages.members.depositApplication.expectedDepositDate': '예상 입금일',
  'pages.members.depositApplication.actions': '기능',
  'pages.members.depositApplication.approve': '승인',
  'pages.members.depositApplication.complete': '완료',
  'pages.members.depositApplication.reject': '거절',
  'pages.members.depositApplication.cancellation': '취소',
  'pages.members.depositApplication.viewDetails': '상세보기',
  'pages.members.depositApplication.approveConfirm': '예치금 신청 승인',
  'pages.members.depositApplication.approveContent': '{name}님의 {amount}원 예치금 신청을 승인하시겠습니까?',
  'pages.members.depositApplication.approved': '예치금 신청이 승인되었습니다',
  'pages.members.depositApplication.rejectConfirm': '예치금 신청 거절',
  'pages.members.depositApplication.rejectContent': '{name}님의 예치금 신청을 거절하시겠습니까?',
  'pages.members.depositApplication.rejected': '예치금 신청이 거절되었습니다',
  'pages.members.depositApplication.totalApplications': '전체 신청',
  'pages.members.depositApplication.pendingApplications': '대기 중',
  'pages.members.depositApplication.approvedApplications': '승인 완료',
  'pages.members.depositApplication.totalAmount': '총 신청금액',
  'pages.members.depositApplication.reasonRecharge': '예치금 충전',
  'pages.members.depositApplication.mock.companyName': '(주)무역상사',
  'pages.members.depositApplication.mock.personName': '홍길동',
  'pages.members.depositApplication.mock.bank.kb': 'KB국민은행',
  'pages.members.depositApplication.mock.bank.shinhan': '신한은행',
  'pages.members.depositApplication.mock.bank.hana': '하나은행',
  'pages.members.depositApplication.mock.bank.woori': '우리은행',

  // Recharge Review
  'pages.members.rechargeReview.title': '충전 검토',
  'pages.members.rechargeReview.filter.group.title': '상태 필터',
  'pages.members.rechargeReview.filter.pendingReview': '검토 대기',
  'pages.members.rechargeReview.filter.approvalSuccessful': '승인 완료',
  'pages.members.rechargeReview.filter.reviewFailed': '검토 실패',
  'pages.members.rechargeReview.column.userId': '회원ID',
  'pages.members.rechargeReview.column.user': '회원',
  'pages.members.rechargeReview.column.remittanceMethod': '송금방법',
  'pages.members.rechargeReview.column.remitterName': '송금자명',
  'pages.members.rechargeReview.column.rechargeCurrencyAndAmount': '충전 통화 및 금액',
  'pages.members.rechargeReview.column.receivedCurrencyAndAmount': '수신 통화 및 금액',
  'pages.members.rechargeReview.column.serviceFee': '서비스 수수료',
  'pages.members.rechargeReview.column.receivingBankInformation': '수신 은행 정보',
  'pages.members.rechargeReview.column.addTime': '등록 시간',
  'pages.members.rechargeReview.column.operate': '작업',
  'pages.members.rechargeReview.memberName': '회원명',
  'pages.members.rechargeReview.memberId': '회원ID',
  'pages.members.rechargeReview.amount': '금액',
  'pages.members.rechargeReview.paymentMethod': '결제방법',
  'pages.members.rechargeReview.status': '상태',
  'pages.members.rechargeReview.status.pending': '대기',
  'pages.members.rechargeReview.status.approved': '승인',
  'pages.members.rechargeReview.status.rejected': '거절',
  'pages.members.rechargeReview.applicationDate': '신청일',
  'pages.members.rechargeReview.approvalDate': '승인일',
  'pages.members.rechargeReview.transactionId': '거래ID',
  'pages.members.rechargeReview.admin': '관리자',
  'pages.members.rechargeReview.approve': '승인',
  'pages.members.rechargeReview.reject': '거절',
  'pages.members.rechargeReview.approveConfirm': '충전 신청 승인',
  'pages.members.rechargeReview.approveContent': '{name}님의 {amount}원 충전 신청을 승인하시겠습니까?',
  'pages.members.rechargeReview.approved': '충전 신청이 승인되었습니다',
  'pages.members.rechargeReview.rejectConfirm': '충전 신청 거절',
  'pages.members.rechargeReview.rejectContent': '{name}님의 충전 신청을 거절하시겠습니까?',
  'pages.members.rechargeReview.rejected': '충전 신청이 거절되었습니다',
  'pages.members.rechargeReview.statistics.total': '전체 신청',
  'pages.members.rechargeReview.statistics.pending': '대기 중',
  'pages.members.rechargeReview.statistics.approved': '승인 완료',
  'pages.members.rechargeReview.statistics.totalAmount': '총 신청금액',
  'pages.members.rechargeReview.exportSuccess': '데이터를 내보냈습니다',
  'pages.members.rechargeReview.remittanceCurrency': '송금 통화',
  'pages.members.rechargeReview.remittanceCurrencyAndAmount': '송금 통화 및 금액',
  'pages.members.rechargeReview.receivingBankName': '수신 은행명',
  'pages.members.rechargeReview.receivingAccountNumber': '수신 계좌번호',
  'pages.members.rechargeReview.receivingAccountHolder': '수신 예금주',

  // Withdraw Review
  'pages.members.withdrawReview.title': '출금 검토',
  'pages.members.withdrawReview.filter.group.title': '상태 필터',
  'pages.members.withdrawReview.filter.pendingReview': '검토 대기',
  'pages.members.withdrawReview.filter.approvalSuccessful': '승인 완료',
  'pages.members.withdrawReview.filter.reviewFailed': '검토 실패',
  'pages.members.withdrawReview.column.id': 'ID',
  'pages.members.withdrawReview.column.userId': '회원ID',
  'pages.members.withdrawReview.column.user': '회원',
  'pages.members.withdrawReview.column.handlingFee': '수수료',
  'pages.members.withdrawReview.column.withdrawalAmount': '출금 금액',
  'pages.members.withdrawReview.column.amountReceived': '수신 금액',
  'pages.members.withdrawReview.column.bankCardName': '은행카드명',
  'pages.members.withdrawReview.column.bankCardNumber': '은행카드번호',
  'pages.members.withdrawReview.column.bankCardHolder': '은행카드 소유자',
  'pages.members.withdrawReview.column.withdrawalTime': '출금 시간',
  'pages.members.withdrawReview.column.operate': '작업',
  'pages.members.withdrawReview.memberName': '회원명',
  'pages.members.withdrawReview.memberId': '회원ID',
  'pages.members.withdrawReview.amount': '금액',
  'pages.members.withdrawReview.status': '상태',
  'pages.members.withdrawReview.status.pending': '대기',
  'pages.members.withdrawReview.status.approved': '승인',
  'pages.members.withdrawReview.status.rejected': '거절',
  'pages.members.withdrawReview.bankName': '은행명',
  'pages.members.withdrawReview.accountNumber': '계좌번호',
  'pages.members.withdrawReview.accountHolder': '예금주',
  'pages.members.withdrawReview.applicationDate': '신청일',
  'pages.members.withdrawReview.approvalDate': '승인일',
  'pages.members.withdrawReview.admin': '관리자',
  'pages.members.withdrawReview.approve': '승인',
  'pages.members.withdrawReview.reject': '거절',
  'pages.members.withdrawReview.approveConfirm': '출금 신청 승인',
  'pages.members.withdrawReview.approveContent': '{name}님의 {amount}원 출금 신청을 승인하시겠습니까?',
  'pages.members.withdrawReview.approved': '출금 신청이 승인되었습니다',
  'pages.members.withdrawReview.rejectConfirm': '출금 신청 거절',
  'pages.members.withdrawReview.rejectContent': '{name}님의 출금 신청을 거절하시겠습니까?',
  'pages.members.withdrawReview.rejected': '출금 신청이 거절되었습니다',
  'pages.members.withdrawReview.statistics.total': '전체 신청',
  'pages.members.withdrawReview.statistics.pending': '대기 중',
  'pages.members.withdrawReview.statistics.approved': '승인 완료',
  'pages.members.withdrawReview.statistics.totalAmount': '총 신청금액',
  'pages.members.withdrawReview.exportSuccess': '데이터를 내보냈습니다',

  // Financial Record
  'pages.members.financialRecord.title': '재무 기록',
  'pages.members.financialRecord.filter.group.title': '기록 필터',
  'pages.members.financialRecord.filter.financialRecords': '재무 기록',
  'pages.members.financialRecord.filter.consumptionRecords': '소비 기록',
  'pages.members.financialRecord.filter.refundRecords': '환불 기록',
  'pages.members.financialRecord.filter.rebateRecords': '리베이트 기록',
  'pages.members.financialRecord.filter.pointsRecord': '포인트 기록',
  'pages.members.financialRecord.filter.couponUsageHistory': '쿠폰 사용 내역',
  'pages.members.financialRecord.filter.taxSettlement': '세금 정산 관리',
  'pages.members.financialRecord.tab.financial': '재무 기록',
  'pages.members.financialRecord.tab.consumption': '소비 기록',
  'pages.members.financialRecord.tab.refundRecords': '환불 기록',
  'pages.members.financialRecord.tab.rebate': '리베이트 기록',
  'pages.members.financialRecord.tab.points': '포인트 내역',
  'pages.members.financialRecord.tab.coupon': '쿠폰 사용 내역',
  'pages.members.financialRecord.tab.tax': '세금 정산 관리',
  /** 재무기록 탭 공통 — 예치금 신청내역 등과 동일 문구(시작시간/마감시간) */
  'pages.members.financialRecord.tabsFilter.startTime': '시작시간',
  'pages.members.financialRecord.tabsFilter.endTime': '마감시간',
  'pages.members.financialRecord.tabsFilter.paymentDateStart': '결제일 시작',
  'pages.members.financialRecord.tabsFilter.paymentDateEnd': '결제일 종료',
  // Financial Records Columns
  'pages.members.financialRecord.financial.column.orderNumber': '주문 번호',
  'pages.members.financialRecord.financial.column.purchaseOrderNumber': '구매 주문 번호',
  'pages.members.financialRecord.financial.column.userIdUserName': '회원 ID/이름',
  'pages.members.financialRecord.financial.column.productUnitPrice': '상품 단가',
  'pages.members.financialRecord.financial.column.productTotalPrice': '상품 총액',
  'pages.members.financialRecord.financial.column.handlingFee': '수수료 (1%)',
  'pages.members.financialRecord.financial.column.designatedShootingFee': '지정촬영 비용',
  'pages.members.financialRecord.financial.column.firstInternationalShippingFee': '1차 국제 배송비',
  'pages.members.financialRecord.financial.column.secondInternationalShippingFee': '2차 국제 배송비',
  'pages.members.financialRecord.financial.column.paymentMethod': '결제 방법',
  'pages.members.financialRecord.financial.column.transactionNumber': '거래 번호',
  'pages.members.financialRecord.financial.column.secondPaymentMethod': '2차 결제 방법',
  'pages.members.financialRecord.financial.column.secondPaymentTransactionNumber': '2차 결제 거래 번호',
  'pages.members.financialRecord.financial.column.orderPointsUsed': '주문 사용 적립금',
  'pages.members.financialRecord.financial.column.deliveryPointsUsed': '배송 사용 적립금',
  'pages.members.financialRecord.financial.column.orderCouponsUsed': '주문 사용 쿠폰',
  'pages.members.financialRecord.financial.column.deliveryCouponsUsed': '배송 사용 쿠폰',
  'pages.members.financialRecord.financial.column.paymentType': '결제 유형',
  'pages.members.financialRecord.financial.column.amountBeforeChange': '변경 전 금액',
  'pages.members.financialRecord.financial.column.changeAmount': '변경 금액',
  'pages.members.financialRecord.financial.column.amountAfterChange': '변경 후 금액',
  'pages.members.financialRecord.financial.column.paidTime': '결제 시간',
  'pages.members.financialRecord.financial.column.financialSettlementTime': '재무 정산 시간',
  'pages.members.financialRecord.financial.column.operatingTime': '작업 시간',
  'pages.members.financialRecord.financial.column.remarks': '비고',
  // Consumption Records Columns
  'pages.members.financialRecord.consumption.column.orderNumber': '주문번호',
  'pages.members.financialRecord.consumption.column.purchaseOrderNumber': '구매 주문 번호',
  'pages.members.financialRecord.consumption.column.userId': '회원 ID',
  'pages.members.financialRecord.consumption.column.recipientName': '수취인 이름',
  'pages.members.financialRecord.consumption.column.productUnitPrice': '상품 단가',
  'pages.members.financialRecord.consumption.column.productTotalPrice': '상품 총액',
  'pages.members.financialRecord.consumption.column.handlingFee': '수수료 (1%)',
  'pages.members.financialRecord.consumption.column.designatedShootingFee': '지정촬영 비용',
  'pages.members.financialRecord.consumption.column.firstInternationalShippingFee': '1차 국제 배송비',
  'pages.members.financialRecord.consumption.column.secondInternationalShippingFee': '2차 국제 배송비',
  'pages.members.financialRecord.consumption.column.paymentMethod': '결제 방법',
  'pages.members.financialRecord.consumption.column.transactionNumber': '거래 번호',
  'pages.members.financialRecord.consumption.column.secondPaymentMethod': '2차 결제 방법',
  'pages.members.financialRecord.consumption.column.secondPaymentTransactionNumber': '2차 결제 거래 번호',
  'pages.members.financialRecord.consumption.column.orderPointsUsed': '주문 사용 적립금',
  'pages.members.financialRecord.consumption.column.deliveryPointsUsed': '배송 사용 적립금',
  'pages.members.financialRecord.consumption.column.orderCouponsUsed': '주문 사용 쿠폰',
  'pages.members.financialRecord.consumption.column.deliveryCouponsUsed': '배송 사용 쿠폰',
  'pages.members.financialRecord.consumption.column.userAction': '회원 작업',
  'pages.members.financialRecord.consumption.column.paymentType': '결제 유형',
  'pages.members.financialRecord.consumption.column.amountBeforeChange': '변경 전 금액',
  'pages.members.financialRecord.consumption.column.changeAmount': '변동 금액',
  'pages.members.financialRecord.consumption.column.amountAfterChange': '변경 후 금액',
  'pages.members.financialRecord.consumption.column.paidTime': '결제 시간',
  'pages.members.financialRecord.consumption.column.financialSettlementTime': '재무 정산 시간',
  'pages.members.financialRecord.consumption.column.addTime': '추가 시간',
  'pages.members.financialRecord.consumption.column.changedTime': '변경 시간',
  // Rebate Records Columns
  'pages.members.financialRecord.rebate.column.userInfo': '회원 정보',
  'pages.members.financialRecord.rebate.column.memberName': '회원명',
  'pages.members.financialRecord.rebate.column.mailbox': '사서함',
  'pages.members.financialRecord.rebate.column.orderNumber': '주문번호',
  'pages.members.financialRecord.rebate.column.shippingRebate': '운임 리베이트',
  'pages.members.financialRecord.rebate.column.serviceFeeRebate': '서비스비 리베이트',
  'pages.members.financialRecord.rebate.column.totalRebateAmount': '리베이트 금액',
  'pages.members.financialRecord.rebate.column.amountBeforeChange': '변동 전 금액',
  'pages.members.financialRecord.rebate.column.amountAfterChange': '변동 후 금액',
  'pages.members.financialRecord.rebate.column.operatingTime': '작업 시간',
  'pages.members.financialRecord.rebate.column.sellerName': '셀러명',
  'pages.members.financialRecord.rebate.column.sellerMailbox': '셀러사서함',
  'pages.members.financialRecord.rebate.column.productNo': '번호',
  'pages.members.financialRecord.rebate.column.productName': '상품명',
  'pages.members.financialRecord.rebate.column.supplierName': '공급상이름',
  'pages.members.financialRecord.rebate.column.quantity': '수량',
  'pages.members.financialRecord.rebate.column.buyerMailbox': '회원 사서함',
  'pages.members.financialRecord.rebate.column.recipient': '수취인',
  'pages.members.financialRecord.rebate.column.paymentAmount': '결제금액',
  'pages.members.financialRecord.rebate.column.productCost': '상품원가',
  'pages.members.financialRecord.rebate.column.intlShipping': '운비',
  'pages.members.financialRecord.rebate.column.rebate': '리베이트',
  'pages.members.financialRecord.rebate.column.intlTrackingNo': '국제운송장번호',
  'pages.members.financialRecord.rebate.column.orderCreatedAt': '주문생성일시',
  'pages.members.financialRecord.rebate.column.downlineSellerUserId': '하위셀러',
  'pages.members.financialRecord.rebate.filter.sellerMailbox': '셀러사서함',
  'pages.members.financialRecord.rebate.filter.dateRangeFrom': '조회 기간 시작',
  'pages.members.financialRecord.rebate.filter.dateRangeTo': '조회 기간 종료',
  // Coupon Usage History Columns
  'pages.members.financialRecord.coupon.column.id': 'ID',
  'pages.members.financialRecord.coupon.column.userNameId': '회원 이름(ID)',
  'pages.members.financialRecord.coupon.column.orderNumber': '주문번호',
  'pages.members.financialRecord.coupon.column.couponName': '쿠폰 이름',
  'pages.members.financialRecord.coupon.column.couponCode': '쿠폰 코드',
  'pages.members.financialRecord.coupon.column.couponAmount': '쿠폰 금액',
  'pages.members.financialRecord.coupon.column.minimalUsageAmount': '최소 사용 금액',
  'pages.members.financialRecord.coupon.column.receiptMethod': '수령 방법',
  'pages.members.financialRecord.coupon.column.availablePeriod': '사용 가능 기간',
  'pages.members.financialRecord.coupon.column.status': '상태',
  'pages.members.financialRecord.coupon.column.receiveTime': '수령 시간',
  'pages.members.financialRecord.coupon.status.used': '사용',
  'pages.members.financialRecord.coupon.status.available': '사용 가능',
  'pages.members.financialRecord.coupon.status.expired': '만료',
  'pages.members.financialRecord.coupon.status.unused': '미사용',

  // Deposit (formerly Advanced Deposit)
  'pages.members.deposit.title': '입금 관리',
  'pages.members.deposit.column.paymentMethods': '결제 방법',
  'pages.members.deposit.column.userId': '회원ID',
  'pages.members.deposit.column.tr': 'TR',
  'pages.members.deposit.column.orderCreationTime': '주문 생성 시간',
  'pages.members.deposit.column.payerName': '결제자명',
  'pages.members.deposit.column.paymentAmountKRW': '결제 금액(원)',
  'pages.members.deposit.column.amountUsedKRW': '사용 금액(원)',
  'pages.members.deposit.column.remainingAmountKRW': '입금 잔액(원)',

  // Membership Level Management
  'pages.members.membershipLevel.title': '회원 등급',
  'pages.members.membershipLevel.column.level': '등급 레벨',
  'pages.members.membershipLevel.column.availablePointsRange': '사용 가능 포인트 범위',
  'pages.members.membershipLevel.column.pointsAcquisitionRatio': '포인트 획득 비율',
  'pages.members.membershipLevel.column.pointsDiscountRatio': '포인트 할인 비율',
  'pages.members.membershipLevel.column.orderAmountDiscountRatio': '주문 금액 할인 비율',
  'pages.members.membershipLevel.column.freeStorageDays': '무료 창고 보관 일수',
  'pages.members.membershipLevel.column.status': '상태',
  'pages.members.membershipLevel.column.ruleSettingTime': '규칙 설정 시간',
  'pages.members.membershipLevel.status.active': '활성',
  'pages.members.membershipLevel.status.inactive': '비활성',
  'pages.members.membershipLevel.column.id': 'ID',
  'pages.members.membershipLevel.column.grade': '등급',
  'pages.members.membershipLevel.column.integral': '적립금',
  'pages.members.membershipLevel.column.maxPointsUsable': '사용 가능한 최대 포인트',
  'pages.members.membershipLevel.column.minPointsAvailable': '사용 가능한 최소 포인트',
  'pages.members.membershipLevel.column.discountOnTotalOrderAmount': '전체 주문 금액 할인',
  'pages.members.membershipLevel.column.freeStorageValidityPeriod': '무료 보관 유효 기간(일)',
  'pages.members.membershipLevel.column.remark': '비고',
  'pages.members.membershipLevel.column.addTime': '등록 시간',
  'pages.members.membershipLevel.disable': '사용 중지',
  'pages.members.membershipLevel.enable': '활성화',
  'pages.members.membershipLevel.disableConfirm': '이 규칙을 사용 중지하시겠습니까?',
  'pages.members.membershipLevel.disableSuccess': '규칙이 사용 중지되었습니다',
  'pages.members.membershipLevel.disableError': '사용 중지에 실패했습니다',
  'pages.members.membershipLevel.enableSuccess': '규칙이 활성화되었습니다',
  'pages.members.membershipLevel.enableError': '활성화에 실패했습니다',
  'pages.members.membershipLevel.deleteConfirmDesc': '이 작업은 되돌릴 수 없습니다.',
  'pages.members.membershipLevel.deleteTitle': '등급 삭제',
  'pages.members.membershipLevel.deleteConfirm': '{name} 등급을 삭제하시겠습니까?',
  'pages.members.membershipLevel.deleteSuccess': '등급이 삭제되었습니다',
  'pages.members.membershipLevel.updateSuccess': '등급이 수정되었습니다',
  'pages.members.membershipLevel.createSuccess': '등급이 생성되었습니다',
  'pages.members.membershipLevel.modal.addTitle': '등급 추가',
  'pages.members.membershipLevel.modal.editTitle': '등급 수정',
  'pages.members.membershipLevel.form.grade': '등급',
  'pages.members.membershipLevel.form.gradePlaceholder': '등급을 입력하세요',
  'pages.members.membershipLevel.form.integral': '적립금',
  'pages.members.membershipLevel.form.integralPlaceholder': '적립금을 입력하세요',
  'pages.members.membershipLevel.form.maxPointsUsable': '사용 가능한 최대 포인트',
  'pages.members.membershipLevel.form.maxPointsUsablePlaceholder': '사용 가능한 최대 포인트를 입력하세요',
  'pages.members.membershipLevel.form.minPointsAvailable': '사용 가능한 최소 포인트',
  'pages.members.membershipLevel.form.minPointsAvailablePlaceholder': '사용 가능한 최소 포인트를 입력하세요',
  'pages.members.membershipLevel.form.pointsAcquisitionRatio': '포인트 획득 비율',
  'pages.members.membershipLevel.form.pointsAcquisitionRatioPlaceholder': '포인트 획득 비율을 입력하세요',
  'pages.members.membershipLevel.form.pointsDiscountRatio': '포인트 할인 비율',
  'pages.members.membershipLevel.form.pointsDiscountRatioPlaceholder': '포인트 할인 비율을 입력하세요 (%)',
  'pages.members.membershipLevel.form.orderAmountDiscountRatio': '주문 금액 할인 비율',
  'pages.members.membershipLevel.form.orderAmountDiscountRatioPlaceholder': '주문 금액 할인 비율을 입력하세요',
  'pages.members.membershipLevel.form.discountOnTotalOrderAmount': '전체 주문 금액 할인',
  'pages.members.membershipLevel.form.discountOnTotalOrderAmountPlaceholder': '전체 주문 금액 할인율을 입력하세요 (%)',
  'pages.members.membershipLevel.form.freeStorageDays': '무료 창고 보관 일수',
  'pages.members.membershipLevel.form.freeStorageDaysPlaceholder': '무료 창고 보관 일수를 입력하세요',
  'pages.members.membershipLevel.form.freeStorageValidityPeriod': '무료 보관 유효 기간',
  'pages.members.membershipLevel.form.freeStorageValidityPeriodPlaceholder': '무료 보관 유효 기간을 입력하세요',
  'pages.members.membershipLevel.form.days': '일',
  'pages.members.membershipLevel.form.remark': '비고',
  'pages.members.membershipLevel.form.remarkPlaceholder': '비고를 입력하세요',

  // Rebate Level
  'pages.members.rebateLevel.title': '리베이트 등급',
  'pages.members.rebateLevel.column.grade': '등급',
  'pages.members.rebateLevel.column.rebatePercentage': '일반리베이트율',
  'pages.members.rebateLevel.column.labangRebatePercentage': '라방리베이트율',
  'pages.members.rebateLevel.column.addTime': '등록일시',
  'pages.members.rebateLevel.column.levelName': '등급명',
  'pages.members.rebateLevel.column.levelCode': '등급 코드',
  'pages.members.rebateLevel.column.rebateRate': '리베이트율',
  'pages.members.rebateLevel.column.minPurchaseAmount': '최소 구매 금액',
  'pages.members.rebateLevel.column.maxPurchaseAmount': '최대 구매 금액',
  'pages.members.rebateLevel.column.description': '설명',
  'pages.members.rebateLevel.column.isActive': '활성화',
  'pages.members.rebateLevel.deleteTitle': '리베이트 등급 삭제',
  'pages.members.rebateLevel.deleteConfirm': '{name} 리베이트 등급을 삭제하시겠습니까?',
  'pages.members.rebateLevel.deleteSuccess': '리베이트 등급이 삭제되었습니다',
  'pages.members.rebateLevel.updateSuccess': '리베이트 등급이 수정되었습니다',
  'pages.members.rebateLevel.createSuccess': '리베이트 등급이 생성되었습니다',
  'pages.members.rebateLevel.modal.addTitle': '리베이트 등급 추가',
  'pages.members.rebateLevel.modal.editTitle': '리베이트 등급 수정',
  'pages.members.rebateLevel.form.grade': '등급',
  'pages.members.rebateLevel.form.gradePlaceholder': '등급을 입력하세요',
  'pages.members.rebateLevel.form.gradeRequired': '등급을 입력해주세요',
  'pages.members.rebateLevel.form.rebatePercentage': '리베이트율',
  'pages.members.rebateLevel.form.rebatePercentagePlaceholder': '리베이트율을 입력하세요 (%)',
  'pages.members.rebateLevel.form.rebatePercentageRequired': '리베이트율을 입력해주세요',
  'pages.members.rebateLevel.form.levelName': '등급명',
  'pages.members.rebateLevel.form.levelNamePlaceholder': '등급명을 입력하세요',
  'pages.members.rebateLevel.form.levelCode': '등급 코드',
  'pages.members.rebateLevel.form.levelCodePlaceholder': '등급 코드를 입력하세요',
  'pages.members.rebateLevel.form.rebateRate': '리베이트율',
  'pages.members.rebateLevel.form.rebateRatePlaceholder': '리베이트율을 입력하세요 (%)',
  'pages.members.rebateLevel.form.minPurchaseAmount': '최소 구매 금액',
  'pages.members.rebateLevel.form.minPurchaseAmountPlaceholder': '최소 구매 금액을 입력하세요',
  'pages.members.rebateLevel.form.maxPurchaseAmount': '최대 구매 금액',
  'pages.members.rebateLevel.form.maxPurchaseAmountPlaceholder': '최대 구매 금액을 입력하세요 (선택)',
  'pages.members.rebateLevel.form.description': '설명',
  'pages.members.rebateLevel.form.descriptionPlaceholder': '설명을 입력하세요',
  'pages.members.rebateLevel.form.isActive': '활성화',

  // Todaymall Rebate Level
  'pages.products.rebateLevel.title': '리베이트 레벨',
  'pages.products.rebateLevel.addButton': '리베이트 레벨 추가',
  'pages.products.rebateLevel.column.layer': '레이어',
  'pages.products.rebateLevel.column.type': '유형',
  'pages.products.rebateLevel.column.rebatePercentage': '리베이트 비율 (%)',
  'pages.products.rebateLevel.column.createdAt': '생성일',
  'pages.products.rebateLevel.column.actions': '작업',
  'pages.products.rebateLevel.type.regular': '일반',
  'pages.products.rebateLevel.type.labang': '라방',
  'pages.products.rebateLevel.action.edit': '수정',
  'pages.products.rebateLevel.action.delete': '삭제',
  'pages.products.rebateLevel.deleteConfirm': '이 리베이트 레벨을 삭제하시겠습니까?',
  'pages.products.rebateLevel.deleteConfirmYes': '예',
  'pages.products.rebateLevel.deleteConfirmNo': '아니오',
  'pages.products.rebateLevel.deleteSuccess': '리베이트 레벨이 삭제되었습니다',
  'pages.products.rebateLevel.deleteFailed': '리베이트 레벨 삭제 실패',
  'pages.products.rebateLevel.updateSuccess': '리베이트 레벨이 수정되었습니다',
  'pages.products.rebateLevel.createSuccess': '리베이트 레벨이 생성되었습니다',
  'pages.products.rebateLevel.saveFailed': '리베이트 레벨 저장 실패',
  'pages.products.rebateLevel.modal.addTitle': '리베이트 레벨 추가',
  'pages.products.rebateLevel.modal.editTitle': '리베이트 레벨 수정',
  'pages.products.rebateLevel.form.layer': '레이어',
  'pages.products.rebateLevel.form.layerPlaceholder': '레이어를 선택하세요',
  'pages.products.rebateLevel.form.layerRequired': '레이어를 선택해주세요',
  'pages.products.rebateLevel.form.layer1': '레이어 1',
  'pages.products.rebateLevel.form.layer2': '레이어 2',
  'pages.products.rebateLevel.form.layer3': '레이어 3',
  'pages.products.rebateLevel.form.layer4': '레이어 4',
  'pages.products.rebateLevel.form.layer5': '레이어 5',
  'pages.products.rebateLevel.form.lecturer': '강사',
  'pages.products.rebateLevel.form.type': '유형',
  'pages.products.rebateLevel.form.typeRequired': '유형을 선택해주세요',
  'pages.products.rebateLevel.form.rebatePercentage': '리베이트 비율 (%)',
  'pages.products.rebateLevel.form.rebatePercentagePlaceholder': '예: 70',
  'pages.products.rebateLevel.form.rebatePercentageRequired': '비율을 입력해주세요',
  'pages.products.rebateLevel.form.rebatePercentageRange': '0에서 100 사이여야 합니다',
  'pages.products.rebateLevel.form.example': '예시:',
  'pages.products.rebateLevel.form.exampleText': '레이어 {layer} {type} 회원은 {percentage}% 리베이트를 받습니다.',

  // Todaymall Rebate Rules
  'pages.products.rebateRules.title': '리베이트 규칙',
  'pages.products.rebateRules.addButton': '리베이트 규칙 추가',
  'pages.products.rebateRules.column.lowerLimit': '하한 (₩)',
  'pages.products.rebateRules.column.upperLimit': '상한 (₩)',
  'pages.products.rebateRules.column.percentage': '리베이트 비율 (%)',
  'pages.products.rebateRules.column.createdAt': '생성일',
  'pages.products.rebateRules.column.actions': '작업',
  'pages.products.rebateRules.action.edit': '수정',
  'pages.products.rebateRules.action.delete': '삭제',
  'pages.products.rebateRules.deleteConfirm': '이 리베이트 규칙을 삭제하시겠습니까?',
  'pages.products.rebateRules.deleteConfirmYes': '예',
  'pages.products.rebateRules.deleteConfirmNo': '아니오',
  'pages.products.rebateRules.deleteSuccess': '리베이트 규칙이 삭제되었습니다',
  'pages.products.rebateRules.deleteFailed': '리베이트 규칙 삭제 실패',
  'pages.products.rebateRules.updateSuccess': '리베이트 규칙이 수정되었습니다',
  'pages.products.rebateRules.createSuccess': '리베이트 규칙이 생성되었습니다',
  'pages.products.rebateRules.saveFailed': '리베이트 규칙 저장 실패',
  'pages.products.rebateRules.modal.addTitle': '리베이트 규칙 추가',
  'pages.products.rebateRules.modal.editTitle': '리베이트 규칙 수정',
  'pages.products.rebateRules.form.lowerLimit': '하한 (₩)',
  'pages.products.rebateRules.form.lowerLimitPlaceholder': '예: 0',
  'pages.products.rebateRules.form.lowerLimitRequired': '하한을 입력해주세요',
  'pages.products.rebateRules.form.lowerLimitMin': '0 이상이어야 합니다',
  'pages.products.rebateRules.form.upperLimit': '상한 (₩)',
  'pages.products.rebateRules.form.upperLimitPlaceholder': '예: 100000',
  'pages.products.rebateRules.form.upperLimitRequired': '상한을 입력해주세요',
  'pages.products.rebateRules.form.upperLimitMin': '0보다 커야 합니다',
  'pages.products.rebateRules.form.upperLimitGreater': '상한은 하한보다 커야 합니다',
  'pages.products.rebateRules.form.percentage': '리베이트 비율 (%)',
  'pages.products.rebateRules.form.percentagePlaceholder': '예: 5',
  'pages.products.rebateRules.form.percentageRequired': '비율을 입력해주세요',
  'pages.products.rebateRules.form.percentageRange': '0에서 100 사이여야 합니다',
  'pages.products.rebateRules.form.example': '예시:',
  'pages.products.rebateRules.form.exampleText': '₩{lower}에서 ₩{upper} 사이의 구매에 대해 회원은 {percentage}% 리베이트를 받습니다.',

  // Rebate Rules
  'pages.members.rebateRules.title': '리베이트 규칙',
  'pages.members.rebateRules.column.lowerLimit': '가격 차이 범위 하한',
  'pages.members.rebateRules.column.upperLimit': '가격 차이 범위 상한',
  'pages.members.rebateRules.column.rebatePercentage': '일반리베이트율',
  'pages.members.rebateRules.column.labangRebatePercentage': '라방리베이트율',
  'pages.members.rebateRules.column.addTime': '등록일시',
  'pages.members.rebateRules.column.ruleName': '규칙명',
  'pages.members.rebateRules.column.ruleType': '규칙 유형',
  'pages.members.rebateRules.column.targetName': '대상명',
  'pages.members.rebateRules.column.rebateRate': '리베이트율',
  'pages.members.rebateRules.column.minOrderAmount': '최소 주문 금액',
  'pages.members.rebateRules.column.maxRebateAmount': '최대 리베이트 금액',
  'pages.members.rebateRules.column.startDate': '시작일',
  'pages.members.rebateRules.column.endDate': '종료일',
  'pages.members.rebateRules.column.isActive': '활성화',
  'pages.members.rebateRules.ruleType.product': '상품',
  'pages.members.rebateRules.ruleType.category': '카테고리',
  'pages.members.rebateRules.ruleType.order': '주문',
  'pages.members.rebateRules.deleteTitle': '리베이트 규칙 삭제',
  'pages.members.rebateRules.deleteConfirm': '리베이트 규칙을 삭제하시겠습니까?',
  'pages.members.rebateRules.deleteSuccess': '리베이트 규칙이 삭제되었습니다',
  'pages.members.rebateRules.updateSuccess': '리베이트 규칙이 수정되었습니다',
  'pages.members.rebateRules.createSuccess': '리베이트 규칙이 생성되었습니다',
  'pages.members.rebateRules.modal.addTitle': '리베이트 규칙 추가',
  'pages.members.rebateRules.modal.editTitle': '리베이트 규칙 수정',
  'pages.members.rebateRules.form.lowerLimit': '가격 차이 범위 하한',
  'pages.members.rebateRules.form.lowerLimitPlaceholder': '가격 차이 범위 하한을 입력하세요',
  'pages.members.rebateRules.form.lowerLimitRequired': '가격 차이 범위 하한을 입력해주세요',
  'pages.members.rebateRules.form.upperLimit': '가격 차이 범위 상한',
  'pages.members.rebateRules.form.upperLimitPlaceholder': '가격 차이 범위 상한을 입력하세요',
  'pages.members.rebateRules.form.upperLimitRequired': '가격 차이 범위 상한을 입력해주세요',
  'pages.members.rebateRules.form.rebatePercentage': '리베이트율',
  'pages.members.rebateRules.form.rebatePercentagePlaceholder': '리베이트율을 입력하세요 (%)',
  'pages.members.rebateRules.form.rebatePercentageRequired': '리베이트율을 입력해주세요',
  'pages.members.rebateRules.form.ruleType': '규칙 유형',
  'pages.members.rebateRules.form.ruleTypePlaceholder': '규칙 유형을 선택하세요',
  'pages.members.rebateRules.form.ruleTypeRequired': '규칙 유형을 선택해주세요',
  'pages.members.rebateRules.form.ruleName': '규칙명',
  'pages.members.rebateRules.form.ruleNamePlaceholder': '규칙명을 입력하세요',
  'pages.members.rebateRules.form.targetName': '대상명',
  'pages.members.rebateRules.form.targetNamePlaceholder': '대상명을 입력하세요',
  'pages.members.rebateRules.form.rebateRate': '리베이트율',
  'pages.members.rebateRules.form.rebateRatePlaceholder': '리베이트율을 입력하세요 (%)',
  'pages.members.rebateRules.form.minOrderAmount': '최소 주문 금액',
  'pages.members.rebateRules.form.minOrderAmountPlaceholder': '최소 주문 금액을 입력하세요 (선택)',
  'pages.members.rebateRules.form.maxRebateAmount': '최대 리베이트 금액',
  'pages.members.rebateRules.form.maxRebateAmountPlaceholder': '최대 리베이트 금액을 입력하세요 (선택)',
  'pages.members.rebateRules.form.startDate': '시작일',
  'pages.members.rebateRules.form.endDate': '종료일',
  'pages.members.rebateRules.form.isActive': '활성화',

  // User Promotion Detail
  'pages.members.userPromotionDetail.title': '회원 추천',
  'pages.members.userPromotionDetail.column.userInfo': '회원 정보',
  'pages.members.userPromotionDetail.column.userUniqueId': '사서함',
  'pages.members.userPromotionDetail.column.invitationInfo': '초대 정보',
  'pages.members.userPromotionDetail.expand.warehouseAddresses': '배송지(창고) 정보',
  'pages.members.userPromotionDetail.expand.invitedUsers': '이 회원이 초대한 회원 (판매자 제외)',
  'pages.members.userPromotionDetail.expand.noAddresses': '등록된 배송지가 없습니다.',
  'pages.members.userPromotionDetail.expand.noInvitedUsers': '초대한 일반 회원이 없습니다.',
  'pages.members.userPromotionDetail.expand.inviteeAddresses': '초대 회원 배송지',
  'pages.members.userPromotionDetail.column.inviterUid': '초대자 UID',
  'pages.members.userPromotionDetail.column.numberOfInvitees': '초대 인원',
  'pages.members.userPromotionDetail.column.totalPoints': '총 포인트',
  'pages.members.userPromotionDetail.column.totalPointsWithdrawal': '총 포인트 출금',
  'pages.members.userPromotionDetail.column.remainingPoints': '남은 포인트',
  'pages.members.userPromotionDetail.column.userId': '회원ID',
  'pages.members.userPromotionDetail.column.userName': '회원명',
  'pages.members.userPromotionDetail.column.email': '이메일',
  'pages.members.userPromotionDetail.column.referralCode': '추천 코드',
  'pages.members.userPromotionDetail.fetchError': '회원 추천 정보를 가져오는데 실패했습니다',
  'pages.members.userPromotionDetail.column.level': '등급',
  'pages.members.userPromotionDetail.column.rebatePercentage': '리베이트 비율',
  'pages.members.userPromotionDetail.column.settingTime': '규칙 설정 시간',
  'pages.members.userPromotionDetail.column.lowerLimit': '하한',
  'pages.members.userPromotionDetail.column.upperLimit': '상한',
  'pages.members.userPromotionDetail.column.ruleType': '규칙 유형',
  'pages.members.userPromotionDetail.rebateLevel': '리베이트 등급',
  'pages.members.userPromotionDetail.rebateRule': '리베이트 규칙',
  'pages.members.userPromotionDetail.editRebateLevel': '리베이트 등급 수정',
  'pages.members.userPromotionDetail.editRebateRule': '리베이트 규칙 수정',
  'pages.members.userPromotionDetail.rebateLevelManagement': '리베이트 등급 관리',
  'pages.members.userPromotionDetail.rebateRuleManagement': '리베이트 규칙 관리',
  'pages.members.userPromotionDetail.deleteRebateLevel': '리베이트 등급 삭제',
  'pages.members.userPromotionDetail.deleteRebateLevelConfirm': '이 리베이트 등급을 삭제하시겠습니까?',
  'pages.members.userPromotionDetail.deleteRebateRule': '리베이트 규칙 삭제',
  'pages.members.userPromotionDetail.deleteRebateRuleConfirm': '이 리베이트 규칙을 삭제하시겠습니까?',
  'pages.members.userPromotionDetail.deleteConfirm': '삭제하시겠습니까?',
  'pages.members.userPromotionDetail.deleteSuccess': '삭제되었습니다',
  'pages.members.userPromotionDetail.updateSuccess': '업데이트되었습니다',
  'pages.members.userPromotionDetail.createSuccess': '생성되었습니다',
  'pages.members.userPromotionDetail.form.level': '등급',
  'pages.members.userPromotionDetail.form.rebatePercentage': '리베이트 비율',
  'pages.members.userPromotionDetail.form.lowerLimit': '하한',
  'pages.members.userPromotionDetail.form.upperLimit': '상한',
  'pages.members.userPromotionDetail.form.ruleType': '규칙 유형',
  'pages.members.userPromotionDetail.ruleType.priceDifference': '가격 차이',
  'pages.members.userPromotionDetail.column.promotionType': '프로모션 유형',
  'pages.members.userPromotionDetail.column.promotionName': '프로모션명',
  'pages.members.userPromotionDetail.column.promotionCode': '프로모션 코드',
  'pages.members.userPromotionDetail.column.amount': '금액',
  'pages.members.userPromotionDetail.column.status': '상태',
  'pages.members.userPromotionDetail.column.startDate': '시작일',
  'pages.members.userPromotionDetail.column.endDate': '종료일',
  'pages.members.userPromotionDetail.column.usedDate': '사용일',
  'pages.members.userPromotionDetail.column.orderNumber': '주문번호',
  'pages.members.userPromotionDetail.promotionType.rebate': '리베이트',
  'pages.members.userPromotionDetail.promotionType.discount': '할인',
  'pages.members.userPromotionDetail.promotionType.points': '포인트',
  'pages.members.userPromotionDetail.promotionType.coupon': '쿠폰',
  'pages.members.userPromotionDetail.status.active': '활성',
  'pages.members.userPromotionDetail.status.used': '사용됨',
  'pages.members.userPromotionDetail.status.expired': '만료됨',
  'pages.members.userPromotionDetail.status.cancelled': '취소됨',
  'pages.members.depositApplication.mock.accountHolder': '이대표',
  'pages.members.depositApplication.mock.admin': '관리자1',
  'pages.members.depositApplication.mock.memo': '우수 회원',
  'pages.members.forexDepositPayment.mock.adminMemo': '관리자 메모 내용입니다',

  // Deposit Usage Detailed
  'pages.members.depositUsage.memberName': '회원명',
  'pages.members.depositUsage.usageClassification': '사용분류',
  'pages.members.depositUsage.classificationPaymentCost': '결제 비용 사용',
  'pages.members.depositUsage.classificationDepositTopup': '예치금 충전',
  'pages.members.depositUsage.classificationAdminAccrual': '관리자 예치금 적립',
  'pages.members.depositUsage.classificationAdminDeduction': '관리자 예치금 차감',
  'pages.members.depositUsage.classificationRefund': '구매 상품 환불',
  'pages.members.depositUsage.content': '내용',
  'pages.members.depositUsage.amount': '사용금액',
  'pages.members.depositUsage.balance': '잔액',
  'pages.members.depositUsage.usageDate': '사용일',
  'pages.members.depositUsage.paymentOrderNumber': 'Payment OrderNumber',
  'pages.members.depositUsage.depositPaymentOrderNumber': 'Deposit Payment Order Number',
  'pages.members.depositUsage.usageType': '사용유형',
  'pages.members.depositUsage.typeOrder': '주문',
  'pages.members.depositUsage.typeRefund': '환불',
  'pages.members.depositUsage.typeWithdrawal': '출금',
  'pages.members.depositUsage.orderNo': '주문번호',
  'pages.members.depositUsage.actions': '기능',
  'pages.members.depositUsage.viewDetails': '상세보기',
  'pages.members.depositUsage.totalUsage': '전체 사용',
  'pages.members.depositUsage.totalAmount': '총 사용금액',
  'pages.members.depositUsage.averageAmount': '평균 사용금액',
  'pages.members.depositUsage.descriptionOrder': '주문 결제',
  'pages.members.depositUsage.mock.companyName': '(주)무역상사',
  'pages.members.depositUsage.mock.memberName': '홍길동',
  'pages.members.depositUsage.mock.paymentContent': '주문 결제 관련 내용',
  'pages.members.depositUsage.depositRegistration': '예치금 등록',
  'pages.members.depositUsage.memberSearch': '회원검색',
  'pages.members.depositUsage.searchByMemberId': '회원아이디',
  'pages.members.depositUsage.searchByMemberName': '회원명',
  'pages.members.depositUsage.searchRequired': '검색어를 입력하세요',
  'pages.members.depositUsage.searchPlaceholder': '검색',
  'pages.members.depositUsage.search': '검색',
  'pages.members.depositUsage.memberSelect': '회원 선택',
  'pages.members.depositUsage.contentRequired': '내용을 입력하세요',
  'pages.members.depositUsage.contentPlaceholder': '내용을 입력하세요',
  'pages.members.depositUsage.amountRequired': '금액을 입력하세요',
  'pages.members.depositUsage.amountMin': '금액은 0보다 커야 합니다',
  'pages.members.depositUsage.amountPlaceholder': '0',
  'pages.members.depositUsage.registrationSuccess': '예치금이 성공적으로 등록되었습니다',

  // Bankbook Verification Detailed
  'pages.members.bankbookVerification.depositDate': '입금일',
  'pages.members.bankbookVerification.accountNumber': '계좌번호',
  'pages.members.bankbookVerification.depositor': '입금인',
  'pages.members.bankbookVerification.amount': '금액',
  'pages.members.bankbookVerification.completionStatus': '완료여부',
  'pages.members.bankbookVerification.completed': '완료',
  'pages.members.bankbookVerification.notCompleted': '미완료',
  'pages.members.bankbookVerification.status': '상태',
  'pages.members.bankbookVerification.statusVerified': '인증완료',
  'pages.members.bankbookVerification.statusPending': '대기중',
  'pages.members.bankbookVerification.statusFailed': '인증실패',
  'pages.members.bankbookVerification.processingDate': '처리일',
  'pages.members.bankbookVerification.memberName': '회원명',
  'pages.members.bankbookVerification.bankInfo': '은행정보',
  'pages.members.bankbookVerification.autoVerify': '자동인증',
  'pages.members.bankbookVerification.enabled': '사용',
  'pages.members.bankbookVerification.disabled': '미사용',
  'pages.members.bankbookVerification.lastVerifiedDate': '최종인증일',
  'pages.members.bankbookVerification.actions': '기능',
  'pages.members.bankbookVerification.verify': '인증',
  'pages.members.bankbookVerification.autoVerifyUpdated': '{name}님의 자동인증이 {status}되었습니다',
  'pages.members.bankbookVerification.verificationStarted': '{name}님의 통장 인증을 시작합니다',
  'pages.members.bankbookVerification.totalAccounts': '전체 계좌',
  'pages.members.bankbookVerification.autoVerified': '자동인증',
  'pages.members.bankbookVerification.verified': '인증완료',
  'pages.members.bankbookVerification.failureReasonMismatch': '계좌 정보 불일치',
  'pages.members.bankbookVerification.mock.depositor1': '이대표',
  'pages.members.bankbookVerification.mock.depositor2': '홍길동',
  'pages.members.bankbookVerification.mock.additionalInfo': '추가 정보',

  // Forex Deposit Application Detailed
  'pages.members.forexDepositApplication.memberName': '회원명',
  'pages.members.forexDepositApplication.depositorCompanyName': '입금자회사명',
  'pages.members.forexDepositApplication.applicationAmountUSD': '신청금액($)',
  'pages.members.forexDepositApplication.usdDepositAmount': '달러입금액($)',
  'pages.members.forexDepositApplication.actualDepositAmountCNY': '실제입금액(¥)',
  'pages.members.forexDepositApplication.feeRatePercent': '수수료율(%)',
  'pages.members.forexDepositApplication.actualFeeCNY': '실제수수료(¥)',
  'pages.members.forexDepositApplication.actualRechargeAmountCNY': '실제충전금액(¥)',
  'pages.members.forexDepositApplication.remittanceDate': '송금일자',
  'pages.members.forexDepositApplication.completionStatus': '완료여부',
  'pages.members.forexDepositApplication.completed': '완료',
  'pages.members.forexDepositApplication.notCompleted': '미완료',
  'pages.members.forexDepositApplication.applicationDate': '신청일자',
  'pages.members.forexDepositApplication.completionDate': '완료일자',
  'pages.members.forexDepositApplication.adminDesignatedDate': '관리자지정일자',
  'pages.members.forexDepositApplication.smsNotSent': 'SMS 발송안함',
  'pages.members.forexDepositApplication.smsSent': 'SMS 발송함',
  'pages.members.forexDepositApplication.memo': '비고',
  'pages.members.forexDepositApplication.memoPlaceholder': '비고를 입력하세요',
  'pages.members.forexDepositApplication.memoRegistered': '비고가 등록되었습니다',
  'pages.members.forexDepositApplication.amount': '신청금액',
  'pages.members.forexDepositApplication.bankInfo': '은행정보',
  'pages.members.forexDepositApplication.status': '상태',
  'pages.members.forexDepositApplication.statusPending': '대기',
  'pages.members.forexDepositApplication.statusApproved': '승인',
  'pages.members.forexDepositApplication.statusRejected': '거절',
  'pages.members.forexDepositApplication.actions': '기능',
  'pages.members.forexDepositApplication.approve': '승인',
  'pages.members.forexDepositApplication.reject': '거절',
  'pages.members.forexDepositApplication.viewDetails': '상세보기',
  'pages.members.forexDepositApplication.approveConfirm': '외화 예치금 신청 승인',
  'pages.members.forexDepositApplication.approveContent': '{name}님의 {amount} {currency} 외화 예치금 신청을 승인하시겠습니까?',
  'pages.members.forexDepositApplication.approved': '외화 예치금 신청이 승인되었습니다',
  'pages.members.forexDepositApplication.rejectConfirm': '외화 예치금 신청 거절',
  'pages.members.forexDepositApplication.rejectContent': '{name}님의 외화 예치금 신청을 거절하시겠습니까?',
  'pages.members.forexDepositApplication.rejected': '외화 예치금 신청이 거절되었습니다',
  'pages.members.forexDepositApplication.totalApplications': '전체 신청',
  'pages.members.forexDepositApplication.pendingApplications': '대기 중',
  'pages.members.forexDepositApplication.approvedApplications': '승인 완료',
  'pages.members.forexDepositApplication.totalAmount': '총 신청금액',
  'pages.members.forexDepositApplication.exchangeRate': '환율',
  'pages.members.forexDepositApplication.reasonRecharge': '외화 예치금 충전',

  // Forex Deposit Usage Detailed
  'pages.members.forexDepositUsage.memberNameWithMailbox': '회원명(사서함)',
  'pages.members.forexDepositUsage.usageClassification': '사용구분',
  'pages.members.forexDepositUsage.classificationPaymentCost': '결제 비용 사용',
  'pages.members.forexDepositUsage.classificationDepositTopup': '예치금 충전',
  'pages.members.forexDepositUsage.classificationAdminAccrual': '관리자 예치금 적립',
  'pages.members.forexDepositUsage.classificationAdminDeduction': '관리자 예치금 차감',
  'pages.members.forexDepositUsage.classificationRefund': '구매 상품 환불',
  'pages.members.forexDepositUsage.content': '내용',
  'pages.members.forexDepositUsage.paymentNumber': '결제번호',
  'pages.members.forexDepositUsage.order1688Number': '1688주문번호',
  'pages.members.forexDepositUsage.alipayPaymentNumber': '支付宝결제번호',
  'pages.members.forexDepositUsage.register': '등록',
  'pages.members.forexDepositUsage.registered': '등록되었습니다',
  'pages.members.forexDepositUsage.pleaseEnterValue': '값을 입력해주세요',
  'pages.members.forexDepositUsage.enterOrder1688Number': '1688주문번호를 입력하세요',
  'pages.members.forexDepositUsage.enterAlipayPaymentNumber': '支付宝결제번호를 입력하세요',
  'pages.members.forexDepositUsage.depositRegistration': '예치금 등록',
  'pages.members.forexDepositUsage.depositChangeExcel': '예치금 변동 엑셀',
  'pages.members.forexDepositUsage.depositRefundExcel': '예치금 환불 엑셀',
  'pages.members.forexDepositUsage.paymentCostExcel': '결제비용 사용 엑셀',
  'pages.members.forexDepositUsage.accumulationDeductionExcel': '적립/차감 엑셀',
  'pages.members.forexDepositUsage.memberSearch': '회원검색',
  'pages.members.forexDepositUsage.searchByMemberId': '회원아이디',
  'pages.members.forexDepositUsage.searchByMemberName': '회원명',
  'pages.members.forexDepositUsage.searchRequired': '검색어를 입력하세요',
  'pages.members.forexDepositUsage.searchPlaceholder': '검색',
  'pages.members.forexDepositUsage.search': '검색',
  'pages.members.forexDepositUsage.memberSelect': '회원 선택',
  'pages.members.forexDepositUsage.contentRequired': '내용을 입력하세요',
  'pages.members.forexDepositUsage.contentPlaceholder': '내용을 입력하세요',
  'pages.members.forexDepositUsage.amountRequired': '금액을 입력하세요',
  'pages.members.forexDepositUsage.amountMin': '금액은 0보다 커야 합니다',
  'pages.members.forexDepositUsage.amountPlaceholder': '0',
  'pages.members.forexDepositUsage.registrationSuccess': '예치금이 성공적으로 등록되었습니다',
  'pages.members.forexDepositUsage.exportingDepositChange': '예치금 변동 내보내는 중...',
  'pages.members.forexDepositUsage.exportingDepositRefund': '예치금 환불 내보내는 중...',
  'pages.members.forexDepositUsage.exportingPaymentCost': '결제비용 사용 내보내는 중...',
  'pages.members.forexDepositUsage.exportingAccumulationDeduction': '적립/차감 내보내는 중...',
  'pages.members.forexDepositUsage.depositAmountCNY': '예치금(¥)',
  'pages.members.forexDepositUsage.remainingDepositCNY': '잔여 예치금(¥)',
  'pages.members.forexDepositUsage.usageDate': '일자',
  'pages.members.forexDepositUsage.adminDesignatedDate': '관리자지정일자',
  'pages.members.forexDepositUsage.usageType': '사용유형',
  'pages.members.forexDepositUsage.typeOrder': '주문',
  'pages.members.forexDepositUsage.typeRefund': '환불',
  'pages.members.forexDepositUsage.typeWithdrawal': '출금',
  'pages.members.forexDepositUsage.orderNo': '주문번호',
  'pages.members.forexDepositUsage.balance': '잔액',
  'pages.members.forexDepositUsage.actions': '기능',
  'pages.members.forexDepositUsage.viewDetails': '상세보기',
  'pages.members.forexDepositUsage.totalUsage': '전체 사용',
  'pages.members.forexDepositUsage.totalAmount': '총 사용금액',
  'pages.members.forexDepositUsage.averageAmount': '평균 사용금액',
  'pages.members.forexDepositUsage.descriptionOrder': '주문 결제',

  // Forex Deposit Payment Detailed
  'pages.members.forexDepositPayment.memberNameWithMailbox': '회원명(사서함)',
  'pages.members.forexDepositPayment.applicationClassification': '신청구분',
  'pages.members.forexDepositPayment.classificationDeposit': '입금',
  'pages.members.forexDepositPayment.classificationWithdrawal': '출금',
  'pages.members.forexDepositPayment.classificationRefund': '환불',
  'pages.members.forexDepositPayment.applicationInfo': '신청정보',
  'pages.members.forexDepositPayment.siteId': 'Site ID',
  'pages.members.forexDepositPayment.request': 'Request',
  'pages.members.forexDepositPayment.enterSiteId': 'Site ID를 입력하세요',
  'pages.members.forexDepositPayment.enterRequest': 'Request를 입력하세요',
  'pages.members.forexDepositPayment.applicationAmount': '신청금액',
  'pages.members.forexDepositPayment.status': '상태',
  'pages.members.forexDepositPayment.statusCompleted': '완료',
  'pages.members.forexDepositPayment.statusPending': '대기',
  'pages.members.forexDepositPayment.statusFailed': '실패',
  'pages.members.forexDepositPayment.applicationDate': '일자',
  'pages.members.forexDepositPayment.adminDesignatedDate': '관리자지정일자',
  'pages.members.forexDepositPayment.smsNotSent': 'SMS 발송안함',
  'pages.members.forexDepositPayment.smsSent': 'SMS 발송함',
  'pages.members.forexDepositPayment.all': '전체',
  'pages.members.forexDepositPayment.progressing': '진행중',
  'pages.members.forexDepositPayment.progressingSuccess': '진행이 완료되었습니다',
  'pages.members.forexDepositPayment.adminMemo': '관리자 메모',
  'pages.members.forexDepositPayment.adminMemoPlaceholder': '관리자 메모를 입력하세요',
  'pages.members.forexDepositPayment.adminMemoRegistered': '관리자 메모가 등록되었습니다',
  'pages.members.forexDepositPayment.memberName': '회원명',
  'pages.members.forexDepositPayment.paymentAmount': '결제금액',
  'pages.members.forexDepositPayment.paymentMethod': '결제방법',
  'pages.members.forexDepositPayment.methodBank': '은행',
  'pages.members.forexDepositPayment.methodCard': '카드',
  'pages.members.forexDepositPayment.methodTransfer': '이체',
  'pages.members.forexDepositPayment.paymentStatus': '결제상태',
  'pages.members.forexDepositPayment.transactionId': '거래번호',
  'pages.members.forexDepositPayment.paymentDate': '결제일',
  'pages.members.forexDepositPayment.actions': '기능',
  'pages.members.forexDepositPayment.viewDetails': '상세보기',
  'pages.members.forexDepositPayment.totalPayments': '전체 결제',
  'pages.members.forexDepositPayment.completedPayments': '완료',
  'pages.members.forexDepositPayment.totalAmount': '총 결제금액',
  'pages.members.forexDepositPayment.totalFee': '총 수수료',
  'pages.members.forexDepositPayment.exchangeRate': '환율',
  'pages.members.forexDepositPayment.fee': '수수료',

  // CS Pages
  'pages.cs.banners.description': '메인 배너, 팝업, 이벤트 페이지 관리',
  'pages.cs.lookingForOwner.description': '주인을 찾습니다 관리 페이지',

  // Bulletin Board Settings
  'pages.cs.bulletinBoard.title': '게시판 설정',
  'pages.cs.bulletinBoard.saveSuccess': '설정이 저장되었습니다',
  'pages.cs.bulletinBoard.generalSettings': '일반 설정',
  'pages.cs.bulletinBoard.postsPerPage': '페이지당 게시물 수',
  'pages.cs.bulletinBoard.allowAnonymous': '익명 게시 허용',
  'pages.cs.bulletinBoard.requireApproval': '관리자 승인 필요',
  'pages.cs.bulletinBoard.attachmentSettings': '첨부파일 설정',
  'pages.cs.bulletinBoard.allowAttachments': '첨부파일 허용',
  'pages.cs.bulletinBoard.maxAttachmentSize': '최대 첨부파일 크기 (MB)',
  'pages.cs.bulletinBoard.allowedFileTypes': '허용된 파일 형식',
  'pages.cs.bulletinBoard.commentSettings': '댓글 설정',
  'pages.cs.bulletinBoard.allowComments': '댓글 허용',
  'pages.cs.bulletinBoard.notifyOnNewPost': '새 게시물 시 관리자에게 알림',
  'pages.cs.bulletinBoard.notificationEmail': '알림 이메일',
  'pages.cs.bulletinBoard.save': '설정 저장',
  'pages.cs.bulletinBoard.reset': '초기화',
  'pages.cs.bulletinBoard.number': '번호',
  'pages.cs.bulletinBoard.titleColumn': '제목',
  'pages.cs.bulletinBoard.category': '카테고리',
  'pages.cs.bulletinBoard.categoryNotice': '공지사항',
  'pages.cs.bulletinBoard.categoryEvent': '이벤트',
  'pages.cs.bulletinBoard.categoryFaq': 'FAQ',
  'pages.cs.bulletinBoard.categoryUpdate': '업데이트',
  'pages.cs.bulletinBoard.status': '상태',
  'pages.cs.bulletinBoard.statusActive': '활성',
  'pages.cs.bulletinBoard.statusInactive': '비활성',
  'pages.cs.bulletinBoard.registrationDate': '등록일',
  'pages.cs.bulletinBoard.views': '조회수',
  'pages.cs.bulletinBoard.actions': '작업',
  'pages.cs.bulletinBoard.edit': '수정',
  'pages.cs.bulletinBoard.delete': '삭제',
  'pages.cs.bulletinBoard.add': '추가',
  'pages.cs.bulletinBoard.addTitle': '게시판 추가',
  'pages.cs.bulletinBoard.editTitle': '게시판 수정',
  'pages.cs.bulletinBoard.deleteConfirm': '게시판 삭제',
  'pages.cs.bulletinBoard.deleteContent': '"{title}"을(를) 삭제하시겠습니까?',
  'pages.cs.bulletinBoard.deleteSuccess': '삭제되었습니다',
  'pages.cs.bulletinBoard.updateSuccess': '수정되었습니다',
  'pages.cs.bulletinBoard.createSuccess': '등록되었습니다',
  'pages.cs.bulletinBoard.titleRequired': '제목을 입력하세요',
  'pages.cs.bulletinBoard.titlePlaceholder': '제목 입력',
  'pages.cs.bulletinBoard.categoryRequired': '카테고리를 선택하세요',
  'pages.cs.bulletinBoard.categoryPlaceholder': '카테고리 선택',
  'pages.cs.bulletinBoard.content': '내용',
  'pages.cs.bulletinBoard.contentRequired': '내용을 입력하세요',
  'pages.cs.bulletinBoard.contentPlaceholder': '내용 입력',
  'pages.cs.bulletinBoard.cancel': '취소',
  'pages.cs.bulletinBoard.type': '타입',
  'pages.cs.bulletinBoard.typePlaceholder': '타입 선택',
  'pages.cs.bulletinBoard.typeGeneral': '일반',
  'pages.cs.bulletinBoard.typeGallery': '갤러리',
  'pages.cs.bulletinBoard.typeQA': 'Q&A',
  'pages.cs.bulletinBoard.secretPost': '비밀글 여부',
  'pages.cs.bulletinBoard.headerPost': '머릿글 사용 여부',
  'pages.cs.bulletinBoard.statusEnabled': '상태 사용 여부',
  'pages.cs.bulletinBoard.writePermission': '쓰기권한 여부',
  'pages.cs.bulletinBoard.viewPermission': '보기권한 여부',
  'pages.cs.bulletinBoard.commentPermission': '덧글권한 여부',
  'pages.cs.bulletinBoard.noticeCount': '공지글수',
  'pages.cs.bulletinBoard.enabled': '사용여부',

  // CS - Danger Management
  'pages.cs.dangerManagement.title': '위험어 관리',
  'pages.cs.dangerManagement.addTitle': '위험어 추가',
  'pages.cs.dangerManagement.editTitle': '위험어 수정',
  'pages.cs.dangerManagement.deleteConfirm': '위험어 삭제',
  'pages.cs.dangerManagement.deleteConfirmContent': '"{term}" 위험어를 삭제하시겠습니까?',
  'pages.cs.dangerManagement.deleteSuccess': '위험어가 삭제되었습니다',
  'pages.cs.dangerManagement.updateSuccess': '위험어가 수정되었습니다',
  'pages.cs.dangerManagement.createSuccess': '위험어가 등록되었습니다',
  'pages.cs.dangerManagement.submitError': '위험어 저장 중 오류가 발생했습니다',
  'pages.cs.dangerManagement.fetchError': '위험 키워드를 불러오는데 실패했습니다',
  'pages.cs.dangerManagement.deleteError': '위험 키워드 삭제에 실패했습니다',
  'pages.cs.dangerManagement.duplicateError': '이미 존재하는 위험 키워드입니다',
  'pages.cs.dangerManagement.validationError': '유효성 검사 오류',
  'pages.cs.dangerManagement.form.termLength': '용어는 1자에서 200자 사이여야 합니다',
  'pages.cs.dangerManagement.column.id': 'ID',
  'pages.cs.dangerManagement.column.term': '용어',
  'pages.cs.dangerManagement.column.category': '카테고리',
  'pages.cs.dangerManagement.column.severity': '심각도',
  'pages.cs.dangerManagement.column.action': '조치',
  'pages.cs.dangerManagement.column.description': '설명',
  'pages.cs.dangerManagement.column.isActive': '활성화',
  'pages.cs.dangerManagement.category.prohibited': '금지',
  'pages.cs.dangerManagement.category.restricted': '제한',
  'pages.cs.dangerManagement.category.sensitive': '민감',
  'pages.cs.dangerManagement.severity.high': '높음',
  'pages.cs.dangerManagement.severity.medium': '보통',
  'pages.cs.dangerManagement.severity.low': '낮음',
  'pages.cs.dangerManagement.action.block': '차단',
  'pages.cs.dangerManagement.action.warn': '경고',
  'pages.cs.dangerManagement.action.review': '검토',
  'pages.cs.dangerManagement.form.term': '용어',
  'pages.cs.dangerManagement.form.termRequired': '용어를 입력하세요',
  'pages.cs.dangerManagement.form.atLeastOneLang': '최소 한 가지 언어 입력 필요 (영어, 중국어 또는 한국어)',
  'pages.cs.dangerManagement.translate': '번역',
  'pages.cs.dangerManagement.translateSuccess': '번역 완료',
  'pages.cs.dangerManagement.translateError': '번역 실패',
  'pages.cs.dangerManagement.form.category': '카테고리',
  'pages.cs.dangerManagement.form.categoryRequired': '카테고리를 선택하세요',
  'pages.cs.dangerManagement.form.severity': '심각도',
  'pages.cs.dangerManagement.form.severityRequired': '심각도를 선택하세요',
  'pages.cs.dangerManagement.form.action': '조치',
  'pages.cs.dangerManagement.form.actionRequired': '조치를 선택하세요',
  'pages.cs.dangerManagement.form.description': '설명',
  'pages.cs.dangerManagement.form.isActive': '활성화',

  // CS - Edit Search Term
  'pages.cs.editSearchTerm.title': '검색어 편집',
  'pages.cs.editSearchTerm.addTitle': '검색어 추가',
  'pages.cs.editSearchTerm.editTitle': '검색어 수정',
  'pages.cs.editSearchTerm.deleteConfirm': '검색어 삭제',
  'pages.cs.editSearchTerm.deleteConfirmContent': '"{term}" 검색어를 삭제하시겠습니까?',
  'pages.cs.editSearchTerm.deleteSuccess': '검색어가 삭제되었습니다',
  'pages.cs.editSearchTerm.updateSuccess': '검색어가 수정되었습니다',
  'pages.cs.editSearchTerm.createSuccess': '검색어가 등록되었습니다',
  'pages.cs.editSearchTerm.submitError': '검색어 저장 중 오류가 발생했습니다',
  'pages.cs.editSearchTerm.fetchError': '검색어 로드 실패',
  'pages.cs.editSearchTerm.deleteError': '검색어 삭제 실패',
  'pages.cs.editSearchTerm.createError': '검색어 생성 실패',
  'pages.cs.editSearchTerm.updateError': '검색어 업데이트 실패',
  'pages.cs.editSearchTerm.column.id': 'ID',
  'pages.cs.editSearchTerm.column.term': '검색어',
  'pages.cs.editSearchTerm.column.category': '카테고리',
  'pages.cs.editSearchTerm.column.priority': '우선순위',
  'pages.cs.editSearchTerm.column.synonyms': '동의어',
  'pages.cs.editSearchTerm.column.relatedTerms': '관련어',
  'pages.cs.editSearchTerm.column.searchCount': '검색 횟수',
  'pages.cs.editSearchTerm.column.isActive': '활성화',
  'pages.cs.editSearchTerm.column.correctTerm': '올바른 검색어',
  'pages.cs.editSearchTerm.form.term': '검색어',
  'pages.cs.editSearchTerm.form.termRequired': '검색어를 입력하세요',
  'pages.cs.editSearchTerm.form.atLeastOneLang': '최소 한 가지 언어 입력 필요 (영어, 중국어 또는 한국어)',
  'pages.cs.editSearchTerm.translate': '번역',
  'pages.cs.editSearchTerm.translateSuccess': '번역 완료',
  'pages.cs.editSearchTerm.translateError': '번역 실패',
  'pages.cs.editSearchTerm.form.correctTerm': '올바른 검색어',
  'pages.cs.editSearchTerm.form.correctTermRequired': '올바른 검색어를 입력하세요',
  'pages.cs.editSearchTerm.form.isActive': '활성화',
  'pages.cs.editSearchTerm.form.category': '카테고리',
  'pages.cs.editSearchTerm.form.categoryRequired': '카테고리를 입력하세요',
  'pages.cs.editSearchTerm.form.priority': '우선순위',
  'pages.cs.editSearchTerm.form.priorityRequired': '우선순위를 입력하세요',
  'pages.cs.editSearchTerm.form.synonyms': '동의어',
  'pages.cs.editSearchTerm.form.synonymsTooltip': '쉼표로 구분하여 입력하세요',
  'pages.cs.editSearchTerm.form.synonymsPlaceholder': '예: 휴대폰, 핸드폰',
  'pages.cs.editSearchTerm.form.relatedTerms': '관련어',
  'pages.cs.editSearchTerm.form.relatedTermsTooltip': '쉼표로 구분하여 입력하세요',
  'pages.cs.editSearchTerm.form.relatedTermsPlaceholder': '예: 케이스, 보호필름',

  // CS - Suggestion
  'pages.cs.suggestion.title': '싸이트평가',
  'pages.cs.suggestion.list': '건의사항 목록',
  'pages.cs.suggestion.detailTitle': '건의사항 상세',
  'pages.cs.suggestion.responseTitle': '건의사항 응답',
  'pages.cs.suggestion.column.sequenceNumber': '번호',
  'pages.cs.suggestion.column.category': '분류',
  'pages.cs.suggestion.column.title': '제목',
  'pages.cs.suggestion.column.content': '내용',
  'pages.cs.suggestion.column.userName': '작성자',
  'pages.cs.suggestion.column.email': '이메일',
  'pages.cs.suggestion.column.status': '상태',
  'pages.cs.suggestion.column.createdAt': '등록일',
  'pages.cs.suggestion.column.actions': '관리',
  'pages.cs.suggestion.category.feature': '기능 요청',
  'pages.cs.suggestion.category.improvement': '개선 요청',
  'pages.cs.suggestion.category.bug': '버그 신고',
  'pages.cs.suggestion.category.other': '기타',
  'pages.cs.suggestion.status.pending': '대기 중',
  'pages.cs.suggestion.status.reviewing': '검토 중',
  'pages.cs.suggestion.status.accepted': '수락됨',
  'pages.cs.suggestion.status.rejected': '거절됨',
  'pages.cs.suggestion.status.completed': '완료',
  'pages.cs.suggestion.action.view': '보기',
  'pages.cs.suggestion.action.respond': '응답',
  'pages.cs.suggestion.action.delete': '삭제',
  'pages.cs.suggestion.deleteConfirm': '삭제하시겠습니까?',
  'pages.cs.suggestion.deleteSuccess': '삭제되었습니다',
  'pages.cs.suggestion.responseSuccess': '응답이 저장되었습니다',
  'pages.cs.suggestion.adminResponse': '관리자 응답',
  'pages.cs.suggestion.respondedBy': '응답자',
  'pages.cs.suggestion.close': '닫기',
  'pages.cs.suggestion.submit': '저장',
  'pages.cs.suggestion.cancel': '취소',
  'pages.cs.suggestion.form.status': '상태',
  'pages.cs.suggestion.form.statusRequired': '상태를 선택해주세요',
  'pages.cs.suggestion.form.response': '응답 내용',
  'pages.cs.suggestion.form.responseRequired': '응답 내용을 입력해주세요',
  'pages.cs.suggestion.form.responsePlaceholder': '회원에게 보낼 응답 내용을 입력하세요',

  // CS - Email Template
  'pages.cs.emailTemplate.title': '이메일 템플릿',
  'pages.cs.emailTemplate.addTitle': '이메일 템플릿 추가',
  'pages.cs.emailTemplate.editTitle': '이메일 템플릿 수정',
  'pages.cs.emailTemplate.deleteConfirm': '이메일 템플릿 삭제',
  'pages.cs.emailTemplate.deleteConfirmContent': '"{name}" 이메일 템플릿을 삭제하시겠습니까?',
  'pages.cs.emailTemplate.deleteSuccess': '이메일 템플릿이 삭제되었습니다',
  'pages.cs.emailTemplate.updateSuccess': '이메일 템플릿이 수정되었습니다',
  'pages.cs.emailTemplate.createSuccess': '이메일 템플릿이 등록되었습니다',
  'pages.cs.emailTemplate.submitError': '이메일 템플릿 저장 중 오류가 발생했습니다',
  'pages.cs.emailTemplate.previewTitle': '이메일 템플릿 미리보기',
  'pages.cs.emailTemplate.column.name': '템플릿명',
  'pages.cs.emailTemplate.column.subject': '제목',
  'pages.cs.emailTemplate.column.category': '카테고리',
  'pages.cs.emailTemplate.column.variables': '변수',
  'pages.cs.emailTemplate.column.isActive': '활성화',
  'pages.cs.emailTemplate.category.notification': '알림',
  'pages.cs.emailTemplate.category.marketing': '마케팅',
  'pages.cs.emailTemplate.category.transactional': '거래',
  'pages.cs.emailTemplate.category.system': '시스템',
  'pages.cs.emailTemplate.form.name': '템플릿명',
  'pages.cs.emailTemplate.form.nameRequired': '템플릿명을 입력하세요',
  'pages.cs.emailTemplate.form.category': '카테고리',
  'pages.cs.emailTemplate.form.categoryRequired': '카테고리를 선택하세요',
  'pages.cs.emailTemplate.form.subject': '제목',
  'pages.cs.emailTemplate.form.subjectRequired': '제목을 입력하세요',
  'pages.cs.emailTemplate.form.subjectPlaceholder': '이메일 제목을 입력하세요',
  'pages.cs.emailTemplate.form.content': '내용',
  'pages.cs.emailTemplate.form.contentRequired': '내용을 입력하세요',
  'pages.cs.emailTemplate.form.contentTooltip': '변수는 {변수명} 형식으로 사용하세요 (예: {userName}, {orderNo})',
  'pages.cs.emailTemplate.form.contentPlaceholder': '이메일 내용을 입력하세요. 변수는 {변수명} 형식으로 사용하세요',
  'pages.cs.emailTemplate.form.isActive': '활성화',

  // CS - SMS Template
  'pages.cs.smsTemplate.title': 'SMS 템플릿',
  'pages.cs.smsTemplate.addTitle': 'SMS 템플릿 추가',
  'pages.cs.smsTemplate.editTitle': 'SMS 템플릿 수정',
  'pages.cs.smsTemplate.deleteConfirm': 'SMS 템플릿 삭제',
  'pages.cs.smsTemplate.deleteConfirmContent': '"{name}" SMS 템플릿을 삭제하시겠습니까?',
  'pages.cs.smsTemplate.deleteSuccess': 'SMS 템플릿이 삭제되었습니다',
  'pages.cs.smsTemplate.updateSuccess': 'SMS 템플릿이 수정되었습니다',
  'pages.cs.smsTemplate.createSuccess': 'SMS 템플릿이 등록되었습니다',
  'pages.cs.smsTemplate.submitError': 'SMS 템플릿 저장 중 오류가 발생했습니다',
  'pages.cs.smsTemplate.previewTitle': 'SMS 템플릿 미리보기',
  'pages.cs.smsTemplate.column.name': '템플릿명',
  'pages.cs.smsTemplate.column.category': '카테고리',
  'pages.cs.smsTemplate.column.content': '내용',
  'pages.cs.smsTemplate.column.variables': '변수',
  'pages.cs.smsTemplate.column.isActive': '활성화',
  'pages.cs.smsTemplate.category.notification': '알림',
  'pages.cs.smsTemplate.category.marketing': '마케팅',
  'pages.cs.smsTemplate.category.transactional': '거래',
  'pages.cs.smsTemplate.category.system': '시스템',
  'pages.cs.smsTemplate.form.name': '템플릿명',
  'pages.cs.smsTemplate.form.nameRequired': '템플릿명을 입력하세요',
  'pages.cs.smsTemplate.form.category': '카테고리',
  'pages.cs.smsTemplate.form.categoryRequired': '카테고리를 선택하세요',
  'pages.cs.smsTemplate.form.content': '내용',
  'pages.cs.smsTemplate.form.contentRequired': '내용을 입력하세요',
  'pages.cs.smsTemplate.form.contentTooltip': '변수는 {변수명} 형식으로 사용하세요. 최대 90자까지 입력 가능합니다',
  'pages.cs.smsTemplate.form.contentPlaceholder': 'SMS 내용을 입력하세요. 변수는 {변수명} 형식으로 사용하세요',
  'pages.cs.smsTemplate.form.isActive': '활성화',

  // CS - Email Log
  'pages.cs.emailLog.title': '이메일 로그',
  'pages.cs.emailLog.detailTitle': '이메일 로그 상세',
  'pages.cs.emailLog.column.templateName': '템플릿명',
  'pages.cs.emailLog.column.recipient': '수신자',
  'pages.cs.emailLog.column.subject': '제목',
  'pages.cs.emailLog.column.status': '상태',
  'pages.cs.emailLog.column.sentAt': '발송일시',
  'pages.cs.emailLog.column.errorMessage': '오류 메시지',
  'pages.cs.emailLog.status.sent': '발송완료',
  'pages.cs.emailLog.status.failed': '발송실패',
  'pages.cs.emailLog.status.pending': '대기중',
  'pages.cs.emailLog.detail.templateName': '템플릿명',
  'pages.cs.emailLog.detail.recipient': '수신자',
  'pages.cs.emailLog.detail.subject': '제목',
  'pages.cs.emailLog.detail.status': '상태',
  'pages.cs.emailLog.detail.sentAt': '발송일시',
  'pages.cs.emailLog.detail.failedAt': '실패일시',
  'pages.cs.emailLog.detail.errorMessage': '오류 메시지',
  'pages.cs.emailLog.detail.createdAt': '생성일시',

  // CS - Push Message
  'pages.cs.pushMessage.title': '푸시 메시지',
  'pages.cs.pushMessage.addTitle': '푸시 메시지 추가',
  'pages.cs.pushMessage.editTitle': '푸시 메시지 수정',
  'pages.cs.pushMessage.deleteConfirm': '푸시 메시지 삭제',
  'pages.cs.pushMessage.deleteConfirmContent': '"{title}" 푸시 메시지를 삭제하시겠습니까?',
  'pages.cs.pushMessage.deleteSuccess': '푸시 메시지가 삭제되었습니다',
  'pages.cs.pushMessage.updateSuccess': '푸시 메시지가 수정되었습니다',
  'pages.cs.pushMessage.createSuccess': '푸시 메시지가 등록되었습니다',
  'pages.cs.pushMessage.submitError': '푸시 메시지 저장 중 오류가 발생했습니다',
  'pages.cs.pushMessage.send': '발송',
  'pages.cs.pushMessage.sendSuccess': '푸시 메시지가 발송되었습니다',
  'pages.cs.pushMessage.column.title': '제목',
  'pages.cs.pushMessage.column.content': '내용',
  'pages.cs.pushMessage.column.targetType': '대상',
  'pages.cs.pushMessage.column.sendType': '발송유형',
  'pages.cs.pushMessage.column.status': '상태',
  'pages.cs.pushMessage.column.sentCount': '발송수',
  'pages.cs.pushMessage.column.readCount': '읽음수',
  'pages.cs.pushMessage.column.scheduledAt': '예약일시',
  'pages.cs.pushMessage.targetType.all': '전체',
  'pages.cs.pushMessage.targetType.specific': '특정 회원',
  'pages.cs.pushMessage.targetType.segment': '세그먼트',
  'pages.cs.pushMessage.sendType.immediate': '즉시',
  'pages.cs.pushMessage.sendType.scheduled': '예약',
  'pages.cs.pushMessage.status.draft': '초안',
  'pages.cs.pushMessage.status.scheduled': '예약됨',
  'pages.cs.pushMessage.status.sent': '발송완료',
  'pages.cs.pushMessage.status.failed': '발송실패',
  'pages.cs.pushMessage.form.title': '제목',
  'pages.cs.pushMessage.form.titleRequired': '제목을 입력하세요',
  'pages.cs.pushMessage.form.content': '내용',
  'pages.cs.pushMessage.form.contentRequired': '내용을 입력하세요',
  'pages.cs.pushMessage.form.targetType': '대상',
  'pages.cs.pushMessage.form.targetTypeRequired': '대상을 선택하세요',
  'pages.cs.pushMessage.form.sendType': '발송유형',
  'pages.cs.pushMessage.form.sendTypeRequired': '발송유형을 선택하세요',
  'pages.cs.pushMessage.form.scheduledAt': '예약일시',
  'pages.cs.pushMessage.form.scheduledAtRequired': '예약일시를 선택하세요',
  'pages.reviews.title': '이용후기',
  'pages.reviews.number': '번호',
  'pages.reviews.author': '작성자',
  'pages.reviews.views': '조회수',
  'pages.reviews.registrationDate': '등록일',
  'pages.reviews.actions': '작업',
  'pages.reviews.view': '보기',
  'pages.reviews.edit': '수정',
  'pages.reviews.delete': '삭제',
  'pages.reviews.deleteConfirm': '삭제하시겠습니까?',
  'pages.reviews.deleted': '삭제되었습니다',
  'pages.reviews.searchSuccess': '검색되었습니다',
  'pages.reviews.imagesCount': '개',
  'pages.reviews.pageSize': 'page',
  'pages.reviews.date': '일자',
  'pages.reviews.memberName': '회원명',
  'pages.reviews.memberNamePlaceholder': '회원명',
  'pages.reviews.titlePlaceholder': '제목',
  'pages.reviews.content': '내용',
  'pages.reviews.contentPlaceholder': '내용',
  'pages.reviews.postNumber': '게시글번호',
  'pages.reviews.postNumberPlaceholder': '게시글번호',
  'pages.reviews.search': '검색',
  'pages.reviews.reset': '초기화',
  'pages.reviews.write': '글쓰기',
  'pages.reviews.totalCount': 'total count',
  'pages.reviews.page': 'page',
  'pages.reviews.total': 'total',
  'pages.reviews.viewDetail': '상세보기',
  'pages.reviews.titleRequired': '제목을 입력하세요',
  'pages.reviews.contentRequired': '내용을 입력하세요',
  'pages.reviews.isNotice': '공지글 여부',
  'pages.reviews.attachments': '다중 첨부파일',
  'pages.reviews.attachments.count': '개',
  'pages.reviews.sequenceNumber': '순번',
  'pages.reviews.complaintType': '불만 유형',
  'pages.reviews.complaintType.complaint': '불만',
  'pages.reviews.complaintType.suggestion': '제안',
  'pages.reviews.memberNumber': '회원 번호',
  'pages.reviews.orderNumber': '주문 번호',
  'pages.reviews.subOrderNumber': '하위 주문 번호',
  'pages.reviews.processingStatus': '처리 상태',
  'pages.reviews.processingStatus.unconfirmed': '미확인',
  'pages.reviews.processingStatus.processed': '처리 완료',
  'pages.reviews.updatedAt': '최신 업데이트 시간',
  'pages.reviews.maxFiles': '최대 수량 : 5개',
  'pages.reviews.maxFileSize': '1개 파일 최대 용량 : 3MB',
  'pages.reviews.chooseFiles': 'Choose files',
  'pages.reviews.cancel': '취소',
  'pages.reviews.save': '저장',
  'pages.reviews.createSuccess': '저장되었습니다',
  'pages.reviews.updateSuccess': '수정되었습니다',
  'pages.reviews.detail': '상세보기',
  'pages.reviews.postInfo': '게시글 정보',
  'pages.reviews.list': '목록',
  'pages.reviews.policyWarning': '욕설, 도배, 비방, 루머 등 운영정책에 어긋나는 게시물 등록 시에는 글쓰기 제한 등 불이익을 받으실 수 있습니다',
  'pages.reviews.comments': '덧글',
  'pages.reviews.commentPlaceholder': '안녕하세요. 투데이직구입니다.',
  'pages.reviews.writeComment': '덧글쓰기',
  'pages.reviews.commentRequired': '덧글을 입력하세요',
  'pages.reviews.commentSubmitted': '덧글이 등록되었습니다',
  'pages.reviews.totalComments': '전체',
  'pages.reviews.commentsCount': '개의 덧글이 있습니다',
  'pages.reviews.noComments': '등록된 덧글이 없습니다.',
  'pages.reviews.filter': '검색 필터',

  // Inquiries Page
  'pages.cs.inquiries.title': '1:1 문의 관리',
  'pages.cs.inquiries.stats.total': '전체 문의',
  'pages.cs.inquiries.stats.pending': '대기중',
  'pages.cs.inquiries.stats.answered': '답변완료',
  'pages.cs.inquiries.stats.avgResponseTime': '평균 응답시간',
  'pages.cs.inquiries.stats.hours': '시간',
  'pages.cs.inquiries.list': '문의 목록',
  'pages.cs.inquiries.export': '엑셀 다운로드',
  'pages.cs.inquiries.exportSuccess': '엑셀 다운로드가 완료되었습니다',
  'pages.cs.inquiries.id': 'ID',
  'pages.cs.inquiries.number': '번호',
  'pages.cs.inquiries.author': '작성자명',
  'pages.cs.inquiries.views': '조회수',
  'pages.cs.inquiries.memberInfo': '회원정보',
  'pages.cs.inquiries.category': '카테고리',
  'pages.cs.inquiries.category.order': '주문문의',
  'pages.cs.inquiries.category.product': '상품문의',
  'pages.cs.inquiries.category.delivery': '배송문의',
  'pages.cs.inquiries.category.payment': '결제문의',
  'pages.cs.inquiries.category.etc': '기타',
  'pages.cs.inquiries.fieldTitle': '제목',
  'pages.cs.inquiries.priority': '우선순위',
  'pages.cs.inquiries.priority.high': '높음',
  'pages.cs.inquiries.priority.normal': '보통',
  'pages.cs.inquiries.priority.low': '낮음',
  'pages.cs.inquiries.status': '상태',
  'pages.cs.inquiries.status.pending': '대기중',
  'pages.cs.inquiries.status.answered': '답변완료',
  'pages.cs.inquiries.createdAt': '등록일',
  'pages.cs.inquiries.answeredAt': '답변일시',
  'pages.cs.inquiries.actions': '작업',
  'pages.cs.inquiries.viewDetail': '상세',
  'pages.cs.inquiries.answer': '답변',
  'pages.cs.inquiries.detailTitle': '문의 상세',
  'pages.cs.inquiries.close': '닫기',
  'pages.cs.inquiries.answerButton': '답변하기',
  'pages.cs.inquiries.inquiryContent': '문의 내용',
  'pages.cs.inquiries.inquiryId': '문의 ID',
  'pages.cs.inquiries.memberName': '회원명',
  'pages.cs.inquiries.memberId': '회원 ID',
  'pages.cs.inquiries.answerer': '답변자',
  'pages.cs.inquiries.answerContent': '답변',
  'pages.cs.inquiries.answerTitle': '답변 작성',
  'pages.cs.inquiries.answerContentField': '답변 내용',
  'pages.cs.inquiries.answerContentPlaceholder': '답변 내용을 입력하세요',
  'pages.cs.inquiries.submit': '등록',
  'pages.cs.inquiries.cancel': '취소',
  'pages.cs.inquiries.answerSuccess': '답변이 등록되었습니다',
  'pages.cs.inquiries.stats.open': '열림',
  'pages.cs.inquiries.stats.closed': '닫힘',
  'pages.cs.inquiries.stats.resolved': '해결됨',
  'pages.cs.inquiries.user': '회원',
  'pages.cs.inquiries.subject': '제목',
  'pages.cs.inquiries.subjectEmpty': '(제목 없음)',
  'pages.cs.inquiries.tab.all': '전체',
  'pages.cs.inquiries.tab.inProgress': '문의중',
  'pages.cs.inquiries.tab.answered': '답변완료',
  'pages.cs.inquiries.tab.onHold': '답변보류',
  'pages.cs.inquiries.isHeader': '머릿글',
  'pages.cs.inquiries.content': '내용',
  'pages.cs.inquiries.addTitle': '문의 추가',
  'pages.cs.inquiries.addSuccess': '문의가 추가되었습니다',
  'pages.cs.inquiries.addError': '문의 추가에 실패했습니다',
  'pages.cs.inquiries.secret': '비밀글',
  'pages.cs.inquiries.selectCategory': '카테고리 선택',
  'pages.cs.inquiries.contentPlaceholder': '내용을 입력하세요',
  'pages.cs.inquiries.attachments': '다중 첨부파일',
  'pages.cs.inquiries.attachmentInfo': '최대 5개, 5MB 이하 파일만 첨부 가능',
  'pages.cs.inquiries.loadError': '문의를 불러오는데 실패했습니다',
  'pages.cs.inquiries.deleteSuccess': '문의가 삭제되었습니다',
  'pages.cs.inquiries.deleteError': '문의 삭제에 실패했습니다',
  'pages.cs.inquiries.deleteConfirm': '정말 삭제하시겠습니까?',
  'pages.cs.inquiries.notFound': '문의를 찾을 수 없습니다',
  'pages.cs.inquiries.replySection': '답변',
  'pages.cs.inquiries.replyRequired': '답변 내용을 입력하세요',
  'pages.cs.inquiries.replySuccess': '답변이 등록되었습니다',
  'pages.cs.inquiries.replyError': '답변 등록에 실패했습니다',
  'pages.cs.inquiries.replyPlaceholder': '답변 내용을 입력하세요',
  'pages.cs.inquiries.replyNote': '목록, 도메인, 비밀번호 등 민감한 정보는 이곳에는 게시 금지 시에는 글을 삭제 시킬 수 있습니다',
  'pages.cs.inquiries.smsNotification': 'SMS 알림설정',
  'pages.cs.inquiries.noNotification': '알림 없음',
  'pages.cs.inquiries.reply': '답변',

  // Inquiry Header Options
  'pages.cs.inquiries.header.shippingAgency': '배송대행',
  'pages.cs.inquiries.header.purchaseAgency': '구매대행',
  'pages.cs.inquiries.header.payment': '결제',
  'pages.cs.inquiries.header.deposit': '예치금',
  'pages.cs.inquiries.header.etc': '기타',
  'pages.cs.inquiries.header.ttIdApplication': 'TT ID 신청',  
  'pages.cs.inquiries.status.unconfirmed': '미확인',
  'pages.cs.inquiries.status.in_progress': '문의중',
  'pages.cs.inquiries.status.confirmed': '확인됨',
  'pages.cs.inquiries.assignedAdmin': '할당된 관리자',
  'pages.cs.inquiries.unassigned': '미할당',
  'pages.cs.inquiries.status.open': '열림',
  'pages.cs.inquiries.status.closed': '닫힘',
  'pages.cs.inquiries.status.resolved': '해결됨',
  'pages.cs.inquiries.messageCount': '메시지 수',
  'pages.cs.inquiries.createdDate': '생성일',
  'pages.cs.inquiries.lastMessage': '마지막 메시지',
  'pages.cs.inquiries.viewChat': '대화 보기',
  'pages.cs.inquiries.assign': '할당',
  'pages.cs.inquiries.listTitle': '1:1 문의 목록',
  'pages.cs.inquiries.chatTitle': '1:1 문의 대화',
  'pages.cs.inquiries.assignToMe': '나에게 할당',
  'pages.cs.inquiries.admin': '관리자',
  'pages.cs.inquiries.userLabel': '회원',
  'pages.cs.inquiries.noMessages': '메시지가 없습니다.',
  'pages.cs.inquiries.messageRequired': '메시지를 입력하세요',
  'pages.cs.inquiries.messagePlaceholder': '메시지를 입력하세요...',
  'pages.cs.inquiries.send': '전송',
  'pages.cs.inquiries.reopen': '다시 열기',
  'pages.cs.inquiries.assignSuccess': '문의가 할당되었습니다.',
  'pages.cs.inquiries.assignError': '할당에 실패했습니다.',
  'pages.cs.inquiries.sendSuccess': '메시지가 전송되었습니다.',
  'pages.cs.inquiries.sendError': '메시지 전송에 실패했습니다.',
  'pages.cs.inquiries.userLoadError': '회원 정보를 불러오는데 실패했습니다.',
  'pages.cs.inquiries.attachFile': '파일 첨부',
  'pages.cs.inquiries.uploadError': '파일 업로드에 실패했습니다.',
  'pages.cs.inquiries.fileSizeLimit': '파일 크기는 10MB 이하여야 합니다.',
  'pages.cs.inquiries.closeSuccess': '문의가 닫혔습니다.',
  'pages.cs.inquiries.closeError': '문의 닫기에 실패했습니다.',
  'pages.cs.inquiries.processingButton': '처리중',
  'pages.cs.inquiries.confirmButton': '확인',
  'pages.cs.inquiries.processingStarted': '처리가 시작되었습니다.',
  'pages.cs.inquiries.confirmedSuccess': '확인 완료.',
  'pages.cs.inquiries.processingError': '처리 시작에 실패했습니다.',
  'pages.cs.inquiries.confirmError': '확인 처리에 실패했습니다.',
  'pages.cs.inquiries.attachmentPlaceholder': '[첨부파일]',
  'pages.cs.inquiries.reopenSuccess': '문의가 다시 열렸습니다.',
  'pages.cs.inquiries.category.general': '일반',
  'pages.cs.inquiries.category.support': '지원',
  'pages.cs.inquiries.category.complaint': '불만',
  'pages.cs.inquiries.category.suggestion': '제안',
  'pages.cs.inquiries.category.technical': '기술',
  'pages.cs.inquiries.unreadMessages': '{count}개의 읽지 않은 메시지',
  'pages.cs.inquiries.messageRead': '읽음',

  // Notices Page
  'pages.cs.notices.stats.total': '전체 공지',
  'pages.cs.notices.stats.published': '게시중',
  'pages.cs.notices.stats.draft': '임시저장',
  'pages.cs.notices.stats.hidden': '숨김',
  'pages.cs.notices.list': '공지사항 목록',
  'pages.cs.notices.add': '공지사항 작성',
  'pages.cs.notices.export': '엑셀 다운로드',
  'pages.cs.notices.id': 'ID',
  'pages.cs.notices.title': '제목',
  'pages.cs.notices.category': '카테고리',
  'pages.cs.notices.category.general': '일반',
  'pages.cs.notices.category.important': '중요',
  'pages.cs.notices.category.event': '이벤트',
  'pages.cs.notices.category.maintenance': '점검',
  'pages.cs.notices.status': '상태',
  'pages.cs.notices.status.published': '게시중',
  'pages.cs.notices.status.draft': '임시저장',
  'pages.cs.notices.status.hidden': '숨김',
  'pages.cs.notices.priority': '우선순위',
  'pages.cs.notices.priority.high': '높음',
  'pages.cs.notices.priority.normal': '보통',
  'pages.cs.notices.priority.low': '낮음',
  'pages.cs.notices.views': '조회수',
  'pages.cs.notices.author': '작성자',
  'pages.cs.notices.createdAt': '작성일시',
  'pages.cs.notices.create': '작성',
  'pages.cs.notices.actions': '작업',
  'pages.cs.notices.viewDetail': '상세',
  'pages.cs.notices.edit': '수정',
  'pages.cs.notices.delete': '삭제',
  'pages.cs.notices.deleteConfirm': '정말 삭제하시겠습니까?',
  'pages.cs.notices.detailTitle': '공지사항 상세',
  'pages.cs.notices.content': '내용',
  'pages.cs.notices.updatedAt': '수정일시',
  'pages.cs.notices.publishAt': '게시일시',
  'pages.cs.notices.tags': '태그',
  'pages.cs.notices.editTitle': '공지사항 수정',
  'pages.cs.notices.createTitle': '공지사항 작성',
  'pages.cs.notices.titlePlaceholder': '공지사항 제목을 입력하세요',
  'pages.cs.notices.contentPlaceholder': '공지사항 내용을 입력하세요',
  'pages.cs.notices.titleRequired': '제목을 입력해주세요',
  'pages.cs.notices.contentRequired': '내용을 입력해주세요',
  'pages.cs.notices.updateSuccess': '공지사항이 수정되었습니다',
  'pages.cs.notices.createSuccess': '공지사항이 등록되었습니다',
  'pages.cs.notices.deleteSuccess': '공지사항이 삭제되었습니다',
  'pages.cs.notices.close': '닫기',
  'pages.cs.notices.cancel': '취소',
  'pages.cs.notices.broadcastCreated': '새로운 공지사항이 생성되었습니다',
  'pages.cs.notices.broadcastDeleted': '공지사항이 삭제되었습니다',
  'pages.cs.notices.deleteFailed': '삭제에 실패했습니다',
  'pages.cs.notices.updateFailed': '수정에 실패했습니다',
  'pages.cs.notices.createFailed': '등록에 실패했습니다',
  'pages.cs.notices.loadFailed': '불러오기에 실패했습니다',
  'pages.cs.notices.number': '번호',
  'pages.cs.notices.fieldTitle': '제목',
  'pages.cs.notices.isHeader': '머릿글',
  'pages.cs.notices.tab.all': '전체',
  'pages.cs.notices.exportSuccess': '엑셀 다운로드가 완료되었습니다',
  'pages.cs.notices.addTitle': '공지사항 추가',
  'pages.cs.notices.addSuccess': '공지사항이 추가되었습니다',
  'pages.cs.notices.addError': '공지사항 추가에 실패했습니다',
  'pages.cs.notices.secret': '비밀글',
  'pages.cs.notices.selectCategory': '카테고리 선택',
  'pages.cs.notices.attachments': '다중 첨부파일',
  'pages.cs.notices.attachmentInfo': '최대 5개, 5MB 이하 파일만 첨부 가능',
  'pages.cs.notices.loadError': '공지사항을 불러오는데 실패했습니다',
  'pages.cs.notices.deleteError': '공지사항 삭제에 실패했습니다',
  'pages.cs.notices.notFound': '공지사항을 찾을 수 없습니다',
  'pages.cs.notices.submit': '등록',
  'pages.cs.notices.category.order': '주문',
  'pages.cs.notices.category.product': '상품',
  'pages.cs.notices.category.delivery': '배송',
  'pages.cs.notices.category.payment': '결제',
  'pages.cs.notices.category.etc': '기타',

  // Suggestion Page (Service Inquiry/Suggestion)
  'pages.cs.suggestion.number': '번호',
  'pages.cs.suggestion.fieldTitle': '제목',
  'pages.cs.suggestion.author': '작성자명',
  'pages.cs.suggestion.views': '조회수',
  'pages.cs.suggestion.createdAt': '등록일',
  'pages.cs.suggestion.status': '상태',
  'pages.cs.suggestion.isHeader': '머릿글',
  'pages.cs.suggestion.content': '내용',
  'pages.cs.suggestion.export': '엑셀 다운로드',
  'pages.cs.suggestion.exportSuccess': '엑셀 다운로드가 완료되었습니다',
  'pages.cs.suggestion.tab.all': '전체',
  'pages.cs.suggestion.tab.inProgress': '문의중',
  'pages.cs.suggestion.tab.answered': '답변완료',
  'pages.cs.suggestion.tab.onHold': '답변보류',
  'pages.cs.suggestion.addTitle': '건의사항 추가',
  'pages.cs.suggestion.addSuccess': '건의사항이 추가되었습니다',
  'pages.cs.suggestion.addError': '건의사항 추가에 실패했습니다',
  'pages.cs.suggestion.secret': '비밀글',
  'pages.cs.suggestion.selectCategory': '카테고리 선택',
  'pages.cs.suggestion.category': '카테고리',
  'pages.cs.suggestion.category.general': '일반',
  'pages.cs.suggestion.category.order': '주문',
  'pages.cs.suggestion.category.product': '상품',
  'pages.cs.suggestion.category.delivery': '배송',
  'pages.cs.suggestion.category.payment': '결제',
  'pages.cs.suggestion.category.etc': '기타',
  'pages.cs.suggestion.contentPlaceholder': '내용을 입력하세요',
  'pages.cs.suggestion.attachments': '다중 첨부파일',
  'pages.cs.suggestion.attachmentInfo': '최대 5개, 5MB 이하 파일만 첨부 가능',
  'pages.cs.suggestion.loadError': '건의사항을 불러오는데 실패했습니다',
  'pages.cs.suggestion.deleteError': '건의사항 삭제에 실패했습니다',
  'pages.cs.suggestion.notFound': '건의사항을 찾을 수 없습니다',
  'pages.cs.suggestion.replySection': '답변',
  'pages.cs.suggestion.replyRequired': '답변 내용을 입력하세요',
  'pages.cs.suggestion.replySuccess': '답변이 등록되었습니다',
  'pages.cs.suggestion.replyError': '답변 등록에 실패했습니다',
  'pages.cs.suggestion.replyPlaceholder': '답변 내용을 입력하세요',
  'pages.cs.suggestion.replyNote': '목록, 도메인, 비밀번호 등 민감한 정보는 이곳에는 게시 금지 시에는 글을 삭제 시킬 수 있습니다',
  'pages.cs.suggestion.smsNotification': 'SMS 알림설정',
  'pages.cs.suggestion.noNotification': '알림 없음',
  'pages.cs.suggestion.reply': '답변',

  // Suggestion Header Options
  'pages.cs.suggestion.header.shippingAgency': '배송대행',
  'pages.cs.suggestion.header.purchaseAgency': '구매대행',
  'pages.cs.suggestion.header.payment': '결제',
  'pages.cs.suggestion.header.deposit': '예치금',
  'pages.cs.suggestion.header.etc': '기타',

  // FAQ Header Options
  'pages.cs.faq.header.joinMembership': '회원가입',
  'pages.cs.faq.header.applyShippingAgency': '배송대행 신청',
  'pages.cs.faq.header.combinedPackaging': '합포장 신청',
  'pages.cs.faq.header.overseasReturn': '해외반품 신청',
  'pages.cs.faq.header.incomingOutgoingDelivery': '입출고 및 배송',
  'pages.cs.faq.header.serviceCost': '서비스 비용',
  'pages.cs.faq.header.customsClearance': '통관 및 관부가세',
  'pages.cs.faq.header.compensation': '보상',

  // Notices Header Options
  'pages.cs.notices.header.joinMembership': '회원가입',
  'pages.cs.notices.header.applyShippingAgency': '배송대행 신청',
  'pages.cs.notices.header.combinedPackaging': '합포장 신청',
  'pages.cs.notices.header.overseasReturn': '해외반품 신청',
  'pages.cs.notices.header.incomingOutgoingDelivery': '입출고 및 배송',
  'pages.cs.notices.header.serviceCost': '서비스 비용',
  'pages.cs.notices.header.customsClearance': '통관 및 관부가세',
  'pages.cs.notices.header.compensation': '보상',

  // Event Header Options
  'pages.cs.event.header.joinMembership': '회원가입',
  'pages.cs.event.header.applyShippingAgency': '배송대행 신청',
  'pages.cs.event.header.combinedPackaging': '합포장 신청',
  'pages.cs.event.header.overseasReturn': '해외반품 신청',
  'pages.cs.event.header.incomingOutgoingDelivery': '입출고 및 배송',
  'pages.cs.event.header.serviceCost': '서비스 비용',
  'pages.cs.event.header.customsClearance': '통관 및 관부가세',
  'pages.cs.event.header.compensation': '보상',

  // Reviews Header Options
  'pages.cs.reviews.header.joinMembership': '회원가입',
  'pages.cs.reviews.header.applyShippingAgency': '배송대행 신청',
  'pages.cs.reviews.header.combinedPackaging': '합포장 신청',
  'pages.cs.reviews.header.overseasReturn': '해외반품 신청',
  'pages.cs.reviews.header.incomingOutgoingDelivery': '입출고 및 배송',
  'pages.cs.reviews.header.serviceCost': '서비스 비용',
  'pages.cs.reviews.header.customsClearance': '통관 및 관부가세',
  'pages.cs.reviews.header.compensation': '보상',

  // Looking for Owner Header Options
  'pages.cs.looking-for-owner.header.joinMembership': '회원가입',
  'pages.cs.looking-for-owner.header.applyShippingAgency': '배송대행 신청',
  'pages.cs.looking-for-owner.header.combinedPackaging': '합포장 신청',
  'pages.cs.looking-for-owner.header.overseasReturn': '해외반품 신청',
  'pages.cs.looking-for-owner.header.incomingOutgoingDelivery': '입출고 및 배송',
  'pages.cs.looking-for-owner.header.serviceCost': '서비스 비용',
  'pages.cs.looking-for-owner.header.customsClearance': '통관 및 관부가세',
  'pages.cs.looking-for-owner.header.compensation': '보상',

  // FAQ Page
  'pages.cs.faq.number': '번호',
  'pages.cs.faq.fieldTitle': '제목',
  'pages.cs.faq.author': '작성자명',
  'pages.cs.faq.views': '조회수',
  'pages.cs.faq.createdAt': '등록일',
  'pages.cs.faq.isHeader': '머릿글',
  'pages.cs.faq.content': '내용',
  'pages.cs.faq.export': '엑셀 다운로드',
  'pages.cs.faq.exportSuccess': '엑셀 다운로드가 완료되었습니다',
  'pages.cs.faq.tab.all': '전체',
  'pages.cs.faq.addTitle': 'FAQ 추가',
  'pages.cs.faq.addSuccess': 'FAQ가 추가되었습니다',
  'pages.cs.faq.addError': 'FAQ 추가에 실패했습니다',
  'pages.cs.faq.secret': '비밀글',
  'pages.cs.faq.selectCategory': '카테고리 선택',
  'pages.cs.faq.category': '카테고리',
  'pages.cs.faq.category.general': '일반',
  'pages.cs.faq.category.order': '주문',
  'pages.cs.faq.category.product': '상품',
  'pages.cs.faq.category.delivery': '배송',
  'pages.cs.faq.category.payment': '결제',
  'pages.cs.faq.category.etc': '기타',
  'pages.cs.faq.contentPlaceholder': '내용을 입력하세요',
  'pages.cs.faq.attachments': '다중 첨부파일',
  'pages.cs.faq.attachmentInfo': '최대 5개, 5MB 이하 파일만 첨부 가능',
  'pages.cs.faq.submit': '등록',
  'pages.cs.faq.cancel': '취소',
  'pages.cs.faq.detailTitle': 'FAQ 상세',
  'pages.cs.faq.loadError': 'FAQ를 불러오는데 실패했습니다',
  'pages.cs.faq.deleteSuccess': 'FAQ가 삭제되었습니다',
  'pages.cs.faq.deleteError': 'FAQ 삭제에 실패했습니다',
  'pages.cs.faq.deleteConfirm': '정말 삭제하시겠습니까?',
  'pages.cs.faq.notFound': 'FAQ를 찾을 수 없습니다',

  // Reviews Page
  'pages.cs.reviews.number': '번호',
  'pages.cs.reviews.fieldTitle': '제목',
  'pages.cs.reviews.author': '작성자명',
  'pages.cs.reviews.views': '조회수',
  'pages.cs.reviews.createdAt': '등록일',
  'pages.cs.reviews.isHeader': '머릿글',
  'pages.cs.reviews.content': '내용',
  'pages.cs.reviews.export': '엑셀 다운로드',
  'pages.cs.reviews.exportSuccess': '엑셀 다운로드가 완료되었습니다',
  'pages.cs.reviews.tab.all': '전체',
  'pages.cs.reviews.addTitle': '이용후기 추가',
  'pages.cs.reviews.addSuccess': '이용후기가 추가되었습니다',
  'pages.cs.reviews.addError': '이용후기 추가에 실패했습니다',
  'pages.cs.reviews.secret': '비밀글',
  'pages.cs.reviews.selectCategory': '카테고리 선택',
  'pages.cs.reviews.category': '카테고리',
  'pages.cs.reviews.category.general': '일반',
  'pages.cs.reviews.category.order': '주문',
  'pages.cs.reviews.category.product': '상품',
  'pages.cs.reviews.category.delivery': '배송',
  'pages.cs.reviews.category.payment': '결제',
  'pages.cs.reviews.category.etc': '기타',
  'pages.cs.reviews.contentPlaceholder': '내용을 입력하세요',
  'pages.cs.reviews.attachments': '다중 첨부파일',
  'pages.cs.reviews.attachmentInfo': '최대 5개, 5MB 이하 파일만 첨부 가능',
  'pages.cs.reviews.submit': '등록',
  'pages.cs.reviews.cancel': '취소',
  'pages.cs.reviews.detailTitle': '이용후기 상세',
  'pages.cs.reviews.loadError': '이용후기를 불러오는데 실패했습니다',
  'pages.cs.reviews.deleteSuccess': '이용후기가 삭제되었습니다',
  'pages.cs.reviews.deleteError': '이용후기 삭제에 실패했습니다',
  'pages.cs.reviews.deleteConfirm': '정말 삭제하시겠습니까?',
  'pages.cs.reviews.notFound': '이용후기를 찾을 수 없습니다',

  // Looking for Owner Page
  'pages.cs.looking-for-owner.number': '번호',
  'pages.cs.looking-for-owner.fieldTitle': '제목',
  'pages.cs.looking-for-owner.author': '작성자명',
  'pages.cs.looking-for-owner.views': '조회수',
  'pages.cs.looking-for-owner.createdAt': '등록일',
  'pages.cs.looking-for-owner.isHeader': '머릿글',
  'pages.cs.looking-for-owner.content': '내용',
  'pages.cs.looking-for-owner.export': '엑셀 다운로드',
  'pages.cs.looking-for-owner.exportSuccess': '엑셀 다운로드가 완료되었습니다',
  'pages.cs.looking-for-owner.tab.all': '전체',
  'pages.cs.looking-for-owner.addTitle': '주인을 찾습니다 추가',
  'pages.cs.looking-for-owner.addSuccess': '주인을 찾습니다가 추가되었습니다',
  'pages.cs.looking-for-owner.addError': '주인을 찾습니다 추가에 실패했습니다',
  'pages.cs.looking-for-owner.secret': '비밀글',
  'pages.cs.looking-for-owner.selectCategory': '카테고리 선택',
  'pages.cs.looking-for-owner.category': '카테고리',
  'pages.cs.looking-for-owner.category.general': '일반',
  'pages.cs.looking-for-owner.category.order': '주문',
  'pages.cs.looking-for-owner.category.product': '상품',
  'pages.cs.looking-for-owner.category.delivery': '배송',
  'pages.cs.looking-for-owner.category.payment': '결제',
  'pages.cs.looking-for-owner.category.etc': '기타',
  'pages.cs.looking-for-owner.contentPlaceholder': '내용을 입력하세요',
  'pages.cs.looking-for-owner.attachments': '다중 첨부파일',
  'pages.cs.looking-for-owner.attachmentInfo': '최대 5개, 5MB 이하 파일만 첨부 가능',
  'pages.cs.looking-for-owner.submit': '등록',
  'pages.cs.looking-for-owner.cancel': '취소',
  'pages.cs.looking-for-owner.detailTitle': '주인을 찾습니다 상세',
  'pages.cs.looking-for-owner.loadError': '주인을 찾습니다를 불러오는데 실패했습니다',
  'pages.cs.looking-for-owner.deleteSuccess': '주인을 찾습니다가 삭제되었습니다',
  'pages.cs.looking-for-owner.deleteError': '주인을 찾습니다 삭제에 실패했습니다',
  'pages.cs.looking-for-owner.deleteConfirm': '정말 삭제하시겠습니까?',
  'pages.cs.looking-for-owner.notFound': '주인을 찾습니다를 찾을 수 없습니다',

  // Event Page
  'pages.cs.event.number': '번호',
  'pages.cs.event.fieldTitle': '제목',
  'pages.cs.event.author': '작성자명',
  'pages.cs.event.views': '조회수',
  'pages.cs.event.createdAt': '등록일',
  'pages.cs.event.isHeader': '머릿글',
  'pages.cs.event.content': '내용',
  'pages.cs.event.export': '엑셀 다운로드',
  'pages.cs.event.exportSuccess': '엑셀 다운로드가 완료되었습니다',
  'pages.cs.event.tab.all': '전체',
  'pages.cs.event.addTitle': '이벤트 추가',
  'pages.cs.event.addSuccess': '이벤트가 추가되었습니다',
  'pages.cs.event.addError': '이벤트 추가에 실패했습니다',
  'pages.cs.event.secret': '비밀글',
  'pages.cs.event.selectCategory': '카테고리 선택',
  'pages.cs.event.category': '카테고리',
  'pages.cs.event.category.general': '일반',
  'pages.cs.event.category.order': '주문',
  'pages.cs.event.category.product': '상품',
  'pages.cs.event.category.delivery': '배송',
  'pages.cs.event.category.payment': '결제',
  'pages.cs.event.category.etc': '기타',
  'pages.cs.event.contentPlaceholder': '내용을 입력하세요',
  'pages.cs.event.attachments': '다중 첨부파일',
  'pages.cs.event.attachmentInfo': '최대 5개, 5MB 이하 파일만 첨부 가능',
  'pages.cs.event.submit': '등록',
  'pages.cs.event.cancel': '취소',
  'pages.cs.event.detailTitle': '이벤트 상세',
  'pages.cs.event.loadError': '이벤트를 불러오는데 실패했습니다',
  'pages.cs.event.deleteSuccess': '이벤트가 삭제되었습니다',
  'pages.cs.event.deleteError': '이벤트 삭제에 실패했습니다',
  'pages.cs.event.deleteConfirm': '정말 삭제하시겠습니까?',
  'pages.cs.event.notFound': '이벤트를 찾을 수 없습니다',
  'pages.cs.notices.type': '타입',
  'pages.cs.notices.type.announcement': '공지',
  'pages.cs.notices.type.maintenance': '점검',
  'pages.cs.notices.type.update': '업데이트',
  'pages.cs.notices.type.warning': '경고',
  'pages.cs.notices.type.info': '정보',
  'pages.cs.notices.type.promotion': '프로모션',
  'pages.cs.notices.status.active': '활성',
  'pages.cs.notices.status.inactive': '비활성',
  'pages.cs.notices.priority.urgent': '긴급',
  'pages.cs.notices.targetAudience': '대상',
  'pages.cs.notices.targetAudience.all': '전체',
  'pages.cs.notices.targetAudience.users': '회원',
  'pages.cs.notices.targetAudience.admins': '관리자',
  'pages.cs.notices.stats.active': '활성',
  'pages.cs.notices.stats.expired': '만료',
  'pages.cs.notices.stats.announcement': '공지',
  'pages.cs.notices.expiresAt': '만료일',
  'pages.cs.notices.expiresAtOptional': '만료일 (선택사항)',
  'pages.cs.notices.expiresAtPlaceholder': '만료일을 선택하세요',
  'pages.cs.notices.typePlaceholder': '타입을 선택하세요',
  'pages.cs.notices.typeRequired': '타입을 선택하세요',
  'pages.cs.notices.contentPlaceholderFull': '공지사항 내용을 입력하세요 (최대 5000자)',
  'pages.cs.notices.contentMaxLength': '내용은 최대 5000자까지 입력 가능합니다',
  'pages.cs.notices.priorityPlaceholder': '우선순위를 선택하세요',
  'pages.cs.notices.priorityRequired': '우선순위를 선택하세요',
  'pages.cs.notices.targetAudiencePlaceholder': '대상을 선택하세요',
  'pages.cs.notices.targetAudienceRequired': '대상을 선택하세요',

  // Looking For Owner Page
  'pages.cs.lookingForOwner.stats.total': '전체 게시글',
  'pages.cs.lookingForOwner.stats.active': '진행중',
  'pages.cs.lookingForOwner.stats.completed': '완료',
  'pages.cs.lookingForOwner.stats.closed': '종료',
  'pages.cs.lookingForOwner.list': '주인을 찾습니다 목록',
  'pages.cs.lookingForOwner.add': '게시글 작성',
  'pages.cs.lookingForOwner.export': '엑셀 다운로드',
  'pages.cs.lookingForOwner.id': 'ID',
  'pages.cs.lookingForOwner.memberInfo': '회원정보',
  'pages.cs.lookingForOwner.title': '제목',
  'pages.cs.lookingForOwner.category': '카테고리',
  'pages.cs.lookingForOwner.category.lost': '분실',
  'pages.cs.lookingForOwner.category.found': '습득',
  'pages.cs.lookingForOwner.category.exchange': '교환',
  'pages.cs.lookingForOwner.status': '상태',
  'pages.cs.lookingForOwner.status.active': '진행중',
  'pages.cs.lookingForOwner.status.completed': '완료',
  'pages.cs.lookingForOwner.status.closed': '종료',
  'pages.cs.lookingForOwner.location': '위치',
  'pages.cs.lookingForOwner.views': '조회수',
  'pages.cs.lookingForOwner.replies': '댓글수',
  'pages.cs.lookingForOwner.createdAt': '작성일시',
  'pages.cs.lookingForOwner.actions': '작업',
  'pages.cs.lookingForOwner.viewDetail': '상세',
  'pages.cs.lookingForOwner.edit': '수정',
  'pages.cs.lookingForOwner.complete': '완료처리',
  'pages.cs.lookingForOwner.delete': '삭제',
  'pages.cs.lookingForOwner.deleteConfirm': '정말 삭제하시겠습니까?',
  'pages.cs.lookingForOwner.detailTitle': '게시글 상세',
  'pages.cs.lookingForOwner.memberName': '회원명',
  'pages.cs.lookingForOwner.memberId': '회원ID',
  'pages.cs.lookingForOwner.contact': '연락처',
  'pages.cs.lookingForOwner.descriptionField': '내용',
  'pages.cs.lookingForOwner.updatedAt': '수정일시',
  'pages.cs.lookingForOwner.completedAt': '완료일시',
  'pages.cs.lookingForOwner.images': '이미지',
  'pages.cs.lookingForOwner.editTitle': '게시글 수정',
  'pages.cs.lookingForOwner.createTitle': '게시글 작성',
  'pages.cs.lookingForOwner.titlePlaceholder': '게시글 제목을 입력하세요',
  'pages.cs.lookingForOwner.descriptionPlaceholder': '게시글 내용을 입력하세요',
  'pages.cs.lookingForOwner.locationPlaceholder': '위치를 입력하세요',
  'pages.cs.lookingForOwner.contactPlaceholder': '연락처를 입력하세요',
  'pages.cs.lookingForOwner.titleRequired': '제목을 입력해주세요',
  'pages.cs.lookingForOwner.descriptionRequired': '내용을 입력해주세요',
  'pages.cs.lookingForOwner.updateSuccess': '게시글이 수정되었습니다',
  'pages.cs.lookingForOwner.createSuccess': '게시글이 등록되었습니다',
  'pages.cs.lookingForOwner.deleteSuccess': '게시글이 삭제되었습니다',
  'pages.cs.lookingForOwner.statusChangeSuccess': '상태가 변경되었습니다',
  'pages.cs.lookingForOwner.close': '닫기',
  'pages.cs.lookingForOwner.cancel': '취소',

  // In Transit (배송중) Pages
  'pages.orders.inKoreaDelivery.title': '배송중',
  'pages.orders.inKoreaDelivery.breadcrumb': '주문관리',
  'pages.orders.inKoreaDelivery.description': '국내 배송중인 주문',
  'pages.orders.inKoreaDelivery.subDescription': '한국 내 배송 진행중인 주문 조회 및 관리',
  'pages.orders.inKoreaDelivery.generalMember': '일반 회원',
  'pages.orders.inKoreaDelivery.businessMember': '사업자 회원',
  'pages.orders.inKoreaDelivery.shipped': '출고완료',
  'pages.orders.inKoreaDelivery.delivering': '배송중',
  'pages.orders.inKoreaDelivery.delayed': '배송지연',
  'pages.orders.inKoreaDelivery.clearFilter': '필터 초기화',
  'pages.orders.inKoreaDelivery.courier': '택배사',
  'pages.orders.inKoreaDelivery.allCouriers': '전체',
  'pages.orders.inKoreaDelivery.cj': 'CJ대한통운',
  'pages.orders.inKoreaDelivery.hanjin': '한진택배',
  'pages.orders.inKoreaDelivery.lotte': '롯데택배',
  'pages.orders.inKoreaDelivery.shipDate': '출고일',
  'pages.orders.inKoreaDelivery.deliveryDate': '배송완료일',

  // Completed (배송완료) Pages
  'pages.orders.completed.title': '배송완료',
  'pages.orders.completed.breadcrumb': '주문관리',
  'pages.orders.completed.description': '배송 완료된 주문',
  'pages.orders.completed.subDescription': '배송이 완료된 주문 조회 및 통계',
  'pages.orders.completed.completedDate': '배송완료일',

  // No Data (노데이타) Pages
  'pages.orders.noData.title': '노데이타',
  'pages.orders.noData.breadcrumb': '주문관리',
  'pages.orders.noData.description': '주문 매칭 관리',
  'pages.orders.noData.subDescription': '미매칭 주문 조회 및 매칭 처리 (일반/사업자 회원)',
  'pages.orders.noData.management': '노데이타 관리',

  // Order Inquiries (주문문의) Pages
  'pages.orders.orderQuestions.title': '주문문의',
  'pages.orders.orderQuestions.breadcrumb': '주문관리',
  'pages.orders.orderQuestions.description': '주문 관련 문의 관리',
  'pages.orders.orderQuestions.subDescription': '주문에 대한 회원 문의 조회 및 답변',
  'pages.orders.orderQuestions.orderNo': '주문번호',
  'pages.orders.orderQuestions.memberNameId': '회원ID / 사서함',
  'pages.orders.orderQuestions.memberManager': '회원담당자',
  'pages.orders.orderQuestions.content': '내용',
  'pages.orders.orderQuestions.writer': '회원명',
  'pages.orders.orderQuestions.status': '확인',
  'pages.orders.orderQuestions.processingStatus': '처리 상태',
  'pages.orders.orderQuestions.statusUnread': '미확인',
  'pages.orders.orderQuestions.statusRead': '처리중',
  'pages.orders.orderQuestions.statusProcessed': '확인 완료',
  'pages.orders.orderQuestions.statusAll': '전체',
  'pages.orders.orderQuestions.searchByUserUniqueId': '사서함',
  'pages.orders.orderQuestions.contentPreview': '상담 내용 미리보기',
  'pages.orders.orderQuestions.preview': '미리보기',
  'pages.orders.orderQuestions.answered': '답변완료',
  'pages.orders.orderQuestions.unanswered': '미답변',
  'pages.orders.orderQuestions.answeredStatus': '답변 상태',
  'pages.orders.orderQuestions.registeredDate': '등록일 / 마지막 메시지 시간',
  'pages.orders.orderQuestions.answerer': '문의답변자',
  'pages.orders.orderQuestions.delete': '삭제',
  'pages.orders.orderQuestions.all': '전체',
  'pages.orders.orderQuestions.searchBy': '검색 기준',
  'pages.orders.orderQuestions.searchByContent': '내용',
  'pages.orders.orderQuestions.searchByOrderNo': '주문번호',
  'pages.orders.orderQuestions.searchByMemberName': '회원명',
  'pages.orders.orderQuestions.searchPlaceholder': '검색어를 입력하세요',
  'pages.orders.orderQuestions.search': '검색',
  'pages.orders.orderQuestions.category': '주문문의',
  'pages.orders.orderQuestions.answerSubmitted': '답변이 등록되었습니다',
  'pages.orders.orderQuestions.messageCount': '메시지 {count}개',
  'pages.orders.orderQuestions.messages': '메시지',
  'pages.orders.orderQuestions.orderNoWithMessages': '주문번호: {orderNumber} (메시지 {count}개)',
  'pages.orders.orderQuestions.unreadMessages': '읽지 않은 메시지 {count}개',
  'pages.orders.orderQuestions.totalItems': '총 {total}건',
  'pages.orders.orderQuestions.member': '회원',
  'pages.orders.orderQuestions.confirmDelete': '문의 삭제',
  'pages.orders.orderQuestions.confirmDeleteDescription': '이 문의를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
  'pages.orders.orderQuestions.deleteSuccess': '문의가 삭제되었습니다',
  'pages.orders.orderQuestions.deleteError': '문의 삭제에 실패했습니다',
  'pages.orders.orderQuestions.cancel': '취소',
  'pages.orders.orderQuestions.processingButton': '처리중',
  'pages.orders.orderQuestions.confirmButton': '확인 완료',
  'pages.orders.orderQuestions.processingStarted': '처리를 시작했습니다',
  'pages.orders.orderQuestions.processingError': '처리 시작에 실패했습니다',
  'pages.orders.orderQuestions.confirmed': '문의 처리가 완료되었습니다',
  'pages.orders.orderQuestions.confirmError': '문의 처리에 실패했습니다',
  'questionModal.edit': '수정',
  'questionModal.delete': '삭제',
  'questionModal.messageDeleted': '메시지가 삭제되었습니다',
  'questionModal.messageDeleteFailed': '메시지 삭제에 실패했습니다',
  'questionModal.messageUpdated': '메시지가 수정되었습니다',
  'questionModal.messageUpdateFailed': '메시지 수정에 실패했습니다',
  'questionModal.editMessagePrompt': '메시지를 수정하세요',
  'questionModal.deleteConfirmTitle': '메시지 삭제',
  'questionModal.deleteConfirmContent': '이 메시지를 삭제하시겠습니까?',
  'questionModal.cancel': '취소',
  'questionModal.editingMessage': '메시지 수정 중…',
  'questionModal.cancelEdit': '수정 취소',
  
  'pages.orders.userRefund.title': '회원 환불 요청',
  'pages.orders.userRefund.orderInfo': '주문 정보',
  'pages.orders.userRefund.priceBreakdown': '가격 분해',
  'pages.orders.userRefund.productPrice': '상품 가격',
  'pages.orders.userRefund.chinaShipping': '중국 운송',
  'pages.orders.userRefund.serviceFee': '서비스 수수료',
  'pages.orders.userRefund.addOnServices': '부가 서비스',
  'pages.orders.userRefund.selectRefundItems': '환불 항목 선택:',
  'pages.orders.userRefund.refundItems': '환불 항목:',
  'pages.orders.userRefund.alwaysRefunded': '(항상 환불됨)',
  'pages.orders.userRefund.refundSummary': '환불 요약',
  'pages.orders.userRefund.productPriceRefund': '상품 가격 환불',
  'pages.orders.userRefund.chinaShippingRefund': '중국 운송 환불',
  'pages.orders.userRefund.serviceFeeRefund': '서비스 수수료 환불',
  'pages.orders.userRefund.totalRefund': '총 환불 금액',

  'pages.orders.platformRefund.title': '플랫폼 환불 요청',
  'pages.orders.platformRefund.orderInfo': '주문 정보',
  'pages.orders.platformRefund.priceBreakdown': '가격 분해',
  'pages.orders.platformRefund.productPrice': '상품 가격',
  'pages.orders.platformRefund.chinaShipping': '중국 운송',
  'pages.orders.platformRefund.serviceFee': '서비스 수수료',
  'pages.orders.platformRefund.addOnServices': '부가 서비스',
  'pages.orders.platformRefund.selectRefundItems': '환불 항목 선택:',
  'pages.orders.platformRefund.refundItems': '환불 항목:',
  'pages.orders.platformRefund.alwaysRefunded': '(항상 환불됨)',
  'pages.orders.platformRefund.refundSummary': '환불 요약',
  'pages.orders.platformRefund.productPriceRefund': '상품 가격 환불',
  'pages.orders.platformRefund.serviceFeeRefund': '서비스 수수료 환불',
  'pages.orders.platformRefund.chinaShippingRefund': '중국 운송 환불',
  'pages.orders.platformRefund.totalRefund': '총 환불 금액',
  'pages.orders.alreadyRefundedExternally.checkbox': '이미 외부에서 환불함 (결제취소·예치금 적립 안 함)',
  'pages.orders.alreadyRefundedExternally.alertTitle': '결제취소도, 예치금 적립도 하지 않습니다',
  'pages.orders.alreadyRefundedExternally.alertDescription': '은행 송금이나 PG 관리자 화면에서 이미 고객에게 환불한 건에만 쓰십시오. 카드 결제취소를 호출하지 않고, 무통장·예치금 결제건은 예치금도 적립되지 않습니다(카드·무통장과 함께 쓴 예치금 몫만 예치금으로 돌려줍니다). 환불 기록·리베이트 차감·재고 복원·상태 변경만 진행됩니다. 무통장 환불을 평소처럼 예치금으로 돌려주려면 체크하지 마십시오.',

  'pages.orders.finalRefund.title': '최종 환불 요청',
  'pages.orders.finalRefund.orderInfo': '주문 정보',
  'pages.orders.finalRefund.priceBreakdown': '가격 분해',
  'pages.orders.finalRefund.paymentType': '결제 유형',
  'pages.orders.finalRefund.paidPrice': '지불 금액',
  'pages.orders.finalRefund.refundPrice': '환불 금액',
  'pages.orders.finalRefund.ratio': '비율 (%)',
  'pages.orders.finalRefund.productPrice': '상품 가격',
  'pages.orders.finalRefund.chinaShipping': '중국 운송 가격',
  'pages.orders.finalRefund.additionalInternational': '추가 국제 운송',
  'pages.orders.finalRefund.secondTierAddOnServices': '두 번째 계층 추가 서비스',
  'pages.orders.finalRefund.serviceFee': '서비스 수수료',
  'pages.orders.finalRefund.addOnServices': '부가 서비스',
  'pages.orders.finalRefund.totalRefund': '총 환불 금액',
  'pages.orders.finalRefund.refundExceedsPaid': '환불 금액은 지불 금액을 초과할 수 없습니다',
  'pages.orders.finalRefund.firstTierPayment': '1차 결제',
  'pages.orders.finalRefund.secondTierPayment': '2차 결제',
  'pages.orders.finalRefund.bundleOrder': '묶음 주문 (H01)',
  'pages.orders.finalRefund.bundleOrderHint': '원본 부모주문별 1차 상품금액·서비스 수수료 환불액을 설정하세요.',
  'pages.orders.finalRefund.noAmountSelected': '환불할 금액을 하나 이상 입력하세요.',
  'pages.orders.finalRefund.noRefundableItems': '환불 가능한 항목이 없습니다.',
  'pages.orders.finalRefund.grandTotal': '환불 합계',
  'pages.orders.finalRefund.executeSuccess': '최종 환불이 실행되었습니다.',
  'pages.orders.refundPayout.failedTitle': '환불 금액이 고객에게 돌아가지 않았습니다',
  'pages.orders.refundPayout.failedBody': '결제사가 취소를 거절해 환불이 \'지급 대기\'로 남았습니다. 상태를 완료로 바꾸지 말고, 사유를 해결한 뒤 환불을 다시 실행하세요. 결제사 관리 화면에서 직접 취소했다면 [외부 선환불]로 기록하세요.',
  'pages.orders.refundPayout.gatewayReason': '결제사 응답',
  'pages.orders.common.exchangeRate': '환율',

  // Inventory Inquiries (재고문의) Pages
  'pages.orders.inventoryQuestions.title': '재고문의',
  'pages.orders.inventoryQuestions.breadcrumb': '주문관리',
  'pages.orders.inventoryQuestions.description': '재고 관련 문의 관리',
  'pages.orders.inventoryQuestions.subDescription': '재고 확인 및 문의 답변 처리',
  'pages.orders.inventoryQuestions.orderNo': '주문번호',
  'pages.orders.inventoryQuestions.memberNameId': '회원명/아이디',
  'pages.orders.inventoryQuestions.memberManager': '회원담당자',
  'pages.orders.inventoryQuestions.content': '내용',
  'pages.orders.inventoryQuestions.writer': '작성자',
  'pages.orders.inventoryQuestions.status': '확인',
  'pages.orders.inventoryQuestions.answered': '답변완료',
  'pages.orders.inventoryQuestions.unanswered': '미답변',
  'pages.orders.inventoryQuestions.registeredDate': '등록일',
  'pages.orders.inventoryQuestions.answerer': '문의답변자',
  'pages.orders.inventoryQuestions.delete': '삭제',
  'pages.orders.inventoryQuestions.all': '전체',
  'pages.orders.inventoryQuestions.searchBy': '검색 기준',
  'pages.orders.inventoryQuestions.searchByContent': '내용',
  'pages.orders.inventoryQuestions.searchByOrderNo': '주문번호',
  'pages.orders.inventoryQuestions.searchByMemberName': '회원명',
  'pages.orders.inventoryQuestions.searchPlaceholder': '검색어를 입력하세요',
  'pages.orders.inventoryQuestions.search': '검색',
  'pages.orders.inventoryQuestions.category': '재고문의',
  'pages.orders.inventoryQuestions.mock.name1': '김철수',
  'pages.orders.inventoryQuestions.mock.name2': '이영희',
  'pages.orders.inventoryQuestions.mock.name3': '박민수',
  'pages.orders.inventoryQuestions.mock.question1': '주문한 제품 재고는 보드는 언제 도착하나요? W823,077',
  'pages.orders.inventoryQuestions.mock.answer1': '재고 확인 결과 11월 25일 입고 예정입니다.',
  'pages.orders.inventoryQuestions.mock.question2': '재고 확인 부탁드립니다.',
  'pages.orders.inventoryQuestions.mock.question3': '상품이 언제쯤 입고될 예정인가요? 빠른 답변 부탁드립니다.',
  'pages.orders.inventoryQuestions.mock.answer3': '해당 상품은 11월 30일 입고 예정입니다.',

  // Additional keys for Completed and NoData pages
  'pages.orders.completed.reviewWritten': '리뷰작성',
  'pages.orders.completed.noReview': '미작성',
  'pages.orders.completed.orderNo': '주문번호',
  'pages.orders.completed.memberName': '회원명',
  'pages.orders.completed.memberType': '구분',
  'pages.orders.completed.receiver': '수취인',
  'pages.orders.completed.contact': '연락처',
  'pages.orders.completed.address': '배송지',
  'pages.orders.completed.trackingNo': '운송장번호',
  'pages.orders.completed.orderAmount': '주문금액',
  'pages.orders.completed.shippingFee': '배송비',
  'pages.orders.completed.deliveryDays': '소요일수',
  'pages.orders.completed.review': '리뷰',
  'pages.orders.completed.rating': '평점',
  'pages.orders.completed.reviewCompleted': '작성완료',
  'pages.orders.completed.actions': '기능',
  'pages.orders.completed.viewDetails': '상세보기',
  'pages.orders.completed.requestReview': '리뷰요청',
  'pages.orders.completed.batchRequestReview': '선택된 {count}건 리뷰요청',
  'pages.orders.completed.excelDownload': '엑셀다운',
  'pages.orders.completed.more': '더보기 ▼',
  'pages.orders.completed.collapse': '접기 ▲',
  'pages.orders.completed.reset': '초기화',
  'pages.orders.completed.search': '검색',
  'pages.orders.completed.total': '총 {total}건',
  'pages.orders.completed.reviewStatus': '리뷰상태',
  'pages.orders.completed.all': '전체',
  'pages.orders.completed.reviewed': '작성완료',
  'pages.orders.completed.noReviewStatus': '미작성',
  'pages.orders.completed.viewAll': '전체 보기',
  'pages.orders.completed.general': '일반',
  'pages.orders.completed.business': '사업자',
  'pages.orders.noData.unmatched': '미매칭',
  'pages.orders.noData.matched': '매칭완료',
  'pages.orders.noData.unlinked': '매칭해제',
  'pages.orders.noData.applicationType': '신청구분',
  'pages.orders.noData.all': '전체',
  'pages.orders.noData.delivery': '배송대행',
  'pages.orders.noData.purchase': '구매대행',
  'pages.orders.noData.registrationDate': '등록일',
  'pages.orders.noData.matchStatus': '매칭상태',
  'pages.orders.noData.product': '제품',
  'pages.orders.noData.image': '이미지',
  'pages.orders.noData.center': '센터',
  'pages.orders.noData.mailbox': '사서함',
  'pages.orders.noData.mailboxNo': '사서함 번호',
  'pages.orders.noData.productName': '상품명',
  'pages.orders.noData.quantity': '수량',
  'pages.orders.noData.codFee': '착불 수수료',
  'pages.orders.noData.weight': '무게',
  'pages.orders.noData.wearer': '착용자',
  'pages.orders.noData.orderNo': '주문번호',
  'pages.orders.noData.orderNumber': '주문번호',
  'pages.orders.noData.registrationDateCol': '등록일자',
  'pages.orders.noData.rackNo': '랙번호',
  'pages.orders.noData.rackNumber': '랙 번호',
  'pages.orders.noData.issue': '문제',
  'pages.orders.noData.issueNoOrderInfo': '주문정보없음',
  'pages.orders.noData.result': '결과',
  'pages.orders.noData.actions': '기능',
  'pages.orders.noData.match': '매칭',
  'pages.orders.noData.unlink': '매칭해제',
  'pages.orders.noData.enterTrackingNumber': '운송장번호 입력',
  'pages.orders.noData.trackingNumberRequired': '운송장번호를 입력해주세요',
  'pages.orders.noData.trackingNumberSaved': '운송장번호가 성공적으로 저장되었습니다',
  'pages.orders.noData.saveError': '운송장번호 저장에 실패했습니다',
  'pages.orders.noData.save': '저장',
  'pages.orders.noData.return': '반환',
  'pages.orders.noData.returnFunctionality': '반환 기능은 구현 예정입니다',
  'pages.orders.noData.recordIdRequired': '기록 ID가 필요합니다',
  'pages.orders.noData.returnedSuccess': '상태가 반환으로 성공적으로 업데이트되었습니다',
  'pages.orders.noData.returnError': '상태를 반환으로 업데이트하는데 실패했습니다',
  'pages.orders.noData.batchMatch': '선택된 {count}건 일괄 매칭',
  'pages.orders.noData.excelDownload': '엑셀다운',
  'pages.orders.noData.more': '더보기 ▼',
  'pages.orders.noData.collapse': '접기 ▲',
  'pages.orders.noData.reset': '초기화',
  'pages.orders.noData.search': '검색',
  'pages.orders.noData.total': '총 {total}건',
  'pages.orders.noData.refresh': '새로고침',
  'pages.orders.noData.viewAll': '전체 보기',
  'pages.orders.noData.previewImage': '확대보기',
  'pages.orders.noData.general': '일반',
  'pages.orders.noData.business': '사업자',
  'pages.orders.noData.memberName': '회원명',
  'pages.orders.noData.trackingNo': '트래킹번호',
  // 'pages.orders.inKoreaDelivery.shipped': '출고완료',
  'pages.orders.inKoreaDelivery.viewAll': '전체 보기',
  'pages.orders.inKoreaDelivery.trackDelivery': '배송조회',
  'pages.orders.inKoreaDelivery.viewDetails': '상세보기',
  'pages.orders.inKoreaDelivery.deliveryStatus': '배송상태',
  'pages.orders.inKoreaDelivery.shippedDate': '출고일시',
  'pages.orders.inKoreaDelivery.estimatedArrival': '예상도착',
  'pages.orders.inKoreaDelivery.receiver': '수령인',
  'pages.orders.inKoreaDelivery.address': '배송지',
  'pages.orders.inKoreaDelivery.courierTracking': '택배사/운송장번호',
  'pages.orders.inKoreaDelivery.orderNo': '주문번호',
  'pages.orders.inKoreaDelivery.memberName': '회원명',
  'pages.orders.inKoreaDelivery.memberType': '구분',
  'pages.orders.inKoreaDelivery.contact': '연락처',
  'pages.orders.inKoreaDelivery.trackingNo': '운송장번호',
  'pages.orders.inKoreaDelivery.actions': '기능',
  'pages.orders.inKoreaDelivery.batchTrack': '선택된 {count}건 일괄 조회',
  'pages.orders.inKoreaDelivery.excelDownload': '엑셀다운',
  'pages.orders.inKoreaDelivery.more': '더보기 ▼',
  'pages.orders.inKoreaDelivery.collapse': '접기 ▲',
  'pages.orders.inKoreaDelivery.reset': '초기화',
  'pages.orders.inKoreaDelivery.search': '검색',
  'pages.orders.inKoreaDelivery.total': '총 {total}건',
  'pages.orders.inKoreaDelivery.general': '일반',
  'pages.orders.inKoreaDelivery.business': '사업자',

  // Coupons Page
  'pages.members.coupons.title': '쿠폰 관리',
  'pages.members.coupons.couponList': '쿠폰 목록',
  'pages.members.coupons.usageHistory': '발급/사용 내역',
  'pages.members.coupons.totalCoupons': '전체 쿠폰',
  'pages.members.coupons.activeCoupons': '활성 쿠폰',
  'pages.members.coupons.issuedCoupons': '발급된 쿠폰',
  'pages.members.coupons.usedCoupons': '사용된 쿠폰',
  'pages.members.coupons.id': 'ID',
  'pages.members.coupons.couponName': '쿠폰명',
  'pages.members.coupons.couponCode': '쿠폰 코드',
  'pages.members.coupons.discountType': '할인 유형',
  'pages.members.coupons.discountTypeFixed': '정액',
  'pages.members.coupons.discountTypePercent': '정률',
  'pages.members.coupons.discountAmount': '할인 금액',
  'pages.members.coupons.minOrderAmount': '최소 주문금액',
  'pages.members.coupons.usageStatus': '사용 현황',
  'pages.members.coupons.usagePercent': '% 사용',
  'pages.members.coupons.validPeriod': '유효 기간',
  'pages.members.coupons.status': '상태',
  'pages.members.coupons.statusActive': '활성',
  'pages.members.coupons.statusInactive': '비활성',
  'pages.members.coupons.statusExpired': '만료',
  'pages.members.coupons.createdAt': '등록일',
  'pages.members.coupons.actions': '작업',
  'pages.members.coupons.issue': '발급',
  'pages.members.coupons.edit': '수정',
  'pages.members.coupons.delete': '삭제',
  'pages.members.coupons.memberInfo': '회원 정보',
  'pages.members.coupons.orderNo': '주문번호',
  'pages.members.coupons.usedAt': '사용일시',
  'pages.members.coupons.statusUsed': '사용완료',
  'pages.members.coupons.statusUnused': '미사용',
  'pages.members.coupons.excelDownload': '엑셀 다운로드',
  'pages.members.coupons.createCoupon': '쿠폰 생성',
  'pages.members.coupons.deleteConfirm': '쿠폰 삭제',
  'pages.members.coupons.deleteContent': '"{name}" 쿠폰을 삭제하시겠습니까?',
  'pages.members.coupons.deleted': '쿠폰이 삭제되었습니다',
  'pages.members.coupons.updated': '쿠폰이 수정되었습니다',
  'pages.members.coupons.created': '쿠폰이 생성되었습니다',
  'pages.members.coupons.issued': '쿠폰이 발급되었습니다',
  'pages.members.coupons.issuedSuccess': '쿠폰이 성공적으로 발급되었습니다. 발급: {issued}, 건너뜀: {skipped}',
  'pages.members.coupons.issueFailed': '쿠폰 발급에 실패했습니다',
  'pages.members.coupons.modalEdit': '쿠폰 수정',
  'pages.members.coupons.modalCreate': '쿠폰 생성',
  'pages.members.coupons.nameLabel': '쿠폰명',
  'pages.members.coupons.nameRequired': '쿠폰명을 입력하세요',
  'pages.members.coupons.namePlaceholder': '예: 신규회원 환영 쿠폰',
  'pages.members.coupons.codeLabel': '쿠폰 코드',
  'pages.members.coupons.codeRequired': '쿠폰 코드를 입력하세요',
  'pages.members.coupons.codePlaceholder': '예: WELCOME2025',
  'pages.members.coupons.typeLabel': '할인 유형',
  'pages.members.coupons.typeFixed': '정액 할인',
  'pages.members.coupons.typePercent': '정률 할인 (%)',
  'pages.members.coupons.discountValueLabel': '할인 금액/비율',
  'pages.members.coupons.minOrderAmountLabel': '최소 주문금액',
  'pages.members.coupons.maxDiscountAmountLabel': '최대 할인금액 (선택)',
  'pages.members.coupons.validPeriodLabel': '유효 기간',
  'pages.members.coupons.validPeriodRequired': '유효 기간을 선택하세요',
  'pages.members.coupons.totalCountLabel': '발급 수량',
  'pages.members.coupons.descriptionLabel': '쿠폰 설명',
  'pages.members.coupons.descriptionPlaceholder': '쿠폰에 대한 설명을 입력하세요',
  'pages.members.coupons.statusLabel': '상태',
  'pages.members.coupons.statusActiveText': '활성',
  'pages.members.coupons.statusInactiveText': '비활성',
  'pages.members.coupons.issueModalTitle': '쿠폰 발급 - {name}',
  'pages.members.coupons.targetTypeLabel': '발급 대상',
  'pages.members.coupons.targetTypeAll': '전체 회원',
  'pages.members.coupons.targetTypeLevel': '등급별',
  'pages.members.coupons.memberLevelLabel': '회원 등급',
  'pages.members.coupons.targetTypeSpecific': '특정 회원',
  'pages.members.coupons.memberIdsLabel': '회원 선택',
  'pages.members.coupons.memberIdsRequired': '최소 한 명의 회원을 선택하세요',
  'pages.members.coupons.memberIdsPlaceholder': '이메일 또는 전화번호로 회원 검색 및 선택',
  'pages.members.coupons.messageLabel': '발송 메시지 (선택)',
  'pages.members.coupons.messagePlaceholder': '쿠폰 발급 시 전송할 메시지',
  'pages.members.coupons.currency': '원',
  'pages.members.coupons.unit': '개',
  'pages.members.coupons.couponIdLabel': '쿠폰 ID',
  'pages.members.coupons.couponIdTooltip': '각 쿠폰 세트마다 고유 ID가 생성됩니다',
  'pages.members.coupons.couponIdPlaceholder': '자동 생성 (예: COUPON_SET_000001)',
  'pages.members.coupons.validityDaysLabel': '쿠폰 유효 기간(일)',
  'pages.members.coupons.validityDaysTooltip': '쿠폰 유효 기간을 일 단위로 입력하세요',
  'pages.members.coupons.validityDaysPlaceholder': '일 수를 입력하세요',
  'pages.members.coupons.days': '일',
  'pages.members.coupons.remainingQuantity': '남은 수량',
  'pages.members.coupons.usedCountLabel': '이미 사용된 쿠폰 수량',
  'pages.members.coupons.issuanceMethod': '발급 방식',
  'pages.members.coupons.issuanceMethodLabel': '발급 방식',
  'pages.members.coupons.issuanceMethodTooltip': '쿠폰 배포 방식을 선택하세요: 회원 발급, 시스템 발급, 가입 보너스',
  'pages.members.coupons.issuanceMethodUser': '회원 청구',
  'pages.members.coupons.issuanceMethodSystem': '시스템 배포',
  'pages.members.coupons.issuanceMethodSignup': '등록 및 쿠폰 수령',
  'pages.members.coupons.signupCouponIdLabel': '가입 완료 후 쿠폰 ID',
  'pages.members.coupons.signupCouponIdTooltip': '가입 완료 후 어떤 쿠폰을 지급할지 선택합니다. 쿠폰 ID를 입력할 수 있습니다.',
  'pages.members.coupons.signupCouponIdPlaceholder': '가입 후 지급할 쿠폰 ID를 입력하세요',
  'pages.members.coupons.distributionEnabledLabel': '배포 시스템 쿠폰',
  'pages.members.coupons.distributionEnabledTooltip': '시스템 내에서 특정 유형의 쿠폰을 균등하게 배포하도록 선택할 수 있습니다',
  'pages.members.coupons.enabled': '활성화',
  'pages.members.coupons.disabled': '비활성화',
  'pages.members.coupons.issueButtonTooltipUser': '선택한 회원에게 이 쿠폰을 수동으로 발급합니다',
  'pages.members.coupons.issueButtonTooltipSystem': '선택한 회원에게 이 쿠폰을 발급합니다',
  'pages.members.coupons.issueModalSystemHelp': '시스템 쿠폰: 모든 회원 또는 특정 회원에게 이 쿠폰을 발급할 수 있습니다.',
  'pages.members.coupons.issueModalUserHelp': '회원 쿠폰: 이 쿠폰은 수동으로 발급해야 합니다. 아래에서 대상 회원를 선택하세요.',
  'pages.members.coupons.issueToAll': '모든 회원에게 발급',
  'pages.members.coupons.issueToAllTooltip': '모든 회원에게 자동으로 이 쿠폰을 발급합니다',
  'pages.members.coupons.issueToAllConfirm': '모든 회원에게 발급',
  'pages.members.coupons.issueToAllContent': '"{name}"을(를) 모든 회원에게 발급하시겠습니까?',
  'pages.members.coupons.issuedToAll': '"{name}" 쿠폰이 모든 회원에게 발급되었습니다',

  // Points Page
  'pages.members.points.title': '포인트 내역',
  'pages.members.points.totalEarned': '총 적립 포인트',
  'pages.members.points.totalUsed': '총 사용 포인트',
  'pages.members.points.currentBalance': '현재 보유 포인트',
  'pages.members.points.expiringThisMonth': '이번 달 소멸 예정',
  'pages.members.points.memberInfo': '회원 정보',
  'pages.members.points.memberId': '회원 ID',
  'pages.members.points.type': '구분',
  'pages.members.points.typeEarn': '적립',
  'pages.members.points.typeUse': '사용',
  'pages.members.points.typeExpire': '소멸',
  'pages.members.points.typeAdmin': '관리자',
  'pages.members.points.points': '포인트',
  'pages.members.points.balance': '잔액',
  'pages.members.points.reason': '사유',
  'pages.members.points.content': '내용',
  'pages.members.points.orderNo': '주문번호',
  'pages.members.points.processedAt': '처리일시',
  'pages.members.points.dateRange': '처리 기간',
  'pages.members.points.expiryDate': '만료일',
  'pages.members.points.processor': '처리자',
  'pages.members.points.excelDownload': '엑셀 다운로드',
  'pages.members.points.addPoints': '포인트 지급',
  'pages.members.points.paid': '포인트가 지급되었습니다',
  'pages.members.points.modalTitle': '포인트 지급',
  'pages.members.points.memberIdLabel': '회원 ID',
  'pages.members.points.memberIdRequired': '회원 ID를 입력하세요',
  'pages.members.points.memberIdPlaceholder': '회원 ID 또는 이메일',
  'pages.members.points.typeLabel': '구분',
  // 'pages.members.points.typeAdmin': '관리자 지급',
  // 'pages.members.points.typeEarn': '적립',
  'pages.members.points.typeDeduct': '차감',
  'pages.members.points.amountLabel': '포인트',
  'pages.members.points.amountRequired': '포인트를 입력하세요',
  'pages.members.points.amountPlaceholder': '0',
  'pages.members.points.reasonLabel': '사유',
  'pages.members.points.reasonRequired': '사유를 입력하세요',
  'pages.members.points.reasonPlaceholder': '포인트 지급/차감 사유를 입력하세요',
  'pages.members.points.expiryDateLabel': '만료일 (선택)',
  'pages.members.points.unit': 'P',
  // Points Record Table Columns
  'pages.members.points.column.id': 'ID',
  'pages.members.points.column.memberName': '회원 이름',
  'pages.members.points.column.mailbox': '사서함',
  'pages.members.points.column.orderNumber': '주문번호',
  'pages.members.points.column.paymentDetails': '결제 상세',
  'pages.members.points.column.pointsBeforeChange': '변경 전 포인트',
  'pages.members.points.column.pointsUsed': '사용 포인트',
  'pages.members.points.column.pointsReceived': '적립 포인트',
  'pages.members.points.column.pointsAfterChange': '변경 후 포인트',
  'pages.members.points.column.pointsCurrencyExchangeRate': '포인트·통화 환율',
  'pages.members.points.column.pointsCurrencyExchangeAmount': '포인트·통화 환산 금액',
  'pages.members.points.column.time': '시간',

  'pages.helpCenter.title': '헬프센터',
  'pages.helpCenter.subTitle': '웹사이트 도움말 및 콘텐츠 관리',
  'pages.helpCenter.tabs.guides': '가이드',
  'pages.helpCenter.tabs.faqs': 'FAQ',
  'pages.helpCenter.tabs.payWith': '결제 수단',
  'pages.helpCenter.tabs.socialLinks': '소셜 링크',
  'pages.helpCenter.tabs.viewHelp': '도움말 보기',
  'pages.helpCenter.tabs.footer': '푸터 정보',
  'pages.helpCenter.columns.order': '순서',
  'pages.helpCenter.columns.chapter': '챕터',
  'pages.helpCenter.columns.subChapterCount': '서브챕터 수',
  'pages.helpCenter.columns.actions': '작업',
  'pages.helpCenter.columns.question': '질문',
  'pages.helpCenter.columns.category': '카테고리',
  'pages.helpCenter.columns.image': '이미지',
  'pages.helpCenter.columns.title': '제목',
  'pages.helpCenter.columns.description': '설명',
  'pages.helpCenter.columns.platform': '플랫폼',
  'pages.helpCenter.columns.url': 'URL',
  'pages.helpCenter.columns.content': '내용',
  'pages.helpCenter.columns.name': '이름',
  'pages.helpCenter.columns.value': '값',
  'pages.helpCenter.columns.visible': '표시',
  'pages.helpCenter.buttons.addGuide': '가이드 추가',
  'pages.helpCenter.buttons.manageCategory': '카테고리 관리',
  'pages.helpCenter.buttons.addFAQ': 'FAQ 추가',
  'pages.helpCenter.buttons.addPayWith': '결제 수단 추가',
  'pages.helpCenter.buttons.addSocialLink': '소셜 링크 추가',
  'pages.helpCenter.buttons.addViewHelpContent': '도움말 콘텐츠 추가',
  'pages.helpCenter.buttons.editFooter': '푸터 정보 수정',
  'pages.helpCenter.buttons.edit': '수정',
  'pages.helpCenter.buttons.delete': '삭제',
  'pages.helpCenter.buttons.addCategory': '카테고리 추가',
  'pages.helpCenter.buttons.addSubChapter': '서브챕터 추가',
  'pages.helpCenter.buttons.save': '저장',
  'pages.helpCenter.buttons.cancel': '취소',
  'pages.helpCenter.modals.guide.add': '가이드 추가',
  'pages.helpCenter.modals.guide.edit': '가이드 수정',
  'pages.helpCenter.modals.category.manage': '카테고리 관리',
  'pages.helpCenter.modals.category.add': '카테고리 추가',
  'pages.helpCenter.modals.category.edit': '카테고리 수정',
  'pages.helpCenter.modals.viewHelpContent.add': '도움말 콘텐츠 추가',
  'pages.helpCenter.modals.viewHelpContent.edit': '도움말 콘텐츠 수정',
  'pages.helpCenter.modals.faq.add': 'FAQ 추가',
  'pages.helpCenter.modals.faq.edit': 'FAQ 수정',
  'pages.helpCenter.modals.payWith.add': '결제 수단 추가',
  'pages.helpCenter.modals.payWith.edit': '결제 수단 수정',
  'pages.helpCenter.modals.socialLink.add': '소셜 링크 추가',
  'pages.helpCenter.modals.socialLink.edit': '소셜 링크 수정',
  'pages.helpCenter.modals.footer.edit': '푸터 정보 수정',
  'pages.helpCenter.forms.chapter': '챕터',
  'pages.helpCenter.forms.chapterRequired': '챕터를 입력하세요',
  'pages.helpCenter.forms.chapterPlaceholder': '챕터 제목',
  'pages.helpCenter.forms.order': '순서',
  'pages.helpCenter.forms.orderRequired': '순서를 입력하세요',
  'pages.helpCenter.forms.orderPlaceholder': '순서',
  'pages.helpCenter.forms.chapterContent': '챕터 내용',
  'pages.helpCenter.forms.chapterContentTooltip': '서브챕터가 없으면 챕터에 직접 내용을 입력할 수 있습니다',
  'pages.helpCenter.forms.chapterContentPlaceholder': '챕터 내용을 입력하세요',
  'pages.helpCenter.forms.subChapters': '서브챕터 (선택사항)',
  'pages.helpCenter.forms.subChaptersHint': '서브챕터를 추가하면 챕터 내용 필드가 숨겨집니다',
  'pages.helpCenter.forms.subChapterTitle': '서브챕터 제목',
  'pages.helpCenter.forms.subChapterTitleRequired': '서브챕터 제목을 입력하세요',
  'pages.helpCenter.forms.subChapterTitlePlaceholder': '서브챕터 제목',
  'pages.helpCenter.forms.subChapterContent': '서브챕터 내용',
  'pages.helpCenter.forms.subChapterContentRequired': '서브챕터 내용을 입력하세요',
  'pages.helpCenter.forms.subChapterContentPlaceholder': '서브챕터 내용',
  'pages.helpCenter.forms.categoryName': '카테고리 이름',
  'pages.helpCenter.forms.categoryNameRequired': '카테고리 이름을 입력하세요',
  'pages.helpCenter.forms.categoryNamePlaceholder': '예: 주문/구매',
  'pages.helpCenter.forms.categoryValue': '카테고리 값 (영문)',
  'pages.helpCenter.forms.categoryValueRequired': '카테고리 값을 입력하세요',
  'pages.helpCenter.forms.categoryValuePlaceholder': '예: order',
  'pages.helpCenter.forms.question': '질문',
  'pages.helpCenter.forms.questionRequired': '질문을 입력하세요',
  'pages.helpCenter.forms.questionPlaceholder': '질문',
  'pages.helpCenter.forms.answer': '답변',
  'pages.helpCenter.forms.answerRequired': '답변을 입력하세요',
  'pages.helpCenter.forms.answerPlaceholder': '답변',
  'pages.helpCenter.forms.category': '카테고리',
  'pages.helpCenter.forms.categoryRequired': '카테고리를 선택하세요',
  'pages.helpCenter.forms.categoryPlaceholder': '카테고리 선택',
  'pages.helpCenter.forms.title': '제목',
  'pages.helpCenter.forms.titleRequired': '제목을 입력하세요',
  'pages.helpCenter.forms.titlePlaceholder': '결제 수단 제목',
  'pages.helpCenter.forms.description': '설명',
  'pages.helpCenter.forms.descriptionRequired': '설명을 입력하세요',
  'pages.helpCenter.forms.descriptionPlaceholder': '설명',
  'pages.helpCenter.forms.iconUrl': '아이콘 URL',
  'pages.helpCenter.forms.iconUrlPlaceholder': '아이콘 URL (선택사항)',
  'pages.helpCenter.forms.platform': '플랫폼',
  'pages.helpCenter.forms.platformPlaceholder': '플랫폼 이름 (예: Facebook, Twitter)',
  'pages.helpCenter.forms.url': 'URL',
  'pages.helpCenter.forms.urlPlaceholder': 'https://...',
  'pages.helpCenter.forms.viewHelpTitlePlaceholder': '도움말 제목',
  'pages.helpCenter.forms.content': '내용',
  'pages.helpCenter.forms.contentRequired': '내용을 입력하세요',
  'pages.helpCenter.forms.visible': '표시 여부',
  'pages.helpCenter.messages.deleteConfirm': '삭제하시겠습니까?',
  'pages.helpCenter.messages.noImage': '없음',
  'pages.helpCenter.messages.currentFooterInfo': '현재 푸터 정보',
  'pages.helpCenter.messages.categoryList': 'FAQ 카테고리 목록',
  'pages.helpCenter.footer.companyName': '회사명',
  'pages.helpCenter.footer.representative': '대표',
  'pages.helpCenter.footer.address': '주소',
  'pages.helpCenter.footer.businessNumber': '사업자번호',
  'pages.helpCenter.footer.communicationNumber': '통신판매번호',
  'pages.helpCenter.footer.phone': '전화',
  'pages.helpCenter.footer.email': '이메일',
  'pages.helpCenter.footer.complaintContact': '민원 담당자 연락처',
  'pages.helpCenter.footer.serviceDescription': '서비스 설명',
  'pages.helpCenter.footer.paymentDescription': '결제 설명',
  'pages.helpCenter.footer.companyNamePlaceholder': '주식회사 타오익스프레스',
  'pages.helpCenter.footer.representativePlaceholder': '대표 유두성',
  'pages.helpCenter.footer.addressPlaceholder': '강남구 논현로151길 41, 3052호',
  'pages.helpCenter.footer.businessNumberPlaceholder': '730-88-03052',
  'pages.helpCenter.footer.communicationNumberPlaceholder': '제2023-서울강남-04824호',
  'pages.helpCenter.footer.phonePlaceholder': '070-7792-6663',
  'pages.helpCenter.footer.emailPlaceholder': 'taoexpress_1@163.com',
  'pages.helpCenter.footer.complaintContactPlaceholder': '070-7792-6663',
  'pages.helpCenter.footer.serviceDescriptionPlaceholder': '사이트내에서 판매되는 상품에 대하여 배송 환불 민원 이슈 등은 타오익스프레스에서 처리하며 모든 책임은 타오익스프레스에 있습니다 - 민원 담당자 연락처: 070-7792-6663',
  'pages.helpCenter.footer.paymentDescriptionPlaceholder': '다양한 은행의 신용카드와 체크카드를 지원하여 충전과 결제가 가능합니다. 도움말 보기',
  'pages.helpCenter.footer.showHideOptions': '표시/숨김 옵션',
  'pages.helpCenter.footer.showCompanyName': '회사명 표시',
  'pages.helpCenter.footer.showRepresentative': '대표 표시',
  'pages.helpCenter.footer.showAddress': '주소 표시',
  'pages.helpCenter.footer.showBusinessNumber': '사업자번호 표시',
  'pages.helpCenter.footer.showCommunicationNumber': '통신판매번호 표시',
  'pages.helpCenter.footer.showPhone': '전화번호 표시',
  'pages.helpCenter.footer.showEmail': '이메일 표시',
  'pages.helpCenter.footer.showComplaintContact': '민원 담당자 표시',
  'pages.helpCenter.footer.showServiceDescription': '서비스 설명 표시',
  'pages.helpCenter.footer.showPaymentDescription': '결제 설명 표시',
  'pages.helpCenter.footer.showViewHelp': '도움말 보기 표시',
  'pages.helpCenter.footer.whatIsTodayMall': 'TodayMall이란',
  'pages.helpCenter.footer.whatIsTodayMallPlaceholder': 'TodayMall에 대한 설명을 입력하세요',
  'pages.helpCenter.footer.whatIsTodayMallRequired': 'TodayMall 설명을 입력하세요',
  'pages.helpCenter.footer.showWhatIsTodayMall': 'TodayMall 설명 표시',
  'pages.helpCenter.footer.companyTagline': '회사 슬로건',
  'pages.helpCenter.footer.companyTaglinePlaceholder': '회사 슬로건을 입력하세요 (예: 온라인 쇼핑의 최고의 선택)',
  'pages.helpCenter.footer.companyTaglineRequired': '회사 슬로건을 입력하세요',
  'pages.helpCenter.footer.showCompanyTagline': '회사 슬로건 표시',
  'pages.helpCenter.footer.companyIntroduction': '회사 소개',
  'pages.helpCenter.footer.companyIntroductionPlaceholder': '회사 소개를 입력하세요',
  'pages.helpCenter.footer.companyIntroductionRequired': '회사 소개를 입력하세요',
  'pages.helpCenter.footer.showCompanyIntroduction': '회사 소개 표시',
  'pages.helpCenter.footer.sections.companyInfo': '회사 정보',
  'pages.helpCenter.footer.sections.contactInfo': '연락처 정보',
  'pages.helpCenter.footer.sections.descriptions': '설명',
  'pages.helpCenter.footer.sections.viewHelp': '도움말 보기',
  'pages.helpCenter.footer.companyNameRequired': '회사명을 입력하세요',
  'pages.helpCenter.footer.representativeRequired': '대표를 입력하세요',
  'pages.helpCenter.footer.addressRequired': '주소를 입력하세요',
  'pages.helpCenter.footer.businessNumberRequired': '사업자번호를 입력하세요',
  'pages.helpCenter.footer.communicationNumberRequired': '통신판매번호를 입력하세요',
  'pages.helpCenter.footer.phoneRequired': '전화번호를 입력하세요',
  'pages.helpCenter.footer.emailRequired': '이메일을 입력하세요',
  'pages.helpCenter.languages.korean': '한국어',
  'pages.helpCenter.languages.english': 'English',
  'pages.helpCenter.languages.chinese': '中文',
  'pages.helpCenter.placeholders.koreanInput': '한국어로 입력하세요',
  'pages.helpCenter.placeholders.englishInput': 'Enter in English',
  'pages.helpCenter.placeholders.chineseInput': '请输入中文',
  'pages.helpCenter.placeholders.koreanHTML': '한국어로 HTML 내용을 입력하세요...',
  'pages.helpCenter.placeholders.englishHTML': 'Enter HTML content in English...',
  'pages.helpCenter.placeholders.chineseHTML': '请输入中文HTML内容...',
  'pages.helpCenter.tooltips.bold': '굵게',
  'pages.helpCenter.tooltips.italic': '기울임',
  'pages.helpCenter.tooltips.underline': '밑줄',
  'pages.helpCenter.tooltips.alignLeft': '왼쪽 정렬',
  'pages.helpCenter.tooltips.alignCenter': '가운데 정렬',
  'pages.helpCenter.tooltips.alignRight': '오른쪽 정렬',
  'pages.helpCenter.tooltips.orderedList': '번호 목록',
  'pages.helpCenter.tooltips.unorderedList': '글머리 목록',
  'pages.helpCenter.messages.footerLoadFailed': '푸터 정보를 불러오는데 실패했습니다',
  'pages.helpCenter.messages.viewHelpSaved': '도움말 보기 내용이 저장되었습니다',
  'pages.helpCenter.messages.viewHelpSaveFailed': '도움말 보기 내용 저장에 실패했습니다',
  'pages.helpCenter.messages.viewHelpLoadFailed': '도움말 보기 내용을 불러오는데 실패했습니다',
  'pages.helpCenter.messages.guideDeleted': '가이드가 삭제되었습니다',
  'pages.helpCenter.messages.guideDeleteFailed': '가이드 삭제에 실패했습니다',
  'pages.helpCenter.messages.guideUpdated': '가이드가 수정되었습니다',
  'pages.helpCenter.messages.guideAdded': '가이드가 추가되었습니다',
  'pages.helpCenter.messages.guideSaveFailed': '가이드 저장에 실패했습니다',
  'pages.helpCenter.messages.categoryDeleteFailed': '카테고리 삭제에 실패했습니다',
  'pages.helpCenter.messages.categorySaveFailed': '카테고리 저장에 실패했습니다',
  'pages.helpCenter.messages.categoryLoadFailed': '카테고리를 불러오는데 실패했습니다',
  'pages.helpCenter.messages.faqDeleted': 'FAQ가 삭제되었습니다',
  'pages.helpCenter.messages.faqDeleteFailed': 'FAQ 삭제에 실패했습니다',
  'pages.helpCenter.messages.faqUpdated': 'FAQ가 수정되었습니다',
  'pages.helpCenter.messages.faqAdded': 'FAQ가 추가되었습니다',
  'pages.helpCenter.messages.faqSaveFailed': 'FAQ 저장에 실패했습니다',
  'pages.helpCenter.messages.faqLoadFailed': 'FAQ를 불러오는데 실패했습니다',
  'pages.helpCenter.messages.paymentMethodDeleted': '결제 수단이 삭제되었습니다',
  'pages.helpCenter.messages.paymentMethodDeleteFailed': '결제 수단 삭제에 실패했습니다',
  'pages.helpCenter.messages.paymentMethodUpdated': '결제 수단이 수정되었습니다',
  'pages.helpCenter.messages.paymentMethodAdded': '결제 수단이 추가되었습니다',
  'pages.helpCenter.messages.paymentMethodSaveFailed': '결제 수단 저장에 실패했습니다',
  'pages.helpCenter.messages.paymentMethodLoadFailed': '결제 수단을 불러오는데 실패했습니다',
  'pages.helpCenter.messages.paymentMethodStatusUpdated': '결제 수단 상태가 업데이트되었습니다',
  'pages.helpCenter.messages.socialLinkDeleted': '소셜 링크가 삭제되었습니다',
  'pages.helpCenter.messages.socialLinkDeleteFailed': '소셜 링크 삭제에 실패했습니다',
  'pages.helpCenter.messages.socialLinkUpdated': '소셜 링크가 수정되었습니다',
  'pages.helpCenter.messages.socialLinkAdded': '소셜 링크가 추가되었습니다',
  'pages.helpCenter.messages.socialLinkSaveFailed': '소셜 링크 저장에 실패했습니다',
  'pages.helpCenter.messages.socialLinkLoadFailed': '소셜 링크를 불러오는데 실패했습니다',
  'pages.helpCenter.messages.socialLinkStatusUpdated': '소셜 링크 상태가 업데이트되었습니다',
  'pages.helpCenter.messages.footerSaved': '푸터 정보가 저장되었습니다',
  'pages.helpCenter.messages.footerSaveFailed': '푸터 정보 저장에 실패했습니다',
  'pages.helpCenter.messages.guideStatusUpdated': '가이드 상태가 업데이트되었습니다',
  'pages.helpCenter.messages.faqStatusUpdated': 'FAQ 상태가 업데이트되었습니다',
  'pages.helpCenter.messages.statusUpdateFailed': '상태 업데이트에 실패했습니다',
  'pages.helpCenter.messages.guideLoadFailed': '가이드를 불러오는데 실패했습니다',
  'pages.helpCenter.forms.viewHelpContent': '도움말 보기 내용',
  'pages.helpCenter.forms.viewHelpContentRequired': '도움말 보기 내용을 입력하세요',
  'pages.helpCenter.forms.viewHelpContentPlaceholder': '도움말 보기 내용을 입력하세요 (HTML 지원)',
  'pages.helpCenter.forms.preview': '미리보기',
  'pages.helpCenter.forms.enterContent': '내용을 입력하세요',
  'pages.helpCenter.forms.titleMinOneLanguage': '제목을 최소 한 언어로 입력하세요',
  'pages.helpCenter.forms.descriptionMinOneLanguage': '설명을 최소 한 언어로 입력하세요',
  'pages.helpCenter.forms.platformRequired': '플랫폼을 입력하세요',
  'pages.helpCenter.forms.urlRequired': 'URL을 입력하세요',
  'pages.helpCenter.footer.complaintContactRequired': '민원 담당자 연락처를 입력하세요',
  'pages.helpCenter.footer.serviceDescriptionRequired': '서비스 설명을 입력하세요',
  'pages.helpCenter.footer.paymentDescriptionRequired': '결제 설명을 입력하세요',

  // Administrators page
  'pages.administrators.title': '관리자 관리',
  'pages.administrators.id': 'ID',
  'pages.administrators.adminInfo': '관리자 정보',
  'pages.administrators.name': '이름',
  'pages.administrators.email': '이메일',
  'pages.administrators.role': '역할',
  'pages.administrators.role.superadmin': '최고 관리자',
  'pages.administrators.role.admin': '관리자',
  'pages.administrators.role.manager': '매니저',
  'pages.administrators.role.staff': '직원',
  'pages.administrators.status': '상태',
  'pages.administrators.status.active': '활성',
  'pages.administrators.status.inactive': '비활성',
  'pages.administrators.status.locked': '잠김',
  'pages.administrators.lastLogin': '마지막 로그인',
  'pages.administrators.createdAt': '생성일',
  'pages.administrators.actions': '작업',
  'pages.administrators.detail': '상세',
  'pages.administrators.edit': '수정',
  'pages.administrators.password': '비밀번호',
  'pages.administrators.deactivate': '비활성화',
  'pages.administrators.activate': '활성화',
  'pages.administrators.delete': '삭제',
  'pages.administrators.totalAdmins': '전체 관리자',
  'pages.administrators.activeAccounts': '활성 계정',
  'pages.administrators.inactiveAccounts': '비활성 계정',
  'pages.administrators.superAdmins': '최고 관리자',
  'pages.administrators.list': '관리자 목록',
  'pages.administrators.add': '관리자 추가',
  'pages.administrators.adminIdNotFound': '관리자 ID를 찾을 수 없습니다',
  'pages.administrators.deleteConfirm': '관리자 삭제',
  'pages.administrators.deleteConfirmMessage': '{name} 관리자를 삭제하시겠습니까?',
  'pages.administrators.deleteKeepsLogs': '계정은 목록에서 사라지고 로그인할 수 없게 됩니다. 이 계정의 작업 로그와 처리 기록은 지워지지 않고 그대로 남습니다.',
  'pages.administrators.permissions': '권한',
  'pages.administrators.selectAll': '전체 선택',
  'pages.administrators.deselectAll': '전체 해제',
  'pages.administrators.selected': '선택됨',
  'pages.administrators.permissionsSection.todaymallCore': '투데이몰 핵심',
  'pages.administrators.permissionsSection.storehouse': '창고 및 물류',
  'pages.administrators.permissionsSection.settlement': '정산',
  'pages.administrators.permissionsSection.customerService': '회원 서비스',
  'pages.administrators.permissionsSection.system': '시스템',
  'pages.administrators.permissions.orders': '주문 관리',
  'pages.administrators.permissions.users': '회원 관리',
  'pages.administrators.permissions.products': '상품 관리',
  'pages.administrators.permissions.categories': '카테고리 관리',
  'pages.administrators.permissions.warehouses': '창고 관리',
  'pages.administrators.permissions.racks': '랙 관리',
  'pages.administrators.permissions.packages': '패키지 관리',
  'pages.administrators.permissions.warehouse-transactions': '창고 거래 조회',
  'pages.administrators.permissions.activity-logs': '활동 로그',
  'pages.administrators.permissions.settlement': '정산 관리',
  'pages.administrators.permissions.help-center': '회원센터 관리',
  'pages.administrators.permissions.banners': '배너 관리',
  'pages.administrators.permissions.content': '콘텐츠 관리',
  'pages.administrators.permissions.general-inquiry': '일반 문의 관리',
  'pages.administrators.permissions.system': '시스템 관리',
  'pages.administrators.noPermissions': '권한이 없습니다',
  'pages.administrators.close': '닫기',
  'pages.administrators.passwordReset': '비밀번호 재설정',
  'pages.administrators.currentPassword': '현재 비밀번호',
  'pages.administrators.newPassword': '새 비밀번호',
  'pages.administrators.confirmPassword': '비밀번호 확인',
  'pages.administrators.passwordMismatch': '비밀번호가 일치하지 않습니다',
  'pages.administrators.incorrectCurrentPassword': '현재 비밀번호가 올바르지 않습니다',
  'pages.administrators.permissionsMismatch': '경고: {sent}개의 권한을 전송했지만 {returned}개를 받았습니다. 백엔드에서 수정했을 수 있습니다.',
  'pages.administrators.form.passwordRequired': '비밀번호를 입력하세요',
  'pages.administrators.form.passwordPlaceholder': '비밀번호',
  'pages.administrators.form.nameRequired': '이름을 입력하세요',
  'pages.administrators.form.namePlaceholder': '이름',
  'pages.administrators.form.emailRequired': '이메일을 입력하세요',
  'pages.administrators.form.emailInvalid': '유효한 이메일을 입력하세요',
  'pages.administrators.form.emailPlaceholder': '이메일',
  'pages.administrators.form.newPasswordRequired': '새 비밀번호를 입력하세요',
  'pages.administrators.form.newPasswordPlaceholder': '새 비밀번호',
  'pages.administrators.form.confirmPasswordRequired': '비밀번호를 다시 입력하세요',
  'pages.administrators.form.confirmPasswordPlaceholder': '비밀번호 확인',
  'pages.administrators.form.passwordMinLength': '비밀번호는 최소 8자 이상이어야 합니다',
  'pages.administrators.form.currentPasswordRequired': '현재 비밀번호를 입력하세요',
  'pages.administrators.form.currentPasswordPlaceholder': '현재 비밀번호',
  'pages.administrators.form.rolePlaceholder': '역할 선택',
  'pages.administrators.addMember': '소관자 계정 등록',
  'pages.administrators.memberCode': '회원코드',
  'pages.administrators.memberLevel': '회원등급',
  'pages.administrators.memberName': '회원명',
  'pages.administrators.userId': 'ID',
  'pages.administrators.centerInCharge': '담당센터',
  'pages.administrators.registrationDate': '등록일자',
  'pages.administrators.accessRights': '접근권한',
  'pages.administrators.deleteConfirmContent': '이 관리자를 삭제하시겠습니까?',
  'pages.administrators.modal.title': 'Edit member information',
  'pages.administrators.modal.userId': 'id',
  'pages.administrators.modal.memberName': 'name',
  'pages.administrators.modal.memberLevel': 'Administrator level',
  'pages.administrators.modal.password': 'password',
  'pages.administrators.modal.centerInCharge': 'Center in charge',
  'pages.administrators.accessRightsModal.title': 'Modify access permissions',
  'pages.administrators.accessRightsModal.selectAll': 'Select All',
  'pages.administrators.accessRightsModal.accessRights': 'Access rights',
  'pages.administrators.accessRightsModal.menu.agency': 'Agency Comprehensive Management (101)',
  'pages.administrators.accessRightsModal.menu.rocket': 'Rocket Order Management (116)',
  'pages.administrators.accessRightsModal.menu.trade': 'Trade Services (113)',
  'pages.administrators.accessRightsModal.menu.payment': 'Payment agency service (115)',
  
  // New granular permission structure
  'pages.administrators.selectAllSection': '이 섹션 전체 선택',
  'pages.administrators.clearAllSection': '이 섹션 전체 해제',
  'pages.administrators.pageName': '페이지 이름',
  'pages.administrators.viewPermission': '조회',
  'pages.administrators.editPermission': '수정',
  
  // Sections
  'pages.administrators.sections.operation': '운영 관리',
  'pages.administrators.sections.orders': '주문 관리',
  'pages.administrators.sections.storehouse': '창고 관리',
  'pages.administrators.sections.logistics': '물류 관리',
  'pages.administrators.sections.members': '회원 관리',
  'pages.administrators.sections.settlement': '정산 관리',
  'pages.administrators.sections.customerService': '회원 서비스',
  'pages.administrators.sections.system': '시스템 관리',
  
  // Pages
  'pages.administrators.pages.operationData': '운영 데이터',
  'pages.administrators.pages.categories': '카테고리 관리',
  'pages.administrators.pages.companyMall': '자사몰',
  'pages.administrators.pages.liveSellers': '라이브 판매자',
  'pages.administrators.pages.couponPointSettings': '쿠폰/포인트 설정',
  'pages.administrators.pages.rebateSettings': '리베이트 설정',
  'pages.administrators.pages.searchManagement': '검색 관리',
  'pages.administrators.pages.orderStatistics': '주문 통계',
  'pages.administrators.pages.userOrders': '회원 주문',
  'pages.administrators.pages.pendingPayment': '결제 대기',
  'pages.administrators.pages.orderQuestions': '주문 문의',
  'pages.administrators.pages.inspectionList': '검수 목록',
  'pages.administrators.pages.rackManagement': '랙 관리',
  'pages.administrators.pages.warehouseAddress': '창고 주소',
  'pages.administrators.pages.waybillInformations': '운송장 정보',
  'pages.administrators.pages.waybillBandwidth': '운송장 대역폭',
  'pages.administrators.pages.transportationMethods': '운송 방법',
  'pages.administrators.pages.regionalManagement': '지역 관리',
  'pages.administrators.pages.internationalTracking': '국제 추적 번호',
  'pages.administrators.pages.hsProductCode': 'HS 상품 코드',
  'pages.administrators.pages.memberStatistics': '회원 통계',
  'pages.administrators.pages.generalMembers': '일반 회원',
  'pages.administrators.pages.promotionDetail': '프로모션 상세',
  'pages.administrators.pages.settlementManagement': '정산 관리',
  'pages.administrators.pages.memberRechargeReview': '회원 충전 검토',
  'pages.administrators.pages.memberWithdrawalReview': '회원 출금 검토',
  'pages.administrators.pages.financialRecords': '재무 기록',
  'pages.administrators.pages.deposit': '입금',
  'pages.administrators.pages.coupons': '쿠폰',
  'pages.administrators.pages.oneToOneInquiry': '1:1 문의',
  'pages.administrators.pages.notices': '공지사항',
  'pages.administrators.pages.suggestion': '제안',
  'pages.administrators.pages.review': '리뷰',
  'pages.administrators.pages.helpCenter': '회원센터',
  'pages.administrators.pages.bannerEvent': '배너/이벤트',
  'pages.administrators.pages.administrators': '관리자',
  'pages.administrators.pages.exchangeTariffSetting': '환율/관세 설정',
  'pages.administrators.pages.purchaseConditionSetting': '구매 조건 설정',
  'pages.administrators.pages.workerLog': '작업자 로그',
  'pages.administrators.pages.productPriceIncrease': '상품 가격 인상',
  
  // Friendly date formats
  'pages.administrators.justNow': '방금 전',
  'pages.administrators.minutesAgo': '{count}분 전',
  'pages.administrators.hoursAgo': '{count}시간 전',
  'pages.administrators.daysAgo': '{count}일 전',
  'pages.administrators.monthsAgo': '{count}개월 전',
  'pages.administrators.yearsAgo': '{count}년 전',
  
  // Individual permission labels
  'pages.roles.ordersread': '주문 조회',
  'pages.roles.orderswrite': '주문 수정',
  'pages.roles.ordersdelete': '주문 삭제',
  'pages.roles.ordersfulfill': '주문 처리',
  'pages.roles.ordersinquiry': '주문 문의 처리',
  'pages.roles.usersread': '회원 조회',
  'pages.roles.userswrite': '회원 수정',
  'pages.roles.usersdelete': '회원 삭제',
  'pages.roles.productsread': '상품 조회',
  'pages.roles.productswrite': '상품 등록',
  'pages.roles.productswriteedit': '상품 수정',
  'pages.roles.productsdelete': '상품 삭제',
  'pages.roles.productssync': '상품 동기화',
  'pages.roles.categoriesread': '카테고리 조회',
  'pages.roles.categorieswrite': '카테고리 수정',
  'pages.roles.categoriesdelete': '카테고리 삭제',
  'pages.roles.warehousesread': '창고 조회',
  'pages.roles.warehouseswrite': '창고 수정',
  'pages.roles.racksread': '랙 조회',
  'pages.roles.rackswrite': '랙 수정',
  'pages.roles.packagesread': '패키지 조회',
  'pages.roles.packageswrite': '패키지 수정',
  'pages.roles.warehousetransactionsread': '창고 거래 조회',
  'pages.roles.activitylogsread': '활동 로그 조회',
  'pages.roles.settlementread': '정산 조회',
  'pages.roles.settlementwrite': '정산 처리',
  'pages.roles.helpcenterread': '회원센터 조회',
  'pages.roles.helpcenterwrite': '회원센터 수정',
  'pages.roles.helpcenterdelete': '회원센터 삭제',
  'pages.roles.bannersread': '배너 조회',
  'pages.roles.bannerswrite': '배너 수정',
  'pages.roles.bannersdelete': '배너 삭제',
  'pages.roles.contentwrite': '콘텐츠 수정',
  'pages.roles.contentdelete': '콘텐츠 삭제',
  'pages.roles.generalinquiry': '일반 문의 처리',
  'pages.roles.adminsread': '관리자 조회',
  'pages.roles.adminswrite': '관리자 수정',
  'pages.roles.adminsdelete': '관리자 삭제',
  'pages.roles.permissionsmanage': '권한 관리',
  'pages.roles.settingsread': '설정 조회',
  'pages.roles.settingswrite': '설정 수정',
  'pages.administrators.createSuccess': '관리자가 추가되었습니다',
  'pages.administrators.createFailed': '관리자 추가에 실패했습니다',
  'pages.administrators.updateSuccess': '관리자 정보가 수정되었습니다',
  'pages.administrators.updateFailed': '관리자 수정에 실패했습니다',
  'pages.administrators.deleteSuccess': '관리자가 삭제되었습니다',
  'pages.administrators.deleteFailed': '관리자 삭제에 실패했습니다',
  'pages.administrators.phone': '전화번호',
  'pages.administrators.username': '회원명',
  'pages.administrators.usernamePlaceholder': 'admin001',
  'pages.administrators.usernameRequired': '회원명을 입력하세요',
  'pages.administrators.department': '부서',
  'pages.administrators.department.management': '경영지원',
  'pages.administrators.department.sales': '영업',
  'pages.administrators.department.cs': '회원지원',
  'pages.administrators.department.logistics': '물류',
  'pages.administrators.department.it': 'IT',
  'pages.administrators.departmentPlaceholder': '부서 선택',
  'pages.administrators.newThisMonth': '이번 달 신규',
  'pages.administrators.detailTitle': '관리자 상세',
  'pages.administrators.basicInfo': '기본 정보',
  'pages.administrators.passwordChange': '비밀번호 (변경 시에만 입력)',
  'pages.administrators.passwordChangePlaceholder': '비밀번호를 변경하려면 입력하세요',
  'pages.administrators.rolePlaceholder': '역할 선택',
  'pages.administrators.statusActive': '활성',
  'pages.administrators.statusInactive': '비활성',
  'pages.administrators.mock.name': '홍길동',
  'pages.admins.adminIdNotFound': '관리자 ID를 찾을 수 없습니다',
  'pages.admins.deleteAdmin': '관리자 삭제',
  'pages.admins.deleteAdminContent': '"{name}" 관리자를 삭제하시겠습니까?',
  'pages.admins.resetPassword': '비밀번호 재설정',
  'pages.admins.resetPasswordContent': '"{name}" 관리자의 비밀번호를 재설정하시겠습니까?',
  'pages.admins.resetPasswordSuccess': '비밀번호가 재설정되었습니다',
  'pages.admins.adminInfo': '관리자 정보',
  'pages.admins.email': '이메일',
  'pages.admins.role': '역할',
  'pages.admins.role.superadmin': '최고관리자',
  'pages.admins.role.admin': '관리자',
  'pages.admins.role.manager': '매니저',
  'pages.admins.role.staff': '직원',
  'pages.admins.department': '부서',
  'pages.admins.department.management': '경영지원',
  'pages.admins.department.sales': '영업',
  'pages.admins.department.cs': '회원지원',
  'pages.admins.department.logistics': '물류',
  'pages.admins.department.it': 'IT',
  'pages.admins.status': '상태',
  'pages.admins.status.active': '활성',
  'pages.admins.status.inactive': '비활성',
  'pages.admins.lastLogin': '최근 로그인',
  'pages.admins.createdAt': '등록일',
  'pages.admins.actions': '작업',
  'pages.admins.detail': '상세',
  'pages.admins.edit': '수정',
  'pages.admins.delete': '삭제',

  // Rates page
  'pages.rates.title': '환율/관세 설정',
  'pages.rates.currentExchangeRate': '현재 환율 (해외직구 위안화)',
  'pages.rates.basicTariffRate': '기본 관세율',
  'pages.rates.vatRate': '부가세율',
  'pages.rates.exchangeRateInfo': '환율 및 관세 안내',
  'pages.rates.exchangeRateInfoDesc': '환율은 매일 자동으로 업데이트되며, 수동으로 조정할 수 있습니다. 관세율은 상품 카테고리별로 다르게 적용될 수 있습니다.',
  'pages.rates.exchangeRateSettings': '환율 설정',
  'pages.rates.tariffSettings': '관세 설정',
  'pages.rates.exchangeRateHistory': '환율 변동 내역',
  'pages.rates.date': '날짜',
  'pages.rates.rate': '환율',
  'pages.rates.change': '변동',
  'pages.rates.cny': '해외직구 위안화 (CNY)',
  'pages.rates.cnyLive': '라이브 위안화 (CNY)',
  'pages.rates.cnyOwnmall': '자사몰 위안화 (CNY)',
  'pages.rates.cnySegmentHint': '라이브·자사몰 환율은 새로 등록하거나 원가를 고친 상품, 그리고 새 주문부터 적용됩니다. 이미 등록된 상품의 원가는 바뀌지 않습니다.',
  'pages.rates.cnyLiveShort': '라이브',
  'pages.rates.cnyOwnmallShort': '자사몰',
  'pages.rates.usd': '달러 (USD)',
  'pages.rates.jpy': '엔화 (JPY)',
  'pages.rates.eur': '유로 (EUR)',
  'pages.rates.basicTariff': '기본 관세율',
  'pages.rates.vat': '부가세율 (VAT)',
  'pages.rates.specialTariff': '특별 관세율 (전자제품)',
  'pages.rates.luxuryTariff': '사치품 관세율',
  'pages.rates.reset': '초기화',
  'pages.rates.save': '저장',
  'pages.rates.saveSuccess': '환율 및 관세 설정이 저장되었습니다',
  'pages.rates.saveError': '환율 저장에 실패했습니다',
  'pages.rates.loadError': '환율을 불러오는데 실패했습니다',
  'pages.rates.noRatesToUpdate': '업데이트할 환율이 없습니다',
  'pages.rates.rateRequired': '환율을 입력하세요',
  'pages.rates.saveExchangeRates': '환율 저장',
  'pages.rates.saveTariff': '관세 설정 저장',
  'pages.rates.resetTariff': '관세 설정 초기화',
  'pages.rates.noTariffToUpdate': '업데이트할 관세율이 없습니다',
  'pages.rates.tariffSaveSuccess': '관세 설정이 저장되었습니다',
  'pages.rates.tariffSaveError': '관세 설정 저장에 실패했습니다',

  // Additional Cost Settings page
  'pages.settings.additionalCost.title': '추가 비용 설정',
  'pages.settings.additionalCost.description': '주문에 적용될 추가 비용을 설정합니다',
  'pages.settings.additionalCost.simplifiedCustomsClearance': '간이통관 비용 (₩)',
  'pages.settings.additionalCost.simplifiedCustomsClearanceRequired': '간이통관 비용을 입력하세요',
  'pages.settings.additionalCost.designatedShooting': '지정촬영 비용 (₩)',
  'pages.settings.additionalCost.designatedShootingRequired': '지정촬영 비용을 입력하세요',
  'pages.settings.additionalCost.saveSuccess': '설정이 저장되었습니다',
  'pages.settings.additionalCost.saveFailed': '설정 저장에 실패했습니다',

  // Purchase Condition Settings page
  'pages.purchaseConditionSettings.title': '구매 조건 설정',
  'pages.purchaseConditionSettings.limitPrice.title': '가격 제한',
  'pages.purchaseConditionSettings.limitPrice.label': '자동 구매 가격 제한 (원)',
  'pages.purchaseConditionSettings.limitPrice.required': '가격 제한을 입력하세요',
  'pages.purchaseConditionSettings.limitPrice.min': '가격 제한은 0 이상이어야 합니다',
  'pages.purchaseConditionSettings.limitPrice.tooltip': '이 금액 이상의 주문은 수동 구매로 처리됩니다',
  'pages.purchaseConditionSettings.limitPrice.description': '주문 금액이 이 값 이상이면 자동 구매 대신 수동 구매로 처리됩니다.',
  'pages.purchaseConditionSettings.userMemo.title': '회원 메모 상태',
  'pages.purchaseConditionSettings.userMemo.enabled': '회원 메모 기반 조건 활성화',
  'pages.purchaseConditionSettings.userMemo.keywords': '키워드 (쉼표로 구분)',
  'pages.purchaseConditionSettings.userMemo.keywordsTooltip': '이 키워드가 포함된 회원 메모가 있는 주문은 수동 구매로 처리됩니다',
  'pages.purchaseConditionSettings.userMemo.keywordsPlaceholder': '예: urgent, important, check',
  'pages.purchaseConditionSettings.userMemo.description': '회원 메모에 지정된 키워드가 포함되어 있으면 수동 구매로 처리됩니다.',
  'pages.purchaseConditionSettings.sensitiveProducts.title': '민감 상품 목록',
  'pages.purchaseConditionSettings.sensitiveProducts.add': '민감 상품 추가',
  'pages.purchaseConditionSettings.sensitiveProducts.empty': '민감 상품이 없습니다',
  'pages.purchaseConditionSettings.sensitiveProducts.description': '이 목록에 등록된 상품은 자동 구매 대신 수동 구매로 처리됩니다.',
  'pages.purchaseConditionSettings.table.productName': '상품명',
  'pages.purchaseConditionSettings.table.productId': '상품 ID',
  'pages.purchaseConditionSettings.table.url': 'URL',
  'pages.purchaseConditionSettings.table.reason': '사유',
  'pages.purchaseConditionSettings.modal.addTitle': '민감 상품 추가',
  'pages.purchaseConditionSettings.modal.editTitle': '민감 상품 수정',
  'pages.purchaseConditionSettings.modal.productName': '상품명',
  'pages.purchaseConditionSettings.modal.productNameRequired': '상품명을 입력하세요',
  'pages.purchaseConditionSettings.modal.productId': '상품 ID',
  'pages.purchaseConditionSettings.modal.url': '상품 URL',
  'pages.purchaseConditionSettings.modal.reason': '사유',
  'pages.purchaseConditionSettings.saveSuccess': '구매 조건 설정이 저장되었습니다',
  'pages.purchaseConditionSettings.saveError': '구매 조건 설정 저장에 실패했습니다',
  'pages.purchaseConditionSettings.productAdded': '민감 상품이 추가되었습니다',
  'pages.purchaseConditionSettings.productUpdated': '민감 상품이 수정되었습니다',
  'pages.purchaseConditionSettings.productDeleted': '민감 상품이 삭제되었습니다',
  'pages.purchaseConditionSettings.deleteConfirm': '이 민감 상품을 삭제하시겠습니까?',
  'pages.purchaseConditionSettings.amountThreshold.title': '금액 임계값',
  'pages.purchaseConditionSettings.amountThreshold.label': '자동 구매 금액 임계값 (원)',
  'pages.purchaseConditionSettings.amountThreshold.currentValue': '현재 값',
  'pages.purchaseConditionSettings.amountThreshold.required': '금액 임계값을 입력하세요',
  'pages.purchaseConditionSettings.amountThreshold.min': '금액 임계값은 0 이상이어야 합니다',
  'pages.purchaseConditionSettings.amountThreshold.tooltip': '이 금액 이상의 주문은 수동 구매로 처리됩니다',
  'pages.purchaseConditionSettings.amountThreshold.description': '주문 금액이 이 값 이상이면 자동 구매 대신 수동 구매로 처리됩니다.',
  'pages.purchaseConditionSettings.memoKeywords.title': '메모 키워드',
  'pages.purchaseConditionSettings.memoKeywords.label': '메모 키워드',
  'pages.purchaseConditionSettings.memoKeywords.tooltip': '이 키워드가 포함된 메모가 있는 주문은 수동 구매로 처리됩니다',
  'pages.purchaseConditionSettings.memoKeywords.placeholder': '키워드를 입력하고 Enter를 누르거나 추가 버튼을 클릭하세요',
  'pages.purchaseConditionSettings.memoKeywords.empty': '키워드가 없습니다',
  'pages.purchaseConditionSettings.memoKeywords.description': '메모에 지정된 키워드가 포함되어 있으면 수동 구매로 처리됩니다.',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.title': '민감 상품 오퍼 ID',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.label': '민감 상품 오퍼 ID',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.tooltip': '이 오퍼 ID가 포함된 주문은 수동 구매로 처리됩니다',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.placeholder': '오퍼 ID를 입력하고 Enter를 누르거나 추가 버튼을 클릭하세요',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.empty': '오퍼 ID가 없습니다',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.description': '이 목록에 등록된 오퍼 ID가 포함된 주문은 자동 구매 대신 수동 구매로 처리됩니다.',
  'pages.purchaseConditionSettings.info.title': '설정 정보',
  'pages.purchaseConditionSettings.info.lastUpdatedBy': '최종 수정자',
  'pages.purchaseConditionSettings.info.updatedAt': '최종 수정일시',
  'pages.purchaseConditionSettings.loadError': '설정을 불러오는데 실패했습니다',

  // Shipping Rate page
  'pages.shippingRate.title': '배송비요율',
  'pages.shippingRate.registrationButton': '배송비요율 등록',
  'pages.shippingRate.deleteCenterPlaceholder': '= 센터별 요율 삭제',
  'pages.shippingRate.deleteButton': '삭제',
  'pages.shippingRate.deleteConfirm': '이 센터의 모든 요율을 삭제하시겠습니까?',
  'pages.shippingRate.deleteSuccess': '요율이 성공적으로 삭제되었습니다',
  'pages.shippingRate.deleteError': '요율 삭제에 실패했습니다',
  'pages.shippingRate.selectCenterToDelete': '삭제할 센터를 선택해주세요',
  'pages.shippingRate.weight': '무게',
  'pages.shippingRate.basicMember': '기본 회원',
  'pages.shippingRate.shippingAgencyVIP': '배송대행 VIP',
  'pages.shippingRate.shippingAgencySVIP': '배송대행 SVIP',
  'pages.shippingRate.purchasingAgent': '구매대행',
  'pages.shippingRate.vipPurchasingAgent': 'VIP 구매대행',
  'pages.shippingRate.ttBusinessOperator': 'TT 사업자',
  'pages.shippingRate.ttVIP': 'TT VIP',
  'pages.shippingRate.ttIndividual': 'TT 개인',
  'pages.shippingRate.registrationModalTitle': '배송비요율 등록',
  'pages.shippingRate.centerShippingMethod': '센터/운송방식',
  'pages.shippingRate.centerRequired': '센터/운송방식을 선택해주세요',
  'pages.shippingRate.selectCenter': '= 선택',
  'pages.shippingRate.membershipLevel': '회원등급',
  'pages.shippingRate.membershipLevelRequired': '회원등급을 선택해주세요',
  'pages.shippingRate.selectMembershipLevel': '= 선택',
  'pages.shippingRate.startEndWeight': '시작 ~ 종료무게',
  'pages.shippingRate.startWeight': '시작 무게',
  'pages.shippingRate.endWeight': '종료 무게',
  'pages.shippingRate.startWeightRequired': '시작 무게를 입력해주세요',
  'pages.shippingRate.endWeightRequired': '종료 무게를 입력해주세요',
  'pages.shippingRate.weightInterval': '무게간격',
  'pages.shippingRate.weightIntervalRequired': '무게간격을 선택해주세요',
  'pages.shippingRate.selectWeightInterval': '무게간격 선택',
  'pages.shippingRate.startingAmount': '시작금액',
  'pages.shippingRate.startingAmountRequired': '시작금액을 입력해주세요',
  'pages.shippingRate.amountInterval': '금액간격',
  'pages.shippingRate.amountIntervalRequired': '금액간격을 입력해주세요',
  'pages.shippingRate.registrationSuccess': '배송비요율이 성공적으로 등록되었습니다',
  'pages.shippingRate.registrationError': '배송비요율 등록에 실패했습니다',
  'pages.shippingRate.updateSuccess': '배송비요율이 성공적으로 수정되었습니다',
  'pages.shippingRate.updateError': '배송비요율 수정에 실패했습니다',
  'pages.shippingRate.deleteRuleConfirm': '이 배송비요율 규칙을 삭제하시겠습니까?',
  'pages.shippingRate.editModalTitle': '배송비요율 규칙 수정',
  'pages.shippingRate.noData': '등록된 요율이 없습니다',
  'pages.shippingRate.selectRoute': '편집/삭제할 경로 선택',
  'pages.shippingRate.route.weihaiShip': '중국/위해/선박',
  'pages.shippingRate.route.weihaiAir': '중국/위해/항공',
  'pages.shippingRate.route.qingdaoShip': '중국/청도/선박',
  'pages.shippingRate.route.qingdaoAir': '중국/청도/항공',
  'pages.shippingRate.route.guangzhouShip': '중국/광저우/선박',
  'pages.shippingRate.route.guangzhouAir': '중국/광저우/항공',

  // Roles page
  'pages.roles.title': '권한 관리',
  'pages.roles.list': '역할 목록',
  'pages.roles.add': '역할 추가',
  'pages.roles.edit': '역할 수정',
  'pages.roles.delete': '역할 삭제',
  'pages.roles.id': 'ID',
  'pages.roles.name': '역할명',
  'pages.roles.code': '역할 코드',
  'pages.roles.description': '설명',
  'pages.roles.userCount': '회원 수',
  'pages.roles.permissionCount': '권한 수',
  'pages.roles.status': '상태',
  'pages.roles.createdAt': '등록일',
  'pages.roles.actions': '작업',
  'pages.roles.permissionSettings': '권한 설정',
  'pages.roles.ordersManagement': '주문 관리',
  'pages.roles.ordersView': '주문 조회',
  'pages.roles.ordersEdit': '주문 수정',
  'pages.roles.ordersDelete': '주문 삭제',
  'pages.roles.membersManagement': '회원 관리',
  'pages.roles.membersView': '회원 조회',
  'pages.roles.membersEdit': '회원 수정',
  'pages.roles.membersDelete': '회원 삭제',
  'pages.roles.productsManagement': '상품 관리',
  'pages.roles.productsView': '상품 조회',
  'pages.roles.productsCreate': '상품 등록',
  'pages.roles.productsEdit': '상품 수정',
  'pages.roles.productsDelete': '상품 삭제',
  'pages.roles.settlementManagement': '정산 관리',
  'pages.roles.settlementView': '정산 조회',
  'pages.roles.settlementProcess': '정산 처리',
  'pages.roles.systemManagement': '시스템 관리',
  'pages.roles.systemAdmins': '관리자 관리',
  'pages.roles.systemRoles': '권한 관리',
  'pages.roles.systemSettings': '시스템 설정',
  'pages.roles.status.active': '활성',
  'pages.roles.status.inactive': '비활성',
  'pages.roles.form.nameRequired': '역할명을 입력하세요',
  'pages.roles.form.codeRequired': '역할 코드를 입력하세요',
  'pages.roles.form.namePlaceholder': '예: 관리자',
  'pages.roles.form.codePlaceholder': '예: ADMIN',
  'pages.roles.form.descriptionPlaceholder': '역할에 대한 설명을 입력하세요',
  'pages.roles.deleteConfirm': '역할 삭제',
  'pages.roles.deleteConfirmMessage': '"{name}" 역할을 삭제하시겠습니까?',
  'pages.roles.deleteSuccess': '역할이 삭제되었습니다',
  'pages.roles.updateSuccess': '역할이 수정되었습니다',
  'pages.roles.createSuccess': '역할이 추가되었습니다',
  'pages.roles.unit.people': '명',
  'pages.roles.unit.items': '개',
  'pages.roles.mock.superAdmin': '최고관리자',
  'pages.roles.mock.superAdminDesc': '모든 권한을 가진 최고 관리자',
  'pages.roles.mock.admin': '관리자',
  'pages.roles.mock.adminDesc': '대부분의 관리 권한을 가진 관리자',
  'pages.roles.mock.manager': '매니저',
  'pages.roles.mock.managerDesc': '주문 및 회원 관리 권한',
  'pages.roles.mock.csStaff': 'CS 담당자',
  'pages.roles.mock.csStaffDesc': '회원 지원 관련 권한',

  // Additional permission keys
  'pages.roles.dashboard': '대시보드',
  'pages.roles.dashboardView': '대시보드 조회',
  'pages.roles.todaymall': 'TodayMall',
  'pages.roles.todayggigu': 'TodayGgigu',
  'pages.roles.permissionView': '조회만',
  'pages.roles.permissionEdit': '수정',
  'pages.roles.productsCategory': '카테고리 관리',
  'pages.roles.productsImport': '타오바오 상품 가져오기',
  'pages.roles.ordersUser': '일반 주문',
  'pages.roles.ordersBusiness': '사업자 주문',
  'pages.roles.ordersVvic': 'VVIC 주문',
  'pages.roles.ordersRocket': '로켓 주문',
  'pages.roles.ordersPendingPayment': '결제 대기',
  'pages.roles.ordersPendingAddress': '주소 대기',
  'pages.roles.ordersInChinaWarehouse': '중국 창고',
  'pages.roles.ordersInKoreaDelivery': '한국 배송',
  'pages.roles.ordersCompleted': '완료된 주문',
  'pages.roles.ordersNoData': '데이터 없음',
  'pages.roles.ordersQuestions': '주문 문의',
  'pages.roles.ordersInventoryQuestions': '재고 문의',
  'pages.roles.membersGeneral': '일반 회원',
  'pages.roles.membersBusiness': '사업자 회원',
  'pages.roles.membersBlacklist': '블랙리스트 회원',
  'pages.roles.membersCoupons': '쿠폰 관리',
  'pages.roles.membersCouponPointSettings': '쿠폰 포인트 설정',
  'pages.roles.membersPoints': '포인트 관리',
  'pages.roles.membersRebate': '리베이트 관리',
  'pages.roles.membersDeposit': '예치금 관리',
  'pages.roles.storehouseManagement': '창고 관리',
  'pages.roles.storehouseView': '창고 조회',
  'pages.roles.storehouseExpressInspection': '택배 검수',
  'pages.roles.storehouseNonMasterCourier': '비마스터 택배',
  'pages.roles.storehouseInspectionList': '검수 목록',
  'pages.roles.storehouseRack': '랙 관리',
  'pages.roles.storehouseWarehouseAddress': '창고 주소',
  'pages.roles.logisticsManagement': '물류 관리',
  'pages.roles.logisticsView': '물류 조회',
  'pages.roles.logisticsBatchTracking': '일괄 추적',
  'pages.roles.logisticsForwarders': '포워더',
  'pages.roles.logisticsShippingRate': '배송비 규칙',
  'pages.roles.logisticsInternationalTracking': '국제 추적',
  'pages.roles.settlementSellers': '판매자 정산',
  'pages.roles.settlementPlatform': '플랫폼 정산',
  'pages.roles.settlementCoupons': '쿠폰 정산',
  'pages.roles.settlementPriceIncrease': '가격 상승',
  'pages.roles.settlementServiceFee': '서비스 수수료',
  'pages.roles.csManagement': '회원센터 관리',
  'pages.roles.csView': '회원센터 조회',
  'pages.roles.csInquiries': '문의 관리',
  'pages.roles.csNotices': '공지사항',
  'pages.roles.csLookingForOwner': '주인 찾기',
  'pages.roles.csReviews': '리뷰 관리',
  'pages.roles.csHelp': '도움말 센터',
  'pages.roles.csBanners': '배너 관리',
  'pages.roles.csEmailManagement': '이메일 관리',
  'pages.roles.systemRates': '환율 관리',
  'pages.roles.systemPurchaseCondition': '구매 조건 설정',
  'pages.roles.systemShippingRate': '배송비 설정',

  // System Settings page
  'pages.systemSettings.title': '시스템 관리',
  'pages.systemSettings.breadcrumb.system': '시스템',
  'pages.systemSettings.breadcrumb.settings': '시스템 관리',
  'pages.systemSettings.tab.admins': '관리자 계정',
  'pages.systemSettings.tab.roles': '권한 관리',
  'pages.systemSettings.admins.title': '관리자 계정 관리',
  'pages.systemSettings.admins.description': '관리자 추가, 수정, 삭제 및 권한 설정',
  'pages.systemSettings.roles.title': '역할 및 권한 관리',
  'pages.systemSettings.roles.description': '역할 생성 및 권한 할당',

  // Notification Icon
  'pages.notification.title': '알림',
  'pages.notification.orderInquiryMessage': '새로운 주문 문의 메시지가 도착했습니다.',
  'pages.notification.generalInquiryMessage': '새로운 1:1 문의 메시지가 도착했습니다.',
  'pages.notification.orderInquiries': '주문문의',
  'pages.notification.generalInquiries': '1:1 문의',
  'pages.notification.inventoryInquiries': '재고문의',
  'pages.notification.depositApplication': '입금신청',
  'pages.notification.bankTransferPayment': '무통장입금',
  'pages.notification.unit.items': '건',
  'pages.notification.clickToView': '클릭하여 보기',

  // Additional Cost Modal
  'pages.additionalCost.title': '■ 대행추가비용 등록',
  'pages.additionalCost.save': '저장',
  'pages.additionalCost.close': '닫기',
  'pages.additionalCost.saveSuccess': '추가비용이 저장되었습니다',
  'pages.additionalCost.orderInfo': '주문정보',
  'pages.additionalCost.orderNumberMemberName': '주문번호 / 회원명',
  'pages.additionalCost.center': '센터',
  'pages.additionalCost.additionalCost': '추가비용',
  'pages.additionalCost.vvicCost': 'VVIC 추가비용',
  'pages.additionalCost.purchaseCost': '구매대행 추가비용',
  'pages.additionalCost.shippingCost': '배송대행 추가비용',
  'pages.additionalCost.saved': '추가비용이 저장되었습니다',
  'pages.additionalCost.productInformation': '상품정보',
  'pages.additionalCost.productNo': '상품번호',
  'pages.additionalCost.productName': '상품명',
  'pages.additionalCost.image': '이미지',
  'pages.additionalCost.quantity': '수량',
  'pages.additionalCost.trackingNumber': '트래킹번호',
  'pages.additionalCost.status': '상태',
  'pages.additionalCost.customsClearance': '목록통관',
  'pages.additionalCost.actualInspection': '실사',
  'pages.additionalCost.viewActualInspection': '실사보기',
  'pages.additionalCost.adminMemo': '관리자 메모',
  'pages.additionalCost.additionalServices': '부가서비스',
  'pages.additionalCost.boxCount': '박스 수',
  'pages.additionalCost.box': 'Box',
  'pages.additionalCost.appliedExchangeRate': '적용환율',
  'pages.additionalCost.totalAmount': '총금액',
  'pages.additionalCost.totalQuantityAmount': '총 수량 / 총금액',
  'pages.additionalCost.items': '개',
  'pages.additionalCost.recipientAddress': '수취인 주소',
  'pages.additionalCost.destination': '대한민국 - 인천',
  'pages.additionalCost.smsNotSend': 'SMS 발송안함',
  'pages.additionalCost.smsSend': 'SMS 발송',

  // Barcode Scan Modal
  'pages.barcodeScan.title.receiving': '입고스캔',
  'pages.barcodeScan.title.rackAssignment': '랙지정',
  'pages.barcodeScan.warehouse.guangzhou': '광저우',
  'pages.barcodeScan.warehouse.weihai': '위해',
  'pages.barcodeScan.warehouse.qingdao': '청도',
  'pages.barcodeScan.warehouse.yiwu': '이우',
  'pages.barcodeScan.rackSize.small': '소',
  'pages.barcodeScan.rackSize.medium': '중',
  'pages.barcodeScan.rackSize.large': '대',
  'pages.barcodeScan.trackingNumber': '트래킹번호',
  'pages.barcodeScan.trackingNumberPlaceholder': '트래킹번호',
  'pages.barcodeScan.depositAmount': '착불금 (元)',
  'pages.barcodeScan.orderNumber': '주문번호',
  'pages.barcodeScan.orderNumberLabel': '주문번호 :',
  'pages.barcodeScan.rackNumber': '랙번호',
  'pages.barcodeScan.changeRack': '변경랙',
  'pages.barcodeScan.receivedTime': '수취시간',
  'pages.barcodeScan.operator': '작업자',
  'pages.barcodeScan.scanComplete': '바코드 스캔 완료: {value}',
  'pages.barcodeScan.scanError': '바코드 스캔 중 오류가 발생했습니다',
  'pages.barcodeScan.trackingNumberRequired': '트래킹번호를 입력하세요',
  'pages.barcodeScan.ordersFound': '{count}건의 주문을 찾았습니다',
  'pages.barcodeScan.registered': '등록: {value}',
  'pages.barcodeScan.scannerDeviceInstruction': '스캐너 장치로 바코드를 스캔하세요',
  'pages.barcodeScan.deleted': '삭제되었습니다',
  'pages.barcodeScan.checkLabel': '{orderNo} 점수라벨',
  'pages.barcodeScan.recheck': '재검색',
  'pages.barcodeScan.rackSaveComplete': '{orderNo} 랙 저장 완료',
  'pages.barcodeScan.reset': '초기화',
  'pages.barcodeScan.selectWarehouse': '창고 선택',
  'pages.barcodeScan.warehouseLoadError': '창고 로드 실패',
  'pages.barcodeScan.invoiceImages': '송장 이미지',
  'pages.barcodeScan.upload': '업로드',
  'pages.barcodeScan.onlyImagesAllowed': '이미지 파일만 허용됩니다',
  'pages.barcodeScan.imageSizeLimit': '이미지는 10MB보다 작아야 합니다',
  'pages.barcodeScan.maxImagesReached': '최대 10개의 이미지가 허용됩니다',
  'pages.barcodeScan.takePhoto': '사진 촬영',
  'pages.barcodeScan.capture': '촬영',
  'pages.barcodeScan.cameraNotReady': '카메라가 준비되지 않았습니다',
  'pages.barcodeScan.captureFailed': '사진 촬영 실패',
  'pages.barcodeScan.photoCaptured': '사진이 성공적으로 촬영되었습니다',
  'pages.barcodeScan.warehouseRequired': '창고를 선택해주세요',
  'pages.barcodeScan.registerError': '접수 등록 실패',
  'pages.barcodeScan.recheckButton': '재검색',
  'pages.barcodeScan.save': '저장',
  'pages.barcodeScan.cancel': '취소',
  'pages.barcodeScan.register': '등록',
  'pages.barcodeScan.receivingScan': '입고스캔',
  'pages.barcodeScan.selectScanMethod': '스캔 방법을 선택하세요',
  'pages.barcodeScan.cameraScan': '📷 카메라 스캔',
  'pages.barcodeScan.scannerDevice': '🔫 스캐너 장치',
  'pages.barcodeScan.scannerWaiting': '스캐너 장치 대기 중...',
  'pages.barcodeScan.scannerInstruction': '바코드 스캐너로 바코드를 스캔하세요',
  'pages.barcodeScan.frameInstruction': '바코드를 프레임 안에 맞춰주세요',
  'pages.barcodeScan.close': '닫기',
  'pages.barcodeScan.search': '검색 Q',
  'pages.barcodeScan.rackAssignment': '랙지정',
  'pages.barcodeScan.receiptLabel': '접수라벨',
  'pages.barcodeScan.trackingNumberColon': '트래킹번호 :',

  // Label Management Modal
  'pages.labelManagement.title': '포장관리',
  'pages.labelManagement.orderNumberRequired': '주문번호를 입력하세요',
  'pages.labelManagement.ordersFound': '{count}건의 주문을 찾았습니다',
  'pages.labelManagement.orderDetail': '{trackingNumber} 상세 정보',
  'pages.labelManagement.orderNumber': '주문번호',
  'pages.labelManagement.orderNumberPlaceholder': '주문번호',
  'pages.labelManagement.orderNumberColon': '주문번호 :',
  'pages.labelManagement.search': '검색 Q',
  'pages.labelManagement.detail': '상세',
  'pages.labelManagement.customer': '회원',
  'pages.labelManagement.recipient': '수취인',
  'pages.labelManagement.trackingNumber': '택배번호',
  'pages.labelManagement.searchInstruction': '주문번호를 검색하여 포장 정보를 확인하세요',
  'pages.labelManagement.menu.logout': '로그아웃',
  'pages.labelManagement.menu.warehouseScan': '입고스캔/실사',
  'pages.labelManagement.menu.rackManagement': '랙운송관리',
  'pages.labelManagement.menu.labelManagement': '포장관리',
  'pages.labelManagement.menu.shippingScan': '출고스캔',
  'pages.labelManagement.menu.title': 'Menu',
  'pages.labelManagement.message.logout': '로그아웃',
  'pages.labelManagement.message.warehouseScan': '입고스캔/실사 페이지로 이동',
  'pages.labelManagement.message.rackManagement': '랙운송관리 페이지로 이동',
  'pages.labelManagement.message.labelManagement': '포장관리 페이지로 이동',
  'pages.labelManagement.message.shippingScan': '출고스캔 페이지로 이동',
  'pages.labelManagement.warehouse.guangzhou': '광저우',
  'pages.labelManagement.warehouse.weihei': '위해',
  'pages.labelManagement.warehouse.qingdao': '청도',
  'pages.labelManagement.warehouse.yiwu': '이우',
  'pages.labelManagement.labelPrinting': '{trackingNumber} 라벨 출력 준비 중...',
  'pages.labelManagement.mock.recipient1': '김덕화',
  'pages.labelManagement.mock.recipient2': '김혜림',
  'pages.labelManagement.mock.recipient3': '오혜미',
  'pages.labelManagement.mock.recipient4': '방정영',

  // Order Log Modal
  'pages.orderLog.title': '■ 주문 로그 - 주문번호 : {orderNo}',
  'pages.orderLog.close': '닫기',
  'pages.orderLog.columns.no': 'No',
  'pages.orderLog.columns.time': '시간',
  'pages.orderLog.columns.status': '상태',
  'pages.orderLog.columns.content': '내용',
  'pages.orderLog.columns.detail': '상세',
  'pages.orderLog.columns.processor': '처리자',
  'pages.orderLog.noLogs': '로그 기록이 없습니다',
  'pages.orderLog.memo': '메모:',
  'pages.orderLog.system': '시스템',
  'pages.orderLog.orderNotFound': '주문을 찾을 수 없습니다',
  'pages.orderLog.orderIdNotFound': '주문 ID를 찾을 수 없습니다',
  'pages.orderLog.fetchError': '주문 상태 이력 조회에 실패했습니다',

  // Output Scan Modal
  'pages.outputScan.title': '출고스캔',
  'pages.outputScan.searchPlaceholder': '검색',
  'pages.outputScan.searchRequired': '검색어를 입력하세요',
  'pages.outputScan.ordersFound': '{count}건의 주문을 찾았습니다',
  'pages.outputScan.paymentComplete': '결제완료',
  'pages.outputScan.waitingForOutput': '출고대기',
  'pages.outputScan.tab.pyeongtaek': '평택',
  'pages.outputScan.tab.incheon': '인천',
  'pages.outputScan.tab.air': '항공',
  'pages.outputScan.paymentCompleteSelected': '결제완료 - {tab} 선택됨',
  'pages.outputScan.waitingForOutputSelected': '출고대기 - {tab} 선택됨',
  'pages.outputScan.totalQuantity': '총 수량',
  'pages.outputScan.totalWeight': '총 무게',
  'pages.outputScan.trackingNumberPlaceholder': '운송장번호',
  'pages.outputScan.trackingNumberRequired': '운송장번호를 입력하세요',
  'pages.outputScan.moved': '이동되었습니다',
  'pages.outputScan.move': '이동',
  'pages.outputScan.orderNumberColon': '주문번호 :',
  'pages.outputScan.recipient': '수취인',
  'pages.outputScan.boxCountWeight': '박스수 / 무게',
  'pages.outputScan.trackingNumber': '운송장번호',
  'pages.outputScan.internationalTrackingNumber': '국제 운송장 번호',
  'pages.outputScan.locationCode': '위치 코드',
  'pages.outputScan.locationCodePlaceholder': '위치 코드 입력 (예: A-01-03-001)',
  'pages.outputScan.locationCodeRequired': '위치 코드를 입력하세요',
  'pages.outputScan.cancel': '취소',
  'pages.outputScan.submit': '제출',

  // Product Log Modal
  'pages.productLog.title': '■ 상품 로그 - 상품번호 : {productNo}',
  'pages.productLog.close': '닫기',
  'pages.productLog.columns.no': 'No',
  'pages.productLog.columns.operator': '작업자',
  'pages.productLog.columns.content': '내용',
  'pages.productLog.columns.registrationDate': '등록일',
  'pages.productLog.noLogs': '로그 기록이 없습니다',

  // Product Table Modal
  'pages.productTable.title': '주문 상품 목록 - {orderNo}',
  'pages.productTable.trackingNumberInput': '트래킹번호 입력:',
  'pages.productTable.trackingNumberPlaceholder': '트래킹번호',
  'pages.productTable.register': '등록',
  'pages.productTable.columns.no': '번호',
  'pages.productTable.columns.checkbox': '체크박스',
  'pages.productTable.columns.productStatus': '상품상태',
  'pages.productTable.columns.productLog': '상품로그',
  'pages.productTable.columns.image': '이미지',
  'pages.productTable.columns.customsClearance': '[통관품목]',
  'pages.productTable.columns.productName': '상품명',
  'pages.productTable.columns.color': '[색상]',
  'pages.productTable.columns.size': '사이즈',
  'pages.productTable.columns.productCode': '품번 / 재질',
  'pages.productTable.columns.sellerInfo': '판매자정보',
  'pages.productTable.columns.trackingNo': '[Tracking No]',
  'pages.productTable.columns.orderNo': 'Order No',
  'pages.productTable.columns.exposure': '(노출OX)',
  'pages.productTable.columns.shippingCost': '[배송비용] 실제(O) / 판매자(X)',
  'pages.productTable.columns.refundCost': '[환불비용] 판매자(X) / 회원(O)',
  'pages.productTable.columns.unitPriceQuantity': '단가 * 수량',
  'pages.productTable.columns.totalActualPayment': '총액 / 실지불금액',
  'pages.productTable.columns.actualQuantity': '* 실수량',
  'pages.productTable.columns.total': '총액',
  'pages.productTable.columns.rackNo': '[랙번호]',
  'pages.productTable.columns.previousRackNo': '이전 랙번호',
  'pages.productTable.status.shipped': '출고',
  'pages.productTable.status.log': '로그',
  'pages.productTable.status.arrivalExpected': '도착예정',
  'pages.productTable.exposure.yes': '(노출 O)',
  'pages.productTable.shipping': '배송:',
  'pages.productTable.refund': '환불:',
  'pages.productTable.actualPayment': '실지불:',
  'pages.productTable.previous': '이전:',
  'pages.productTable.productNote': '상품 비고:',
  'pages.productTable.productNotePlaceholder': '상품 비고 입력',
  'pages.productTable.sellerAddress': '판매자 주소:',
  'pages.productTable.sellerAddressPlaceholder': '판매자 주소 입력',
  'pages.productTable.mock.furniture': '[가구]',
  'pages.productTable.mock.cotton': '면',
  'pages.productTable.mock.sellerA': '판매자A',

  // Tracking Number Modal
  'pages.trackingNumber.title': '■ 운송장번호 등록',
  'pages.trackingNumber.save': '저장',
  'pages.trackingNumber.close': '닫기',
  'pages.trackingNumber.trackingNumber': '운송장번호',
  'pages.trackingNumber.trackingNumberPlaceholder': '운송장번호',
  'pages.trackingNumber.shippingDate': '출고일자',
  'pages.trackingNumber.shippingDatePlaceholder': '출고일자',
  'pages.trackingNumber.trackingNumberRequired': '운송장번호를 입력해주세요',
  'pages.trackingNumber.shippingDateRequired': '출고일자를 입력해주세요',
  'pages.trackingNumber.registered': '운송장번호가 등록되었습니다',

  // Sub Waybill Modal
  'pages.subWaybill.title': '서브운송장번호 등록',
  'pages.subWaybill.save': '저장',
  'pages.subWaybill.close': '닫기',
  'pages.subWaybill.orderNumber': '주문번호',
  'pages.subWaybill.mainWaybillNumber': '대표 운송장번호',
  'pages.subWaybill.subWaybillNumber': '운송장번호',
  'pages.subWaybill.subWaybillNumberPlaceholder': '운송장번호를 입력하세요',
  'pages.subWaybill.registered': '운송장번호가 등록되었습니다',
  'pages.subWaybill.registerFailed': '운송장번호 등록에 실패했습니다',
  'pages.subWaybill.waybillNumberRequired': '운송장 번호가 필요합니다',
  'pages.subWaybill.orderNumberRequired': '주문 번호가 필요합니다',
  'pages.subWaybill.warningMessage': '빈값의 운송장번호를 입력하면 해당 서브 운송장번호는 삭제됩니다.',

  // Bundle Orders Modal
  'pages.bundleOrders.title': '주문 합치기',
  'pages.bundleOrders.bundle': '합치기',
  'pages.bundleOrders.close': '닫기',
  'pages.bundleOrders.orderNo': '주문번호',
  'pages.bundleOrders.memberId': '회원번호',
  'pages.bundleOrders.memberName': '회원명',
  'pages.bundleOrders.deliveryAddress': '수취인 주소',
  'pages.bundleOrders.shippingMethod': '배송방법',
  'pages.bundleOrders.productCount': '상품 수량',
  'pages.bundleOrders.totalAmount': '총 금액',
  'pages.bundleOrders.description': '동일한 회원번호, 수취인 주소, 배송방식의 주문을 합쳐 새로운 주문번호를 생성합니다.',
  'pages.bundleOrders.selectedCount': '{count}개 주문 선택됨',
  'pages.bundleOrders.selectAtLeastTwo': '최소 2개 이상의 주문을 선택해주세요',
  'pages.bundleOrders.bundled': '주문이 합쳐졌고 새로운 주문번호가 생성되었습니다',
  'pages.bundleOrders.noOrderInfo': '노데이타',
  'pages.bundleOrders.noOrdersFound': '주문을 찾을 수 없습니다',
  'pages.bundleOrders.select': '선택',
  'pages.bundleOrders.orderNumber': '주문번호',
  'pages.bundleOrders.itemCount': '상품 수',
  'pages.bundleOrders.progressStatus': '상태',
  'pages.bundleOrders.createdAt': '생성일',
  'pages.bundleOrders.selectAtLeastOne': '최소 1개 이상의 주문을 선택해주세요',
  'pages.bundleOrders.orderIdRequired': '주문 ID가 필요합니다',
  'pages.bundleOrders.fetchError': '합칠 수 있는 주문을 가져오는데 실패했습니다',
  'pages.bundleOrders.bundleError': '주문 합치기 실패, 다시 시도해주세요',
  'pages.bundleOrders.currentOrder': '현재 주문',
  // Split Order Modal
  'pages.splitOrder.title': '주문 나누기',
  'pages.splitOrder.split': '나누기',
  'pages.splitOrder.close': '닫기',
  'pages.splitOrder.orderNo': '주문번호',
  'pages.splitOrder.productNo': '상품번호',
  'pages.splitOrder.image': '이미지',
  'pages.splitOrder.productName': '상품명',
  'pages.splitOrder.variation': '옵션',
  'pages.splitOrder.quantity': '수량',
  'pages.splitOrder.originalQuantity': '원래 수량',
  'pages.splitOrder.splitQuantity': '분할 수량',
  'pages.splitOrder.originalTotal': '원래 총액',
  'pages.splitOrder.splitTotal': '분할 총액',
  'pages.splitOrder.quantityMustBeGreaterThanZero': '분할 수량은 0보다 커야 합니다',
  'pages.splitOrder.quantityExceedsAvailable': '분할 수량은 사용 가능한 수량을 초과할 수 없습니다',
  'pages.splitOrder.unitPrice': '단가',
  'pages.splitOrder.totalPrice': '총액',
  'pages.splitOrder.description': '나눌 상품을 선택하세요. 선택한 상품은 새 주문으로 생성됩니다.',
  'pages.splitOrder.selectAtLeastOne': '최소 1개 이상의 상품을 선택해주세요',
  'pages.splitOrder.cannotSelectAll': '모든 상품을 선택할 수 없습니다. 원래 주문에 최소 1개 상품을 남겨두어야 합니다',
  'pages.splitOrder.selectedTotal': '선택한 상품 총액',
  'pages.splitOrder.splitSuccess': '주문이 성공적으로 나뉘었습니다. 새 주문이 생성되었습니다',
  'pages.splitOrder.splitError': '주문 나누기 실패, 다시 시도해주세요',

  // Merge Order Modal
  'pages.mergeOrder.title': '주문 합치기',
  'pages.mergeOrder.description': '합칠 주문을 선택하세요. 합쳐진 주문에는 선택한 주문의 모든 상품이 포함됩니다.',
  'pages.mergeOrder.currentOrder': '현재 주문',
  'pages.mergeOrder.select': '선택',
  'pages.mergeOrder.orderNumber': '주문번호',
  'pages.mergeOrder.memberName': '회원명',
  'pages.mergeOrder.itemCount': '상품 수',
  'pages.mergeOrder.totalAmount': '총액',
  'pages.mergeOrder.progressStatus': '상태',
  'pages.mergeOrder.createdAt': '생성일',
  'pages.mergeOrder.selectAtLeastOne': '최소 1개 이상의 주문을 선택해주세요',
  'pages.mergeOrder.selectOnlyOne': '하나의 분할 주문만 선택해주세요',
  'pages.mergeOrder.orderIdRequired': '주문 ID가 필요합니다',
  'pages.mergeOrder.fetchError': '합칠 수 있는 주문을 가져오는데 실패했습니다',
  'pages.mergeOrder.splitRefundSuccess': '환불 분할 주문이 성공적으로 생성되었습니다',
  'pages.mergeOrder.splitRefundError': '환불 분할 주문 생성 실패, 다시 시도해주세요',
  'pages.mergeOrder.merge': '합치기',
  'pages.mergeOrder.mergeSuccess': '주문이 성공적으로 합쳐졌습니다. 새 주문이 생성되었습니다',
  'pages.mergeOrder.mergeError': '주문 합치기 실패, 다시 시도해주세요',
  'pages.mergeOrder.close': '닫기',
  'pages.mergeOrder.orderNo': '주문번호',
  'pages.mergeOrder.memberId': '회원번호',
  'pages.mergeOrder.deliveryAddress': '수취인 주소',
  'pages.mergeOrder.shippingMethod': '배송방법',
  'pages.mergeOrder.productCount': '상품 수량',
  'pages.mergeOrder.selectAtLeastTwo': '최소 2개 이상의 주문을 선택해주세요',
  'pages.mergeOrder.merged': '주문이 합쳐졌고 새로운 주문번호가 생성되었습니다',
  'pages.mergeOrder.selectedCount': '{count}개 주문 선택됨',
  'pages.mergeOrder.noOrdersFound': '주문을 찾을 수 없습니다',
  'pages.mergeOrder.splitFrom': '분할 출처',
  'pages.mergeOrder.hasSplitOrders': '분할 주문 있음',

  // User Info Modal
  'pages.userInfo.title': '회원 정보',
  'pages.userInfo.memberType.general': '일반',
  'pages.userInfo.memberType.business': '사업자',
  'pages.userInfo.memberTypeTag.general': '일반회원',
  'pages.userInfo.memberTypeTag.business': '사업자회원',
  'pages.userInfo.mailbox': '사서함번호',
  'pages.userInfo.businessNo': '사업자등록번호',
  'pages.userInfo.registrationDate': '가입일',
  'pages.userInfo.totalOrders': '총 주문건수',
  'pages.userInfo.totalAmount': '총 주문금액',
  'pages.userInfo.contact': '연락처',
  'pages.userInfo.email': '이메일',
  'pages.userInfo.address': '주소',
  'pages.userInfo.memo': '메모',
  'pages.userInfo.unit.orders': '건',
  'pages.userInfo.unit.currency': '원',
  'pages.userInfo.actions.memberInfo': '회원정보',
  'pages.userInfo.actions.userUniqueId': '사서함',
  'pages.userInfo.actions.inquiry': '문의',
  'pages.userInfo.actions.notificationMessage': '알림 메시지',
  'pages.userInfo.actions.orders': '주문',
  'pages.userInfo.actions.paymentConfirmation': '결제 확인',
  'pages.userInfo.actions.deposit': '예치금',
  'pages.userInfo.actions.coupon': '쿠폰',
  'pages.userInfo.actions.point': '포인트',

  // Auth
  'pages.auth.loginSuccess': '로그인 성공!',
  'pages.auth.loginFailed': '로그인 실패',
  'pages.auth.loginFailedWithConsole': '로그인 실패. 콘솔에서 자세한 내용을 확인하세요.',
  
  // Settlement - Dashboard
  'pages.settlement.dashboard.title': '재무 대시보드',
  'pages.settlement.dashboard.refresh': '새로고침',
  'pages.settlement.dashboard.overview.totalUsers': '총 회원 수',
  'pages.settlement.dashboard.overview.totalOrders': '총 주문 수',
  'pages.settlement.dashboard.overview.totalRevenue': '총 매출',
  'pages.settlement.dashboard.overview.totalProducts': '총 상품 수',
  'pages.settlement.dashboard.overview.activeProducts': '판매중 상품',
  'pages.settlement.dashboard.overview.pendingOrders': '대기 주문',
  'pages.settlement.dashboard.revenue.title': '매출',
  'pages.settlement.dashboard.revenue.today': '오늘',
  'pages.settlement.dashboard.revenue.thisWeek': '이번 주',
  'pages.settlement.dashboard.revenue.thisMonth': '이번 달',
  'pages.settlement.dashboard.revenue.thisYear': '올해',
  'pages.settlement.dashboard.revenue.growth': '성장률',
  'pages.settlement.dashboard.orders.title': '주문',
  'pages.settlement.dashboard.orders.today': '오늘',
  'pages.settlement.dashboard.orders.thisWeek': '이번 주',
  'pages.settlement.dashboard.orders.thisMonth': '이번 달',
  'pages.settlement.dashboard.orders.byStatus': '상태별',
  'pages.settlement.dashboard.topProducts.title': '인기 상품',
  'pages.settlement.dashboard.topProducts.productId': '상품 ID',
  'pages.settlement.dashboard.topProducts.name': '상품명',
  'pages.settlement.dashboard.topProducts.sales': '판매량',
  'pages.settlement.dashboard.topProducts.revenue': '매출',
  'pages.settlement.dashboard.recentActivity.title': '최근 활동',
  'pages.settlement.dashboard.recentActivity.empty': '활동 내역 없음',

  // Settlement - Sellers
  'pages.settlement.sellers.title': '판매자 정산',
  'pages.settlement.sellers.tableTitle': '판매자 정산 내역',
  'pages.settlement.sellers.processSettlement': '정산 처리',
  'pages.settlement.sellers.processSettlementConfirm': '{sellerName}의 정산을 처리하시겠습니까? ({amount}원)',
  'pages.settlement.sellers.processSettlementSuccess': '정산이 처리되었습니다',
  'pages.settlement.sellers.process': '처리',
  'pages.settlement.sellers.statement': '명세서',
  'pages.settlement.sellers.exportExcel': '엑셀 다운로드',
  'pages.settlement.sellers.exportExcelSuccess': '엑셀 파일 다운로드를 시작합니다',
  'pages.settlement.sellers.downloadStatement': '명세서 다운로드',
  'pages.settlement.sellers.settlementRate': '정산율 {percent}%',
  'pages.settlement.sellers.stat.totalSettlementThisMonth': '이번 달 총 정산액',
  'pages.settlement.sellers.stat.pending': '대기중',
  'pages.settlement.sellers.stat.completed': '처리 완료',
  'pages.settlement.sellers.stat.avgSettlement': '평균 정산액',
  'pages.settlement.sellers.alert.title': '정산 안내',
  'pages.settlement.sellers.alert.description': '매월 1일~말일까지의 매출을 익월 10일에 정산합니다. 정산 금액은 총 매출에서 수수료, 배송비, 기타 비용을 차감한 금액입니다.',
  'pages.settlement.sellers.column.id': 'ID',
  'pages.settlement.sellers.column.sellerInfo': '판매자 정보',
  'pages.settlement.sellers.column.period': '정산 기간',
  'pages.settlement.sellers.column.totalSales': '총 매출',
  'pages.settlement.sellers.column.commission': '수수료',
  'pages.settlement.sellers.column.shippingFee': '배송비',
  'pages.settlement.sellers.column.settlementAmount': '정산 금액',
  'pages.settlement.sellers.column.orderProduct': '주문/상품',
  'pages.settlement.sellers.column.status': '상태',
  'pages.settlement.sellers.column.requestDate': '신청일',
  'pages.settlement.sellers.column.completedDate': '완료일',
  'pages.settlement.sellers.column.action': '작업',
  'pages.settlement.sellers.status.pending': '대기',
  'pages.settlement.sellers.status.processing': '처리중',
  'pages.settlement.sellers.status.completed': '완료',
  'pages.settlement.sellers.status.failed': '실패',
  'pages.settlement.sellers.detailModal.title': '정산 상세 - {sellerName}',
  'pages.settlement.sellers.tab.summary': '정산 요약',
  'pages.settlement.sellers.tab.account': '입금 정보',
  'pages.settlement.sellers.detail.sellerId': '판매자 ID',
  'pages.settlement.sellers.detail.sellerName': '판매자명',
  'pages.settlement.sellers.detail.period': '정산 기간',
  'pages.settlement.sellers.detail.orderCount': '주문 건수',
  'pages.settlement.sellers.detail.productCount': '상품 수',
  'pages.settlement.sellers.detail.settlementAmountDetail': '정산 금액 상세',
  'pages.settlement.sellers.detail.totalSales': '총 매출',
  'pages.settlement.sellers.detail.platformCommission': '플랫폼 수수료 (10%)',
  'pages.settlement.sellers.detail.shippingFee': '배송비',
  'pages.settlement.sellers.detail.otherDeduction': '기타 차감',
  'pages.settlement.sellers.detail.finalSettlementAmount': '최종 정산 금액',
  'pages.settlement.sellers.detail.bankName': '은행명',
  'pages.settlement.sellers.detail.accountNumber': '계좌번호',
  'pages.settlement.sellers.detail.accountHolder': '예금주',
  'pages.settlement.sellers.detail.requestDate': '신청일',
  'pages.settlement.sellers.detail.completedDate': '완료일',
  'pages.settlement.sellers.detail.status': '상태',
  'pages.settlement.sellers.mock.sellerName': '판매자',
  'pages.settlement.sellers.mock.bank.kb': '국민은행',
  'pages.settlement.sellers.mock.bank.shinhan': '신한은행',
  'pages.settlement.sellers.mock.bank.woori': '우리은행',
  'pages.settlement.sellers.mock.bank.hana': '하나은행',
  
  // Settlement - Member Recharge Review
  'pages.settlement.memberRechargeReview.title': '예치금 신청내역',
  'pages.settlement.memberRechargeReview.memberName': '회원명',
  'pages.settlement.memberRechargeReview.applicationType': '신청구분',
  'pages.settlement.memberRechargeReview.typeDeposit': '신청',
  'pages.settlement.memberRechargeReview.typeWithdraw': '출금',
  'pages.settlement.memberRechargeReview.typeRefund': '환불',
  'pages.settlement.memberRechargeReview.rejectReasonPlaceholder': '거부 사유를 입력해주세요',
  'pages.settlement.memberRechargeReview.depositAmount': '입금액',
  'pages.settlement.memberRechargeReview.refundAmount': '환불액',
  'pages.settlement.memberRechargeReview.depositor': '입금자(예금주)',
  'pages.settlement.memberRechargeReview.bankInfo': '계좌번호',
  'pages.settlement.memberRechargeReview.status': '완료여부',
  'pages.settlement.memberRechargeReview.statusPending': '신청',
  'pages.settlement.memberRechargeReview.statusApproved': '완료',
  'pages.settlement.memberRechargeReview.statusRejected': '취소',
  'pages.settlement.memberRechargeReview.applicationDate': '신청일자',
  'pages.settlement.memberRechargeReview.expectedDepositDate': '입금예정일',
  'pages.settlement.memberRechargeReview.actions': '작업',
  'pages.settlement.memberRechargeReview.complete': '완료',
  'pages.settlement.memberRechargeReview.cancellation': '취소',
  'pages.settlement.memberRechargeReview.totalApplications': '총 신청건수',
  'pages.settlement.memberRechargeReview.pendingApplications': '신청 대기',
  'pages.settlement.memberRechargeReview.approvedApplications': '완료',
  'pages.settlement.memberRechargeReview.totalAmount': '총 금액',
  'pages.settlement.memberRechargeReview.approveConfirm': '승인하시겠습니까?',
  'pages.settlement.memberRechargeReview.approveContent': '{name}님의 {amount}원 충전을 승인하시겠습니까?',
  'pages.settlement.memberRechargeReview.approved': '승인되었습니다',
  'pages.settlement.memberRechargeReview.approveError': '승인에 실패했습니다',
  'pages.settlement.memberRechargeReview.rejectConfirm': '신청을 거절하시겠습니까?',
  'pages.settlement.memberRechargeReview.rejectContent': '{name}님의 예치금 신청을 거절하시겠습니까?',
  'pages.settlement.memberRechargeReview.rejected': '거절되었습니다',
  'pages.settlement.memberRechargeReview.rejectError': '거절에 실패했습니다',
  'pages.settlement.memberRechargeReview.registrationSuccess': '등록되었습니다',
  
  // Settlement - Member Withdrawal Review
  'pages.settlement.memberWithdrawalReview.title': '예치금 사용내역',
  'pages.settlement.memberWithdrawalReview.memberName': '회원명',
  'pages.settlement.memberWithdrawalReview.usageClassification': '사용구분',
  'pages.settlement.memberWithdrawalReview.classificationDepositTopup': '예치금충전',
  'pages.settlement.memberWithdrawalReview.classificationRefund': '예치금환불',
  'pages.settlement.memberWithdrawalReview.classificationPaymentCost': '결제비용사용',
  'pages.settlement.memberWithdrawalReview.classificationPaymentCancel': '결제비용취소',
  'pages.settlement.memberWithdrawalReview.classificationAdminAccrual': '관리자예치금적립',
  'pages.settlement.memberWithdrawalReview.classificationAdminDeduction': '관리자예치금차감',
  'pages.settlement.memberWithdrawalReview.classificationProductRefund': '구매상품환불',
  'pages.settlement.memberWithdrawalReview.content': '내용',
  'pages.settlement.memberWithdrawalReview.transactionCode': '거래 코드',
  'pages.settlement.memberWithdrawalReview.amount': '금액',
  'pages.settlement.memberWithdrawalReview.balance': '잔액',
  'pages.settlement.memberWithdrawalReview.usageDate': '사용일자',
  'pages.settlement.memberWithdrawalReview.paymentOrderNumber': '결제주문번호',
  'pages.settlement.memberWithdrawalReview.depositPaymentOrderNumber': '예치금결제주문번호',
  'pages.settlement.memberWithdrawalReview.totalUsage': '총 사용건수',
  'pages.settlement.memberWithdrawalReview.totalAmount': '총 사용금액',
  'pages.settlement.memberWithdrawalReview.averageAmount': '평균 사용금액',
  'pages.settlement.memberWithdrawalReview.totalDeposit': '전체예치금',
  'pages.settlement.memberWithdrawalReview.depositRegistration': '예치금등록',
  'pages.settlement.memberWithdrawalReview.memberSearch': '회원검색',
  'pages.settlement.memberWithdrawalReview.searchByMemberId': '회원ID',
  'pages.settlement.memberWithdrawalReview.searchByMemberName': '회원명',
  'pages.settlement.memberWithdrawalReview.searchByMailbox': '사서함번호',
  'pages.settlement.memberWithdrawalReview.searchRequired': '검색어를 입력하세요',
  'pages.settlement.memberWithdrawalReview.searchPlaceholder': '검색어를 입력하세요',
  'pages.settlement.memberWithdrawalReview.search': '검색',
  'pages.settlement.memberWithdrawalReview.memberSelect': '회원선택',
  'pages.settlement.memberWithdrawalReview.contentRequired': '내용을 입력하세요',
  'pages.settlement.memberWithdrawalReview.contentPlaceholder': '예치금 적립 또는 차감 사유를 입력하세요',
  'pages.settlement.memberWithdrawalReview.amountRequired': '금액을 입력하세요',
  'pages.settlement.memberWithdrawalReview.amountMin': '금액은 1원 이상이어야 합니다',
  'pages.settlement.memberWithdrawalReview.amountPlaceholder': '금액을 입력하세요',
  'pages.settlement.memberWithdrawalReview.registrationSuccess': '등록되었습니다',
  'pages.settlement.memberWithdrawalReview.registrationFailed': '등록에 실패했습니다',
  'pages.settlement.memberWithdrawalReview.direction': '적립/차감',
  'pages.settlement.memberWithdrawalReview.direction.add': '적립',
  'pages.settlement.memberWithdrawalReview.direction.subtract': '차감',
  'pages.settlement.memberWithdrawalReview.currentBalance': '현재 예치금',
  'pages.settlement.memberWithdrawalReview.negativeWarning': '차감 후 잔액이 음수가 됩니다. 서버에서 거절됩니다.',
  'pages.settlement.memberWithdrawalReview.submit': '등록',
  'pages.settlement.memberWithdrawalReview.memberRequired': '회원을 선택해 주세요',
  'pages.settlement.memberWithdrawalReview.noMemberFound': '검색 결과가 없습니다',
  
  // Settlement - Platform
  'pages.settlement.platform.title': '플랫폼 수수료 정산',
  'pages.settlement.platform.tableTitle': '월별 수수료 내역',
  'pages.settlement.platform.exportExcel': '엑셀 다운로드',
  'pages.settlement.platform.exportExcelSuccess': '엑셀 파일 다운로드를 시작합니다',
  'pages.settlement.platform.downloadReport': '리포트 다운로드',
  'pages.settlement.platform.month': '{month}월',
  'pages.settlement.platform.year': '{year}년',
  'pages.settlement.platform.stat.totalRevenueThisMonth': '이번 달 총 수익',
  'pages.settlement.platform.stat.commissionRevenue': '수수료 수익',
  'pages.settlement.platform.stat.shippingFeeRevenue': '배송비 수익',
  'pages.settlement.platform.stat.monthOverMonth': '전월 대비',
  'pages.settlement.platform.chart.title': '월별 수익 추이',
  'pages.settlement.platform.column.id': 'ID',
  'pages.settlement.platform.column.period': '정산 기간',
  'pages.settlement.platform.column.year': '년도',
  'pages.settlement.platform.column.month': '월',
  'pages.settlement.platform.column.totalSales': '총 매출',
  'pages.settlement.platform.column.commissionRate': '수수료율',
  'pages.settlement.platform.column.commissionAmount': '수수료 수익',
  'pages.settlement.platform.column.shippingFee': '배송비 수익',
  'pages.settlement.platform.column.additionalFee': '기타 수익',
  'pages.settlement.platform.column.totalFee': '총 수익',
  'pages.settlement.platform.column.orderSeller': '주문/판매자',
  'pages.settlement.platform.column.avgOrderValue': '평균 주문액',
  'pages.settlement.platform.column.growthRate': '성장률',
  'pages.settlement.platform.column.action': '작업',
  'pages.settlement.platform.detailModal.title': '수수료 상세 - {period}',
  'pages.settlement.platform.detail.revenueSummary': '수익 요약',
  'pages.settlement.platform.detail.revenueDetail': '수익 상세',
  'pages.settlement.platform.detail.growthMetrics': '성장 지표',
  'pages.settlement.platform.detail.revenueComposition': '수익 구성',
  'pages.settlement.platform.detail.period': '정산 기간',
  'pages.settlement.platform.detail.totalSales': '총 매출',
  'pages.settlement.platform.detail.orderCount': '주문 건수',
  'pages.settlement.platform.detail.sellerCount': '판매자 수',
  'pages.settlement.platform.detail.avgOrderValue': '평균 주문액',
  'pages.settlement.platform.detail.platformCommission': '플랫폼 수수료 ({rate}%)',
  'pages.settlement.platform.detail.shippingFeeRevenue': '배송비 수익',
  'pages.settlement.platform.detail.additionalRevenue': '기타 수익',
  'pages.settlement.platform.detail.totalRevenue': '총 수익',
  'pages.settlement.platform.detail.monthOverMonthGrowth': '전월 대비 성장률',
  'pages.settlement.platform.detail.profitRate': '수익률',
  'pages.settlement.platform.detail.platformCommissionLabel': '플랫폼 수수료',
  'pages.settlement.platform.detail.shippingFeeRevenueLabel': '배송비 수익',
  'pages.settlement.platform.detail.additionalRevenueLabel': '기타 수익',

  // Settlement - Coupons (moved from members)
  'pages.settlement.coupons.title': '포인트/쿠폰 설정',

  // Members - Statistics
  'pages.members.statistics.title': '회원 통계',
  'pages.members.statistics.cumulativeRegisteredUsers': '누적 등록 회원',
  'pages.members.statistics.visitors': '방문자 수',
  'pages.members.statistics.newUsers': '신규 회원 수',
  'pages.members.statistics.orderTransactionUsers': '주문 거래 회원 수',
  'pages.members.statistics.waybillTransactionUsers': '운송장 거래 회원 수',
  'pages.members.statistics.dateRange': '조회 기간',
  'pages.members.statistics.query': '조회',
  'pages.members.statistics.reset': '초기화',
  'pages.members.statistics.pageViews': '페이지 조회수',
  'pages.members.statistics.trendChart': '회원 통계 추이',
  'pages.members.statistics.chart.pageViews': '페이지 조회수',
  'pages.members.statistics.chart.visitors': '방문자 수',
  'pages.members.statistics.chart.newUsers': '신규 회원 수',
  'pages.members.statistics.chart.orderTransactionUsers': '주문 거래 회원 수',
  'pages.members.statistics.chart.waybillTransactionUsers': '운송장 거래 회원 수',
  'pages.members.statistics.chart.cumulativeRegisteredUsers': '누적 등록 회원 추이',

  // Settlement - Product Price Increase
  'pages.settlement.productPriceIncrease.title': '상품 가격 인상',
  'pages.settlement.productPriceIncrease.addTitle': '상품 가격 인상 추가',
  'pages.settlement.productPriceIncrease.editTitle': '상품 가격 인상 수정',
  'pages.settlement.productPriceIncrease.deleteConfirm': '상품 가격 인상 삭제',
  'pages.settlement.productPriceIncrease.deleteConfirmContent': 'ID "{id}" 가격 범위의 가격 인상 정보를 삭제하시겠습니까?',
  'pages.settlement.productPriceIncrease.deleteSuccess': '상품 가격 인상 정보가 삭제되었습니다',
  'pages.settlement.productPriceIncrease.deleteError': '가격 인상 설정 삭제에 실패했습니다',
  'pages.settlement.productPriceIncrease.fetchError': '가격 인상 설정을 가져오는데 실패했습니다',
  'pages.settlement.productPriceIncrease.updateSuccess': '상품 가격 인상 정보가 수정되었습니다',
  'pages.settlement.productPriceIncrease.createSuccess': '상품 가격 인상 정보가 등록되었습니다',
  'pages.settlement.productPriceIncrease.submitError': '상품 가격 인상 정보 저장 중 오류가 발생했습니다',
  'pages.settlement.productPriceIncrease.approve': '승인',
  'pages.settlement.productPriceIncrease.reject': '거부',
  'pages.settlement.productPriceIncrease.approveSuccess': '가격 인상이 승인되었습니다',
  'pages.settlement.productPriceIncrease.rejectSuccess': '가격 인상이 거부되었습니다',
  'pages.settlement.productPriceIncrease.statistics.total': '전체',
  'pages.settlement.productPriceIncrease.statistics.pending': '대기',
  'pages.settlement.productPriceIncrease.statistics.approved': '승인됨',
  'pages.settlement.productPriceIncrease.statistics.totalIncrease': '총 인상액',
  'pages.settlement.productPriceIncrease.serviceFee.title': '서비스 수수료',
  'pages.settlement.productPriceIncrease.serviceFee.feeAmount': '수수료 금액',
  'pages.settlement.productPriceIncrease.serviceFee.enterFee': '수수료를 입력하세요',
  'pages.settlement.productPriceIncrease.serviceFee.register': '등록',
  'pages.settlement.productPriceIncrease.serviceFee.required': '수수료를 입력하세요',
  'pages.settlement.productPriceIncrease.serviceFee.updateSuccess': '서비스 수수료가 업데이트되었습니다',
  'pages.settlement.productPriceIncrease.serviceFee.updateError': '서비스 수수료 업데이트 실패',
  'pages.settlement.productPriceIncrease.column.id': 'ID',
  'pages.settlement.productPriceIncrease.column.startingPrice': '시작가격',
  'pages.settlement.productPriceIncrease.column.endPrice': '종료가격',
  'pages.settlement.productPriceIncrease.column.increaseType': '인상유형',
  'pages.settlement.productPriceIncrease.column.addValue': '추가값',
  'pages.settlement.productPriceIncrease.column.operate': '작업',
  'pages.settlement.productPriceIncrease.column.productCode': '상품코드',
  'pages.settlement.productPriceIncrease.column.productName': '상품명',
  'pages.settlement.productPriceIncrease.column.category': '카테고리',
  'pages.settlement.productPriceIncrease.column.currentPrice': '현재가격',
  'pages.settlement.productPriceIncrease.column.increaseValue': '인상값',
  'pages.settlement.productPriceIncrease.column.newPrice': '신규가격',
  'pages.settlement.productPriceIncrease.column.effectiveDate': '적용일',
  'pages.settlement.productPriceIncrease.column.reason': '사유',
  'pages.settlement.productPriceIncrease.column.status': '상태',
  'pages.settlement.productPriceIncrease.increaseType.percent': '비율',
  'pages.settlement.productPriceIncrease.increaseType.fixed': '고정',
  'pages.settlement.productPriceIncrease.status.pending': '대기',
  'pages.settlement.productPriceIncrease.status.approved': '승인',
  'pages.settlement.productPriceIncrease.status.rejected': '거부',
  'pages.settlement.productPriceIncrease.status.active': '활성',
  'pages.settlement.productPriceIncrease.form.startingPrice': '시작가격',
  'pages.settlement.productPriceIncrease.form.startingPriceRequired': '시작가격을 입력하세요',
  'pages.settlement.productPriceIncrease.form.endPrice': '종료가격',
  'pages.settlement.productPriceIncrease.form.endPriceRequired': '종료가격을 입력하세요',
  'pages.settlement.productPriceIncrease.form.endPricePlaceholder': '무제한은 999999999 입력',
  'pages.settlement.productPriceIncrease.form.increaseType': '인상유형',
  'pages.settlement.productPriceIncrease.form.increaseTypeRequired': '인상유형을 선택하세요',
  'pages.settlement.productPriceIncrease.form.addValue': '추가값',
  'pages.settlement.productPriceIncrease.form.addValueRequired': '추가값을 입력하세요',
  'pages.settlement.productPriceIncrease.form.productCode': '상품코드',
  'pages.settlement.productPriceIncrease.form.productCodeRequired': '상품코드를 입력하세요',
  'pages.settlement.productPriceIncrease.form.productName': '상품명',
  'pages.settlement.productPriceIncrease.form.productNameRequired': '상품명을 입력하세요',
  'pages.settlement.productPriceIncrease.form.currentPrice': '현재가격',
  'pages.settlement.productPriceIncrease.form.currentPriceRequired': '현재가격을 입력하세요',
  'pages.settlement.productPriceIncrease.form.increaseValue': '인상값',
  'pages.settlement.productPriceIncrease.form.increaseValueRequired': '인상값을 입력하세요',
  'pages.settlement.productPriceIncrease.form.effectiveDate': '적용일',
  'pages.settlement.productPriceIncrease.form.effectiveDateRequired': '적용일을 선택하세요',
  'pages.settlement.productPriceIncrease.form.reason': '사유',
  'pages.settlement.productPriceIncrease.form.reasonRequired': '사유를 입력하세요',

  // Settlement - Service Fee
  'pages.settlement.serviceFee.title': '서비스 수수료',
  'pages.settlement.serviceFee.addTitle': '서비스 수수료 추가',
  'pages.settlement.serviceFee.editTitle': '서비스 수수료 수정',
  'pages.settlement.serviceFee.deleteConfirm': '서비스 수수료 삭제',
  'pages.settlement.serviceFee.deleteConfirmContent': '"{serviceName}" 서비스 수수료를 삭제하시겠습니까?',
  'pages.settlement.serviceFee.deleteSuccess': '서비스 수수료가 삭제되었습니다',
  'pages.settlement.serviceFee.updateSuccess': '서비스 수수료가 수정되었습니다',
  'pages.settlement.serviceFee.createSuccess': '서비스 수수료가 등록되었습니다',
  'pages.settlement.serviceFee.submitError': '서비스 수수료 저장 중 오류가 발생했습니다',
  'pages.settlement.serviceFee.statistics.total': '전체',
  'pages.settlement.serviceFee.statistics.active': '활성',
  'pages.settlement.serviceFee.statistics.inactive': '비활성',
  'pages.settlement.serviceFee.column.serviceType': '서비스유형',
  'pages.settlement.serviceFee.column.serviceName': '서비스명',
  'pages.settlement.serviceFee.column.usageType': '사용유형',
  'pages.settlement.serviceFee.column.operate': '작업',
  'pages.settlement.serviceFee.column.feeType': '수수료유형',
  'pages.settlement.serviceFee.column.feeValue': '수수료값',
  'pages.settlement.serviceFee.column.minAmount': '최소금액',
  'pages.settlement.serviceFee.column.maxAmount': '최대금액',
  'pages.settlement.serviceFee.column.applicableTo': '적용대상',
  'pages.settlement.serviceFee.column.isActive': '활성화',
  'pages.settlement.serviceFee.column.effectiveDate': '적용일',
  'pages.settlement.serviceFee.serviceType.payment': '결제',
  'pages.settlement.serviceFee.serviceType.shipping': '배송',
  'pages.settlement.serviceFee.serviceType.platform': '플랫폼',
  'pages.settlement.serviceFee.serviceType.storage': '보관',
  'pages.settlement.serviceFee.feeType.fixed': '고정',
  'pages.settlement.serviceFee.feeType.percent': '비율',
  'pages.settlement.serviceFee.feeType.tiered': '구간',
  'pages.settlement.serviceFee.form.serviceType': '서비스유형',
  'pages.settlement.serviceFee.form.serviceTypeRequired': '서비스유형을 선택하세요',
  'pages.settlement.serviceFee.form.serviceName': '서비스명',
  'pages.settlement.serviceFee.form.serviceNameRequired': '서비스명을 입력하세요',
  'pages.settlement.serviceFee.form.feeType': '수수료유형',
  'pages.settlement.serviceFee.form.feeTypeRequired': '수수료유형을 선택하세요',
  'pages.settlement.serviceFee.form.feeValue': '수수료값',
  'pages.settlement.serviceFee.form.feeValueRequired': '수수료값을 입력하세요',
  'pages.settlement.serviceFee.form.minAmount': '최소금액',
  'pages.settlement.serviceFee.form.maxAmount': '최대금액',
  'pages.settlement.serviceFee.form.effectiveDate': '적용일',
  'pages.settlement.serviceFee.form.effectiveDateRequired': '적용일을 선택하세요',
  'pages.settlement.serviceFee.form.description': '설명',
  'pages.settlement.serviceFee.form.isActive': '활성화',
  
  // Settlement - Member Recharge Review
  'pages.settlement.memberRechargeReview.filter.group.title': '상태',
  'pages.settlement.memberRechargeReview.filter.pendingReview': '심사 대기',
  'pages.settlement.memberRechargeReview.filter.approvalSuccessful': '심사 성공',
  'pages.settlement.memberRechargeReview.filter.reviewFailed': '심사 실패',
  'pages.settlement.memberRechargeReview.column.userId': '회원 ID',
  'pages.settlement.memberRechargeReview.column.user': '회원',
  'pages.settlement.memberRechargeReview.column.remittanceMethod': '송금 방식',
  'pages.settlement.memberRechargeReview.column.remitterName': '송금인 성명',
  'pages.settlement.memberRechargeReview.column.rechargeCurrencyAndAmount': '충전 통화 금액',
  'pages.settlement.memberRechargeReview.column.receivedCurrencyAndAmount': '입금 통화 금액',
  'pages.settlement.memberRechargeReview.column.serviceFee': '서비스비',
  'pages.settlement.memberRechargeReview.column.receivingBankInformation': '수취 은행 정보',
  'pages.settlement.memberRechargeReview.column.addTime': '추가 시간',
  'pages.settlement.memberRechargeReview.approve': '심사 성공',
  'pages.settlement.memberRechargeReview.reject': '심사 실패',
  'pages.settlement.memberRechargeReview.rejectTitle': '심사 실패 사유 입력',
  'pages.settlement.memberRechargeReview.rejectionReason': '거부 사유',
  'pages.settlement.memberRechargeReview.rejectionReasonRequired': '거부 사유를 입력해주세요',
  'pages.settlement.memberRechargeReview.rejectionReasonPlaceholder': '거부 사유를 입력해주세요',
  'pages.settlement.memberRechargeReview.viewReason': '사유 확인',
  'pages.settlement.memberRechargeReview.viewReasonTitle': '심사 실패 사유',
  'pages.settlement.memberRechargeReview.receivingAccount': '수취 계좌',
  'pages.settlement.memberRechargeReview.receivingAccountManagement': '수취 계좌 관리',
  'pages.settlement.memberRechargeReview.bankName': '은행명',
  'pages.settlement.memberRechargeReview.bankNameRequired': '은행명을 입력해주세요',
  'pages.settlement.memberRechargeReview.accountNumber': '계좌번호',
  'pages.settlement.memberRechargeReview.accountNumberRequired': '계좌번호를 입력해주세요',
  'pages.settlement.memberRechargeReview.accountHolder': '예금주',
  'pages.settlement.memberRechargeReview.accountHolderRequired': '예금주를 입력해주세요',
  'pages.settlement.memberRechargeReview.currency': '통화',
  'pages.settlement.memberRechargeReview.currencyRequired': '통화를 선택해주세요',
  'pages.settlement.memberRechargeReview.isActive': '활성 상태',
  'pages.settlement.memberRechargeReview.accountList': '계좌 목록',
  'pages.settlement.memberRechargeReview.accountAdded': '계좌가 추가되었습니다',
  'pages.settlement.memberRechargeReview.accountUpdated': '계좌가 수정되었습니다',
  'pages.settlement.memberRechargeReview.accountStatusUpdated': '상태가 변경되었습니다',
  'pages.settlement.memberRechargeReview.accountError': '오류가 발생했습니다',
  'pages.settlement.memberRechargeReview.selectOrDateRequired': '날짜를 선택하거나 항목을 선택해주세요',
  'pages.settlement.memberRechargeReview.exportSuccess': '{count}건의 데이터를 내보냈습니다',
  'pages.settlement.memberRechargeReview.receivingBankInfo': '수취 은행 정보',

  // Settlement - Member Withdrawal Review,
  'pages.settlement.memberWithdrawalReview.filter.pendingReview': '심사 대기',
  'pages.settlement.memberWithdrawalReview.filter.approvalSuccessful': '심사 성공',
  'pages.settlement.memberWithdrawalReview.filter.reviewFailed': '심사 실패',
  'pages.settlement.memberWithdrawalReview.column.userId': '회원 ID',
  'pages.settlement.memberWithdrawalReview.column.user': '회원',
  'pages.settlement.memberWithdrawalReview.column.handlingFee': '수수료',
  'pages.settlement.memberWithdrawalReview.column.withdrawalAmount': '출금 금액',
  'pages.settlement.memberWithdrawalReview.column.amountReceived': '입금 금액',
  'pages.settlement.memberWithdrawalReview.column.bankCardName': '은행 카드 이름',
  'pages.settlement.memberWithdrawalReview.column.bankCardNumber': '은행 카드 계좌번호',
  'pages.settlement.memberWithdrawalReview.column.bankCardHolder': '은행 카드 소유자',
  'pages.settlement.memberWithdrawalReview.column.withdrawalTime': '출금 시간',
  'pages.settlement.memberWithdrawalReview.approve': '심사 성공',
  'pages.settlement.memberWithdrawalReview.reject': '심사 실패',
  'pages.settlement.memberWithdrawalReview.approveConfirm': '승인하시겠습니까?',
  'pages.settlement.memberWithdrawalReview.approveContent': '회원 "{name}"의 {amount}원 출금을 승인하시겠습니까?',
  'pages.settlement.memberWithdrawalReview.approved': '승인되었습니다',
  'pages.settlement.memberWithdrawalReview.rejectTitle': '심사 실패 사유 입력',
  'pages.settlement.memberWithdrawalReview.rejectionReason': '거부 사유',
  'pages.settlement.memberWithdrawalReview.rejectionReasonRequired': '거부 사유를 입력해주세요',
  'pages.settlement.memberWithdrawalReview.rejectionReasonPlaceholder': '거부 사유를 입력해주세요',
  'pages.settlement.memberWithdrawalReview.rejected': '거부되었습니다',
  'pages.settlement.memberWithdrawalReview.rejectError': '오류가 발생했습니다',
  'pages.settlement.memberWithdrawalReview.viewReason': '사유 확인',
  'pages.settlement.memberWithdrawalReview.viewReasonTitle': '심사 실패 사유',
  'pages.settlement.memberWithdrawalReview.withdrawalFeeSettings': '출금 수수료 설정',
  'pages.settlement.memberWithdrawalReview.feeSettingName': '이름',
  'pages.settlement.memberWithdrawalReview.feeSettingNameRequired': '이름을 입력해주세요',
  'pages.settlement.memberWithdrawalReview.feeType': '수수료 유형',
  'pages.settlement.memberWithdrawalReview.feeTypeRequired': '수수료 유형을 선택해주세요',
  'pages.settlement.memberWithdrawalReview.feeTypeNone': '① 수수료=0',
  'pages.settlement.memberWithdrawalReview.feeTypePercentage': '② 수수료=출금 금액×수수료 비율',
  'pages.settlement.memberWithdrawalReview.feeTypeFixed': '③ 수수료=고정 출금 수수료',
  'pages.settlement.memberWithdrawalReview.feeRate': '수수료 비율',
  'pages.settlement.memberWithdrawalReview.feeRateRequired': '수수료 비율을 입력해주세요',
  'pages.settlement.memberWithdrawalReview.fixedFee': '고정 출금 수수료',
  'pages.settlement.memberWithdrawalReview.fixedFeeRequired': '고정 출금 수수료를 입력해주세요',
  'pages.settlement.memberWithdrawalReview.minWithdrawalAmount': '최소 출금 금액',
  'pages.settlement.memberWithdrawalReview.minWithdrawalAmountRequired': '최소 출금 금액을 입력해주세요',
  'pages.settlement.memberWithdrawalReview.maxWithdrawalAmount': '최대 출금 금액',
  'pages.settlement.memberWithdrawalReview.maxWithdrawalAmountRequired': '최대 출금 금액을 입력해주세요',
  'pages.settlement.memberWithdrawalReview.feeSettingsList': '수수료 설정 목록',
  'pages.settlement.memberWithdrawalReview.feeSettingAdded': '수수료 설정이 추가되었습니다',
  'pages.settlement.memberWithdrawalReview.feeSettingError': '오류가 발생했습니다',
  'pages.settlement.memberWithdrawalReview.minMaxAmount': '최소/최대 출금 금액',
  'pages.settlement.memberWithdrawalReview.financialTaxReport': '재무 세금 신고서',
  'pages.settlement.memberWithdrawalReview.taxReportDownloaded': '재무 세금 신고서가 다운로드되었습니다',

  // ── Member Recharge Review (new design) ──────────────────────
  'pages.settlement.memberRechargeReview.header.title': '예치금 신청 내역',
  'pages.settlement.memberRechargeReview.list.title': '예치금 신청 내역 리스트',
  'pages.settlement.memberRechargeReview.period.today': '금일',
  'pages.settlement.memberRechargeReview.period.month': '이번달',
  'pages.settlement.memberRechargeReview.period.quarter': '이번분기',
  'pages.settlement.memberRechargeReview.period.year': '올해',
  'pages.settlement.memberRechargeReview.period.todayRecharge': '금일 충전 신청',
  'pages.settlement.memberRechargeReview.period.todayWithdraw': '금일 출금 신청',
  'pages.settlement.memberRechargeReview.stat.amount': '금액',
  'pages.settlement.memberRechargeReview.stat.count': '건수',
  'pages.settlement.memberRechargeReview.chart.rechargeAmount': '충전금액',
  'pages.settlement.memberRechargeReview.chart.withdrawAmount': '출금금액',
  'pages.settlement.memberRechargeReview.chart.rechargeCount': '충전건수',
  'pages.settlement.memberRechargeReview.chart.withdrawCount': '출금건수',
  'pages.settlement.memberRechargeReview.info.description': '본 파트는 예치금 충전 및 출금 내역 입니다.',
  'pages.settlement.memberRechargeReview.info.relation': '무통장 입금 및 출금과 관련이 됩니다.',
  'pages.settlement.memberRechargeReview.viewMode.detail': '상세보기',
  'pages.settlement.memberRechargeReview.viewMode.summary': '요약보기',
  'pages.settlement.memberRechargeReview.filter.startTime': '시작시간',
  'pages.settlement.memberRechargeReview.filter.endTime': '마감시간',
  'pages.settlement.memberRechargeReview.filter.applicationType': '신청유형',
  'pages.settlement.memberRechargeReview.filter.completionStatus': '처리상태',
  'pages.settlement.memberRechargeReview.filter.search': '검색',
  'pages.settlement.memberRechargeReview.filter.mailbox': '사서함',
  'pages.settlement.memberRechargeReview.filter.orderNumber': '주문번호',
  'pages.settlement.memberRechargeReview.filter.memberName': '회원명',
  'pages.settlement.memberRechargeReview.filter.financeManager': '재무담당',
  'pages.settlement.memberRechargeReview.applicationType.recharge': '충전',
  'pages.settlement.memberRechargeReview.applicationType.withdraw': '출금',
  'pages.settlement.memberRechargeReview.completionStatus.pending': '승인 대기',
  'pages.settlement.memberRechargeReview.completionStatus.completed': '승인 완료',
  'pages.settlement.memberRechargeReview.completionStatus.cancelled': '거절',
  'pages.settlement.memberRechargeReview.completionStatus.rejected': '거절',
  'pages.settlement.memberRechargeReview.column.no': '번호',
  'pages.settlement.memberRechargeReview.column.mailboxMember': '사서함 / 회원명',
  'pages.settlement.memberRechargeReview.column.applicationTypeAndDate': '신청유형 / 신청일시',
  'pages.settlement.memberRechargeReview.column.depositBalance': '예치금잔액',
  'pages.settlement.memberRechargeReview.column.rechargeAmountSerial': '[신청] 충전금액 / 충전 일련번호',
  'pages.settlement.memberRechargeReview.column.depositorName': '충전신청 입금자명',
  'pages.settlement.memberRechargeReview.column.matchedDepositorAdmin': '입금자명 수동매칭 / 관리자',
  'pages.settlement.memberRechargeReview.column.withdrawalAmountSerial': '[신청] 출금금액 / 출금 일련번호',
  'pages.settlement.memberRechargeReview.column.withdrawalRecipient': '출금신청 수취인명 / 은행명 / 계좌번호',
  'pages.settlement.memberRechargeReview.column.balanceAfter': '변동후 잔액',
  'pages.settlement.memberRechargeReview.column.completionStatusAndDate': '처리상태 / 처리일시',
  'pages.settlement.memberRechargeReview.column.financeAdminCheckedAt': '재무담당 확인일시',
  'pages.settlement.memberRechargeReview.action.edit': '편집',
  'pages.settlement.memberRechargeReview.action.confirm': '승인',
  'pages.settlement.memberRechargeReview.action.cancel': '취소',
  'pages.settlement.memberRechargeReview.action.approve': '승인',
  'pages.settlement.memberRechargeReview.action.reject': '거절',
  'pages.settlement.memberRechargeReview.confirmInfoRequired': '정보, 금액 확인이 필요합니다.',
  'pages.settlement.memberRechargeReview.fetchError': '예치금 신청 내역을 불러오는데 실패했습니다',
  'pages.settlement.memberRechargeReview.updateRemitterError': '입금자명 수정에 실패했습니다',
  'pages.settlement.memberRechargeReview.confirmModal.title': '예치금 신청 승인',
  'pages.settlement.memberRechargeReview.confirmModal.mailbox': '사서함',
  'pages.settlement.memberRechargeReview.confirmModal.memberName': '회원명',
  'pages.settlement.memberRechargeReview.confirmModal.type': '구분',
  'pages.settlement.memberRechargeReview.confirmModal.amount': '금액',
  'pages.settlement.memberRechargeReview.confirmModal.amountRequired': '금액을 입력하세요.',
  'pages.settlement.memberRechargeReview.confirmModal.confirmInfo': '신청 정보와 금액을 확인했습니다',
  'pages.settlement.memberRechargeReview.confirmModal.confirmInfoRequired': '정보, 금액 확인이 필요합니다.',
  'pages.settlement.memberRechargeReview.confirmModal.ok': '승인',
  'pages.settlement.memberRechargeReview.confirmModal.cancel': '취소',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.open': '대행 출금 등록',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.title': '대행 출금 등록',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.hint':
    '로그인이 불가한 비회원(게스트) 주문의 환불금을 계좌로 지급할 때 사용합니다. 예치금에서 차감되어 출금건이 만들어지고, 실제 이체 후 승인 처리하면 완료됩니다.',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.orderNumber': '주문번호',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.orderNumberPlaceholder': '환불 주문번호',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.orderNumberRequired': '주문번호를 입력하세요',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.amount': '출금금액',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.amountRequired': '출금금액을 입력하세요',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.bankName': '은행',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.accountNumber': '계좌번호',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.accountHolder': '예금주',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.description': '메모',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.descriptionPlaceholder':
    '계좌 확인 경로 등 (선택)',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.ok': '등록',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.success': '대행 출금건이 등록되었습니다',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.error': '대행 출금 등록에 실패했습니다',
  'pages.settlement.memberRechargeReview.editDepositorModal.title': '입금자명 수동매칭',
  'pages.settlement.memberRechargeReview.editDepositorModal.original': '원본 입금자명',
  'pages.settlement.memberRechargeReview.editDepositorModal.matched': '수동매칭 입금자명',
  'pages.settlement.memberRechargeReview.editDepositorModal.matchedPlaceholder': '수동매칭 입금자명',
  'pages.settlement.memberRechargeReview.editDepositorModal.admin': '처리 관리자',
  'pages.settlement.memberRechargeReview.editDepositorModal.adminPlaceholder': '관리자명',
  'pages.settlement.memberRechargeReview.editDepositorModal.success': '입금자명 수동매칭 정보가 저장되었습니다.',
  'pages.settlement.memberRechargeReview.editDepositorModal.save': '저장',

  // ── Member Withdrawal Review (new design) ────────────────────
  'pages.settlement.memberWithdrawalReview.header.title': '예치금 사용 내역',
  'pages.settlement.memberWithdrawalReview.list.title': '[세금정산관리용] 예치금 사용 내역 리스트',
  'pages.settlement.memberWithdrawalReview.stat.todayBalance': '금일 잔액',
  'pages.settlement.memberWithdrawalReview.stat.lastMonthEndBalance': '전월 말 잔액',
  'pages.settlement.memberWithdrawalReview.stat.monthlyBalance': '월별 잔액',
  'pages.settlement.memberWithdrawalReview.stat.todayRecharge': '금일 충전',
  'pages.settlement.memberWithdrawalReview.stat.thisMonthRecharge': '이번달 충전',
  'pages.settlement.memberWithdrawalReview.stat.monthlyRecharge': '월별 충전',
  'pages.settlement.memberWithdrawalReview.stat.todayWithdraw': '금일 출금',
  'pages.settlement.memberWithdrawalReview.stat.thisMonthWithdraw': '이번달 출금',
  'pages.settlement.memberWithdrawalReview.stat.monthlyWithdraw': '월별 출금',
  'pages.settlement.memberWithdrawalReview.stat.todayUse': '금일 사용',
  'pages.settlement.memberWithdrawalReview.stat.thisMonthUse': '이번달 사용',
  'pages.settlement.memberWithdrawalReview.stat.monthlyUse': '월별 사용',
  'pages.settlement.memberWithdrawalReview.stat.todayDeduct': '금일 차감',
  'pages.settlement.memberWithdrawalReview.stat.thisMonthDeduct': '이번달 차감',
  'pages.settlement.memberWithdrawalReview.stat.monthlyDeduct': '월별 차감',
  'pages.settlement.memberWithdrawalReview.stat.todayEarn': '금일 적립',
  'pages.settlement.memberWithdrawalReview.stat.thisMonthEarn': '이번달 적립',
  'pages.settlement.memberWithdrawalReview.stat.monthlyEarn': '월별 적립',
  'pages.settlement.memberWithdrawalReview.category.order': '주문',
  'pages.settlement.memberWithdrawalReview.category.bankRefund': '무통장환불',
  'pages.settlement.memberWithdrawalReview.category.rebate': '리베이트',
  'pages.settlement.memberWithdrawalReview.category.share': '공유',
  'pages.settlement.memberWithdrawalReview.viewMode.detail': '상세보기',
  'pages.settlement.memberWithdrawalReview.viewMode.summary': '요약보기',
  'pages.settlement.memberWithdrawalReview.filter.startTime': '시작시간',
  'pages.settlement.memberWithdrawalReview.filter.endTime': '마감시간',
  'pages.settlement.memberWithdrawalReview.filter.earningCategory': '적립구분',
  'pages.settlement.memberWithdrawalReview.filter.earningOption.bankRefund': '무통장 환불',
  'pages.settlement.memberWithdrawalReview.filter.earningOption.rebate': '리베이트 적립',
  'pages.settlement.memberWithdrawalReview.filter.earningOption.share': '공유 적립',
  'pages.settlement.memberWithdrawalReview.filter.deductionCategory': '차감구분',
  'pages.settlement.memberWithdrawalReview.filter.deductionOption.order': '주문',
  'pages.settlement.memberWithdrawalReview.filter.deductionOption.rebate': '리베이트 차감',
  'pages.settlement.memberWithdrawalReview.filter.deductionOption.share': '공유 차감',
  'pages.settlement.memberWithdrawalReview.filter.bankCategory': '무통장 충전/출금',
  'pages.settlement.memberWithdrawalReview.filter.bankOption.recharge': '충전',
  'pages.settlement.memberWithdrawalReview.filter.bankOption.withdraw': '출금',
  'pages.settlement.memberWithdrawalReview.filter.serialSearch': '일련번호검색',
  'pages.settlement.memberWithdrawalReview.filter.serialPlaceholder': '필터링 선택후 일련번호 입력...',
  'pages.settlement.memberWithdrawalReview.filter.mailbox': '사서함',
  'pages.settlement.memberWithdrawalReview.filter.orderNumber': '주문번호',
  'pages.settlement.memberWithdrawalReview.filter.memberName': '회원명',
  'pages.settlement.memberWithdrawalReview.filter.memo': '메모',
  'pages.settlement.memberWithdrawalReview.filter.search': '검색',
  'pages.settlement.memberWithdrawalReview.column.no': '번호',
  'pages.settlement.memberWithdrawalReview.column.mailboxMember': '사서함 / 회원명',
  'pages.settlement.memberWithdrawalReview.column.memo': '메모',
  'pages.settlement.memberWithdrawalReview.column.carryover': '이월잔액',
  'pages.settlement.memberWithdrawalReview.column.bankRefund': '무통장 환불 번호 / 무통장 환부 금액 / 일시',
  'pages.settlement.memberWithdrawalReview.column.rebateEarn': '리베이트 적립 번호 / 리베이트 적립 금액 / 일시',
  'pages.settlement.memberWithdrawalReview.column.shareEarn': '공유 적립 번호 / 공유 적립 금액 / 일시',
  'pages.settlement.memberWithdrawalReview.column.bankRecharge': '무통장 충전 번호 / 무통장 충전 금액 / 일시',
  'pages.settlement.memberWithdrawalReview.column.order': '주문번호 / 주문사용금액 / 일시',
  'pages.settlement.memberWithdrawalReview.column.rebateDeduct': '리베이트 차감 번호 / 리베이트 차감 금액 / 일시',
  'pages.settlement.memberWithdrawalReview.column.shareDeduct': '공유 차감 번호 / 공유 차감 금액 / 일시',
  'pages.settlement.memberWithdrawalReview.column.bankWithdraw': '무통장 출금 번호 / 무통장 출금 금액 / 일시',
  'pages.settlement.memberWithdrawalReview.column.balanceAfter': '변동후 잔액',
  'pages.settlement.memberWithdrawalReview.column.adminChangedAt': '관리자 변동일시',
  'pages.settlement.memberWithdrawalReview.legend.earning': '● 적립(플러스) 금액',
  'pages.settlement.memberWithdrawalReview.legend.deduction': '● 차감(마이너스) 금액',

  // Settlement - Financial Tax Report
  'pages.settlement.financialTaxReport.title': '재무 세금 신고서',
  'pages.settlement.financialTaxReport.column.date': '날짜',
  'pages.settlement.financialTaxReport.column.transactionType': '거래 유형',
  'pages.settlement.financialTaxReport.column.amount': '금액',
  'pages.settlement.financialTaxReport.column.description': '설명',
  'pages.settlement.financialTaxReport.column.taxAmount': '세금 금액',
  'pages.settlement.financialTaxReport.download': '다운로드',
  'pages.settlement.financialTaxReport.downloadSuccess': '재무 세금 신고서가 다운로드되었습니다',
  
  // Settlement - Management
  'pages.settlement.management.title': '재무관리',
  'pages.settlement.management.breadcrumb': '재무관리',
  'pages.settlement.management.tab.platformCommission': '플랫폼 수수료',
  'pages.settlement.management.tab.sellers': '판매자 정산',
  'pages.settlement.management.platform.content': '플랫폼 수수료 정산 내역',
  'pages.settlement.management.platform.description': '월별 수수료 수익 및 통계',
  'pages.settlement.management.sellers.content': '판매자 정산 처리',
  'pages.settlement.management.sellers.description': '판매자별 정산 내역 및 처리',
  
  // Logistics - Batch Tracking
  'pages.logistics.batchTracking.title': '운송장 일괄 등록',
  'pages.logistics.batchTracking.subTitle': '엑셀 파일로 여러 주문의 운송장을 한번에 등록할 수 있습니다',
  'pages.logistics.batchTracking.selectFile': '파일을 선택해주세요',
  'pages.logistics.batchTracking.uploadSuccess': '파일 업로드 완료',
  'pages.logistics.batchTracking.processSuccess': '운송장 등록이 완료되었습니다',
  'pages.logistics.batchTracking.downloadTemplateSuccess': '템플릿 파일 다운로드를 시작합니다',
  'pages.logistics.batchTracking.downloadTemplate': '템플릿 다운로드',
  'pages.logistics.batchTracking.uploadFile': '파일 업로드',
  'pages.logistics.batchTracking.manualInput': '수동 입력',
  'pages.logistics.batchTracking.selectExcelFile': '엑셀 파일 선택',
  'pages.logistics.batchTracking.noErrors': '오류가 없습니다',
  'pages.logistics.batchTracking.downloadErrorsSuccess': '{count}건의 오류 데이터를 다운로드합니다',
  'pages.logistics.batchTracking.downloadErrors': '오류 데이터 다운로드',
  'pages.logistics.batchTracking.customer': '회원{num}',
  'pages.logistics.batchTracking.error.emptyTrackingNumber': '운송장번호가 비어있습니다',
  'pages.logistics.batchTracking.notEntered': '미입력',
  'pages.logistics.batchTracking.step.upload.title': '파일 업로드',
  'pages.logistics.batchTracking.step.upload.description': '엑셀 파일 선택',
  'pages.logistics.batchTracking.step.review.title': '데이터 확인',
  'pages.logistics.batchTracking.step.review.description': '업로드된 데이터 검증',
  'pages.logistics.batchTracking.step.complete.title': '등록 완료',
  'pages.logistics.batchTracking.step.complete.description': '운송장 등록 완료',
  'pages.logistics.batchTracking.uploadGuide.title': '엑셀 파일 업로드 안내',
  'pages.logistics.batchTracking.uploadGuide.format': '• 지원 형식: .xlsx, .xls',
  'pages.logistics.batchTracking.uploadGuide.columns': '• 필수 컬럼: 주문번호, 운송장번호, 택배사, 출고일자',
  'pages.logistics.batchTracking.uploadGuide.maxCount': '• 최대 1,000건까지 한번에 등록 가능',
  'pages.logistics.batchTracking.uploadGuide.template': '• 템플릿 파일을 다운로드하여 양식에 맞게 작성해주세요',
  'pages.logistics.batchTracking.column.status': '상태',
  'pages.logistics.batchTracking.column.orderNo': '주문번호',
  'pages.logistics.batchTracking.column.customerName': '회원명',
  'pages.logistics.batchTracking.column.productCount': '상품수',
  'pages.logistics.batchTracking.column.trackingNumber': '운송장번호',
  'pages.logistics.batchTracking.column.carrier': '택배사',
  'pages.logistics.batchTracking.column.shippingDate': '출고일자',
  'pages.logistics.batchTracking.column.errorMessage': '오류 메시지',
  'pages.logistics.batchTracking.status.success': '성공',
  'pages.logistics.batchTracking.status.error': '오류',
  'pages.logistics.batchTracking.status.pending': '대기',
  'pages.logistics.batchTracking.stat.total': '전체',
  'pages.logistics.batchTracking.stat.success': '정상',
  'pages.logistics.batchTracking.stat.error': '오류',
  'pages.logistics.batchTracking.stat.pending': '대기',
  'pages.logistics.batchTracking.errorsFound': '{count}건의 오류가 발견되었습니다',
  'pages.logistics.batchTracking.errorsDescription': '오류가 있는 항목은 등록되지 않습니다. 오류 데이터를 다운로드하여 수정 후 다시 업로드해주세요.',
  'pages.logistics.batchTracking.uploadedData': '업로드된 데이터 ({count}건)',
  'pages.logistics.batchTracking.reupload': '다시 업로드',
  'pages.logistics.batchTracking.registerTracking': '운송장 등록 ({count}건)',
  'pages.logistics.batchTracking.completeTitle': '운송장 등록이 완료되었습니다',
  'pages.logistics.batchTracking.completeDescription': '총 {count}건의 운송장이 성공적으로 등록되었습니다',
  'pages.logistics.batchTracking.errorsExist': '{count}건의 오류가 있습니다',
  'pages.logistics.batchTracking.errorsNotRegistered': '오류가 있는 항목은 등록되지 않았습니다',
  'pages.logistics.batchTracking.registerAgain': '새로 등록하기',
  'pages.logistics.batchTracking.goToOrders': '주문 관리로 이동',
  'pages.logistics.batchTracking.resultDetail': '등록 결과 상세',
  'pages.logistics.batchTracking.manualInputModal.title': '운송장 수동 입력',
  'pages.logistics.batchTracking.manualInputModal.orderNo': '주문번호',
  'pages.logistics.batchTracking.manualInputModal.trackingNumber': '운송장번호',
  'pages.logistics.batchTracking.manualInputModal.selectCarrier': '택배사 선택',
  'pages.logistics.batchTracking.manualInputModal.shippingDate': '출고일자',
  'pages.logistics.batchTracking.manualInputModal.memo': '메모 (선택사항)',
  'pages.logistics.batchTracking.manualInputSuccess': '운송장이 등록되었습니다',
  'pages.logistics.batchTracking.carrier.cj': 'CJ대한통운',
  'pages.logistics.batchTracking.carrier.post': '우체국택배',
  'pages.logistics.batchTracking.carrier.hanjin': '한진택배',
  'pages.logistics.batchTracking.carrier.logen': '로젠택배',
  'pages.logistics.batchTracking.carrier.kdexp': '경동택배',
  
  // Logistics - Forwarders
  'pages.logistics.forwarders.title': '배대지 관리',
  'pages.logistics.forwarders.addForwarder': '배대지 추가',
  'pages.logistics.forwarders.deleteTitle': '배대지 삭제',
  'pages.logistics.forwarders.deleteConfirm': '"{name}" 배대지를 삭제하시겠습니까?',
  'pages.logistics.forwarders.deleteSuccess': '배대지가 삭제되었습니다',
  'pages.logistics.forwarders.updateSuccess': '배대지 정보가 수정되었습니다',
  'pages.logistics.forwarders.createSuccess': '배대지가 등록되었습니다',
  'pages.logistics.forwarders.apiTestLoading': 'API 연결 테스트 중...',
  'pages.logistics.forwarders.apiTestSuccess': 'API 연결 성공!',
  'pages.logistics.forwarders.apiSaveSuccess': 'API 설정이 저장되었습니다',
  'pages.logistics.forwarders.syncLoading': '동기화 중...',
  'pages.logistics.forwarders.syncSuccess': '{name} 데이터 동기화 완료',
  'pages.logistics.forwarders.column.id': 'ID',
  'pages.logistics.forwarders.column.name': '배대지명',
  'pages.logistics.forwarders.column.code': '배대지 코드',
  'pages.logistics.forwarders.column.apiStatus': 'API 상태',
  'pages.logistics.forwarders.column.shippingMethods': '배송 방법',
  'pages.logistics.forwarders.column.pricePerKg': '단가 (kg당)',
  'pages.logistics.forwarders.column.contactPerson': '담당자',
  'pages.logistics.forwarders.column.phone': '연락처',
  'pages.logistics.forwarders.column.totalOrders': '총 주문수',
  'pages.logistics.forwarders.column.lastSync': '최종 동기화',
  'pages.logistics.forwarders.column.status': '상태',
  'pages.logistics.forwarders.column.action': '작업',
  'pages.logistics.forwarders.type.domestic': '국내',
  'pages.logistics.forwarders.type.international': '국제',
  'pages.logistics.forwarders.apiStatus.connected': '연결됨',
  'pages.logistics.forwarders.apiStatus.disconnected': '미연결',
  'pages.logistics.forwarders.apiStatus.error': '오류',
  'pages.logistics.forwarders.status.active': '활성',
  'pages.logistics.forwarders.status.inactive': '비활성',
  'pages.logistics.forwarders.action.apiConfig': 'API 설정',
  'pages.logistics.forwarders.action.sync': '동기화',
  'pages.logistics.forwarders.stat.totalForwarders': '전체 배대지',
  'pages.logistics.forwarders.stat.apiConnected': 'API 연결',
  'pages.logistics.forwarders.stat.ordersThisMonth': '이번 달 주문',
  'pages.logistics.forwarders.stat.avgPrice': '평균 단가',
  'pages.logistics.forwarders.stat.avgPriceSuffix': '원/kg',
  'pages.logistics.forwarders.modal.addTitle': '배대지 추가',
  'pages.logistics.forwarders.modal.editTitle': '배대지 수정',
  'pages.logistics.forwarders.tab.basic': '기본 정보',
  'pages.logistics.forwarders.tab.contact': '담당자 정보',
  'pages.logistics.forwarders.tab.memo': '메모',
  'pages.logistics.forwarders.form.name': '배대지명',
  'pages.logistics.forwarders.form.nameRequired': '배대지명을 입력하세요',
  'pages.logistics.forwarders.form.namePlaceholder': '예: CJ대한통운',
  'pages.logistics.forwarders.form.code': '배대지 코드',
  'pages.logistics.forwarders.form.codeRequired': '코드를 입력하세요',
  'pages.logistics.forwarders.form.codePlaceholder': '예: CJ',
  'pages.logistics.forwarders.form.type': '유형',
  'pages.logistics.forwarders.form.typePlaceholder': '유형 선택',
  'pages.logistics.forwarders.form.pricePerKg': '단가 (kg당)',
  'pages.logistics.forwarders.form.shippingMethods': '배송 방법',
  'pages.logistics.forwarders.form.shippingMethodsPlaceholder': '배송 방법 선택',
  'pages.logistics.forwarders.form.address': '주소',
  'pages.logistics.forwarders.form.addressPlaceholder': '배대지 주소',
  'pages.logistics.forwarders.form.status': '상태',
  'pages.logistics.forwarders.form.contactPerson': '담당자명',
  'pages.logistics.forwarders.form.contactPersonPlaceholder': '담당자명',
  'pages.logistics.forwarders.form.phone': '연락처',
  'pages.logistics.forwarders.form.phonePlaceholder': '02-1234-5678',
  'pages.logistics.forwarders.form.email': '이메일',
  'pages.logistics.forwarders.form.emailPlaceholder': 'email@example.com',
  'pages.logistics.forwarders.form.memo': '관리자 메모',
  'pages.logistics.forwarders.form.memoPlaceholder': '메모를 입력하세요',
  'pages.logistics.forwarders.shippingMethod.air': '항공',
  'pages.logistics.forwarders.shippingMethod.airExpress': '항공특송',
  'pages.logistics.forwarders.shippingMethod.ship': '배',
  'pages.logistics.forwarders.shippingMethod.shipExpress': '배특송',
  'pages.logistics.forwarders.apiModal.title': 'API 설정 - {name}',
  'pages.logistics.forwarders.apiModal.alertTitle': 'API 연동 안내',
  'pages.logistics.forwarders.apiModal.alertDescription': '배대지 API를 연동하면 운송장 자동 조회 및 배송 상태 실시간 업데이트가 가능합니다.',
  'pages.logistics.forwarders.apiModal.apiKey': 'API Key',
  'pages.logistics.forwarders.apiModal.apiKeyRequired': 'API Key를 입력하세요',
  'pages.logistics.forwarders.apiModal.apiKeyPlaceholder': 'API Key를 입력하세요',
  'pages.logistics.forwarders.apiModal.trackingUrl': '운송장 조회 URL',
  'pages.logistics.forwarders.apiModal.trackingUrlInvalid': '올바른 URL을 입력하세요',
  'pages.logistics.forwarders.apiModal.trackingUrlPlaceholder': 'https://api.example.com/tracking',
  'pages.logistics.forwarders.apiModal.webhookUrl': 'Webhook URL (선택)',
  'pages.logistics.forwarders.apiModal.webhookUrlPlaceholder': 'https://your-domain.com/webhook',
  'pages.logistics.forwarders.apiModal.timeout': '타임아웃 (초)',
  'pages.logistics.forwarders.apiModal.testButton': 'API 연결 테스트',
  'pages.logistics.forwarders.simple.title': '배대지 관리',
  'pages.logistics.forwarders.simple.breadcrumb.logistics': '물류관리',
  'pages.logistics.forwarders.simple.breadcrumb.forwarders': '배대지 관리',
  'pages.logistics.forwarders.simple.description': '배송대행지 정보 관리',
  'pages.logistics.forwarders.simple.subDescription': '배대지 추가, 수정, 삭제 및 정보 관리',
  'pages.logistics.forwarders.mock.cjName': 'CJ대한통운',
  'pages.logistics.forwarders.mock.cjContact': '김대리',
  'pages.logistics.forwarders.mock.cjAddress': '서울시 중구 세종대로 39',
  'pages.logistics.forwarders.mock.cjMemo': 'CJ대한통운 메인 계정',
  'pages.logistics.forwarders.mock.postName': '우체국택배',
  'pages.logistics.forwarders.mock.postContact': '이과장',
  'pages.logistics.forwarders.mock.postAddress': '서울시 종로구 우정국로 26',
  'pages.logistics.forwarders.mock.postMemo': '우체국택배 계정',
  'pages.logistics.forwarders.mock.hanjinName': '한진택배',
  'pages.logistics.forwarders.mock.hanjinContact': '박부장',
  'pages.logistics.forwarders.mock.hanjinAddress': '서울시 강남구 테헤란로 152',
  'pages.logistics.forwarders.mock.hanjinMemo': '한진택배 계정',
  'pages.logistics.forwarders.mock.logenName': '로젠택배',
  'pages.logistics.forwarders.mock.logenContact': '최대리',
  'pages.logistics.forwarders.mock.logenAddress': '서울시 송파구 올림픽로 289',
  'pages.logistics.forwarders.mock.logenMemo': 'API 연동 대기중',
  'pages.logistics.forwarders.mock.dhlAddress': '서울시 강남구 영동대로 517',
  'pages.logistics.forwarders.mock.dhlMemo': 'DHL 국제특송',
  'pages.logistics.forwarders.mock.fedexAddress': '서울시 중구 세종대로 136',
  'pages.logistics.forwarders.mock.fedexMemo': 'API 오류 발생 - 확인 필요',
  
  // Logistics - Rack Management
  'pages.logistics.rack.title': '랙 관리',
  'pages.logistics.rack.addRack': '랙 추가',
  'pages.logistics.rack.addRackSingle': '단일 랙 추가',
  'pages.logistics.rack.batchCreate': '일괄 추가 (열)',
  'pages.logistics.rack.batchUnavailable': '일괄 사용 불가',
  'pages.logistics.rack.batch.modalTitle': '랙 일괄 추가 (열)',
  'pages.logistics.rack.batch.columnFrom': '열 시작',
  'pages.logistics.rack.batch.columnTo': '열 끝',
  'pages.logistics.rack.batch.create': '생성',
  'pages.logistics.rack.batch.columnRangeError': '열 시작은 열 끝보다 작거나 같아야 합니다',
  'pages.logistics.rack.batch.maxColumnsWarning': '한 번에 100개 이상의 랙을 생성하면 시간이 걸릴 수 있습니다.',
  'pages.logistics.rack.batch.createSuccess': '{count}개의 랙이 생성되었습니다',
  'pages.logistics.rack.batch.createPartialError': '{count}개의 랙 생성에 실패했습니다',
  'pages.logistics.rack.exportStatus': '랙 현황 내보내기',
  'pages.logistics.rack.deleteTitle': '랙 삭제',
  'pages.logistics.rack.deleteConfirm': '"{code}" 랙을 삭제하시겠습니까?',
  'pages.logistics.rack.deleteSuccess': '랙이 삭제되었습니다',
  'pages.logistics.rack.deleteError': '랙 삭제 실패',
  'pages.logistics.rack.batchDelete': '일괄 삭제',
  'pages.logistics.rack.batchDeleteTitle': '랙 일괄 삭제',
  'pages.logistics.rack.batchDeleteConfirm': '{count}개의 랙을 삭제하시겠습니까?',
  'pages.logistics.rack.batchDeleteSuccess': '{count}개의 랙이 삭제되었습니다',
  'pages.logistics.rack.batchDeletePartialSuccess': '{deleted}개의 랙이 삭제되었고, {failed}개가 실패했습니다',
  'pages.logistics.rack.batchDeleteError': '랙 삭제 실패',
  'pages.logistics.rack.selectRacksToDelete': '삭제할 랙을 선택해주세요',
  'pages.logistics.rack.cannotDeleteRacksWithProducts': '제품이 있는 {count}개의 랙은 삭제할 수 없습니다',
  'pages.logistics.rack.cannotDeleteInactiveRacks': '비활성화된 {count}개의 랙은 삭제할 수 없습니다',
  'pages.logistics.rack.noValidRacksToDelete': '삭제할 유효한 랙이 없습니다',
  'pages.logistics.rack.updateSuccess': '랙 정보가 수정되었습니다',
  'pages.logistics.rack.createSuccess': '랙이 등록되었습니다',
  'pages.logistics.rack.printQRSuccess': '{code} QR 코드 출력 준비 중...',
  'pages.logistics.rack.column.id': 'ID',
  'pages.logistics.rack.column.rackCode': '랙 코드',
  'pages.logistics.rack.column.warehouse': '창고',
  'pages.logistics.rack.column.zone': '구역',
  'pages.logistics.rack.column.location': '위치',
  'pages.logistics.rack.column.trackingNumbers': '운송장 번호',
  'pages.logistics.rack.column.row': '행',
  'pages.logistics.rack.column.column': '열',
  'pages.logistics.rack.column.level': '층',
  'pages.logistics.rack.column.capacity': '용량',
  'pages.logistics.rack.column.productCount': '상품 수',
  'pages.logistics.rack.column.status': '상태',
  'pages.logistics.rack.column.environment': '환경',
  'pages.logistics.rack.column.lastUpdated': '최종 업데이트',
  'pages.logistics.rack.column.action': '작업',
  'pages.logistics.rack.warehouse.weihai': '위해',
  'pages.logistics.rack.warehouse.qingdao': '청도',
  'pages.logistics.rack.warehouse.guangzhou': '광저우',
  'pages.logistics.rack.warehouse.yiwu': '이우',
  'pages.logistics.rack.zone.A': 'A구역',
  'pages.logistics.rack.zone.B': 'B구역',
  'pages.logistics.rack.zone.C': 'C구역',
  'pages.logistics.rack.zone.D': 'D구역',
  'pages.logistics.rack.zone.E': 'E구역',
  'pages.logistics.rack.location.row': '행',
  'pages.logistics.rack.location.column': '열',
  'pages.logistics.rack.location.level': '층',
  'pages.logistics.rack.capacity.inUse': '사용중',
  'pages.logistics.rack.status.available': '사용가능',
  'pages.logistics.rack.status.full': '만석',
  'pages.logistics.rack.status.maintenance': '이용중',
  'pages.logistics.rack.status.reserved': '예약됨',
  'pages.logistics.rack.environment.temperature': '온도',
  'pages.logistics.rack.environment.humidity': '습도',
  'pages.logistics.rack.action.viewInventory': '재고보기',
  'pages.logistics.rack.inventory.empty': '이 랙에 재고 항목이 없습니다.',
  'pages.logistics.rack.stat.totalRacks': '전체 랙',
  'pages.logistics.rack.stat.available': '사용 가능',
  'pages.logistics.rack.stat.full': '만석',
  'pages.logistics.rack.stat.maintenance': '이용중',
  'pages.logistics.rack.modal.addTitle': '랙 추가',
  'pages.logistics.rack.modal.editTitle': '랙 정보 수정',
  'pages.logistics.rack.form.warehouse': '창고',
  'pages.logistics.rack.form.warehousePlaceholder': '창고 선택',
  'pages.logistics.rack.form.zone': '구역',
  'pages.logistics.rack.form.zonePlaceholder': '구역 선택',
  'pages.logistics.rack.form.row': '행',
  'pages.logistics.rack.form.rowPlaceholder': '예: 01',
  'pages.logistics.rack.form.column': '열',
  'pages.logistics.rack.form.columnPlaceholder': '예: 05',
  'pages.logistics.rack.form.level': '층',
  'pages.logistics.rack.form.levelPlaceholder': '예: 3',
  'pages.logistics.rack.form.capacity': '최대 용량',
  'pages.logistics.rack.form.capacityPlaceholder': '개수',
  'pages.logistics.rack.form.status': '상태',
  'pages.logistics.rack.form.statusPlaceholder': '상태 선택',
  'pages.logistics.rack.form.sizeType': '크기 유형',
  'pages.logistics.rack.form.sizeTypePlaceholder': '크기 유형 선택',
  'pages.logistics.rack.form.sizeTypeRequired': '크기 유형을 선택해주세요',
  'pages.logistics.rack.form.warehouseRequired': '창고를 선택해주세요',
  'pages.logistics.rack.form.notes': '메모',
  'pages.logistics.rack.form.notesPlaceholder': '메모 입력 (선택사항)',
  'pages.logistics.rack.location.zone': '구역',
  'pages.logistics.rack.fetchError': '랙 조회 실패',
  'pages.logistics.rack.createError': '랙 생성 실패',
  'pages.logistics.rack.updateError': '랙 수정 실패',
  'pages.logistics.rack.batchCreateTitle': '랙 일괄 생성',
  'pages.logistics.rack.batchCreateSuccess': '랙이 일괄 생성되었습니다',
  'pages.logistics.rack.batchCreateError': '랙 일괄 생성 실패',
  'pages.logistics.rack.batchCreateConfirmTitle': '랙 일괄 생성 확인',
  'pages.logistics.rack.batchCreateConfirm': '{count}개의 랙을 생성하시겠습니까?',
  'pages.logistics.rack.batchCreateNoRacks': '생성할 랙이 없습니다',
  'pages.logistics.rack.batchCreate.zoneStart': '구역 시작 번호',
  'pages.logistics.rack.batchCreate.zoneStartPlaceholder': '구역 시작 번호를 입력하세요',
  'pages.logistics.rack.batchCreate.zoneEnd': '구역 종료 번호',
  'pages.logistics.rack.batchCreate.zoneEndPlaceholder': '구역 종료 번호를 입력하세요',
  'pages.logistics.rack.batchCreate.rackStart': '랙 시작 번호',
  'pages.logistics.rack.batchCreate.rackStartPlaceholder': '랙 시작 번호를 입력하세요',
  'pages.logistics.rack.batchCreate.rackEnd': '랙 종료 번호',
  'pages.logistics.rack.batchCreate.rackEndPlaceholder': '랙 종료 번호를 입력하세요',
  'pages.logistics.rack.batchCreate.positionStart': '위치 시작 번호',
  'pages.logistics.rack.batchCreate.positionStartPlaceholder': '위치 시작 번호를 입력하세요',
  'pages.logistics.rack.batchCreate.positionEnd': '위치 종료 번호',
  'pages.logistics.rack.batchCreate.positionEndPlaceholder': '위치 종료 번호를 입력하세요',
  'pages.logistics.rack.batchUnavailableTitle': '일괄 사용 불가 처리',
  'pages.logistics.rack.batchUnavailableConfirm': '선택한 {count}개의 랙을 사용 불가로 처리하시겠습니까?',
  'pages.logistics.rack.batchUnavailableSuccess': '랙이 일괄 사용 불가로 처리되었습니다',
  'pages.logistics.rack.batchUnavailableError': '랙 일괄 사용 불가 처리 실패',
  'pages.logistics.rack.noSelection': '선택한 항목이 없습니다',
  'pages.logistics.rack.barcodeError': '바코드 값을 찾을 수 없습니다',
  'pages.logistics.rack.printWindowError': '인쇄 창을 열 수 없습니다. 이 사이트의 팝업을 허용해주세요.',
  'pages.logistics.rack.barcodeGenerationError': '바코드 생성 실패',
  'pages.logistics.rack.printBarcode': '바코드 인쇄 (Code-128)',
  'pages.logistics.rack.bulkBarcode': '선택한 바코드 인쇄',
  'pages.logistics.rack.noRacksSelected': '바코드를 인쇄하려면 최소 하나의 랙을 선택해주세요',
  'pages.logistics.rack.bulkBarcodeSuccess': '{count}개의 랙에 대한 바코드 생성 완료',

  // Logistics - Waybill Informations
  'pages.logistics.waybillInformations.title': '운송장 정보',
  'pages.logistics.waybillInformations.addTitle': '운송장 정보 추가',
  'pages.logistics.waybillInformations.editTitle': '운송장 정보 수정',
  'pages.logistics.waybillInformations.deleteConfirm': '운송장 정보 삭제',
  'pages.logistics.waybillInformations.deleteConfirmContent': '"{zyid}" 운송장 정보를 삭제하시겠습니까?',
  'pages.logistics.waybillInformations.deleteSuccess': '운송장 정보가 삭제되었습니다',
  'pages.logistics.waybillInformations.updateSuccess': '운송장 정보가 수정되었습니다',
  'pages.logistics.waybillInformations.createSuccess': '운송장 정보가 등록되었습니다',
  'pages.logistics.waybillInformations.submitError': '운송장 정보 저장 중 오류가 발생했습니다',
  'pages.logistics.waybillInformations.exportSuccess': '{count}건의 데이터를 내보냈습니다',
  'pages.logistics.waybillInformations.exportError': '내보내기 중 오류가 발생했습니다',
  'pages.logistics.waybillInformations.exporting': '내보내는 중입니다...',
  'pages.logistics.waybillInformations.column.shippedAt': '출고완료시간',
  'pages.logistics.waybillInformations.column.secondPaidAt': '2차비용결제일시',
  'pages.logistics.waybillInformations.column.mailbox': '사서함',
  'pages.logistics.waybillInformations.column.recipient': '수취인명',
  'pages.logistics.waybillInformations.column.secondPaymentStatus': '2차결제상태',
  'pages.logistics.waybillInformations.column.secondPaymentMethod': '2차결제방법',
  'pages.logistics.waybillInformations.column.progressStatus': '진행상태',
  'pages.logistics.waybillInformations.column.warehouse': '창고',
  'pages.logistics.waybillInformations.column.transferMethod': '운송방식',
  'pages.logistics.waybillInformations.column.weight': '무게',
  'pages.logistics.waybillInformations.column.internationalShipping': '국제운송비용',
  'pages.logistics.waybillInformations.column.ruralShipping': '도서산간비용',
  'pages.logistics.waybillInformations.column.simplifiedClearance': '간이통관비용',
  'pages.logistics.waybillInformations.column.service': '서비스비용',
  'pages.logistics.waybillInformations.column.deposit': '예치금',
  'pages.logistics.waybillInformations.column.coupon': '쿠폰',
  'pages.logistics.waybillInformations.column.secondPaymentTotal': '2차결제비용',
  'pages.logistics.waybillInformations.filter.shippedStart': '출고완료 시작일',
  'pages.logistics.waybillInformations.filter.shippedEnd': '출고완료 마감일',
  'pages.logistics.waybillInformations.filter.secondPaidStart': '2차결제 시작일',
  'pages.logistics.waybillInformations.filter.secondPaidEnd': '2차결제 마감일',
  'pages.logistics.waybillInformations.paymentStatus.all': '2차결제상태 전체',
  'pages.logistics.waybillInformations.paymentStatus.unpaid': '미결제',
  'pages.logistics.waybillInformations.paymentStatus.pending': '결제대기',
  'pages.logistics.waybillInformations.paymentStatus.processing': '결제처리중',
  'pages.logistics.waybillInformations.paymentStatus.paid': '결제완료',
  'pages.logistics.waybillInformations.paymentStatus.failed': '결제실패',
  'pages.logistics.waybillInformations.paymentStatus.refunded': '환불완료',
  'pages.logistics.waybillInformations.paymentMethod.all': '2차결제방법 전체',
  'pages.logistics.waybillInformations.paymentMethod.card': '카드',
  'pages.logistics.waybillInformations.paymentMethod.bank': '무통장',
  'pages.logistics.waybillInformations.paymentMethod.deposit': '예치금',
  'pages.logistics.waybillInformations.paymentMethod.points': '포인트',
  'pages.logistics.waybillInformations.progressStatus.all': '진행상태 전체',
  'pages.logistics.waybillInformations.progressStatus.WH_PAY_WAIT': '출고비결제대기',
  'pages.logistics.waybillInformations.progressStatus.WH_PAY_DONE': '출고비결제완료',
  'pages.logistics.waybillInformations.progressStatus.WH_SHIPPED': '출고완료',
  'pages.logistics.waybillInformations.progressStatus.INTERNATIONAL_SHIPPING': '국제운송중',
  'pages.logistics.waybillInformations.progressStatus.INTERNATIONAL_SHIPPED': '국제운송완료',
  'pages.logistics.waybillInformations.transferMethod.all': '운송방식 전체',
  'pages.logistics.waybillInformations.transferMethod.ship': '해운',
  'pages.logistics.waybillInformations.transferMethod.air': '항공',
  'pages.logistics.waybillInformations.transferMethod.shipExpress': '해운특송',
  'pages.logistics.waybillInformations.transferMethod.airExpress': '항공특송',
  'pages.logistics.waybillInformations.warehouse.all': '창고 전체',
  'pages.logistics.waybillInformations.column.id': 'ID',
  'pages.logistics.waybillInformations.column.orderNumber': '주문번호',
  'pages.logistics.waybillInformations.column.totalProductPriceW': '상품 총액 (원)',
  'pages.logistics.waybillInformations.column.shippingFeeWithinChinaW': '중국 내 배송비 (원)',
  'pages.logistics.waybillInformations.column.purchaseFeeW': '구매 수수료 (원)',
  'pages.logistics.waybillInformations.column.secondaryPaymentW': '추가 결제 (원)',
  'pages.logistics.waybillInformations.column.totalProductPriceYuan': '상품 총액 (¥)',
  'pages.logistics.waybillInformations.column.shippingFeeWithinChinaYuan': '중국 내 배송비 (¥)',
  'pages.logistics.waybillInformations.column.purchaseFeeYuan': '구매 수수료 (¥)',
  'pages.logistics.waybillInformations.column.secondaryPaymentYuan': '추가 결제 (¥)',
  'pages.logistics.waybillInformations.column.waybillNumber': '운송장 번호',
  'pages.logistics.waybillInformations.column.paymentMethod': '결제 방법',
  'pages.logistics.waybillInformations.column.paymentType': '결제 유형',
  'pages.logistics.waybillInformations.column.createdAt': '등록일시',
  'pages.logistics.waybillInformations.status.pending': '대기',
  'pages.logistics.waybillInformations.status.inTransit': '배송중',
  'pages.logistics.waybillInformations.status.delivered': '배송완료',
  'pages.logistics.waybillInformations.status.exception': '예외',
  'pages.logistics.waybillInformations.form.id': 'ID',
  'pages.logistics.waybillInformations.form.idRequired': 'ID를 입력하세요',
  'pages.logistics.waybillInformations.form.totalProductPriceW': '상품 총액 (원)',
  'pages.logistics.waybillInformations.form.totalProductPriceWRequired': '상품 총액 (원)을 입력하세요',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaW': '중국 내 배송비 (원)',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaWRequired': '중국 내 배송비 (원)을 입력하세요',
  'pages.logistics.waybillInformations.form.purchaseFeeW': '구매 수수료 (원)',
  'pages.logistics.waybillInformations.form.purchaseFeeWRequired': '구매 수수료 (원)을 입력하세요',
  'pages.logistics.waybillInformations.form.secondaryPaymentW': '추가 결제 (원)',
  'pages.logistics.waybillInformations.form.secondaryPaymentWRequired': '추가 결제 (원)을 입력하세요',
  'pages.logistics.waybillInformations.form.totalProductPriceYuan': '상품 총액 (¥)',
  'pages.logistics.waybillInformations.form.totalProductPriceYuanRequired': '상품 총액 (¥)을 입력하세요',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaYuan': '중국 내 배송비 (¥)',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaYuanRequired': '중국 내 배송비 (¥)을 입력하세요',
  'pages.logistics.waybillInformations.form.purchaseFeeYuan': '구매 수수료 (¥)',
  'pages.logistics.waybillInformations.form.purchaseFeeYuanRequired': '구매 수수료 (¥)을 입력하세요',
  'pages.logistics.waybillInformations.form.secondaryPaymentYuan': '추가 결제 (¥)',
  'pages.logistics.waybillInformations.form.secondaryPaymentYuanRequired': '추가 결제 (¥)을 입력하세요',
  'pages.logistics.waybillInformations.form.waybillNumber': '운송장 번호',
  'pages.logistics.waybillInformations.form.waybillNumberRequired': '운송장 번호를 입력하세요',
  'pages.logistics.waybillInformations.form.paymentMethod': '결제 방법',
  'pages.logistics.waybillInformations.form.paymentMethodRequired': '결제 방법을 선택하세요',
  'pages.logistics.waybillInformations.form.paymentType': '결제 유형',
  'pages.logistics.waybillInformations.form.paymentTypeRequired': '결제 유형을 선택하세요',
  'pages.logistics.waybillInformations.form.carrierRequired': '택배사를 선택하세요',

  // Logistics - Waybill Bandwidth Management
  'pages.logistics.waybillBandwidthManagement.title': '운송장 대역폭 관리',
  'pages.logistics.waybillBandwidthManagement.column.no': '번호',
  'pages.logistics.waybillBandwidthManagement.column.centerTransportationMethod': '센터/운송 방법',
  'pages.logistics.waybillBandwidthManagement.column.courier': '택배사',
  'pages.logistics.waybillBandwidthManagement.column.title': '제목',
  'pages.logistics.waybillBandwidthManagement.column.waybillBandwidth': '운송장 대역폭',
  'pages.logistics.waybillBandwidthManagement.column.totalBandwidth': '총 대역폭',
  'pages.logistics.waybillBandwidthManagement.column.waybillsUsed': '사용된 운송장 수',
  'pages.logistics.waybillBandwidthManagement.column.waybillsAvailable': '사용 가능한 운송장 수',
  'pages.logistics.waybillBandwidthManagement.column.waybillNumberStart': '운송장 번호 시작',
  'pages.logistics.waybillBandwidthManagement.column.waybillNumberEnd': '운송장 번호 종료',
  'pages.logistics.waybillBandwidthManagement.column.isInUse': '사용 여부',
  'pages.logistics.waybillBandwidthManagement.column.registrationDate': '등록일',
  'pages.logistics.waybillBandwidthManagement.inUse': '사용 중',
  'pages.logistics.waybillBandwidthManagement.notInUse': '미사용',
  'pages.logistics.waybillBandwidthManagement.deleteConfirm': '운송장 대역폭 삭제',
  'pages.logistics.waybillBandwidthManagement.deleteConfirmContent': '"{title}"을(를) 삭제하시겠습니까?',
  'pages.logistics.waybillBandwidthManagement.deleteSuccess': '삭제되었습니다',
  'pages.logistics.waybillBandwidthManagement.setInUseSuccess': '사용 중으로 설정되었습니다',
  'pages.logistics.waybillBandwidthManagement.setNotInUseSuccess': '미사용으로 설정되었습니다',
  'pages.logistics.waybillBandwidthManagement.addComingSoon': '추가 기능 준비 중입니다',
  'pages.logistics.waybillBandwidthManagement.addTitle': '운송장 대역폭 추가',
  'pages.logistics.waybillBandwidthManagement.editTitle': '운송장 대역폭 수정',
  'pages.logistics.waybillBandwidthManagement.createSuccess': '운송장 대역폭이 등록되었습니다',
  'pages.logistics.waybillBandwidthManagement.editSuccess': '운송장 대역폭이 수정되었습니다',
  'pages.logistics.waybillBandwidthManagement.submitError': '작업에 실패했습니다. 다시 시도해 주세요.',
  'pages.logistics.waybillBandwidthManagement.column.includeInactive': '표시',
  'pages.logistics.waybillBandwidthManagement.showAll': '전체',
  'pages.logistics.waybillBandwidthManagement.showActiveOnly': '사용 중만',
  'pages.logistics.waybillBandwidthManagement.includeInactivePlaceholder': '상태별 필터',
  'pages.logistics.waybillBandwidthManagement.column.warehouse': '창고',
  'pages.logistics.waybillBandwidthManagement.column.transportationMethod': '운송 방법',
  'pages.logistics.waybillBandwidthManagement.form.warehouse': '창고',
  'pages.logistics.waybillBandwidthManagement.form.warehouseRequired': '창고를 선택하세요',
  'pages.logistics.waybillBandwidthManagement.form.warehousePlaceholder': '창고를 선택하세요',
  'pages.logistics.waybillBandwidthManagement.form.transportationMethod': '운송 방법',
  'pages.logistics.waybillBandwidthManagement.form.transportationMethodRequired': '운송 방법을 선택하세요',
  'pages.logistics.waybillBandwidthManagement.form.transportationMethodPlaceholder': '운송 방법 선택',
  'pages.logistics.waybillBandwidthManagement.transportationMethod.ship': '선박',
  'pages.logistics.waybillBandwidthManagement.transportationMethod.air': '항공',
  'pages.logistics.waybillBandwidthManagement.form.courier': '택배사',
  'pages.logistics.waybillBandwidthManagement.form.courierRequired': '택배사를 입력하세요',
  'pages.logistics.waybillBandwidthManagement.form.courierPlaceholder': '예: CJ 대한통운',
  'pages.logistics.waybillBandwidthManagement.form.title': '제목',
  'pages.logistics.waybillBandwidthManagement.form.titleRequired': '제목을 입력하세요',
  'pages.logistics.waybillBandwidthManagement.form.titlePlaceholder': '예: 위해 RED - CJ - 항공',
  'pages.logistics.waybillBandwidthManagement.form.file': '파일',
  'pages.logistics.waybillBandwidthManagement.form.fileRequired': 'Excel 파일을 업로드하세요',
  'pages.logistics.waybillBandwidthManagement.form.uploadFile': '파일 업로드',
  'pages.logistics.waybillBandwidthManagement.form.fileTypeError': 'Excel 파일만 업로드할 수 있습니다 (.xlsx, .xls)',
  'pages.logistics.waybillBandwidthManagement.form.isActive': '활성화',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.title': '운송장 번호 목록',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.number': '운송장 번호',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.used': '상태',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.usedYes': '사용됨',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.usedNo': '미사용',
  'pages.logistics.waybillBandwidthManagement.uploadMore.title': '운송장 번호 추가 — {title}',
  'pages.logistics.waybillBandwidthManagement.uploadMore.titleFallback': '파일에서 운송장 번호 추가',
  'pages.logistics.waybillBandwidthManagement.uploadMore.hint':
    'Excel/CSV는 첫 번째 열, TXT는 한 줄에 하나씩 읽습니다. 중복이거나 다른 풀에서 이미 쓰인 번호는 건너뜁니다. 가능하면 .xlsx를 사용하세요.',
  'pages.logistics.waybillBandwidthManagement.uploadMore.pickFile': '파일 선택',
  'pages.logistics.waybillBandwidthManagement.uploadMore.submit': '업로드',
  'pages.logistics.waybillBandwidthManagement.uploadMore.action': '번호 추가 업로드',
  'pages.logistics.waybillBandwidthManagement.uploadMore.success': '운송장 번호 {added}건이 추가되었습니다. 풀 합계: {totalInPool}건.',
  'pages.logistics.waybillBandwidthManagement.uploadMore.successWithSkipped':
    '신규 {added}건 추가, {skipped}건 건너뜀(중복). 풀 합계: {totalInPool}건.',
  'pages.logistics.waybillBandwidthManagement.uploadMore.noNew':
    '추가된 번호 없음(중복 또는 이미 풀에 있음 {skipped}건).',
  'pages.logistics.waybillBandwidthManagement.uploadMore.fileTypeError': '.xlsx, .csv, .txt만 사용할 수 있습니다.',

  'pages.logistics.waybillInformations.form.status': '상태',
  'pages.logistics.waybillInformations.form.statusRequired': '상태를 선택하세요',
  'pages.logistics.waybillInformations.form.origin': '출발지',
  'pages.logistics.waybillInformations.form.originRequired': '출발지를 입력하세요',
  'pages.logistics.waybillInformations.form.destination': '도착지',
  'pages.logistics.waybillInformations.form.destinationRequired': '도착지를 입력하세요',
  'pages.logistics.waybillInformations.form.weight': '무게',
  'pages.logistics.waybillInformations.form.weightRequired': '무게를 입력하세요',
  'pages.logistics.waybillInformations.form.recipientName': '수령인',
  'pages.logistics.waybillInformations.form.recipientNameRequired': '수령인을 입력하세요',
  'pages.logistics.waybillInformations.form.recipientPhone': '수령인 연락처',
  'pages.logistics.waybillInformations.form.recipientPhoneRequired': '수령인 연락처를 입력하세요',
  'pages.logistics.waybillInformations.form.notes': '비고',

  // Logistics - Collect Orders
  'pages.logistics.collectOrders.title': '수거 주문',
  'pages.logistics.collectOrders.statistics.total': '전체',
  'pages.logistics.collectOrders.statistics.pending': '대기',
  'pages.logistics.collectOrders.statistics.processing': '처리중',
  'pages.logistics.collectOrders.statistics.completed': '완료',
  'pages.logistics.collectOrders.column.waybillNumber': '운송장 번호',
  'pages.logistics.collectOrders.column.uid': '회원 정보 (UID)',
  'pages.logistics.collectOrders.column.productNumber': '상품 번호',
  'pages.logistics.collectOrders.column.shippingMethod': '배송 방법',
  'pages.logistics.collectOrders.column.overseasWarehouse': '해외 창고',
  'pages.logistics.collectOrders.column.paymentStatus': '결제 상태',
  'pages.logistics.collectOrders.column.creationTime': '생성 시간',
  'pages.logistics.collectOrders.column.updateTime': '수정 시간',
  'pages.logistics.collectOrders.column.state': '상태',
  'pages.logistics.collectOrders.column.storageFees': '보관료',
  'pages.logistics.collectOrders.column.work': '작업',
  'pages.logistics.collectOrders.paymentStatus.paid': '결제완료',
  'pages.logistics.collectOrders.paymentStatus.unpaid': '미결제',
  'pages.logistics.collectOrders.paymentStatus.partial': '부분결제',
  'pages.logistics.collectOrders.paymentStatus.refunded': '환불됨',
  'pages.logistics.collectOrders.state.pending': '대기',
  'pages.logistics.collectOrders.state.processing': '처리중',
  'pages.logistics.collectOrders.state.completed': '완료',
  'pages.logistics.collectOrders.state.cancelled': '취소됨',
  'pages.logistics.collectOrders.deleteConfirm': '수거 주문 삭제',
  'pages.logistics.collectOrders.deleteConfirmContent': '"{waybillNumber}" 수거 주문을 삭제하시겠습니까?',
  'pages.logistics.collectOrders.deleteSuccess': '수거 주문이 삭제되었습니다',
  'pages.logistics.collectOrders.edit': '수정',

  // Logistics - Transportation Methods
  'pages.logistics.transportationMethods.title': '운송 방법',
  'pages.logistics.transportationMethods.addTitle': '운송 방법 추가',
  'pages.logistics.transportationMethods.editTitle': '운송 방법 수정',
  'pages.logistics.transportationMethods.deleteConfirm': '운송 방법 삭제',
  'pages.logistics.transportationMethods.deleteConfirmContent': '"{regionId}" 운송 방법을 삭제하시겠습니까?',
  'pages.logistics.transportationMethods.deleteSuccess': '운송 방법이 삭제되었습니다',
  'pages.logistics.transportationMethods.updateSuccess': '운송 방법이 수정되었습니다',
  'pages.logistics.transportationMethods.createSuccess': '운송 방법이 등록되었습니다',
  'pages.logistics.transportationMethods.submitError': '운송 방법 저장 중 오류가 발생했습니다',
  'pages.logistics.transportationMethods.column.regionId': '지역 ID',
  'pages.logistics.transportationMethods.column.isActive': '활성',
  'pages.logistics.transportationMethods.column.isInactive': '비활성',
  'pages.logistics.transportationMethods.column.icon': '아이콘',
  'pages.logistics.transportationMethods.column.userLevel': '회원 등급',
  'pages.logistics.transportationMethods.userLevelAll': '전체',
  'pages.logistics.transportationMethods.column.areaName': '지역명',
  'pages.logistics.transportationMethods.column.deliveryName': '배송명',
  'pages.logistics.transportationMethods.column.customsClearanceFees': '통관 수수료',
  'pages.logistics.transportationMethods.column.serviceFee': '서비스 수수료',
  'pages.logistics.transportationMethods.column.visible': '표시',
  'pages.logistics.transportationMethods.column.work': '작업',
  'pages.logistics.transportationMethods.form.regionId': '지역 ID',
  'pages.logistics.transportationMethods.form.regionIdRequired': '지역 ID를 입력하세요',
  'pages.logistics.transportationMethods.form.icon': '아이콘',
  'pages.logistics.transportationMethods.form.iconPlaceholder': '이미지 URL을 입력하세요',
  'pages.logistics.transportationMethods.form.userLevel': '회원 등급',
  'pages.logistics.transportationMethods.form.userLevelPlaceholder': '예: 전체, 프리미엄, 기본',
  'pages.logistics.transportationMethods.form.areaName': '지역명',
  'pages.logistics.transportationMethods.form.areaNameRequired': '지역명을 입력하세요',
  'pages.logistics.transportationMethods.form.deliveryName': '배송명',
  'pages.logistics.transportationMethods.form.deliveryNameRequired': '배송명을 입력하세요',
  'pages.logistics.transportationMethods.form.customsClearanceFees': '통관 수수료',
  'pages.logistics.transportationMethods.form.customsClearanceFeesRequired': '통관 수수료를 입력하세요',
  'pages.logistics.transportationMethods.form.serviceFee': '서비스 수수료',
  'pages.logistics.transportationMethods.form.serviceFeeRequired': '서비스 수수료를 입력하세요',
  'pages.logistics.transportationMethods.form.visible': '표시',
  'pages.logistics.transportationMethods.add': '운송 방식 추가',
  'pages.logistics.transportationMethods.stepWeight': '단계별 중량 (阶梯重量)',
  'pages.logistics.transportationMethods.additionalWeight': '추가 중량 (续重重量)',
  'pages.logistics.transportationMethods.stepWeightPlaceholder': '단계별 중량 설정 — 추후 구현 예정.',
  'pages.logistics.transportationMethods.additionalWeightPlaceholder': '추가 중량 설정 — 추후 구현 예정.',
  'pages.logistics.transportationMethods.transportationFeeTitle': '운송 요금 (단계별 중량 & 추가 중량)',
  'pages.logistics.transportationMethods.stairWeight': '단계 중량',
  'pages.logistics.transportationMethods.tieredPricing': '단계별 가격',
  'pages.logistics.transportationMethods.additionalWeightPrice': '추가 중량 가격',
  'pages.logistics.transportationMethods.registrationFee': '등록비',
  'pages.logistics.transportationMethods.form.serviceCostRatioOnly': '비율 (%)',
  'pages.logistics.transportationMethods.disable': '사용 중지',
  'pages.logistics.transportationMethods.disableConfirm': '사용 중지하시겠습니까?',
  'pages.logistics.transportationMethods.disableSuccess': '사용 중지되었습니다',
  'pages.logistics.transportationMethods.column.id': 'ID',
  'pages.logistics.transportationMethods.column.serviceAreaName': '서비스 지역명',
  'pages.logistics.transportationMethods.column.customsCost': '통관 비용',
  'pages.logistics.transportationMethods.column.serviceCost': '서비스 비용',
  'pages.logistics.transportationMethods.column.isDisplayed': '표시 여부',
  'pages.logistics.transportationMethods.tab.basicInfo': '기본 정보',
  'pages.logistics.transportationMethods.tab.weightSettings': '중량 설정',
  'pages.logistics.transportationMethods.tab.weightLimits': '중량 제한',
  'pages.logistics.transportationMethods.tab.deviation': '중량/부피 편차값',
  'pages.logistics.transportationMethods.tab.actualWeight': '실제 중량',
  'pages.logistics.transportationMethods.tab.tieredWeight': '계단식 중량 설정',
  'pages.logistics.transportationMethods.tab.volumeWeight': '부피 중량 계산 설정',
  'pages.logistics.transportationMethods.tab.billingCriteria': '기타 청구 기준',
  'pages.logistics.transportationMethods.tab.routeInfo': '경로 정보',
  'pages.logistics.transportationMethods.tab.displayStatus': '표시 여부',
  'pages.logistics.transportationMethods.form.serviceArea': '서비스 지역',
  'pages.logistics.transportationMethods.form.shippingWarehouse': '출고 창고',
  'pages.logistics.transportationMethods.form.shippingWarehousePlaceholder': '출고 창고 선택',
  'pages.logistics.transportationMethods.form.customsCost': '통관비',
  'pages.logistics.transportationMethods.form.serviceCostCalculationType': '서비스 비용 계산 방식',
  'pages.logistics.transportationMethods.form.serviceCostFixed': '고정 서비스비',
  'pages.logistics.transportationMethods.form.serviceCostRatio': '비율 (%)',
  'pages.logistics.transportationMethods.form.minWeight': '최소 중량',
  'pages.logistics.transportationMethods.form.maxWeight': '최대 중량',
  'pages.logistics.transportationMethods.form.minCalculationWeight': '최소 계산 중량',
  'pages.logistics.transportationMethods.form.sizeLimit': '크기 제한',
  'pages.logistics.transportationMethods.form.weightDeviation': '중량 편차값',
  'pages.logistics.transportationMethods.form.lengthDeviation': '길이 편차값',
  'pages.logistics.transportationMethods.form.widthDeviation': '너비 편차값',
  'pages.logistics.transportationMethods.form.heightDeviation': '높이 편차값',
  'pages.logistics.transportationMethods.form.volumeDeviation': '부피 편차값',
  'pages.logistics.transportationMethods.form.actualWeightForCustoms': '통관 신고용 중량',
  'pages.logistics.transportationMethods.form.actualWeightForBilling': '재정 대조용 중량',
  'pages.logistics.transportationMethods.form.weightUnit': '중량 단위',
  'pages.logistics.transportationMethods.form.actualWeightRules': '회원 설명을 위한 규칙',
  'pages.logistics.transportationMethods.form.baseWeight': '택배 기본 중량',
  'pages.logistics.transportationMethods.form.basePrice': '기본 가격',
  'pages.logistics.transportationMethods.form.additionalWeight': '추가 중량',
  'pages.logistics.transportationMethods.form.additionalWeightPrice': '추가 중량 가격',
  'pages.logistics.transportationMethods.form.tieredWeights': '계단식 중량 및 가격',
  'pages.logistics.transportationMethods.form.volumeCoefficient': '부피 계수',
  'pages.logistics.transportationMethods.form.volumeExpansionMode': '부피 팽창 모드',
  'pages.logistics.transportationMethods.form.logisticsProcessingFee': '물류 업체 처리비',
  'pages.logistics.transportationMethods.form.fuelCost': '연료비',
  'pages.logistics.transportationMethods.form.operatingCost': '운영비',
  'pages.logistics.transportationMethods.form.taxPaymentMethod': '세금 납부 방식',
  'pages.logistics.transportationMethods.form.taxDeclarationMethod': '신고 방식',
  'pages.logistics.transportationMethods.form.shippingTime': '운송 소요 시간',
  'pages.logistics.transportationMethods.form.routeRiskNotice': '운송 경로 위험 안내',
  'pages.logistics.transportationMethods.form.routeFeeStandard': '노선 요금 기준',
  'pages.logistics.transportationMethods.form.lineCharacteristics': '노선 특성',
  'pages.logistics.transportationMethods.form.volumeBillingRules': '부피 청구 규칙',
  'pages.logistics.transportationMethods.form.volumeBillingRulesPlaceholder': '숫자만 입력하세요',
  'pages.logistics.transportationMethods.form.deliveryNamePlaceholder': '배송명을 입력하세요',
  'pages.logistics.transportationMethods.form.serviceAreaPlaceholder': '서비스 지역을 입력하세요',
  'pages.logistics.transportationMethods.form.shippingTimePlaceholder': '예: 2-3일',
  'pages.logistics.transportationMethods.form.routeRiskNoticePlaceholder': '운송 경로 위험 안내 내용을 입력하세요',
  'pages.logistics.transportationMethods.form.lineCharacteristicsPlaceholder': '노선 특성을 입력하세요',
  'pages.logistics.transportationMethods.form.upload': '업로드',
  'pages.logistics.transportationMethods.displayed': '표시',
  'pages.logistics.transportationMethods.hidden': '비표시',
  'pages.logistics.transportationMethods.active': '활성',
  'pages.logistics.transportationMethods.inactive': '비활성',
  'pages.logistics.transportationMethods.form.isDisplayed': '프론트엔드 회원 표시 여부',
  'pages.logistics.transportationMethods.form.isActive': '활성 상태',

  // Logistics - Logistics Trajectory
  'pages.logistics.logisticsTrajectory.title': '물류 경로',
  'pages.logistics.logisticsTrajectory.viewAll': '전체 보기',
  'pages.logistics.logisticsTrajectory.column.waybillNumber': '운송장 번호',
  'pages.logistics.logisticsTrajectory.column.uid': '회원 정보 (UID)',
  'pages.logistics.logisticsTrajectory.column.productNumber': '상품 번호',
  'pages.logistics.logisticsTrajectory.column.shippingMethod': '배송 방법',
  'pages.logistics.logisticsTrajectory.column.overseasWarehouse': '해외 창고',
  'pages.logistics.logisticsTrajectory.column.paymentStatus': '결제 상태',
  'pages.logistics.logisticsTrajectory.column.creationTime': '생성 시간',
  'pages.logistics.logisticsTrajectory.column.updateTime': '수정 시간',
  'pages.logistics.logisticsTrajectory.column.state': '상태',
  'pages.logistics.logisticsTrajectory.column.storageFees': '보관료',
  'pages.logistics.logisticsTrajectory.column.work': '작업',
  'pages.logistics.logisticsTrajectory.paymentStatus.paid': '결제완료',
  'pages.logistics.logisticsTrajectory.paymentStatus.unpaid': '미결제',
  'pages.logistics.logisticsTrajectory.paymentStatus.partial': '부분결제',
  'pages.logistics.logisticsTrajectory.paymentStatus.refunded': '환불됨',
  'pages.logistics.logisticsTrajectory.viewTrajectory': '경로 보기',
  'pages.logistics.logisticsTrajectory.filter.group.entire': '전체',
  'pages.logistics.logisticsTrajectory.filter.group.chinaWarehouse': '중국 창고',
  'pages.logistics.logisticsTrajectory.filter.group.chinaCustoms': '중국 세관',
  'pages.logistics.logisticsTrajectory.filter.group.international': '국제 운송',
  'pages.logistics.logisticsTrajectory.filter.group.destinationCustoms': '목적지 세관',
  'pages.logistics.logisticsTrajectory.filter.group.destinationWarehouse': '목적지 창고',
  'pages.logistics.logisticsTrajectory.filter.group.transitCenter': '물류센터',
  'pages.logistics.logisticsTrajectory.filter.group.delivery': '배송',
  'pages.logistics.logisticsTrajectory.filter.group.completed': '완료',
  'pages.logistics.logisticsTrajectory.filter.entire': '전체',
  'pages.logistics.logisticsTrajectory.filter.warehouseAwaiting': '중국 창고 출고 대기',
  'pages.logistics.logisticsTrajectory.filter.shipmentCompleted': '중국 창고 출고 완료',
  'pages.logistics.logisticsTrajectory.filter.arrivalChineseCustoms': '중국 세관 도착',
  'pages.logistics.logisticsTrajectory.filter.customsReleased': '세관 통과 완료',
  'pages.logistics.logisticsTrajectory.filter.internationalTransport': '국제 운송',
  'pages.logistics.logisticsTrajectory.filter.arrivalDestinationCustoms': '목적지 세관 도착',
  'pages.logistics.logisticsTrajectory.filter.customsInspection': '목적지 국가 세관 검사',
  'pages.logistics.logisticsTrajectory.filter.arrivalKoreanWarehouse': '한국 창고 도착',
  'pages.logistics.logisticsTrajectory.filter.pickingTransitCenter': '목적지 물류센터 픽업',
  'pages.logistics.logisticsTrajectory.filter.deliveryBeginsTransit': '목적지 물류센터 배송 시작',
  'pages.logistics.logisticsTrajectory.filter.localDelivery': '지역 배송',
  'pages.logistics.logisticsTrajectory.filter.localDeliveryDestination': '목적지 국가 지역 배송',
  'pages.logistics.logisticsTrajectory.filter.packageDelivered': '배송 완료',
  'pages.logistics.logisticsTrajectory.filter.customerSigned': '회원 서명 완료',

  // Logistics - Goods
  'pages.logistics.goods.title': '상품',
  'pages.logistics.goods.addTitle': '상품 추가',
  'pages.logistics.goods.editTitle': '상품 수정',
  'pages.logistics.goods.detailTitle': '상품 상세',
  'pages.logistics.goods.deleteConfirm': '상품 삭제',
  'pages.logistics.goods.deleteConfirmContent': '"{goodName}" 상품을 삭제하시겠습니까?',
  'pages.logistics.goods.deleteSuccess': '상품이 삭제되었습니다',
  'pages.logistics.goods.updateSuccess': '상품이 수정되었습니다',
  'pages.logistics.goods.createSuccess': '상품이 등록되었습니다',
  'pages.logistics.goods.submitError': '상품 저장 중 오류가 발생했습니다',
  'pages.logistics.goods.column.image': '이미지',
  'pages.logistics.goods.column.goodCode': '상품코드',
  'pages.logistics.goods.column.goodName': '상품명',
  'pages.logistics.goods.column.category': '카테고리',
  'pages.logistics.goods.column.weight': '무게',
  'pages.logistics.goods.column.dimensions': '치수',
  'pages.logistics.goods.column.volume': '부피',
  'pages.logistics.goods.column.unitPrice': '단가',
  'pages.logistics.goods.column.status': '상태',
  'pages.logistics.goods.column.description': '설명',
  'pages.logistics.goods.status.active': '활성',
  'pages.logistics.goods.status.inactive': '비활성',
  'pages.logistics.goods.status.discontinued': '단종',
  'pages.logistics.goods.form.goodCode': '상품코드',
  'pages.logistics.goods.form.goodCodeRequired': '상품코드를 입력하세요',
  'pages.logistics.goods.form.goodName': '상품명',
  'pages.logistics.goods.form.goodNameRequired': '상품명을 입력하세요',
  'pages.logistics.goods.form.category': '카테고리',
  'pages.logistics.goods.form.categoryRequired': '카테고리를 선택하세요',
  'pages.logistics.goods.form.weight': '무게',
  'pages.logistics.goods.form.weightRequired': '무게를 입력하세요',
  'pages.logistics.goods.form.length': '길이',
  'pages.logistics.goods.form.lengthRequired': '길이를 입력하세요',
  'pages.logistics.goods.form.width': '너비',
  'pages.logistics.goods.form.widthRequired': '너비를 입력하세요',
  'pages.logistics.goods.form.height': '높이',
  'pages.logistics.goods.form.heightRequired': '높이를 입력하세요',
  'pages.logistics.goods.form.unitPrice': '단가',
  'pages.logistics.goods.form.unitPriceRequired': '단가를 입력하세요',
  'pages.logistics.goods.form.imageUrl': '이미지 URL',
  'pages.logistics.goods.form.description': '설명',
  'pages.logistics.goods.form.status': '상태',
  'pages.logistics.goods.form.statusRequired': '상태를 선택하세요',

  // Logistics - Logistics Trajectory
  'pages.logistics.logisticsTrajectory.searchPlaceholder': '운송장번호를 입력하세요',
  'pages.logistics.logisticsTrajectory.enterTrackingNumber': '운송장번호를 입력하세요',
  'pages.logistics.logisticsTrajectory.searchSuccess': '운송장 정보를 찾았습니다',
  'pages.logistics.logisticsTrajectory.searchNotFound': '운송장 정보를 찾을 수 없습니다',
  'pages.logistics.logisticsTrajectory.refreshSuccess': '데이터를 새로고침했습니다',
  'pages.logistics.logisticsTrajectory.trajectoryDetails': '경로 상세 - {trackingNumber}',
  'pages.logistics.logisticsTrajectory.operator': '담당자',
  'pages.logistics.logisticsTrajectory.column.trackingNumber': '운송장번호',
  'pages.logistics.logisticsTrajectory.column.orderNumber': '주문번호',
  'pages.logistics.logisticsTrajectory.column.carrier': '택배사',
  'pages.logistics.logisticsTrajectory.column.origin': '출발지',
  'pages.logistics.logisticsTrajectory.column.destination': '도착지',
  'pages.logistics.logisticsTrajectory.column.currentStatus': '현재상태',
  'pages.logistics.logisticsTrajectory.column.eventCount': '이벤트수',
  'pages.logistics.logisticsTrajectory.status.pending': '대기',
  'pages.logistics.logisticsTrajectory.status.inTransit': '배송중',
  'pages.logistics.logisticsTrajectory.status.outForDelivery': '배송출발',
  'pages.logistics.logisticsTrajectory.status.delivered': '배송완료',
  'pages.logistics.logisticsTrajectory.status.exception': '예외',

  // Logistics - Regional Management
  'pages.logistics.regionalManagement.title': '지역 국가 관리',
  'pages.logistics.regionalManagement.addTitle': '새 정보 추가',
  'pages.logistics.regionalManagement.editTitle': '지역 정보 수정',
  'pages.logistics.regionalManagement.add': '새 정보 추가',
  'pages.logistics.regionalManagement.deleteConfirm': '삭제하시겠습니까?',
  'pages.logistics.regionalManagement.deleteConfirmContent': '이 지역 정보를 삭제하시겠습니까?',
  'pages.logistics.regionalManagement.deleteSuccess': '삭제되었습니다',
  'pages.logistics.regionalManagement.updateSuccess': '수정되었습니다',
  'pages.logistics.regionalManagement.createSuccess': '생성되었습니다',
  'pages.logistics.regionalManagement.submitError': '오류가 발생했습니다',
  'pages.logistics.regionalManagement.batchDelete': '정보 일괄 삭제',
  'pages.logistics.regionalManagement.batchDeleteConfirm': '일괄 삭제',
  'pages.logistics.regionalManagement.batchDeleteConfirmContent': '선택한 {count}개의 항목을 삭제하시겠습니까?',
  'pages.logistics.regionalManagement.batchDeleteSuccess': '삭제되었습니다',
  'pages.logistics.regionalManagement.selectItemsFirst': '삭제할 항목을 선택해주세요',
  'pages.logistics.regionalManagement.column.id': 'ID',
  'pages.logistics.regionalManagement.column.image': '이미지',
  'pages.logistics.regionalManagement.column.region': '지역',
  'pages.logistics.regionalManagement.column.regionNameEn': '지역 영문명',
  'pages.logistics.regionalManagement.column.countryCode': '국가 코드',
  'pages.logistics.regionalManagement.column.destinationCountry': '목적지 국가',
  'pages.logistics.regionalManagement.column.destinationCity': '목적지 도시',
  'pages.logistics.regionalManagement.column.affiliationTag': '소속 태그',
  'pages.logistics.regionalManagement.column.customRegionCode': '회원 정의 지역 코드',
  'pages.logistics.regionalManagement.column.countryPhoneCode': '국가 전화번호 코드',
  'pages.logistics.regionalManagement.column.createdAt': '생성 시간',
  'pages.logistics.regionalManagement.filter.startDate': '시작일',
  'pages.logistics.regionalManagement.filter.endDate': '종료일',
  'pages.logistics.regionalManagement.filter.selectDate': '날짜 선택',
  'pages.logistics.regionalManagement.column.regionCode': '지역코드',
  'pages.logistics.regionalManagement.column.regionName': '지역명',
  'pages.logistics.regionalManagement.column.country': '국가',
  'pages.logistics.regionalManagement.column.province': '도/시',
  'pages.logistics.regionalManagement.column.city': '시/군/구',
  'pages.logistics.regionalManagement.column.postalCode': '우편번호',
  'pages.logistics.regionalManagement.column.timeZone': '시간대',
  'pages.logistics.regionalManagement.column.currency': '통화',
  'pages.logistics.regionalManagement.column.isActive': '활성화',
  'pages.logistics.regionalManagement.column.updatedAt': '수정일',
  'pages.logistics.regionalManagement.treeTitle': '지역 트리',
  'pages.logistics.regionalManagement.detailsTitle': '지역 상세',
  'pages.logistics.regionalManagement.selectAreaFirst': '먼저 지역을 선택하세요',
  'pages.logistics.regionalManagement.selectAreaHint': '왼쪽 트리에서 지역을 선택하면 상세 정보가 표시됩니다',
  'pages.logistics.regionalManagement.form.region': '지역',
  'pages.logistics.regionalManagement.form.regionRequired': '지역을 입력하세요',
  'pages.logistics.regionalManagement.form.regionPlaceholder': '지역을 입력하세요',
  'pages.logistics.regionalManagement.form.regionNameEn': '지역 영문명',
  'pages.logistics.regionalManagement.form.regionNameEnRequired': '지역 영문명을 입력하세요',
  'pages.logistics.regionalManagement.form.regionNameEnPlaceholder': '지역 영문명을 입력하세요',
  'pages.logistics.regionalManagement.form.countryCode': '국가 코드',
  'pages.logistics.regionalManagement.form.countryCodeRequired': '국가 코드를 입력하세요',
  'pages.logistics.regionalManagement.form.countryCodePlaceholder': '예: KR, CN, US',
  'pages.logistics.regionalManagement.form.destinationCountry': '목적지 국가',
  'pages.logistics.regionalManagement.form.destinationCountryRequired': '목적지 국가를 입력하세요',
  'pages.logistics.regionalManagement.form.destinationCountryPlaceholder': '목적지 국가를 입력하세요',
  'pages.logistics.regionalManagement.form.destinationCity': '목적지 도시',
  'pages.logistics.regionalManagement.form.destinationCityRequired': '목적지 도시를 입력하세요',
  'pages.logistics.regionalManagement.form.destinationCityPlaceholder': '목적지 도시를 입력하세요',
  'pages.logistics.regionalManagement.form.affiliationTag': '소속 태그',
  'pages.logistics.regionalManagement.form.affiliationTagPlaceholder': '소속 태그를 입력하세요',
  'pages.logistics.regionalManagement.form.customRegionCode': '회원 정의 지역 코드',
  'pages.logistics.regionalManagement.form.customRegionCodePlaceholder': '회원 정의 지역 코드를 입력하세요',
  'pages.logistics.regionalManagement.form.countryPhoneCode': '국가 전화번호 코드',
  'pages.logistics.regionalManagement.form.countryPhoneCodeRequired': '국가 전화번호 코드를 입력하세요',
  'pages.logistics.regionalManagement.form.countryPhoneCodePlaceholder': '예: +82, +86',
  'pages.logistics.regionalManagement.form.image': '이미지',
  'pages.logistics.regionalManagement.form.regionCode': '지역코드',
  'pages.logistics.regionalManagement.form.regionCodeRequired': '지역코드를 입력하세요',
  'pages.logistics.regionalManagement.form.regionName': '지역명',
  'pages.logistics.regionalManagement.form.regionNameRequired': '지역명을 입력하세요',
  'pages.logistics.regionalManagement.form.country': '국가',
  'pages.logistics.regionalManagement.form.countryRequired': '국가를 입력하세요',
  'pages.logistics.regionalManagement.form.province': '도/시',
  'pages.logistics.regionalManagement.form.city': '시/군/구',
  'pages.logistics.regionalManagement.form.postalCode': '우편번호',
  'pages.logistics.regionalManagement.form.timeZone': '시간대',
  'pages.logistics.regionalManagement.form.timeZoneRequired': '시간대를 입력하세요',
  'pages.logistics.regionalManagement.form.currency': '통화',
  'pages.logistics.regionalManagement.form.currencyRequired': '통화를 입력하세요',
  'pages.logistics.regionalManagement.form.description': '설명',
  'pages.logistics.regionalManagement.form.isActive': '활성화',

  // Logistics - International Tracking Number Management
  'pages.logistics.internationalTrackingNumberManagement.title': '국제 운송장 번호 관리',
  'pages.logistics.internationalTrackingNumberManagement.addTitle': '새 운송장 번호 추가',
  'pages.logistics.internationalTrackingNumberManagement.editTitle': '운송장 번호 수정',
  'pages.logistics.internationalTrackingNumberManagement.add': '새 운송장 번호 추가',
  'pages.logistics.internationalTrackingNumberManagement.deleteConfirm': '삭제하시겠습니까?',
  'pages.logistics.internationalTrackingNumberManagement.deleteConfirmContent': '운송장 번호 "{trackingNumber}"를 삭제하시겠습니까?',
  'pages.logistics.internationalTrackingNumberManagement.deleteSuccess': '삭제되었습니다',
  'pages.logistics.internationalTrackingNumberManagement.updateSuccess': '수정되었습니다',
  'pages.logistics.internationalTrackingNumberManagement.createSuccess': '생성되었습니다',
  'pages.logistics.internationalTrackingNumberManagement.submitError': '오류가 발생했습니다',
  'pages.logistics.internationalTrackingNumberManagement.selectItemsFirst': '내보낼 항목을 선택하세요',
  'pages.logistics.internationalTrackingNumberManagement.exportSuccess': '{count}건의 데이터를 내보냈습니다',
  'pages.logistics.internationalTrackingNumberManagement.importSea': '해운 EXCEL 가져오기',
  'pages.logistics.internationalTrackingNumberManagement.importAir': '항공운송 EXCEL 가져오기',
  'pages.logistics.internationalTrackingNumberManagement.importSeaTitle': '해운 EXCEL 가져오기',
  'pages.logistics.internationalTrackingNumberManagement.importAirTitle': '항공운송 EXCEL 가져오기',
  'pages.logistics.internationalTrackingNumberManagement.importSuccess': '{type} Excel 파일이 가져와졌습니다',
  'pages.logistics.internationalTrackingNumberManagement.importError': '가져오기 중 오류가 발생했습니다',
  'pages.logistics.internationalTrackingNumberManagement.fileRequired': '파일을 선택해주세요',
  'pages.logistics.internationalTrackingNumberManagement.uploadFile': '파일 선택',
  'pages.logistics.internationalTrackingNumberManagement.column.id': 'ID',
  'pages.logistics.internationalTrackingNumberManagement.column.trackingNumber': '운송장 번호',
  'pages.logistics.internationalTrackingNumberManagement.column.transportationType': '운송 유형',
  'pages.logistics.internationalTrackingNumberManagement.column.status': '상태',
  'pages.logistics.internationalTrackingNumberManagement.column.createdAt': '생성 시간',
  'pages.logistics.internationalTrackingNumberManagement.filter.selectDate': '날짜 선택',
  'pages.logistics.internationalTrackingNumberManagement.column.orderNumber': '주문번호',
  'pages.logistics.internationalTrackingNumberManagement.column.state': '상태',
  'pages.logistics.internationalTrackingNumberManagement.column.time': '시간',
  'pages.logistics.internationalTrackingNumberManagement.column.operate': '작업',
  'pages.logistics.internationalTrackingNumberManagement.column.carrier': '택배사',
  'pages.logistics.internationalTrackingNumberManagement.transportationType.sea': '해운',
  'pages.logistics.internationalTrackingNumberManagement.transportationType.air': '항공운송',
  'pages.logistics.internationalTrackingNumberManagement.status.unused': '미사용',
  'pages.logistics.internationalTrackingNumberManagement.status.used': '사용',
  'pages.logistics.internationalTrackingNumberManagement.form.trackingNumber': '국제 운송장 번호',
  'pages.logistics.internationalTrackingNumberManagement.form.trackingNumberRequired': '운송장 번호를 입력하세요',
  'pages.logistics.internationalTrackingNumberManagement.form.trackingNumberPlaceholder': '운송장 번호를 입력하세요',
  'pages.logistics.internationalTrackingNumberManagement.form.transportationType': '운송 유형',
  'pages.logistics.internationalTrackingNumberManagement.form.transportationTypeRequired': '운송 유형을 선택하세요',
  'pages.logistics.internationalTrackingNumberManagement.form.transportationTypePlaceholder': '운송 유형을 선택하세요',
  'pages.logistics.internationalTrackingNumberManagement.form.excelFile': 'Excel 파일',
  'pages.logistics.internationalTrackingNumberManagement.form.excelFileRequired': 'Excel 파일을 선택해주세요',

  // Logistics - HS Product Code Management
  'pages.logistics.hsProductCodeManagement.title': 'HS 상품 코드 관리',
  'pages.logistics.hsProductCodeManagement.addTitle': '새 분류 추가',
  'pages.logistics.hsProductCodeManagement.editTitle': 'HS 상품 코드 수정',
  'pages.logistics.hsProductCodeManagement.add': '새 분류 추가',
  'pages.logistics.hsProductCodeManagement.deleteConfirm': '삭제하시겠습니까?',
  'pages.logistics.hsProductCodeManagement.deleteSuccess': '삭제되었습니다',
  'pages.logistics.hsProductCodeManagement.updateSuccess': '수정되었습니다',
  'pages.logistics.hsProductCodeManagement.createSuccess': '생성되었습니다',
  'pages.logistics.hsProductCodeManagement.submitError': '오류가 발생했습니다',
  'pages.logistics.hsProductCodeManagement.importBulk': '분류 일괄 가져오기',
  'pages.logistics.hsProductCodeManagement.importSelective': '분류 선택 가져오기',
  'pages.logistics.hsProductCodeManagement.importBulkTitle': '분류 일괄 가져오기',
  'pages.logistics.hsProductCodeManagement.importSelectiveTitle': '분류 선택 가져오기',
  'pages.logistics.hsProductCodeManagement.importSuccess': '{type} 가져오기가 완료되었습니다',
  'pages.logistics.hsProductCodeManagement.importError': '가져오기 중 오류가 발생했습니다',
  'pages.logistics.hsProductCodeManagement.importType.bulk': '일괄',
  'pages.logistics.hsProductCodeManagement.importType.selective': '선택',
  'pages.logistics.hsProductCodeManagement.export': '분류 내보내기',
  'pages.logistics.hsProductCodeManagement.exportSuccess': '내보내기가 완료되었습니다',
  'pages.logistics.hsProductCodeManagement.fileRequired': '파일을 선택해주세요',
  'pages.logistics.hsProductCodeManagement.uploadFile': '파일 선택',
  'pages.logistics.hsProductCodeManagement.column.id': 'ID',
  'pages.logistics.hsProductCodeManagement.column.classificationName': '분류 이름',
  'pages.logistics.hsProductCodeManagement.column.classificationNameEn': '분류 영문명',
  'pages.logistics.hsProductCodeManagement.column.productCode': '상품 코드',
  'pages.logistics.hsProductCodeManagement.column.simplifiedType': '간이/비간이',
  'pages.logistics.hsProductCodeManagement.column.createdAt': '추가 시간',
  'pages.logistics.hsProductCodeManagement.simplifiedType.simplified': '간이',
  'pages.logistics.hsProductCodeManagement.simplifiedType.nonSimplified': '비간이',
  'pages.logistics.hsProductCodeManagement.form.classificationName': '분류 이름',
  'pages.logistics.hsProductCodeManagement.form.classificationNameRequired': '분류 이름을 입력하세요',
  'pages.logistics.hsProductCodeManagement.form.classificationNamePlaceholder': '분류 이름을 입력하세요',
  'pages.logistics.hsProductCodeManagement.form.classificationNameEn': '분류 영문명',
  'pages.logistics.hsProductCodeManagement.form.classificationNameEnRequired': '분류 영문명을 입력하세요',
  'pages.logistics.hsProductCodeManagement.form.classificationNameEnPlaceholder': '분류 영문명을 입력하세요',
  'pages.logistics.hsProductCodeManagement.form.productCode': '상품 코드',
  'pages.logistics.hsProductCodeManagement.form.productCodeRequired': '상품 코드를 입력하세요',
  'pages.logistics.hsProductCodeManagement.form.productCodePlaceholder': '예: HS6203.42.90',
  'pages.logistics.hsProductCodeManagement.form.simplifiedType': '간이/비간이',
  'pages.logistics.hsProductCodeManagement.form.simplifiedTypeRequired': '간이/비간이를 선택하세요',
  'pages.logistics.hsProductCodeManagement.form.referenceImage': '참고 이미지',
  'pages.logistics.hsProductCodeManagement.form.excelFile': 'Excel 파일',
  'pages.logistics.hsProductCodeManagement.form.excelFileRequired': 'Excel 파일을 선택해주세요',
  'pages.logistics.internationalTrackingNumberManagement.column.originCountry': '출발국가',
  'pages.logistics.internationalTrackingNumberManagement.column.destinationCountry': '도착국가',
  'pages.logistics.internationalTrackingNumberManagement.column.shippingDate': '출고일',
  'pages.logistics.internationalTrackingNumberManagement.column.estimatedDeliveryDate': '예상배송일',
  'pages.logistics.internationalTrackingNumberManagement.column.actualDeliveryDate': '실제배송일',
  'pages.logistics.internationalTrackingNumberManagement.column.customsStatus': '통관상태',
  'pages.logistics.internationalTrackingNumberManagement.status.pending': '대기',
  'pages.logistics.internationalTrackingNumberManagement.status.inTransit': '배송중',
  'pages.logistics.internationalTrackingNumberManagement.status.customsClearance': '통관중',
  'pages.logistics.internationalTrackingNumberManagement.status.delivered': '배송완료',
  'pages.logistics.internationalTrackingNumberManagement.status.exception': '예외',
  'pages.logistics.internationalTrackingNumberManagement.state.pending': '대기',
  'pages.logistics.internationalTrackingNumberManagement.state.inTransit': '배송중',
  'pages.logistics.internationalTrackingNumberManagement.state.customsClearance': '통관중',
  'pages.logistics.internationalTrackingNumberManagement.state.delivered': '배송완료',
  'pages.logistics.internationalTrackingNumberManagement.state.exception': '예외',
  'pages.logistics.internationalTrackingNumberManagement.form.orderNumber': '주문번호',
  'pages.logistics.internationalTrackingNumberManagement.form.orderNumberRequired': '주문번호를 입력하세요',
  'pages.logistics.internationalTrackingNumberManagement.form.carrier': '택배사',
  'pages.logistics.internationalTrackingNumberManagement.form.carrierRequired': '택배사를 선택하세요',
  'pages.logistics.internationalTrackingNumberManagement.form.originCountry': '출발국가',
  'pages.logistics.internationalTrackingNumberManagement.form.originCountryRequired': '출발국가를 입력하세요',
  'pages.logistics.internationalTrackingNumberManagement.form.destinationCountry': '도착국가',
  'pages.logistics.internationalTrackingNumberManagement.form.destinationCountryRequired': '도착국가를 입력하세요',
  'pages.logistics.internationalTrackingNumberManagement.form.status': '상태',
  'pages.logistics.internationalTrackingNumberManagement.form.statusRequired': '상태를 선택하세요',
  'pages.logistics.internationalTrackingNumberManagement.form.state': '상태',
  'pages.logistics.internationalTrackingNumberManagement.form.stateRequired': '상태를 선택하세요',
  'pages.logistics.internationalTrackingNumberManagement.form.time': '시간',
  'pages.logistics.internationalTrackingNumberManagement.form.timeRequired': '시간을 입력하세요',
  'pages.logistics.internationalTrackingNumberManagement.form.customsStatus': '통관상태',
  'pages.logistics.internationalTrackingNumberManagement.form.notes': '비고',

  // Article Management page
  'pages.articleManagement.title': '게시글 관리',
  'pages.articleManagement.add': '게시글 작성',
  'pages.articleManagement.edit': '게시글 수정',
  'pages.articleManagement.delete': '게시글 삭제',
  'pages.articleManagement.deleteConfirm': '게시글 삭제',
  'pages.articleManagement.deleteConfirmMessage': '"{title}" 게시글을 삭제하시겠습니까?',

  // Website Content Management
  'pages.system.websiteContentManagement.title': '웹사이트 콘텐츠 관리',
  'pages.system.websiteContentManagement.tab.seoSettings': '웹사이트 SEO 설정',
  'pages.system.websiteContentManagement.tab.emailConfiguration': '이메일 구성',
  'pages.system.websiteContentManagement.tab.imageSettings': '이미지 설정',
  'pages.system.websiteContentManagement.tab.basicConfiguration': '웹사이트 기본 구성',
  'pages.system.websiteContentManagement.tab.appSettings': '앱 설정',

  // Website SEO Settings
  'pages.system.websiteSEOSettings.title': '웹사이트 SEO 설정',
  'pages.system.websiteSEOSettings.websiteTitle': '웹사이트 제목:',
  'pages.system.websiteSEOSettings.websiteTitlePlaceholder': '웹사이트 제목',
  'pages.system.websiteSEOSettings.websiteKeywords': '웹사이트 키워드:',
  'pages.system.websiteSEOSettings.websiteKeywordsPlaceholder': '웹사이트 키워드',
  'pages.system.websiteSEOSettings.websiteDescription': '웹사이트 설명:',
  'pages.system.websiteSEOSettings.websiteDescriptionPlaceholder': '웹사이트 상세 설명',
  'pages.system.websiteSEOSettings.googleAnalytics': 'Google Analytics:',
  'pages.system.websiteSEOSettings.googleAnalyticsDescription': 'Google Analytics 코드의 토큰 키를 입력하세요',
  'pages.system.websiteSEOSettings.baiduStatistics': 'Baidu 통계:',
  'pages.system.websiteSEOSettings.baiduStatisticsDescription': 'Baidu 분석 코드의 토큰 키를 입력하세요',
  'pages.system.websiteSEOSettings.facebookStatistics': 'Facebook 통계:',
  'pages.system.websiteSEOSettings.facebookStatisticsDescription': 'Facebook 추적 코드, 특히 Facebook 픽셀 추적 코드를 설정하는 것은 Facebook에서 프로모션을 용이하게 하기 위한 것입니다.',
  'pages.system.websiteSEOSettings.javascriptCode': 'JavaScript 코드:',
  'pages.system.websiteSEOSettings.javascriptCodeDescription': '실행해야 하는 기타 JavaScript 코드',
  'pages.system.websiteSEOSettings.javascriptCodePlaceholder': 'JavaScript 코드 입력',
  'pages.system.websiteSEOSettings.mapDomainSettings': '지도 도메인 설정:',
  'pages.system.websiteSEOSettings.mapDomainSettingsDescription': '기본 도메인 이름은 웹사이트 도메인 이름입니다. 공식 도메인 이름을 바인딩한 후 사이트 맵의 도메인 이름이 일괄적으로 공식 도메인 이름으로 변경됩니다.',
  'pages.system.websiteSEOSettings.mapDomainSettingsPlaceholder': '도메인 이름 입력',
  'pages.system.websiteSEOSettings.pleaseEnter': '입력하세요',
  'pages.system.websiteSEOSettings.saveSuccess': '설정이 성공적으로 저장되었습니다',
  'pages.system.websiteSEOSettings.saveError': '설정 저장 실패',

  // Email Configuration
  'pages.system.emailConfiguration.title': '이메일 구성',
  'pages.system.emailConfiguration.emailSMTP': '이메일 SMTP:',
  'pages.system.emailConfiguration.emailSMTPDescription': '이메일을 보내는 서버, 예: smtp.qq.com.',
  'pages.system.emailConfiguration.emailSMTPPlaceholder': 'SMTP 서버 입력',
  'pages.system.emailConfiguration.emailPort': '이메일 포트:',
  'pages.system.emailConfiguration.emailPortDescription': '이메일 주소에 해당하는 포트 번호, 예: 465',
  'pages.system.emailConfiguration.emailPortPlaceholder': '포트 번호 입력',
  'pages.system.emailConfiguration.senderName': '발신자 이름:',
  'pages.system.emailConfiguration.senderNameDescription': '발신자 이름',
  'pages.system.emailConfiguration.senderNamePlaceholder': '발신자 이름 입력',
  'pages.system.emailConfiguration.outboxPassword': '보낸 편지함 비밀번호:',
  'pages.system.emailConfiguration.outboxPasswordDescription': '발신자의 이메일 비밀번호',
  'pages.system.emailConfiguration.outboxPasswordPlaceholder': '비밀번호 입력',
  'pages.system.emailConfiguration.outbox': '보낸 편지함:',
  'pages.system.emailConfiguration.outboxDescription': '발신자의 이메일 주소',
  'pages.system.emailConfiguration.outboxPlaceholder': '이메일 주소 입력',
  'pages.system.emailConfiguration.backendInbox': '백엔드 받은 편지함:',
  'pages.system.emailConfiguration.backendInboxDescription': '백엔드로 전송된 이메일을 받을 이메일 주소 (예: "회원이 주문했습니다").',
  'pages.system.emailConfiguration.backendInboxPlaceholder': '이메일 주소 입력',
  'pages.system.emailConfiguration.recipientName': '수신자 이름:',
  'pages.system.emailConfiguration.recipientNameDescription': '백엔드 이메일을 받을 때 발신자 이름',
  'pages.system.emailConfiguration.recipientNamePlaceholder': '수신자 이름 입력',
  'pages.system.emailConfiguration.platformAccount': '플랫폼 계정:',
  'pages.system.emailConfiguration.platformAccountDescription': '관련 SMS/번역 플랫폼의 로그인 계정을 입력하세요.',
  'pages.system.emailConfiguration.platformAccountPlaceholder': '플랫폼 계정 입력',
  'pages.system.emailConfiguration.platformPassword': '플랫폼 비밀번호:',
  'pages.system.emailConfiguration.platformPasswordDescription': '관련 SMS/번역 플랫폼의 로그인 비밀번호를 입력하세요.',
  'pages.system.emailConfiguration.platformPasswordPlaceholder': '플랫폼 비밀번호 입력',
  'pages.system.emailConfiguration.emailSSL': '이메일 SSL:',
  'pages.system.emailConfiguration.emailSSLDescription': 'ssl',
  'pages.system.emailConfiguration.emailSSLPlaceholder': 'SSL 옵션 선택',
  'pages.system.emailConfiguration.saveSuccess': '설정이 성공적으로 저장되었습니다',
  'pages.system.emailConfiguration.saveError': '설정 저장 실패',

  // Image Settings
  'pages.system.imageSettings.title': '이미지 설정',
  'pages.system.imageSettings.websiteLogo': '웹사이트 로고',
  'pages.system.imageSettings.websiteLogoDescription': '웹사이트 로고 이미지를 업로드하세요',
  'pages.system.imageSettings.homepageQRCode': '홈페이지 QR 코드',
  'pages.system.imageSettings.homepageQRCodeDescription': '홈페이지 QR 코드 이미지를 업로드하세요',
  'pages.system.imageSettings.mobileLogo': '모바일 로고',
  'pages.system.imageSettings.mobileLogoDescription': '모바일 로고 이미지를 업로드하세요',
  'pages.system.imageSettings.pcWebsiteIcon': 'PC 웹사이트 아이콘',
  'pages.system.imageSettings.pcWebsiteIconDescription': 'PC 웹사이트 아이콘(favicon)을 업로드하세요',
  'pages.system.imageSettings.pcPromotionalImage': 'PC 프로모션 이미지',
  'pages.system.imageSettings.pcPromotionalImageDescription': 'PC 프로모션 이미지를 업로드하세요',
  'pages.system.imageSettings.appSharingImage': '앱 공유 이미지',
  'pages.system.imageSettings.appSharingImageDescription': '앱 공유 이미지를 업로드하세요',
  'pages.system.imageSettings.pcRegistrationBackgroundImage': 'PC 회원가입 배경 이미지',
  'pages.system.imageSettings.pcRegistrationBackgroundImageDescription': 'PC 회원가입 배경 이미지를 업로드하세요',
  'pages.system.imageSettings.pcLoginBackgroundImage': 'PC 로그인 배경 이미지',
  'pages.system.imageSettings.pcLoginBackgroundImageDescription': 'PC 로그인 배경 이미지를 업로드하세요',
  'pages.system.imageSettings.defaultDetailImage': '상세 이미지 기본 이미지',
  'pages.system.imageSettings.defaultDetailImageDescription': '상품 상세 기본 이미지를 업로드하세요',
  'pages.system.imageSettings.imageUrlPlaceholder': '이미지 URL',
  'pages.system.imageSettings.upload': '업로드',
  'pages.system.imageSettings.uploadSuccess': '이미지 업로드 성공',
  'pages.system.imageSettings.uploadFailed': '이미지 업로드 실패',
  'pages.system.imageSettings.uploadImageOnly': '이미지 파일만 업로드 가능합니다',
  'pages.system.imageSettings.imageSizeLimit': '이미지 크기는 10MB 미만이어야 합니다',
  'pages.system.imageSettings.saveSuccess': '설정이 성공적으로 저장되었습니다',
  'pages.system.imageSettings.saveError': '설정 저장 실패',

  // Website Basic Configuration
  'pages.system.websiteBasicConfiguration.title': '웹사이트 기본 구성',
  'pages.system.websiteBasicConfiguration.websiteName': '웹사이트 이름:',
  'pages.system.websiteBasicConfiguration.websiteNamePlaceholder': '웹사이트 이름 입력',
  'pages.system.websiteBasicConfiguration.websiteHomepageName': '웹사이트 홈페이지 이름 (xxxx에 오신 것을 환영합니다)',
  'pages.system.websiteBasicConfiguration.websiteHomepageNameDescription': 'xxxx에 오신 것을 환영합니다',
  'pages.system.websiteBasicConfiguration.websiteHomepageNamePlaceholder': '홈페이지 이름 입력',
  'pages.system.websiteBasicConfiguration.storageFees': '보관 수수료:',
  'pages.system.websiteBasicConfiguration.storageFeesDescription': '보관 수수료 (단가/일)',
  'pages.system.websiteBasicConfiguration.storageFeesPlaceholder': '보관 수수료 입력',
  'pages.system.websiteBasicConfiguration.storageDays': '보관 일수:',
  'pages.system.websiteBasicConfiguration.storageDaysDescription': '창고 무료 보관 일수 (단위: 일)',
  'pages.system.websiteBasicConfiguration.storageDaysPlaceholder': '보관 일수 입력',
  'pages.system.websiteBasicConfiguration.expirationTime': '만료 시간:',
  'pages.system.websiteBasicConfiguration.expirationTimeDescription': '장바구니 상품 만료 시간 (단위: 일)',
  'pages.system.websiteBasicConfiguration.expirationTimePlaceholder': '만료 시간 입력',
  'pages.system.websiteBasicConfiguration.deleteShoppingCart': '장바구니 삭제:',
  'pages.system.websiteBasicConfiguration.deleteShoppingCartDescription': '장바구니 상품이 얼마 후에 제거될까요? (단위: 일)',
  'pages.system.websiteBasicConfiguration.deleteShoppingCartPlaceholder': '일수 입력',
  'pages.system.websiteBasicConfiguration.registrationAgreement': '등록 약관:',
  'pages.system.websiteBasicConfiguration.registrationAgreementDescription': '등록 페이지 개인정보 약관 게시물 구성 (게시물 관리에서 추가한 게시물 ID를 입력해야 함)',
  'pages.system.websiteBasicConfiguration.registrationAgreementPlaceholder': '게시물 ID 입력',
  'pages.system.websiteBasicConfiguration.exportList': '내보내기 목록:',
  'pages.system.websiteBasicConfiguration.exportListDescription': '미국 달러 환율과 주 통화의 비율',
  'pages.system.websiteBasicConfiguration.exportListPlaceholder': '환율 입력',
  'pages.system.websiteBasicConfiguration.customerServiceCode': '회원 서비스 코드:',
  'pages.system.websiteBasicConfiguration.customerServiceCodeDescription': '회원 서비스 JavaScript 코드 설정',
  'pages.system.websiteBasicConfiguration.customerServiceCodePlaceholder': '입력하세요',
  'pages.system.websiteBasicConfiguration.customerServiceHotline': '회원 서비스 핫라인:',
  'pages.system.websiteBasicConfiguration.customerServiceHotlineDescription': '웹사이트 연락처 정보 설정',
  'pages.system.websiteBasicConfiguration.customerServiceHotlinePlaceholder': '핫라인 입력',
  'pages.system.websiteBasicConfiguration.customerServiceEmail': '회원 서비스 이메일:',
  'pages.system.websiteBasicConfiguration.customerServiceEmailDescription': '웹사이트 연락처 정보 설정',
  'pages.system.websiteBasicConfiguration.customerServiceEmailPlaceholder': '이메일 입력',
  'pages.system.websiteBasicConfiguration.filingInformation': '등록 정보:',
  'pages.system.websiteBasicConfiguration.filingInformationDescription': '웹사이트 푸터 저작권 정보 및 등록 설정',
  'pages.system.websiteBasicConfiguration.filingInformationPlaceholder': '등록 정보 입력',
  'pages.system.websiteBasicConfiguration.customerServiceWeChat': '회원 서비스 위챗:',
  'pages.system.websiteBasicConfiguration.customerServiceWeChatDescription': '웹사이트 연락처 정보 설정',
  'pages.system.websiteBasicConfiguration.customerServiceWeChatPlaceholder': '위챗 입력',
  'pages.system.websiteBasicConfiguration.themeColorSettings': '테마 색상 설정:',
  'pages.system.websiteBasicConfiguration.themeColorSettingsDescription': '웹사이트 테마 색상, 아이콘 제외',
  'pages.system.websiteBasicConfiguration.shippingUnit': '배송 단위:',
  'pages.system.websiteBasicConfiguration.shippingUnitDescription': '배송 단위 설정: kg/g 입력. (주요 표시 페이지 표시: 배송비 추정 및 주문하기.)',
  'pages.system.websiteBasicConfiguration.shippingUnitPlaceholder': 'kg/g 입력',
  'pages.system.websiteBasicConfiguration.frontEndHomepage': '프론트엔드 홈페이지:',
  'pages.system.websiteBasicConfiguration.frontEndHomepageDescription': '기본 홈페이지',
  'pages.system.websiteBasicConfiguration.frontEndHomepagePlaceholder': '홈페이지 경로 입력',
  'pages.system.websiteBasicConfiguration.regionalAdministrativeCode': '지역 행정 코드:',
  'pages.system.websiteBasicConfiguration.regionalAdministrativeCodeDescription': '구매 창고 주소의 행정 코드 처음 6자리 숫자 입력 (다음에서 지역 코드 조회: https://xingzhengquhua.bmcx.com/)',
  'pages.system.websiteBasicConfiguration.regionalAdministrativeCodePlaceholder': '6자리 코드 입력',
  'pages.system.websiteBasicConfiguration.cancelOrder': '주문 취소:',
  'pages.system.websiteBasicConfiguration.cancelOrderDescription': '구매 주문이 자동으로 취소되는 시간을 설정합니다.',
  'pages.system.websiteBasicConfiguration.cancelOrderPlaceholder': '시간 입력',
  'pages.system.websiteBasicConfiguration.automaticConfirmationTimeout': '시간 초과 후 자동 수령 확인 (시간):',
  'pages.system.websiteBasicConfiguration.automaticConfirmationTimeoutDescription': 'xxx시간 후 자동 배송',
  'pages.system.websiteBasicConfiguration.automaticConfirmationTimeoutPlaceholder': '시간 입력',
  'pages.system.websiteBasicConfiguration.homepageWaterfallLayoutKeywords': '홈페이지 워터폴 레이아웃 키워드:',
  'pages.system.websiteBasicConfiguration.homepageWaterfallLayoutKeywordsDescription': '중국어 키워드만 허용됩니다. 여러 키워드를 입력할 수 있습니다.',
  'pages.system.websiteBasicConfiguration.homepageWaterfallLayoutKeywordsPlaceholder': '쉼표로 구분된 키워드 입력',
  'pages.system.websiteBasicConfiguration.saveSuccess': '설정이 성공적으로 저장되었습니다',
  'pages.system.websiteBasicConfiguration.saveError': '설정 저장 실패',

  // App Settings
  'pages.system.appSettings.title': '앱 설정',
  'pages.system.appSettings.androidVersionNumber': 'Android 버전 번호:',
  'pages.system.appSettings.androidVersionNumberDescription': 'Android 앱 버전 번호를 입력하세요',
  'pages.system.appSettings.androidVersionNumberPlaceholder': '예: 1.0.0',
  'pages.system.appSettings.iosVersionNumber': 'iOS 버전 번호:',
  'pages.system.appSettings.iosVersionNumberDescription': 'iOS 앱 버전 번호를 입력하세요',
  'pages.system.appSettings.iosVersionNumberPlaceholder': '예: 1.0.0',
  'pages.system.appSettings.androidDownloadLink': 'Android 다운로드 링크:',
  'pages.system.appSettings.androidDownloadLinkDescription': 'Android 앱 다운로드 링크를 입력하세요',
  'pages.system.appSettings.androidDownloadLinkPlaceholder': 'https://...',
  'pages.system.appSettings.iosDownloadLink': 'iOS 다운로드 링크:',
  'pages.system.appSettings.iosDownloadLinkDescription': 'iOS 앱 다운로드 링크를 입력하세요',
  'pages.system.appSettings.iosDownloadLinkPlaceholder': 'https://...',
  'pages.system.appSettings.saveSuccess': '설정이 성공적으로 저장되었습니다',
  'pages.system.appSettings.saveError': '설정 저장 실패',
  'pages.articleManagement.deleteSuccess': '게시글이 삭제되었습니다',
  'pages.articleManagement.updateSuccess': '게시글이 수정되었습니다',
  'pages.articleManagement.createSuccess': '게시글이 등록되었습니다',
  'pages.articleManagement.id': 'ID',
  'pages.articleManagement.titleColumn': '제목',
  'pages.articleManagement.category': '카테고리',
  'pages.articleManagement.category.notice': '공지사항',
  'pages.articleManagement.category.news': '뉴스',
  'pages.articleManagement.category.guide': '이용가이드',
  'pages.articleManagement.category.event': '이벤트',
  'pages.articleManagement.category.faq': 'FAQ',
  'pages.articleManagement.author': '작성자',
  'pages.articleManagement.status': '상태',
  'pages.articleManagement.status.published': '게시중',
  'pages.articleManagement.status.draft': '임시저장',
  'pages.articleManagement.status.hidden': '숨김',
  'pages.articleManagement.tags': '태그',
  'pages.articleManagement.views': '조회수',
  'pages.articleManagement.likes': '좋아요',
  'pages.articleManagement.comments': '댓글',
  'pages.articleManagement.createdAt': '작성일',
  'pages.articleManagement.updatedAt': '수정일',
  'pages.articleManagement.actions': '작업',
  'pages.articleManagement.view': '보기',
  'pages.articleManagement.editButton': '수정',
  'pages.articleManagement.deleteButton': '삭제',
  'pages.articleManagement.form.title': '제목',
  'pages.articleManagement.form.titleRequired': '제목을 입력하세요',
  'pages.articleManagement.form.titlePlaceholder': '게시글 제목',
  'pages.articleManagement.form.category': '카테고리',
  'pages.articleManagement.form.categoryPlaceholder': '카테고리 선택',
  'pages.articleManagement.form.content': '내용',
  'pages.articleManagement.form.contentRequired': '내용을 입력하세요',
  'pages.articleManagement.form.contentPlaceholder': '게시글 내용을 입력하세요',
  'pages.articleManagement.form.tags': '태그',
  'pages.articleManagement.form.tagsPlaceholder': '태그 입력 (Enter로 추가)',
  'pages.articleManagement.form.status': '상태',
  'pages.articleManagement.form.statusPlaceholder': '상태 선택',
  'pages.articleManagement.mock.title1': '신규 서비스 오픈 안내',
  'pages.articleManagement.mock.title2': '배송 지연 공지',
  'pages.articleManagement.mock.title3': '타오바오 구매 가이드',
  'pages.articleManagement.mock.title4': '할인 이벤트',
  'pages.articleManagement.mock.title5': 'FAQ 업데이트',
  'pages.articleManagement.mock.author1': '관리자',
  'pages.articleManagement.mock.author2': '운영팀',
  'pages.articleManagement.mock.author3': '회원센터',
  'pages.articleManagement.mock.content': '게시글 내용입니다...',
  'pages.articleManagement.mock.tag1': '중요',
  'pages.articleManagement.mock.tag2': '필독',
  'pages.articleManagement.mock.tag3': '이벤트',
  'pages.articleManagement.mock.tag4': '긴급',

  // Advertise Management
  'pages.advertise.title': '광고 관리',
  'pages.advertise.list': '광고 목록',
  'pages.advertise.add': '광고 등록',
  'pages.advertise.edit': '광고 수정',
  'pages.advertise.delete': '광고 삭제',
  'pages.advertise.deleteConfirm': '"{title}" 광고를 삭제하시겠습니까?',
  'pages.advertise.deleteSuccess': '광고가 삭제되었습니다',
  'pages.advertise.updateSuccess': '광고가 수정되었습니다',
  'pages.advertise.createSuccess': '광고가 등록되었습니다',
  'pages.advertise.column.id': 'ID',
  'pages.advertise.column.title': '광고명',
  'pages.advertise.column.image': '광고 이미지',
  'pages.advertise.column.type': '광고 유형',
  'pages.advertise.column.position': '노출 위치',
  'pages.advertise.column.linkUrl': '링크 URL',
  'pages.advertise.column.dateRange': '게시 기간',
  'pages.advertise.column.startDate': '시작일',
  'pages.advertise.column.endDate': '종료일',
  'pages.advertise.column.status': '상태',
  'pages.advertise.column.order': '노출 순서',
  'pages.advertise.column.views': '조회수',
  'pages.advertise.column.clicks': '클릭수',
  'pages.advertise.column.action': '작업',
  'pages.advertise.type.banner': '배너',
  'pages.advertise.type.popup': '팝업',
  'pages.advertise.type.sidebar': '사이드바',
  'pages.advertise.position.mainTop': '메인 상단',
  'pages.advertise.position.mainMiddle': '메인 중단',
  'pages.advertise.position.mainBottom': '메인 하단',
  'pages.advertise.position.productList': '상품 목록',
  'pages.advertise.position.productDetail': '상품 상세',
  'pages.advertise.position.orderPage': '주문 페이지',
  'pages.advertise.status.active': '활성',
  'pages.advertise.status.inactive': '비활성',
  'pages.advertise.action.preview': '미리보기',
  'pages.advertise.action.edit': '수정',
  'pages.advertise.action.delete': '삭제',
  'pages.advertise.form.title': '광고명',
  'pages.advertise.form.titlePlaceholder': '광고명',
  'pages.advertise.form.titleRequired': '광고명을 입력하세요',
  'pages.advertise.form.type': '광고 유형',
  'pages.advertise.form.typePlaceholder': '광고 유형 선택',
  'pages.advertise.form.position': '노출 위치',
  'pages.advertise.form.positionPlaceholder': '노출 위치 선택',
  'pages.advertise.form.image': '광고 이미지',
  'pages.advertise.form.imageUpload': '이미지 업로드',
  'pages.advertise.form.dateRange': '게시 기간',
  'pages.advertise.form.dateRangeRequired': '게시 기간을 선택하세요',
  'pages.advertise.form.linkUrl': '링크 URL',
  'pages.advertise.form.linkUrlPlaceholder': 'https://example.com',
  'pages.advertise.form.linkUrlInvalid': '올바른 URL을 입력하세요',
  'pages.advertise.form.order': '노출 순서',
  'pages.advertise.form.orderPlaceholder': '숫자가 작을수록 먼저 노출됩니다',
  'pages.advertise.form.status': '상태',
  'pages.advertise.form.statusPlaceholder': '상태 선택',
  'pages.advertise.mock.newMemberDiscount': '신규회원 할인',
  'pages.advertise.mock.freeShippingEvent': '무료배송 이벤트',
  'pages.advertise.mock.timeSale': '타임세일',
  'pages.advertise.mock.seasonSpecial': '시즌 특가',
  'pages.advertise.mock.adSuffix': '광고',

  // Banners Management
  'pages.banners.title': '배너/이벤트 관리',
  'pages.banners.list': '배너 목록',
  'pages.banners.add': '배너 등록',
  'pages.banners.edit': '배너 수정',
  'pages.banners.delete': '배너 삭제',
  'pages.banners.deleteConfirm': '"{title}" 배너를 삭제하시겠습니까?',
  'pages.banners.deleteSuccess': '배너가 삭제되었습니다',
  'pages.banners.updateSuccess': '배너가 수정되었습니다',
  'pages.banners.createSuccess': '배너가 등록되었습니다',
  'pages.banners.column.id': 'ID',
  'pages.banners.column.image': '배너 이미지',
  'pages.banners.column.title': '배너명',
  'pages.banners.column.position': '노출 위치',
  'pages.banners.column.order': '노출 순서',
  'pages.banners.column.dateRange': '게시 기간',
  'pages.banners.column.views': '조회수',
  'pages.banners.column.clicks': '클릭수',
  'pages.banners.column.status': '상태',
  'pages.banners.column.action': '작업',
  'pages.banners.position.mainTop': '메인 상단',
  'pages.banners.position.mainMiddle': '메인 중단',
  'pages.banners.position.mainBottom': '메인 하단',
  'pages.banners.position.sidebar': '사이드바',
  'pages.banners.status.active': '활성',
  'pages.banners.status.inactive': '비활성',
  'pages.banners.status.expired': '만료',
  'pages.banners.action.preview': '미리보기',
  'pages.banners.action.edit': '수정',
  'pages.banners.action.delete': '삭제',
  'pages.banners.form.title': '배너명',
  'pages.banners.form.titlePlaceholder': '배너명',
  'pages.banners.form.titleRequired': '배너명을 입력하세요',
  'pages.banners.form.position': '노출 위치',
  'pages.banners.form.positionPlaceholder': '노출 위치 선택',
  'pages.banners.form.image': '배너 이미지',
  'pages.banners.form.imageUpload': '이미지 업로드',
  'pages.banners.form.linkUrl': '링크 URL',
  'pages.banners.form.linkUrlPlaceholder': 'https://example.com',
  'pages.banners.form.linkUrlInvalid': '올바른 URL을 입력하세요',
  'pages.banners.form.dateRange': '게시 기간',
  'pages.banners.form.dateRangeRequired': '게시 기간을 선택하세요',
  'pages.banners.form.order': '노출 순서',
  'pages.banners.form.orderPlaceholder': '숫자가 작을수록 먼저 노출됩니다',
  'pages.banners.form.status': '상태',
  'pages.banners.form.statusActive': '활성',
  'pages.banners.form.statusInactive': '비활성',
  'pages.banners.mock.newMemberDiscount': '신규회원 할인',
  'pages.banners.mock.freeShipping': '무료배송',
  'pages.banners.mock.timeSale': '타임세일',
  'pages.banners.mock.seasonSpecial': '시즌 특가',
  'pages.banners.mock.eventSuffix': '이벤트',

  // Banner Advertisement Management
  'pages.bannerAdvertisement.title': '배너 관리',
  'pages.bannerAdvertisement.list': '배너 목록',
  'pages.bannerAdvertisement.add': '배너 등록',
  'pages.bannerAdvertisement.edit': '배너 수정',
  'pages.bannerAdvertisement.delete': '배너 삭제',
  'pages.bannerAdvertisement.deleteConfirm': '"{title}" 배너를 삭제하시겠습니까?',
  'pages.bannerAdvertisement.deleteSuccess': '배너가 삭제되었습니다',
  'pages.bannerAdvertisement.updateSuccess': '배너가 수정되었습니다',
  'pages.bannerAdvertisement.createSuccess': '배너가 등록되었습니다',
  'pages.bannerAdvertisement.loadBannerError': '배너 정보를 불러오는데 실패했습니다',
  'pages.bannerAdvertisement.deleteError': '삭제에 실패했습니다',
  'pages.bannerAdvertisement.operationFailed': '작업에 실패했습니다',
  'pages.bannerAdvertisement.column.id': 'ID',
  'pages.bannerAdvertisement.column.image': '이미지',
  'pages.bannerAdvertisement.column.title': '제목',
  'pages.bannerAdvertisement.column.category': '카테고리',
  'pages.bannerAdvertisement.column.exposureLocation': '노출 위치',
  'pages.bannerAdvertisement.column.exposureOrder': '노출 순서',
  'pages.bannerAdvertisement.column.dateRange': '게시 기간',
  'pages.bannerAdvertisement.column.views': '조회수',
  'pages.bannerAdvertisement.column.clicks': '클릭수',
  'pages.bannerAdvertisement.column.status': '상태',
  'pages.bannerAdvertisement.column.active': '활성',
  'pages.bannerAdvertisement.column.action': '작업',
  'pages.bannerAdvertisement.category.promotion': '프로모션',
  'pages.bannerAdvertisement.category.event': '이벤트',
  'pages.bannerAdvertisement.category.announcement': '공지사항',
  'pages.bannerAdvertisement.category.product': '상품',
  'pages.bannerAdvertisement.category.other': '기타',
  'pages.bannerAdvertisement.location.home': '홈',
  'pages.bannerAdvertisement.location.category': '카테고리',
  'pages.bannerAdvertisement.location.product': '상품',
  'pages.bannerAdvertisement.location.cart': '장바구니',
  'pages.bannerAdvertisement.location.checkout': '결제',
  'pages.bannerAdvertisement.location.profile': '프로필',
  'pages.bannerAdvertisement.location.other': '기타',
  'pages.bannerAdvertisement.situation.active': '활성',
  'pages.bannerAdvertisement.situation.inactive': '비활성',
  'pages.bannerAdvertisement.situation.scheduled': '예약됨',
  'pages.bannerAdvertisement.situation.expired': '만료',
  'pages.bannerAdvertisement.status.active': '활성',
  'pages.bannerAdvertisement.status.inactive': '비활성',
  'pages.bannerAdvertisement.action.edit': '수정',
  'pages.bannerAdvertisement.action.delete': '삭제',
  'pages.bannerAdvertisement.form.title': '제목',
  'pages.bannerAdvertisement.form.titleRequired': '제목을 입력하세요',
  'pages.bannerAdvertisement.form.titleAtLeastOneLanguage': '최소 하나의 언어로 제목을 입력하세요',
  'pages.bannerAdvertisement.form.titlePlaceholder': '배너 제목 (최대 200자)',
  'pages.bannerAdvertisement.form.imageUrl': '이미지 URL',
  'pages.bannerAdvertisement.form.imageUrlRequired': '이미지 URL을 입력하세요',
  'pages.bannerAdvertisement.form.imageUrlPlaceholder': 'https://example.com/banner.jpg',
  'pages.bannerAdvertisement.form.category': '카테고리',
  'pages.bannerAdvertisement.form.categoryRequired': '카테고리를 선택하세요',
  'pages.bannerAdvertisement.form.categoryPlaceholder': '카테고리 선택',
  'pages.bannerAdvertisement.form.exposureLocation': '노출 위치',
  'pages.bannerAdvertisement.form.exposureLocationRequired': '노출 위치를 선택하세요',
  'pages.bannerAdvertisement.form.exposureLocationPlaceholder': '노출 위치 선택',
  'pages.bannerAdvertisement.form.exposureOrder': '노출 순서',
  'pages.bannerAdvertisement.form.exposureOrderRequired': '노출 순서를 입력하세요',
  'pages.bannerAdvertisement.form.exposureOrderPlaceholder': '숫자가 작을수록 먼저 노출됩니다 (0 이상)',
  'pages.bannerAdvertisement.form.startDate': '시작 일시',
  'pages.bannerAdvertisement.form.startDateRequired': '시작 일시를 선택하세요',
  'pages.bannerAdvertisement.form.startDatePlaceholder': '시작 일시 선택',
  'pages.bannerAdvertisement.form.endDate': '종료 일시',
  'pages.bannerAdvertisement.form.endDateRequired': '종료 일시를 선택하세요',
  'pages.bannerAdvertisement.form.endDatePlaceholder': '종료 일시 선택',
  'pages.bannerAdvertisement.form.linkUrl': '링크 URL',
  'pages.bannerAdvertisement.form.linkUrlInvalid': '올바른 URL 형식을 입력하세요',
  'pages.bannerAdvertisement.form.linkUrlPlaceholder': 'https://example.com (선택사항)',
  'pages.bannerAdvertisement.form.isActive': '활성 상태',
  'pages.bannerAdvertisement.form.isActiveActive': '활성',
  'pages.bannerAdvertisement.form.isActiveInactive': '비활성',
  'pages.bannerAdvertisement.validation.startEndDateRequired': '시작 일시와 종료 일시를 모두 선택하세요',
  'pages.bannerAdvertisement.validation.endDateAfterStartDate': '종료 일시는 시작 일시보다 이후여야 합니다',
  'pages.bannerAdvertisement.validation.titleAtLeastOneLanguage': '최소 하나의 언어로 제목을 입력하세요',
  'pages.bannerAdvertisement.validation.imageUrlRequired': '이미지 URL을 입력하세요',
  'pages.bannerAdvertisement.validation.categoryRequired': '카테고리를 선택하세요',
  'pages.bannerAdvertisement.validation.exposureLocationRequired': '노출 위치를 선택하세요',
  'pages.bannerAdvertisement.modal.edit': '수정',
  'pages.bannerAdvertisement.modal.register': '등록',
  'pages.bannerAdvertisement.modal.cancel': '취소',
  'pages.bannerAdvertisement.image.noImage': '이미지 없음',
  'pages.bannerAdvertisement.pagination.total': '총 {total}개',
  'pages.bannerAdvertisement.multilingual.korean': '한국어',
  'pages.bannerAdvertisement.multilingual.koreanPlaceholder': '한국어로 입력하세요',
  'pages.bannerAdvertisement.multilingual.english': 'English',
  'pages.bannerAdvertisement.multilingual.englishPlaceholder': 'Enter in English',
  'pages.bannerAdvertisement.multilingual.chinese': '中文',
  'pages.bannerAdvertisement.multilingual.chinesePlaceholder': '请输入中文',
  'pages.bannerAdvertisement.tabs.banners': '배너',
  'pages.bannerAdvertisement.tabs.carousel': '캐러셀',
  'pages.bannerAdvertisement.tabs.popup': '팝업 (라이브 / 셀러 / 상품)',
  'pages.bannerAdvertisement.popup.introTitle': '페이지 팝업 설정',
  'pages.bannerAdvertisement.popup.introDesc':
    '라이브 페이지, 셀러 상세, 상품 상세에 표시할 팝업을 설정합니다. 슬롯을 켜고 이미지·동영상 URL·문구·링크를 입력한 뒤 저장하세요. 앱/웹은 GET /admin/marketing-popups 로 동일한 JSON을 불러오면 됩니다.',
  'pages.bannerAdvertisement.popup.localOnlyTitle': '이 브라우저에만 저장됨',
  'pages.bannerAdvertisement.popup.localOnlyDesc':
    'marketing-popups API를 사용할 수 없습니다. 설정은 localStorage에 저장되어 관리자 PC에서만 유지됩니다. 서버 API를 연결하면 전 사용자에게 반영됩니다.',
  'pages.bannerAdvertisement.popup.slot.live': '라이브 페이지',
  'pages.bannerAdvertisement.popup.slot.sellerDetail': '셀러 상세 페이지',
  'pages.bannerAdvertisement.popup.slot.productDetail': '상품 상세 페이지',
  'pages.bannerAdvertisement.popup.image': '팝업 이미지',
  'pages.bannerAdvertisement.popup.changeImage': '이미지 변경',
  'pages.bannerAdvertisement.popup.videoUrl': '동영상 URL',
  'pages.bannerAdvertisement.popup.videoUrlPlaceholder': 'https://… (mp4 등 직접 링크)',
  'pages.bannerAdvertisement.popup.videoHint':
    '동영상 파일 업로드 전용 API가 생기면 이미지와 동일한 방식으로 연동할 수 있습니다. 현재는 URL로 입력해 주세요.',
  'pages.bannerAdvertisement.popup.link': '클릭 시 이동 링크',
  'pages.bannerAdvertisement.popup.title': '제목 (다국어)',
  'pages.bannerAdvertisement.popup.body': '본문 (다국어)',
  'pages.bannerAdvertisement.popup.saveAll': '팝업 설정 저장',
  'pages.bannerAdvertisement.popup.saveSuccess': '팝업 설정이 저장되었습니다',
  'pages.bannerAdvertisement.popup.saveLocalSuccess': '로컬에만 저장되었습니다 (API 미연동)',
  'pages.bannerAdvertisement.popup.saveFailed': '팝업 설정 저장에 실패했습니다',
  'pages.bannerAdvertisement.carousel.manage': '캐러셀 관리',
  'pages.bannerAdvertisement.carousel.title': '캐러셀 관리',
  'pages.bannerAdvertisement.carousel.noItems': '캐러셀 항목이 없습니다',
  'pages.bannerAdvertisement.carousel.save': '저장',
  'pages.bannerAdvertisement.carousel.saveSuccess': '캐러셀이 저장되었습니다',
  'pages.bannerAdvertisement.carousel.item': '항목',
  'pages.bannerAdvertisement.carousel.remove': '제거',
  'pages.bannerAdvertisement.carousel.addItem': '캐러셀 항목 추가',
  'pages.bannerAdvertisement.carousel.imageTitle': '이미지 제목',
  'pages.bannerAdvertisement.carousel.imageTitleRequired': '이미지 제목을 입력하세요',
  'pages.bannerAdvertisement.carousel.imageTitleAtLeastOneLanguage': '최소 하나의 언어로 이미지 제목을 입력하세요',
  'pages.bannerAdvertisement.carousel.imageTitlePlaceholder': '이미지 제목을 입력하세요',
  'pages.bannerAdvertisement.carousel.number': '번호 (순서)',
  'pages.bannerAdvertisement.carousel.numberTooltip': '회원 기기에서 표시되는 순서대로 크기 조정',
  'pages.bannerAdvertisement.carousel.numberRequired': '순서 번호를 입력하세요',
  'pages.bannerAdvertisement.carousel.link': '링크',
  'pages.bannerAdvertisement.carousel.linkTooltip': '회원 기기에서 캐러셀 이미지를 클릭하면 해당 링크로 이동',
  'pages.bannerAdvertisement.carousel.linkRequired': '링크 URL을 입력하세요',
  'pages.bannerAdvertisement.carousel.linkInvalid': '올바른 URL을 입력하세요',
  'pages.bannerAdvertisement.carousel.linkPlaceholder': 'https://example.com',
  'pages.bannerAdvertisement.carousel.active': '활성화',
  'pages.bannerAdvertisement.carousel.displayLocation': '표시 위치',
  'pages.bannerAdvertisement.carousel.desktopDisplaySize': '데스크톱 표시 크기',
  'pages.bannerAdvertisement.carousel.mobileDisplaySize': '모바일 표시 크기',
  'pages.bannerAdvertisement.carousel.width': '너비',
  'pages.bannerAdvertisement.carousel.height': '높이',
  'pages.bannerAdvertisement.carousel.imageUpload': '이미지 업로드',
  'pages.bannerAdvertisement.carousel.desktopImageUpload': '데스크톱용 이미지 크기 업로드',
  'pages.bannerAdvertisement.carousel.mobileImageUpload': '모바일용 이미지 크기 업로드',
  'pages.bannerAdvertisement.carousel.desktopImageRequired': '데스크톱 이미지를 업로드하세요',
  'pages.bannerAdvertisement.carousel.mobileImageRequired': '모바일 이미지를 업로드하세요',
  'pages.bannerAdvertisement.carousel.imageUrlPlaceholder': '이미지 URL 또는 이미지 업로드',
  'pages.bannerAdvertisement.carousel.upload': '업로드',
  'pages.bannerAdvertisement.carousel.uploadSuccess': '이미지가 업로드되었습니다',
  'pages.bannerAdvertisement.carousel.uploadFailed': '이미지 업로드에 실패했습니다',
  'pages.bannerAdvertisement.carousel.uploadImageOnly': '이미지 파일만 업로드 가능합니다',
  'pages.bannerAdvertisement.carousel.imageSizeLimit': '이미지 크기는 10MB 이하여야 합니다',
  'pages.bannerAdvertisement.carousel.masterImageUpload': '배너 이미지 (한 장)',
  'pages.bannerAdvertisement.carousel.masterImageRequired': '배너 이미지를 업로드하세요',
  'pages.bannerAdvertisement.carousel.masterImageHint':
    '서버에서 이 파일로 PC용·모바일용 최적화 이미지를 각각 생성합니다.',
  'pages.bannerAdvertisement.carousel.savedPcMobileHint': '현재 저장된 PC / 모바일 이미지 (위에서 새 이미지를 올리면 교체됩니다).',

  // 창고 관리
  'pages.storehouse.expressInspection.title': '택배 입고 검수',
  'pages.storehouse.expressInspection.column.userInfo': '회원 정보(UID)',
  'pages.storehouse.expressInspection.column.orderNo': '주문번호',
  'pages.storehouse.expressInspection.column.trackingNumber': '운송장 번호',
  'pages.storehouse.expressInspection.column.courier': '택배사',
  'pages.storehouse.expressInspection.column.status': '상태',
  'pages.storehouse.expressInspection.column.inboundWeight': '입고 중량',
  'pages.storehouse.expressInspection.column.inboundDimensions': '입고 크기(가×세×높)',
  'pages.storehouse.expressInspection.column.locationInfo': '창고 위치 정보',
  'pages.storehouse.expressInspection.column.inspectionInfo': '검수 정보',
  'pages.storehouse.expressInspection.column.orderService': '주문 서비스',
  'pages.storehouse.expressInspection.column.userRemarks': '회원 메모',
  'pages.storehouse.expressInspection.column.warehouseRemarks': '창고 메모',
  'pages.storehouse.expressInspection.status.pending': '대기',
  'pages.storehouse.expressInspection.status.inspected': '검수완료',
  'pages.storehouse.expressInspection.status.error': '오류',
  'pages.storehouse.expressInspection.filter.total': '전체',
  'pages.storehouse.expressInspection.filter.notYetStored': '미입고',
  'pages.storehouse.expressInspection.filter.received': '수령',
  'pages.storehouse.expressInspection.filter.inspected': '검수 완료',
  'pages.storehouse.expressInspection.filter.weightedAndStored': '계량 및 입고',
  'pages.storehouse.expressInspection.filter.availableNow': '사용 가능',
  'pages.storehouse.expressInspection.filter.removedFromShelves': '선반에서 제거',
  'pages.storehouse.expressInspection.filter.title': '필터',
  'pages.storehouse.expressInspection.filterApplied': '필터 적용됨: {label}',
  'pages.storehouse.expressInspection.filterCleared': '필터가 지워졌습니다',
  'pages.storehouse.expressInspection.viewAll': '전체 보기',
  'pages.storehouse.expressInspection.action.inspect': '검수',
  'pages.storehouse.expressInspection.action.batchInspect': '일괄 검수',
  'pages.storehouse.expressInspection.action.expand': '펼치기',
  'pages.storehouse.expressInspection.action.collapse': '접기',
  'pages.storehouse.expressInspection.expandIconTitle': '펼치기',
  'pages.storehouse.expressInspection.product.column.image': '商品图片',
  'pages.storehouse.expressInspection.product.column.name': '상품명',
  'pages.storehouse.expressInspection.product.column.specifications': '规格属性',
  'pages.storehouse.expressInspection.product.column.quantity': '수량',
  'pages.storehouse.expressInspection.product.column.cargoValue': '货物价值',
  'pages.storehouse.expressInspection.product.column.inboundWeight': '入库重量',
  'pages.storehouse.expressInspection.product.column.inboundDimensions': '入库长宽高',
  'pages.storehouse.expressInspection.product.column.location': '所在库位',
  'pages.storehouse.expressInspection.product.column.cargoAttributes': '货物属性',
  'pages.storehouse.expressInspection.product.column.inspectionPhotos': '精细验货照片',
  'pages.storehouse.expressInspection.product.unit.won': '원',
  'pages.storehouse.expressInspection.product.unit.cm': 'cm',

  'pages.storehouse.nonMasterCourier.title': '비주류 택배 입고',
  'pages.storehouse.nonMasterCourier.column.trackingNumber': '운송장 번호',
  'pages.storehouse.nonMasterCourier.column.courier': '택배사',
  'pages.storehouse.nonMasterCourier.column.enteredDate': '입고일시',
  'pages.storehouse.nonMasterCourier.column.orderNo': '주문번호',
  'pages.storehouse.nonMasterCourier.column.customerName': '회원명',
  'pages.storehouse.nonMasterCourier.column.productCount': '상품 수량',
  'pages.storehouse.nonMasterCourier.column.status': '상태',
  'pages.storehouse.nonMasterCourier.status.pending': '대기',
  'pages.storehouse.nonMasterCourier.status.processed': '처리완료',
  'pages.storehouse.nonMasterCourier.status.error': '오류',
  'pages.storehouse.nonMasterCourier.viewUnclaimed': '미인수 패키지 입고 기록 보기',
  'pages.storehouse.nonMasterCourier.storehouse': '창고',
  'pages.storehouse.nonMasterCourier.storehouseRequired': '창고를 선택하세요',
  'pages.storehouse.nonMasterCourier.warehouseLocationType': '창고 위치 유형',
  'pages.storehouse.nonMasterCourier.warehouseLocationTypeRequired': '창고 위치 유형을 선택하세요',
  'pages.storehouse.nonMasterCourier.locationType.largeCargo': '대형 화물 구역',
  'pages.storehouse.nonMasterCourier.locationType.fileArea': '파일 구역',
  'pages.storehouse.nonMasterCourier.locationType.sensitiveGoods': '민감 물품 구역',
  'pages.storehouse.nonMasterCourier.locationType.generalGoods': '일반 물품 구역',
  'pages.storehouse.nonMasterCourier.locationType.ecommerceSmall': '전자상거래 소품 구역',
  'pages.storehouse.nonMasterCourier.locationType.mixedBatch': '혼합 배치 소포 구역',
  'pages.storehouse.nonMasterCourier.locationType.mediumContainer': '중형 컨테이너 화물 구역',
  'pages.storehouse.nonMasterCourier.locationType.smallOverweight': '소품 초과 중량 구역',
  'pages.storehouse.nonMasterCourier.locationType.largeUnusual': '대형 이형 구역',
  'pages.storehouse.nonMasterCourier.stockLocation': '재고 위치',
  'pages.storehouse.nonMasterCourier.stockLocationRequired': '재고 위치를 선택하세요',
  'pages.storehouse.nonMasterCourier.print': '인쇄',
  'pages.storehouse.nonMasterCourier.userId': '회원 ID',
  'pages.storehouse.nonMasterCourier.userIdRequired': '회원 ID를 입력하세요',
  'pages.storehouse.nonMasterCourier.userName': '회원 이름',
  'pages.storehouse.nonMasterCourier.userNameRequired': '회원 이름을 입력하세요',
  'pages.storehouse.nonMasterCourier.invoiceNumber': '송장 번호',
  'pages.storehouse.nonMasterCourier.invoiceNumberRequired': '송장 번호를 입력하세요',
  'pages.storehouse.nonMasterCourier.weight': '무게(kg)',
  'pages.storehouse.nonMasterCourier.weightRequired': '무게를 입력하세요',
  'pages.storehouse.nonMasterCourier.length': '길이(cm)',
  'pages.storehouse.nonMasterCourier.lengthRequired': '길이를 입력하세요',
  'pages.storehouse.nonMasterCourier.width': '너비(cm)',
  'pages.storehouse.nonMasterCourier.widthRequired': '너비를 입력하세요',
  'pages.storehouse.nonMasterCourier.height': '높이(cm)',
  'pages.storehouse.nonMasterCourier.heightRequired': '높이를 입력하세요',
  'pages.storehouse.nonMasterCourier.confirmWarehousing': '입고 확인',
  'pages.storehouse.nonMasterCourier.action.process': '처리',
  'pages.storehouse.nonMasterCourier.action.batchProcess': '일괄 처리',

  'pages.storehouse.inspectionList.title': '검수 목록',
  'pages.storehouse.inspectionList.column.userInfo': '회원 정보(UID)',
  'pages.storehouse.inspectionList.column.invoiceNumber': '송장 번호',
  'pages.storehouse.inspectionList.column.courier': '택배사',
  'pages.storehouse.inspectionList.column.uniqueCode': '검수자',
  'pages.storehouse.inspectionList.column.status': '상태',
  'pages.storehouse.inspectionList.column.inboundWeight': '입고 중량',
  'pages.storehouse.inspectionList.column.warehouseDimensions': '창고 크기(가×세×높)',
  'pages.storehouse.inspectionList.column.storageLocation': '저장 위치 정보',
  'pages.storehouse.inspectionList.column.inspectionNo': '검수번호',
  'pages.storehouse.inspectionList.column.trackingNumber': '운송장 번호',
  'pages.storehouse.inspectionList.filter.userName': '회원명',
  'pages.storehouse.inspectionList.filter.rackNumber': '랙 번호',
  'pages.storehouse.inspectionList.column.inspectionDate': '검수일시',
  'pages.storehouse.inspectionList.column.orderNo': '주문번호',
  'pages.storehouse.inspectionList.column.customerName': '회원명',
  'pages.storehouse.inspectionList.column.customerEmail': '회원 이메일',
  'pages.storehouse.inspectionList.column.customerPhone': '회원 전화번호',
  'pages.storehouse.inspectionList.column.inspector': '검수자',
  'pages.storehouse.inspectionList.column.notes': '비고',
  'pages.storehouse.inspectionList.status.passed': '합격',
  'pages.storehouse.inspectionList.status.failed': '불합격',
  'pages.storehouse.inspectionList.status.pending': '대기',
  'pages.storehouse.inspectionList.action.export': '내보내기',
  'pages.storehouse.inspectionList.exporting': '내보내는 중...',
  'pages.storehouse.inspectionList.exportSuccess': '내보내기가 성공적으로 완료되었습니다',
  'pages.storehouse.inspectionList.exportError': '검수 목록 내보내기 실패',
  'pages.storehouse.inspectionList.noDataToExport': '내보낼 데이터가 없습니다',
  'pages.storehouse.inspectionList.detailTitle': '검수 상세',
  'pages.storehouse.inspectionList.products': '상품',
  'pages.storehouse.inspectionList.expandIconTitle': '펼치기',
  'pages.storehouse.inspectionList.noProducts': '상품 없음',
  'pages.storehouse.inspectionList.product.column.image': '상품 이미지',
  'pages.storehouse.inspectionList.product.column.name': '상품명',
  'pages.storehouse.inspectionList.product.column.specifications': '상품 속성',
  'pages.storehouse.inspectionList.product.column.quantity': '수량',
  'pages.storehouse.inspectionList.product.column.cargoValue': '가격',
  'pages.storehouse.inspectionList.product.column.inboundWeight': '입고 중량',
  'pages.storehouse.inspectionList.product.column.inboundDimensions': '입고 크기(가×세×높)',
  'pages.storehouse.inspectionList.product.column.location': '입고 위치',
  'pages.storehouse.inspectionList.product.column.cargoAttributes': '상품 속성',
  'pages.storehouse.inspectionList.product.column.inspectionPhotos': '검수 상세 사진',
  'pages.storehouse.inspectionList.product.column.categoryName': '카테고리',
  'pages.storehouse.inspectionList.product.unit.won': '원',
  'pages.storehouse.inspectionList.product.unit.cm': 'cm',
  'pages.storehouse.inspectionList.product.unit.cny': '위안',
  'pages.storehouse.inspectionList.recipient': '수령인 정보',
  'pages.storehouse.inspectionList.recipient.name': '수령인 이름',
  'pages.storehouse.inspectionList.recipient.phone': '전화번호',
  'pages.storehouse.inspectionList.recipient.clearanceType': '통관 유형',
  'pages.storehouse.inspectionList.recipient.customsCode': '개인통관고유부호',
  'pages.storehouse.inspectionList.recipient.address': '주소',
  'pages.storehouse.inspectionList.recipient.zipCode': '우편번호',
  'pages.storehouse.inspectionList.recipient.postalCode': '우편번호',
  'pages.storehouse.inspectionList.recipient.note': '배송 메모',

  'pages.storehouse.warehouseSettings.title': '창고 설정',
  'pages.storehouse.warehouseSettings.tab.address': '창고 주소',
  'pages.storehouse.warehouseSettings.tab.chineseWarehousePosition': '중국 창고 위치',

  'pages.storehouse.warehouseAddress.title': '창고 주소',
  'pages.storehouse.warehouseAddress.rackManagement': '랙 관리',
  'pages.storehouse.warehouseAddress.racks': '랙',
  'pages.storehouse.warehouseAddress.noRacks': '이 창고에 랙이 없습니다',
  'pages.storehouse.warehouseAddress.column.name': '이름',
  'pages.storehouse.warehouseAddress.column.address': '주소',
  'pages.storehouse.warehouseAddress.column.contactPerson': '담당자',
  'pages.storehouse.warehouseAddress.column.contactPhone': '연락처',
  'pages.storehouse.warehouseAddress.column.isDefault': '기본',
  'pages.storehouse.warehouseAddress.column.createdAt': '생성일시',
  'pages.storehouse.warehouseAddress.addTitle': '창고 주소 추가',
  'pages.storehouse.warehouseAddress.editTitle': '창고 주소 수정',
  'pages.storehouse.warehouseAddress.form.name': '이름',
  'pages.storehouse.warehouseAddress.form.nameRequired': '이름을 입력하세요',
  'pages.storehouse.warehouseAddress.form.address': '주소',
  'pages.storehouse.warehouseAddress.form.addressRequired': '주소를 입력하세요',
  'pages.storehouse.warehouseAddress.form.contactPerson': '담당자',
  'pages.storehouse.warehouseAddress.form.contactPersonRequired': '담당자를 입력하세요',
  'pages.storehouse.warehouseAddress.form.contactPhone': '연락처',
  'pages.storehouse.warehouseAddress.form.contactPhoneRequired': '연락처를 입력하세요',
  'pages.storehouse.warehouseAddress.confirmDelete': '이 창고 주소를 삭제하시겠습니까?',
  'pages.storehouse.warehouseAddress.deleteSuccess': '창고 주소가 삭제되었습니다',
  'pages.storehouse.warehouseAddress.updateSuccess': '창고 주소가 업데이트되었습니다',
  'pages.storehouse.warehouseAddress.createSuccess': '창고 주소가 생성되었습니다',
  'pages.storehouse.warehouseAddress.addWarehouse': '창고 주소 추가',
  'pages.storehouse.warehouseAddress.customizableParameters': '회원 정의 가능한 매개변수:',
  'pages.storehouse.warehouseAddress.noData': '창고 주소 정보가 없습니다.',
  'pages.storehouse.warehouseAddress.forwardingWarehouse': '배송대행 창고 주소',
  'pages.storehouse.warehouseAddress.purchasingAgentWarehouse': '구매대행 창고 주소',
  'pages.storehouse.warehouseAddress.consignee': '수취인',
  'pages.storehouse.warehouseAddress.consigneeRequired': '수취인을 입력하세요',
  'pages.storehouse.warehouseAddress.contactMethod': '연락처',
  'pages.storehouse.warehouseAddress.contactMethodRequired': '연락처를 입력하세요',
  'pages.storehouse.warehouseAddress.email': '이메일',
  'pages.storehouse.warehouseAddress.emailRequired': '이메일을 입력하세요',
  'pages.storehouse.warehouseAddress.emailInvalid': '유효한 이메일 주소를 입력하세요',
  'pages.storehouse.warehouseAddress.warehouseName': '창고명',
  'pages.storehouse.warehouseAddress.defaultWarehouse': '기본 창고',
  'pages.storehouse.warehouseAddress.warehouseNameRequired': '창고명을 입력하세요',
  'pages.storehouse.warehouseAddress.postalCode': '창고 우편번호',
  'pages.storehouse.warehouseAddress.postalCodeRequired': '창고 우편번호를 입력하세요',
  'pages.storehouse.warehouseAddress.administrativeDivisionCode': '행정구역 코드',
  'pages.storehouse.warehouseAddress.administrativeDivisionCodeRequired': '행정구역 코드를 입력하세요',
  'pages.storehouse.warehouseAddress.warehouseAddress': '창고 주소',
  'pages.storehouse.warehouseAddress.warehouseAddressRequired': '창고 주소를 입력하세요',
  'pages.storehouse.warehouseAddress.procurementWarehouse': '구매 창고',
  'pages.storehouse.warehouseAddress.convertSuccess': '구매 창고로 성공적으로 변환되었습니다',
  'pages.storehouse.warehouseAddress.warehouseCode': '창고 코드',
  'pages.storehouse.warehouseAddress.warehouseCodeRequired': '창고 코드를 입력하세요',
  'pages.storehouse.warehouseAddress.warehouseCodePlaceholder': '예: WH-QINGDAO-1',
  'pages.storehouse.warehouseAddress.phone': '전화',
  'pages.storehouse.warehouseAddress.phonePlaceholder': '예: 0631-5555001',
  'pages.storehouse.warehouseAddress.province': '도/성',
  'pages.storehouse.warehouseAddress.provinceRequired': '도/성을 입력하세요',
  'pages.storehouse.warehouseAddress.provincePlaceholder': '예: 山东省',
  'pages.storehouse.warehouseAddress.city': '시',
  'pages.storehouse.warehouseAddress.cityRequired': '시를 입력하세요',
  'pages.storehouse.warehouseAddress.cityPlaceholder': '예: 威海市',
  'pages.storehouse.warehouseAddress.district': '구/군',
  'pages.storehouse.warehouseAddress.districtRequired': '구/군을 입력하세요',
  'pages.storehouse.warehouseAddress.districtPlaceholder': '예: 环翠区',
  'pages.storehouse.warehouseAddress.town': '읍/면',
  'pages.storehouse.warehouseAddress.townPlaceholder': '예: 文泉镇',
  'pages.storehouse.warehouseAddress.addressCode': '주소 코드',
  'pages.storehouse.warehouseAddress.addressCodePlaceholder': '예: 371002',
  'pages.storehouse.warehouseAddress.consigneePlaceholder': '예: 张伟',
  'pages.storehouse.warehouseAddress.contactMethodPlaceholder': '예: 18561073633',
  'pages.storehouse.warehouseAddress.warehouseNamePlaceholder': '예: 青岛仓库',
  'pages.storehouse.warehouseAddress.postalCodePlaceholder': '예: 264200',
  'pages.storehouse.warehouseAddress.administrativeDivisionCodePlaceholder': '예: 371002',
  'pages.storehouse.warehouseAddress.warehouseAddressPlaceholder': '예: 环翠区温泉镇新苑路2号',
  'pages.storehouse.warehouseAddress.createError': '창고 생성 실패',
  'pages.storehouse.warehouseAddress.updateError': '창고 업데이트 실패',
  'pages.storehouse.warehouseAddress.deleteError': '창고 삭제 실패',
  'pages.common.modify': '수정',
  'pages.common.today': '오늘',
  'pages.common.last7Days': '지난 7일',
  'pages.common.last30Days': '지난 30일',
  'pages.common.thisMonth': '이번 달',
  'pages.common.lastMonth': '지난 달',
  'pages.common.exportingOrders': '내보내는 중...',
  'pages.common.exportError': '엑셀 내보내기 실패',
  
  'pages.storehouse.chineseWarehousePosition.title': '중국 창고 위치',
  'pages.storehouse.chineseWarehousePosition.column.positionCode': '위치 코드',
  'pages.storehouse.chineseWarehousePosition.column.positionName': '위치명',
  'pages.storehouse.chineseWarehousePosition.column.warehouseName': '창고명',
  'pages.storehouse.chineseWarehousePosition.column.area': '구역',
  'pages.storehouse.chineseWarehousePosition.column.row': '행',
  'pages.storehouse.chineseWarehousePosition.column.column': '열',
  'pages.storehouse.chineseWarehousePosition.column.shelf': '선반',
  'pages.storehouse.chineseWarehousePosition.column.capacity': '용량',
  'pages.storehouse.chineseWarehousePosition.column.currentStock': '현재 재고',
  'pages.storehouse.chineseWarehousePosition.column.createdAt': '생성일시',
  'pages.storehouse.chineseWarehousePosition.column.locationCode': '위치 코드',
  'pages.storehouse.chineseWarehousePosition.column.stockLocation': '재고 위치',
  'pages.storehouse.chineseWarehousePosition.column.warehouseLocationCode': '창고 위치 코드',
  'pages.storehouse.chineseWarehousePosition.column.warehouseLocationType': '창고 위치 유형',
  'pages.storehouse.chineseWarehousePosition.column.availableStock': '보관 가능한 수량',
  'pages.storehouse.chineseWarehousePosition.stockLocation': '재고 위치',
  'pages.storehouse.chineseWarehousePosition.warehouseLocationCode': '창고 위치 코드',
  'pages.storehouse.chineseWarehousePosition.warehouseLocationType': '창고 위치 유형',
  'pages.storehouse.chineseWarehousePosition.availableStock': '보관 가능한 수량',
  'pages.storehouse.chineseWarehousePosition.currentStock': '현재 보관 수량',
  'pages.storehouse.chineseWarehousePosition.form.locationCode': '위치 코드',
  'pages.storehouse.chineseWarehousePosition.form.locationCodeRequired': '위치 코드를 입력하세요',
  'pages.storehouse.chineseWarehousePosition.form.warehouseLocationType': '창고 위치 유형',
  'pages.storehouse.chineseWarehousePosition.form.warehouseLocationTypeRequired': '창고 위치 유형을 입력하세요',
  'pages.storehouse.chineseWarehousePosition.form.availableStock': '보관 가능한 수량',
  'pages.storehouse.chineseWarehousePosition.form.availableStockRequired': '보관 가능한 수량을 입력하세요',
  'pages.storehouse.chineseWarehousePosition.form.currentStock': '현재 보관 수량',
  'pages.storehouse.chineseWarehousePosition.form.currentStockRequired': '현재 보관 수량을 입력하세요',
  'pages.storehouse.chineseWarehousePosition.addTitle': '창고 위치 추가',
  'pages.storehouse.chineseWarehousePosition.editTitle': '창고 위치 수정',
  'pages.storehouse.chineseWarehousePosition.form.positionCode': '위치 코드',
  'pages.storehouse.chineseWarehousePosition.form.positionCodeRequired': '위치 코드를 입력하세요',
  'pages.storehouse.chineseWarehousePosition.form.positionName': '위치명',
  'pages.storehouse.chineseWarehousePosition.form.positionNameRequired': '위치명을 입력하세요',
  'pages.storehouse.chineseWarehousePosition.form.warehouseName': '창고명',
  'pages.storehouse.chineseWarehousePosition.form.warehouseNameRequired': '창고명을 입력하세요',
  'pages.storehouse.chineseWarehousePosition.form.area': '구역',
  'pages.storehouse.chineseWarehousePosition.form.areaRequired': '구역을 입력하세요',
  'pages.storehouse.chineseWarehousePosition.form.row': '행',
  'pages.storehouse.chineseWarehousePosition.form.rowRequired': '행을 입력하세요',
  'pages.storehouse.chineseWarehousePosition.form.column': '열',
  'pages.storehouse.chineseWarehousePosition.form.columnRequired': '열을 입력하세요',
  'pages.storehouse.chineseWarehousePosition.form.shelf': '선반',
  'pages.storehouse.chineseWarehousePosition.form.shelfRequired': '선반을 입력하세요',
  'pages.storehouse.chineseWarehousePosition.form.capacity': '용량',
  'pages.storehouse.chineseWarehousePosition.form.capacityRequired': '용량을 입력하세요',
  'pages.storehouse.chineseWarehousePosition.confirmDelete': '이 창고 위치를 삭제하시겠습니까?',
  'pages.storehouse.chineseWarehousePosition.deleteSuccess': '창고 위치가 삭제되었습니다',
  'pages.storehouse.chineseWarehousePosition.createSuccess': '창고 위치가 생성되었습니다',
  'pages.storehouse.chineseWarehousePosition.updateSuccess': '창고 위치가 수정되었습니다',

  // 쿠폰 포인트 설정
  'pages.members.couponPointSettings.title': '쿠폰 포인트 설정',
  'pages.members.couponPointSettings.pointsPerCurrency': '포인트 당 통화 (₩)',
  'pages.members.couponPointSettings.coupon': '쿠폰',
  'pages.members.couponPointSettings.example': '예: 100으로 설정하면 ₩10,000 = 100 포인트',
  'pages.members.couponPointSettings.freeEditingFunction': '쿠폰 추가/삭제를 위한 무료 편집 기능',
  'pages.members.couponPointSettings.distributionSystemCoupon': '배포 시스템 쿠폰',
  'pages.members.couponPointSettings.distributionSystemCouponDescription': '시스템 내에서 특정 유형의 쿠폰을 균등하게 배포하도록 선택할 수 있습니다.',
  'pages.members.couponPointSettings.pointSettings': '포인트 설정',
  'pages.members.couponPointSettings.pointSettingsDescription': '초대를 받은 회원가 이 사이트에 등록하면 포인트가 부여됩니다. 이러한 포인트는 수동으로 편집하고 설정할 수 있습니다.',
  'pages.members.couponPointSettings.couponDetails': '쿠폰 상세',
  'pages.members.couponPointSettings.addCoupon': '쿠폰 추가',
  'pages.members.couponPointSettings.editCoupon': '쿠폰 수정',
  'pages.members.couponPointSettings.deleteConfirm': '이 쿠폰을 삭제하시겠습니까?',
  'pages.members.couponPointSettings.deleteSuccess': '쿠폰이 삭제되었습니다',
  'pages.members.couponPointSettings.createSuccess': '쿠폰이 생성되었습니다',
  'pages.members.couponPointSettings.updateSuccess': '쿠폰이 수정되었습니다',
  'pages.members.couponPointSettings.pointUpdateSuccess': '포인트 설정이 수정되었습니다',
  'pages.members.couponPointSettings.pointUpdateError': '추천 설정 업데이트 실패',
  'pages.members.couponPointSettings.fetchError': '데이터 로드 실패',
  'pages.members.couponPointSettings.fetchCouponsError': '쿠폰 로드 실패',
  'pages.members.couponPointSettings.deleteError': '쿠폰 삭제 실패',
  'pages.members.couponPointSettings.createError': '쿠폰 생성 실패',
  'pages.members.couponPointSettings.updateError': '쿠폰 업데이트 실패',
  'pages.members.couponPointSettings.referralPoints': '추천 포인트',
  'pages.members.couponPointSettings.referralPointsRequired': '추천 포인트를 입력하세요',
  'pages.members.couponPointSettings.referralPointsPlaceholder': '추천 성공 시 부여되는 포인트를 입력하세요',
  'pages.members.couponPointSettings.noCoupons': '쿠폰이 없습니다',
  'pages.members.couponPointSettings.signupPoints': '가입 포인트',
  'pages.members.couponPointSettings.signupPointsRequired': '가입 포인트를 입력하세요',
  'pages.members.couponPointSettings.signupPointsPlaceholder': '가입 시 부여되는 포인트를 입력하세요',
  'pages.members.couponPointSettings.promotionSuccessPoints': '프로모션 성공 포인트',
  'pages.members.couponPointSettings.promotionSuccessPointsRequired': '프로모션 성공 포인트를 입력하세요',
  'pages.members.couponPointSettings.promotionSuccessPointsPlaceholder': '프로모션 성공 시 부여되는 포인트를 입력하세요',
  'pages.members.couponPointSettings.days': '일',
  'pages.members.couponPointSettings.column.couponName': '쿠폰 이름',
  'pages.members.couponPointSettings.column.amount': '쿠폰 금액',
  'pages.members.couponPointSettings.column.code': '쿠폰 사용 코드',
  'pages.members.couponPointSettings.column.minPurchaseAmount': '최소 구매 금액',
  'pages.members.couponPointSettings.column.validityDays': '쿠폰 유효 기간(일)',
  'pages.members.couponPointSettings.column.remainingQuantity': '남은 쿠폰 수량',
  'pages.members.couponPointSettings.column.usedQuantity': '이미 사용된 쿠폰 수량',
  'pages.members.couponPointSettings.column.createdBy': '생성 관리자',
  'pages.members.couponPointSettings.column.issuanceMethod': '발급 방식',
  'pages.members.couponPointSettings.column.couponId': '쿠폰 ID',
  'pages.members.couponPointSettings.column.distributionEnabled': '배포 활성화',
  'pages.members.couponPointSettings.column.createdAt': '생성일',
  'pages.members.couponPointSettings.issuanceMethodUser': '회원 청구',
  'pages.members.couponPointSettings.issuanceMethodSystem': '시스템 배포',
  'pages.members.couponPointSettings.issuanceMethodSignup': '등록 및 쿠폰 수령',
  'pages.members.couponPointSettings.detail.addCouponName': '쿠폰 이름 추가',
  'pages.members.couponPointSettings.detail.setCouponAmount': '쿠폰 금액 설정',
  'pages.members.couponPointSettings.detail.enterCouponCode': '쿠폰 사용 코드 입력',
  'pages.members.couponPointSettings.detail.setMinPurchaseAmount': '최소 구매 금액 설정',
  'pages.members.couponPointSettings.detail.setValidityDays': '쿠폰 유효 기간(일)',
  'pages.members.couponPointSettings.detail.remainingQuantity': '남은 쿠폰 수량',
  'pages.members.couponPointSettings.detail.usedQuantity': '이미 사용된 쿠폰 수량',
  'pages.members.couponPointSettings.detail.issuanceMethod': '발급 방식(상세: 회원 발급, 시스템 발급, 가입 보너스)',
  'pages.members.couponPointSettings.detail.addCouponId': '쿠폰 ID 추가 (각 쿠폰 세트마다 고유 ID가 생성됩니다)',
  'pages.members.couponPointSettings.detail.couponSettings': '쿠폰 설정 (가입 완료 후 어떤 쿠폰을 지급할지 선택합니다. 쿠폰 ID를 입력할 수 있습니다.)',
  'pages.members.couponPointSettings.form.couponName': '쿠폰 이름',
  'pages.members.couponPointSettings.form.couponNameRequired': '쿠폰 이름을 입력하세요',
  'pages.members.couponPointSettings.form.couponNamePlaceholder': '쿠폰 이름을 입력하세요',
  'pages.members.couponPointSettings.form.amount': '쿠폰 금액',
  'pages.members.couponPointSettings.form.amountRequired': '쿠폰 금액을 입력하세요',
  'pages.members.couponPointSettings.form.discountMode': '할인 방식',
  'pages.members.couponPointSettings.form.discountModeRequired': '할인 방식을 선택하세요',
  'pages.members.couponPointSettings.discountModeFixed': '고정 금액 (₩)',
  'pages.members.couponPointSettings.discountModePercentage': '상품 금액 비율 (%)',
  'pages.members.couponPointSettings.form.percentage': '할인 비율 (%)',
  'pages.members.couponPointSettings.form.percentageRequired': '할인 비율을 입력하세요',
  'pages.members.couponPointSettings.form.code': '쿠폰 사용 코드',
  'pages.members.couponPointSettings.form.codeRequired': '쿠폰 사용 코드를 입력하세요',
  'pages.members.couponPointSettings.form.codePattern': '쿠폰 코드는 대문자와 숫자만 입력 가능합니다',
  'pages.members.couponPointSettings.form.codePlaceholder': '쿠폰 사용 코드를 입력하세요',
  'pages.members.couponPointSettings.form.minPurchaseAmount': '최소 구매 금액',
  'pages.members.couponPointSettings.form.minPurchaseAmountRequired': '최소 구매 금액을 입력하세요',
  'pages.members.couponPointSettings.form.validityDays': '쿠폰 유효 기간(일)',
  'pages.members.couponPointSettings.form.validityDaysRequired': '쿠폰 유효 기간을 입력하세요',
  'pages.members.couponPointSettings.form.remainingQuantity': '남은 쿠폰 수량',
  'pages.members.couponPointSettings.form.remainingQuantityRequired': '남은 쿠폰 수량을 입력하세요',
  'pages.members.couponPointSettings.form.remainingQuantityMinForCode': '회원 쿠폰코드 교환을 위해 최소 1 이상 입력하세요. (관리자 수동 발급은 이 재고를 사용하지 않습니다)',
  'pages.members.couponPointSettings.form.remainingQuantityTooltip': '회원이 쿠폰 코드로 교환할 때 사용하는 재고입니다. 관리자 수동 발급은 이 수량을 차감하지 않습니다.',
  'pages.members.couponPointSettings.form.usedQuantity': '이미 사용된 쿠폰 수량',
  'pages.members.couponPointSettings.form.issuanceMethod': '발급 방식',
  'pages.members.couponPointSettings.form.issuanceMethodRequired': '발급 방식을 선택하세요',
  'pages.members.couponPointSettings.form.couponId': '쿠폰 ID',
  'pages.members.couponPointSettings.form.couponIdTooltip': '각 쿠폰 세트마다 고유 ID가 생성됩니다',
  'pages.members.couponPointSettings.form.couponIdPlaceholder': '쿠폰 ID를 입력하세요',
  'pages.members.couponPointSettings.form.signupCouponId': '가입 쿠폰 ID',
  'pages.members.couponPointSettings.form.signupCouponIdTooltip': '가입 완료 후 어떤 쿠폰을 지급할지 선택합니다. 쿠폰 ID를 입력할 수 있습니다.',
  'pages.members.couponPointSettings.form.signupCouponIdPlaceholder': '가입 후 지급할 쿠폰 ID를 입력하세요',
  'pages.members.couponPointSettings.form.distributionEnabled': '배포 시스템 활성화',
  'pages.members.couponPointSettings.form.signupWelcome': '회원가입 환영 쿠폰 (수량 무제한)',
  'pages.members.couponPointSettings.form.couponType': '쿠폰 종류',
  'pages.members.couponPointSettings.form.couponTypeRequired': '쿠폰 종류를 선택하세요',
  'pages.members.couponPointSettings.couponTypeProduct': '상품 쿠폰',
  'pages.members.couponPointSettings.couponTypeTransportation': '운송 쿠폰',
  'pages.members.couponPointSettings.couponTypeLive': '라이브 쿠폰',
  'pages.members.couponPointSettings.couponTypeReferral': '추천인 가입 쿠폰',
  'pages.members.couponPointSettings.column.platformScope': '플랫폼',
  'pages.members.couponPointSettings.platformLive': '라이브',
  'pages.members.couponPointSettings.platformEcommerce': '1688 / 타오바오 / VVIC',
  'pages.members.couponPointSettings.form.referralDiscountType': '할인 유형',
  'pages.members.couponPointSettings.form.platformScope': '적용 플랫폼',
  'pages.members.couponPointSettings.form.platformScopeRequired': '플랫폼을 선택하세요',
  'pages.members.couponPointSettings.referralCouponHelp': '가입 시 추천인 코드를 입력한 신규 회원에게 자동 발급됩니다. 상품/배송 할인과 적용 플랫폼을 선택하세요.',
  'pages.members.couponPointSettings.form.referralSignupEnabled': '추천인 가입 자동 발급',
  'pages.members.couponPointSettings.form.referralSignupEnabledTooltip': '활성화 시 추천인 코드로 가입한 신규 회원에게 이 쿠폰을 자동 발급합니다.',
  'pages.members.couponPointSettings.column.couponType': '쿠폰 종류',
  'pages.members.couponPointSettings.column.liveSeller': '라이브 셀러',
  'pages.members.couponPointSettings.form.liveSeller': '라이브 셀러 (LS 사서함)',
  'pages.members.couponPointSettings.form.liveSellerRequired': '라이브 셀러를 선택하세요',
  'pages.members.couponPointSettings.form.liveSellerPlaceholder': 'LS 사서함으로 검색 (예: LS123)',
  'pages.members.couponPointSettings.column.applicableStores': '적용 매장',
  'pages.members.couponPointSettings.applicableStoresAll': '전체 매장',
  'pages.members.couponPointSettings.applicableStoresCount': '{count}개 매장',
  'pages.members.couponPointSettings.form.applicableStores': '적용 매장',
  'pages.members.couponPointSettings.form.applicableStoresHelp': '고른 매장(상가명)의 상품에만 할인되고, 최소 구매 금액도 그 상품 금액으로 따집니다. 비워 두면 이 셀러의 모든 상품에 사용됩니다.',
  'pages.members.couponPointSettings.form.applicableStoresPlaceholder': '매장(상가명)으로 검색해 고르기 (비워 두면 모든 매장)',
  'pages.members.couponPointSettings.form.applicableStoresNeedSeller': '라이브 셀러를 먼저 선택하세요',
  'pages.members.couponPointSettings.form.applicableStoresEmpty': '찾는 매장이 없습니다',
  'pages.members.couponPointSettings.form.applicableStoresProductCount': '상품 {count}개',
  'pages.members.couponPointSettings.form.applicableStoresMissing': '지금 이 셀러 상품에 없는 매장',

  // Point Rules Engine
  'pages.members.pointRules.tabTitle': '포인트 규칙 엔진',
  'pages.members.pointRules.management': '포인트 규칙 관리',
  'pages.members.pointRules.add': '포인트 규칙 추가',
  'pages.members.pointRules.edit': '포인트 규칙 수정',
  'pages.members.pointRules.description': '회원 이벤트 기반으로 자동 및 수동 포인트 지급 규칙을 설정합니다. 조건, 한도 및 만료 설정을 지원합니다.',
  'pages.members.pointRules.noRules': '설정된 포인트 규칙이 없습니다',
  'pages.members.pointRules.deleteTitle': '포인트 규칙 삭제',
  'pages.members.pointRules.deleteConfirm': '이 포인트 규칙을 삭제하시겠습니까?',
  'pages.members.pointRules.deleteSuccess': '포인트 규칙이 삭제되었습니다',
  'pages.members.pointRules.deleteError': '포인트 규칙 삭제 실패',
  'pages.members.pointRules.createSuccess': '포인트 규칙이 생성되었습니다',
  'pages.members.pointRules.updateSuccess': '포인트 규칙이 수정되었습니다',
  'pages.members.pointRules.createError': '포인트 규칙 생성 실패',
  'pages.members.pointRules.updateError': '포인트 규칙 수정 실패',
  'pages.members.pointRules.fetchError': '포인트 규칙 로드 실패',
  'pages.members.pointRules.column.ruleName': '규칙 이름',
  'pages.members.pointRules.column.eventType': '이벤트 유형',
  'pages.members.pointRules.column.points': '포인트',
  'pages.members.pointRules.column.conditions': '조건',
  'pages.members.pointRules.column.type': '유형',
  'pages.members.pointRules.column.maxPerUser': '회원당 최대',
  'pages.members.pointRules.column.validity': '유효 기간',
  'pages.members.pointRules.column.status': '상태',
  'pages.members.pointRules.eventType.signup': '회원가입',
  'pages.members.pointRules.eventType.reviewCreated': '리뷰 작성',
  'pages.members.pointRules.eventType.orderCompleted': '상품 구매',
  'pages.members.pointRules.eventType.attendance': '출석체크',
  'pages.members.pointRules.grantType.automatic': '자동',
  'pages.members.pointRules.grantType.manual': '수동',
  'pages.members.pointRules.unlimited': '무제한',
  'pages.members.pointRules.conditionMinChars': '최소 {count}자',
  'pages.members.pointRules.conditionMinImages': '최소 {count}개 이미지',
  'pages.members.pointRules.conditionMinOrder': '최소 주문 {amount}₩',
  'pages.members.pointRules.daysUnit': '{days}일',
  'pages.members.pointRules.form.ruleName': '규칙 이름',
  'pages.members.pointRules.form.ruleNameRequired': '규칙 이름을 입력하세요',
  'pages.members.pointRules.form.ruleNamePlaceholder': '예: 기본 리뷰 포인트, 가입 보너스',
  'pages.members.pointRules.form.eventType': '이벤트 유형',
  'pages.members.pointRules.form.eventTypeRequired': '이벤트 유형을 선택하세요',
  'pages.members.pointRules.form.eventTypePlaceholder': '이벤트 유형 선택',
  'pages.members.pointRules.form.pointsToAward': '지급 포인트',
  'pages.members.pointRules.form.pointsRequired': '포인트를 입력하세요',
  'pages.members.pointRules.form.pointsPlaceholder': '예: 100',
  'pages.members.pointRules.form.reviewConditions': '리뷰 조건',
  'pages.members.pointRules.form.minCharacters': '최소 리뷰 길이 (글자 수)',
  'pages.members.pointRules.form.minCharactersPlaceholder': '예: 20',
  'pages.members.pointRules.form.minImages': '최소 이미지 수',
  'pages.members.pointRules.form.minImagesPlaceholder': '예: 1',
  'pages.members.pointRules.form.orderConditions': '주문 조건',
  'pages.members.pointRules.form.minOrderAmount': '최소 주문 금액 (₩)',
  'pages.members.pointRules.form.minOrderAmountPlaceholder': '예: 50000',
  'pages.members.pointRules.form.paymentSettings': '지급 설정',
  'pages.members.pointRules.form.paymentType': '지급 유형',
  'pages.members.pointRules.form.pointValidity': '포인트 유효 기간 (일)',
  'pages.members.pointRules.form.pointValidityRequired': '유효 기간을 입력하세요',
  'pages.members.pointRules.form.pointValidityPlaceholder': '예: 365',
  'pages.members.pointRules.form.limits': '한도',
  'pages.members.pointRules.form.maxPerUser': '회원당 최대',
  'pages.members.pointRules.form.maxPerDay': '일일 최대',
  'pages.members.pointRules.form.maxPerMonth': '월간 최대',
  'pages.members.pointRules.form.unlimitedTooltip': '무제한으로 비워두세요',
  'pages.members.pointRules.form.unlimitedPlaceholder': '무제한으로 비워두세요',
  'pages.members.pointRules.form.ruleStatus': '규칙 상태',
  'pages.members.pointRules.form.active': '활성',
  'pages.members.pointRules.form.inactive': '비활성',
  'pages.members.pointRules.form.earnRatesTitle': '구매 적립률 설정',
  'pages.members.pointRules.form.earnRatesDescription': '구매금액을 기준으로 판매 채널별 적립률을 각각 설정합니다.',
  'pages.members.pointRules.form.earnRateOwnmall': '자사몰',
  'pages.members.pointRules.form.earnRateLive': '라이브 상품',
  'pages.members.pointRules.form.earnRateOverseas': '해외대행 / 해외직구',
  'pages.members.pointRules.form.earnRateLabel': '구매금액 적립률',
  'pages.members.pointRules.form.earnRatePlaceholder': '예: {value}',
  'pages.members.pointRules.form.earnRateRequired': '적립률을 입력하세요 (적립하지 않으려면 0)',
  'pages.members.pointRules.form.earnRatesHint': '결제 금액 × 적립률만큼 지급하며 소수점 이하는 버립니다. 한 주문에 여러 채널 상품이 섞이면 상품 금액 비중대로 나누어 계산하고, 라이브(LS) 주문은 전체에 라이브 적립률을 적용합니다.',
  'pages.members.pointRules.form.purchaseConditions': '구매 조건',
  'pages.members.pointRules.form.purchaseTimingHint': '포인트는 결제 완료 시 지급되며, 환불되면 환불 금액만큼 자동으로 회수됩니다.',
  'pages.members.pointRules.form.attendanceConditions': '출석 조건',
  'pages.members.pointRules.form.attendanceOncePerDay': '출석 포인트는 회원당 하루 한 번(한국 시간 기준) 지급됩니다.',
  'pages.members.pointRules.form.streakBonusEnabled': '연속 출석 보너스 사용',
  'pages.members.pointRules.form.streakBonusTitle': '연속 출석 보너스 설정',
  'pages.members.pointRules.form.streak7Bonus': '7일 연속 보너스',
  'pages.members.pointRules.form.streak7BonusPlaceholder': '예: 500',
  'pages.members.pointRules.form.streak30Bonus': '30일 연속 보너스',
  'pages.members.pointRules.form.streak30BonusPlaceholder': '예: 3,000',
  'pages.members.pointRules.form.streakBonusHint': '연속 출석 7일째·30일째가 될 때마다 출석 포인트에 더해 지급합니다(7일 보너스는 14일째·21일째…, 30일 보너스는 60일째…에도 지급). 하루라도 빠지면 연속 일수는 1일부터 다시 셉니다. 비워 두거나 0이면 그 보너스는 지급하지 않습니다.',
  'pages.members.pointRules.earnRatesSummary': '자사몰 {ownmall}% · 라이브 {live}% · 해외직구 {overseas}%',
  'pages.members.pointRules.conditionStreak7': '7일 연속 +{points}P',
  'pages.members.pointRules.conditionStreak30': '30일 연속 +{points}P',

  // Consumption Change Details
  'pages.members.consumptionChangeDetails.title': '소비 변동 상세',
  'pages.members.consumptionChangeDetails.tab.financial': '회원 재무 기록',
  'pages.members.consumptionChangeDetails.tab.consumption': '회원 소비 기록',
  'pages.members.consumptionChangeDetails.tab.rebate': '리베이트 기록',
  'pages.members.consumptionChangeDetails.tab.points': '포인트 사용 기록',
  'pages.members.consumptionChangeDetails.tab.coupon': '쿠폰 사용 기록',
  'pages.members.consumptionChangeDetails.column.userId': '회원 ID',
  'pages.members.consumptionChangeDetails.column.userName': '회원 이름',
  'pages.members.consumptionChangeDetails.column.userInfo': '회원 정보',
  'pages.members.consumptionChangeDetails.column.memberLevel': '회원 등급',
  'pages.members.consumptionChangeDetails.column.currentPoints': '현재 잔여 포인트',
  'pages.members.consumptionChangeDetails.column.currentDeposit': '현재 잔여 예치금',
  'pages.members.consumptionChangeDetails.column.updateTime': '업데이트 시간',
  'pages.members.consumptionChangeDetails.column.orderNo': '주문 번호',
  'pages.members.consumptionChangeDetails.column.paymentMethod': '회원 결제 방식',
  'pages.members.consumptionChangeDetails.column.paymentType': '결제 유형',
  'pages.members.consumptionChangeDetails.column.amountBefore': '변경 전 금액',
  'pages.members.consumptionChangeDetails.column.changeAmount': '변동 금액',
  'pages.members.consumptionChangeDetails.column.amountAfter': '변경 후 금액',
  'pages.members.consumptionChangeDetails.column.currentBalance': '현재 잔여 금액',
  'pages.members.consumptionChangeDetails.column.changeTime': '변동 시간',
  'pages.members.consumptionChangeDetails.column.time': '시간',
  'pages.members.consumptionChangeDetails.column.rebateAmount': '리베이트 금액',
  'pages.members.consumptionChangeDetails.column.type': '유형',
  'pages.members.consumptionChangeDetails.column.couponName': '쿠폰 이름',
  'pages.members.consumptionChangeDetails.column.couponCode': '쿠폰 교환 코드',
  'pages.members.consumptionChangeDetails.column.couponValue': '쿠폰 액면가',
  'pages.members.consumptionChangeDetails.column.minOrderAmount': '최소 사용 금액',
  'pages.members.consumptionChangeDetails.column.receiveMethod': '수령 방식',
  'pages.members.consumptionChangeDetails.column.validPeriod': '유효 기간',
  'pages.members.consumptionChangeDetails.column.status': '사용 상태',
  'pages.members.consumptionChangeDetails.column.receiveTime': '수령 시간',
  'pages.members.consumptionChangeDetails.column.usedTime': '사용 시간',
  'pages.members.consumptionChangeDetails.status.used': '사용됨',
  'pages.members.consumptionChangeDetails.status.unused': '미사용',
  'pages.members.consumptionChangeDetails.status.expired': '만료됨',
  'pages.members.consumptionChangeDetails.exportSuccess': '데이터가 내보내기되었습니다',

  // System - Work Log
  'pages.system.workLog.title': '작업 로그',
  'pages.system.workLog.column.employeeId': '직원 ID',
  'pages.system.workLog.column.employeeName': '직원 이름',
  'pages.system.workLog.deletedAccount': '삭제된 계정',
  'pages.system.workLog.column.workContent': '작업 내용',
  'pages.system.workLog.column.workTime': '작업 시간',
  'pages.system.workLog.exportSuccess': '작업 로그 데이터가 내보내기되었습니다',

  // Shipping Cost Modal
  'pages.shippingCost.title': '배송비 무게측정',
  'pages.shippingCost.orderInformation': '주문정보',
  'pages.shippingCost.orderNoMemberName': '주문번호/회원명',
  'pages.shippingCost.center': '센터',
  'pages.shippingCost.trackingCount': '트래킹 수',
  'pages.shippingCost.items': '개',
  'pages.shippingCost.recipient': '수취인',
  'pages.shippingCost.mountainislandCost': '도서산간비용',
  'pages.shippingCost.recipientAddress': '수취인 주소',
  'pages.shippingCost.totalQuantityAmount': '총수량/총금액',
  'pages.shippingCost.productInformation': '상품정보',
  'pages.shippingCost.productNo': '상품번호',
  'pages.shippingCost.productName': '상품명',
  'pages.shippingCost.image': '이미지',
  'pages.shippingCost.quantity': '수량',
  'pages.shippingCost.trackingNumber': '트래킹번호',
  'pages.shippingCost.status': '상태',
  'pages.shippingCost.rackNumber': '랙번호',
  'pages.shippingCost.actualInspection': '실사',
  'pages.shippingCost.viewActualInspection': '실사보기',
  'pages.shippingCost.adminMemo': '관리자 메모',
  'pages.shippingCost.additionalServices': '부가서비스',
  'pages.shippingCost.boxCount': '박스 수',
  'pages.shippingCost.box': 'Box',
  'pages.shippingCost.inspectionOptions': '검수옵션',
  'pages.shippingCost.originMarkingOptions': '원산지표시옵션',
  'pages.shippingCost.businessLCLCustomsOptions': '사업자LCL릉관옵션',
  'pages.shippingCost.packagingOptions': '포장옵션',
  'pages.shippingCost.otherOptions': '기타옵션',
  'pages.shippingCost.additionalCosts': '추가비용',
  'pages.shippingCost.totalServiceAmount': '부가서비스 총액',
  'pages.shippingCost.weightInformation': '무게정보',
  'pages.shippingCost.actualWeight': '실제무게',
  'pages.shippingCost.applicableExchangeRate': '적용환율',
  'pages.shippingCost.volumetricWeight': '부피무게',
  'pages.shippingCost.volume': '부피',
  'pages.shippingCost.applicableWeight': '적용무게 (배송비)',
  'pages.shippingCost.actual': '실제무게',
  'pages.shippingCost.volumetric': '부피무게',
  'pages.shippingCost.totalAmount': '총금액',
  'pages.shippingCost.save': '저장',
  'pages.shippingCost.close': '닫기',
  'pages.shippingCost.saved': '배송비용이 저장되었습니다',
  'pages.shippingCost.smsNotSend': 'SMS 발송안함',
  'pages.shippingCost.smsSend': 'SMS 발송',
  'pages.shippingCost.cbmWeight': 'CBM 무게',
  'pages.shippingCost.additionalCost': '추가비용',
  'pages.shippingCost.weightCost': '무게비용',
  'pages.shippingCost.totalCost': '총비용',
  'pages.shippingCost.additionalPlusWeight': '추가+무게',
  'pages.shippingCost.calculatedWeight': '계산된 무게',
  'pages.shippingCost.selectWeight': '무게 선택',
  'pages.shippingCost.boxNumber': '박스번호',
  'pages.shippingCost.dimensions': '크기 (가로×길이×높이)',
  'pages.shippingCost.shippingCost': '배송비',
  'pages.shippingCost.width': '가로',
  'pages.shippingCost.length': '길이',
  'pages.shippingCost.height': '높이',
  'pages.shippingCost.warehouseComplete': '입고완료',

  // Packing Modal
  'pages.packing.title': '포장',
  'pages.packing.internationalTrackingNumber': '국제 운송장 번호',
  'pages.packing.recipientAddress': '수령인 주소',
  'pages.packing.recipient': '수령인',
  'pages.packing.address': '주소',
  'pages.packing.phone': '전화번호',
  'pages.packing.weightAndDimensions': '무게 및 치수',
  'pages.packing.weight': '무게',
  'pages.packing.shippingMethod': '배송 방법',
  'pages.packing.width': '너비',
  'pages.packing.length': '길이',
  'pages.packing.height': '높이',
  'pages.packing.shippingFeeCalculation': '배송비 계산',
  'pages.packing.realWeight': '실제 무게',
  'pages.packing.volumetricWeight': '부피 무게 (CBM)',
  'pages.packing.chargeableWeight': '청구 무게 (적용)',
  'pages.packing.internationalShippingFee': '국제 배송비',
  'pages.packing.additionalCost': '추가 비용',
  'pages.packing.simplifiedCustomsClearance': '간이통관',
  'pages.packing.designatedShooting': '지정촬영',
  'pages.packing.totalCost': '총 비용',
  'pages.packing.save': '저장',
  'pages.packing.close': '닫기',
  'pages.packing.saved': '포장이 성공적으로 완료되었습니다',

  // Rack Designation Modal
  'pages.rackDesignation.title': '랙 지정',
  'pages.rackDesignation.internationalTrackingNumber': '국제 운송장 번호',
  'pages.rackDesignation.rackNumber': '랙 번호',
  'pages.rackDesignation.save': '저장',
  'pages.rackDesignation.close': '닫기',

  // Return Cost Modal
  'pages.returnCost.title': '반품비용',
  'pages.returnCost.orderInformation': '주문정보',
  'pages.returnCost.orderNumber': '주문번호',
  'pages.returnCost.deliveryCenter': '배송 센터',
  'pages.returnCost.totalQuantityAmount': '총 수량/총액',
  'pages.returnCost.items': '개',
  'pages.returnCost.additionalServices': '부가서비스',
  'pages.returnCost.costInformation': '비용정보',
  'pages.returnCost.weight': '무게',
  'pages.returnCost.returnTrackingNumber': '반품 운송장번호',
  'pages.returnCost.returnTrackingNumberPlaceholder': '반품 운송장번호를 입력하세요',
  'pages.returnCost.appliedExchangeRate': '적용환율',
  'pages.returnCost.totalAmount': '총금액',
  'pages.returnCost.courierPaymentAmount': '택배사 지불 금액',
  'pages.returnCost.save': '저장',
  'pages.returnCost.close': '닫기',
  'pages.returnCost.saved': '반품비용이 저장되었습니다',
  'pages.returnCost.smsNotSend': 'SMS 발송안함',
  'pages.returnCost.smsSend': 'SMS 발송',
  'pages.refundSplit.title': '환불 분할',
  'pages.refundSplit.description': '부분 오류로 인해 반품/환불이 필요한 주문은 환불이 필요한 소번호와 수량을 선택하여 분할할 수 있습니다. 분리된 주문은 자동으로 "플랫폼 환불 신청" 상태로 전환되며, 원본 주문과 연동됩니다.',
  'pages.refundSplit.orderNo': '주문번호',
  'pages.refundSplit.select': '선택',
  'pages.refundSplit.image': '이미지',
  'pages.refundSplit.productName': '상품명',
  'pages.refundSplit.variation': '규격',
  'pages.refundSplit.originalQuantity': '원본 수량',
  'pages.refundSplit.refundQuantity': '환불 수량',
  'pages.refundSplit.unitPrice': '단가',
  'pages.refundSplit.refundAmount': '환불 금액',
  'pages.refundSplit.selectedGross': '선택 상품 정가',
  'pages.refundSplit.couponDeduction': '쿠폰/포인트 배분 차감',
  'pages.refundSplit.selectedTotal': '예상 환불액',
  'pages.refundSplit.confirm': '환불 분할 확인',
  'pages.refundSplit.close': '취소',
  'pages.refundSplit.selectAtLeastOne': '최소 하나의 상품을 선택해주세요.',
  'pages.refundSplit.invalidQuantity': '모든 선택된 상품에 유효한 환불 수량을 입력해주세요.',
  'pages.refundSplit.quantityExceedsMax': '환불 수량은 최대 {max}개를 초과할 수 없습니다.',
  'pages.refundSplit.cannotRefundAll': '모든 상품을 환불할 수 없습니다. 최소 하나의 상품은 원본 주문에 남아있어야 합니다.',
  'pages.refundSplit.noRefundProducts': '환불할 상품이 없습니다.',
  'pages.refundSplit.success': '환불 분할이 완료되었습니다.',
  'pages.refundSplit.error': '환불 분할 중 오류가 발생했습니다.',
  
  'pages.members.taxSettlement.purchaseAmount': '구매 금액',
  'pages.members.taxSettlement.purchaseFee': '구매 대행비',
  'pages.members.taxSettlement.warehouseArea': '창고 지역',
  'pages.members.taxSettlement.transportationMethod': '운송 방법',
  'pages.members.taxSettlement.mailboxNumber': '우편번호',
  'pages.members.taxSettlement.waybillNumber': '운송장 번호',
  'pages.members.taxSettlement.orderNumber': '주문 번호',
  'pages.members.taxSettlement.paymentDate': '결제 일시',
  'pages.members.taxSettlement.paymentMethod': '결제 수단',
  'pages.members.taxSettlement.refundRoute': '환불 경로',
  'pages.members.taxSettlement.paymentMethod.creditCard': '신용카드',
  'pages.members.taxSettlement.paymentMethod.deposit': '예치금',
  'pages.members.taxSettlement.paymentMethod.points': '포인트',
  'pages.members.taxSettlement.paymentMethod.bankTransfer': '무통장',
  'pages.members.taxSettlement.entryType.first_payment': '1차결제',
  'pages.members.taxSettlement.entryType.second_payment': '2차결제',
  'pages.members.taxSettlement.entryType.partial_refund': '부분환불',
  'pages.members.taxSettlement.entryType.full_refund': '전체환불',
  'pages.members.taxSettlement.col.orderDateTime': '주문일시',
  'pages.members.taxSettlement.col.userUniqueNo': '사서함번호',
  'pages.members.taxSettlement.col.userName': '회원이름',
  'pages.members.taxSettlement.col.internationalTrackingNumber': '운송장번호',
  'pages.members.taxSettlement.col.customsItemNamesEn': '상품이름(영어)',
  'pages.members.taxSettlement.col.entryType': '구분',
  'pages.members.taxSettlement.col.bankAmount': '뱅크출입금 금액',
  'pages.members.taxSettlement.col.refundDepositCredit': '환불 예치금 적립',
  'pages.members.taxSettlement.col.purchaseEstimate': '구매견적',
  'pages.members.taxSettlement.col.firstTierPaymentCost': '1차결제비용',
  'pages.members.taxSettlement.col.firstTierProductAmount': '상품금액 (1차결제)',
  'pages.members.taxSettlement.col.firstTierServiceFee': '상품수수료 (1차결제)',
  'pages.members.taxSettlement.col.firstTierDomesticShipping': '국내배송비용 (1차결제)',
  'pages.members.taxSettlement.col.couponUsed': '쿠폰사용',
  'pages.members.taxSettlement.col.pointsUsed': '포인트사용',
  'pages.members.taxSettlement.col.relatedOrderNumbers': '관연주문',
  'pages.members.taxSettlement.col.bankNetAfterRefund': '환불차감후 뱅크금액',
  'pages.members.taxSettlement.col.firstTierAfterRefund': '환불후 1차결제금액',
  'pages.members.taxSettlement.col.depositUsed': '예치금사용',
  'pages.members.taxSettlement.col.secondTierPaymentCost': '2차결제비용',
  'pages.members.taxSettlement.col.internationalShippingSecondTier': '국제배송비용(2차결제)',
  'pages.members.taxSettlement.col.ruralShippingSecondTier': '도서산간비용(2차결제)',
  'pages.members.taxSettlement.col.simplifiedClearanceSecondTier': '간이통관비용 (2차결제)',
  'pages.members.taxSettlement.col.addOnServicesSecondTier': '부가서비스비용 (2차결제)',
  'pages.members.taxSettlement.col.productPurchaseCNY': '상품구입 CNY',
  'pages.members.taxSettlement.col.exchangeRate': '환율',
  'pages.members.taxSettlement.col.miscLoss': '잡손실',
  'pages.members.taxSettlement.col.note': '비고',
  'pages.members.taxSettlement.receiver': '수취인',
  'pages.members.taxSettlement.receiverAddress': '수취인 주소',
  'pages.members.taxSettlement.personalCustomsCode': '개인통관코드',
  'pages.members.taxSettlement.productNameEnglish': '상품 이름 (영어)',
  'pages.members.taxSettlement.ct': 'C/T',
  'pages.members.taxSettlement.weight': '무게',
  'pages.members.taxSettlement.shippingCosts': '운송비',
  'pages.members.taxSettlement.additionalServices': '부가서비스',
  'pages.members.taxSettlement.additionalCostPayment': '추가 비용 지불',
  'pages.members.taxSettlement.export': 'Excel 내보내기',
  'pages.members.taxSettlement.exportSuccess': 'Excel 내보내기 시작되었습니다.',
  'pages.members.taxSettlement.progressStatus': '진행 상태',
  'pages.members.taxSettlement.tab.order': '주문',
  'pages.members.taxSettlement.tab.deposit': '예치금',
  'pages.members.taxSettlement.order.orderDate': '주문일시',
  'pages.members.taxSettlement.order.orderNumber': '주문번호',
  'pages.members.taxSettlement.order.memberName': '회원명',
  'pages.members.taxSettlement.order.waybillNumber': '운송장번호',
  'pages.members.taxSettlement.order.productNameEnglish': '영문상품명',
  'pages.members.taxSettlement.order.paymentMethod': '결제수단',
  'pages.members.taxSettlement.order.refundType': '환불/2차결제 구분',
  'pages.members.taxSettlement.order.paymentAmounts': '1차/2차 결제비용',
  'pages.members.taxSettlement.order.productAmount': '상품금액',
  'pages.members.taxSettlement.order.fee': '수수료',
  'pages.members.taxSettlement.order.domesticShippingFee': '국내배송비',
  'pages.members.taxSettlement.order.sumAmount': '합계(상품+수수료+국내배송비)',
  'pages.members.taxSettlement.order.internationalShippingFee': '국제배송비',
  'pages.members.taxSettlement.order.secondaryPaymentAmount': '2차결제금액(국제배송비 외)',
  'pages.members.taxSettlement.order.pointsUsed': '포인트사용금액',
  'pages.members.taxSettlement.order.couponUsed': '쿠폰사용금액',
  'pages.members.taxSettlement.order.depositUsed': '예치금사용금액',
  'pages.members.taxSettlement.order.productPurchaseCost': '상품구입비(상품가격/환율)',
  'pages.members.taxSettlement.order.exchangeRate': '환율',
  'pages.members.taxSettlement.order.netFee': '수수료-포인트-쿠폰',
  'pages.members.taxSettlement.order.paymentMethod.bankTransfer': '무통장',
  'pages.members.taxSettlement.order.paymentMethod.creditCard': '신용카드',
  'pages.members.taxSettlement.order.paymentMethod.deposit': '예치금',
  'pages.members.taxSettlement.order.paymentMethod.points': '포인트',
  'pages.members.taxSettlement.order.refundType.fullRefund': '전부환불',
  'pages.members.taxSettlement.order.refundType.partialRefund': '부분환불',
  'pages.members.taxSettlement.order.refundType.secondPayment': '2차결제',
  'pages.members.taxSettlement.deposit.memberName': '회원명',
  'pages.members.taxSettlement.deposit.carryoverBalance': '이월잔액',
  'pages.members.taxSettlement.deposit.earning': '적립(환불대신/리베이트)',
  'pages.members.taxSettlement.deposit.depositRecharge': '예치금충전',
  'pages.members.taxSettlement.deposit.deduction': '차감(주문사용/리베이트 차감)',
  'pages.members.taxSettlement.deposit.depositWithdrawal': '예치금출금',
  'pages.members.taxSettlement.deposit.balanceAfter': '변동후 잔액',

  // Store Management
  'pages.products.store.title': '스토어 관리',
  'pages.products.store.edit': '수정',
  'pages.products.store.delete': '삭제',
  'pages.products.store.products': '상품',
  'pages.products.store.viewProducts': '이 스토어의 상품 보기',
  'pages.products.store.editTitle': '스토어 수정',
  'pages.products.store.nameKo': '한국어 이름',
  'pages.products.store.nameEn': '영어 이름',
  'pages.products.store.nameZh': '중국어 이름',
  'pages.products.store.totalProducts': '총 상품수',
  'pages.products.store.nameKoRequired': '한국어 이름을 입력하세요',
  'pages.products.store.nameKoPlaceholder': '한국어 스토어 이름 입력',
  'pages.products.store.translateFromThis': '이 값으로 다른 언어 번역',
  'pages.products.store.nameEnPlaceholder': '영어 스토어 이름 입력',
  'pages.products.store.nameZhPlaceholder': '중국어 스토어 이름 입력',
  'pages.products.store.image': '스토어 이미지',
  'pages.products.store.uploadImage': '이미지 업로드',
  'pages.products.store.status': '상태',
  'pages.products.store.createdAt': '생성일',
  'pages.products.store.actions': '작업',
  'pages.products.store.total': '총',
  'pages.products.store.showInactive': '비활성 표시',
  'pages.products.store.hideInactive': '비활성 숨김',
  'pages.products.store.createSuccess': '스토어가 성공적으로 생성되었습니다',
  'pages.products.store.createFailed': '스토어 생성에 실패했습니다',
  'pages.products.store.updateSuccess': '스토어가 성공적으로 업데이트되었습니다',
  'pages.products.store.unsavedKeep': '계속 편집',
  'pages.products.store.unsavedDiscard': '닫기',
  'pages.products.store.unsavedBody': '닫으면 지금까지 고친 내용이 사라집니다. 닫을까요?',
  'pages.products.store.unsavedTitle': '저장하지 않은 변경이 있습니다',
  'pages.products.store.updateFailed': '스토어 업데이트에 실패했습니다',
  'pages.products.store.deleteSuccess': '스토어가 성공적으로 삭제되었습니다',
  'pages.products.store.deleteFailed': '스토어 삭제에 실패했습니다',
  'pages.products.store.deleteConfirm': '스토어 삭제',
  'pages.products.store.deleteContent': '"{name}" 스토어를 삭제하시겠습니까?',
  // 스토어 ↔ 회원 연결
  'pages.products.store.owner': '회원',
  'pages.products.store.ownerNone': '미연결',
  'pages.products.store.ownerHint': '사서함 번호(LS56, TM373)나 닉네임으로 검색해 이 스토어의 회원을 연결합니다. 스토어 리베이트의 셀러 몫이 이 회원에게 갑니다.',
  'pages.products.store.ownerPlaceholder': '사서함 번호 또는 닉네임 검색',
  'pages.products.store.ownerNotFound': '회원을 찾을 수 없습니다',
  'pages.products.store.pointShop': '포인트샵',
  'pages.products.store.pointShopHint': '켜면 이 스토어의 상품은 포인트로만 구매할 수 있습니다.',

  // 스토어 리베이트 설정
  'pages.products.storeRebate.title': '스토어 리베이트 설정',
  'pages.products.storeRebate.store': '스토어',
  'pages.products.storeRebate.owner': '회원',
  'pages.products.storeRebate.ownerNone': '회원 미연결',
  'pages.products.storeRebate.inactiveStore': '비활성',
  'pages.products.storeRebate.sellerPercent': '셀러 %',
  'pages.products.storeRebate.companyPercent': '회사 %',
  'pages.products.storeRebate.configuredAt': '설정 시간',
  'pages.products.storeRebate.actions': '작업',
  'pages.products.storeRebate.setting': '설정',
  'pages.products.storeRebate.delete': '삭제',
  'pages.products.storeRebate.addRebate': '리베이트 추가',
  'pages.products.storeRebate.addModalTitle': '스토어 리베이트 설정 추가',
  'pages.products.storeRebate.editModalTitle': '스토어 리베이트 설정 수정',
  'pages.products.storeRebate.storeRequired': '스토어를 선택하세요',
  'pages.products.storeRebate.storeSelectPlaceholder': '스토어 이름 또는 회원으로 검색',
  'pages.products.storeRebate.noStoreLeft': '리베이트를 설정하지 않은 스토어가 없습니다',
  'pages.products.storeRebate.sellerPercentRequired': '셀러 비율을 입력하세요',
  'pages.products.storeRebate.companyPercentRequired': '회사 비율을 입력하세요',
  'pages.products.storeRebate.sumError': '셀러 %와 회사 %의 합은 100이어야 합니다',
  'pages.products.storeRebate.sumHint': '셀러 %를 입력하면 회사 %는 100에서 뺀 값으로 채워집니다.',
  'pages.products.storeRebate.ownerMissingHint': '이 스토어에는 연결된 회원이 없습니다. 스토어 관리에서 회원을 먼저 연결해야 셀러 몫을 받을 사람이 정해집니다.',
  'pages.products.storeRebate.addSuccess': '스토어 리베이트 설정이 추가되었습니다',
  'pages.products.storeRebate.addFailed': '스토어 리베이트 설정 추가에 실패했습니다',
  'pages.products.storeRebate.updateSuccess': '스토어 리베이트 설정이 수정되었습니다',
  'pages.products.storeRebate.updateFailed': '스토어 리베이트 설정 수정에 실패했습니다',
  'pages.products.storeRebate.deleteSuccess': '스토어 리베이트 설정이 삭제되었습니다',
  'pages.products.storeRebate.deleteFailed': '스토어 리베이트 설정 삭제에 실패했습니다',
  'pages.products.storeRebate.deleteConfirm': '스토어 리베이트 설정 삭제',
  'pages.products.storeRebate.deleteContent': '"{name}" 스토어의 리베이트 설정을 삭제하시겠습니까?',
  'pages.products.storeRebate.searchPlaceholder': '스토어 이름, 사서함 번호 또는 닉네임으로 검색',
  'pages.products.storeRebate.search': '검색',
  'pages.products.storeRebate.reset': '초기화',
  'pages.products.storeRebate.batchUpdateTitle': '백분율 일괄 수정',
  'pages.products.storeRebate.applySetting': '설정 적용',
  'pages.products.storeRebate.cancel': '취소',
  'pages.products.storeRebate.batchUpdateSuccess': '일괄 수정이 완료되었습니다',
  'pages.products.storeRebate.batchUpdateFailed': '일괄 수정에 실패했습니다',

  // 라이브 셀러
  'pages.live.sellers.title': '라이브방송 셀러 관리',
  'pages.live.sellers.register': '셀러등록',
  'pages.live.sellers.sellerName': '셀러명',
  'pages.live.sellers.id': 'ID',
  'pages.live.sellers.contact': '연락처',
  'pages.live.sellers.liveCount': '라이브횟수',
  'pages.live.sellers.totalViews': '총 조회수',
  'pages.live.sellers.totalItemsSold': '총 판매량',
  'pages.live.sellers.activeProducts': '진행중상품',
  'pages.live.sellers.status': '상태',
  'pages.live.sellers.status.active': '● 라이브중',
  'pages.live.sellers.status.inactive': '○ 휴식',
  'pages.live.sellers.top10': 'TOP10',
  'pages.live.sellers.popular': '인기',
  'pages.live.sellers.pointSeller': '포인트',
  'pages.live.sellers.actions': '작업',
  'pages.live.sellers.detail': '상세',
  'pages.live.sellers.edit': '수정',
  'pages.live.sellers.delete': '삭제',
  'pages.live.sellers.deleteConfirm': '셀러 삭제',
  'pages.live.sellers.deleteContent': '"{name}" 셀러를 삭제하시겠습니까?',
  'pages.live.sellers.deleteSuccess': '셀러가 삭제되었습니다',
  'pages.live.sellers.deleteFailed': '셀러 삭제에 실패했습니다',
  'pages.live.sellers.updateSuccess': '셀러가 수정되었습니다',
  'pages.live.sellers.updateFailed': '셀러 수정에 실패했습니다',
  'pages.live.sellers.edit.liveCount': '라이브 횟수',
  'pages.live.sellers.edit.liveCountPlaceholder': '라이브 횟수를 입력하세요',
  'pages.live.sellers.edit.topRank': 'TOP 10 순위',
  'pages.live.sellers.edit.topRankPlaceholder': '순위 입력 (1-10)',
  'pages.live.sellers.edit.topRankTooltip': 'TOP 10 셀러의 경우 1-10 사이의 순위를 설정하고, 해당 없으면 비워두세요',
  'pages.live.sellers.edit.rankDelta': '랭킹 변동',
  'pages.live.sellers.edit.rankDeltaHint': '+는 상승, -는 하락, 0은 변동 없음',
  'pages.live.sellers.edit.rankDeltaPlaceholder': '예: 2, -1, 0',
  'pages.live.sellers.edit.totalViews': '총 조회수',
  'pages.live.sellers.edit.totalViewsPlaceholder': '총 조회수 입력',
  'pages.live.sellers.edit.totalItemsSold': '총 판매량',
  'pages.live.sellers.edit.totalItemsSoldPlaceholder': '총 판매량 입력',
  'pages.live.sellers.edit.popularStatus': '인기 셀러 상태',
  'pages.live.sellers.edit.pointSellerStatus': '포인트 셀러 상태',
  'pages.live.sellers.loadFailed': '셀러 목록을 불러오는데 실패했습니다',
  'pages.live.sellers.legend': '[범례] 🔥 인기셀러 (최근 30일 라이브 5회 이상)',
  'pages.live.sellers.top10Info': 'TOP10: 이번 달 라이브 횟수/판매량 기준 자동 산정',
  
  // 라이브 셀러 등록
  'pages.live.sellers.register.title': '셀러 등록',
  'pages.live.sellers.register.searchUser': '회원 검색',
  'pages.live.sellers.register.searchPlaceholder': '이름, 이메일, ID로 검색',
  'pages.live.sellers.register.search': '검색',
  'pages.live.sellers.register.searchResults': '검색결과 (기존 회원)',
  'pages.live.sellers.register.noResults': '검색 결과가 없습니다',
  'pages.live.sellers.register.selectUser': '셀러등록',
  'pages.live.sellers.register.selected': '선택됨',
  'pages.live.sellers.register.registerAsSeller': '셀러등록',
  'pages.live.sellers.register.selectedUser': '선택 회원',
  'pages.live.sellers.register.registrationInfo': '등록 정보 입력',
  'pages.live.sellers.register.nickname': '라이브 닉네임',
  'pages.live.sellers.register.nicknamePlaceholder': '라이브 방송에서 사용할 닉네임',
  'pages.live.sellers.register.liveChannelLink': '라이브 채널 링크',
  'pages.live.sellers.register.liveChannelLinkPlaceholder': '라이브 채널 URL을 입력하세요',
  'pages.live.sellers.channels.section': 'SNS 채널',
  'pages.live.sellers.channels.tiktok': '틱톡 링크',
  'pages.live.sellers.channels.youtube': '유튜브 링크',
  'pages.live.sellers.channels.tiktokPlaceholder': 'https://www.tiktok.com/@아이디 또는 @아이디',
  'pages.live.sellers.channels.youtubePlaceholder': 'https://www.youtube.com/@핸들 또는 @핸들',
  'pages.live.sellers.channels.tiktokInvalid': '틱톡 주소(tiktok.com)나 @아이디를 입력하세요',
  'pages.live.sellers.channels.youtubeInvalid': '유튜브 주소(youtube.com · youtu.be)나 @핸들을 입력하세요',
  'pages.live.sellers.channels.useLiveChannelLink': '라이브 채널 링크 주소 넣기',
  'pages.live.sellers.channels.hint': '넣은 링크는 셀러 페이지와 라이브 페이지 셀러 카드에 아이콘으로 보입니다. 비우면 아이콘이 사라집니다.',
  'pages.live.sellers.register.referralCode': '추천 코드',
  'pages.live.sellers.register.referralCodePlaceholder': '추천인 코드를 입력하세요',
  'pages.live.sellers.register.referralCodeTooltip': '추천인이 있는 경우 해당 코드를 입력하세요 (선택 사항)',
  'pages.live.sellers.detailInfo.title': '셀러 상세 정보',
  'pages.live.sellers.detailInfo.userId': '회원 ID',
  'pages.live.sellers.detailInfo.sellerId': '셀러 ID',
  'pages.live.sellers.detailInfo.recommender': '추천인',
  'pages.live.sellers.detailInfo.rebate': '리베이트',
  'pages.live.sellers.detailInfo.teamRebate': '팀 리베이트',
  'pages.live.sellers.detailInfo.deposit': '예치금',
  'pages.live.sellers.detailInfo.salesCount': '판매수량',
  'pages.live.sellers.detailInfo.salesAmount': '판매금액',
  'pages.live.sellers.detailInfo.rebateAccrued': '리베이트(적립)',
  'pages.live.sellers.detailInfo.avgOrderValue': '객단가',
  'pages.live.sellers.detailInfo.refundCount': '반품수량',
  'pages.live.sellers.detailInfo.refundAmount': '반품금액',
  'pages.live.sellers.detailInfo.rebateDeducted': '리베이트(차감)',
  'pages.live.sellers.detailInfo.refundRate': '반품비율',
  'pages.live.sellers.detailInfo.teamMembers': '팀원수',
  'pages.live.sellers.detailInfo.teamSalesAmount': '팀 판매금액',
  'pages.live.sellers.detailInfo.teamRebateAccrued': '팀 리베이트(적립)',
  'pages.live.sellers.detailInfo.teamRebateDeducted': '팀 리베이트(차감)',
  'pages.live.sellers.detailInfo.teamRefundRate': '팀 반품비율',
  'pages.live.sellers.detailInfo.followers': '팔로워',
  'pages.live.sellers.detailInfo.teamFollowers': '팀 팔로워',
  'pages.live.sellers.detailInfo.rank': '순위',
  'pages.live.sellers.detailInfo.regionDistribution': '지역 분포',
  'pages.live.sellers.detailInfo.noData': '데이터 없음',
  'pages.live.sellers.detailInfo.comparedToYesterday': '전일 대비',
  'pages.live.sellers.detailInfo.comparedToLastMonth': '전월 대비',
  'pages.live.sellers.detailInfo.unitMan': '만',
  'pages.live.sellers.detailInfo.name': '이름',
  'pages.live.sellers.detailInfo.miniHomepage': '미니 홈페이지',
  'pages.live.sellers.detailInfo.liveChannel': '라이브 페이지',
  'pages.live.sellers.detailInfo.personal': '개인',
  'pages.live.sellers.detailInfo.team': '팀',
  'pages.live.sellers.detailInfo.refunds': '환불',
  'pages.live.sellers.detailInfo.metric': '항목',
  'pages.live.sellers.products.batchUpdate': '일괄 수정',
  'pages.live.sellers.products.batchUpdate.apply': '일괄 적용',
  'pages.live.sellers.products.batchUpdate.selectFirst': '수정할 상품을 먼저 선택해 주세요.',
  'pages.live.sellers.products.batchUpdate.valueRequired': '값을 입력해 주세요.',
  'pages.live.sellers.products.batchUpdate.description': '선택한 상품의 모든 SKU에 동일한 값이 적용됩니다.',
  'pages.live.sellers.products.batchUpdate.descriptionProduct': '선택한 상품 모두에 같은 값이 적용됩니다.',
  'pages.live.sellers.products.batchUpdate.placeholder.companyName': '상가명 입력',
  'pages.live.sellers.products.column.category': '카테고리',
  'pages.live.sellers.products.category.placeholder': '카테고리 선택',
  'pages.live.sellers.products.category.wholeGroup': '{name} 전체',
  'pages.live.sellers.products.category.sharedHint': '자사몰 카테고리를 함께 씁니다. 자사몰 상품은 여기서 바꾸면 자사몰 상품 목록의 카테고리도 같이 바뀝니다.',
  'pages.live.sellers.products.applyToSelected.title': '선택한 {count}개 상품에 적용할까요?',
  'pages.live.sellers.products.category.applyToSelected.content': '선택한 {count}개 상품의 카테고리를 모두 “{category}”(으)로 지정합니다.',
  'pages.live.sellers.products.applyToSelected.all': '{count}개 모두 적용',
  'pages.live.sellers.products.applyToSelected.onlyThis': '이 상품만',
  'pages.live.sellers.products.category.none': '카테고리 없음',
  'pages.live.sellers.products.companyName.applyToSelected.content': '선택한 {count}개 상품의 상가명을 모두 “{companyName}”(으)로 지정합니다.',
  'pages.live.sellers.products.companyName.none': '상가명 없음',
  'pages.live.sellers.products.flag.applyToSelected.content': '선택한 {count}개 상품의 “{field}”을(를) 모두 {state}(으)로 바꿉니다.',
  'pages.live.sellers.products.flag.on': '켬',
  'pages.live.sellers.products.flag.off': '끔',
  'pages.live.sellers.products.flag.liveOnly': '간편 등록 상품에만 쓰는 설정입니다. 자사몰 상품은 자사몰 상품 관리에서 노출을 바꿔 주세요.',
  'pages.live.sellers.products.filter.categoryNone': '카테고리 미지정',
  'pages.live.sellers.products.filter.category': '카테고리 필터',
  'pages.live.sellers.products.selection.setCategory': '선택 상품 카테고리 지정',
  'pages.live.sellers.products.selection.clear': '선택 해제',
  'pages.live.sellers.products.tab.simple': '간편 등록 상품',
  'pages.live.sellers.products.tab.company': '자사몰 상품',
  'pages.live.sellers.products.headerTitle.simple': '간편 등록 상품',
  'pages.live.sellers.products.headerTitle.company': '자사몰 상품',
  'pages.live.sellers.products.addCompanyProduct': '자사몰 상품 등록',
  'pages.live.sellers.products.addCompany.selectProduct': '상품을 하나 이상 선택해 주세요.',
  'pages.live.sellers.products.addCompany.registeredCount': '해당 셀러에 {count}건이 등록되었습니다.',
  'pages.live.sellers.products.addCompany.failed': '등록에 실패했습니다.',
  'pages.live.sellers.products.addCompany.partialResult': '{success}건 성공, {failed}건 실패 ({reasons})',
  'pages.live.sellers.products.addCompany.failReason.item': '{label} {count}건',
  'pages.live.sellers.products.addCompany.failReason.ownedByOtherSeller': '다른 셀러 소유 상품',
  'pages.live.sellers.products.addCompany.failReason.notFound': '상품 없음',
  'pages.live.sellers.products.addCompany.failReason.createFailed': '등록 오류',
  'pages.live.sellers.products.addCompany.batchHint': '각 행에서 상품을 검색하여 선택하세요.',
  'pages.live.sellers.products.addCompany.registerSelected': '선택 상품 등록 ({count})',
  'pages.live.sellers.products.loadFailed': '상품 목록을 불러오지 못했습니다.',
  'pages.live.sellers.products.sortBy.createdAt_desc': '등록일 최신순',
  'pages.live.sellers.products.sortBy.createdAt_asc': '등록일 오래된순',
  'pages.live.sellers.products.sortBy.updatedAt_desc': '수정일 최신순',
  'pages.live.sellers.products.sortBy.updatedAt_asc': '수정일 오래된순',
  'pages.live.sellers.products.filter.registeredFrom': '등록일 시작',
  'pages.live.sellers.products.filter.registeredTo': '등록일 종료',
  'pages.live.sellers.products.column.image': '이미지',
  'pages.live.sellers.products.column.title': '상품명',
  'pages.live.sellers.products.column.companyName': '상가명',
  'pages.live.sellers.products.column.offerId': 'Offer ID',
  'pages.live.sellers.products.column.productNo': '상품번호',
  'pages.live.sellers.products.column.userName': '사용자명',
  'pages.live.sellers.products.column.userUniqueId': '유저 고유 ID',
  'pages.live.sellers.products.filter.userUniqueIdPlaceholder': '유저 고유 ID로 검색',
  'pages.live.sellers.products.column.liveCode': '라이브코드',
  'pages.live.sellers.products.column.registeredAt': '등록일',
  'pages.live.sellers.products.column.salesQuantity': '판매수량',
  'pages.live.sellers.products.column.viewCount': '조회수',
  'pages.live.sellers.products.column.hotProduct': '핫상품',
  'pages.live.sellers.products.column.popularProduct': '인기상품',
  'pages.live.sellers.products.column.topFixed': '상단 고정',
  'pages.live.sellers.products.column.liveStatus': '라이브 노출',
  'pages.live.sellers.products.column.specialPrice': '특가',
  'pages.live.sellers.products.column.manage': '관리',
  'pages.live.sellers.products.tag.hot': '핫',
  'pages.live.sellers.products.tag.popular': '인기',
  'pages.live.sellers.products.tag.special': '특가',
  'pages.live.sellers.products.delete.title': '상품 삭제',
  'pages.live.sellers.products.delete.content': '이 상품을 삭제하시겠습니까?',
  'pages.live.sellers.products.delete.notImplemented': '삭제 기능은 준비 중입니다.',
  'pages.live.sellers.products.delete.noStatus': '연결된 라이브 일정이 없어 삭제할 수 없습니다',
  'pages.live.sellers.products.batchDelete': '일괄 삭제',
  'pages.live.sellers.products.batchDelete.title': '선택한 상품 삭제',
  'pages.live.sellers.products.batchDelete.content':
    '선택한 {count}개 상품을 이 셀러 페이지에서 삭제합니다. 되돌릴 수 없습니다.',
  'pages.live.sellers.products.batchDelete.ok': '삭제',
  'pages.live.sellers.products.batchDelete.selectFirst': '삭제할 상품을 먼저 선택해 주세요.',
  'pages.live.sellers.products.batchDelete.result': '{count}건을 삭제했습니다.',
  'pages.live.sellers.products.batchDelete.resultWithFailures': '{count}건 삭제, {failed}건 실패 ({reasons})',
  'pages.live.sellers.products.batchDelete.failReason.item': '{label} {count}건',
  'pages.live.sellers.products.batchDelete.failReason.notRegistered': '이 셀러 페이지에 없는 상품',
  'pages.live.sellers.products.batchDelete.failReason.notFound': '상품 없음',
  'pages.live.sellers.products.batchDelete.failReason.deleteFailed': '삭제 오류',
  'pages.live.sellers.products.copyLink.tooltip': '구매 링크 복사',
  'pages.live.sellers.products.copyLink.noStatus': '연결된 라이브 일정이 없어 링크를 생성할 수 없습니다',
  'pages.live.sellers.products.copyLink.success': '구매 링크가 클립보드에 복사되었습니다',
  'pages.live.sellers.products.copyLink.failed': '구매 링크 생성에 실패했습니다',
  'pages.live.sellers.products.copyLink.empty': '서버에서 링크가 반환되지 않았습니다',
  'pages.live.sellers.products.copyLink.manualTitle': '아래 링크를 직접 복사해 주세요',
  'pages.live.sellers.products.batchUpdate.modalTitle': '{batch} ({count})',
  'pages.live.sellers.products.batchUpdate.field': '항목',
  'pages.live.sellers.products.batchUpdate.value': '값',
  'pages.live.sellers.products.batchUpdate.field.productName': '상품명',
  'pages.live.sellers.products.batchUpdate.productName.ko': '상품명 (Ko)',
  'pages.live.sellers.products.batchUpdate.productName.en': '상품명 (En)',
  'pages.live.sellers.products.batchUpdate.productName.zh': '상품명 (Zh)',
  'pages.live.sellers.products.batchUpdate.productName.placeholder': '상품명을 입력하면 다른 언어는 자동 번역됩니다',
  'pages.live.sellers.products.batchUpdate.productName.koRequired': '한국어 상품명은 필수입니다',
  'pages.live.sellers.products.batchUpdate.productName.translate': '이 값으로 다른 언어 번역',
  'pages.live.sellers.products.batchUpdate.field.costPrice': '사입가 (₩)',
  'pages.live.sellers.products.batchUpdate.field.costPriceCny': '사입가 (CNY)',
  'pages.live.sellers.products.batchUpdate.field.salePrice': '판매가 (₩)',
  'pages.live.sellers.products.batchUpdate.field.tagPrice': '태그가 (₩)',
  'pages.live.sellers.products.batchUpdate.field.stock': '재고',
  'pages.live.sellers.products.batchUpdate.placeholder.amount': '금액',
  'pages.live.sellers.products.batchUpdate.placeholder.cny': '금액 (CNY)',
  'pages.live.sellers.products.batchUpdate.placeholder.qty': '수량',
  'pages.live.sellers.products.batchUpdate.result': '{success}개 상품이 수정되었습니다.',
  'pages.live.sellers.products.batchUpdate.resultWithFailures':
    '{success}개 상품이 수정되었습니다. ({failed}개 실패)',
  'pages.live.sellers.products.simpleEdit.title': '간편 수정',
  'pages.live.sellers.products.simpleEdit.titleWithProduct': '간편 수정 — {name}',
  'pages.live.sellers.products.simpleEdit.productInfo': '상품 정보',
  'pages.live.sellers.products.simpleEdit.productNo': '품번',
  'pages.live.sellers.products.simpleEdit.productNoPlaceholder': '품번을 입력하세요',
  'pages.live.sellers.products.simpleEdit.companyName': '상가명',
  'pages.live.sellers.products.simpleEdit.okSave': '수정 확인',
  'pages.live.sellers.products.simpleEdit.attr': '속성',
  'pages.live.sellers.products.simpleEdit.attrColorSize': '색상/사이즈',
  'pages.live.sellers.products.simpleEdit.addColor': '색상 추가',
  'pages.live.sellers.products.simpleEdit.addSize': '사이즈 추가',
  'pages.live.sellers.products.simpleEdit.colorPlaceholder': '블랙 / 화이트 …',
  'pages.live.sellers.products.simpleEdit.sizePlaceholder': 'S / M / L / XL …',
  'pages.live.sellers.products.simpleEdit.attrNamePlaceholder': '속성명',
  'pages.live.sellers.products.simpleEdit.addValuesPlaceholder': '{name} 추가',
  'pages.live.sellers.products.simpleEdit.addValuesDefaultName': '값',
  'pages.live.sellers.products.simpleEdit.confirmAdd': '추가 확인',
  'pages.live.sellers.products.simpleEdit.addAttr': '속성 추가',
  'pages.live.sellers.products.simpleEdit.table.emptyText': '색상/사이즈를 추가해 주세요.',
  'pages.live.sellers.products.simpleEdit.column.image': '이미지',
  'pages.live.sellers.products.simpleEdit.column.attrs': '속성',
  'pages.live.sellers.products.simpleEdit.column.costPrice': '사입가 (KRW)',
  'pages.live.sellers.products.simpleEdit.column.costPriceCny': '사입가 (CNY)',
  'pages.live.sellers.products.simpleEdit.column.salePrice': '판매가',
  'pages.live.sellers.products.simpleEdit.column.tagPrice': '태그가',
  'pages.live.sellers.products.simpleEdit.column.stock': '재고',
  'pages.live.sellers.products.simpleEdit.column.delete': '삭제',
  'pages.live.sellers.products.simpleEdit.bulkTitleSelected': '일괄 수정 (선택 {count}개)',
  'pages.live.sellers.products.simpleEdit.bulkTitleAll': '일괄 수정 (전체)',
  'pages.live.sellers.products.simpleEdit.bulkField.costPrice': '사입가',
  'pages.live.sellers.products.simpleEdit.bulkField.costPriceCny': '사입가 (CNY)',
  'pages.live.sellers.products.simpleEdit.bulkField.salePrice': '판매가',
  'pages.live.sellers.products.simpleEdit.bulkField.tagPrice': '태그가',
  'pages.live.sellers.products.simpleEdit.bulkField.stock': '재고',
  'pages.live.sellers.products.simpleEdit.bulkField.imageUrl': '이미지',
  'pages.live.sellers.products.simpleEdit.bulkImagePlaceholder': '이미지 URL',
  'pages.live.sellers.products.simpleEdit.bulkValuePlaceholder': '값',
  'pages.live.sellers.products.simpleEdit.bulkApply': '일괄 적용',
  'pages.live.sellers.products.simpleEdit.clearSelection': '선택 해제',
  'pages.live.sellers.products.simpleEdit.imageSwapTitle': '이미지 교체',
  'pages.live.sellers.products.simpleEdit.imageSwapUrlPlaceholder': '이미지 URL을 입력하세요',
  'pages.live.sellers.products.simpleEdit.imageSwapNoPreview': '미리보기 없음',
  'pages.live.sellers.products.simpleEdit.gallery.label': '상품 사진 ({count}/{max})',
  'pages.live.sellers.products.simpleEdit.gallery.required': '상품 사진을 한 장 이상 남겨 주세요.',
  'pages.live.sellers.products.simpleEdit.coverRemovePending': '커버 사진은 저장하면 삭제됩니다.',
  'pages.live.sellers.products.simpleEdit.coverRemoveUndo': '되돌리기',
  'pages.live.sellers.products.simpleEdit.coverRemoveFailed': '커버 사진 삭제에 실패했습니다. 나머지 내용은 저장되었습니다.',
  'pages.productGallery.main': '대표',
  'pages.productGallery.view': '크게 보기',
  'pages.productGallery.replace': '사진 교체',
  'pages.productGallery.remove': '삭제',
  'pages.productGallery.add': '사진 추가',
  'pages.productGallery.hint': '첫 번째가 대표 사진 · 끌어서 순서 변경',
  'pages.productGallery.limit': '사진은 최대 {max}장까지 올릴 수 있습니다.',
  'pages.productGallery.notImage': '이미지 파일만 올릴 수 있습니다.',
  'pages.productGallery.uploadFailed': '사진 업로드에 실패했습니다.',
  'pages.productGallery.cover': '커버',
  'pages.productGallery.coverHint':
    '커버(랜딩 이미지): 프론트 페이지 설정에서 올린 사진으로, 상품 상세 첫 사진과 상품 카드에 대표 사진보다 먼저 나갑니다. 지우면 대표 사진이 다시 쓰입니다.',
  'pages.live.sellers.products.simpleEdit.noProductInfo': '상품 정보가 없습니다. 다시 열어 주세요.',
  'pages.live.sellers.products.simpleEdit.noSkus': '저장할 SKU가 없습니다.',
  'pages.live.sellers.products.simpleEdit.saveSuccess': '상품이 수정되었습니다.',
  'pages.live.sellers.products.simpleEdit.saveFailed': '상품 수정에 실패했습니다.',
  'pages.live.sellers.products.simpleEdit.loadFailed': '상품을 불러오지 못했습니다.',
  'pages.live.sellers.products.simpleEdit.colorOrSizeRequired': '색상 또는 사이즈를 입력해 주세요.',
  'pages.live.sellers.products.simpleEdit.bulkValueRequired': '값을 입력해 주세요.',
  'pages.live.sellers.products.simpleEdit.bulkAppliedAll': '전체 행에 일괄 수정되었습니다.',
  'pages.live.sellers.products.simpleEdit.bulkAppliedSelected': '선택한 {count}개 행에 일괄 수정되었습니다.',
  'pages.live.sellers.register.nicknameRequired': '닉네임을 입력해주세요',
  'pages.live.sellers.register.phone': '연락처',
  'pages.live.sellers.register.phonePlaceholder': '010-1234-5678',
  'pages.live.sellers.register.platforms': '플랫폼',
  'pages.live.sellers.register.instagram': '인스타 @',
  'pages.live.sellers.register.tiktok': '틱톡 @',
  'pages.live.sellers.register.youtube': '유튜브 @',
  'pages.live.sellers.register.usernamePlaceholder': 'username',
  'pages.live.sellers.register.channelPlaceholder': 'channel',
  'pages.live.sellers.register.submit': '셀러등록',
  'pages.live.sellers.register.cancel': '취소',
  'pages.live.sellers.register.success': '셀러가 등록되었습니다',
  'pages.live.sellers.register.failed': '셀러 등록에 실패했습니다',
  'pages.live.sellers.register.selectUserFirst': '회원을 선택해주세요',
  'pages.live.sellers.register.userInfo': 'user: {userId} | {email}',
  'pages.live.sellers.register.joinDate': '가입: {date} | 구매횟수: {count}회',
  'pages.live.sellers.register.searchFailed': '회원 검색에 실패했습니다',
  
  // 라이브 셀러 상세
  'pages.live.sellers.detail.title': '셀러 상세: {name}',
  'pages.live.sellers.detail.back': '뒤로',
  'pages.live.sellers.detail.list': '목록',
  'pages.live.sellers.detail.basicInfo': '기본정보',
  'pages.live.sellers.detail.name': '이름',
  'pages.live.sellers.detail.contact': '연락처',
  'pages.live.sellers.detail.uid': '회원 ID',
  'pages.live.sellers.detail.nickname': '닉네임',
  'pages.live.sellers.detail.userNumber': '번호',
  'pages.live.sellers.detail.joinDate': '가입일',
  'pages.live.sellers.detail.orderCount': '구매횟수',
  'pages.live.sellers.detail.platforms': '플랫폼',
  'pages.live.sellers.detail.status': '상태',
  'pages.live.sellers.detail.totalLiveCount': '총 라이브횟수',
  'pages.live.sellers.detail.top10Rank': 'TOP10 순위',
  'pages.live.sellers.detail.popularSeller': '인기셀러',
  'pages.live.sellers.detail.popular': '🔥 인기',
  'pages.live.sellers.detail.popularInfo': '🔥 (30일간 {count}회)',
  'pages.live.sellers.detail.pointSeller': '포인트 셀러',
  'pages.live.sellers.detail.pointSellerLabel': '⭐ 포인트 셀러',
  'pages.live.sellers.detail.notFound': '셀러 정보를 찾을 수 없습니다',
  'pages.live.sellers.detail.loadFailed': '셀러 정보를 불러오는데 실패했습니다',
  'pages.live.sellers.detail.times': '{count}회',
  'pages.live.sellers.detail.rank': '{rank}위',
  'pages.live.sellers.userId': '유저ID',
  'pages.live.sellers.sellerId': '셀러 ID',
  'pages.live.sellers.name': '셀러 닉넴',
  'pages.live.sellers.recommender': '추천인',
  'pages.live.sellers.team': '팀원수',
  'pages.live.sellers.follower': '팔로워',
  'pages.live.sellers.salesAmount': '판매금액',
  'pages.live.sellers.salesCount': '판매수',
  'pages.live.sellers.rebate': '리베이트 누적',
  'pages.live.sellers.refundAmount': '환불금액',
  'pages.live.sellers.rebateDeduction': '리베이트 차감',
  'pages.live.sellers.liveStatus': '라이브 상태',
  'pages.live.sellers.liveStatus.live': '라이브',
  'pages.live.sellers.liveStatus.idle': '대기',
  'pages.live.sellers.homepage': '홈페이지',
  'pages.live.sellers.homepageLink': '링크',
  'pages.live.sellers.sellerMailbox': '셀러 사서함',
  'pages.live.sellers.sellerNickname': '셀러 닉네임',
  'pages.live.sellers.rebateAccrued': '리베이트누적',
  'pages.live.sellers.rebateDeducted': '리베이트차감',
  'pages.live.sellers.marginAmount': '마진 금액',
  'pages.live.sellers.deposit': '예치금',
  'pages.live.sellers.livePage': '라이브페이지',
  'pages.live.sellers.listSearchPlaceholder': '사서함 또는 유저 ID 검색',
  'pages.live.sellers.liveLinkCopy': '라이브 링크 복사',
  'pages.live.sellers.liveLinkCopied': '라이브 링크를 복사했습니다.',
  'pages.live.sellers.liveLinkCopyFailed': '링크를 복사하지 못했습니다.',

  // 라이브 리베이트 설정
  'pages.live.rebate.title': '라이브 리베이트 설정',
  'pages.live.rebate.liveTeamName': '라이브 팀 이름',
  'pages.live.rebate.memberId': '회원 ID',
  'pages.live.rebate.sellerId': '셀러 ID',
  'pages.live.rebate.sellerPercent': '셀러 %',
  'pages.live.rebate.companyPercent': '회사 %',
  'pages.live.rebate.teamPercent': '팀 %',
  'pages.live.rebate.teamRebatePercent': '팀 리베이트 %',
  'pages.live.rebate.settingTimeAdmin': '설정 시간 / 관리자',
  'pages.live.rebate.actions': '작업',
  'pages.live.rebate.setting': '설정',
  'pages.live.rebate.detail': '상세',
  'pages.live.rebate.delete': '삭제',
  'pages.live.rebate.addRebate': '리베이트 추가',
  'pages.live.rebate.batchUpdate': '일괄 수정',
  'pages.live.rebate.selectFirst': '먼저 항목을 선택하세요',
  'pages.live.rebate.addSuccess': '리베이트가 성공적으로 추가되었습니다',
  'pages.live.rebate.addFailed': '리베이트 추가에 실패했습니다',
  'pages.live.rebate.updateSuccess': '리베이트가 성공적으로 수정되었습니다',
  'pages.live.rebate.updateFailed': '리베이트 수정에 실패했습니다',
  'pages.live.rebate.deleteSuccess': '리베이트가 성공적으로 삭제되었습니다',
  'pages.live.rebate.deleteFailed': '리베이트 삭제에 실패했습니다',
  'pages.live.rebate.deleteConfirm': '리베이트 삭제',
  'pages.live.rebate.deleteContent': '이 리베이트 설정을 삭제하시겠습니까?',
  'pages.live.rebate.addModalTitle': '리베이트 설정 추가',
  'pages.live.rebate.editModalTitle': '리베이트 설정 수정',
  'pages.live.rebate.liveTeamNameRequired': '라이브 팀 이름을 입력하세요',
  'pages.live.rebate.memberIdRequired': '회원 ID를 입력하세요',
  'pages.live.rebate.sellerIdRequired': '셀러 ID를 입력하세요',
  'pages.live.rebate.sellerPercentRequired': '셀러 비율을 입력하세요',
  'pages.live.rebate.companyPercentRequired': '회사 비율을 입력하세요',
  'pages.live.rebate.teamPercentRequired': '팀 비율을 입력하세요',
  'pages.live.rebate.teamRebatePercentRequired': '팀 리베이트 비율을 입력하세요',
  'pages.live.rebate.loadFailed': '리베이트 설정을 불러오는데 실패했습니다',
  'pages.live.rebate.selectAtLeastTwo': '최소 2개의 항목을 선택하세요',
  'pages.live.rebate.batchSetting': '일괄 설정',
  'pages.live.rebate.batchUpdateTitle': '백분율 일괄 수정',
  'pages.live.rebate.selectedItems': '개 항목 선택됨',
  'pages.live.rebate.applySetting': '설정 적용',
  'pages.live.rebate.cancel': '취소',
  'pages.live.rebate.batchUpdateSuccess': '일괄 수정이 성공적으로 완료되었습니다',
  'pages.live.rebate.batchUpdateFailed': '일괄 수정에 실패했습니다',
  'pages.live.rebate.searchPlaceholder': '라이브 팀 이름, 판매자 ID 또는 회원 ID로 검색',
  'pages.live.rebate.levelDetailTitle': '라이브 팀 목록',
  'pages.live.rebate.levelDetail.column.teamName': '팀 이름',
  'pages.live.rebate.levelDetail.column.depth': '레벨',
  'pages.live.rebate.levelDetail.column.userUniqueId': '사서함',
  'pages.live.rebate.levelDetail.column.userId': '회원 ID',
  'pages.live.rebate.levelDetail.column.userName': '판매자 닉네임',
  'pages.live.rebate.levelDetail.column.subordinateSellerCount': '하위 팀원',
  'pages.live.rebate.levelDetail.column.salesAmountKrw': '팀 판매 금액',
  'pages.live.rebate.levelDetail.column.ownSalesAmountKrw': '본인 판매 금액',
  'pages.live.rebate.levelDetail.column.subordinateSalesAmountKrw': '하위 셀러 판매 금액',
  'pages.live.rebate.levelDetail.split.own': '본인',
  'pages.live.rebate.levelDetail.split.team': '팀',
  'pages.live.rebate.levelDetail.column.marginAmountKrw': '마진 금액',
  'pages.live.rebate.levelDetail.column.salesQuantity': '판매 수량',
  'pages.live.rebate.levelDetail.column.refundAmountKrw': '환불 금액 (원)',
  'pages.live.rebate.levelDetail.column.refundQuantity': '환불 수량',
  'pages.live.rebate.levelDetail.column.teamRebateAccruedKrw': '팀 리베이트 적립 (원)',
  'pages.live.rebate.levelDetail.column.teamRebateDeductedKrw': '팀 리베이트 차감 (원)',
  'pages.live.rebate.levelDetail.column.rebateAccruedKrw': '리베이트 적립 (원)',
  'pages.live.rebate.levelDetail.column.rebateGrossAccruedKrw': '회수 전 총 적립 (원)',
  'pages.live.rebate.levelDetail.column.rebateDeductedKrw': '리베이트 차감 (원)',
  'pages.live.rebate.levelDetail.column.teamRebateAfterRefundKrw': '환불 후 팀 리베이트 (원)',
  'pages.live.rebate.levelDetail.column.platformAccruedKrw': '회사 적립 (원)',
  'pages.live.rebate.levelDetail.column.platformDeductedKrw': '회사 차감 (원)',
  'pages.live.rebate.levelDetail.column.platformAfterRefundKrw': '환불 후 회사 (원)',
  'pages.live.rebate.levelDetail.column.level': '레벨',
  'pages.live.rebate.levelDetail.column.mailbox': '메',
  'pages.live.rebate.levelDetail.column.teamMemberCount': '팀 구성원 수',
  'pages.live.rebate.levelDetail.column.sellingPrice': '판매 가격',
  'pages.live.rebate.levelDetail.column.sellingQuantity': '판매 수량',
  'pages.live.rebate.levelDetail.column.companyProfit': '회사 이익',
  'pages.live.rebate.levelDetail.column.refundPrice': '환불 가격',
  'pages.live.rebate.levelDetail.column.refundAmount': '환불 금액',
  'pages.live.rebate.levelDetail.column.remountRevenue': '회사 수익',
  'pages.live.rebate.levelDetail.column.action': '작업',
  'pages.live.rebate.levelDetail.searchLabel': '검색:',
  'pages.live.rebate.levelDetail.searchPlaceholder': '판매자 ID, 회원 ID 또는 회원 이름으로 검색...',
  'pages.live.rebate.levelDetail.searchButton': '검색',
  'pages.live.rebate.levelDetail.resetButton': '초기화',
  'pages.live.rebate.levelDetail.reloadButton': '새로고침',
  'pages.live.rebate.levelDetail.detailButton': '상세',
  'pages.live.rebate.levelDetail.loadError': '라이브 리베이트 상세 데이터를 불러오는데 실패했습니다',
  'pages.live.rebate.levelDetail.level1': '레벨 1',
  'pages.live.rebate.levelDetail.level2': '레벨 2',
  'pages.live.rebate.levelDetail.level3': '레벨 3',
  'pages.live.rebate.levelDetail.level4': '레벨 4',
  'pages.live.rebate.searchLabel': '검색',
  'pages.live.rebate.search': '검색',
  'pages.live.rebate.reset': '초기화',
  'pages.live.rebate.teamLead': '팀 리더',
  'pages.live.rebate.teamLeadId': '팀 리더 ID',
  'pages.live.rebate.teamLeadIdRequired': '팀 리더 ID를 입력하세요',
  'pages.live.rebate.teamInternalSelfPercent': '팀 내부 본인 %',
  'pages.live.rebate.teamInternalSelfPercentRequired': '팀 내부 본인 비율을 입력하세요',
  'pages.live.rebate.teamInternalUplinePercent': '팀 내부 상위 %',
  'pages.live.rebate.teamRebate': '팀 리베이트',
  'pages.live.rebate.memberSettings': '팀원 설정',
  'pages.live.rebate.memberSettingsTitle': '팀원별 리베이트 설정',
  'pages.live.rebate.memberSettingsHint': '개별 셀러의 리베이트 %를 설정합니다. 저장하면 해당 셀러의 정산에는 팀 설정 대신 이 값이 사용됩니다. "미설정" 셀러는 팀 설정이 그대로 적용됩니다.',
  'pages.live.rebate.memberSource': '설정 출처',
  'pages.live.rebate.memberSourceTeamCopy': '팀 복사',
  'pages.live.rebate.memberSourceAdmin': '개별 설정',
  'pages.live.rebate.memberSourceNone': '미설정 (팀 설정 적용)',
  'pages.live.rebate.memberSourceTeamConfig': '팀 설정',
  'pages.live.rebate.memberSelfPercent': '자기 보유 %',
  'pages.live.rebate.memberSave': '저장',
  'pages.live.rebate.memberSaveSuccess': '셀러 리베이트 설정이 저장되었습니다',
  'pages.live.rebate.memberSaveFailed': '셀러 리베이트 설정 저장에 실패했습니다',
  'pages.live.rebate.memberLoadFailed': '팀원 목록을 불러오는데 실패했습니다',
  'pages.live.rebate.marginSumError': '셀러+회사+팀 %의 합은 100이어야 합니다',
  'pages.live.rebate.teamLeadTag': '팀장',
  'pages.live.rebate.teamInternalUplinePercentRequired': '팀 내부 상위 비율을 입력하세요',
  'pages.live.rebate.configuredAt': '설정 시간',
  'pages.live.rebate.configuredAtRequired': '설정 시간을 선택하세요',

  // 라이브 상품
  'pages.live.products.title': '라이브 상품 관리',  
  'pages.live.products.bulkUpdateTitle': '라이브 상품 일괄 수정',
  'pages.live.products.bulkUpdateOnlineViews': '라이브 상품 온라인 조회수 일괄 수정',
  'pages.live.products.bulkUpdateReviewScore': '라이브 상품 리뷰 점수 일괄 수정',
  'pages.live.products.bulkUpdateReviewNumbers': '라이브 상품 리뷰 수 일괄 수정',
  'pages.live.products.bulkUpdateLivePeriods': '라이브 상품 라이브 날짜/시간 일괄 수정',
  'pages.live.products.bulkUpdateIsHot': '인기상품 일괄 수정',
  'pages.live.products.bulkUpdateDescription': '선택한 {count}개 항목이 일괄 수정됩니다',
  'pages.live.products.selectedCount': '선택한 항목 {count}개',
  'pages.live.products.clearSelection': '선택 해제',
  'pages.live.products.add': '새 라이브 상품 등록',
  'pages.live.products.addTitle': '새 라이브 상품 등록',
  'pages.live.products.editTitle': '라이브 상품 수정',
  'pages.live.products.quickEdit': '빠른 수정',
  'pages.live.products.productNumber': '상품번호',
  'pages.live.products.offerId': 'OfferId',
  'pages.live.products.productName': '상품명',
  'pages.live.products.productInformation': '상품 정보',
  'pages.live.products.image': '이미지',
  'pages.live.products.video': '영상',
  'pages.live.products.liveDateTime': '라이브일시',
  'pages.live.products.liveTitle': '라이브 제목',
  'pages.live.products.onlineViews': '온라인 조회수',
  'pages.live.products.itemsSold': '판매량',
  'pages.live.products.reviewScore': '리뷰 점수',
  'pages.live.products.reviewNumbers': '리뷰 수',
  'pages.live.products.videoStatus.uploaded': '[등록]',
  'pages.live.products.videoStatus.notUploaded': '[미등록]',
  'pages.live.products.status': '상태',
  'pages.live.products.status.scheduled': '○ 라이브예정',
  'pages.live.products.status.live': '● 라이브중',
  'pages.live.products.status.completed': '○ 라이브완료',
  'pages.live.products.status.cancelled': '○ 취소됨',
  'pages.live.products.isHot': '인기상품',
  'pages.live.products.setHot': '인기상품 설정',
  'pages.live.products.removeHot': '인기상품 해제',
  'pages.live.products.updatedAt': '수정일시',
  'pages.live.products.manage': '관리',
  'pages.live.products.edit': '수정',
  'pages.live.products.delete': '삭제',
  'pages.live.products.deleteConfirm': '상품 삭제',
  'pages.live.products.deleteContent': '이 라이브 상품을 삭제하시겠습니까?',
  'pages.live.products.deleteSuccess': '상품이 삭제되었습니다',
  'pages.live.products.deleteFailed': '삭제에 실패했습니다',
  'pages.live.products.loadFailed': '상품 목록을 불러오는데 실패했습니다',
  'pages.live.products.createSuccess': '상품이 등록되었습니다',
  'pages.live.products.updateSuccess': '상품이 수정되었습니다',
  'pages.live.products.saveFailed': '작업에 실패했습니다',
  'pages.live.products.bulkUpdate.liveTitleRequired': '라이브 제목을 입력해주세요',
  'pages.live.products.bulkUpdate.onlineViewsRequired': '온라인 조회수를 입력해주세요',
  'pages.live.products.bulkUpdate.reviewScoreRequired': '리뷰 점수를 입력해주세요',
  'pages.live.products.bulkUpdate.reviewNumbersRequired': '리뷰 수를 입력해주세요',
  'pages.live.products.bulkUpdate.isHotRequired': '인기상품 여부를 선택해주세요',
  
  // 라이브 상품 폼
  'pages.live.products.form.product': '상품',
  'pages.live.products.form.productPlaceholder': '상품 번호 또는 이름으로 검색',
  'pages.live.products.form.productRequired': '상품을 선택해주세요',
  'pages.live.products.form.searchFailed': '상품 검색에 실패했습니다',
  'pages.live.products.form.productNumber': '상품 번호',
  'pages.live.products.form.productNumberPlaceholder': 'P00123',
  'pages.live.products.form.productNumberRequired': '상품 번호를 입력해주세요',
  'pages.live.products.form.liveDate': '라이브 날짜',
  'pages.live.products.form.liveDatePeriod': '라이브 기간',
  'pages.live.products.form.liveLink': '라이브 방송 URL',
  'pages.live.products.form.liveLinkPlaceholder': '라이브 방송 URL 입력',
  'pages.live.products.form.liveDateRequired': '날짜를 선택해주세요',
  'pages.live.products.form.startTime': '시작 시간',
  'pages.live.products.form.startTimeRequired': '시작 시간을 선택해주세요',
  'pages.live.products.form.endTime': '종료 시간',
  'pages.live.products.form.title': '라이브 제목',
  'pages.live.products.form.titlePlaceholder': '신상 운동화 특가',
  'pages.live.products.form.titleRequired': '제목을 입력해주세요',
  'pages.live.products.form.onlineViews': '온라인 조회수',
  'pages.live.products.form.onlineViewsPlaceholder': '온라인 조회수 입력',
  'pages.live.products.form.itemsSold': '판매량',
  'pages.live.products.form.itemsSoldPlaceholder': '판매량 입력',
  'pages.live.products.form.reviewScore': '리뷰 점수',
  'pages.live.products.form.reviewScorePlaceholder': '리뷰 점수 입력 (0-5)',
  'pages.live.products.form.reviewNumbers': '리뷰 수',
  'pages.live.products.form.reviewNumbersPlaceholder': '리뷰 수 입력',
  'pages.live.products.form.image': '이미지',
  'pages.live.products.form.uploadImage': '이미지 업로드',
  'pages.live.products.form.videoUrl': '영상',
  'pages.live.products.form.uploadVideo': '영상 업로드',
  'pages.live.products.form.uploadMedia': '영상/이미지 업로드',
  'pages.live.products.form.videoUrlPlaceholder': 'https://...',
  'pages.live.products.form.imageUrl': '이미지 URL',
  'pages.live.products.form.imageUrlPlaceholder': 'https://...',
  'pages.live.products.form.status': '상태',
  'pages.live.products.form.statusRequired': '상태를 선택해주세요',
  'pages.live.products.form.submit': '등록',
  'pages.live.products.form.cancel': '취소',

  // Live Page Settings
  'pages.live.pageSettings.title': '라이브 페이지 설정',
  'pages.live.pageSettings.visible': '노출',
  'pages.live.pageSettings.hidden': '숨김',
  'pages.live.pageSettings.col.actions': '작업',
  'pages.live.pageSettings.schedules.tab': '라이브 일정',
  'pages.live.pageSettings.schedules.add': '일정 추가',
  'pages.live.pageSettings.schedules.addTitle': '라이브 일정 추가',
  'pages.live.pageSettings.schedules.editTitle': '라이브 일정 수정',
  'pages.live.pageSettings.schedules.col.title': '제목',
  'pages.live.pageSettings.schedules.col.seller': '셀러',
  'pages.live.pageSettings.schedules.col.time': '일정 시간',
  'pages.live.pageSettings.schedules.col.startTime': '시작 시간',
  'pages.live.pageSettings.schedules.col.endTime': '마감 시간',
  'pages.live.pageSettings.schedules.endAfterStart': '마감 시간은 시작 시간 이후여야 합니다',
  'pages.live.pageSettings.schedules.col.visible': '노출 여부',
  'pages.live.pageSettings.schedules.sellerPlaceholder': '셀러 검색',
  'pages.live.pageSettings.schedules.created': '라이브 일정이 추가되었습니다',
  'pages.live.pageSettings.schedules.updated': '라이브 일정이 수정되었습니다',
  'pages.live.pageSettings.schedules.deleted': '라이브 일정이 삭제되었습니다',
  'pages.live.pageSettings.schedules.saveFailed': '일정 저장에 실패했습니다',
  'pages.live.pageSettings.schedules.deleteFailed': '일정 삭제에 실패했습니다',
  'pages.live.pageSettings.schedules.deleteConfirm': '이 라이브 일정을 삭제하시겠습니까?',
  'pages.live.pageSettings.reels.tab': '라이브 릴스',
  'pages.live.sections.tab': '섹션 구성',
  'pages.live.sections.add': '섹션 추가',
  'pages.live.sections.addTitle': '섹션 추가',
  'pages.live.sections.editTitle': '섹션 편집',
  'pages.live.sections.saved': '섹션을 저장했습니다',
  'pages.live.sections.saveFailed': '섹션 저장에 실패했습니다',
  'pages.live.sections.loadFailed': '섹션 목록을 불러오지 못했습니다',
  'pages.live.sections.reordered': '순서를 변경했습니다',
  'pages.live.sections.reorderFailed': '순서 변경에 실패했습니다',
  'pages.live.sections.deleted': '섹션을 삭제했습니다',
  'pages.live.sections.deleteFailed': '섹션 삭제에 실패했습니다',
  'pages.live.sections.deleteConfirm': '이 섹션을 삭제할까요?',
  'pages.live.sections.dragHint': '손잡이를 끌어 순서를 바꿉니다',
  'pages.live.sections.autoOnlyHint': '이 유형은 다른 화면에서 관리하는 자료를 규칙으로 가져옵니다. 직접 고르기는 상품·셀러·배너·타임세일·쿠폰·문구 띠 섹션에서 쓸 수 있습니다.',
  'pages.live.sections.column.title': '섹션',
  'pages.live.sections.column.untitled': '(제목 없음)',
  'pages.live.sections.column.type': '유형',
  'pages.live.sections.column.source': '내용 구성',
  'pages.live.sections.column.items': '항목',
  'pages.live.sections.column.itemCount': '{count}개 지정',
  'pages.live.sections.column.limitCount': '최대 {count}개',
  'pages.live.sections.column.device': '기기',
  'pages.live.sections.column.visible': '노출',
  'pages.live.sections.group.basic': '기본 정보',
  'pages.live.sections.group.content': '내용 구성',
  'pages.live.sections.group.style': '표시 방식',
  'pages.live.sections.field.key': '섹션 키',
  'pages.live.sections.field.keyHint': '영문 소문자·숫자·하이픈만 (예: today-live-pick)',
  'pages.live.sections.field.type': '유형',
  'pages.live.sections.field.title': '제목',
  'pages.live.sections.field.subtitle': '부제',
  'pages.live.sections.field.layout': '배치',
  'pages.live.sections.field.device': '기기',
  'pages.live.sections.field.itemLimit': '노출 개수',
  'pages.live.sections.field.isVisible': '노출',
  'pages.live.sections.field.moreLink': '더보기 링크',
  'pages.live.sections.field.period': '노출 기간',
  'pages.live.sections.field.periodHint': '비워 두면 계속 노출됩니다',
  'pages.live.sections.field.sourceMode': '내용 구성',
  'pages.live.sections.field.backgroundColor': '배경색',
  'pages.live.sections.field.fullBleed': '화면 전체 너비',
  'pages.live.sections.sourceMode.auto': '조건으로 자동',
  'pages.live.sections.sourceMode.manual': '직접 고르기',
  'pages.live.sections.type.heroLive': '대형 라이브',
  'pages.live.sections.type.liveNow': '지금 방송중',
  'pages.live.sections.type.schedule': '라이브 편성표',
  'pages.live.sections.type.reels': '라이브 릴',
  'pages.live.sections.type.sellerRail': '셀러 목록',
  'pages.live.sections.type.productRail': '상품 가로목록',
  'pages.live.sections.type.productGrid': '상품 격자',
  'pages.live.sections.type.ranking': '랭킹',
  'pages.live.sections.type.categoryTabs': '카테고리 탭',
  'pages.live.sections.type.banner': '배너',
  'pages.live.sections.type.eventTicker': '이벤트 띠',
  'pages.live.sections.type.timeSale': '타임세일',
  'pages.live.sections.type.coupon': '쿠폰',
  'pages.live.sections.type.ticker': '문구 띠',
  'pages.live.sections.layout.hero': '대형',
  'pages.live.sections.layout.rail': '가로 스크롤',
  'pages.live.sections.layout.grid': '격자',
  'pages.live.sections.layout.list': '목록',
  'pages.live.sections.layout.banner': '배너',
  'pages.live.sections.device.all': '전체',
  'pages.live.sections.device.pc': 'PC',
  'pages.live.sections.device.mobile': '모바일',
  'pages.live.sections.filter.productFlags': '상품 조건',
  'pages.live.sections.filter.sellerFlags': '셀러 조건',
  'pages.live.sections.filter.categories': '카테고리',
  'pages.live.sections.filter.categoryTabsHint': '비워 두면 활성 대분류 전체를 탭으로 보여줍니다',
  'pages.live.sections.filter.simpleAutoHint':
    '이 유형은 진행 중인 목록에서 자동으로 채웁니다 — 노출 개수와 정렬만 정하면 됩니다',
  'pages.live.sections.filter.liveState': '방송 상태',
  'pages.live.sections.filter.sortBy': '정렬',
  'pages.live.sections.filter.flagPopular': '인기',
  'pages.live.sections.filter.flagPoint': '포인트',
  'pages.live.sections.filter.sortRank': '순위',
  'pages.live.sections.filter.flag_isPopular': '인기',
  'pages.live.sections.filter.flag_isFeatured': '추천',
  'pages.live.sections.filter.flag_isBestSeller': '베스트',
  'pages.live.sections.filter.flag_isNewArrival': '신상',
  'pages.live.sections.filter.flag_isImportant': '상단 고정',
  'pages.live.sections.filter.flag_isPoint': '포인트 파트너',
  'pages.live.sections.filter.liveState_all': '전체',
  'pages.live.sections.filter.liveState_live': '방송중',
  'pages.live.sections.filter.liveState_scheduled': '방송 예정',
  'pages.live.sections.filter.liveState_recent': '최근 종료',
  'pages.live.sections.filter.sortBy_recent': '최신순',
  'pages.live.sections.filter.sortBy_sold': '판매순',
  'pages.live.sections.filter.sortBy_price_asc': '낮은 가격순',
  'pages.live.sections.filter.sortBy_price_desc': '높은 가격순',
  'pages.live.sections.filter.sortBy_rank': '순위순',
  'pages.live.sections.filter.sortBy_views': '조회순',
  'pages.live.sections.items.remove': '빼기',
  'pages.live.sections.items.bannerRow': '배너 {index}',
  'pages.live.sections.items.imagePc': 'PC 이미지',
  'pages.live.sections.items.imageMobile': '모바일 이미지',
  'pages.live.sections.items.linkUrl': '링크',
  'pages.live.sections.items.caption': '문구',
  'pages.live.sections.items.addProduct': '상품 고르기',
  'pages.live.sections.items.addSeller': '셀러 고르기',
  'pages.live.sections.items.addBanner': '배너 추가',
  'pages.live.sections.items.addTimeSale': '타임세일 고르기',
  'pages.live.sections.items.addCoupon': '쿠폰 고르기',
  'pages.live.sections.items.addMetric': '문구 줄 추가',
  'pages.live.sections.items.metricRow': '문구 {index}',
  'pages.live.sections.items.metricCaption': '띠에 보일 문구',
  'pages.live.sections.items.metricLink': '링크',
  'pages.live.sections.items.timeSaleHidden': '비공개',
  'pages.live.sections.items.metricCaptionRequired': '{index}번 문구 줄에 최소 한 언어는 채워 주세요',
  'pages.live.sections.items.count': '{count} / {max}개',
  'pages.live.sections.items.empty': '아직 담은 항목이 없습니다',
  'pages.live.sections.picker.loadFailed': '목록을 불러오지 못했습니다',
  'pages.live.sections.picker.productTitle': '라이브 상품 고르기',
  'pages.live.sections.picker.sellerTitle': '라이브 셀러 고르기',
  'pages.live.sections.picker.confirm': '담기',
  'pages.live.sections.picker.searchPlaceholder': '상품명 · 상품번호 검색',
  'pages.live.sections.picker.sellerSearchPlaceholder': '셀러명 검색',
  'pages.live.sections.picker.image': '이미지',
  'pages.live.sections.picker.product': '상품',
  'pages.live.sections.picker.productNo': '상품번호',
  'pages.live.sections.picker.uniqueNo': '고유번호',
  'pages.live.sections.picker.seller': '셀러',
  'pages.live.sections.picker.sellerId': '셀러 ID',
  'pages.live.sections.picker.sellerFlags': '구분',
  // Live Time Sales
  'pages.live.timeSales.tab': '타임세일',
  'pages.live.timeSales.add': '타임세일 추가',
  'pages.live.timeSales.addTitle': '타임세일 추가',
  'pages.live.timeSales.editTitle': '타임세일 수정',
  'pages.live.timeSales.dragHint': '손잡이를 끌어 순서를 바꿉니다',
  'pages.live.timeSales.loadFailed': '타임세일 목록을 불러오지 못했습니다',
  'pages.live.timeSales.saved': '저장했습니다',
  'pages.live.timeSales.saveFailed': '저장에 실패했습니다',
  'pages.live.timeSales.deleteConfirm': '이 타임세일을 삭제할까요?',
  'pages.live.timeSales.deleted': '삭제했습니다',
  'pages.live.timeSales.deleteFailed': '삭제에 실패했습니다',
  'pages.live.timeSales.reordered': '순서를 변경했습니다',
  'pages.live.timeSales.reorderFailed': '순서 변경에 실패했습니다',
  'pages.live.timeSales.column.product': '상품',
  'pages.live.timeSales.column.title': '세일 제목',
  'pages.live.timeSales.column.period': '기간',
  'pages.live.timeSales.column.progress': '판매 진행률',
  'pages.live.timeSales.column.salePrice': '세일가',
  'pages.live.timeSales.column.visible': '노출',
  'pages.live.timeSales.column.untitled': '제목 없음',
  'pages.live.timeSales.status.scheduled': '예정',
  'pages.live.timeSales.status.running': '진행 중',
  'pages.live.timeSales.status.ended': '종료',
  'pages.live.timeSales.progress.text': '{sold} / {target}개',
  'pages.live.timeSales.salePrice.useProductPrice': '상품 가격 사용',
  'pages.live.timeSales.form.product': '상품',
  'pages.live.timeSales.form.productRequired': '상품을 선택해 주세요',
  'pages.live.timeSales.form.pickProduct': '상품 선택',
  'pages.live.timeSales.form.changeProduct': '상품 변경',
  'pages.live.timeSales.form.pickOneOnly': '타임세일에는 상품을 하나만 담습니다. 첫 번째 상품으로 설정했습니다',
  'pages.live.timeSales.form.noProduct': '선택된 상품 없음',
  'pages.live.timeSales.form.title': '세일 제목',
  'pages.live.timeSales.form.titlePlaceholder': '예: 오늘의 타임세일',
  'pages.live.timeSales.form.period': '세일 기간',
  'pages.live.timeSales.form.periodRequired': '시작·종료 시각을 모두 입력해 주세요',
  'pages.live.timeSales.form.periodInvalid': '종료 시각은 시작 시각보다 뒤여야 합니다',
  'pages.live.timeSales.form.targetQuantity': '목표 수량',
  'pages.live.timeSales.form.soldQuantity': '판매 수량',
  'pages.live.timeSales.form.salePrice': '세일가 (원)',
  'pages.live.timeSales.form.salePriceHint': '비워 두면 상품 가격을 그대로 씁니다',
  'pages.live.timeSales.form.isVisible': '노출',
  'pages.live.pageSettings.reels.add': '릴스 추가',
  'pages.live.pageSettings.reels.addTitle': '라이브 릴스 추가',
  'pages.live.pageSettings.reels.editTitle': '라이브 릴스 수정',
  'pages.live.pageSettings.reels.col.cover': '대표 이미지',
  'pages.live.pageSettings.reels.col.title': '제목',
  'pages.live.pageSettings.reels.col.seller': '셀러',
  'pages.live.pageSettings.reels.col.watchUserCount': '시청자 수',
  'pages.live.pageSettings.reels.col.scheduledDate': '날짜',
  'pages.live.pageSettings.reels.col.time': '시간',
  'pages.live.pageSettings.reels.col.video': '동영상',
  'pages.live.pageSettings.reels.col.showOnFrontend': '노출',
  'pages.live.pageSettings.reels.timeFrom': '시작',
  'pages.live.pageSettings.reels.timeTo': '종료',
  'pages.live.pageSettings.reels.imageSection': '대표 이미지',
  'pages.live.pageSettings.reels.videoSection': '동영상',
  'pages.live.pageSettings.reels.imageUrl': '이미지 URL',
  'pages.live.pageSettings.reels.videoUrl': '동영상 URL',
  'pages.live.pageSettings.reels.uploadImage': '이미지 업로드',
  'pages.live.pageSettings.reels.uploadVideo': '동영상 업로드',
  'pages.live.pageSettings.reels.clearFile': '업로드 파일 삭제',
  'pages.live.pageSettings.reels.open': '열기',
  'pages.live.pageSettings.reels.created': '릴스가 추가되었습니다',
  'pages.live.pageSettings.reels.updated': '릴스가 수정되었습니다',
  'pages.live.pageSettings.reels.deleted': '릴스가 삭제되었습니다',
  'pages.live.pageSettings.reels.saveFailed': '릴스 저장에 실패했습니다',
  'pages.live.pageSettings.reels.deleteFailed': '릴스 삭제에 실패했습니다',
  'pages.live.pageSettings.reels.deleteConfirm': '이 릴스를 삭제하시겠습니까?',

  // ── [레인 J5] M2 §5-2·§5-3 숏클립/타임세일 카드 문구·상품 연결 ──────────
  'pages.live.pageSettings.reels.col.cardText': '카드 문구',
  'pages.live.pageSettings.reels.col.product': '연결 상품',
  'pages.live.pageSettings.reels.cardSection': '카드 문구 · 연결 상품',
  'pages.live.pageSettings.reels.product': '연결 상품',
  'pages.live.pageSettings.reels.productHint':
    '이 클립이 홍보하는 상품입니다. 비워 두면 상품을 연결하지 않습니다',
  'pages.live.pageSettings.reels.noProduct': '선택된 상품 없음',
  'pages.live.pageSettings.reels.pickProduct': '상품 선택',
  'pages.live.pageSettings.reels.changeProduct': '상품 변경',
  'pages.live.pageSettings.reels.clearProduct': '연결 해제',
  'pages.live.pageSettings.reels.pickOneOnly':
    '숏클립에는 상품을 하나만 연결합니다. 첫 번째 상품으로 설정했습니다',
  'pages.live.pageSettings.reels.priceLabel': '가격 문구',
  'pages.live.pageSettings.reels.priceLabelHint':
    '계산된 금액이 아니라 카드에 그대로 나가는 문구입니다 (최대 60자)',
  'pages.live.pageSettings.reels.priceLabelPlaceholder': '39,000원~',
  'pages.live.pageSettings.reels.caption': '캡션',
  'pages.live.pageSettings.reels.captionHint': '클립 아래에 표시되는 문구입니다',
  'pages.live.pageSettings.reels.captionPlaceholder': '예: 겨울 신상 라이브',
  'pages.live.pageSettings.reels.eventText': '이벤트 문구',
  'pages.live.pageSettings.reels.eventTextHint': '카드에 주황색으로 표시되는 줄입니다',
  'pages.live.pageSettings.reels.eventTextPlaceholder': '예: 선착순 100명 사은품',
  'pages.live.timeSales.column.cardText': '카드 문구',
  'pages.live.timeSales.form.products': '상품 (최대 2개)',
  'pages.live.timeSales.form.productsHint':
    '카드 한 장에 상품을 최대 2개까지 올립니다. 상품 선택을 누르면 고른 결과가 목록을 대체합니다',
  'pages.live.timeSales.form.removeProduct': '이 상품 빼기',
  'pages.live.timeSales.form.tooManyProducts': '상품은 최대 {max}개까지 담을 수 있습니다',
  'pages.live.timeSales.form.caption': '캡션',
  'pages.live.timeSales.form.captionHint': '카드 캡션 줄입니다 (언어당 200자)',
  'pages.live.timeSales.form.captionPlaceholder': '예: 오늘만 이 가격',
  'pages.live.timeSales.form.eventText': '이벤트 문구',
  'pages.live.timeSales.form.eventTextHint': '카드에 주황색으로 표시되는 줄입니다 (언어당 200자)',
  'pages.live.timeSales.form.eventTextPlaceholder': '예: 구매 시 사은품 증정',
  // ── [레인 J5] 끝 ──────────────────────────────────────────────────────

  // ── 프론트 페이지 설정 (M2, /operation/frontend-pages) ──────────────────
  // 화면 전체가 쓰는 공통 문구만 먼저 둔다. 섹션 편집·라이브 일정·스토어 등
  // 세부 키는 각 레인이 확정한 뒤 이 블록 아래에 이어 붙인다.
  'pages.frontendPages.carousel.changeImage': '이미지 바꾸기',
  'pages.frontendPages.carousel.clearImage': '고른 파일 지우기',
  'pages.frontendPages.carousel.heavyImage': '이미지가 무겁습니다. 더 작게 올리는 편이 좋습니다.',
  'pages.frontendPages.carousel.imagePicked': '이미지를 골랐습니다. 저장해야 반영됩니다.',
  'pages.frontendPages.carousel.notImage': '이미지 파일만 올릴 수 있습니다.',
  'pages.frontendPages.carousel.recommendSize': '권장',
  'pages.frontendPages.carousel.tooLarge': '파일이 너무 큽니다.',
  'pages.frontendPages.carousel.variants': '변형',
  'pages.frontendPages.items.cropHint': '카드에서는 주황 점선 안쪽만 보입니다.',
  'pages.frontendPages.items.heavyImage': '이미지가 무겁습니다. 더 작게 올리는 편이 좋습니다.',
  'pages.frontendPages.items.pickerAction': '작업',
  'pages.frontendPages.items.pickerAdd': '담기',
  'pages.frontendPages.items.pickerAddOnlyHint': '이 창은 담기만 합니다. 담은 카드를 빼려면 목록에서 지우세요.',
  'pages.frontendPages.items.pickerAlreadyAdded': '담김',
  'pages.frontendPages.items.pickerClose': '닫기',
  'pages.frontendPages.items.pickerExcludedReason': '이 슬롯의 상품 범위에 맞지 않아 담을 수 없습니다.',
  'pages.frontendPages.items.pickerFull': '슬롯이 다 찼습니다. 카드를 빼거나 숨기면 더 담을 수 있습니다.',
  'pages.frontendPages.items.pickerTrimmed': '슬롯 상한을 넘어 {count}개는 담지 않았습니다(최대 {max}개).',
  'pages.frontendPages.items.recommendSize': '권장',
  'pages.frontendPages.items.removeUnlistedBody': '이 카드가 가리키는 대상이 목록에 없어 이름을 확인할 수 없습니다. 그래도 지울까요?',
  'pages.frontendPages.items.removeUnlistedTitle': '무엇인지 확인할 수 없는 카드입니다',
  'pages.frontendPages.items.replaceSeller': '셀러 바꾸기',
  'pages.frontendPages.items.unlistedCoupon': '(목록에 없는 쿠폰) {id}',
  'pages.frontendPages.items.unlistedSession': '(목록에 없는 지난 세션) {id}',
  'pages.frontendPages.items.unlistedSessionHint': '이미 끝난 세션이라 목록에 없습니다. 셀러·시간·상품 수는 확인할 수 없지만 카드는 프론트에 그대로 나갑니다.',
  'pages.frontendPages.items.unlistedTimeSale': '(목록에 없는 지난 타임세일) {id}',
  'pages.frontendPages.items.unlistedTimeSaleHint': '이미 끝난 타임세일이라 목록에 없습니다. 제목은 확인할 수 없습니다.',
  'pages.frontendPages.items.variants': '변형',
  'pages.frontendPages.schedule.unsavedBody': '닫으면 지금까지 고친 내용이 사라집니다. 닫을까요?',
  'pages.frontendPages.schedule.unsavedDiscard': '닫기',
  'pages.frontendPages.schedule.unsavedKeep': '계속 편집',
  'pages.frontendPages.schedule.unsavedTitle': '저장하지 않은 변경이 있습니다',
  'pages.frontendPages.slots.removeConfirmBody': '이 슬롯의 카드 {count}장이 함께 빠집니다.',
  'pages.frontendPages.slots.removeConfirmOk': '지우기',
  'pages.frontendPages.slots.removeConfirmTitle': '이 슬롯을 지울까요?',
  'pages.frontendPages.title': '프론트 페이지 설정',
  'pages.frontendPages.page.site': '공통',
  'pages.frontendPages.page.home': '추천',
  'pages.frontendPages.page.overseas': '해외직구',
  'pages.frontendPages.page.live': '라이브',
  'pages.frontendPages.page.ownmall': '자사몰',
  'pages.frontendPages.tab.sections': '섹션 구성',
  'pages.frontendPages.tab.settings': '페이지 설정',
  'pages.frontendPages.tab.schedule': '라이브 일정',
  'pages.frontendPages.tab.reels': '숏클립',
  'pages.frontendPages.tab.timeSales': '타임세일',
  'pages.frontendPages.tab.layout': '페이지 구성',
  'pages.frontendPages.canvas.introHome': '추천 페이지에 보이는 순서입니다. 블록을 열어 그 자리의 이미지·상품·문구를 고칩니다.',
  'pages.frontendPages.canvas.introLive': '라이브 페이지에 보이는 순서입니다. 방송 일정은 라이브 셀러 캐러셀 블록의 [라이브 일정 열기]에서, 나머지 블록은 각 자리의 편집으로 고칩니다.',
  'pages.frontendPages.canvas.laterPages': '해외직구 페이지 본문은 이번 작업 범위가 아닙니다. 섹션은 그대로 둘 수 있습니다.',
  'pages.frontendPages.canvas.introOwnmall': '자사몰 페이지에 보이는 순서입니다. 블록을 열어 그 자리의 이미지·상품·문구를 고칩니다.',
  'pages.frontendPages.canvas.introOverseas': '해외직구 페이지에 보이는 순서입니다. 블록을 열어 그 자리의 이미지·상품·문구를 고칩니다.',
  'pages.frontendPages.canvas.block.overseasHero.title': '히어로 (배너 + 캐러셀 + 배너)',
  'pages.frontendPages.canvas.block.overseasHero.desc': '왼쪽·오른쪽 이미지 배너 한 장씩과 가운데 캐러셀입니다. 오른쪽은 "오른쪽 위" 칸의 첫 카드를 씁니다.',
  'pages.frontendPages.canvas.block.ovBest.title': '지금 많이 찾는 상품 (3열)',
  'pages.frontendPages.canvas.block.ovBest.desc': '1688 · 타오바오 · VVIC 세 열입니다. 열마다 외부 상품 카드 2장을 담고, 타오바오·VVIC 열은 순위 카드로 나갑니다.',
  'pages.frontendPages.canvas.block.overseasMarket.title': '공급처별 카테고리 상품',
  'pages.frontendPages.canvas.block.overseasMarket.desc': '공급처 탭(1688·타오바오·VVIC) → 카테고리 칩 → 하위 탭 → 상품 레일입니다. 칩은 카테고리 관리의 카테고리를 고르고, 카드는 상품 링크나 수동 입력으로 넣습니다. 카드가 없는 칩은 카테고리 이름으로 그 플랫폼을 검색한 결과를 보여 줍니다.',
  'pages.frontendPages.canvas.block.overseasMore.title': '더 많은 상품 보기',
  'pages.frontendPages.canvas.block.overseasMore.desc': '1688 신상품 피드를 계속 더 불러오는 격자입니다. 제목과 처음 몇 개, 더보기 클릭당 몇 개를 고칩니다.',
  'pages.frontendPages.canvas.block.ownmallHero.title': '히어로 (배너 + 캐러셀 + 프로모 카드)',
  'pages.frontendPages.canvas.block.ownmallHero.desc': '왼쪽 큰 이미지 배너, 가운데 캐러셀, 오른쪽 프로모 카드 2장(작은 줄·굵은 줄·작은 줄 + 아이콘)입니다.',
  'pages.frontendPages.canvas.block.ownmallStores.title': '오늘의 추천 스토어',
  'pages.frontendPages.canvas.block.ownmallStores.desc': '자사몰 스토어 카드입니다. 더보기 링크가 오른쪽 "전체보기"가 됩니다.',
  'pages.frontendPages.canvas.block.ownmallPopular.title': '인기상품 (탭)',
  'pages.frontendPages.canvas.block.ownmallPopular.desc': '칩 하나가 탭 하나입니다. 탭마다 상품 조건(추천·신상·인기…)을 고르면 그 조건의 상품이 레일로 나갑니다.',
  'pages.frontendPages.canvas.block.ownmallCategories.title': '카테고리 띠 + 카테고리 상품',
  'pages.frontendPages.canvas.block.ownmallCategories.desc': '자사몰 페지의 카테고리 줄(동그란 카테고리 버튼)과, 그 아래 고른 카테고리의 하위 탭·상품 줄입니다. 카테고리를 하나도 넣지 않으면 1단계 카테고리가 모두 자동으로 나갑니다.',
  'pages.frontendPages.canvas.block.ownmallMore.title': '더 많은 상품 보기',
  'pages.frontendPages.canvas.block.ownmallMore.desc': '자사몰 상품을 계속 더 불러오는 격자입니다. 제목과 처음 몇 개, 더보기 클릭당 몇 개를 고칩니다.',
  'pages.frontendPages.canvas.visible': '노출',
  'pages.frontendPages.canvas.hidden': '숨김',
  'pages.frontendPages.canvas.missing': '아직 없음',
  'pages.frontendPages.canvas.cardCount': '카드 {cards}/{total}',
  'pages.frontendPages.canvas.edit': '이 블록 편집',
  'pages.frontendPages.canvas.create': '이 블록 만들기',
  'pages.frontendPages.canvas.showSchedule': '라이브 일정 열기',
  'pages.frontendPages.canvas.hideSchedule': '라이브 일정 접기',
  'pages.frontendPages.canvas.extras': '기타 블록 (릴스·타임세일 등)',
  'pages.frontendPages.canvas.extrasHint': '시안에 없는 옛 밴드입니다. 켜 둔 것만 프론트에 나갑니다.',
  'pages.frontendPages.canvas.extraName.liveHeroM': '상단 배너',
  'pages.frontendPages.canvas.extraName.liveWideBanners': '와이드 배너',
  'pages.frontendPages.canvas.deviceOnly.mobile': '모바일 전용',
  'pages.frontendPages.canvas.deviceOnly.pc': 'PC 전용',
  'pages.frontendPages.canvas.advanced': '고급: 밴드 목록으로 편집',
  'pages.frontendPages.canvas.empty': '이 페이지에 정해 둔 블록이 없습니다.',
  'pages.frontendPages.canvas.editHint': '시안 자리의 제목·상품·이미지를 고칩니다. 밴드 키와 타입은 바꾸지 않습니다.',
  'pages.frontendPages.canvas.block.hero.title': '히어로 (LIVE CHANNEL · 캐러셀 · 인기 신상)',
  'pages.frontendPages.canvas.block.hero.desc': '왼쪽 LIVE CHANNEL 카드, 가운데 배너 캐러셀, 오른쪽 인기 신상·자사몰 인기 상품. 라벨·아이콘·상품을 여기서 고칩니다.',
  'pages.frontendPages.canvas.block.homeCats.title': '카테고리 그룹',
  'pages.frontendPages.canvas.block.homeCats.desc': '왼쪽 HOT 그룹을 고르면 오른쪽 원형 카테고리가 바뀝니다. 각 원은 이미지·제목·검색 링크입니다.',
  'pages.frontendPages.canvas.block.liveBest.title': '라이브 인기 상품',
  'pages.frontendPages.canvas.block.liveBest.desc': '세 열의 제목과 상품입니다. 라이브 상품과 자사몰 상품을 담을 수 있습니다. 상품을 담을 때 랜딩 이미지를 올리면 카드와 상세 첫 장에 같이 쓰입니다.',
  'pages.frontendPages.canvas.block.homeStores.title': '오늘의 추천 스토어',
  'pages.frontendPages.canvas.block.homeStores.desc': '자사몰 스토어 카드입니다. 원형·메인 이미지와 추천 노출·대표 상품은 스토어 관리와 상품 목록에서도 고칠 수 있습니다.',
  'pages.frontendPages.canvas.block.overseasBest.title': '해외직구 많이 찾는 상품',
  'pages.frontendPages.canvas.block.overseasBest.desc': '열 제목과 상품 이미지·제목·가격·할인가·링크를 고칩니다.',
  'pages.frontendPages.canvas.block.more.title': '더 많은 상품 보기',
  'pages.frontendPages.canvas.block.more.desc': '제목과 처음 몇 개, 더보기 클릭당 몇 개를 더 보여줄지(초기 개수·더보기 개수)를 고칩니다.',
  'pages.frontendPages.canvas.block.spotlight.title': '라이브 셀러 캐러셀',
  'pages.frontendPages.canvas.block.spotlight.desc': '가운데 셀러의 메인 이미지·시간·제목·슬로건·대표 상품 3개입니다. 옆 화살표로 다른 셀러가 가운데로 옵니다.',
  'pages.frontendPages.canvas.block.liveCats.title': '라이브 카테고리 그룹',
  'pages.frontendPages.canvas.block.liveCats.desc': '추천 페이지와 같은 모양이지만 설정은 따로입니다. 원을 누르면 라이브 상품 검색으로 갑니다.',
  'pages.frontendPages.canvas.block.chance.title': '라이브 찬스',
  'pages.frontendPages.canvas.block.chance.desc': '필터 칩과 정렬, 지금 볼 수 있는 라이브 카드 그리드입니다.',
  'pages.frontendPages.canvas.block.liveBestSellers.title': '인기 BEST 셀러',
  'pages.frontendPages.canvas.block.liveBestSellers.desc': '셀러를 담으면 그 순서로 나갑니다. 비우면 누적 시청순(또는 판매순)으로 자동으로 채웁니다. 카드 아래 상품은 셀러마다 고를 수 있습니다.',
  'pages.frontendPages.canvas.block.liveRanking.title': '쇼핑라이브 인기 상품 랭킹',
  'pages.frontendPages.canvas.block.liveRanking.desc': '기간 탭(오늘·3일·1주일)과 순위가 있는 상품 그리드입니다. 탭은 manual 모드에서 동작합니다.',
  'pages.frontendPages.canvas.block.liveStores.title': '오늘의 추천 스토어 (라이브)',
  'pages.frontendPages.canvas.block.liveStores.desc': '라이브 페이지에 올릴 자사몰 스토어 레일입니다. 추천 페이지와 목록을 따로 둘 수 있습니다.',
  'pages.frontendPages.canvas.block.liveBanners.title': '와이드 하이라이트 배너',
  'pages.frontendPages.canvas.block.liveBanners.desc': '전폭 이미지와 링크입니다.',
  'pages.frontendPages.canvas.block.liveReels.title': '인기 급상승 숏클립',
  'pages.frontendPages.canvas.block.liveReels.desc': '라이브 찬스와 같은 방송 카드에 파란 「숏클립」 표시가 붙습니다. 방송을 직접 고르면 그 순서대로, 자동이면 끝난 방송 중 시청 수가 많은 순으로 나갑니다.',
  'pages.frontendPages.canvas.block.liveBenefits.title': '라이브 혜택',
  'pages.frontendPages.canvas.block.liveBenefits.desc': '라이브 찬스처럼 방송을 골라 담고, 카드마다 카운트다운 끝 시각을 정합니다. 시각이 지나면 「시간 종료」로 바뀌고, 비워 두면 카운트다운 없이 나갑니다.',
  'pages.frontendPages.canvas.block.partners.title': '포인트 파트너 셀러',
  'pages.frontendPages.canvas.block.partners.desc': '큰 셀러 사진과 팔로우·대표 상품이 한 장으로 보이는 2열 파트너 블록입니다.',
  'pages.frontendPages.canvas.block.liveSellerRail.title': '셀러 추천',
  'pages.frontendPages.canvas.block.liveSellerRail.desc':
    '라이브 셀러 캐러셀 바로 아래 셀러 원형 줄입니다. 담은 셀러만 담은 순서로 나오며, 셀러 관리의 인기·포인트 셀러 설정과는 따로 움직입니다. 셀러를 빼려면 [편집]에서 지우고, 띠를 통째로 숨기려면 노출 스위치를 끄세요.',
  'pages.frontendPages.action.preview': '미리보기(숨김 포함)',
  'pages.frontendPages.action.invalidateCache': '캐시 즉시 반영',
  'pages.frontendPages.preview.unavailable': '미리보기 서버(Redis)가 없어 발급할 수 없습니다',
  'pages.frontendPages.readOnlyHint': '편집 권한이 없습니다',
  'pages.frontendPages.loadFailed': '프론트 페이지 설정을 불러오지 못했습니다',
  'pages.frontendPages.saved': '저장했습니다',
  'pages.frontendPages.saveFailed': '저장에 실패했습니다',

  // ── 프론트 페이지 설정 (M2) — 섹션 구성 · 드로어 · 라이브 일정 · 스토어/캐러셀 ──
  // fp:action
  'pages.frontendPages.action.openStorefront': '프론트에서 보기',
  'pages.frontendPages.action.previewHint': '숨김 밴드까지 포함해 지금 상태 그대로 새 창에서 봅니다.',
  // fp:(top)
  'pages.frontendPages.addSection': '밴드 추가',
  // fp:blocked
  'pages.frontendPages.blocked.body':
    '밴드 설정과 카드는 저장됐습니다. 아래 사유를 고친 뒤 다시 저장하세요. 내가 직접 끈 카드는 여기 나오지 않습니다.',
  'pages.frontendPages.blocked.cardAt': '{slot} · {index}번째 카드 — {reason}',
  'pages.frontendPages.blocked.cardAtNoSlot': '{index}번째 카드 — {reason}',
  'pages.frontendPages.blocked.goToCards': '카드 보기',
  'pages.frontendPages.blocked.more': '외 {count}장',
  'pages.frontendPages.blocked.title': '카드 {count}장은 지금 프론트에 나가지 않습니다',
  // fp:cache
  'pages.frontendPages.cache.failed': '캐시를 비우지 못했습니다.',
  'pages.frontendPages.cache.invalidated': '캐시를 비웠습니다.',
  'pages.frontendPages.cacheHint': '저장 즉시 서버 캐시가 비워집니다. 프론트 화면은 새로고침해야 하고, 프론트가 이 응답을 30초 캐시하므로 그동안은 옛 값이 보일 수 있습니다. 30초 뒤에도 안 보이면 밴드의 노출·기간·보이는 카드 수를 확인하세요.',
  // fp:card
  'pages.frontendPages.card.basic': '기본',
  'pages.frontendPages.card.heading': '띠 문구 (선택)',
  'pages.frontendPages.card.headingHint':
    '세 칸 위에 큰 제목이 필요할 때만 적습니다. 비워 두면 히어로 칸만 나갑니다.',
  'pages.frontendPages.card.slots': '슬롯',
  'pages.frontendPages.card.source': '소스',
  'pages.frontendPages.card.style': '스타일',
  // fp:heroGuide
  'pages.frontendPages.heroGuide.introTitle': '추천 페이지 맨 위 세 칸',
  'pages.frontendPages.heroGuide.intro':
    '왼쪽은 LIVE CHANNEL 카드 1장, 가운데는 배너 캐러셀, 오른쪽은 인기 신상과 자사몰 인기 상품입니다. 지도를 눌러 자리를 고른 뒤 그 자리에 이미지·상품을 넣으면 됩니다.',
  'pages.frontendPages.heroGuide.howTo1': '위 지도에서 바꾸고 싶은 자리를 누릅니다.',
  'pages.frontendPages.heroGuide.howTo2': '열린 단계에서 배너 또는 상품을 담습니다.',
  'pages.frontendPages.heroGuide.howTo3': '오른쪽 배치를 확인하고 저장합니다.',
  'pages.frontendPages.heroGuide.mapHint': '바꾸고 싶은 자리를 누르세요. 아래 단계가 그 자리로 열립니다.',
  'pages.frontendPages.heroGuide.step1': '왼쪽 · LIVE CHANNEL',
  'pages.frontendPages.heroGuide.step1Short': '배너 1장',
  'pages.frontendPages.heroGuide.step2': '가운데 · 배너 캐러셀',
  'pages.frontendPages.heroGuide.step2Short': '배너 여러 장',
  'pages.frontendPages.heroGuide.step3': '오른쪽 위 · 인기 신상',
  'pages.frontendPages.heroGuide.step3Short': '상품 최대 3개',
  'pages.frontendPages.heroGuide.step4': '오른쪽 아래 · 자사몰 인기',
  'pages.frontendPages.heroGuide.step4Short': '상품 최대 3개',
  'pages.frontendPages.heroGuide.hint.left':
    'LIVE CHANNEL 자리에 나갈 큰 카드입니다. 배너 이미지를 올리고 제목·링크를 적으세요. 1장만 나갑니다.',
  'pages.frontendPages.heroGuide.hint.carousel':
    '가운데를 채우는 배너 슬라이드입니다. 새 배너를 만들거나 이미 있는 캐러셀을 고르세요. 이 목록은 CS › 배너/캐러셀과 같습니다.',
  'pages.frontendPages.heroGuide.hint.rightTop':
    '인기 신상 칸입니다. 상품을 최대 3개까지 담으세요. 하나도 안 넣으면 저장 후 시스템이 상품을 채워 줍니다. 칸 제목은 아래에서 바꿀 수 있습니다.',
  'pages.frontendPages.heroGuide.hint.rightBottom':
    '자사몰 인기 상품 칸입니다. 상품을 최대 3개까지 담으세요. 비워 두면 시스템이 채웁니다.',
  'pages.frontendPages.heroGuide.stepTitle.left': '1. 왼쪽 LIVE CHANNEL 카드',
  'pages.frontendPages.heroGuide.stepTitle.carousel': '2. 가운데 배너 캐러셀',
  'pages.frontendPages.heroGuide.stepTitle.rightTop': '3. 오른쪽 위 · 인기 신상',
  'pages.frontendPages.heroGuide.stepTitle.rightBottom': '4. 오른쪽 아래 · 자사몰 인기',
  'pages.frontendPages.heroGuide.columnTitle': '이 칸의 제목 (프론트에 그대로 나갑니다)',
  'pages.frontendPages.heroGuide.when': '언제 보여줄까요',
  'pages.frontendPages.heroGuide.places': '자리별 콘텐츠',
  'pages.frontendPages.heroGuide.optional': '색 · 배경 (선택)',
  'pages.frontendPages.heroGuide.visibleHint': '끄면 추천 페이지에서 이 블록 전체가 사라집니다.',
  'pages.frontendPages.heroGuide.deviceHint':
    "휴대폰에도 히어로를 보이려면 '전체'를 고르세요. 'PC만'이면 모바일에서 이 블록이 사라집니다.",
  'pages.frontendPages.heroGuide.preview.title': '배치 미리보기',
  'pages.frontendPages.heroGuide.preview.left': 'LIVE CHANNEL',
  'pages.frontendPages.heroGuide.preview.carousel': '가운데 배너',
  'pages.frontendPages.heroGuide.preview.rightTop': '인기 신상',
  'pages.frontendPages.heroGuide.preview.rightBottom': '자사몰 인기',
  'pages.frontendPages.heroGuide.preview.leftEmpty': '배너 1장을 넣으세요',
  'pages.frontendPages.heroGuide.preview.carouselEmpty': '캐러셀에서 배너를 고르세요',
  'pages.frontendPages.heroGuide.preview.productsEmpty': '상품을 담거나, 비워 두면 자동으로 채워집니다',
  'pages.frontendPages.heroGuide.start.left': '아래 [배너 추가]를 눌러 LIVE CHANNEL 이미지를 올리세요.',
  'pages.frontendPages.heroGuide.start.rightTop': '아래 [상품 추가]로 담거나, 비워 두고 저장하면 시스템이 채웁니다.',
  'pages.frontendPages.heroGuide.start.rightBottom': '아래 [상품 추가]로 담거나, 비워 두고 저장하면 시스템이 채웁니다.',
  // fp:blockGuide
  'pages.frontendPages.blockGuide.howTo1': '위에서 이 블록을 언제 보여줄지 고릅니다.',
  'pages.frontendPages.blockGuide.howTo2': '아래 단계에서 제목과 넣을 내용을 고칩니다.',
  'pages.frontendPages.blockGuide.howTo3': '저장을 누르면 프론트에 반영됩니다.',
  'pages.frontendPages.blockGuide.howToMap1': '위 지도에서 바꾸고 싶은 자리를 누릅니다.',
  'pages.frontendPages.blockGuide.howToMap2': '열린 단계에서 제목과 내용을 담습니다.',
  'pages.frontendPages.blockGuide.mapHint': '바꾸고 싶은 자리를 누르세요. 아래 단계가 그 자리로 열립니다.',
  'pages.frontendPages.blockGuide.productColumns.mapHint': '세 열 중 고치고 싶은 열을 누르세요.',
  'pages.frontendPages.blockGuide.ranking.mapHint': '오늘 · 3일 · 1주 중 고치고 싶은 기간을 누르세요.',
  'pages.frontendPages.blockGuide.categoryGroups.mapHint': '그룹 중 고치고 싶은 것을 누르세요. 그 그룹의 원 이미지와 원형 카테고리를 담습니다.',
  'pages.frontendPages.blockGuide.liveChance.mapHint': '필터 칩을 눌러 그 칩에 나갈 라이브를 담습니다.',
  'pages.frontendPages.blockGuide.when': '언제 보여줄까요',
  'pages.frontendPages.blockGuide.visibleHint': '끄면 이 페이지에서 이 블록 전체가 사라집니다.',
  'pages.frontendPages.blockGuide.deviceHint':
    '「전체」를 고르면 휴대폰에도 나갑니다. 「PC만」이면 모바일에서는 이 블록이 숨겨집니다.',
  'pages.frontendPages.blockGuide.showOnMobileHint': '끄면 휴대폰에서는 이 카테고리 줄을 그리지 않습니다.',
  'pages.frontendPages.blockGuide.showLoadMoreHint': '끄면 다음 쪽이 남아 있어도 더 보기 단추를 그리지 않습니다.',
  'pages.frontendPages.blockGuide.heading': '블록 제목',
  'pages.frontendPages.blockGuide.heading.sellerSpotlight': '캐러셀 위 문구',
  'pages.frontendPages.blockGuide.headingHint': '프론트에서 이 블록 위에 나갑니다. 비우면 제목 줄을 그리지 않습니다.',
  'pages.frontendPages.blockGuide.headingHint.sellerSpotlight':
    '시안의 「오늘의 특가」(주황 작은 글)와 「오늘 놓치지 마세요!」(큰 제목)입니다. 눈썹 문구·제목에 적으세요.',
  'pages.frontendPages.blockGuide.headingMore': '제목 줄 더 꾸미기 (선택)',
  'pages.frontendPages.blockGuide.fill': '내용을 어떻게 채울까요',
  'pages.frontendPages.blockGuide.fillQuestion': '직접 담을까요, 시스템이 고를까요?',
  'pages.frontendPages.blockGuide.fillQuestion.sellerSpotlight': '캐러셀에 어떤 셀러를 올릴까요?',
  'pages.frontendPages.blockGuide.fillQuestion.reels': '숏클립으로 어떤 방송을 보여 줄까요?',
  'pages.frontendPages.blockGuide.fillHint':
    '직접 담기는 아래에 넣은 것만 나갑니다. 시스템이 채우기는 조건에 맞는 것을 자동으로 고릅니다.',
  'pages.frontendPages.blockGuide.fillHint.sellerSpotlight':
    '직접 고르면 아래 셀러 순서대로 캐러셀이 돌아갑니다(맨 위가 첫 화면). 각 셀러에서 고른 상품이 카드 아래에 나갑니다. 자동이면 지금 방송 중이거나 예정된 세션이 채워집니다.',
  'pages.frontendPages.blockGuide.fillHint.reels': '직접 고르면 아래에 담은 방송이 그 순서대로 나갑니다(끝난 방송도 나갑니다). 자동이면 끝난 방송 중 시청 수가 많은 순으로 채워집니다. 방송을 담으면 직접 고르기로 바뀝니다.',
  'pages.frontendPages.blockGuide.fillHint.storeRail':
    '직접 담기: 담은 스토어가 그 순서로 먼저 나가고, 남은 칸은 스토어 관리에서 추천 노출을 켠 다른 스토어로 무작위로 채웁니다. 몇 개를 채울지는 아래 [무작위로 채울 스토어 수]에서 정하고, 채우는 스토어는 하루에 한 번(한국 시간 자정) 바뀝니다. 숨긴 스토어는 채우지 않습니다. 시스템이 채우기(또는 아무것도 담지 않음): 추천 노출 스토어를 스토어 관리 순서대로 보여 줍니다.',
  'pages.frontendPages.blockGuide.autoFilters': '자동으로 고를 조건 (선택)',
  'pages.frontendPages.blockGuide.source.manual': '직접 담기',
  'pages.frontendPages.blockGuide.source.manual.sellerSpotlight': '목록에서 직접 고르기',
  'pages.frontendPages.blockGuide.source.manual.reels': '방송 직접 고르기',
  'pages.frontendPages.blockGuide.source.auto': '시스템이 채우기',
  'pages.frontendPages.blockGuide.source.auto.sellerSpotlight': '진행 중·예정 방송을 자동으로',
  'pages.frontendPages.blockGuide.source.auto.reels': '끝난 방송 시청순으로 자동',
  'pages.frontendPages.blockGuide.places': '무엇을 넣을까요',
  'pages.frontendPages.blockGuide.places.sellerSpotlight': '캐러셀에 나갈 셀러',
  'pages.frontendPages.blockGuide.places.timeSale': '혜택으로 보여 줄 방송',
  'pages.frontendPages.blockGuide.places.reels': '숏클립으로 나갈 방송',
  'pages.frontendPages.blockGuide.optional': '색 · 배경 (선택)',
  'pages.frontendPages.blockGuide.columnTitle': '이 열의 제목 (프론트에 그대로 나갑니다)',
  'pages.frontendPages.blockGuide.groupTitle': '그룹 이름 (원 아래에 나갑니다)',
  'pages.frontendPages.blockGuide.chipTitle': '칩 이름',
  'pages.frontendPages.blockGuide.tabTitle': '탭 이름',
  'pages.frontendPages.blockGuide.addGroup': '그룹 추가',
  'pages.frontendPages.blockGuide.addChip': '필터 칩 추가',
  'pages.frontendPages.blockGuide.addSlot': '자리 추가',
  'pages.frontendPages.blockGuide.emptySlots': '아직 자리가 없습니다. 아래 단추로 만드세요.',
  'pages.frontendPages.blockGuide.noItems': '이 블록은 여기서 상품을 담지 않습니다.',
  'pages.frontendPages.blockGuide.variantHint':
    '기본·라이브 찬스·순위 카드 모양을 고릅니다. 열마다 다르게 쓸 수 있습니다.',
  'pages.frontendPages.blockGuide.initialCountHint': '페이지를 열었을 때 먼저 보여줄 개수입니다.',
  'pages.frontendPages.blockGuide.loadMoreCountHint': '더보기를 누를 때마다 이만큼 더 불러옵니다.',
  'pages.frontendPages.blockGuide.rankingAutoHint':
    '「시스템이 채우기」에서는 오늘/3일/1주 탭에 상품을 넣지 않습니다. 위를 「직접 담기」로 바꾸면 다시 고칠 수 있습니다.',
  'pages.frontendPages.blockGuide.hint.productColumns':
    '이 열에 상품을 최대 2개 담습니다. 비워 두면 저장 후 시스템이 채웁니다.',
  'pages.frontendPages.blockGuide.hint.productColumns.col1':
    '왼쪽 열입니다. 상품을 최대 2개 담으세요. 비워 두면 시스템이 채웁니다.',
  'pages.frontendPages.blockGuide.hint.productColumns.col2':
    '가운데 열입니다. 상품을 최대 2개 담으세요. 비워 두면 시스템이 채웁니다.',
  'pages.frontendPages.blockGuide.hint.productColumns.col3':
    '오른쪽 열입니다. 상품을 최대 2개 담으세요. 비워 두면 시스템이 채웁니다.',
  'pages.frontendPages.blockGuide.hint.ranking':
    '이 기간 탭에 나갈 상품입니다. 최대 10개입니다. 「시스템이 채우기」를 고르면 이 목록은 쓰이지 않습니다.',
  'pages.frontendPages.blockGuide.hint.ranking.today': '오늘 랭킹에 나갈 상품입니다. 최대 10개입니다.',
  'pages.frontendPages.blockGuide.hint.ranking.3d': '최근 3일 랭킹에 나갈 상품입니다. 최대 10개입니다.',
  'pages.frontendPages.blockGuide.hint.ranking.1w': '최근 1주 랭킹에 나갈 상품입니다. 최대 10개입니다.',
  'pages.frontendPages.blockGuide.hint.categoryGroups':
    '이 그룹을 누르면 오른쪽에 원형 카테고리가 바뀝니다. 원을 최대 12개까지 담으세요.',
  'pages.frontendPages.blockGuide.hint.liveChance':
    '칩 이름을 적으세요. 「전체」가 아니면 카테고리를 고른 뒤 라이브를 담습니다.',
  'pages.frontendPages.blockGuide.hint.liveChance.all': '「전체」 칩입니다. 카테고리 없이 모든 라이브를 보여 줍니다.',
  'pages.frontendPages.blockGuide.start.productColumns':
    '아래 [상품 추가]로 담거나, 비워 두고 저장하면 시스템이 채웁니다. 열마다 최대 2개입니다.',
  'pages.frontendPages.blockGuide.start.ranking':
    '아래 [상품 추가]로 담으세요. 「시스템이 채우기」면 이 목록을 쓰지 않습니다.',
  'pages.frontendPages.blockGuide.start.categoryGroups':
    '아래 단추로 카테고리 원을 담으세요. 이미지·이름·링크가 한 세트입니다.',
  'pages.frontendPages.blockGuide.start.liveChance': '아래 단추로 라이브 카드를 담으세요.',
  'pages.frontendPages.blockGuide.start.storeRail': '추천할 스토어를 담으세요. 담은 스토어가 먼저 나가고 남은 칸은 시스템이 무작위로 채웁니다(하루에 한 번 바뀝니다). 비워 두면 모두 시스템이 채웁니다.',
  'pages.frontendPages.blockGuide.start.moreToLove':
    '아래에 상품을 담거나 비워 두면 시스템이 채웁니다. 위쪽에서 처음 몇 개를 정할 수 있습니다.',
  'pages.frontendPages.blockGuide.start.sellerSpotlight':
    '1) 위에서 「목록에서 직접 고르기」를 고릅니다. 2) [셀러 추가]로 라이브 셀러를 담습니다. 3) 각 셀러마다 라이브 페이지에 보일 상품을 최대 3개까지 고릅니다. 위가 첫 장이고, 왼쪽 손잡이로 순서를 바꿉니다.',
  'pages.frontendPages.blockGuide.start.banner': '전폭으로 나갈 배너 이미지를 담으세요.',
  'pages.frontendPages.blockGuide.start.sellerRail': '파트너로 보여줄 셀러를 담으세요.',
  'pages.frontendPages.blockGuide.hint.productTabs': '탭 이름과 이 탭에 나갈 상품 조건을 정하세요. 탭마다 상품은 최대 20개입니다.',
  'pages.frontendPages.blockGuide.start.productTabs': '아래 [상품 추가]로 이 탭의 상품을 담으세요.',
  'pages.frontendPages.blockGuide.hint.categoryShowcase': '카테고리 줄에 나갈 카테고리를 고르세요. 이름과 이미지는 카테고리 관리에 등록된 것이 그대로 나갑니다. 상품은 아래 "탭별 상품"에서 고객 화면의 탭(베스트·하위 카테고리)마다 담습니다.',
  'pages.frontendPages.blockGuide.hint.marketShowcase': '칩 이름을 적고 이 공급처의 카테고리를 고르세요. 칩 그림은 고른 카테고리의 이미지로 나갑니다.',
  'pages.frontendPages.blockGuide.start.marketShowcase': '아래 [외부 상품 추가]로 상품을 담거나, 비워 두면 카테고리 이름으로 검색한 상품이 나갑니다.',
  'pages.frontendPages.blockGuide.addMarketChip': '카테고리 칩 추가',
  'pages.frontendPages.platform.1688': '1688',
  'pages.frontendPages.platform.taobao': '타오바오',
  'pages.frontendPages.platform.vvic': 'VVIC',
  'pages.frontendPages.slots.chipPlatformMissing': '이 칩은 공급처가 없어 프론트에 나가지 않습니다. 공급처를 고르세요.',
  'pages.frontendPages.slots.chipImageFromSearch': '이미지가 없어 검색 결과 상품 사진을 씁니다. 올리면 카테고리 관리에도 저장됩니다.',
  'pages.frontendPages.slots.chipCategoryImage': '칩 이미지',
  'pages.frontendPages.slots.chipCategoryImageSync': '카테고리 관리의 이미지와 같습니다. 바꾸면 바로 저장되어 함께 바뀝니다.',
  'pages.frontendPages.slots.chipCategoryImageSaved': '카테고리 이미지를 저장했습니다. 카테고리 관리에도 반영됐습니다.',
  'pages.frontendPages.slots.chipCategoryImageSaveFailed': '카테고리 이미지를 저장하지 못했습니다.',
  'pages.frontendPages.slots.chipCategoryImageNoPermission': '카테고리 관리 편집 권한이 있어야 바꿀 수 있습니다.',
  'pages.frontendPages.slots.chipCategoryImagePc': 'PC',
  'pages.frontendPages.slots.chipCategoryImageMobile': '모바일',
  'pages.frontendPages.slots.ownChipCategoryImageSync': '자사몰 카테고리 관리의 이미지와 같습니다. 바꾸면 바로 저장되어 함께 바뀝니다. 한쪽만 있으면 양쪽에 그 그림이 나갑니다.',
  'pages.frontendPages.slots.ownChipCategoryImageEmpty': '이미지가 없어 이름 첫 글자가 대신 나갑니다. 올리면 자사몰 카테고리 관리에도 저장됩니다.',
  'pages.frontendPages.slots.ownChipCategoryImageNoPermission': '자사몰 편집 권한이 있어야 바꿀 수 있습니다.',
  'pages.frontendPages.blockGuide.addCategory': '카테고리 추가',
  'pages.frontendPages.blockGuide.emptyCategories': '넣은 카테고리가 없어 1단계 카테고리가 모두 자동으로 나갑니다. 직접 고르려면 [카테고리 추가]를 누르세요.',
  'pages.frontendPages.slots.categoryNotPicked': '카테고리 미선택',
  'pages.frontendPages.slots.categoryMissing': '숨김·삭제된 카테고리',
  'pages.frontendPages.slots.categoryPlaceholder': '카테고리를 고르세요',
  'pages.frontendPages.slots.categoryRequired': '카테고리를 고르세요. 고르지 않으면 프론트에 나가지 않습니다.',
  'pages.frontendPages.slots.categoryMissingHint': '고른 카테고리가 숨김 또는 삭제되어 프론트에 나가지 않습니다. 다른 카테고리를 고르세요.',
  'pages.frontendPages.slots.ownCategoryImage': '카테고리 이미지',
  'pages.frontendPages.slots.subTabs': '탭별 상품',
  'pages.frontendPages.slots.subTabsHint': '고객 화면에서 이 카테고리를 누르면 아래와 같은 탭이 나옵니다. 탭마다 보여 줄 상품을 따로 담으세요.',
  'pages.frontendPages.slots.subTabsNone': '이 카테고리에는 하위 카테고리가 없어 고객 화면에는 "베스트" 탭만 나갑니다. 하위 카테고리는 자사몰 카테고리 관리에서 추가합니다.',
  'pages.frontendPages.slots.subTabBest': '베스트',
  'pages.frontendPages.slots.subTabOrphan': '없어진 탭',
  'pages.frontendPages.slots.subTabOrphanHint': '이 탭의 하위 카테고리가 숨김·삭제되었거나 다른 카테고리로 옮겨져 고객 화면에 없습니다. 여기 담긴 상품은 나가지 않으니, 필요한 상품은 다른 탭에 다시 담고 여기서는 빼세요.',
  'pages.frontendPages.slots.subTabOrphanDropTitle': '이 탭의 상품을 모두 뺄까요?',
  'pages.frontendPages.slots.subTabOrphanDrop': '이 탭의 상품 {count}개 빼기',
  'pages.frontendPages.slots.subTabHint.bestAuto': '고객 화면에서 이 카테고리를 누르면 처음 보이는 "베스트" 탭입니다. 담은 상품이 그 순서대로 나가고, 비워 두면 이 카테고리 전체 상품이 자동으로 나갑니다.',
  'pages.frontendPages.slots.subTabHint.bestManual': '고객 화면에서 이 카테고리를 누르면 처음 보이는 "베스트" 탭입니다. 담은 상품이 그 순서대로 나가고, 비워 두면 하위 탭에 담은 상품이 모두 나갑니다.',
  'pages.frontendPages.slots.subTabHint.subAuto': '고객 화면의 "{name}" 탭입니다. 담은 상품이 그 순서대로 나가고, 비워 두면 "{name}" 카테고리 상품이 자동으로 나갑니다.',
  'pages.frontendPages.slots.subTabHint.subManual': '고객 화면의 "{name}" 탭입니다. 담은 상품이 그 순서대로 나가고, 비워 두면 "베스트"에 담은 상품 중 "{name}" 카테고리 상품만 나갑니다.',
  'pages.frontendPages.slots.subTabDropConfirmTitle': '카테고리를 바꿀까요?',
  'pages.frontendPages.slots.subTabDropConfirmBody': '하위 탭에 담은 상품 {count}개는 새 카테고리에 나갈 탭이 없어 함께 빠집니다. "베스트"에 담은 상품은 그대로 남습니다.',
  'pages.frontendPages.slots.subTabDropConfirmOk': '바꾸기',
  'pages.frontendPages.slots.chipItemCount': '상품 {count}개',
  'pages.frontendPages.blockGuide.start.categoryTabs': '아래 [상품 추가]로 상품을 담으세요. 「시스템이 채우기」를 고르면 자동으로 채웁니다.',
  'pages.frontendPages.blockGuide.start.productGrid': '아래 [상품 추가]로 상품을 담으세요. 「시스템이 채우기」를 고르면 자동으로 채웁니다.',
  'pages.frontendPages.blockGuide.start.productRail': '아래 [상품 추가]로 상품을 담으세요. 「시스템이 채우기」를 고르면 자동으로 채웁니다.',
  'pages.frontendPages.blockGuide.start.coupon': '아래 단추로 받아 갈 쿠폰을 담으세요. 「시스템이 채우기」를 고르면 자동으로 채웁니다.',
  'pages.frontendPages.blockGuide.start.eventTicker': '띠에서 흘러갈 이벤트 배너를 담으세요. 「시스템이 채우기」를 고르면 자동으로 채웁니다.',
  'pages.frontendPages.blockGuide.start.heroLive': '맨 위에 나갈 숏클립을 담으세요. 「시스템이 채우기」를 고르면 자동으로 고릅니다.',
  'pages.frontendPages.blockGuide.start.liveNow': '방송 중으로 보여줄 셀러를 담으세요. 「시스템이 채우기」를 고르면 방송 중인 셀러가 자동으로 나옵니다.',
  'pages.frontendPages.blockGuide.start.reels': '아래 [라이브 세션 추가]로 숏클립으로 보여 줄 방송을 담으세요(최대 12개). 끝난 방송도 담을 수 있습니다. 셀러 상세 → 라이브 상품 관리에서 그 방송에 영상을 올려 두면 카드에서 재생됩니다.',
  'pages.frontendPages.blockGuide.start.schedule': '보여줄 방송 일정을 담으세요. 「시스템이 채우기」를 고르면 예정된 방송이 시간 순으로 나옵니다.',
  'pages.frontendPages.blockGuide.start.ticker': '흘러갈 짧은 문구를 카드 하나에 한 줄씩 담으세요.',
  'pages.frontendPages.blockGuide.start.timeSale': '아래 [라이브 세션 추가]로 혜택을 보여 줄 방송을 담고(최대 12개), 카드마다 「카운트다운 끝」을 정하세요. 비우면 카운트다운 없이, 지나면 「시간 종료」로 나갑니다. 끝난 방송도 담을 수 있습니다.',
  'pages.frontendPages.blockGuide.start.sellerRanking': '셀러를 담으면 그 순서대로 라이브 페이지에 나갑니다. 담지 않은 셀러는 나오지 않습니다. 비우면 위 정렬(시청순·판매순)로 자동으로 채웁니다. 각 셀러의 「노출할 상품」을 비우면 그 셀러 페이지 판매순위의 첫 상품이 카드 아래에 나갑니다.',
  'pages.frontendPages.blockGuide.stepTitle.productColumns.col1': '1. 왼쪽 열',
  'pages.frontendPages.blockGuide.stepTitle.productColumns.col2': '2. 가운데 열',
  'pages.frontendPages.blockGuide.stepTitle.productColumns.col3': '3. 오른쪽 열',
  'pages.frontendPages.blockGuide.stepTitle.ranking.today': '1. 오늘',
  'pages.frontendPages.blockGuide.stepTitle.ranking.3d': '2. 3일',
  'pages.frontendPages.blockGuide.stepTitle.ranking.1w': '3. 1주',
  'pages.frontendPages.blockGuide.stepTitle.liveChance.all': '1. 전체',
  'pages.frontendPages.slotPurpose.heroTriple.left': '왼쪽 LIVE CHANNEL 큰 카드',
  'pages.frontendPages.slotPurpose.heroTriple.carousel': '가운데 배너 캐러셀',
  'pages.frontendPages.slotPurpose.heroTriple.rightTop': '오른쪽 위 인기 신상',
  'pages.frontendPages.slotPurpose.heroTriple.rightBottom': '오른쪽 아래 자사몰 인기',
  'pages.frontendPages.slotPurpose.productColumns.col1': '왼쪽 열 · 상품 최대 2개',
  'pages.frontendPages.slotPurpose.productColumns.col2': '가운데 열 · 상품 최대 2개',
  'pages.frontendPages.slotPurpose.productColumns.col3': '오른쪽 열 · 상품 최대 2개',
  'pages.frontendPages.slotPurpose.ranking.today': '오늘 랭킹',
  'pages.frontendPages.slotPurpose.ranking.3d': '최근 3일 랭킹',
  'pages.frontendPages.slotPurpose.ranking.1w': '최근 1주 랭킹',
  // fp:carousel
  'pages.frontendPages.carousel.actions': '작업',
  'pages.frontendPages.carousel.add': '캐러셀 추가',
  'pages.frontendPages.carousel.addTitle': '캐러셀 추가',
  'pages.frontendPages.carousel.delete': '삭제',
  'pages.frontendPages.carousel.deleteConfirm': '이 캐러셀을 지울까요?',
  'pages.frontendPages.carousel.deleteFailed': '지우지 못했습니다.',
  'pages.frontendPages.carousel.deleted': '지웠습니다.',
  'pages.frontendPages.carousel.edit': '수정',
  'pages.frontendPages.carousel.editTitle': '캐러셀 수정',
  'pages.frontendPages.carousel.imageHint': '새로 등록할 때 PC 이미지만 올리면 서버가 모바일 크기를 함께 만듭니다. 두 장을 올리면 각각 그대로 씁니다. 수정할 때는 바꾼 칸의 이미지만 바뀝니다.',
  'pages.frontendPages.carousel.imageMobile': '모바일 이미지',
  'pages.frontendPages.carousel.imagePc': 'PC 이미지',
  'pages.frontendPages.carousel.imageRequired': '이미지를 한 장 이상 올려야 합니다.',
  'pages.frontendPages.carousel.isActive': '활성',
  'pages.frontendPages.carousel.link': '링크',
  'pages.frontendPages.carousel.loadFailed': '캐러셀을 불러오지 못했습니다.',
  'pages.frontendPages.carousel.viewPermissionRequired':
    '배너/이벤트 조회 권한이 없어 캐러셀 목록을 불러올 수 없습니다.',
  'pages.frontendPages.carousel.editPermissionRequired':
    '캐러셀을 고치려면 배너/이벤트 편집 권한이 필요합니다.',
  'pages.frontendPages.carousel.newTabShort': '(새 탭)',
  'pages.frontendPages.carousel.no': '순번',
  'pages.frontendPages.carousel.openInNewTab': '새 탭',
  'pages.frontendPages.carousel.period': '기간',
  'pages.frontendPages.carousel.periodAlways': '항상',
  'pages.frontendPages.carousel.periodHint': '비우면 항상 노출됩니다. 한국 시간 기준입니다.',
  'pages.frontendPages.carousel.permissionHint': '캐러셀 저장에는 배너/이벤트 편집 권한이 필요합니다.',
  'pages.frontendPages.carousel.pickImage': '이미지 고르기',
  'pages.frontendPages.carousel.sameDataHint': '이 목록은 CS › 배너/캐러셀 관리와 같은 데이터입니다.',
  'pages.frontendPages.carousel.saveFailed': '저장하지 못했습니다.',
  'pages.frontendPages.carousel.saved': '저장했습니다.',
  'pages.frontendPages.carousel.title': '제목',
  'pages.frontendPages.carousel.subtitle': '소제목',
  'pages.frontendPages.carousel.subtitleHint':
    '앱 자사몰 페이지의 카드에서 제목 위에 주황색으로 나옵니다. 비워 두면 표시하지 않습니다.',
  // fp:categoryLink
  'pages.frontendPages.categoryLink.category': '카테고리',
  'pages.frontendPages.categoryLink.categoryOnly1688': '타오바오·VVIC 검색은 키워드만 씁니다. 카테고리는 무시됩니다.',
  'pages.frontendPages.categoryLink.companymallCategoryFirst': '먼저 카테고리를 고르세요. 키워드는 그 다음에 열 수 있습니다.',
  'pages.frontendPages.categoryLink.companymallKeywordHint': '키워드는 선택한 카테고리의 이름과 정확히 같아야 합니다. 다르면 목록이 비어 있게 됩니다.',
  'pages.frontendPages.categoryLink.companymallKeywordLock': '키워드 직접 입력',
  'pages.frontendPages.categoryLink.companymallLiveHint': "자사몰 목록은 자사몰 상품만 검색합니다. 라이브 상품은 '라이브' 모드를 쓰세요.",
  'pages.frontendPages.categoryLink.customUrl': '주소 직접 입력',
  'pages.frontendPages.categoryLink.keyword': '키워드',
  'pages.frontendPages.categoryLink.keywordMismatch': '선택한 카테고리 이름과 다릅니다. 이대로는 저장이 거절됩니다.',
  'pages.frontendPages.categoryLink.keywordRequired': '이 제공처는 키워드가 있어야 링크가 만들어집니다.',
  'pages.frontendPages.categoryLink.mode': '링크 방식',
  'pages.frontendPages.categoryLink.mode_custom': '주소 직접 입력',
  'pages.frontendPages.categoryLink.mode_live': '라이브 상품',
  'pages.frontendPages.categoryLink.mode_mall': '자사몰 목록',
  'pages.frontendPages.categoryLink.mode_search': '오픈마켓 검색',
  'pages.frontendPages.categoryLink.preview': '링크 미리보기',
  'pages.frontendPages.categoryLink.previewEmpty': '아직 열 수 있는 링크가 아닙니다.',
  'pages.frontendPages.categoryLink.provider': '제공처',
  'pages.frontendPages.categoryLink.provider_1688': '1688',
  'pages.frontendPages.categoryLink.provider_companymall': '자사몰',
  'pages.frontendPages.categoryLink.provider_taobao': '타오바오',
  'pages.frontendPages.categoryLink.provider_vvic': 'VVIC',
  'pages.frontendPages.categoryLink.useCategoryName': '카테고리 이름 넣기',
  // fp:column
  'pages.frontendPages.column.always': '항상',
  'pages.frontendPages.column.autoLimit': '자동 {count}개',
  'pages.frontendPages.column.cards': '카드',
  'pages.frontendPages.column.cardsBlocked': '숨겨진 원본 때문에 {count}장이 더 빠집니다',
  'pages.frontendPages.column.cardsHint':
    '실제로 프론트에 나가는 카드 / 전체 카드입니다. 내가 끈 카드와, 원본이 없거나 숨겨진 카드는 앞 숫자에서 빠집니다.',
  'pages.frontendPages.column.device': '디바이스',
  'pages.frontendPages.column.order': '순번',
  'pages.frontendPages.column.period': '기간',
  'pages.frontendPages.column.section': '밴드',
  'pages.frontendPages.column.slots': '슬롯',
  'pages.frontendPages.column.source': '소스',
  'pages.frontendPages.column.type': '타입',
  'pages.frontendPages.column.untitled': '(제목 없음)',
  'pages.frontendPages.column.usedElsewhere': '다른 페이지',
  'pages.frontendPages.column.visible': '노출',
  // fp:delete
  'pages.frontendPages.delete.confirmBody': '"{key}" 밴드와 그 안의 카드가 함께 사라집니다. 되돌릴 수 없습니다.',
  'pages.frontendPages.delete.confirmTitle': '이 밴드를 지울까요?',
  'pages.frontendPages.delete.done': '지웠습니다.',
  'pages.frontendPages.delete.failed': '지우지 못했습니다.',
  // fp:device
  'pages.frontendPages.device.all': '전체',
  'pages.frontendPages.device.mobile': '모바일만',
  'pages.frontendPages.device.pc': 'PC만',
  // fp:(top)
  'pages.frontendPages.dragDisabled': '검색·필터가 걸려 있으면 순서를 바꿀 수 없습니다.',
  'pages.frontendPages.dragHint': '손잡이를 끌어 순서를 바꿉니다.',
  // fp:duplicate
  'pages.frontendPages.duplicate.action': '복제',
  'pages.frontendPages.duplicate.body': '"{key}" 밴드를 어느 페이지로 복제할까요?',
  'pages.frontendPages.duplicate.done': '복제했습니다.',
  'pages.frontendPages.duplicate.failed': '복제하지 못했습니다.',
  'pages.frontendPages.duplicate.hiddenNotice': '복제본은 숨김 상태로 만들어집니다. 확인한 뒤 노출로 바꾸세요.',
  'pages.frontendPages.duplicate.notAllowed': '이 타입을 받지 않음',
  'pages.frontendPages.duplicate.target': '대상 페이지',
  'pages.frontendPages.duplicate.title': '밴드 복제',
  'pages.frontendPages.duplicate.tooltip': '다른 페이지로 복제',
  // fp:(top)
  'pages.frontendPages.editTitle': '밴드 편집',
  // fp:emptyBanner
  'pages.frontendPages.emptyBanner.action': '목록으로 가져오기',
  'pages.frontendPages.emptyBanner.body': '이 페이지에는 저장된 밴드가 없습니다. 기본 레이아웃을 목록으로 가져오면 그때부터 여기서 고칠 수 있습니다.',
  'pages.frontendPages.emptyBanner.title': '현재 기본 레이아웃이 그대로 나가고 있습니다',
  // fp:field
  'pages.frontendPages.field.accentColor': '강조색',
  'pages.frontendPages.field.autoLoadPages': '자동으로 더 불러올 횟수',
  'pages.frontendPages.field.backgroundColor': '배경색',
  'pages.frontendPages.field.badge': '제목 배지',
  'pages.frontendPages.field.device': '디바이스',
  'pages.frontendPages.field.eyebrow': '주황 소제목',
  'pages.frontendPages.field.fullBleed': '화면 가득',
  'pages.frontendPages.field.initialCount': '처음 개수',
  'pages.frontendPages.field.isVisible': '노출',
  'pages.frontendPages.field.itemLimit': '노출 개수',
  'pages.frontendPages.field.autoFillCount': '무작위로 채울 스토어 수',
  'pages.frontendPages.field.autoFillCountPlaceholder': '남은 칸 모두',
  'pages.frontendPages.field.autoFillCountHint':
    '담은 스토어 뒤에 시스템이 무작위로 붙이는 스토어 수입니다. 비워 두면 남은 칸을 모두 채우고, 0이면 담은 스토어만 보여 줍니다. 추천 노출을 켠 스토어가 이보다 적으면 있는 만큼만 나갑니다.',
  'pages.frontendPages.field.key': '키',
  'pages.frontendPages.field.keyHint': '영문 소문자·숫자와 - _ 만 쓸 수 있습니다. 한 페이지 안에서 겹치면 안 됩니다.',
  'pages.frontendPages.field.layout': '레이아웃',
  'pages.frontendPages.field.loadMoreCount': '더 불러올 개수',
  'pages.frontendPages.field.metaText': '보조 문구',
  'pages.frontendPages.field.moreLink': '더보기 링크',
  'pages.frontendPages.field.moreLinkHint': '비우면 더보기 버튼을 그리지 않습니다.',
  'pages.frontendPages.field.period': '노출 기간',
  'pages.frontendPages.field.periodHint': '비우면 항상 노출됩니다. 한국 시간 기준입니다.',
  'pages.frontendPages.field.productScope': '상품 범위',
  'pages.frontendPages.field.productScopeHint': '자동 진열·상품 피커·카드 노출 판정에 함께 쓰입니다.',
  'pages.frontendPages.field.salesMetric': '판매량 표시',
  'pages.frontendPages.field.showOnMobile': '모바일에 노출',
  'pages.frontendPages.field.showLoadMore': '더 보기 단추 노출',
  'pages.frontendPages.field.singleSourceModeHint': '이 타입은 소스가 하나로 고정되어 있습니다.',
  'pages.frontendPages.field.sortOptions': '정렬 선택지',
  'pages.frontendPages.field.sortOptionsHint': '비우면 정렬 드롭다운을 그리지 않습니다.',
  'pages.frontendPages.field.sourceMode': '소스',
  'pages.frontendPages.field.subtitle': '소제목',
  'pages.frontendPages.field.textColor': '글자색',
  'pages.frontendPages.field.title': '제목',
  'pages.frontendPages.field.titleIconHint': '이모지 한 글자 또는 이미지 주소를 넣습니다.',
  'pages.frontendPages.field.titleIconUrl': '제목 아이콘',
  'pages.frontendPages.field.type': '타입',
  // fp:filter
  'pages.frontendPages.filter.categories': '카테고리',
  'pages.frontendPages.filter.liveState': '방송 상태',
  'pages.frontendPages.filter.productFlags': '상품 조건',
  'pages.frontendPages.filter.searchPlaceholder': '키·제목으로 검색',
  'pages.frontendPages.filter.sellerFlags': '셀러 조건',
  'pages.frontendPages.filter.sortBy': '정렬',
  'pages.frontendPages.filter.type': '타입 전체',
  'pages.frontendPages.filter.visibleAll': '노출 전체',
  'pages.frontendPages.filter.visibleOff': '숨김만',
  'pages.frontendPages.filter.visibleOn': '노출만',
  // fp:flag
  'pages.frontendPages.flag.isBestSeller': '베스트',
  'pages.frontendPages.flag.isFeatured': '추천',
  'pages.frontendPages.flag.isImportant': '중요',
  'pages.frontendPages.flag.isNewArrival': '신상',
  'pages.frontendPages.flag.isPoint': '포인트 셀러',
  'pages.frontendPages.flag.isPopular': '인기',
  // fp:gallery
  'pages.frontendPages.gallery.createFailed': '밴드를 넣지 못했습니다.',
  'pages.frontendPages.gallery.created': '밴드를 넣었습니다.',
  'pages.frontendPages.gallery.empty': '이 페이지가 받는 밴드가 없습니다.',
  'pages.frontendPages.gallery.intro': '이 페이지가 받는 밴드만 보여 줍니다. 골라서 넣은 뒤 편집 창에서 내용을 채우세요.',
  'pages.frontendPages.gallery.perSlot': '슬롯당 {max}개 · 모바일 {mobile}개',
  'pages.frontendPages.gallery.slotsFixed': '슬롯 {count}개 고정 · {keys}',
  'pages.frontendPages.gallery.slotsNone': '슬롯 없음',
  'pages.frontendPages.gallery.slotsRange': '슬롯 {min}~{max}개',
  'pages.frontendPages.gallery.title': '{page} 페이지에 넣을 밴드',
  // fp:hiddenReason
  'pages.frontendPages.hiddenReason.coupon_inactive': '받을 수 없는 쿠폰입니다',
  'pages.frontendPages.hiddenReason.item_hidden': '이 카드를 숨김으로 두었습니다',
  'pages.frontendPages.hiddenReason.live_status_ended': '이미 끝난 세션입니다',
  'pages.frontendPages.hiddenReason.live_status_hidden': '세션이 숨김입니다',
  'pages.frontendPages.hiddenReason.live_status_no_product': '세션에 상품이 없습니다',
  'pages.frontendPages.hiddenReason.live_status_products_hidden': '상품 {count}개 숨김',
  'pages.frontendPages.hiddenReason.product_hidden': '상품이 숨김입니다',
  'pages.frontendPages.hiddenReason.product_not_on_sale': '상품이 판매중이 아닙니다',
  'pages.frontendPages.hiddenReason.product_out_of_scope': '이 슬롯의 상품 범위에 맞지 않습니다',
  'pages.frontendPages.hiddenReason.sub_category_missing': '하위 카테고리 탭이 없어졌습니다(숨김·삭제 또는 다른 카테고리로 이동)',
  'pages.frontendPages.hiddenReason.reel_hidden': '숏클립이 숨김입니다',
  'pages.frontendPages.hiddenReason.ref_missing': '연결된 원본이 없습니다',
  'pages.frontendPages.hiddenReason.schedule_hidden': '편성표가 숨김입니다',
  'pages.frontendPages.hiddenReason.store_inactive': '스토어가 비활성입니다',
  'pages.frontendPages.hiddenReason.store_product_hidden': '스토어 대표 상품이 숨김입니다',
  'pages.frontendPages.hiddenReason.time_sale_ended': '이미 끝난 타임세일입니다',
  'pages.frontendPages.hiddenReason.time_sale_hidden': '타임세일이 숨김입니다',
  // fp:importDefaults
  'pages.frontendPages.importDefaults.action': '기본 레이아웃 불러오기',
  'pages.frontendPages.importDefaults.confirmBody': '기본 레이아웃의 밴드를 목록에 넣습니다. 같은 키가 이미 있으면 건너뛰므로 지금 설정은 덮이지 않습니다. 가져온 밴드는 바로 노출 상태로 들어옵니다 — 갤러리에서 추가하거나 복제한 밴드가 숨김으로 들어오는 것과 다릅니다.',
  'pages.frontendPages.importDefaults.confirmTitle': '기본 레이아웃을 가져올까요?',
  'pages.frontendPages.importDefaults.failed': '기본 레이아웃을 가져오지 못했습니다.',
  'pages.frontendPages.importDefaults.nothingNew': '새로 가져올 밴드가 없습니다. {skipped}개는 이미 목록에 있습니다.',
  'pages.frontendPages.importDefaults.result': '{created}개를 가져왔습니다. 이미 있던 {skipped}개는 건너뛰었습니다.',
  // fp:items
  'pages.frontendPages.items.add': '{refType} 추가',
  'pages.frontendPages.items.addLiveSession': '방송 추가',
  'pages.frontendPages.items.addSpotlightSeller': '셀러 추가',
  'pages.frontendPages.items.addPartnerSeller': '셀러 추가',
  'pages.frontendPages.items.autoSellersTitle': '지금 스토어에 나가는 셀러입니다',
  'pages.frontendPages.items.autoSellersHint':
    '이 밴드는 조건(포인트 파트너 등)에 맞는 셀러를 자동으로 모읍니다. 아래가 현재 라이브 페이지에 보이는 목록입니다. 추가·삭제·순서를 바꾼 뒤 저장하면 이 목록이 고정되고, 이후에는 자동으로 바뀌지 않습니다.',
  'pages.frontendPages.items.partnerEmpty':
    '아직 담은 셀러가 없습니다. 위의 [셀러 추가]로 고르거나, 포인트 파트너 플래그가 있는 셀러가 생기면 자동으로 채워집니다.',
  'pages.frontendPages.items.pickSeller': '셀러 고르기',
  'pages.frontendPages.items.spotlightProductsHint':
    '라이브 페이지 카드 아래에 보일 상품입니다. 간편 등록과 자사몰 상품을 이름·라이브코드로 찾을 수 있고, 최대 3개까지 고릅니다. 비우면 방송에 묶인 상품이 나갑니다.',
  'pages.frontendPages.items.spotlightTitleHint':
    '상품을 고르면 카드의 큰 제목은 셀러 이름입니다. 상품을 비우면 라이브 일정의 방송 제목이 나갑니다.',
  'pages.frontendPages.items.rankingProductHint':
    '카드 아래에 보일 상품입니다. 이 셀러의 간편 등록·자사몰 상품에서 1개 고르세요. 비우면 셀러 페이지 판매순위의 첫 상품(상단고정이 있으면 그것)이 나갑니다.',
  'pages.frontendPages.items.partnerProductsHint':
    '포인트 파트너 카드에 셀러와 함께 보일 대표 상품입니다. 이 셀러의 간편 등록·자사몰 상품을 이름·라이브코드로 찾아 최대 3개까지 고르세요. 비우면 이 셀러의 라이브 상품이 자동으로 나갑니다.',
  'pages.frontendPages.items.productTypeOwn': '자사몰',
  'pages.frontendPages.items.productTypeLive': '라이브',
  'pages.frontendPages.items.spotlightLandingHint':
    '고른 상품마다 메인(랜딩) 이미지를 바꿀 수 있습니다. 상품 상세·다른 페이지 카드에도 같이 반영됩니다.',
  'pages.frontendPages.items.spotlightProductsPlaceholder': '노출할 상품 고르기',
  'pages.frontendPages.items.spotlightProductsCount': '{count}/{max}개 선택',
  'pages.frontendPages.items.spotlightProductsLoadFailed': '셀러 상품을 불러오지 못했습니다.',
  'pages.frontendPages.items.spotlightBanner': '배너 이미지',
  'pages.frontendPages.items.spotlightBannerHint':
    '라이브 페이지 카드에 크게 나가는 사진입니다(PC는 카드 왼쪽, 모바일은 큰 카드와 오른쪽 썸네일). 셀러 프로필 사진과 따로 올리며, 비우면 셀러 프로필 사진이 나갑니다. 세로 3:4를 권하고, 한 칸만 올리면 PC·모바일에 같은 사진을 씁니다.',
  'pages.frontendPages.items.cardImage': '카드 사진',
  'pages.frontendPages.items.partnerCardImageHint':
    '포인트 파트너 카드 왼쪽에 크게 나가는 사진입니다. 셀러 프로필 사진과 따로 올리며, 비우면 셀러 프로필 사진이 나갑니다(프로필 사진이 열리지 않으면 기본 아바타). 정사각형 사진을 권합니다.',
  'pages.frontendPages.items.cardImageHint':
    '라이브 페이지 카드에 크게 나가는 사진입니다. 셀러 프로필 사진과 따로 올리며, 비우면 셀러 프로필 사진이 나갑니다. 카드 모양이 PC·모바일 같아 한 장이면 되고, 세로 사진(3:4 안팎)을 권합니다.',
  'pages.frontendPages.items.clipCardImageHint':
    '숏클립 카드에 크게 나가는 사진입니다. 방송에 영상이 있으면 웹 카드에서는 영상이 재생되고, 이 사진은 영상이 뜨기 전과 앱에서 보입니다. 비우면 셀러 사진이 나갑니다. 세로 사진(3:4 안팎)을 권합니다.',
  'pages.frontendPages.items.benefitCardImageHint':
    '라이브 혜택 카드에 크게 나가는 사진입니다. 카운트다운 끝을 정하면 사진 아래쪽에 카운트다운 띠가 겹치니 중요한 글씨는 아래쪽을 피해 주세요. 비우면 셀러 사진(없으면 대표 상품 사진)이 나갑니다. 세로 사진(3:4 안팎)을 권합니다.',
  'pages.frontendPages.items.unlistedSpotlightProduct': '(목록에 없는 상품) {id}',
  'pages.frontendPages.items.addThisSession': '담기',
  'pages.frontendPages.items.alreadyAdded': '이미 담김',
  'pages.frontendPages.items.advisoryHint': '카드는 나가지만 일부가 빠집니다.',
  'pages.frontendPages.items.badgeText': '배지 문구',
  'pages.frontendPages.items.blockingHint': '이 카드는 지금 프론트에 나가지 않습니다.',
  'pages.frontendPages.items.changeImage': '이미지 바꾸기',
  'pages.frontendPages.items.changeLanding': '랜딩 이미지 변경',
  'pages.frontendPages.items.clearImage': '지우기',
  'pages.frontendPages.items.clearLanding': '랜딩 이미지 해제',
  'pages.frontendPages.items.count': '{count}/{max}개',
  'pages.frontendPages.items.discountLabel': '할인 문구',
  'pages.frontendPages.items.empty': '아직 카드가 없습니다.',
  'pages.frontendPages.items.spotlightEmpty': '아직 담은 셀러가 없습니다. 위의 [셀러 추가]를 누르세요.',
  'pages.frontendPages.items.spotlightLegacySession':
    '예전 방식(방송 일정에서 고른 카드)입니다. 이 행을 지우고 [셀러 추가]로 다시 담은 뒤, 셀러 상품을 고르세요.',
  'pages.frontendPages.items.spotlightOrderHint':
    '왼쪽 손잡이를 끌어 순서를 바꿉니다. 맨 위가 첫 화면이고, 그 다음이 오른쪽 화살표로 넘어가는 셀러입니다. 각 행에서 라이브 페이지에 보일 상품을 고릅니다.',
  'pages.frontendPages.items.sessionPickerTitle': '담을 방송 고르기',
  'pages.frontendPages.items.countdownEndAt': '카운트다운 끝',
  'pages.frontendPages.items.countdownEndAtHint': '이 시각까지 카드 사진 아래에 남은 시간이 흐르고, 지나면 「시간 종료」가 됩니다. 비우면 카운트다운을 그리지 않습니다. 한국 시간 기준입니다.',
  'pages.frontendPages.items.countdownRunning': '카운트다운 중',
  'pages.frontendPages.items.countdownOver': '지남 — 「시간 종료」로 나감',
  'pages.frontendPages.items.countdownNone': '카운트다운 없음',
  'pages.frontendPages.items.countdownPreset1h': '1시간 뒤',
  'pages.frontendPages.items.countdownPreset6h': '6시간 뒤',
  'pages.frontendPages.items.countdownPreset24h': '24시간 뒤',
  'pages.frontendPages.items.countdownPreset3d': '3일 뒤',
  'pages.frontendPages.items.benefitExtra': '파란 이벤트 문구 (비우면 방송의 슬로건)',
  'pages.frontendPages.items.reelsSwitchedToManual': '방송을 담아 「방송 직접 고르기」로 바꿨습니다. 저장하면 담은 방송이 나갑니다.',
  'pages.frontendPages.items.sessionPickerHint': '담을 방송을 고르세요. 이미 넣은 방송은 다시 담을 수 없습니다.',
  'pages.frontendPages.items.sessionPickerReplaceHint': '이 칸에 넣을 다른 방송을 고르세요.',
  'pages.frontendPages.items.sessionPickerEmpty': '고를 수 있는 예정·진행 중 방송이 없습니다. 라이브 일정에서 먼저 만드세요.',
  'pages.frontendPages.items.sessionPickerAllSellers': '전체 셀러',
  'pages.frontendPages.items.sessionPickerSearch': '상품번호·방송 제목·셀러 검색',
  'pages.frontendPages.items.sessionPickerNoMatch': '조건에 맞는 방송이 없습니다.',
  'pages.frontendPages.items.changeSession': '다른 방송으로 바꾸기',
  'pages.frontendPages.items.useThisSession': '이 방송으로 바꾸기',
  'pages.frontendPages.items.extraOptional': '할인·이벤트 문구 (보통 쓰지 않음)',
  'pages.frontendPages.items.entityReadOnly': '이 값들은 원본 화면에서만 고칩니다.',
  'pages.frontendPages.items.eventLinkUrl': '이벤트 링크',
  'pages.frontendPages.items.eventText': '이벤트 문구',
  'pages.frontendPages.items.externalId': '외부 상품번호',
  'pages.frontendPages.items.externalLinkRequired': '플랫폼+외부 상품번호 또는 링크 중 하나는 있어야 합니다.',
  'pages.frontendPages.items.imageMobile': '모바일 이미지',
  'pages.frontendPages.items.imagePc': 'PC 이미지',
  'pages.frontendPages.items.circleImage': '원형 이미지',
  'pages.frontendPages.items.circleImageHint':
    '프론트 카테고리 원에 나갑니다. 정사각형 사진을 올리면 원으로 자릅니다. 비우면 회색 원이 보입니다.',
  'pages.frontendPages.items.circleTitle': '원에 나갈 이름',
  'pages.frontendPages.items.circleBadgeHint': '비우면 배지가 없습니다. HOT 같이 짧게 쓰세요.',
  'pages.frontendPages.items.landingChanged': '랜딩 이미지를 바꿨습니다.',
  'pages.frontendPages.items.landingClearBody': '해제하면 상품의 첫 이미지가 카드에 쓰입니다.',
  'pages.frontendPages.items.landingClearTitle': '랜딩 이미지를 해제합니다',
  'pages.frontendPages.items.landingCleared': '랜딩 이미지를 해제했습니다.',
  'pages.frontendPages.items.landingFailed': '랜딩 이미지를 바꾸지 못했습니다.',
  'pages.frontendPages.items.landingHint': '카드 그림은 상품의 랜딩 이미지입니다. 이 밴드에서만 다른 그림을 쓰려면 외부 카드로 넣으세요.',
  'pages.frontendPages.items.landingWarnBody': '이 그림은 상품에 저장됩니다. 상품 상세의 첫 이미지와, 이 상품이 놓인 다른 페이지의 카드에도 그대로 반영됩니다.',
  'pages.frontendPages.items.landingWarnOk': '바꾸겠습니다',
  'pages.frontendPages.items.landingWarnTitle': '랜딩 이미지를 바꿉니다',
  'pages.frontendPages.items.linkPreview': '링크 미리보기',
  'pages.frontendPages.items.linkUrl': '링크',
  'pages.frontendPages.items.liveScheduleEditLink': '라이브 일정에서 수정 →',
  'pages.frontendPages.items.metricCaption': '문구',
  'pages.frontendPages.items.mobileLimit': '모바일에서는 앞 {count}개만 보입니다.',
  'pages.frontendPages.items.notImage': '이미지 파일만 올릴 수 있습니다.',
  'pages.frontendPages.items.openInNewTab': '새 탭으로 열기',
  'pages.frontendPages.items.overLimit': '슬롯 상한을 넘었습니다({count}/{max}). 카드를 줄이거나 숨기면 저장할 수 있습니다.',
  'pages.frontendPages.items.pickCoupon': '쿠폰 고르기',
  'pages.frontendPages.items.pickLiveSession': '라이브 세션 고르기',
  'pages.frontendPages.items.pickSeller': '셀러 고르기',
  'pages.frontendPages.items.pickStore': '스토어 고르기',
  'pages.frontendPages.items.pickTimeSale': '타임세일 고르기',
  'pages.frontendPages.items.pickerExcluded': '카드에서 제외됨',
  'pages.frontendPages.items.pickerExcludedHint':
    '이 화면의 상품 {count}개는 이 범위의 공개 조건(노출·상품 유형)에 맞지 않아 담을 수 없습니다.',
  'pages.frontendPages.items.pickerImage': '이미지',
  'pages.frontendPages.items.pickerLoadFailed': '상품 목록을 불러오지 못했습니다.',
  'pages.frontendPages.items.productViewRequired':
    '상품 관리 권한이 필요합니다. 상품 목록을 불러올 수 없습니다.',
  'pages.frontendPages.items.productEditRequired': '이 작업에는 상품 편집 권한이 필요합니다.',
  'pages.frontendPages.items.productEditDenied':
    '이 작업에는 상품 편집 권한이 필요합니다 — 이미지는 바뀌지 않았습니다.',
  'pages.frontendPages.items.productNamesUnavailable':
    '상품을 읽을 권한이 없어 카드에 이름 대신 id 가 보입니다. 카드 자체는 정상으로 나갑니다.',
  'pages.frontendPages.items.sellerViewRequired':
    '라이브 셀러 조회 권한이 필요합니다. 셀러 목록을 불러올 수 없습니다.',
  'pages.frontendPages.items.pickerProduct': '상품',
  'pages.frontendPages.items.pickerProductNo': '품번',
  'pages.frontendPages.items.pickerScopeHint': '{scope} 범위의 판매중 상품만 보여 줍니다.',
  'pages.frontendPages.items.pickerSearch': '상품명·품번으로 검색',
  'pages.frontendPages.items.pickerTitle': '상품 고르기',
  'pages.frontendPages.items.platform': '플랫폼',
  'pages.frontendPages.items.price': '가격',
  'pages.frontendPages.items.rankDelta': '순위 변동',
  'pages.frontendPages.items.rankDeltaPlaceholder': 'NEW / +2',
  'pages.frontendPages.items.rawRefHint': '아직 전용 피커가 없습니다. 해당 관리 화면에서 id 를 복사해 넣으세요.',
  'pages.frontendPages.items.reelId': '숏클립 id',
  'pages.frontendPages.items.remove': '삭제',
  'pages.frontendPages.items.salePrice': '할인가',
  'pages.frontendPages.items.scheduleId': '편성표 id',
  'pages.frontendPages.items.sessionHidden': '숨김',
  'pages.frontendPages.items.sessionProducts': '상품 {count}개',
  'pages.frontendPages.items.storeCopyHint':
    '사진·이름·홍보 문구·대표 상품은 스토어 관리에서 고칩니다. 카드 사진 아래 파란 줄이 이벤트 문구(누르면 이벤트 링크로 이동)이고, 그 아래 검은 줄이 배지 문구입니다. 둘 다 이 진열에서만 적용됩니다.',
  'pages.frontendPages.items.storeEventLinkHint':
    '이벤트 문구를 누르면 이 주소로 이동합니다. 문구가 비어 있으면 카드에 "이벤트" 링크가 나갑니다.',
  'pages.frontendPages.items.storeBadgeHint':
    '카드 사진 아래, 이벤트 문구 다음 줄에 검은 글씨로 나옵니다. 비워 두면 스토어 관리의 홍보 문구가 나옵니다.',
  'pages.frontendPages.items.storeEditLink': '스토어 관리에서 수정 →',
  'pages.frontendPages.items.storeEventText': '이벤트 문구 (이 진열 전용)',
  'pages.frontendPages.items.storeFeatured': '추천 노출',
  'pages.frontendPages.items.storeInactive': '비활성',
  'pages.frontendPages.items.subtitle': '카드 소제목',
  'pages.frontendPages.items.timeSaleHidden': '숨김',
  'pages.frontendPages.items.title': '카드 제목',
  'pages.frontendPages.items.tooLarge': '파일이 너무 큽니다.',
  'pages.frontendPages.items.upload': '이미지 올리기',
  'pages.frontendPages.items.uploadFailed': '이미지를 올리지 못했습니다.',
  'pages.frontendPages.items.uploadSuccess': '이미지를 올렸습니다.',
  'pages.frontendPages.items.usedElsewhere': '다른 페이지 {count}곳',
  // fp:layout
  'pages.frontendPages.layout.banner': '배너',
  'pages.frontendPages.layout.grid': '격자',
  'pages.frontendPages.layout.hero': '히어로',
  'pages.frontendPages.layout.list': '목록',
  'pages.frontendPages.layout.rail': '가로 스크롤',
  // fp:liveState
  'pages.frontendPages.liveState.all': '전체',
  'pages.frontendPages.liveState.live': '방송 중',
  'pages.frontendPages.liveState.recent': '최근 방송',
  'pages.frontendPages.liveState.scheduled': '방송 예정',
  // fp:(top)
  'pages.frontendPages.metaMissing': '밴드 규칙(메타)을 불러오지 못해 저장할 수 없습니다. 잠시 후 다시 열어 주세요.',
  'pages.frontendPages.loadErrorNotice': '값을 못 읽어서 폼을 잠갔습니다. 이대로 저장하면 SEO 문구가 빈 값으로 덮입니다. 다시 불러온 뒤에 고치세요.',
  'pages.frontendPages.loadErrorNoticeSite': '값을 못 읽어서 폼을 잠갔습니다. 이대로 저장하면 세 언어 태그라인이 비고 카카오 문의 링크가 기본값으로 되돌아갑니다. 사이트 저장은 모든 페이지의 캐시를 비우므로 그 빈 값이 곧바로 머리글에 나갑니다. 다시 불러온 뒤에 고치세요.',
  // fp:preview
  'pages.frontendPages.preview.autoHint': '자동 진열입니다. 실제 카드는 저장 후 규칙으로 채워집니다.',
  'pages.frontendPages.preview.blocked': '이 페이지는 창 안에 넣을 수 없게 되어 있습니다. 새 창에서 열어 확인하세요.',
  'pages.frontendPages.preview.deviceHidden': '이 화면에서는 안 나감',
  'pages.frontendPages.preview.deviceMobile': '모바일 {width}',
  'pages.frontendPages.preview.devicePc': 'PC {width}',
  'pages.frontendPages.preview.emptySlot': '카드 없음',
  'pages.frontendPages.preview.failed': '미리보기 주소를 만들지 못했습니다.',
  'pages.frontendPages.preview.frameTitle': '페이지 미리보기',
  'pages.frontendPages.preview.includeHidden': '숨김 포함',
  'pages.frontendPages.preview.includeHiddenHint': '켜면 숨김 밴드와 숨김 카드까지 그려 봅니다. 방문자에게는 보이지 않습니다.',
  'pages.frontendPages.preview.mobile': '모바일',
  'pages.frontendPages.preview.mobileCut': '모바일 제외',
  'pages.frontendPages.preview.more': '더보기',
  'pages.frontendPages.preview.noTitle': '(제목 없음)',
  'pages.frontendPages.preview.openNewWindow': '새 창에서 열기',
  'pages.frontendPages.preview.originConfirmed': '지금 액자에 실린 곳: {origin} — 백엔드 미리보기 응답으로 확인한 주소입니다.',
  'pages.frontendPages.preview.originSeed': '지금 액자에 실린 곳: {origin} — 관리자 빌드에 주입된 값입니다. [숨김 포함]을 한 번 켜면 백엔드가 실제로 쓰는 주소로 맞춰집니다.',
  'pages.frontendPages.preview.pc': 'PC',
  'pages.frontendPages.preview.sectionHidden': '숨김',
  'pages.frontendPages.preview.title': '카드 미리보기',
  // fp:(top)
  'pages.frontendPages.previewFailed': '미리보기 주소를 만들지 못했습니다.',
  'pages.frontendPages.previewUnavailable': '미리보기 서버(Redis)가 없어 발급할 수 없습니다.',
  // fp:productScope
  'pages.frontendPages.productScope.all': '전체',
  'pages.frontendPages.productScope.live': '라이브 상품',
  'pages.frontendPages.productScope.own': '자사몰 상품',
  // fp:(top)
  'pages.frontendPages.readOnlyNotice': '보기 전용입니다. 값은 볼 수 있지만 저장할 수 없습니다.',
  // fp:refType
  'pages.frontendPages.refType.banner': '배너',
  'pages.frontendPages.refType.categoryLink': '카테고리 링크',
  'pages.frontendPages.refType.coupon': '쿠폰',
  'pages.frontendPages.refType.external': '외부 상품',
  'pages.frontendPages.refType.liveStatus': '라이브 세션',
  'pages.frontendPages.refType.metric': '문구 줄',
  'pages.frontendPages.refType.product': '상품',
  'pages.frontendPages.refType.reel': '숏클립',
  'pages.frontendPages.refType.schedule': '편성표',
  'pages.frontendPages.refType.seller': '셀러',
  'pages.frontendPages.refType.store': '스토어',
  'pages.frontendPages.refType.timeSale': '타임세일',
  // fp:(top)
  'pages.frontendPages.reorderFailed': '순서를 바꾸지 못했습니다.',
  'pages.frontendPages.reload': '다시 불러오기',
  'pages.frontendPages.reordered': '순서를 바꿨습니다.',
  // fp:salesMetric
  'pages.frontendPages.salesMetric.hidden': '표시 안 함',
  'pages.frontendPages.salesMetric.liveSoldAmountSum': '라이브 판매 금액',
  'pages.frontendPages.salesMetric.totalItemsSold': '누적 판매 수량',
  // fp:(top)
  'pages.frontendPages.saveAndPreview': '저장 후 페이지 미리보기',
  'pages.frontendPages.saveBlockedByLoad': '값을 못 읽었습니다. [다시 불러오기] 뒤에 저장할 수 있습니다.',
  'pages.frontendPages.savedWithAdvisory': '카드 {count}장에서 상품 일부가 빠집니다.',
  // fp:schedule
  'pages.frontendPages.schedule.addSession': '세션 추가',
  'pages.frontendPages.schedule.assignTime': '시각 지정',
  'pages.frontendPages.schedule.assignTimeTitle': '시작 시각 지정',
  'pages.frontendPages.schedule.cancel': '취소',
  'pages.frontendPages.schedule.column.actions': '작업',
  'pages.frontendPages.schedule.column.date': '날짜',
  'pages.frontendPages.schedule.column.productCount': '상품 수',
  'pages.frontendPages.schedule.column.seller': '셀러',
  'pages.frontendPages.schedule.column.source': '출처',
  'pages.frontendPages.schedule.column.time': '시간',
  'pages.frontendPages.schedule.column.title': '제목',
  'pages.frontendPages.schedule.column.visible': '노출',
  'pages.frontendPages.schedule.convert': '세션으로 전환',
  'pages.frontendPages.schedule.convertHideFailed': '세션은 만들었지만 구 일정을 숨기지 못했습니다.',
  'pages.frontendPages.schedule.convertHint': '구 일정의 내용을 옮겨 새 세션을 만듭니다.',
  'pages.frontendPages.schedule.convertNotice': '저장하면 새 세션이 만들어지고 원래 구 일정은 숨겨집니다.',
  'pages.frontendPages.schedule.convertSuccess': '세션으로 전환했습니다.',
  'pages.frontendPages.schedule.delete': '삭제',
  'pages.frontendPages.schedule.deleteConfirm': '이 일정을 삭제할까요?',
  'pages.frontendPages.schedule.deleteContentLegacy': '구 일정을 지우면 되돌릴 수 없습니다.',
  'pages.frontendPages.schedule.deleteContentSession': '세션을 지우면 프론트의 스포트라이트에서도 사라집니다.',
  'pages.frontendPages.schedule.deleteFailed': '지우지 못했습니다.',
  'pages.frontendPages.schedule.deleteSuccess': '지웠습니다.',
  'pages.frontendPages.schedule.edit': '수정',
  'pages.frontendPages.schedule.editLegacy': '구 일정 수정',
  'pages.frontendPages.schedule.editSession': '세션 수정',
  'pages.frontendPages.schedule.emptyDay': '없음',
  'pages.frontendPages.schedule.field.endAt': '종료 시각',
  'pages.frontendPages.schedule.field.endAtPlaceholder': '종료 시각 선택',
  'pages.frontendPages.schedule.field.mainImage': '스포트라이트 큰 사진',
  'pages.frontendPages.schedule.field.mainImageHint': '스포트라이트에 크게 걸리는 세로 사진입니다. 3:4 비율을 권합니다.',
  'pages.frontendPages.schedule.field.periodHint': '한국 시간 기준입니다. 시작 시각 없이 만들면 "시간 미정"으로 저장됩니다. 다만 한 번 넣은 시작 시각은 이 화면에서 비울 수 없습니다 — 칸을 비우고 저장해도 서버의 기존 시각이 그대로 남습니다. 방송을 취소하려면 노출을 끄거나 삭제하세요.',
  'pages.frontendPages.schedule.field.products': '라이브 상품',
  'pages.frontendPages.schedule.field.productsHint': '스포트라이트에 나갈 상품을 최대 3개까지 고릅니다. 고른 순서대로 나갑니다.',
  'pages.frontendPages.schedule.field.seller': '셀러',
  'pages.frontendPages.schedule.field.sellerPlaceholder': '셀러 이름이나 코드로 검색',
  'pages.frontendPages.schedule.field.slogan': '슬로건',
  'pages.frontendPages.schedule.field.sloganHint': '스포트라이트 사진 위에 겹쳐 나오는 짧은 문구입니다.',
  'pages.frontendPages.schedule.field.sloganPlaceholder': '예: 오늘만 이 가격',
  'pages.frontendPages.schedule.field.spotlightLabel': '스포트라이트 라벨',
  'pages.frontendPages.schedule.field.spotlightLabelHint': '스포트라이트 위에 붙는 짧은 말머리입니다.',
  'pages.frontendPages.schedule.field.spotlightLabelPlaceholder': '예: 오늘의 라이브',
  'pages.frontendPages.schedule.field.startAt': '시작 시각',
  'pages.frontendPages.schedule.field.startAtPlaceholder': '시작 시각 선택',
  'pages.frontendPages.schedule.field.thumbnail': '라이브 찬스 카드 사진',
  'pages.frontendPages.schedule.field.thumbnailHint': '라이브 찬스 카드에 쓰는 정사각 사진입니다. 1:1 비율을 권합니다.',
  'pages.frontendPages.schedule.field.title': '라이브 제목',
  'pages.frontendPages.schedule.field.titlePlaceholder': '라이브 제목 입력',
  'pages.frontendPages.schedule.field.visible': '노출',
  'pages.frontendPages.schedule.filteredByDate': '{date}만 보기',
  'pages.frontendPages.schedule.intro': '프론트 라이브 페이지에 나가는 방송 일정입니다.',
  'pages.frontendPages.schedule.introDetail': '날짜 칸은 오늘 기준 앞 3일부터 뒤 6일까지 열 칸을 보여 줍니다. 세션과 구 일정을 함께 그리며, 모든 시각은 한국 시간 기준입니다.',
  'pages.frontendPages.schedule.legacyHint': '셀러가 미리 적어 둔 구 일정입니다. 제목과 시각, 노출만 고칠 수 있습니다.',
  'pages.frontendPages.schedule.legacyUnavailable': '구 일정 목록을 불러오지 못해 세션만 표시합니다.',
  'pages.frontendPages.schedule.loadFailed': '일정을 불러오지 못했습니다.',
  'pages.frontendPages.schedule.missingAlert': '시작 시각이 없는 세션이 {count}건 있습니다.',
  'pages.frontendPages.schedule.missingChipHint': '눌러서 모아 보기',
  'pages.frontendPages.schedule.missingHint': '시작 시각이 없는 세션은 어느 날짜 칸에도 서지 못합니다. 시작 시각을 넣으면 그 날짜 칸에 섭니다. 한국 시간 기준입니다.',
  'pages.frontendPages.schedule.missingOnly': '시간 미정만 보기',
  'pages.frontendPages.schedule.nextWeek': '다음 주',
  'pages.frontendPages.schedule.prevWeek': '이전 주',
  'pages.frontendPages.schedule.productPicker.empty': '아직 담은 상품이 없습니다.',
  'pages.frontendPages.schedule.productPicker.excluded': '카드에서 제외',
  'pages.frontendPages.schedule.productPicker.excludedHint': '숨김이거나 판매중이 아니어서 프론트 카드에는 나오지 않습니다.',
  'pages.frontendPages.schedule.productPicker.limit': '상품은 최대 {max}개까지 담을 수 있습니다.',
  'pages.frontendPages.schedule.productPicker.moveDown': '아래로',
  'pages.frontendPages.schedule.productPicker.moveUp': '위로',
  'pages.frontendPages.schedule.productPicker.remove': '빼기',
  'pages.frontendPages.schedule.productPicker.search': '상품명 · 상품번호 검색',
  'pages.frontendPages.schedule.readOnly':
    '보기 전용 권한입니다. 편집하려면 프론트 페이지 편집 또는 라이브 셀러 편집 권한이 필요합니다.',
  'pages.frontendPages.schedule.uploadNoPermission':
    '이미지 업로드에는 상품 편집 권한이 필요합니다.',
  'pages.frontendPages.schedule.productPicker.noPermission':
    '상품 관리 권한이 없어 상품을 고를 수 없습니다.',
  'pages.frontendPages.schedule.refresh': '새로고침',
  'pages.frontendPages.schedule.save': '저장',
  'pages.frontendPages.schedule.saveFailed': '저장하지 못했습니다.',
  'pages.frontendPages.schedule.saveSuccess': '저장했습니다.',
  'pages.frontendPages.schedule.sellerFilterAll': '셀러 전체',
  'pages.frontendPages.schedule.source.legacy': '구 일정',
  'pages.frontendPages.schedule.source.missing': '시간 미정',
  'pages.frontendPages.schedule.source.session': '세션',
  'pages.frontendPages.schedule.stripHint': '칸을 누르면 그 날짜만 봅니다. 한국 시간 기준입니다.',
  'pages.frontendPages.schedule.stripTitle': '날짜별 방송',
  'pages.frontendPages.schedule.tableEmpty': '일정이 없습니다.',
  'pages.frontendPages.schedule.today': '오늘',
  'pages.frontendPages.schedule.todayBadge': '오늘',
  'pages.frontendPages.schedule.upload': '이미지 업로드',
  'pages.frontendPages.schedule.uploadChange': '이미지 변경',
  'pages.frontendPages.schedule.uploadClear': '지우기',
  'pages.frontendPages.schedule.uploadFailed': '이미지를 올리지 못했습니다.',
  'pages.frontendPages.schedule.uploadNotImage': '이미지 파일만 올릴 수 있습니다.',
  'pages.frontendPages.schedule.uploadSuccess': '이미지를 올렸습니다.',
  'pages.frontendPages.schedule.uploadTooLarge': '이미지 크기는 10MB 이하여야 합니다.',
  'pages.frontendPages.schedule.validate.periodOrder': '종료 시각은 시작 시각보다 뒤여야 합니다.',
  'pages.frontendPages.schedule.validate.productRequired': '상품을 하나 이상 고르세요.',
  'pages.frontendPages.schedule.validate.sellerRequired': '셀러를 고르세요.',
  'pages.frontendPages.schedule.validate.startRequired': '시작 시각을 고르세요.',
  'pages.frontendPages.schedule.validate.titleRequired': '제목을 입력하세요.',
  'pages.frontendPages.schedule.visibleUpdateFailed': '노출 설정을 바꾸지 못했습니다.',
  // fp:sectionType
  'pages.frontendPages.sectionType.banner.desc': '이미지 한 장으로 된 띠 배너.',
  'pages.frontendPages.sectionType.banner.name': '배너',
  'pages.frontendPages.sectionType.categoryGroups.desc': '카테고리 링크 카드를 묶음(슬롯)으로 나눠 보여 줍니다. 슬롯 1~10개.',
  'pages.frontendPages.sectionType.categoryGroups.name': '카테고리 묶음',
  'pages.frontendPages.sectionType.categoryTabs.desc': '카테고리 탭을 눌러 상품을 갈아 끼웁니다.',
  'pages.frontendPages.sectionType.categoryTabs.name': '카테고리 탭',
  'pages.frontendPages.sectionType.coupon.desc': '받아 가는 쿠폰 카드를 늘어놓습니다.',
  'pages.frontendPages.sectionType.coupon.name': '쿠폰',
  'pages.frontendPages.sectionType.eventTicker.desc': '이벤트 배너가 좁은 띠에서 흘러갑니다.',
  'pages.frontendPages.sectionType.eventTicker.name': '이벤트 띠',
  'pages.frontendPages.sectionType.heroLive.desc': '라이브 페이지 맨 위의 큰 숏클립 한 편.',
  'pages.frontendPages.sectionType.heroLive.name': '라이브 히어로',
  'pages.frontendPages.sectionType.heroTriple.desc': '왼쪽 큰 칸 · 캐러셀 · 오른쪽 위아래로 나뉜 첫 화면. 수동 진열만 됩니다.',
  'pages.frontendPages.sectionType.heroTriple.name': '히어로 3분할',
  'pages.frontendPages.sectionType.liveChance.desc': "칩으로 나눈 라이브 세션 카드. 첫 칩은 '전체'로 고정되고 칩은 최대 6개입니다.",
  'pages.frontendPages.sectionType.liveChance.name': '라이브 찬스',
  'pages.frontendPages.sectionType.liveNow.desc': '방송 중인 셀러를 줄지어 보여 줍니다.',
  'pages.frontendPages.sectionType.liveNow.name': '지금 방송 중',
  'pages.frontendPages.sectionType.moreToLove.desc': '페이지 맨 아래에서 계속 더 불러오는 상품 격자. 최대 60개.',
  'pages.frontendPages.sectionType.moreToLove.name': '함께 볼 만한 상품',
  'pages.frontendPages.sectionType.productColumns.desc': '세 열에 상품을 두 개씩 놓습니다. 수동 진열만 됩니다.',
  'pages.frontendPages.sectionType.productColumns.name': '상품 3열',
  'pages.frontendPages.sectionType.productGrid.desc': '상품 카드를 격자로 펼칩니다.',
  'pages.frontendPages.sectionType.productGrid.name': '상품 격자',
  'pages.frontendPages.sectionType.productRail.desc': '상품 카드를 한 줄로 가로 스크롤합니다.',
  'pages.frontendPages.sectionType.productRail.name': '상품 줄',
  'pages.frontendPages.sectionType.ranking.desc': '오늘·3일·1주 탭으로 나뉜 순위표. 슬롯당 10개, 모바일 4개.',
  'pages.frontendPages.sectionType.ranking.name': '랭킹',
  'pages.frontendPages.sectionType.reels.desc': '라이브 찬스와 같은 방송 카드(파란 숏클립 표시)를 가로로 넘겨 봅니다. 최대 12개.',
  'pages.frontendPages.sectionType.reels.name': '숏클립',
  'pages.frontendPages.sectionType.schedule.desc': '예정된 방송을 시간 순으로 늘어놓습니다.',
  'pages.frontendPages.sectionType.schedule.name': '방송 편성표',
  'pages.frontendPages.sectionType.sellerRail.desc': '셀러 프로필 카드를 가로로 늘어놓습니다. 판매량 표시를 고를 수 있습니다.',
  'pages.frontendPages.sectionType.sellerRail.name': '셀러 줄',
  'pages.frontendPages.sectionType.sellerRanking.desc': '순위 배지가 붙은 셀러 방송 카드. 셀러를 담으면 그 순서이고, 비우면 누적 시청·판매로 자동 정렬됩니다. 최대 20명입니다.',
  'pages.frontendPages.sectionType.sellerRanking.name': '인기 BEST 셀러',
  'pages.frontendPages.sectionType.sellerSpotlight.desc':
    '라이브 셀러를 세로 큰 카드로 띄웁니다. 셀러마다 노출 상품을 고를 수 있습니다. 최대 10개.',
  'pages.frontendPages.sectionType.sellerSpotlight.name': '라이브 셀러 캐러셀',
  'pages.frontendPages.sectionType.storeRail.desc': '스토어 카드를 가로로 늘어놓습니다. 최대 12개.',
  'pages.frontendPages.sectionType.storeRail.name': '추천 스토어',
  'pages.frontendPages.sectionType.productTabs.desc': '칩(탭)마다 상품 조건이 다른 상품 레일. 탭 1~8개, 탭당 최대 20개.',
  'pages.frontendPages.sectionType.productTabs.name': '상품 탭',
  'pages.frontendPages.sectionType.categoryShowcase.desc': '카테고리 줄과 고른 카테고리의 하위 탭·상품 줄. 카테고리 최대 12개, 비워 두면 1단계 카테고리가 모두 나갑니다. 상품은 하위 탭마다 따로 담습니다.',
  'pages.frontendPages.sectionType.categoryShowcase.name': '카테고리 쇼케이스',
  'pages.frontendPages.sectionType.marketShowcase.desc': '공급처 탭(1688·타오바오·VVIC)과 마켓플레이스 카테고리 칩, 하위 탭·상품 레일. 공급처마다 칩 최대 20개. 카드가 없는 칩은 카테고리 이름으로 검색합니다.',
  'pages.frontendPages.sectionType.marketShowcase.name': '해외직구 카테고리 상품',
  'pages.frontendPages.sectionType.ticker.desc': '짧은 문구가 흘러가는 띠. 수동 진열만 됩니다.',
  'pages.frontendPages.sectionType.ticker.name': '문구 띠',
  'pages.frontendPages.sectionType.timeSale.desc': '방송 카드 사진 아래에 카운트다운 띠가 붙는 혜택 카드. 끝 시각은 카드마다 정합니다. 최대 12개.',
  'pages.frontendPages.sectionType.timeSale.name': '라이브 혜택',
  // fp:settings
  'pages.frontendPages.settings.notSavedYet': '이 페이지는 아직 저장된 설정이 없습니다. 지금 값은 기본값입니다.',
  'pages.frontendPages.settings.previewCard': '미리보기',
  'pages.frontendPages.settings.seoCard': '검색 노출',
  'pages.frontendPages.settings.seoDescription': '페이지 설명',
  'pages.frontendPages.settings.seoDescriptionHint': '검색 결과에서 제목 아래에 보입니다. 두 줄 정도가 적당합니다.',
  'pages.frontendPages.settings.seoTitle': '페이지 제목',
  'pages.frontendPages.settings.seoTitleHint': '브라우저 탭과 검색 결과의 제목에 쓰입니다.',
  // fp:site
  'pages.frontendPages.site.advanced': '고급',
  'pages.frontendPages.site.categoryLimit.en': '영어',
  'pages.frontendPages.site.categoryLimit.ko': '한국어',
  'pages.frontendPages.site.categoryLimit.zh': '중국어',
  'pages.frontendPages.site.categoryLimitHint': '헤더에 펼쳐 보일 카테고리 개수입니다. 언어마다 이름 길이가 달라 따로 정합니다.',
  'pages.frontendPages.site.categorySourceHint': '카테고리 자체는 상품관리 › 카테고리에서 고칩니다.',
  'pages.frontendPages.site.headerTagline': '헤더 태그라인',
  'pages.frontendPages.site.headerTaglineHint': '헤더 맨 윗줄에 보입니다. 스크롤하면 숨겨집니다.',
  'pages.frontendPages.site.headerTaglineMobile': '모바일 태그라인(선택)',
  'pages.frontendPages.site.headerTaglineMobileHint': '비우면 위 태그라인을 그대로 씁니다. 모바일은 좁으니 짧게 쓰세요.',
  'pages.frontendPages.site.headerTaglinePlaceholder': '예: 오늘도 최저가로 만나는 라이브 쇼핑',
  'pages.frontendPages.site.kakaoInquiryUrl': '카카오톡 문의 링크',
  'pages.frontendPages.site.kakaoInquiryUrlHint': '헤더와 푸터의 문의 버튼이 이 주소로 열립니다.',
  'pages.frontendPages.site.notSavedYet': '아직 저장된 공통 설정이 없습니다. 지금 값은 기본값입니다.',
  'pages.frontendPages.site.scopeNotice': '여기서 바꾼 값은 모든 페이지에 함께 적용됩니다.',
  'pages.frontendPages.site.urlWarning': 'http:// 또는 https:// 로 시작하는 주소가 아닙니다.',
  // fp:slotKey
  'pages.frontendPages.slotKey.1w': '1주',
  'pages.frontendPages.slotKey.3d': '3일',
  'pages.frontendPages.slotKey.all': '전체',
  'pages.frontendPages.slotKey.carousel': '캐러셀',
  'pages.frontendPages.slotKey.col1': '1열',
  'pages.frontendPages.slotKey.col2': '2열',
  'pages.frontendPages.slotKey.col3': '3열',
  'pages.frontendPages.slotKey.left': '왼쪽 큰 칸',
  'pages.frontendPages.slotKey.rightBottom': '오른쪽 아래',
  'pages.frontendPages.slotKey.rightTop': '오른쪽 위',
  'pages.frontendPages.slotKey.today': '오늘',
  // fp:slotVariant
  'pages.frontendPages.slotVariant.chance': '라이브 찬스',
  'pages.frontendPages.slotVariant.plain': '기본',
  'pages.frontendPages.slotVariant.ranking': '순위',
  'pages.frontendPages.slotVariant.store': '스토어',
  // fp:autoFill
  'pages.frontendPages.autoFill.title': '비어 있으면 시스템이 채웁니다',
  'pages.frontendPages.autoFill.body':
    '이 자리에는 아직 카드를 넣지 않았습니다. 저장하면 서버가 조건에 맞는 항목으로 자동으로 채웁니다. 직접 담으려면 아래 단추로 추가하세요.',
  'pages.frontendPages.autoFill.tab': '자동',
  // fp:slots
  'pages.frontendPages.slots.allChipHint': "첫 칩은 '전체'입니다. 카테고리를 걸지 않고 모든 세션을 보여 줍니다.",
  'pages.frontendPages.slots.allChipLocked': "'전체' 칩은 지울 수 없습니다.",
  'pages.frontendPages.slots.badgeText': '배지',
  'pages.frontendPages.slots.chipCategories': '이 칩의 카테고리',
  'pages.frontendPages.slots.chipCategoryHint': '자동 모드는 세션 상품의 카테고리로 거릅니다. 간편등록 상품은 카테고리가 비어 있을 수 있어 수동 배정을 권합니다.',
  'pages.frontendPages.slots.tabFlags': '이 탭의 상품 조건',
  'pages.frontendPages.slots.tabFlagsHint': '자동 모드에서 고른 조건을 모두 만족하는 상품이 이 탭에 나갑니다. 비워 두면 섹션 조건만 적용됩니다.',
  'pages.frontendPages.slots.chipRootCategory': '카테고리',
  'pages.frontendPages.slots.chipRootCategoryHint': '1단계 카테고리만 고를 수 있습니다. 고객 화면의 하위 탭은 이 카테고리의 하위 카테고리로 자동 구성되고, 탭마다 나갈 상품은 아래에서 담습니다.',
  'pages.frontendPages.slots.chipPlatform': '이 칩의 공급처',
  'pages.frontendPages.slots.chipMarketCategory': '카테고리',
  'pages.frontendPages.slots.chipMarketCategorySearch': '카테고리 이름으로 검색',
  'pages.frontendPages.slots.chipMarketCategoryHint': '카테고리 관리의 카테고리 중 하위 분류가 있는 것만 나옵니다(이름으로 검색). 하위 탭은 그 하위 분류로 자동 구성되고, 담은 카드가 없으면 카테고리 이름으로 검색한 상품이 나갑니다. 비워 두면 칩 이름으로 검색합니다.',
  'pages.frontendPages.items.importLink': '상품 링크',
  'pages.frontendPages.items.importLinkAction': '가져오기',
  'pages.frontendPages.items.importLinkHint': '1688·타오바오·VVIC 상품 주소를 붙여 넣고 가져오기를 누르면 플랫폼·상품 id·제목·이미지·가격이 채워집니다. 아래 칸에서 직접 고칠 수도 있습니다.',
  'pages.frontendPages.items.importLinkInvalid': '1688·타오바오·VVIC 상품 주소가 아닙니다.',
  'pages.frontendPages.items.importLinkDone': '상품 정보를 가져왔습니다.',
  'pages.frontendPages.items.importLinkFailed': '상품 정보를 가져오지 못했습니다.',
  'pages.frontendPages.slots.chipCategoryRequired': '자동 모드에서는 카테고리를 최소 1개 골라야 합니다. 비우면 전체 칩과 같은 목록이 됩니다.',
  'pages.frontendPages.slots.duplicateKey': '같은 슬롯 키가 이미 있습니다.',
  'pages.frontendPages.slots.iconUrl': '아이콘',
  'pages.frontendPages.slots.iconUrlHint': '프론트가 이 주소를 그림으로 그립니다. 이모지가 아니라 이미지 URL 을 넣으세요.',
  'pages.frontendPages.slots.groupImage': '그룹 원 이미지',
  'pages.frontendPages.slots.groupImageHint':
    '프론트 그룹 원에 나갑니다. 정사각형 사진을 올리면 원으로 자릅니다. 비우면 이름 글자가 원 안에 보입니다.',
  'pages.frontendPages.slots.key': '슬롯 키',
  'pages.frontendPages.slots.legacyNoSlots': '이 밴드에는 아직 슬롯이 없습니다. 슬롯을 저장하면 기존 카드가 첫 슬롯으로 모이며, 슬롯당 상한을 넘으면 저장이 거절됩니다.',
  'pages.frontendPages.slots.minSlots': '슬롯은 최소 {min}개가 있어야 합니다.',
  'pages.frontendPages.slots.moveLeft': '← 앞으로',
  'pages.frontendPages.slots.moveRight': '뒤로 →',
  'pages.frontendPages.slots.noItemsSection': '이 밴드는 카드를 담지 않습니다. 다른 화면의 데이터를 규칙으로 끌어옵니다.',
  'pages.frontendPages.slots.noItemsSlot': '이 슬롯은 카드를 담지 않습니다.',
  'pages.frontendPages.slots.pickTypeFirst': '타입을 먼저 고르세요.',
  'pages.frontendPages.slots.productScope': '상품 범위',
  'pages.frontendPages.slots.rankingAutoHint': '자동 모드에서는 기간탭(오늘/3일/1주)에 카드를 넣지 않습니다. 아래 값은 볼 수만 있고 수동 모드로 바꾸면 다시 고칠 수 있습니다.',
  'pages.frontendPages.slots.scopeInherit': '밴드 값 따르기',
  'pages.frontendPages.slots.title': '라벨',
  'pages.frontendPages.slots.subtitle': '부제',
  'pages.frontendPages.slots.titleMobile': '모바일 라벨',
  'pages.frontendPages.slots.variant': '카드 모양',
  // fp:sortBy
  'pages.frontendPages.sortBy.price_asc': '낮은 가격순',
  'pages.frontendPages.sortBy.price_desc': '높은 가격순',
  'pages.frontendPages.sortBy.rank': '추천순',
  'pages.frontendPages.sortBy.recent': '최신순',
  'pages.frontendPages.sortBy.sold': '판매순',
  'pages.frontendPages.sortBy.views': '시청순',
  // fp:sourceMode
  'pages.frontendPages.sourceMode.auto': '자동 규칙',
  'pages.frontendPages.sourceMode.manual': '수동 진열',
  // fp:(top)
  'pages.frontendPages.typeChangeConfirmBody': '새 타입이 받지 않는 카드 {count}장과 지금 슬롯 구성이 함께 사라집니다. 되돌릴 수 없습니다.',
  'pages.frontendPages.typeChangeConfirmOk': '바꾸겠습니다',
  'pages.frontendPages.typeChangeConfirmTitle': '밴드 타입을 바꿉니다',
  'pages.frontendPages.typeChangeDroppedItems': '새 타입이 받지 않는 카드는 목록에서 뺐습니다.',
  // fp:usedElsewhere
  'pages.frontendPages.unsaved.blockedNote': '프론트에 나가지 않는 카드 {count}장이 남아 있는데 닫습니다.',
  'pages.frontendPages.unsaved.body': '닫으면 지금까지 고친 내용이 사라집니다. 닫을까요?',
  'pages.frontendPages.unsaved.discard': '닫기',
  'pages.frontendPages.unsaved.keepEditing': '계속 편집',
  'pages.frontendPages.unsaved.title': '저장하지 않은 변경이 있습니다',
  'pages.frontendPages.usedElsewhere.badge': '다른 페이지 {count}곳',
  'pages.frontendPages.usedElsewhere.failed': '다른 페이지 목록을 못 읽었습니다.',
  'pages.frontendPages.usedElsewhere.hint': '같은 상품·스토어가 여러 페이지에 놓여 있습니다. 한 곳에서 지워도 다른 곳은 그대로 남습니다.',
  'pages.frontendPages.usedElsewhere.pagesOnly': '페이지만 확인했습니다. 어느 밴드인지는 잠시 후 표시됩니다.',
  'pages.frontendPages.usedElsewhere.retry': '다시 시도',
  'pages.frontendPages.usedElsewhere.title': '이 밴드의 카드가 놓인 곳',
  // fp:validation
  'pages.frontendPages.validation.captionRequired': '{card}의 문구를 채우세요.',
  'pages.frontendPages.validation.cardAt': '{slot} · {index}번째 카드',
  'pages.frontendPages.validation.cardAtNoSlot': '{index}번째 카드',
  'pages.frontendPages.validation.chipCategoryRequired': '칩 "{slot}" 에 카테고리를 최소 1개 골라야 합니다.',
  'pages.frontendPages.validation.externalHalf': '{card}는 플랫폼과 외부 상품번호를 함께 넣어야 합니다.',
  'pages.frontendPages.validation.externalLink': '{card}에 열 수 있는 링크가 없습니다.',
  'pages.frontendPages.validation.imageRequired': '{card}의 이미지를 넣으세요.',
  'pages.frontendPages.validation.linkRequired': '{card}의 링크 대상을 정하세요.',
  'pages.frontendPages.validation.overLimit': '이 밴드의 카드가 상한을 넘었습니다({count}/{max}).',
  'pages.frontendPages.validation.refRequired': '{card}에 연결할 대상을 고르세요.',
  'pages.frontendPages.validation.slotOverLimit': '슬롯 "{slot}" 의 카드가 상한을 넘었습니다({count}/{max}).',
  'pages.frontendPages.validation.sectionOverLimit': '이 블록에는 카드를 최대 {max}개까지 담을 수 있습니다(지금 {count}개).',
  'pages.frontendPages.validation.titleRequired': '{card}의 제목을 넣으세요.',
  'pages.frontendPages.validation.unknownType': '타입 규칙을 찾지 못했습니다.',
  // fp:(top)
  'pages.frontendPages.viewOnlyTooltip': '보기 전용으로 열립니다. 값은 볼 수 있지만 저장할 수 없습니다.',
  // bannerAdvertisement:carousel
  'pages.bannerAdvertisement.carousel.openInNewTab': '새 탭',
  'pages.bannerAdvertisement.carousel.pageKey': '페이지',
  'pages.bannerAdvertisement.carousel.pageKeyAll': '전체 페이지',
  'pages.bannerAdvertisement.carousel.pageKeyHome': '추천',
  'pages.bannerAdvertisement.carousel.pageKeyLive': '라이브',
  'pages.bannerAdvertisement.carousel.pageKeyOverseas': '해외직구',
  'pages.bannerAdvertisement.carousel.pageKeyOwnmall': '자사몰',
  'pages.bannerAdvertisement.carousel.pageKeyTooltip': '이 배너가 붙는 공개 페이지입니다.',
  'pages.bannerAdvertisement.carousel.period': '노출 기간',
  'pages.bannerAdvertisement.carousel.periodAlways': '상시',
  'pages.bannerAdvertisement.carousel.periodTooltip': '비우면 상시 노출입니다. 한국 시각 기준입니다.',
  // products:add
  'pages.products.add.landingImage': '랜딩 대표 이미지(선택)',
  'pages.products.add.landingImageAfterCreate': '상품을 저장한 뒤에 함께 반영됩니다.',
  'pages.products.add.landingImageChange': '이미지 변경',
  'pages.products.add.landingImageClear': '해제',
  'pages.products.add.landingImageHeavy': '이미지가 무겁습니다. 더 작게 올리는 편이 좋습니다.',
  'pages.products.add.landingImageHint': '추천·라이브 카드와 상세 첫 이미지에 사용합니다. 비우면 상품 첫 이미지를 씁니다.',
  'pages.products.add.landingImageNotImage': '이미지 파일만 올릴 수 있습니다',
  'pages.products.add.landingImageRecommend': '권장',
  'pages.products.add.landingImageSaveFailed': '랜딩 대표 이미지 저장에 실패했습니다. 상품은 저장되었습니다.',
  'pages.products.add.landingImageTooLarge': '이미지가 너무 큽니다(최대 10MB)',
  'pages.products.add.landingImageVariants': '변형',
  'pages.products.add.requiredFieldsError': '필수 항목을 입력해 주세요',
  'pages.products.add.uploadError': '이미지 업로드에 실패했습니다',
  // products:category
  'pages.products.category.addCategory': '카테고리 추가',
  'pages.products.category.deleteError': '카테고리 삭제에 실패했습니다',
  'pages.products.category.level1Required': '1차 카테고리를 선택해 주세요',
  // products:list
  'pages.products.list.landingBadge': '랜딩',
  'pages.products.list.setStoreRepresentative': '스토어 대표',
  'pages.products.list.setStoreRepresentativeConfirm': '이 상품을 스토어 카드에 보이는 대표 상품으로 지정할까요?',
  'pages.products.list.setStoreRepresentativeFailed': '대표 상품을 지정하지 못했습니다.',
  'pages.products.list.setStoreRepresentativeSuccess': '추천 페이지 대표 상품으로 지정했습니다.',
  'pages.products.list.storeRepresentativeBadge': '스토어 대표',
  // products:store
  'pages.products.store.avatarImage': '원형 이미지',
  'pages.products.store.avatarImageHint': '스토어 카드와 셀러 목록의 동그란 자리에 쓰입니다.',
  'pages.products.store.basicSection': '기본 정보',
  'pages.products.store.cardPreview': '카드 미리보기',
  'pages.products.store.cardSection': '추천 카드',
  'pages.products.store.changeImage': '이미지 변경',
  'pages.products.store.clearImage': '지우기',
  'pages.products.store.cropHint': '카드에서는 주황 점선 안(316:185)만 보입니다. 사진을 끌어 맞추세요.',
  'pages.products.store.eventLinkInvalid': '올바른 주소가 아닙니다',
  'pages.products.store.eventLinkUrl': '이벤트 링크',
  'pages.products.store.eventText': '이벤트 문구',
  'pages.products.store.eventTextPlaceholder': '구매중인 이벤트 선물',
  'pages.products.store.featuredHint': '노출은 추천 스토어 섹션이 자동 모드일 때 적용됩니다.',
  'pages.products.store.featuredOff': '미노출',
  'pages.products.store.featuredOn': '노출',
  'pages.products.store.featuredOnHome': '추천 페이지 노출',
  'pages.products.store.heavyImage': '이미지가 무겁습니다. 더 작게 올리는 편이 좋습니다.',
  'pages.products.store.homeSortOrder': '정렬 순서',
  'pages.products.store.homeSortOrderHint': '작을수록 앞에 놓입니다.',
  'pages.products.store.orderButton': '순서 정하기',
  'pages.products.store.orderTitle': '스토어 순서 정하기',
  'pages.products.store.orderHint': '끌어서 순서를 바꾼 뒤 저장하세요. 스토어 전체 목록(추천 스토어 [더보기])과, 스토어를 담지 않은 추천 스토어 띠가 이 순서로 나옵니다. 추천 노출을 끈 스토어는 켠 스토어 뒤에 나오고, 비활성 스토어는 목록에 없습니다.',
  'pages.products.store.orderFeatured': '추천 노출',
  'pages.products.store.orderNotFeatured': '추천 노출 꺼짐',
  'pages.products.store.orderDragHandle': '끌어서 순서 바꾸기',
  'pages.products.store.orderSaved': '스토어 순서를 저장했습니다.',
  'pages.products.store.orderSaveFailed': '스토어 순서를 저장하지 못했습니다.',
  'pages.products.store.orderEmpty': '순서를 정할 활성 스토어가 없습니다.',
  'pages.products.store.imageSection': '이미지',
  'pages.products.store.imageTooLarge': '이미지가 너무 큽니다(최대 10MB)',
  'pages.products.store.mainImage': '메인 가로 이미지',
  'pages.products.store.mainImageHint': '추천 스토어 카드의 큰 가로 사진입니다.',
  'pages.products.store.promoText': '홍보 문구',
  'pages.products.store.promoTextPlaceholder': '가을신상 방송중 10%할인',
  'pages.products.store.recommendSize': '권장',
  'pages.products.store.representativeEmpty': '이 스토어에 상품이 없습니다.',
  'pages.products.store.representativeHint': '스토어 카드에 함께 보일 상품 하나를 고릅니다. 상품 목록에는 "스토어 대표" 뱃지만 표시됩니다.',
  'pages.products.store.representativeNone': '지정 안 함',
  'pages.products.store.representativeProduct': '대표 상품',
  'pages.products.store.representativeSaveFirst': '스토어를 먼저 저장하면 대표 상품을 고를 수 있습니다.',
  'pages.products.store.uploadImageOnly': '이미지 파일만 올릴 수 있습니다',
  'pages.products.store.variants': '변형',

  // Main Rolling Banner
  'pages.homepage.mainRollingBanner.title': '메인 롤링배너',
  'pages.homepage.mainRollingBanner.list': '롤링 배너 리스트',
  'pages.homepage.banner.add': '배너 추가',
  'pages.homepage.banner.order': '순서 변경',
  'pages.homepage.banner.image': '이미지',
  'pages.homepage.banner.title': '제목',
  'pages.homepage.banner.url': 'URL',
  'pages.homepage.banner.displayType': '등록',
  'pages.homepage.banner.registrationType': '등록구분',
  'pages.homepage.banner.targetType': '새창여부',
  'pages.homepage.banner.actions': '작업',
  'pages.homepage.banner.edit': '수정',
  'pages.homepage.banner.delete': '삭제',
  'pages.homepage.banner.addModal': '추천상품 등록/수정',
  'pages.homepage.banner.editModal': '배너 수정',
  'pages.homepage.banner.orderModal': '배너 정렬',
  'pages.homepage.banner.form.displayType': '등록 구분',
  'pages.homepage.banner.form.displayTypePlaceholder': '메인>롤링배너',
  'pages.homepage.banner.form.displayTypeRequired': '등록 구분을 선택해주세요',
  'pages.homepage.banner.form.registrationType': '등록 구분',
  'pages.homepage.banner.form.registrationTypePlaceholder': '등록 구분을 선택하세요',
  'pages.homepage.banner.form.registrationTypeRequired': '등록 구분을 선택해주세요',
  'pages.homepage.banner.form.title': '제목',
  'pages.homepage.banner.form.titlePlaceholder': '제목을 입력하세요',
  'pages.homepage.banner.form.titleRequired': '제목을 입력해주세요',
  'pages.homepage.banner.form.image': '이미지',
  'pages.homepage.banner.form.imageUpload': 'Choose file',
  'pages.homepage.banner.form.url': 'URL',
  'pages.homepage.banner.form.urlPlaceholder': 'URL을 입력하세요',
  'pages.homepage.banner.form.usageStatus': '사용 유무',
  'pages.homepage.banner.form.usageStatusPlaceholder': '사용',
  'pages.homepage.banner.form.usageStatusRequired': '사용 유무를 선택해주세요',
  'pages.homepage.banner.form.usageStatus.use': '사용',
  'pages.homepage.banner.form.usageStatus.notUse': '미사용',
  'pages.homepage.banner.form.target': '타겟',
  'pages.homepage.banner.form.targetPlaceholder': '선택하세요',
  'pages.homepage.banner.form.targetRequired': '타겟을 선택해주세요',
  'pages.homepage.banner.form.target.oneself': 'Oneself',
  'pages.homepage.banner.form.target.newWindow': 'New Window',
  'pages.homepage.banner.form.period': '기간',
  'pages.homepage.banner.orderModal.instruction': '마우스로 드래그하여 순서를 변경할 수 있습니다',
  'pages.homepage.banner.orderModal.header.management': '배너관리',
  'pages.homepage.banner.orderModal.header.type': '메인>롤링배너',
  'pages.homepage.banner.message.added': '배너가 추가되었습니다',
  'pages.homepage.banner.message.updated': '배너가 수정되었습니다',
  'pages.homepage.banner.message.deleted': '배너가 삭제되었습니다',
  'pages.homepage.banner.message.orderChanged': '순서가 변경되었습니다',
  'pages.homepage.banner.message.orderSaved': '순서가 저장되었습니다',
  'pages.homepage.banner.message.editInfo': '수정 기능',
  'pages.homepage.banner.confirm.deleteTitle': '삭제 확인',
  'pages.homepage.banner.confirm.deleteContent': '이 배너를 삭제하시겠습니까?',

  // Homepage - Recommended Products
  'pages.homepage.recommendedProducts.title': '추천상품관리',
  'pages.homepage.product.order': '순서',
  'pages.homepage.product.image': '이미지',
  'pages.homepage.product.recommendationType': '추천구분',
  'pages.homepage.product.name': '상품명',
  'pages.homepage.product.country': '국가',
  'pages.homepage.product.price': '가격',
  'pages.homepage.product.category': '카테고리',
  'pages.homepage.product.actions': '관리',
  'pages.homepage.product.add': '추천상품 등록/수정',
  'pages.homepage.product.edit': '수정',
  'pages.homepage.product.delete': '삭제',
  'pages.homepage.product.addModal': '추천상품 등록/수정',
  'pages.homepage.product.editModal': '추천상품 등록/수정',
  'pages.homepage.product.form.recommendationType': '추천구분',
  'pages.homepage.product.form.recommendationTypePlaceholder': '선택',
  'pages.homepage.product.form.recommendationTypeRequired': '추천구분을 선택하세요',
  'pages.homepage.product.form.productName': '상품명',
  'pages.homepage.product.form.productNamePlaceholder': '상품명을 입력하세요',
  'pages.homepage.product.form.productNameRequired': '상품명을 입력하세요',
  'pages.homepage.product.form.productUrl': '상품URL',
  'pages.homepage.product.form.productUrlPlaceholder': '상품 URL을 입력하세요',
  'pages.homepage.product.form.country': '국가',
  'pages.homepage.product.form.countryPlaceholder': '선택',
  'pages.homepage.product.form.countryRequired': '국가를 선택하세요',
  'pages.homepage.product.form.price': '가격',
  'pages.homepage.product.form.pricePlaceholder': '0',
  'pages.homepage.product.form.priceRequired': '가격을 입력하세요',
  'pages.homepage.product.form.category': '카테고리',
  'pages.homepage.product.form.categoryPlaceholder': '카테고리를 입력하세요',
  'pages.homepage.product.form.image': '상품이미지',
  'pages.homepage.product.form.imageUpload': 'Choose file',
  'pages.homepage.product.type.hotDeal': 'Hot Deal',
  'pages.homepage.product.type.newArrival': '신상품',
  'pages.homepage.product.type.bestSeller': '베스트셀러',
  'pages.homepage.product.type.featured': '추천상품',
  'pages.homepage.product.country.china': '중국',
  'pages.homepage.product.country.korea': '한국',
  'pages.homepage.product.country.usa': '미국',
  'pages.homepage.product.country.japan': '일본',
  'pages.homepage.product.message.added': '상품이 추가되었습니다',
  'pages.homepage.product.message.updated': '상품이 수정되었습니다',
  'pages.homepage.product.message.deleted': '상품이 삭제되었습니다',
  'pages.homepage.product.confirm.deleteTitle': '상품 삭제',
  'pages.homepage.product.confirm.deleteContent': '이 상품을 삭제하시겠습니까?',

  // Homepage - Departure Schedule
  'pages.homepage.departureSchedule.title': '출항 스케줄 관리',
  'pages.homepage.schedule.center': '센터',
  'pages.homepage.schedule.transportMethod': '운송방식',
  'pages.homepage.schedule.departureDate': '출항일자',
  'pages.homepage.schedule.departureTime': '출항시간',
  'pages.homepage.schedule.notes': '메모',
  'pages.homepage.schedule.actions': '관리',
  'pages.homepage.schedule.add': '출항 스케줄 - 등록',
  'pages.homepage.schedule.edit': '수정',
  'pages.homepage.schedule.delete': '삭제',
  'pages.homepage.schedule.addModal': '출항 스케줄 - 등록',
  'pages.homepage.schedule.editModal': '출항 스케줄 - 등록',
  'pages.homepage.schedule.form.center': '센터',
  'pages.homepage.schedule.form.centerRequired': '센터를 선택하세요',
  'pages.homepage.schedule.form.transportMethod': '운송방식',
  'pages.homepage.schedule.form.transportMethodRequired': '운송방식을 선택하세요',
  'pages.homepage.schedule.form.departureDate': '출항일자',
  'pages.homepage.schedule.form.departureDateRequired': '출항일자를 선택하세요',
  'pages.homepage.schedule.form.departureTime': '출항시간',
  'pages.homepage.schedule.form.departureTimeRequired': '출항시간을 선택하세요',
  'pages.homepage.schedule.form.notes': '메모',
  'pages.homepage.schedule.form.notesPlaceholder': '메모를 입력하세요',
  'pages.homepage.schedule.center.weihai': '위해',
  'pages.homepage.schedule.center.guangzhou': '광저우',
  'pages.homepage.schedule.transport.seaIncheonCJ': '해운인천(CJ)',
  'pages.homepage.schedule.transport.seaPyeongtaekHanjin': '해운평택(한진)',
  'pages.homepage.schedule.transport.lclMWF': 'LCL(월/수/금 화물선)',
  'pages.homepage.schedule.transport.lclTThSun': 'LCL(화/목/일 웰리선)',
  'pages.homepage.schedule.transport.air': '항공',
  'pages.homepage.schedule.transport.airExpress': '항공특송',
  'pages.homepage.schedule.transport.topitLCL': '토핏LCL(화/목)',
  'pages.homepage.schedule.transport.topitLCLGeneral': '토핏LCL',
  'pages.homepage.schedule.message.added': '스케줄이 추가되었습니다',
  'pages.homepage.schedule.message.updated': '스케줄이 수정되었습니다',
  'pages.homepage.schedule.message.deleted': '스케줄이 삭제되었습니다',
  'pages.homepage.schedule.confirm.deleteTitle': '스케줄 삭제',
  'pages.homepage.schedule.confirm.deleteContent': '이 스케줄을 삭제하시겠습니까?',

  // Homepage - Shopping Information
  'pages.homepage.shoppingInformation.title': '쇼핑정보 관리',
  'pages.homepage.shopping.tab.category': '카테고리 관리',
  'pages.homepage.shopping.tab.site': '사이트 관리',
  'pages.homepage.shopping.addCategory': '카테고리 - 등록',
  'pages.homepage.shopping.addSite': '사이트 - 등록',
  'pages.homepage.shopping.addCategoryModal': '카테고리 - 등록',
  'pages.homepage.shopping.editCategoryModal': '카테고리 - 수정',
  'pages.homepage.shopping.addSiteModal': '사이트 - 등록',
  'pages.homepage.shopping.editSiteModal': '사이트 - 수정',
  'pages.homepage.shopping.category.name': '카테고리명',
  'pages.homepage.shopping.category.order': '순서',
  'pages.homepage.shopping.site.country': '국가',
  'pages.homepage.shopping.site.category': '카테고리',
  'pages.homepage.shopping.site.name': '사이트명',
  'pages.homepage.shopping.site.url': '사이트 URL',
  'pages.homepage.shopping.actions': '관리',
  'pages.homepage.shopping.edit': '수정',
  'pages.homepage.shopping.delete': '삭제',
  'pages.homepage.shopping.form.categoryName': '카테고리명',
  'pages.homepage.shopping.form.categoryNameRequired': '카테고리명을 입력하세요',
  'pages.homepage.shopping.form.categoryNamePlaceholder': '카테고리명을 입력하세요',
  'pages.homepage.shopping.form.country': '국가',
  'pages.homepage.shopping.form.countryRequired': '국가를 선택하세요',
  'pages.homepage.shopping.form.countryPlaceholder': '국가를 선택하세요',
  'pages.homepage.shopping.form.category': '카테고리',
  'pages.homepage.shopping.form.categoryRequired': '카테고리를 선택하세요',
  'pages.homepage.shopping.form.categoryPlaceholder': '카테고리를 선택하세요',
  'pages.homepage.shopping.form.siteName': '사이트명',
  'pages.homepage.shopping.form.siteNameRequired': '사이트명을 입력하세요',
  'pages.homepage.shopping.form.siteNamePlaceholder': '사이트명을 입력하세요',
  'pages.homepage.shopping.form.siteUrl': '사이트 URL',
  'pages.homepage.shopping.form.siteUrlPlaceholder': '사이트 URL을 입력하세요',
  'pages.homepage.shopping.form.image': '이미지',
  'pages.homepage.shopping.form.imageUpload': '업로드',
  'pages.homepage.shopping.country.china': '중국',
  'pages.homepage.shopping.country.korea': '한국',
  'pages.homepage.shopping.country.usa': '미국',
  'pages.homepage.shopping.country.japan': '일본',
  'pages.homepage.shopping.message.categoryAdded': '카테고리가 추가되었습니다',
  'pages.homepage.shopping.message.categoryUpdated': '카테고리가 수정되었습니다',
  'pages.homepage.shopping.message.categoryDeleted': '카테고리가 삭제되었습니다',
  'pages.homepage.shopping.message.siteAdded': '사이트가 추가되었습니다',
  'pages.homepage.shopping.message.siteUpdated': '사이트가 수정되었습니다',
  'pages.homepage.shopping.message.siteDeleted': '사이트가 삭제되었습니다',
  'pages.homepage.shopping.confirm.deleteCategoryTitle': '카테고리 삭제',
  'pages.homepage.shopping.confirm.deleteCategoryContent': '이 카테고리를 삭제하시겠습니까?',
  'pages.homepage.shopping.confirm.deleteSiteTitle': '사이트 삭제',
  'pages.homepage.shopping.confirm.deleteSiteContent': '이 사이트를 삭제하시겠습니까?',

  // Homepage - Event Management
  'pages.homepage.eventManagement.title': '이벤트관리',
  'pages.homepage.event.title': '제목',
  'pages.homepage.event.thumbnail': '썸네일',
  'pages.homepage.event.period': '기간',
  'pages.homepage.event.displayType': '사용여부',
  'pages.homepage.event.actions': '관리',
  'pages.homepage.event.add': '이벤트 등록',
  'pages.homepage.event.edit': '수정',
  'pages.homepage.event.delete': '삭제',
  'pages.homepage.event.addModal': '이벤트 등록/수정',
  'pages.homepage.event.editModal': '이벤트 등록/수정',
  'pages.homepage.event.form.title': '제목',
  'pages.homepage.event.form.titleRequired': '제목을 입력하세요',
  'pages.homepage.event.form.titlePlaceholder': '제목을 입력하세요',
  'pages.homepage.event.form.briefDescription': '간략설명',
  'pages.homepage.event.form.briefDescriptionRequired': '간략설명을 입력하세요',
  'pages.homepage.event.form.briefDescriptionPlaceholder': '간략설명을 입력하세요',
  'pages.homepage.event.form.thumbnail': '썸네일',
  'pages.homepage.event.form.thumbnailUpload': '업로드',
  'pages.homepage.event.form.externalLink': '외부링크',
  'pages.homepage.event.form.externalLinkPlaceholder': '외부링크를 입력하세요',
  'pages.homepage.event.form.period': '기간',
  'pages.homepage.event.form.periodRequired': '기간을 선택하세요',
  'pages.homepage.event.form.exposurePeriod': '노출기간',
  'pages.homepage.event.form.exposurePeriodRequired': '노출기간을 선택하세요',
  'pages.homepage.event.form.displayType': '사용여부',
  'pages.homepage.event.form.displayTypeRequired': '사용여부를 선택하세요',
  'pages.homepage.event.form.displayTypePlaceholder': '사용여부를 선택하세요',
  'pages.homepage.event.form.content': '내용',
  'pages.homepage.event.form.contentHint': 'HTML 형식으로 내용을 입력하세요',
  'pages.homepage.event.displayType.active': '사용',
  'pages.homepage.event.displayType.inactive': '미사용',
  'pages.homepage.event.message.added': '이벤트가 추가되었습니다',
  'pages.homepage.event.message.updated': '이벤트가 수정되었습니다',
  'pages.homepage.event.message.deleted': '이벤트가 삭제되었습니다',
  'pages.homepage.event.confirm.deleteTitle': '이벤트 삭제',
  'pages.homepage.event.confirm.deleteContent': '이 이벤트를 삭제하시겠습니까?',

  // Homepage - Popup Management
  'pages.homepage.popupManagement.title': '팝업관리',
  'pages.homepage.popup.title': '제목',
  'pages.homepage.popup.coordinates': '좌표',
  'pages.homepage.popup.isCentered': '중앙여부',
  'pages.homepage.popup.size': '사이즈',
  'pages.homepage.popup.isOpen': '오픈여부',
  'pages.homepage.popup.period': '기간',
  'pages.homepage.popup.displayType': '사용여부',
  'pages.homepage.popup.actions': '관리',
  'pages.homepage.popup.add': '팝업 등록/수정',
  'pages.homepage.popup.edit': '수정',
  'pages.homepage.popup.delete': '삭제',
  'pages.homepage.popup.addModal': '팝업 등록/수정',
  'pages.homepage.popup.editModal': '팝업 등록/수정',
  'pages.homepage.popup.form.title': '제목',
  'pages.homepage.popup.form.titleRequired': '제목을 입력하세요',
  'pages.homepage.popup.form.titlePlaceholder': '제목을 입력하세요',
  'pages.homepage.popup.form.coordinates': '좌표',
  'pages.homepage.popup.form.isCentered': '중앙여부',
  'pages.homepage.popup.form.isCenteredLabel': '중앙에 배치',
  'pages.homepage.popup.form.size': '사이즈',
  'pages.homepage.popup.form.isOpen': '오픈여부',
  'pages.homepage.popup.form.isOpenLabel': '팝업 열림',
  'pages.homepage.popup.form.period': '기간',
  'pages.homepage.popup.form.periodRequired': '기간을 선택하세요',
  'pages.homepage.popup.form.displayType': '사용여부',
  'pages.homepage.popup.form.displayTypeRequired': '사용여부를 선택하세요',
  'pages.homepage.popup.form.displayTypePlaceholder': '사용여부를 선택하세요',
  'pages.homepage.popup.form.content': '내용',
  'pages.homepage.popup.form.contentPlaceholder': '내용을 입력하세요',
  'pages.homepage.popup.form.contentHint': 'HTML 형식으로 내용을 입력하세요',
  'pages.homepage.popup.displayType.active': '사용',
  'pages.homepage.popup.displayType.inactive': '미사용',
  'pages.homepage.popup.message.added': '팝업이 추가되었습니다',
  'pages.homepage.popup.message.updated': '팝업이 수정되었습니다',
  'pages.homepage.popup.message.deleted': '팝업이 삭제되었습니다',
  'pages.homepage.popup.confirm.deleteTitle': '팝업 삭제',
  'pages.homepage.popup.confirm.deleteContent': '이 팝업을 삭제하시겠습니까?',

  // Homepage - Page Management
  'pages.homepage.pageManagement.title': '페이지관리',
  'pages.homepage.page.pageTitle': '페이지타이틀',
  'pages.homepage.page.displayType': '사용여부',
  'pages.homepage.page.actions': '관리',
  'pages.homepage.page.add': '페이지 등록',
  'pages.homepage.page.edit': '수정',
  'pages.homepage.page.delete': '삭제',
  'pages.homepage.page.addModal': 'HTML PAGE 등록/수정',
  'pages.homepage.page.editModal': 'HTML PAGE 등록/수정',
  'pages.homepage.page.form.pageTitle': '페이지타이틀',
  'pages.homepage.page.form.pageTitleRequired': '페이지타이틀을 입력하세요',
  'pages.homepage.page.form.pageTitlePlaceholder': '페이지타이틀을 입력하세요',
  'pages.homepage.page.form.displayType': '사용여부',
  'pages.homepage.page.form.displayTypeRequired': '사용여부를 선택하세요',
  'pages.homepage.page.form.displayTypePlaceholder': '사용여부를 선택하세요',
  'pages.homepage.page.form.content': '내용',
  'pages.homepage.page.form.contentPlaceholder': '내용을 입력하세요',
  'pages.homepage.page.form.contentHint': 'HTML 형식으로 내용을 입력하세요',
  'pages.homepage.page.displayType.active': '사용',
  'pages.homepage.page.displayType.inactive': '미사용',
  'pages.homepage.page.message.added': '페이지가 추가되었습니다',
  'pages.homepage.page.message.updated': '페이지가 수정되었습니다',
  'pages.homepage.page.message.deleted': '페이지가 삭제되었습니다',
  'pages.homepage.page.confirm.deleteTitle': '페이지 삭제',
  'pages.homepage.page.confirm.deleteContent': '이 페이지를 삭제하시겠습니까?',

  // Homepage - Mail Form Management
  'pages.homepage.mailFormManagement.title': '메일폼관리',
  'pages.homepage.mailForm.title': '제목',
  'pages.homepage.mailForm.displayType': '사용여부',
  'pages.homepage.mailForm.actions': '관리',
  'pages.homepage.mailForm.add': '메일폼 등록',
  'pages.homepage.mailForm.edit': '수정',
  'pages.homepage.mailForm.delete': '삭제',
  'pages.homepage.mailForm.addModal': '메일폼 등록/수정',
  'pages.homepage.mailForm.editModal': '메일폼 등록/수정',
  'pages.homepage.mailForm.form.title': '제목',
  'pages.homepage.mailForm.form.titleRequired': '제목을 입력하세요',
  'pages.homepage.mailForm.form.titlePlaceholder': '제목을 입력하세요',
  'pages.homepage.mailForm.form.displayType': '사용여부',
  'pages.homepage.mailForm.form.displayTypeRequired': '사용여부를 선택하세요',
  'pages.homepage.mailForm.form.displayTypePlaceholder': '사용여부를 선택하세요',
  'pages.homepage.mailForm.form.content': '내용',
  'pages.homepage.mailForm.form.contentPlaceholder': '내용을 입력하세요',
  'pages.homepage.mailForm.form.contentHint': 'HTML 형식으로 내용을 입력하세요',
  'pages.homepage.mailForm.form.variablesHint': '사이트명 : [$SITE_NAME], 이름 : [$MEMBER_NAME], 아이디 : [$MEMBER_ID], 휴대폰번호 : [$MOBILE_NO], 임시비밀번호 : [$PASSWORD]',
  'pages.homepage.mailForm.displayType.active': '사용',
  'pages.homepage.mailForm.displayType.inactive': '미사용',
  'pages.homepage.mailForm.message.added': '메일폼이 추가되었습니다',
  'pages.homepage.mailForm.message.updated': '메일폼이 수정되었습니다',
  'pages.homepage.mailForm.message.deleted': '메일폼이 삭제되었습니다',
  'pages.homepage.mailForm.confirm.deleteTitle': '메일폼 삭제',
  'pages.homepage.mailForm.confirm.deleteContent': '이 메일폼을 삭제하시겠습니까?',

  // Coupon Issuance
  'pages.coupon.issuance.modalTitle': '쿠폰 발급',
  'pages.coupon.issuance.memberButton': '회원별 쿠폰발급',
  'pages.coupon.issuance.levelButton': '등급별 쿠폰발급',
  'pages.coupon.issuance.memberInfo': '회원정보 (쿠폰기간: 비한정)',
  'pages.coupon.issuance.type': '종류',
  'pages.coupon.issuance.code': '쿠폰코드',
  'pages.coupon.issuance.amount': '금액',
  'pages.coupon.issuance.method': '발급방법 (회원ID)',
  'pages.coupon.issuance.usageStatus': '사용여부',
  'pages.coupon.issuance.date': '발급일시',
  'pages.coupon.issuance.memberSearch': '회원검색',
  'pages.coupon.issuance.memberId': '회원아이디',
  'pages.coupon.issuance.memberName': '회원명',
  'pages.coupon.issuance.phone': '휴대폰',
  'pages.coupon.issuance.searchPlaceholder': '검색어 입력',
  'pages.coupon.issuance.selectMember': '회원명',
  'pages.coupon.issuance.selectMemberPlaceholder': '= 회원 선택 =',
  'pages.coupon.issuance.couponType': '쿠폰종류',
  'pages.coupon.issuance.shippingFee': '배송비',
  'pages.coupon.issuance.discount': '할인',
  'pages.coupon.issuance.count': '개',
  'pages.coupon.issuance.category': '발급구분',
  'pages.coupon.issuance.validDays': '유효일',
  'pages.coupon.issuance.fromIssuanceDate': '발급일로 부터',
  'pages.coupon.issuance.days': '일',
  'pages.coupon.issuance.smsOption': 'SMS 발송안함',
  'pages.coupon.issuance.noSms': 'SMS 발송안함',
  'pages.coupon.issuance.sendSms': 'SMS 발송',
  'pages.coupon.issuance.memberLevel': '회원등급',
  'pages.coupon.issuance.level.all': '회원등급 전체',
  'pages.coupon.issuance.level.basic': '베이직회원',
  'pages.coupon.issuance.level.shippingVip': '배송대행VIP',
  'pages.coupon.issuance.level.shippingSvip': '배송대행SVIP',
  'pages.coupon.issuance.level.purchaseBusiness': '구매대행사업자',
  'pages.coupon.issuance.level.purchase': '구매',
  'pages.coupon.issuance.level.agencyVip': '대행VIP',
  'pages.coupon.issuance.level.ttBusiness': 'TT사업자',
  'pages.coupon.issuance.level.ttVip': 'TTVIP',
  'pages.coupon.issuance.level.ttPersonal': 'TT개인',
  'pages.coupon.issuance.successMessage': '쿠폰이 발급되었습니다',
  'pages.coupon.issuance.table.couponType': '쿠폰종류',
  'pages.coupon.issuance.table.issuanceType': '발급구분',
  'pages.coupon.issuance.table.amount': '금액',
  'pages.coupon.issuance.table.effectiveDate': '유효기간',
  'pages.coupon.issuance.table.ownerMember': '소유회원',
  'pages.coupon.issuance.table.isUsed': '사용여부',
  'pages.coupon.issuance.table.issuanceDate': '발급일시',
  'pages.coupon.issuance.filter.period': '기간',
  'pages.coupon.issuance.filter.membershipEvent': '회원가입 이벤트',
  'pages.coupon.issuance.filter.adminIssued': '관리자 발급',
  'pages.coupon.issuance.filter.upgradeEvent': '회원등급 업그레이드 쿠폰 발급',
  'pages.coupon.issuance.filter.used': '사용',
  'pages.coupon.issuance.filter.unused': '미사용',
  'pages.coupon.issuance.filter.memberId': '회원ID',
  'pages.coupon.issuance.filter.memberIdPlaceholder': '회원ID 입력',
  'pages.coupon.issuance.filter.memberNamePlaceholder': '회원명 입력',
  'pages.coupon.issuance.filter.orderNumber': '주문번호',
  'pages.coupon.issuance.filter.orderNumberPlaceholder': '주문번호 입력',
  'pages.coupon.issuance.deleteButton': '삭제',
  'pages.coupon.issuance.selectToDelete': '삭제할 항목을 선택하세요',
  'pages.coupon.issuance.deleteConfirmTitle': '쿠폰 삭제',
  'pages.coupon.issuance.deleteConfirmContent': '{count}개의 쿠폰을 삭제하시겠습니까?',
  'pages.coupon.issuance.deleteSuccess': '쿠폰이 삭제되었습니다',
  'pages.coupon.issuance.selectedCount': '{count}개 선택됨',
  'pages.coupon.issuance.table.couponTypeAndIssuance': '쿠폰종류(발급구분)',
  'pages.coupon.issuance.combined.shippingMembership': '배송비 - 회원가입 이벤트',
  'pages.coupon.issuance.combined.shippingAdmin': '배송비 - 관리자 발급',
  'pages.coupon.issuance.combined.shippingUpgrade': '배송비 - 회원등급 업그레이드',
  'pages.coupon.issuance.searchResults': '검색 결과',
  'pages.coupon.issuance.selectedMember': '선택된 회원',
  'pages.coupon.issuance.price': '가격',
  'pages.coupon.issuance.pieces': '개',
  'pages.coupon.issuance.issuanceType': '발급구분',
  'pages.coupon.issuance.filter.startDate': '시작일',
  'pages.coupon.issuance.filter.endDate': '종료일',

  // Event Coupon
  'pages.coupon.event.couponType': '쿠폰종류',
  'pages.coupon.event.issuanceType': '발급구분',
  'pages.coupon.event.amount': '금액',
  'pages.coupon.event.validDays': '유효일',
  'pages.coupon.event.eventPeriod': '이벤트 기간',
  'pages.coupon.event.createdAt': '생성일시',
  'pages.coupon.event.priceRequired': '금액을 입력하세요',
  'pages.coupon.event.countRequired': '수량을 입력하세요',
  'pages.coupon.event.validDaysRequired': '유효일을 입력하세요',
  'pages.coupon.event.eventPeriodRequired': '이벤트 기간을 선택해주세요',
  'pages.coupon.event.saveSuccess': '이벤트 쿠폰이 생성되었습니다',
  'pages.coupon.event.deleteConfirmTitle': '쿠폰 삭제',
  'pages.coupon.event.deleteConfirmContent': '이 쿠폰을 삭제하시겠습니까?',
  'pages.coupon.event.deleteSuccess': '쿠폰이 삭제되었습니다',

  // SMS
  'pages.sms.title': 'SMS 문자 발송',
  'pages.sms.tabs.storage': '문자보관함',
  'pages.sms.tabs.members': '회원목록',
  'pages.sms.storage.title': '문자보관함',
  'pages.sms.form.recipient': '받는 사람',
  'pages.sms.form.individual': '개인',
  'pages.sms.form.group': '그룹',
  'pages.sms.form.phonePlaceholder': '전화번호를 입력하세요',
  'pages.sms.form.selectGroup': '그룹을 선택하세요',
  'pages.sms.form.allMembers': '전체',
  'pages.sms.form.sender': '보내는 사람',
  'pages.sms.form.message': '문자 내용',
  'pages.sms.form.messagePlaceholder': '메시지를 입력하세요',
  'pages.sms.form.currentLength': '현재 남은 건수는',
  'pages.sms.form.bytes': 'bytes',
  'pages.sms.form.smsInfo': '문자 발송은 30Byte이고 보낸자이름 | MS로 분출됩니다.',
  'pages.sms.form.lmsInfo': 'SMS로 문자 발송의 15P 입니다.',
  'pages.sms.form.mmsInfo': 'LMS로 문자 발송의 35P 입니다. MMS로 문자 발송의 100P입니다. (이미지 파일 첨부)',
  'pages.sms.form.send': '전송하기',
  'pages.sms.member.memberId': '회원명(아이디)',
  'pages.sms.member.name': '등급',
  'pages.sms.member.phone': '휴대폰',
  'pages.sms.member.createdAt': '사서한',
  'pages.sms.member.emptyText': '회원목록을 검색해주세요.',
  'pages.sms.history.title': 'SMS발송내역',
  'pages.sms.history.sendInfo': '발송정보',
  'pages.sms.history.date': '날짜',
  'pages.sms.history.datePlaceholder': '날짜를 선택하세요',
  'pages.sms.history.phone': '휴대폰',
  'pages.sms.history.phonePlaceholder': '휴대폰 번호를 입력하세요',
  'pages.sms.history.message': '내용',
  'pages.sms.history.type': '구분',
  'pages.sms.history.status': '전송',
  'pages.sms.history.pageSize': '개씩 보기',

  // Kakao SMS Management
  'pages.kakao.title': 'Kakao 알 SMS 관리',
  'pages.kakao.table.name': '명칭',
  'pages.kakao.table.kakaoContent': '[카카오톡]',
  'pages.kakao.table.replacementText': '문자메시지 [카카오톡 메시지 미발송시 대체문자]',
  'pages.kakao.table.bytes': 'byte',
  'pages.kakao.table.useStatus': '사용유무',
  'pages.kakao.status.active': '사용',
  'pages.kakao.status.inactive': '미사용',
  'pages.kakao.placeholder.replacementText': '대체 문자를 입력하세요',

  // SMS Point Details
  'pages.smsPoint.title': '포인트내역',
  'pages.smsPoint.filter.year': '년도',
  'pages.smsPoint.filter.month': '월',
  'pages.smsPoint.table.chargingPoint': '충전포인트',
  'pages.smsPoint.table.location': '위치',
  'pages.smsPoint.table.date': '날짜',

  // Member Grades
  'pages.member.grade.basic': '베이직회원',
  'pages.member.grade.shippingAgency': '배송대행',
  'pages.member.grade.shippingVip': '배송대행VIP',
  'pages.member.grade.shippingSvip': '배송대행SVIP',
  'pages.member.grade.purchaseBusiness': '구매대행사업자',
  'pages.member.grade.purchaseVip': '구매대행VIP',
  'pages.member.grade.ttBusiness': 'TT사업자',
  'pages.member.grade.ttVip': 'TTVIP',
  'pages.member.grade.ttSvip': 'TTSVIP',

  // Rack Usage Management
  'pages.rack.usage.title': '랙 사용 관리',
  'pages.rack.usage.rackCode': '랙코드',
  'pages.rack.usage.rackNumber': '랙번호',
  'pages.rack.usage.size': '크기',
  'pages.rack.usage.registrant': '운송번호',
  'pages.rack.usage.stockNumber': '재고번호',
  'pages.rack.usage.locationNumber': '위치번호',
  'pages.rack.usage.registrationDate': '등록일자',
  'pages.rack.usage.detail': '상세',

  // Rack Management
  'pages.rack.management.title': '랙 관리',
  'pages.rack.management.register': '랙 등록',
  'pages.rack.management.rackDefinition': '랙 정의',
  'pages.rack.management.rackCode': '랙 코드',
  'pages.rack.management.size': '크기',
  'pages.rack.management.range': '시작~끝 번호',
  'pages.rack.management.totalRacks': '총 랙 수',
  'pages.rack.management.usedRacks': '사용 랙 수',
  'pages.rack.management.isActive': '사용유무',
  'pages.rack.management.rackDetails': '랙 번호 상세',
  'pages.rack.management.addRack': '랙 번호 추가',
  'pages.rack.management.correction': '수정',
  'pages.rack.management.registerModal': '랙 등록',
  'pages.rack.management.detailsModal': '랙 번호 상세',
  'pages.rack.management.addRackModal': '랙 번호 추가',
  'pages.rack.management.correctionModal': '랙 정보 수정',
  'pages.rack.management.rackCode1': '랙코드_1',
  'pages.rack.management.rackCode2': '랙코드_2',
  'pages.rack.management.startNumber': '시작번호',
  'pages.rack.management.endNumber': '종료번호',
  'pages.rack.management.useCategory': '사용구분',
  'pages.rack.management.combination': '조합형태',
  'pages.rack.management.availableRacks': '사용 가능한 랙 수',
  'pages.rack.management.rackNumber': '랙번호',
  'pages.rack.management.status': '내역',
  'pages.rack.management.inquiry': '조회',
  'pages.rack.management.addRackCount': '추가 랙 수',
  'pages.rack.management.maxAddable': '추가 가능한 최대 랙 수',
  'pages.rack.management.sizeSmall': '소',
  'pages.rack.management.sizeMedium': '중',
  'pages.rack.management.sizeLarge': '대',
  'pages.rack.management.sizeLCL': 'LCL',
  'pages.rack.management.use': '사용',
  'pages.rack.management.notUse': '미사용',
  'pages.rack.management.notInUse': '미사용',
  'pages.rack.management.reset': '초기화',
  'pages.rack.management.detail': '상세',
  'pages.rack.management.registrationDate': '등록일자',
  'pages.rack.management.enterAddCount': '추가할 랙 수를 입력하세요',
  'pages.rack.management.registerSuccess': '랙이 등록되었습니다',
  'pages.rack.management.addSuccess': '랙이 추가되었습니다',
  'pages.rack.management.editSuccess': '랙이 수정되었습니다',

  // Rack Information Log
  'pages.rack.log.title': '랙 정보 로그',
  'pages.rack.log.logNumber': '로그번호',
  'pages.rack.log.rackNumber': '랙번호',
  'pages.rack.log.trackingNumber': '트래킹번호',
  'pages.rack.log.stockNumber': '재고번호',
  'pages.rack.log.noDataNumber': '노데이터번호',
  'pages.rack.log.registrationCode': '등록코드',
  'pages.rack.log.memberName': '회원명',
  'pages.rack.log.registrationDate': '등록일자',
  'pages.rack.log.filter.first': '첫',
  'pages.rack.log.filter.date': '날짜',
  'pages.rack.log.filter.rackNumber': '랙번호',
  'pages.rack.log.filter.trackingNumber': '트래킹번호',
  'pages.rack.log.filter.stockNumber': '재고번호',
  'pages.rack.log.filter.noDataNumber': '노데이터번호',
  'pages.rack.log.filter.memberName': '회원명',

  // Membership Level Management
  'pages.membership.level.title': '회원등급 관리',
  'pages.membership.level.register': '등급등록',
  'pages.membership.level.gradeNumber': '등급번호',
  'pages.membership.level.gradeName': '등급이름',
  'pages.membership.level.numberOfDeliveries': '배송건수',
  'pages.membership.level.purchaseFee': '구매수수료(%)',
  'pages.membership.level.serviceFee': '서비스수수료(%)',
  'pages.membership.level.levelUpCoupon': '레벨업쿠폰',
  'pages.membership.level.pointAccumulation': '포인트적립(%)',
  'pages.membership.level.exchangeRates': '등급별 적용 환율',
  'pages.membership.level.usageStatus': '사용여부',
  'pages.membership.level.deleteConfirmContent': '이 등급을 삭제하시겠습니까?',
  'pages.membership.level.modal.title': '회원등급 관리',
  'pages.membership.level.modal.gradeName': '등급이름',
  'pages.membership.level.modal.purchaseFee': '사입수수료(%)',
  'pages.membership.level.modal.serviceFee': '포인트적립(%)',
  'pages.membership.level.modal.numberOfDeliveries': '등급구분',
  'pages.membership.level.modal.levelUpCoupon': '추가환출금액',
  'pages.membership.level.modal.pointAccumulation': '포인트적립(%)',
  'pages.membership.level.modal.exchangeRates': '등급별 적용 환율',
  'pages.membership.level.modal.usageStatus': '사용여부',
  'pages.membership.level.modal.active': '사용',
  'pages.membership.level.modal.inactive': '미사용',

  // Center Management
  'pages.center.title': '센터 관리',
  'pages.center.centerRegistration': '센터 등록',
  'pages.center.centerAlignment': '센터 정렬',
  'pages.center.nation': '국가',
  'pages.center.center': '센터',
  'pages.center.centerCode': '센터 코드',
  'pages.center.unitOfMeasurement': '계량 단위 (무게)',
  'pages.center.transportationMethod': '운송 방법',
  'pages.center.address': '주소',
  'pages.center.phoneNumber': '전화번호',
  'pages.center.shippingCenter': '배송 센터',
  'pages.center.whetherToUse': '사용 여부',
  'pages.center.deleteConfirmContent': '이 센터를 삭제하시겠습니까?',
  'pages.center.modal.title': '센터 등록/수정',
  'pages.center.modal.nation': '국가',
  'pages.center.modal.centerName': '센터명',
  'pages.center.modal.centerCode': '센터 코드',
  'pages.center.modal.postalCode': '우편번호',
  'pages.center.modal.city': '도시',
  'pages.center.modal.state': '주/도',
  'pages.center.modal.address1': '주소 1',
  'pages.center.modal.address2': '주소 2',
  'pages.center.modal.phoneNumber': '전화번호',
  'pages.center.modal.weightUnit': '무게 단위',
  'pages.center.modal.transportationMethod': '운송 방법',
  'pages.center.modal.image': '이미지 (417 x 235)',
  'pages.center.modal.chooseFile': '파일 선택',
  'pages.center.modal.whetherToUse': '사용 여부',
  'pages.center.modal.briefSummary': '간략 설명',
  'pages.center.alignmentModal.title': '센터 정렬',
  'pages.center.alignmentModal.centerManagement': '센터 관리',
  'pages.center.alignmentModal.order': '순서',
  'pages.center.alignmentModal.dragToReorder': '드래그하여 순서 변경',
  'pages.center.alignmentModal.center1': '대한민국 (인천)',
  'pages.center.alignmentModal.center2': '중국 (위해)',
  'pages.center.alignmentModal.center3': '중국 (칭다오)',
  'pages.center.alignmentModal.center4': '중국 (광저우)',
  'pages.center.alignmentModal.center5': '중국 (이우)',
  'pages.center.alignmentModal.center6': '중국 (항저우)',

  // Deposit Account Management
  'pages.depositAccount.title': '예치금 계좌 관리',
  'pages.depositAccount.register': '예치금 계좌 등록',
  'pages.depositAccount.id': 'ID',
  'pages.depositAccount.bankName': '은행명',
  'pages.depositAccount.accountNumber': '계좌번호',
  'pages.depositAccount.depositor': '예금주',
  'pages.depositAccount.whetherToUse': '사용 여부',
  'pages.depositAccount.deleteConfirmContent': '이 계좌를 삭제하시겠습니까?',
  'pages.depositAccount.modal.title': '예치금 계좌 등록/수정',
  'pages.depositAccount.modal.bankName': '은행명',
  'pages.depositAccount.modal.accountNumber': '계좌번호',
  'pages.depositAccount.modal.depositor': '예금주',
  'pages.depositAccount.modal.whetherToUse': '사용 여부',

  // Exchange Rate (Customs & Applicable)
  'pages.customsExchangeRate.title': '관세 환율',
  'pages.applicableExchangeRate.title': '적용 환율',
  'pages.exchangeRate.register': '환율 등록',
  'pages.exchangeRate.id': 'ID',
  'pages.exchangeRate.nation': '국가',
  'pages.exchangeRate.period': '기간 (제목)',
  'pages.exchangeRate.exchangeRate': '환율',
  'pages.exchangeRate.deleteConfirmContent': '이 환율을 삭제하시겠습니까?',
  'pages.exchangeRate.modal.title': '환율 등록',
  'pages.exchangeRate.modal.nation': '국가',
  'pages.exchangeRate.modal.period': '기간 (제목)',
  'pages.exchangeRate.modal.periodPlaceholder': '예: October 1, 2022 - October 31, 2022',
  'pages.exchangeRate.modal.exchangeRate': '환율',

  // Additional Service Management
  'pages.additionalService.title': '추가 서비스 관리',
  'pages.additionalService.note1': '추가 서비스 비용은 주문 시 자동으로 추가됩니다.',
  'pages.additionalService.note2': '¥ = 위안화 / ₩ = 원화 / $ = 달러',
  'pages.additionalService.saveChanges': '변경사항 저장',
  'pages.additionalService.additionalServices': '추가 서비스',
  'pages.additionalService.amount': '금액',
  'pages.additionalService.explanation': '설명',
  'pages.additionalService.localShippingFee': '현지 배송비',
  'pages.additionalService.additionalCosts': '추가 비용',
  'pages.additionalService.excessCostOfItems': '물품 초과 비용',
  'pages.additionalService.uninspectedShipment': '미검수 배송',
  'pages.additionalService.uninspectedShipmentExplanation': '상품의 개수/사이즈/색상/옵션 등을 확인하지 않고 배송하는 서비스입니다. 단, 제품 외관 파손 여부는 검수합니다.',
  'pages.additionalService.finishworkCostVVIC': '마감작업 비용 (VVIC 필수)',
  'pages.additionalService.finishworkCostVVICExplanation': '도매 상품 마감 작업 비용',
  'pages.additionalService.precisionInspection': '정밀 검수',
  'pages.additionalService.precisionInspectionExplanation': '상품 사이즈/색상 등의 상세한 검수를 원하실 경우, 비용 청구 시 정밀 검수비가 추가됩니다. 검수 후 추가 비용이 발생할 수 있습니다. 검수 후 추가 비용이 발생할 수 있습니다. 스마트폰으로 촬영한 검수 사진을 제공합니다.',
  'pages.additionalService.doNotOpenTheProduct': '제품 개봉 금지',
  'pages.additionalService.businessInspection': '사업자 검수',
  'pages.additionalService.businessInspectionExplanation': '사업자 검수 서비스입니다.',
  'pages.additionalService.noNeedToCheckQuantity': '수량 확인 불필요',
  'pages.additionalService.noNeedToCheckQuantityExplanation': '수량 확인이 필요 없는 서비스입니다.',
  'pages.additionalService.customerRequestReview': '회원 요청 검수',
  'pages.additionalService.customerRequestReviewExplanation': '회원이 요청한 사항을 검수합니다.',
  'pages.additionalService.noInspectionRequired': '검수 불필요',
  'pages.additionalService.noInspectionRequiredExplanation': '검수가 필요 없는 서비스입니다.',
  'pages.additionalService.bubbleWrapPackaging': '에어캡 포장',
  'pages.additionalService.bubbleWrapPackagingExplanation': '에어캡으로 상품을 포장합니다.',
  'pages.additionalService.indivBox': '개별 박스',
  'pages.additionalService.indivBoxExplanation': '상품을 개별 박스에 포장합니다.',
  'pages.additionalService.usdExchangeRate': 'USD 환율 (위안화 금액을 환율로 나눔)',
  'pages.additionalService.example': '예시)',
  'pages.additionalService.serviceName': '서비스명',
  'pages.additionalService.serviceNamePlaceholder': '서비스명을 입력하세요',
  'pages.additionalService.unit': '단위',
  'pages.additionalService.unitPlaceholder': '예: 개, 박스',
  'pages.additionalService.serviceNameKo': '서비스명 (한글)',
  'pages.additionalService.serviceNameZh': '서비스명 (중문)',
  'pages.additionalService.serviceNameEn': '서비스명 (영문)',
  'pages.additionalService.unitPrice': '단가 (₩)',
  'pages.additionalService.unitPricePlaceholder': '단가를 입력하세요',
  'pages.additionalService.sortOrder': '정렬 순서',
  'pages.additionalService.sortOrderPlaceholder': '정렬 순서를 입력하세요',
  'pages.additionalService.code': '코드',
  'pages.additionalService.codePlaceholder': '서비스 코드 입력 (선택사항)',
  'pages.additionalService.requiresQuantity': '수량 필요',
  'pages.additionalService.status': '상태',
  'pages.additionalService.addService': '서비스 추가',
  'pages.additionalService.editService': '서비스 수정',

  // Island and Mountain Cost Management
  'pages.islandMountainCost.import': '파일 업로드',
  'pages.islandMountainCost.import.title': '도서산간비용 파일 업로드',
  'pages.islandMountainCost.import.selectFile': '엑셀 파일 선택',
  'pages.islandMountainCost.import.fileHint': '도서산간 엑셀(.xlsx). 시트 첫 줄에 우편번호 제목("우편번호" 또는 "국가기초코드")과 도선료 제목("도선료" 또는 "도선료금")이 있어야 합니다.',
  'pages.excelFormat.title': '올릴 파일 예시',
  'pages.excelFormat.download': '견본 내려받기',
  'pages.excelFormat.downloadFailed': '견본 파일을 만들지 못했습니다',
  'pages.excelFormat.headerRequired': '첫 줄은 반드시 제목줄이여야 합니다.',
  'pages.excelFormat.noHeaderRow': '제목줄 없이 첫 줄부터 자료를 넣으십시오. 제목줄이 있으면 건너뜁니다.',
  'pages.excelFormat.aliases': '제목으로 쓸 수 있는 이름:',
  'pages.islandMountainCost.import.formatNote': '다른 렬이 더 있어도 되고, 시트가 여러 장이여도 됩니다.',
  'pages.islandMountainCost.import.modeTitle': '반영 방식',
  'pages.islandMountainCost.import.mode.merge': '병합',
  'pages.islandMountainCost.import.mode.mergeHint': '파일에 있는 우편번호만 갱신·추가하고, 파일에 없는 우편번호는 그대로 둡니다.',
  'pages.islandMountainCost.import.mode.replace': '전체 교체',
  'pages.islandMountainCost.import.mode.replaceHint': '파일을 전체 목록으로 보고, 파일에 없는 우편번호는 삭제합니다.',
  'pages.islandMountainCost.import.fileRequired': '파일을 선택해주세요',
  'pages.islandMountainCost.import.analyzing': '파일을 확인하는 중입니다...',
  'pages.islandMountainCost.import.applying': '반영하는 중입니다...',
  'pages.islandMountainCost.import.analyze': '파일 확인',
  'pages.islandMountainCost.import.apply': '반영',
  'pages.islandMountainCost.import.reselect': '다른 파일 선택',
  'pages.islandMountainCost.import.failed': '파일 처리에 실패했습니다',
  'pages.islandMountainCost.import.previewTitle': '반영하면 이렇게 바뀝니다',
  'pages.islandMountainCost.import.sheetsTitle': '시트별 읽은 내용',
  'pages.islandMountainCost.import.sheetName': '시트',
  'pages.islandMountainCost.import.sheetRows': '행',
  'pages.islandMountainCost.import.sheetUnique': '우편번호',
  'pages.islandMountainCost.import.sheetFees': '도선료금',
  'pages.islandMountainCost.import.sheetKind.fee': '요금 시트',
  'pages.islandMountainCost.import.sheetKind.mixed': '혼재 지역 (등록 안 함)',
  'pages.islandMountainCost.import.sheetKind.empty': '읽을 내용 없음',
  'pages.islandMountainCost.import.toCreate': '추가',
  'pages.islandMountainCost.import.toUpdate': '금액 변경',
  'pages.islandMountainCost.import.unchanged': '변경 없음',
  'pages.islandMountainCost.import.toDelete': '삭제',
  'pages.islandMountainCost.import.toKeep': '유지',
  'pages.islandMountainCost.import.keepNotice.count': '파일에 없는 우편번호 {count}건은 그대로 둡니다. 삭제되지 않습니다.',
  'pages.islandMountainCost.import.deleteWarning': '파일에 없는 우편번호 {count}건이 삭제됩니다. 수동으로 등록한 항목도 포함됩니다.',
  'pages.islandMountainCost.import.deleteSamples': '삭제될 항목 (일부)',
  'pages.islandMountainCost.import.mixedNotice': '혼재 지역 {count}건은 도선료금이 없어 등록하지 않습니다.',
  'pages.islandMountainCost.import.conflictNotice': '두 시트에 다른 금액으로 나온 우편번호 {count}건은 큰 금액을 적용합니다.',
  'pages.islandMountainCost.import.invalidNotice': '읽지 못한 행 {count}건은 건너뜁니다.',
  'pages.islandMountainCost.import.keepNotice': '추가 요금과 메모는 파일에 없어, 이미 등록된 우편번호는 기존 값을 그대로 둡니다.',
  'pages.islandMountainCost.import.done': '반영 완료 — 추가 {created}건 / 변경 {updated}건 / 삭제 {deleted}건',
  'pages.islandMountainCost.import.doneMerge': '반영 완료 — 추가 {created}건 / 변경 {updated}건 / 유지 {kept}건',
  'pages.islandMountainCost.title': '도서산간 비용 관리',
  'pages.islandMountainCost.from': '부터',
  'pages.islandMountainCost.all': '전체',
  'pages.islandMountainCost.resetAbove': '위 조건 초기화',
  'pages.islandMountainCost.register': '등록',
  'pages.islandMountainCost.no': 'No',
  'pages.islandMountainCost.postalCode': '우편번호',
  'pages.islandMountainCost.ferryFare': '도선료',
  'pages.islandMountainCost.additionalFare': '추가 요금',
  'pages.islandMountainCost.memo': '메모',
  'pages.islandMountainCost.registrationDate': '등록일 (수정일 날짜)',
  'pages.islandMountainCost.deleteConfirmContent': '이 항목을 삭제하시겠습니까?',
  'pages.islandMountainCost.modal.title': '도선료 등록/수정',
  'pages.islandMountainCost.modal.postalCode': '우편번호',
  'pages.islandMountainCost.modal.postalCodeExample': '예시) 5자리 도로명 우편번호',
  'pages.islandMountainCost.modal.ferryFare': '도선료',
  'pages.islandMountainCost.modal.additionalFare': '추가 요금',
  'pages.islandMountainCost.modal.memo': '메모',

  // Item Management
  'pages.itemManagement.title': '품목 관리',
  'pages.itemManagement.customsClearanceItems': '통관 품목',
  'pages.itemManagement.customsClearanceItemCategories': '통관 품목 카테고리',
  'pages.itemManagement.registerItem': '품목 등록',
  'pages.itemManagement.categoryRegistration': '카테고리 등록',
  'pages.itemManagement.itemNumber': '품목 번호',
  'pages.itemManagement.hsCode': 'HS CODE',
  'pages.itemManagement.category': '카테고리',
  'pages.itemManagement.itemName': '품목명',
  'pages.itemManagement.itemNameEnglish': '품목명 (영문)',
  'pages.itemManagement.itemNameChinese': '품목명 (중문)',
  'pages.itemManagement.whetherOrNotToClearTheList': '목록 통관 여부',
  'pages.itemManagement.tariffRate': '관세율',
  'pages.itemManagement.vatRate': '부가세율',
  'pages.itemManagement.categorySymbol': '카테고리 기호',
  'pages.itemManagement.categoryNumber': '카테고리 번호',
  'pages.itemManagement.categoryName': '카테고리명',
  'pages.itemManagement.categoryNameEnglish': '카테고리명 (영문)',
  'pages.itemManagement.whetherToUse': '사용 여부',
  'pages.itemManagement.deleteItemConfirm': '이 품목을 삭제하시겠습니까?',
  'pages.itemManagement.deleteCategoryConfirm': '이 카테고리를 삭제하시겠습니까?',
  'pages.itemManagement.itemModal.title': '통관 품목 등록/수정',
  'pages.itemManagement.modal.category': '카테고리',
  'pages.itemManagement.modal.hsCode': 'HS CODE',
  'pages.itemManagement.modal.itemName': '품목명',
  'pages.itemManagement.modal.itemNameEnglish': '품목명 (영문)',
  'pages.itemManagement.modal.itemNameChinese': '품목명 (중문)',
  'pages.itemManagement.modal.whetherOrNotToClearTheList': '목록 통관 여부',
  'pages.itemManagement.modal.tariffRate': '관세율',
  'pages.itemManagement.modal.vatRate': '부가세율',
  'pages.itemManagement.categoryModal.title': '카테고리 등록/수정',
  'pages.itemManagement.categoryModal.category': '카테고리',
  'pages.itemManagement.categoryModal.categoryEnglish': '카테고리 (영문)',
  'pages.itemManagement.categoryModal.whetherToUse': '사용 여부',
  'pages.itemManagement.categoryId': '카테고리 ID',
  'pages.itemManagement.parentId': '상위 ID',
  'pages.itemManagement.chineseName': '중국어 이름',
  'pages.itemManagement.englishName': '영어 이름',
  'pages.itemManagement.simpleNonSimple': '간이/비간이',
  'pages.itemManagement.source': '출처',
  'pages.itemManagement.addTime': '등록일시',
  'pages.itemManagement.title.hsCode': 'HS CODE 관리',
  'pages.itemManagement.importExcel': 'Excel 가져오기',
  'pages.itemManagement.exportExcel': 'Excel 내보내기',
  'pages.itemManagement.importSuccess': '{count}건이 성공적으로 가져왔습니다',
  'pages.itemManagement.importFailed': 'Excel 가져오기 실패',
  'pages.itemManagement.exportFailed': 'Excel 내보내기 실패',

  // Waybill Bandwidth Management
  'pages.waybillBandwidth.title': '운송장 대역폭 관리',
  'pages.waybillBandwidth.registerWaybillBandwidth': '운송장 대역폭 등록',
  'pages.waybillBandwidth.no': 'No',
  'pages.waybillBandwidth.centerTransportationMethod': '센터/운송방법',
  'pages.waybillBandwidth.osxId': 'OSX ID',
  'pages.waybillBandwidth.info': '정보',
  'pages.waybillBandwidth.waybillBandwidth': '운송장 대역폭',
  'pages.waybillBandwidth.shipCondition': '배송 조건',
  'pages.waybillBandwidth.numberOfAvailable': '사용 가능 수',
  'pages.waybillBandwidth.numberOfAvailableWaybills': '사용 가능한 운송장 수',
  'pages.waybillBandwidth.whetherToUse': '사용 여부',
  'pages.waybillBandwidth.registrationDate': '등록일',
  'pages.waybillBandwidth.notInUse': '사용 안함',
  'pages.waybillBandwidth.deleteConfirmContent': '이 운송장 대역폭을 삭제하시겠습니까?',
  'pages.waybillBandwidth.modal.title': '운송장 대역폭 등록',
  'pages.waybillBandwidth.modal.center': '센터',
  'pages.waybillBandwidth.modal.for': '위해',
  'pages.waybillBandwidth.modal.guangzhou': '광저우',
  'pages.waybillBandwidth.modal.transportationMethod': '운송 방법',
  'pages.waybillBandwidth.modal.domesticTransportationCompany': '국내 운송 회사',
  'pages.waybillBandwidth.modal.bandwidth': '대역폭',

  // Order Statistics
  'pages.orderStatistics.title': '주문 통계',
  'pages.orderStatistics.annualOrderStatistics': '연간 주문 통계',
  'pages.orderStatistics.monthlyOrderStatistics': '월간 주문 통계',
  'pages.orderStatistics.applicationItem': '신청 항목',
  'pages.orderStatistics.costClassification': '비용 분류',
  'pages.orderStatistics.january': '1월',
  'pages.orderStatistics.february': '2월',
  'pages.orderStatistics.march': '3월',
  'pages.orderStatistics.april': '4월',
  'pages.orderStatistics.may': '5월',
  'pages.orderStatistics.june': '6월',
  'pages.orderStatistics.july': '7월',
  'pages.orderStatistics.august': '8월',
  'pages.orderStatistics.september': '9월',
  'pages.orderStatistics.october': '10월',
  'pages.orderStatistics.november': '11월',
  'pages.orderStatistics.december': '12월',
  'pages.orderStatistics.days': '일',
  'pages.orderStatistics.year': '년',
  'pages.orderStatistics.month': '월',
  'pages.orderStatistics.center': '센터',
  'pages.orderStatistics.all': '전체',
  'pages.orderStatistics.for': '위해',
  'pages.orderStatistics.guangzhou': '광저우',
  'pages.orderStatistics.centerNote': '* 센터를 선택하면 해당 센터의 주문 통계를 기준으로 표시됩니다 (선택하지 않으면 전체 센터 기준)',
  'pages.orderStatistics.annualPaymentCost': '연간 결제 비용',
  'pages.orderStatistics.monthlyPaymentFee': '월간 결제 수수료',

  // Member Statistics
  'pages.memberStatistics.title': '회원 통계',
  'pages.memberStatistics.annualMembershipStatistics': '연간 회원 통계',
  'pages.memberStatistics.monthlyMembershipStatistics': '월간 회원 통계',
  'pages.memberStatistics.memberType': '회원 유형',
  'pages.memberStatistics.applicationItem': '신청 항목',
  'pages.memberStatistics.memberName': '회원 이름',
  'pages.memberStatistics.leeSeomHo': '이섬호',
  'pages.memberStatistics.leeSeomBark': '이섬박',
  'pages.memberStatistics.memberNote': '* 회원을 선택하면 해당 회원의 주문 통계를 기준으로 표시됩니다 (선택하지 않으면 전체 회원 기준)',

  // Worker Statistics
  'pages.workerStatistics.title': '작업자 통계',
  'pages.workerStatistics.workerName': '작업자 이름',
  'pages.workerStatistics.numberOfActualCases': '실제 건수',
  'pages.workerStatistics.actualAverage': '실제 평균',
  'pages.workerStatistics.numberOfPackages': '포장 건수',
  'pages.workerStatistics.packagingAverage': '포장 평균',
  'pages.workerStatistics.workerOfOrderClass': '주문 클래스의 작업자',

  // Worker Log
  'pages.workerLog.title': '작업자 로그',
  'pages.workerLog.no': '번호',
  'pages.workerLog.trackingNumber': '추적 번호',
  'pages.workerLog.orderNumber': '주문 번호',
  'pages.workerLog.operationLog': '작업 로그',
  'pages.workerLog.workerName': '작업자 이름',
  'pages.workerLog.recipientName': '수령인 이름',
  'pages.workerLog.memberNamePostOffice': '회원 이름/우체국',
  'pages.workerLog.waybillNumber': '운송장 번호',
  'pages.workerLog.packagingDate': '포장일',
  'pages.workerLog.shippingDate': '배송일',

  // Tax Settlement Management
  'pages.taxSettlement.title': '세금 정산 관리',
  'pages.taxSettlement.no': '번호',
  'pages.taxSettlement.agencyClassification': '대행 분류',
  'pages.taxSettlement.purchaseAmount': '구매 금액',
  'pages.taxSettlement.purchaseFee': '구매 수수료',
  'pages.taxSettlement.region': '지역',
  'pages.taxSettlement.transportationMethod': '운송 방법',
  'pages.taxSettlement.mailboxNumber': '우편함 번호',
  'pages.taxSettlement.waybillNumber': '운송장 번호',
  'pages.taxSettlement.orderNumber': '주문 번호',
  'pages.taxSettlement.receiver': '수령인',
  'pages.taxSettlement.recipientAddress': '수령인 주소',
  'pages.taxSettlement.personalCustomsCode': '개인 통관 코드',
  'pages.taxSettlement.productNameEnglish': '제품명 (영문)',
  'pages.taxSettlement.ct': 'C/T',
  'pages.taxSettlement.weight': '무게',
  'pages.taxSettlement.shippingCosts': '배송 비용',
  'pages.taxSettlement.additionalServices': '추가 서비스',
  'pages.taxSettlement.additionalCostPayment': '추가 비용 지불',
  'pages.taxSettlement.memberName': '회원 이름',
  'pages.taxSettlement.federalCode': '연방 코드',
  'pages.taxSettlement.excelDownload': 'Excel 다운로드',

  // Purchase Cost Statistics
  'pages.purchaseCost.title': '구매 비용 통계',
  'pages.purchaseCost.costItems': '비용 항목',
  'pages.purchaseCost.totalWon': '합계 (₩)',
  'pages.purchaseCost.yuanAmount': '위안화 (¥)',
  'pages.purchaseCost.no': '번호',
  'pages.purchaseCost.purchaseCompletionDate': '구매 완료일',
  'pages.purchaseCost.orderNumber': '주문 번호',
  'pages.purchaseCost.transportationMethod': '운송 방법',
  'pages.purchaseCost.productPurchaseCost': '제품 구매 비용',
  'pages.purchaseCost.localShippingFee': '현지 배송비',
  'pages.purchaseCost.purchaseFee': '구매 수수료',
  'pages.purchaseCost.additionalCost': '추가 비용',
  'pages.purchaseCost.excessCostOfItems': '품목 초과 비용',
  'pages.purchaseCost.productPurchaseCostPercent': '제품 구매 비용 (%)',
  'pages.purchaseCost.localShippingFeePercent': '현지 배송비 (%)',
  'pages.purchaseCost.purchaseFeePercent': '구매 수수료 (%)',
  'pages.purchaseCost.additionalCostPercent': '추가 비용 (%)',
  'pages.purchaseCost.excessCostOfItemsPercent': '품목 초과 비용 (%)',
  'pages.purchaseCost.yuan': '위안화',

  // Trade Cost Statistics
  'pages.tradeCost.title': '무역 비용 통계',
  'pages.tradeCost.applicationType': '신청 유형',
  'pages.tradeCost.chibaYonggun1': '1 치바용군 (gun)',
  'pages.tradeCost.chibayong1': '1 치바용 (₩)',
  'pages.tradeCost.chibaYonggun2': '2-치바용군 (gun)',
  'pages.tradeCost.chiba2': '2 치바 (₩)',
  'pages.tradeCost.chibaYonggun3': '3-치바용군 (gun)',
  'pages.tradeCost.pieceSet3': '3-피스 세트 (₩)',
  'pages.tradeCost.totalAmount': '총 금액 (₩)',
  'pages.tradeCost.no': '번호',
  'pages.tradeCost.tradeNumber': '거래 번호',
  'pages.tradeCost.endDate': '종료일',
  'pages.tradeCost.memberName': '회원 이름',
  'pages.tradeCost.mailboxNumber': '우편함 번호',
  'pages.tradeCost.firstCost': '1차 비용 (₩)',
  'pages.tradeCost.secondaryCost': '2차 비용 (₩)',
  'pages.tradeCost.thirdCost': '3차 비용 (₩)',
  'pages.tradeCost.select': '= 선택',
  'pages.tradeCost.detailList': '상세 목록',
  'pages.tradeCost.noData': '데이터 없음',

  // Payment Agency Statistics
  'pages.paymentAgency.title': '결제 대행 통계',
  'pages.paymentAgency.annualPaymentAgencyStatistics': '연간 결제 대행 통계',
  'pages.paymentAgency.monthlyPaymentAgencyStatistics': '월간 결제 대행 통계',
  'pages.paymentAgency.applicationItem': '신청 항목',
  'pages.paymentAgency.note': '* 계산은 주문 수와 금액을 기준으로 하며 통계는 완료 시점을 기준으로 합니다 (배송/구매, 광저우/해외), 반품 (반품 완료)',
  'pages.paymentAgency.monthlyNote': '* 계산은 주문 수와 금액을 기준으로 하며 통계는 완료 시점을 기준으로 합니다 (결제 대행, 대행 완료)',
  'pages.paymentAgency.annualPaymentCost': '연간 결제 비용',
  'pages.paymentAgency.monthlyPaymentFee': '월간 결제 수수료',

  // Solution Inquiry
  'pages.solutionInquiry.title': '솔루션 문의',
  'pages.solutionInquiry.announcement': '공지사항',
  'pages.solutionInquiry.workRequest': '작업 요청',
  'pages.solutionInquiry.administratorGuide': '관리자 가이드',
  'pages.solutionInquiry.num': '번호',
  'pages.solutionInquiry.author': '작성자',
  'pages.solutionInquiry.dateOfWriting': '작성일',
  'pages.solutionInquiry.check': '조회',
  'pages.solutionInquiry.menu': '메뉴',
  'pages.solutionInquiry.submenu': '하위 메뉴',
  'pages.solutionInquiry.submenuFilter': '= 하위 메뉴',
  'pages.solutionInquiry.detail': '상세',
  'pages.solutionInquiry.noContent': '내용이 없습니다',
  'pages.solutionInquiry.depositInfo': '입금 계좌 정보: 국민은행 984784307598 Areum Solution Co., Ltd.',
  'pages.solutionInquiry.copyright': '©Copyright 2014 — 2026 Arum Solution. All rights reserved. Go to',
  'pages.solutionInquiry.requestNumber': '요청 번호',
  'pages.solutionInquiry.requestType': '요청 유형',
  'pages.solutionInquiry.status': '상태',
  'pages.solutionInquiry.requestDate': '요청일',
  'pages.solutionInquiry.completionDate': '완료일',
  'pages.solutionInquiry.description': '설명',

  'pages.common.ok': '확인',

  // Trade Services
  'pages.orders.tradeServices.serviceType': '서비스 유형',
  'pages.orders.tradeServices.type': '유형',
  'pages.orders.tradeServices.tradeNumber': '무역번호',
  'pages.orders.tradeServices.tradeNumberPlaceholder': '무역번호 입력',
  'pages.orders.tradeServices.applicationDate': '신청일',
  'pages.orders.tradeServices.typeCenter': '유형/센터',
  'pages.orders.tradeServices.title': '제목',
  'pages.orders.tradeServices.progress': '진행상태',
  'pages.orders.tradeServices.progressApplication': '신청',
  'pages.orders.tradeServices.progressQuotation': '견적',
  'pages.orders.tradeServices.progressPayment': '결제대기',
  'pages.orders.tradeServices.progressInProgress': '진행중',
  'pages.orders.tradeServices.progressCompleted': '완료',
  'pages.orders.tradeServices.paymentInfo': '결제정보',
  'pages.orders.tradeServices.quotationAmount': '견적금액',
  'pages.orders.tradeServices.paidAmount': '결제금액',
  'pages.orders.tradeServices.documents': '견적서/완료보고서',
  'pages.orders.tradeServices.viewQuotation': '견적서 보기',
  'pages.orders.tradeServices.viewCompletionReport': '완료보고서 보기',
  'pages.orders.tradeServices.viewApplication': '신청서 보기',
  'pages.orders.tradeServices.delete': '삭제',
  'pages.orders.tradeServices.viewingApplication': '{number} 신청서를 확인합니다',
  'pages.orders.tradeServices.deleteConfirm': '{number}를 삭제하시겠습니까?',
  'pages.orders.tradeServices.sampleTitle1': '의류 수출 대행 신청',
  'pages.orders.tradeServices.sampleTitle2': '전자제품 수입 통관 대행',
  'pages.orders.tradeServices.sampleTitle3': '무역 컨설팅 요청',
  'pages.orders.tradeServices.export': '수출',
  'pages.orders.tradeServices.import': '수입',
  'pages.orders.tradeServices.customs': '통관',
  'pages.orders.tradeServices.consulting': '컨설팅',
  'pages.orders.tradeServices.amount': '금액',
  'pages.orders.tradeServices.requestDate': '신청일',
  'pages.orders.tradeServices.completionDate': '완료일',
  'pages.orders.tradeServices.totalServices': '총 서비스',
  'pages.orders.tradeServices.processingServices': '처리중 서비스',
  'pages.orders.tradeServices.completedServices': '완료된 서비스',
  'pages.orders.tradeServices.totalAmount': '총 금액',
  'pages.orders.tradeServices.pendingCount': '대기중',
  'pages.orders.tradeServices.overdueCount': '기한 초과',
  'pages.orders.tradeServices.totalPendingAmount': '총 대기 금액',
  'pages.orders.tradeServices.dueDate': '마감일',
  'pages.orders.tradeServices.processPayment': '결제 처리',
  'pages.orders.tradeServices.paymentProcessed': '결제가 처리되었습니다',
  'pages.orders.tradeServices.sampleMemo': '샘플 메모',
  
  // Trade Services - Comprehensive Management Filter
  'pages.orders.tradeServices.marketResearchUnitPrice': '시장조사 (제품단가)',
  'pages.orders.tradeServices.marketResearchOEM': '시장조사 (OEM공장)',
  'pages.orders.tradeServices.productionAgency': '생산대행',
  'pages.orders.tradeServices.exportAgency': '수출대행',
  'pages.orders.tradeServices.oneStopGuide': '원스톱 가이드',
  'pages.orders.tradeServices.applicationReception': '신청접수',
  'pages.orders.tradeServices.confirmationReceipt': '접수확인',
  'pages.orders.tradeServices.paymentWaiting1st': '결제대기(1차)',
  'pages.orders.tradeServices.inProgress': '진행중',
  'pages.orders.tradeServices.1stCompletion': '1차완료',
  'pages.orders.tradeServices.paymentWaiting2nd': '결제대기(2차)',
  'pages.orders.tradeServices.paymentCompleted2nd': '결제완료(2차)',
  'pages.orders.tradeServices.paymentCompleted3rd': '결제완료(3차)',
  'pages.orders.tradeServices.shipmentCompleted': '출하완료',
  'pages.orders.tradeServices.cancelApplication': '신청취소',
  
  // Payment Agency - Comprehensive Management Filter
  'pages.orders.paymentAgency.title': '결제대행',
  'pages.orders.paymentAgency.waitingForPayment': '결제대기',
  'pages.orders.paymentAgency.depositCompleted': '입금완료',
  'pages.orders.paymentAgency.paymentCompletedAtPurchase': '구매시점 결제완료',
  'pages.orders.paymentAgency.agencyCompleted': '대행완료',
  'pages.orders.paymentAgency.paymentRefundRequest': '결제환불요청',
  'pages.orders.paymentAgency.paymentRefundCompleted': '결제환불완료',
  'pages.orders.paymentAgency.cancellation': '취소',

  // Trade Service Application Modal
  'pages.orders.tradeServices.applicationModal.title': '무역 서비스 - 시장조사 (제품 단가)',
  'pages.orders.tradeServices.applicationModal.basicInfo': '기본 정보',
  'pages.orders.tradeServices.applicationModal.centerName': '센터명',
  'pages.orders.tradeServices.applicationModal.quotationReport': '견적서/완료보고서',
  'pages.orders.tradeServices.applicationModal.chooseFile': '파일 선택',
  'pages.orders.tradeServices.applicationModal.fileSelect': '파일 선택',
  'pages.orders.tradeServices.applicationModal.fileUpload': '파일 업로드',
  'pages.orders.tradeServices.applicationModal.applicationInfo': '신청 정보',
  'pages.orders.tradeServices.applicationModal.client': '거래처',
  'pages.orders.tradeServices.applicationModal.totalQuantity': '총 수량',
  'pages.orders.tradeServices.applicationModal.totalAmount': '총 금액',
  'pages.orders.tradeServices.applicationModal.contact': '연락처',
  'pages.orders.tradeServices.applicationModal.email': '이메일',
  'pages.orders.tradeServices.applicationModal.address': '주소',
  'pages.orders.tradeServices.applicationModal.productInfo': '상품 정보',
  'pages.orders.tradeServices.applicationModal.productName': '상품명',
  'pages.orders.tradeServices.applicationModal.productUrl': '상품 URL',
  'pages.orders.tradeServices.applicationModal.material': '재질/소재',
  'pages.orders.tradeServices.applicationModal.estimatedUnitPrice': '예상 단가',
  'pages.orders.tradeServices.applicationModal.quantity': '수량',
  'pages.orders.tradeServices.applicationModal.productImage': '상품 이미지',
  'pages.orders.tradeServices.applicationModal.downloadImage': '이미지 다운로드',
  'pages.orders.tradeServices.applicationModal.adminMemo': '관리자 메모',

  // Payment Agency
  'pages.orders.paymentAgency.paymentType': '결제 유형',
  'pages.orders.paymentAgency.alipay': '알리페이',
  'pages.orders.paymentAgency.wechat': '위챗페이',
  'pages.orders.paymentAgency.unionpay': '유니온페이',
  'pages.orders.paymentAgency.bank': '은행 송금',
  'pages.orders.paymentAgency.amount': '금액',
  'pages.orders.paymentAgency.requestDate': '신청일',
  'pages.orders.paymentAgency.completionDate': '완료일',
  'pages.orders.paymentAgency.totalPayments': '총 결제',
  'pages.orders.paymentAgency.processingPayments': '처리중 결제',
  'pages.orders.paymentAgency.completedPayments': '완료된 결제',
  'pages.orders.paymentAgency.totalAmount': '총 금액',
  'pages.orders.paymentAgency.pendingCount': '대기중',
  'pages.orders.paymentAgency.overdueCount': '기한 초과',
  'pages.orders.paymentAgency.totalPendingAmount': '총 대기 금액',
  'pages.orders.paymentAgency.dueDate': '마감일',
  'pages.orders.paymentAgency.processPayment': '결제 처리',
  'pages.orders.paymentAgency.paymentProcessed': '결제가 처리되었습니다',
  'pages.orders.paymentAgency.sampleMemo': '샘플 메모',

  // Order Finance
  'pages.orderFinance.headerTitle': '주문 재무 목록',
  'pages.orderFinance.modal.title': '주문 재무 상세',
  'pages.orderFinance.column.orderNumber': '주문번호',
  'pages.orderFinance.column.user': '회원',
  'pages.orderFinance.column.progressStatus': '진행상태',
  'pages.orderFinance.column.firstTierStatus': '1차 결제상태',
  'pages.orderFinance.column.firstTierPaymentMethod': '1차 결제수단',
  'pages.orderFinance.column.firstTierPaidAt': '1차 결제일',
  'pages.orderFinance.column.secondTierStatus': '2차 결제상태',
  'pages.orderFinance.column.secondTierPaymentMethod': '2차 결제수단',
  'pages.orderFinance.column.secondTierPaidAt': '2차 결제일',
  'pages.orderFinance.column.firstTierAmountKRW': '1차 금액 (₩)',
  'pages.orderFinance.column.secondTierAmountKRW': '2차 금액 (₩)',
  'pages.orderFinance.column.totalChargeKRW': '총 청구금액 (₩)',
  'pages.orderFinance.column.totalCollectedKRW': '총 수납금액 (₩)',
  'pages.orderFinance.column.outstandingKRW': '미수금 (₩)',
  'pages.orderFinance.column.hasRefundRisk': '환불위험',
  'pages.orderFinance.column.updatedAt': '최근 변경시각',
  'pages.orderFinance.column.createdAt': '생성일',
  'pages.orderFinance.refundRisk.danger': '위험',
  'pages.orderFinance.refundRisk.normal': '정상',
  'pages.orderFinance.modal.userId': '회원',
  'pages.orderFinance.modal.memberId': '회원 ID',
  'pages.orderFinance.modal.email': '이메일',
  'pages.orderFinance.modal.progressStatus': '진행상태',
  'pages.orderFinance.modal.firstTierStatus': '1차 결제상태',
  'pages.orderFinance.modal.firstTierPaymentMethod': '1차 결제수단',
  'pages.orderFinance.modal.firstTierAmount': '1차 금액',
  'pages.orderFinance.modal.firstTierBeforeDiscount': '1차 할인전 금액',
  'pages.orderFinance.modal.firstTierPaidAt': '1차 결제일',
  'pages.orderFinance.modal.secondTierStatus': '2차 결제상태',
  'pages.orderFinance.modal.secondTierPaymentMethod': '2차 결제수단',
  'pages.orderFinance.modal.secondTierAmount': '2차 금액',
  'pages.orderFinance.modal.secondTierBeforeDiscount': '2차 할인전 금액',
  'pages.orderFinance.modal.secondTierPaidAt': '2차 결제일',
  'pages.orderFinance.modal.totalCharge': '총 청구금액',
  'pages.orderFinance.modal.totalCollected': '총 수납금액',
  'pages.orderFinance.modal.outstanding': '미수금',
  'pages.orderFinance.modal.createdAt': '생성일',
  'pages.orderFinance.modal.updatedAt': '최근 변경',
  'pages.orderFinance.progressStatus.BUY_PAY_WAIT': '구매비 결제대기',
  'pages.orderFinance.progressStatus.BUY_PAY_DONE': '구매비 결제완료',
  'pages.orderFinance.progressStatus.BUYING_AUTO': '자동 구매중',
  'pages.orderFinance.progressStatus.BUYING_MANUAL': '수동 구매중',
  'pages.orderFinance.progressStatus.BUYING_PROBLEM': '구매 문제',
  'pages.orderFinance.progressStatus.BUYING_FINANCIAL_SETTLEMENT': '구매 정산중',
  'pages.orderFinance.progressStatus.BUY_FINAL_DONE': '구매 완료',
  'pages.orderFinance.progressStatus.WH_IN_DONE': '입고완료',
  'pages.orderFinance.progressStatus.WH_PAY_WAIT': '국제배송비 결제대기',
  'pages.orderFinance.progressStatus.WH_PAY_DONE': '국제배송비 결제완료',
  'pages.orderFinance.paymentStatus.pending': '결제대기',
  'pages.orderFinance.paymentStatus.processing': '처리중',
  'pages.orderFinance.paymentStatus.paid': '결제완료',
  'pages.orderFinance.paymentStatus.failed': '결제실패',
  'pages.orderFinance.paymentStatus.refunded': '환불완료',
  'pages.orderFinance.paymentMethod.card': '카드',
  'pages.orderFinance.paymentMethod.bank': '무통장입금',
  'pages.orderFinance.paymentMethod.deposit': '예치금',
  'pages.orderFinance.paymentMethod.points': '포인트',

  // Refund Records
  'pages.refundRecords.headerTitle': '환불 내역',
  'pages.refundRecords.column.status': '상태',
  'pages.refundRecords.column.gateway': '결제 게이트웨이',
  'pages.refundRecords.column.reason': '환불 사유',
  'pages.refundRecords.column.refundAmountKRW': '환불 금액 (₩)',
  'pages.refundRecords.column.refundCount': '환불 건수',
  'pages.refundRecords.summary.totalRefundAmountKRW': '총 환불 금액',
  'pages.refundRecords.summary.totalRefundCount': '총 환불 건수',
  'pages.refundRecords.summary.paidRefundCount': '완료 환불 건수',
  'pages.refundRecords.summary.refundSuccessRate': '환불 성공률',
  'pages.refundRecords.status.paid': '완료',
  'pages.refundRecords.status.pending': '대기',
  'pages.refundRecords.status.failed': '실패',
  'pages.refundRecords.gateway.deposit': '예치금',
  'pages.refundRecords.gateway.billgate': '빌게이트',
  'pages.refundRecords.gateway.card': '카드',
  'pages.refundRecords.gateway.bank': '무통장입금',
  'pages.refundRecords.filter.startDate': '시작일',
  'pages.refundRecords.filter.endDate': '종료일',

  // Refund Records (settlement page — new design)
  'pages.refundRecords.title': '환불기록',
  'pages.refundRecords.listTitle': '환불기록 리스트',
  'pages.refundRecords.period.todayRefundAmount': '금일 환불금액',
  'pages.refundRecords.period.month': '이번달',
  'pages.refundRecords.period.quarter': '이번분기',
  'pages.refundRecords.period.year': '올해',
  'pages.refundRecords.unit.count': '건수',
  'pages.refundRecords.unit.qty': '개수',
  'pages.refundRecords.stat.total': '전체',
  'pages.refundRecords.stat.partial': '부분환불',
  'pages.refundRecords.stat.bankWithdrawal': '무통장 출금',
  'pages.refundRecords.stat.member': '회원환불',
  'pages.refundRecords.stat.deposit': '예치금',
  'pages.refundRecords.stat.card': '신용카드',
  'pages.refundRecords.stat.full': '전부환불',
  'pages.refundRecords.stat.platform': '플랫폼환불',
  'pages.refundRecords.stat.lostCoupon': '소실쿠폰',
  'pages.refundRecords.stat.final': '최종환불',
  'pages.refundRecords.stat.lostPoints': '소실포인트',
  'pages.refundRecords.viewMode.detail': '상세보기',
  'pages.refundRecords.viewMode.summary': '요약보기',
  'pages.refundRecords.filter.page': '페이지',
  'pages.refundRecords.filter.startTime': '시간시작',
  'pages.refundRecords.filter.endTime': '시간마감',
  'pages.refundRecords.filter.domesticTrackingNo': '국내운송번호',
  'pages.refundRecords.filter.refundReason': '환불이유',
  'pages.refundRecords.filter.platform': '플랫폼구분',
  'pages.refundRecords.filter.errorType': '오류유형',
  'pages.refundRecords.filter.refundType': '환불유형',
  'pages.refundRecords.filter.refundRoute': '환불루트',
  'pages.refundRecords.filter.refundStatus': '환불상태',
  'pages.refundRecords.filter.mailbox': '사서함',
  'pages.refundRecords.filter.sellerMailbox': '셀러사서함',
  'pages.refundRecords.filter.orderNumber': '주문번호',
  'pages.refundRecords.filter.returnDomesticTrackingNo': '반품국내송번호',
  'pages.refundRecords.filter.refundSerialNo': '환불일련번호',
  'pages.refundRecords.filter.memberName': '회원명',
  'pages.refundRecords.filter.asManager': 'AS담당자',
  'pages.refundRecords.filter.returnInternationalTrackingNo': '반품국제송번호',
  'pages.refundRecords.filter.financeManager': '재무담당자',
  'pages.refundRecords.filter.returnManager': '반품담당자',
  'pages.refundRecords.platform.1688': '1688',
  'pages.refundRecords.platform.taobao': '타오바오',
  'pages.refundRecords.platform.vvic': 'vvic',
  'pages.refundRecords.platform.self': '자사몰',
  'pages.refundRecords.platform.ownmall': '자사몰',
  'pages.refundRecords.platform.live': '라이브채널',
  'pages.refundRecords.errorType.member': '회원환불',
  'pages.refundRecords.errorType.platform': '플랫폼환불',
  'pages.refundRecords.errorType.final': '최종환불',
  'pages.refundRecords.errorType.user_refund': '회원환불',
  'pages.refundRecords.errorType.platform_refund': '플랫폼환불',
  'pages.refundRecords.errorType.final_refund': '최종환불',
  'pages.refundRecords.refundType.partial': '부분',
  'pages.refundRecords.refundType.full': '전부',
  'pages.refundRecords.paymentMethod.deposit': '예치금',
  'pages.refundRecords.paymentMethod.points': '포인트',
  'pages.refundRecords.paymentMethod.bank': '무통장',
  'pages.refundRecords.paymentMethod.card': '신용카드',
  'pages.refundRecords.paymentMethod.billgate': '빌게이트',
  'pages.refundRecords.refundRoute.cardCard': '신용카드→신용카드',
  'pages.refundRecords.refundRoute.bankDeposit': '무통장→예치금',
  'pages.refundRecords.refundRoute.depositDeposit': '예치금→예치금',
  'pages.refundRecords.refundRoute.depositBank': '예치금→무통장',
  'pages.refundRecords.refundRoute.pointsPoints': '포인트→포인트',
  'pages.refundRecords.refundRoute.applying': '신청중',
  'pages.refundRecords.refundRoute.user_refund': '회원환불',
  'pages.refundRecords.refundRoute.platform_refund': '플랫폼환불',
  'pages.refundRecords.refundRoute.final_refund': '최종환불',
  'pages.refundRecords.recordStatus.pending': '대기',
  'pages.refundRecords.recordStatus.completed': '완료',
  'pages.refundRecords.status.done': '완료',
  'pages.refundRecords.status.asInProgress': 'AS중',
  'pages.refundRecords.action.search': '검색',
  'pages.refundRecords.action.download': '다운',
  'pages.refundRecords.action.confirm': '확인',
  'pages.refundRecords.action.cancel': '취소',
  'pages.refundRecords.note.asInputArea': 'AS 담당자 입력부분: 환불이유,AS내역,무통장정보,반품국내국제운송번호',
  'pages.refundRecords.note.autoAccumulate': '환불완료시 자동으로 데이터 누적',
  'pages.refundRecords.col.no': '번호',
  'pages.refundRecords.col.mailboxMember': '사서함 / 회원명',
  'pages.refundRecords.col.refundOrderProduct': '환불일련번호 / 주문번호 / 영문상품명',
  'pages.refundRecords.col.relatedOrderNumbers': '관련주문번호',
  'pages.refundRecords.col.routeStatus': '환불루트 / 환불상태',
  'pages.refundRecords.col.platformRefundNo': '플랫폼구분 / 플랫폼환불번호',
  'pages.refundRecords.col.priceFeeShipping': '상품가격 / 수수료 / 국내운송비용',
  'pages.refundRecords.col.lostCouponPoints': '소실된 쿠폰금액 / 소실된 포인트',
  'pages.refundRecords.col.firstPayment': '1차결제금액 / 1차결제방식 / 주문일시',
  'pages.refundRecords.col.secondPayment': '2차결제금액 / 2차결제방식 / 주문일시',
  'pages.refundRecords.col.refundAmountRate': '환불금액 / 환율',
  'pages.refundRecords.col.tracking': '국내운송번호 / 국제운송번호',
  'pages.refundRecords.col.reasonErrorType': '오류유형 / 환불유형',
  'pages.refundRecords.col.asInfo': 'AS담당자 / AS내역 / AS노드변경일시',
  'pages.refundRecords.col.bankWithdrawal': '[무통장 출금] / 수취인 / 계좌번호',
  'pages.refundRecords.col.returnTracking': '[AS담당자입력] / 반품국내운송번호 / 반품국제운송번호',
  'pages.refundRecords.col.returnManager': '반품담당자 / 반품학인일시',
  'pages.refundRecords.col.refundChannel': '[예치금환불] / [신용카드환불]',
  'pages.refundRecords.col.financeManager': '재무담당자 / 출금거래일시',
  'pages.refundRecords.col.action': '조작',

  // Points (settlement page — new design)
  'pages.points.title': '포인트 내역',
  'pages.points.listTitle': '포인트 사용 내역 리스트',
  'pages.points.period.today': '금일',
  'pages.points.period.month': '이번달',
  'pages.points.period.quarter': '이번분기',
  'pages.points.period.year': '올해',
  'pages.points.label.earnPoints': '적립 포인트',
  'pages.points.label.deductPoints': '차감 포인트',
  'pages.points.chart.monthlyAccrual': '월별적립',
  'pages.points.chart.monthlyDeduction': '월별차감',
  'pages.points.chart.accrualPoints': '적립포인트',
  'pages.points.chart.deductionPoints': '차감포인트',
  'pages.points.chart.dayAxis': '일',
  'pages.points.filter.accrualType': '적립구분',
  'pages.points.filter.deductionType': '차감구분',
  'pages.points.accrualType.join': '가입증정',
  'pages.points.accrualType.review': '리뷰증정',
  'pages.points.accrualType.orderDone': '주문완료증정',
  'pages.points.accrualType.attendance': '출석증정',
  'pages.points.accrualType.share': '공유증정',
  'pages.points.accrualType.admin': '관리자 적립',
  'pages.points.deductionType.orderDeduct': '주문차감',
  'pages.points.deductionType.adminDeduct': '관리자 차감',
  'pages.points.deductionType.expired': '유효일 만료 삭제',
  'pages.points.action.search': '검색',
  'pages.points.action.download': '다운',
  'pages.points.filter.page': '페이지',
  'pages.points.filter.startTime': '시작시간',
  'pages.points.filter.endTime': '마감시간',
  'pages.points.filter.mailbox': '사서함',
  'pages.points.filter.serialNo': '일련번호',
  'pages.points.filter.memberName': '회원명',
  'pages.points.filter.orderNumber': '주문번호',
  'pages.points.col.no': '번호',
  'pages.points.col.mailboxMember': '사서함 / 회원명',
  'pages.points.col.remainingPoints': '잔여 포인트',
  'pages.points.col.serialNo': '일련번호',
  'pages.points.col.category': '구분',
  'pages.points.col.earnedPoints': '적립 포인트',
  'pages.points.col.orderInfo': '주문번호 / 주문일시',
  'pages.points.col.deductedPoints': '차감 포인트',
  'pages.points.col.afterChange': '변동후 포인트 / 변동 일시',
  'pages.points.col.adminAction': '관리자 / 작업',
  'pages.points.action.addOrDeduct': '증가/차감',
  'pages.points.modal.title': '관리자 포인트 조작',
  'pages.points.modal.label.mailbox': '사서함',
  'pages.points.modal.label.memberName': '회원명',
  'pages.points.modal.placeholder.reason': '이유기재...',
  'pages.points.modal.button.addPoints': '포인트 +',
  'pages.points.modal.button.deductPoints': '포인트 -',
  'pages.points.modal.checkbox.confirmRequired': '정보,포인트 확인필수',
  'pages.points.modal.button.confirm': '확인',
  'pages.points.modal.button.cancel': '취소',
  'pages.points.modal.error.reasonRequired': '이유를 기재해주세요',
  'pages.points.modal.error.confirmRequired': '확인이 필요합니다',
  'pages.points.message.operationDone': '포인트 조작 완료',
  'pages.points.message.fetchError': '포인트 내역을 불러오는데 실패했습니다',
  'pages.points.message.exportSuccess': 'Excel 내보내기 완료',
  'pages.points.message.exportError': '내보내기 실패',

  // Coupon Usage (settlement page — new design)
  'pages.couponUsage.title': '쿠폰 사용 내역',
  'pages.couponUsage.listTitle': '쿠폰 사용 내역 리스트',
  'pages.couponUsage.period.today': '금일',
  'pages.couponUsage.period.month': '이번달',
  'pages.couponUsage.period.quarter': '이번분기',
  'pages.couponUsage.period.year': '올해',
  'pages.couponUsage.label.usedAmount': '사용금액',
  'pages.couponUsage.label.usedCount': '사용개수',
  'pages.couponUsage.label.monthlyUsedAmount': '월별사용금액',
  'pages.couponUsage.label.monthlyUsedCount': '월별사용개수',
  'pages.couponUsage.label.issueAmountQty': '발급금액/수량',
  'pages.couponUsage.label.useAmountQty': '사용금액/수량',
  'pages.couponUsage.label.remainAmountQty': '남은금액/수량',
  'pages.couponUsage.chart.legend.amount': '사용금액',
  'pages.couponUsage.chart.legend.count': '사용건수',
  'pages.couponUsage.chart.daily': '일별',
  'pages.couponUsage.chart.monthly': '월별',
  'pages.couponUsage.viewMode.detail': '상세검색',
  'pages.couponUsage.viewMode.summary': '요약검색',
  'pages.couponUsage.filter.page': '페이지',
  'pages.couponUsage.filter.startTime': '시작시간',
  'pages.couponUsage.filter.endTime': '마감시간',
  'pages.couponUsage.filter.couponType': '쿠폰유형',
  'pages.couponUsage.filter.issueMethod': '발급방식',
  'pages.couponUsage.couponType.product': '상품쿠폰',
  'pages.couponUsage.couponType.shipping': '운송쿠폰',
  'pages.couponUsage.couponType.system': '씨스템쿠폰',
  'pages.couponUsage.issueMethod.voucher': '교환권',
  'pages.couponUsage.issueMethod.systemIssue': '씨스템발송',
  'pages.couponUsage.action.search': '검색',
  'pages.couponUsage.action.download': '다운',
  'pages.couponUsage.filter.mailbox': '사서함',
  'pages.couponUsage.filter.orderNumber': '주문번호',
  'pages.couponUsage.filter.couponCode': '쿠폰코드',
  'pages.couponUsage.filter.memberName': '회원명',
  'pages.couponUsage.filter.createdAt': '생성일시',
  'pages.couponUsage.filter.couponName': '쿠폰이름',
  'pages.couponUsage.col.no': '번호',
  'pages.couponUsage.col.mailboxMember': '사서함 / 회원명',
  'pages.couponUsage.col.orderInfo': '주문번호 / 주문일시',
  'pages.couponUsage.col.typeMethod': '쿠폰유형 / 발급방식',
  'pages.couponUsage.col.nameCode': '쿠폰이름 / 쿠폰코드',
  'pages.couponUsage.col.faceValueMin': '쿠폰액면가 / 최소주문금액',
  'pages.couponUsage.col.serialCreated': '일련번호 / 생성일시',

  // Financial Records (settlement page — new design)
  'pages.financialRecords.title': '재무기록',
  'pages.financialRecords.listTitle': '재무기록 리스트',
  'pages.financialRecords.listNote': '1차결제비용 = 예치금 / 쿠폰 / 포인트 + 1차뱅크입금 · 2차결제비용 = 예치금 / 쿠폰 + 2차뱅크입금',
  'pages.financialRecords.viewMode.detail': '상세보기',
  'pages.financialRecords.viewMode.summary': '요약보기',
  'pages.financialRecords.period.todayPaymentAmount': '금일 결제금액',
  'pages.financialRecords.period.month': '이번달',
  'pages.financialRecords.period.quarter': '이번분기',
  'pages.financialRecords.period.year': '올해',
  'pages.financialRecords.stat.total': '전체',
  'pages.financialRecords.stat.bank': '무통장',
  'pages.financialRecords.stat.card': '신용카드',
  'pages.financialRecords.stat.deposit': '예치금',
  'pages.financialRecords.stat.first': '1차',
  'pages.financialRecords.stat.second': '2차',
  'pages.financialRecords.info.defaultIsTodayDone': '디폴트 상태는 금일 결제완료 금액',
  'pages.financialRecords.info.clickShowsCorrespondingTime': '클릭시 상응 시간대 결제완료 금액',
  'pages.financialRecords.info.totalEqFirstSecond': '전체 = 1차 + 2차',
  'pages.financialRecords.info.totalEqBankCard': '전체 = 무통장 + 신용카드',
  'pages.financialRecords.info.depositSeparate': '예치금은 별도',
  'pages.financialRecords.info.systemTimeUtc9': '시스템 시간을 UTC+9로 세팅',
  'pages.financialRecords.info.shownAsCurrentResults': '당일 당시 결과로 현시',
  'pages.financialRecords.info.recordedAsDailyAfter24h': '24시후 당일 데이터로 기록',
  'pages.financialRecords.filter.page': '페이지',
  'pages.financialRecords.filter.startTime': '시간시작',
  'pages.financialRecords.filter.endTime': '시간마감',
  'pages.financialRecords.filter.paymentSerialNo': '결제일련번호',
  'pages.financialRecords.filter.platform': '플랫폼구분',
  'pages.financialRecords.filter.region': '지역',
  'pages.financialRecords.filter.orderType': '업무유형',
  'pages.financialRecords.filter.shippingMethod': '운송방식',
  'pages.financialRecords.filter.appliedOrder': '적용주문',
  'pages.financialRecords.filter.depositUsage': '예치금사용',
  'pages.financialRecords.filter.specialCase': '특수건',
  'pages.financialRecords.filter.warehouseService': '창고서비스',
  'pages.financialRecords.filter.paymentNode': '결제금액 노드',
  'pages.financialRecords.filter.paymentStatus': '결제상태',
  'pages.financialRecords.filter.matching': '매칭',
  'pages.financialRecords.filter.paymentMethod': '결제방식',
  'pages.financialRecords.filter.mailbox': '사서함',
  'pages.financialRecords.filter.orderNumber': '주문번호',
  'pages.financialRecords.filter.memberName': '회원명',
  'pages.financialRecords.filter.paymentAmount': '결제금액',
  'pages.financialRecords.filter.domesticTrackingNo': '국내운송번호',
  'pages.financialRecords.filter.internationalTrackingNo': '국제운송번호',
  'pages.financialRecords.filter.warehouseCode': '창고코드',
  'pages.financialRecords.filter.includeMergedSourceOrders': '병합주문 포함',
  'pages.financialRecords.filter.paymentAmountMin': '최소금액',
  'pages.financialRecords.filter.paymentAmountMax': '최대금액',
  'pages.financialRecords.includeMergedSourceOrders.yes': '포함',
  'pages.financialRecords.includeMergedSourceOrders.no': '미포함',
  'pages.financialRecords.platform.taobao': '타오바오',
  'pages.financialRecords.platform.self': '자사몰',
  'pages.financialRecords.platform.live': '라이브채널',
  'pages.financialRecords.region.weihai': '위해',
  'pages.financialRecords.region.yiwu': '이우',
  'pages.financialRecords.region.guangzhou': '광주',
  'pages.financialRecords.shippingMethod.air': '항공',
  'pages.financialRecords.shippingMethod.sea': '해운',
  'pages.financialRecords.shippingMethod.airExpress': '항공특송',
  'pages.financialRecords.shippingMethod.shipExpress': '배특송',
  'pages.financialRecords.appliedOrder.coupon': '쿠폰',
  'pages.financialRecords.appliedOrder.point': '포인트',
  'pages.financialRecords.appliedOrder.both': '쿠폰+포인트',
  'pages.financialRecords.depositUsage.yes': '유',
  'pages.financialRecords.depositUsage.no': '무',
  'pages.financialRecords.specialCase.remote': '편벽',
  'pages.financialRecords.specialCase.simple': '간이',
  'pages.financialRecords.specialCase.remoteSimple': '편벽간이',
  'pages.financialRecords.warehouseService.photo': '지정촬영',
  'pages.financialRecords.warehouseService.smallBox': '소박스포장',
  'pages.financialRecords.warehouseService.bigBox': '대박스포장',
  'pages.financialRecords.warehouseService.sticker': '스티커',
  'pages.financialRecords.warehouseService.split': '나눔출고',
  'pages.financialRecords.warehouseService.extra': '추가비용',
  'pages.financialRecords.paymentNode.first': '1차뱅크입금',
  'pages.financialRecords.paymentNode.second': '2차뱅크입금',
  'pages.financialRecords.paymentNode.integrated': '통합',
  'pages.financialRecords.paymentStatusOpt.done': '결제완료',
  'pages.financialRecords.paymentStatusOpt.wait': '결제대기',
  'pages.financialRecords.paymentStatusOpt.processing': '처리중',
  'pages.financialRecords.paymentStatusOpt.failed': '실패',
  'pages.financialRecords.paymentStatusOpt.refunded': '환불완료',
  'pages.financialRecords.orderType.general': '일반',
  'pages.financialRecords.orderType.vvic': 'VVIC',
  'pages.financialRecords.orderType.rocket': '로켓',
  'pages.financialRecords.matching.auto': '자동매칭',
  'pages.financialRecords.matching.manual': '수동매칭',
  'pages.financialRecords.paymentMethodOpt.card': '신용카드',
  'pages.financialRecords.paymentMethodOpt.bank': '무통장',
  'pages.financialRecords.paymentMethodOpt.deposit': '예치금',
  'pages.financialRecords.action.search': '검색',
  'pages.financialRecords.action.reset': '초기화',
  'pages.financialRecords.action.download': '다운',
  'pages.financialRecords.col.no': '번호',
  'pages.financialRecords.col.orderNumber': '주문번호',
  'pages.financialRecords.col.mailboxMember': '사서함 / 회원명',
  'pages.financialRecords.col.platformProduct': '플랫폼구분 / 영문상품명',
  'pages.financialRecords.col.priceFeeShipping': '상품가격 / 수수료 / 국내송비용',
  'pages.financialRecords.col.firstTotalRate': '1차결제비용 / 환율',
  'pages.financialRecords.col.depositCouponPoint': '예치금 / 쿠폰 / 포인트',
  'pages.financialRecords.col.firstFinal': '1차뱅크입금 / 1차결제상태 / 국내송번호',
  'pages.financialRecords.col.firstPayment': '1차결제방식 / 입금자명 / 결제일련번호',
  'pages.financialRecords.col.firstTimes': '신청일시 / 결제일시',
  'pages.financialRecords.col.routing': '내역',
  'pages.financialRecords.col.shippingCosts': '국제운송비용 / 도서산간비용 / 간이통관비용',
  'pages.financialRecords.col.serviceCost': '서비스비용',
  'pages.financialRecords.col.secondTotalRate': '2차결제비용 / 환율',
  'pages.financialRecords.col.depositOnly': '예치금 / 쿠폰',
  'pages.financialRecords.col.secondFinal': '2차뱅크입금 / 2차결제상태 / 국제운송번호',
  'pages.financialRecords.col.secondPayment': '2차결제방식 / 입금자명 / 결제일련번호',
  'pages.financialRecords.col.secondTimes': '신청일시 / 결제일시',
  'pages.financialRecords.col.assignee': '구분 / 관리자 / 작업일시',
  'pages.financialRecords.related.mergedInto': '합포장',
  'pages.financialRecords.related.mergedFrom': '원주문',
  'pages.financialRecords.related.splitInto': '분할',
  'pages.financialRecords.cell.paymentDone': '결제완료',
  'pages.financialRecords.cell.firstTeamLead': '1차 빅팀장',
  'pages.live.sellers.products.column.originalPriceKrw': '사입가',
  'pages.live.sellers.products.column.salePriceKrw': '판매가',
  'pages.live.sellers.products.column.amountOnSale': '재고',
  'pages.live.sellers.products.inlineEdit.editTitle': '상품명 수정',
  'pages.live.sellers.products.inlineEdit.editPrice': '가격 수정',
  'pages.live.sellers.products.inlineEdit.editCompanyName': '상가명 수정',
  'pages.live.sellers.products.inlineEdit.save': '저장',
  'pages.live.sellers.products.inlineEdit.cancel': '취소',
  'pages.live.sellers.products.inlineEdit.success': '수정되었습니다',
  'pages.live.sellers.products.inlineEdit.failed': '수정에 실패했습니다',
  'pages.orders.detail.firstPayment': '1차 결제',
  'pages.orders.detail.firstPaymentForMergedOrder': '1차 결제 ({orderNumber})',
  'pages.orders.detail.secondPayment': '2차 결제',
  'pages.orders.detail.paymentMethod.bank': '무통장입금',
  'pages.orders.detail.paymentMethod.bankDeposit': '무통장+예치금',
  'pages.orders.detail.paymentMethod.billgate': '빌게이트',
  'pages.orders.detail.paymentMethod.cardDeposit': '카드+예치금',
  'pages.orders.detail.paymentMethod.deposit': '예치금',
  'pages.orders.detail.paymentMethod.points': '포인트',
  'pages.orders.detail.netPaymentAmount': '1차 결제 합계',
  'pages.orders.detail.depositUsedAmount': '예치금',
  'pages.orders.detail.bankDepositAmount': '무통장 입금액',
  'pages.members.activeUsers.title': '활성 사용자',
  'pages.members.activeUsers.currentActive': '현재 활성 사용자',
  'pages.members.activeUsers.loggedInUsers': '로그인 사용자',
  'pages.members.activeUsers.anonymousVisitors': '비로그인 방문자',
  'pages.members.activeUsers.lastSample': '마지막 집계',
  'pages.members.activeUsers.historyTitle': '활성 사용자 이력',
  'pages.members.activeUsers.total': '전체',
  'pages.members.activeUsers.loggedIn': '로그인',
  'pages.members.activeUsers.anonymous': '비로그인',
  'pages.members.activeUsers.loggedInTableTitle': '현재 활성 로그인 사용자',
  'pages.members.activeUsers.anonymousTableTitle': '비로그인 방문자',
  'pages.members.activeUsers.anonymousHint': '활성 비로그인 방문자를 visitorId 기준으로 최대 50명까지 표시합니다.',
  'pages.members.activeUsers.memberId': '회원 ID',
  'pages.members.activeUsers.name': '이름',
  'pages.members.activeUsers.email': '이메일',
  'pages.members.activeUsers.platform': '플랫폼',
  'pages.members.activeUsers.category': '부류',
  'pages.members.activeUsers.lastActive': '마지막 활동',
  'pages.members.activeUsers.visitorId': '방문자 ID',
  'pages.members.activeUsers.platform.web': '웹',
  'pages.members.activeUsers.platform.android': 'Android',
  'pages.members.activeUsers.platform.ios': 'iOS',
  'pages.members.activeUsers.platform.unknown': '알 수 없음',
  'pages.members.activeUsers.category.seller': '판매자',
  'pages.members.activeUsers.category.business': '사업자',
  'pages.members.activeUsers.category.general': '일반',
  'pages.members.activeUsers.granularity.hour': '시간별',
  'pages.members.activeUsers.granularity.day': '일별',
  'pages.members.activeUsers.granularity.month': '월별',
  'pages.members.activeUsers.granularity.year': '년별',
  'pages.members.activeUsers.botSuspectedCard': '봇 의심',
  'pages.members.activeUsers.botSuspected': '봇 의심',
  'pages.members.activeUsers.verdict': '판정',
  'pages.members.activeUsers.verdictNormal': '정상',
  'pages.members.activeUsers.requestsLastHour': '최근 1시간 요청',
  'pages.members.activeUsers.requestsTotal': '총 요청(7일)',
  'pages.members.activeUsers.topEndpoint': '주요 엔드포인트',
  'pages.members.activeUsers.botReason.highRate': '요청 과다',
  'pages.members.activeUsers.botReason.botUserAgent': '봇 UA',
  'pages.members.activeUsers.botReason.endpointConcentration': '단일 경로 집중',
  'pages.members.activeUsers.ipStatsTitle': 'IP별 요청 상위',
  'pages.members.activeUsers.ipStatsHint':
    '전체 API 요청량 상위 IP입니다. 1688/타오바오 상품상세 크롤 차단은 위 표를 사용하세요.',
  'pages.members.activeUsers.currentlyActive': '현재 접속',
  'pages.members.activeUsers.currentlyActiveYes': '접속 중',
  'pages.members.activeUsers.currentlyActiveNo': '소켓 없음',
  'pages.members.activeUsers.lastRequestAt': '마지막 요청',
  'pages.members.activeUsers.adminTraffic': '관리자 트래픽',
  'pages.members.activeUsers.purposeAlert':
    '이 페이지의 목적은 1688/타오바오 상품상세 API를 과다 호출하는 IP를 찾아 차단하는 것입니다. 소켓 접속 수는 참고용입니다.',
  'pages.members.activeUsers.marketplaceTitle': '1688/타오바오 상품상세 과다 요청 IP',
  'pages.members.activeUsers.marketplaceHint':
    'GET /v1/products/detail (1688·타오바오) 및 1688/타오바오 상세 경로만 집계합니다. 검색·헬프센터·관리자 API는 여기에 넣지 않습니다. 1시간에 상품상세 80회 이상, 또는 서로 다른 상품 40개 이상이면 과다로 표시합니다. 차단하면 해당 IP는 /v1/products 마켓플레이스 API를 쓸 수 없습니다.',
  'pages.members.activeUsers.detailLastHour': '상품상세 (1시간)',
  'pages.members.activeUsers.detailTotal': '상품상세 (7일)',
  'pages.members.activeUsers.uniqueLastHour': '고유 상품 (1시간)',
  'pages.members.activeUsers.uniqueTotal': '고유 상품 (7일)',
  'pages.members.activeUsers.detail1688Hour': '1688 상세 (1시간)',
  'pages.members.activeUsers.detailTaobaoHour': '타오바오 상세 (1시간)',
  'pages.members.activeUsers.abusiveCount': '과다 의심 IP',
  'pages.members.activeUsers.blockedCount': '차단된 IP',
  'pages.members.activeUsers.verdictAbuse': '상품상세 과다',
  'pages.members.activeUsers.abuseReason.high-detail-rate': '상세 요청 과다',
  'pages.members.activeUsers.abuseReason.many-unique-products': '고유 상품 과다',
  'pages.members.activeUsers.block7d': '7일 차단',
  'pages.members.activeUsers.blockPermanent': '영구 차단',
  'pages.members.activeUsers.unblock': '차단 해제',
  'pages.members.activeUsers.blockConfirm7d': '이 IP의 1688/타오바오 상품 API를 7일 동안 막겠습니까?',
  'pages.members.activeUsers.blockConfirmPermanent': '이 IP의 1688/타오바오 상품 API를 영구 차단하겠습니까?',
  'pages.members.activeUsers.unblockConfirm': '이 IP 차단을 해제하겠습니까?',
  'pages.members.activeUsers.blockSuccess': 'IP를 차단했습니다. 상품 API가 즉시 거부됩니다.',
  'pages.members.activeUsers.unblockSuccess': 'IP 차단을 해제했습니다.',
  'pages.members.activeUsers.blockedListTitle': '차단된 IP',
  'pages.members.activeUsers.blockedUntil': '만료',
  'pages.members.activeUsers.blockedUntilPermanent': '영구',
  'pages.members.activeUsers.blockedBy': '차단한 관리자',
  'pages.members.activeUsers.blockedReason': '사유',
  'pages.members.activeUsers.action': '조치',
  'pages.financialRecords.message.exportError': 'Excel 내보내기 실패',

  // 재고관리 (자사몰 창고)
  'pages.ownWarehouse.title': '창고관리',
  'pages.ownWarehouse.subtitle': '창고 목록 및 관리',
  'pages.ownWarehouse.loadFailed': '데이터를 불러오지 못했습니다.',
  'pages.ownWarehouse.saveFailed': '저장에 실패했습니다.',
  'pages.ownWarehouse.deleteFailed': '삭제에 실패했습니다.',
  'pages.ownWarehouse.createSuccess': '창고가 추가되었습니다.',
  'pages.ownWarehouse.updateSuccess': '창고 정보가 수정되었습니다.',
  'pages.ownWarehouse.deleteSuccess': '창고가 삭제되었습니다.',
  'pages.ownWarehouse.deleteConfirmTitle': '창고 삭제',
  'pages.ownWarehouse.deleteConfirmContent': '"{name}" 창고를 삭제하시겠습니까? 재고가 남아 있으면 삭제할 수 없습니다.',
  'pages.ownWarehouse.addWarehouse': '창고 추가',
  'pages.ownWarehouse.editWarehouse': '창고 수정',
  'pages.ownWarehouse.save': '저장',
  'pages.ownWarehouse.cancel': '취소',
  'pages.ownWarehouse.searchPlaceholder': '창고명 검색',
  'pages.ownWarehouse.totalWarehouses': '전체 {total}개 창고',
  'pages.ownWarehouse.status.all': '전체 상태',
  'pages.ownWarehouse.status.active': '사용중',
  'pages.ownWarehouse.status.inactive': '중지',
  'pages.ownWarehouse.columns.name': '창고명',
  'pages.ownWarehouse.columns.address': '창고 주소',
  'pages.ownWarehouse.columns.productKinds': '상품 종류',
  'pages.ownWarehouse.columns.totalStock': '총 재고 수량',
  'pages.ownWarehouse.columns.createdAt': '생성일',
  'pages.ownWarehouse.columns.updatedAt': '최근 수정일',
  'pages.ownWarehouse.columns.status': '상태',
  'pages.ownWarehouse.columns.actions': '관리',
  'pages.ownWarehouse.columns.image': '상품 이미지',
  'pages.ownWarehouse.columns.productTitle': '상품명 / 옵션',
  'pages.ownWarehouse.columns.productNo': '상품번호',
  'pages.ownWarehouse.columns.inboundTotal': '입고 총수량',
  'pages.ownWarehouse.columns.stock': '현지 재고수량',
  'pages.ownWarehouse.columns.costPrice': '원가',
  'pages.ownWarehouse.columns.salePrice': '판매가',
  'pages.ownWarehouse.columns.stockStatus': '재고 상태',
  'pages.ownWarehouse.columns.mallLink': '자사몰 링크',
  'pages.ownWarehouse.columns.skuCount': 'SKU 수량',
  'pages.ownWarehouse.columns.option': '옵션',
  'pages.ownWarehouse.actions.detail': '창고 상세',
  'pages.ownWarehouse.actions.edit': '수정',
  'pages.ownWarehouse.actions.delete': '삭제',
  'pages.ownWarehouse.form.name': '창고명',
  'pages.ownWarehouse.form.namePlaceholder': '창고명을 입력하세요',
  'pages.ownWarehouse.form.nameRequired': '창고명을 입력해 주세요.',
  'pages.ownWarehouse.form.address': '창고 주소',
  'pages.ownWarehouse.form.addressPlaceholder': '창고 주소를 입력하세요',
  'pages.ownWarehouse.form.addressRequired': '창고 주소를 입력해 주세요.',
  'pages.ownWarehouse.form.manager': '담당자',
  'pages.ownWarehouse.form.managerPlaceholder': '담당자명을 입력하세요',
  'pages.ownWarehouse.form.contact': '연락처',
  'pages.ownWarehouse.form.contactPlaceholder': '연락처를 입력하세요',
  'pages.ownWarehouse.form.memo': '메모',
  'pages.ownWarehouse.form.memoPlaceholder': '메모를 입력하세요 (선택)',
  'pages.ownWarehouse.stockStatus.normal': '정상',
  'pages.ownWarehouse.stockStatus.lowStock': '재고 부족',
  'pages.ownWarehouse.stockStatus.outOfStock': '품절',
  'pages.ownWarehouse.tabs.items': '재고 상품 목록',
  'pages.ownWarehouse.tabs.info': '창고 정보',
  'pages.ownWarehouse.stats.productKinds': '상품 종류 (SKU)',
  'pages.ownWarehouse.stats.totalInbound': '총 입고 수량',
  'pages.ownWarehouse.stats.totalStock': '총 재고 수량',
  'pages.ownWarehouse.stats.outOfStock': '품절 상품',
  'pages.ownWarehouse.stats.kindsUnit': '종',
  'pages.ownWarehouse.stats.piecesUnit': '개',
  'pages.ownWarehouse.addProducts': '상품 추가',
  'pages.ownWarehouse.itemSearchPlaceholder': '상품명 또는 상품번호 검색',
  'pages.ownWarehouse.totalItems': '전체 {total}개 상품',
  'pages.ownWarehouse.removeConfirmTitle': '상품 제거',
  'pages.ownWarehouse.removeConfirmContent': '"{name}" 상품을 이 창고에서 제거하시겠습니까? 남은 재고 {stock}개 기록도 함께 제거됩니다.',
  'pages.ownWarehouse.removeSuccess': '상품이 창고에서 제거되었습니다.',
  'pages.ownWarehouse.bulkRemove': '선택 삭제 ({count})',
  'pages.ownWarehouse.bulkRemoveConfirmTitle': '선택 상품 일괄 삭제',
  'pages.ownWarehouse.bulkRemoveConfirmContent': '선택한 상품 {count}개를 이 창고에서 제거하시겠습니까? 남은 재고 {stock}개 기록도 함께 제거됩니다.',
  'pages.ownWarehouse.bulkRemoveSuccess': '상품 {count}개가 창고에서 제거되었습니다.',
  'pages.ownWarehouse.picker.title': '자사몰 상품 등록',
  'pages.ownWarehouse.picker.loadFailed': '상품 목록을 불러오지 못했습니다.',
  'pages.ownWarehouse.picker.noneSelected': '추가할 상품을 선택해 주세요.',
  'pages.ownWarehouse.picker.addResult': '{added}개 상품이 추가되었습니다. (이미 등록된 상품 {skipped}개 스킵)',
  'pages.ownWarehouse.picker.addFailed': '상품 추가에 실패했습니다.',
  'pages.ownWarehouse.picker.addSelected': '선택 상품 추가 ({count})',
  'pages.ownWarehouse.picker.searchPlaceholder': '제품명 / OfferId / UniqueNo 검색',
  'pages.ownWarehouse.picker.totalProducts': '전체 {total}개',
  'pages.ownWarehouse.picker.columns.image': '이미지',
  'pages.ownWarehouse.picker.columns.title': '상품명',
  'pages.ownWarehouse.picker.columns.productNo': '상품번호',
  'pages.ownWarehouse.picker.columns.salePrice': '판매가',
  'pages.ownWarehouse.txn.inboundTitle': '재고 입고',
  'pages.ownWarehouse.txn.outboundTitle': '재고 출고',
  'pages.ownWarehouse.txn.confirm': '확인',
  'pages.ownWarehouse.txn.reason': '사유',
  'pages.ownWarehouse.txn.noQuantity': '수량을 1개 이상 입력해 주세요.',
  'pages.ownWarehouse.txn.inboundSuccess': '입고가 처리되었습니다.',
  'pages.ownWarehouse.txn.outboundSuccess': '출고가 처리되었습니다.',
  'pages.ownWarehouse.txn.failed': '처리에 실패했습니다.',
  'pages.ownWarehouse.txn.inboundQty': '입고 수량',
  'pages.ownWarehouse.txn.outboundQty': '출고 수량',
  'pages.ownWarehouse.reason.normalInbound': '정상입고',
  'pages.ownWarehouse.reason.returnInbound': '반품입고',
  'pages.ownWarehouse.reason.correction': '실수수정',
  'pages.ownWarehouse.reason.saleOutbound': '판매출고',
  'pages.ownWarehouse.reason.disposal': '폐기',
  'pages.ownWarehouse.reason.inboundTypo': '입고 오기입 정정',
  'pages.ownWarehouse.reason.outboundTypo': '출고 오기입 정정',
  'pages.ownWarehouse.reason.stocktaking': '재고 실사',
  'pages.ownWarehouse.reason.damageLoss': '파손·분실',
  'pages.ownWarehouse.adjust.title': '재고 수정',
  'pages.ownWarehouse.adjust.hint': '잘못 기록한 입고·출고를 바로잡습니다. 고칠 칸의 값만 바꿔 주세요. 모든 수정은 사유와 함께 로그에 남습니다.',
  'pages.ownWarehouse.adjust.newInbound': '입고 총수량 (수정 후)',
  'pages.ownWarehouse.adjust.newStock': '재고수량 (수정 후)',
  'pages.ownWarehouse.adjust.memoPlaceholder': '상세 메모 (예: 입고 11개로 잘못 기록, 실제 10개)',
  'pages.ownWarehouse.adjust.noChanges': '변경된 값이 없습니다.',
  'pages.ownWarehouse.adjust.reasonRequired': '수정 사유를 선택해 주세요.',
  'pages.ownWarehouse.adjust.stockOverInbound': '{option}: 재고수량은 입고 총수량보다 클 수 없습니다.',
  'pages.ownWarehouse.adjust.success': '재고가 수정되었습니다.',
  'pages.ownWarehouse.log.title': '■ 입/출고 로그 - 창고 : {name}',
  'pages.ownWarehouse.log.productTitle': '■ 입/출고 로그 - 상품 : {name}',
  'pages.ownWarehouse.log.button': '입/출고 로그',
  'pages.ownWarehouse.log.warehouseButton': '재고 입출고 내역',
  'pages.ownWarehouse.log.loadFailed': '로그를 불러오지 못했습니다.',
  'pages.ownWarehouse.log.noLogs': '로그가 없습니다.',
  'pages.ownWarehouse.log.system': '시스템',
  'pages.ownWarehouse.log.orderNo': '주문번호',
  'pages.ownWarehouse.log.columns.processor': '처리자',
  'pages.ownWarehouse.log.columns.content': '내용',
  'pages.ownWarehouse.log.columns.detail': '상세',
  'pages.ownWarehouse.log.columns.time': '시간',
  'pages.ownWarehouse.log.type.productAdd': '상품 등록',
  'pages.ownWarehouse.log.type.productRemove': '상품 제거',
  'pages.ownWarehouse.log.type.inbound': '입고',
  'pages.ownWarehouse.log.type.outbound': '출고',
  'pages.ownWarehouse.log.type.orderOutbound': '주문 출고',
  'pages.ownWarehouse.log.type.adjust': '재고 수정',
  'pages.ownWarehouse.orderOutbound.button': '재고출고',
  'pages.ownWarehouse.orderOutbound.title': '재고 출고 - 창고 선택',
  'pages.ownWarehouse.orderOutbound.loadFailed': '창고 정보를 불러오지 못했습니다.',
  'pages.ownWarehouse.orderOutbound.noWarehouse': '이 상품을 보유한 창고가 없습니다.',
  'pages.ownWarehouse.orderOutbound.noMatch': '옵션 매칭 안됨',
  'pages.ownWarehouse.orderOutbound.stockLabel': '보유 재고',
  'pages.ownWarehouse.orderOutbound.confirmTitle': '재고 출고 확인',
  'pages.ownWarehouse.orderOutbound.confirmContent': '"{warehouse}" 창고에서 {option} {qty}개를 출고하시겠습니까?',
  'pages.ownWarehouse.orderOutbound.success': '"{warehouse}" 창고에서 출고되었습니다. (남은 재고 {stockAfter}개)',
  'pages.ownWarehouse.orderOutbound.insufficient': '"{warehouse}" 창고의 재고({stock}개)가 주문수량({qty}개)보다 적습니다.',
  'pages.ownWarehouse.orderOutbound.loading': '창고 조회 중...',
  'pages.ownWarehouse.orderOutbound.showOtherOptions': '다른 옵션 보기 ({count})',
  'pages.ownWarehouse.orderOutbound.done': '재고출고 완료',
  'pages.ownWarehouse.orderOutbound.doneTooltip': '"{warehouse}" 창고에서 {qty}개 출고 · {time}',
  'pages.ownWarehouse.orderOutbound.movedToPacking': '주문의 모든 상품이 재고에서 출고되어 주문이 패킹중으로 넘어갔습니다.',

  // 상품 등록 다국어 입력 언어 탭
  'pages.products.add.langTab.ko': '한국어',
  'pages.products.add.langTab.cn': '중국어',
  'pages.products.add.langTab.en': '영어',
  'pages.products.add.langTab.all': '전체 언어',
  'pages.products.add.langTab.hint': '제목·옵션·스펙 입력칸에 적용됩니다. 중국어 입력 시 한국어/영어는 자동 번역됩니다.',
  'pages.products.add.bulkBar.scopeAll':
    '열 머리글의 일괄 단추는 전체 행에 적용됩니다',
  'pages.products.add.bulkBar.scopeSelected':
    '열 머리글의 일괄 단추는 선택한 {count}행에만 적용됩니다',
  'pages.products.add.bulkBar.apply': '적용',
  'pages.products.add.marketplaceCategoryMissing': '받지 못했습니다',
  'pages.products.add.categoryNotDetermined':
    '원 사이트 분류를 찾지 못했습니다 — 카테고리를 직접 골라 주세요.',
  'pages.products.add.categoryAutoCreated':
    '카테고리 "{path}" 를 새로 만들어 골랐습니다 — 이름은 카테고리 관리에서 고칠 수 있습니다.',
  'pages.products.add.categoryAutoCreateFailed':
    '카테고리를 자동으로 만들지 못했습니다 — 직접 골라 주세요.',
  'pages.products.add.marketplaceCategoryPath': '원 사이트 분류: {path}',
  'pages.products.add.newCategory.marketplacePath': '원 사이트 분류: {path}',
  'pages.products.add.newCategory.open': '맞는 카테고리가 없나요? 새로 만들기',
  'pages.products.add.newCategory.title': '새 카테고리 만들기',
  'pages.products.add.newCategory.ok': '만들고 고르기',
  'pages.products.add.newCategory.levelHint': '{level}단계 카테고리로 만들어집니다 — {path}',
  'pages.products.add.newCategory.rootLevel': '최상위',
  'pages.products.add.newCategory.rootPlaceholder': '비워 두면 최상위 카테고리로 만듭니다',
  'pages.products.add.newCategory.level2Placeholder': '비워 두면 2단계 카테고리로 만듭니다',
  'pages.products.add.newCategory.nameKo': '카테고리 이름 (한국어)',
  'pages.products.add.newCategory.nameKoRequired': '한국어 이름을 넣어 주세요.',
  'pages.products.add.newCategory.nameZh': '중국어 이름',
  'pages.products.add.newCategory.nameZhHint':
    '원 사이트에서 쓰는 말(连衣裙·运动鞋…)을 넣어 두면 다음부터 가져오기 때 이 칸이 자동으로 잡힙니다.',
  'pages.products.add.newCategory.nameEn': '영어 이름',
  'pages.products.add.newCategory.duplicate': '같은 자리에 같은 이름의 카테고리가 이미 있습니다.',
  'pages.products.add.newCategory.created': '카테고리 "{path}" 를 만들었습니다.',
  'pages.products.add.newCategory.failed': '카테고리를 만들지 못했습니다.',
  'pages.products.add.categoryAutoPicked':
    '카테고리를 "{path}" 로 골라 뒀습니다 — 맞지 않으면 바꿔 주세요.',
  'pages.products.add.bulkBar.valueRequired': '적용할 값을 입력해 주세요.',
  'pages.products.add.bulkBar.setPlaceholder': '지정값',
  'pages.products.add.bulkBar.salePriceUpdated': '판매가를 일괄 변경했습니다',
  'pages.products.add.bulkBar.originalKrwUpdated': '원가(₩)를 일괄 변경했습니다',
  'pages.products.add.bulkBar.originalCnyUpdated': '원가(위안)를 일괄 변경했습니다',
  'pages.products.add.bulkBar.tagPriceUpdated': '태그가를 일괄 변경했습니다',
  'pages.products.add.bulkBar.stockUpdated': '재고를 일괄 변경했습니다',
  'pages.products.add.skuTable.originalCny': '원가 (위안)',
  'pages.products.add.skuTable.originalKrw': '원가 (₩)',
  'pages.products.add.skuTable.salePrice': '판매가 (₩)',
  'pages.products.add.skuTable.tagPrice': '태그가 (₩)',
  'pages.products.add.skuTable.image': '이미지',
  'pages.ownWarehouse.picker.allStores': '전체 스토어',
  'pages.products.add.editor.translateDescription': '중→한 번역',
  'pages.products.add.descTranslateDone': '상세설명 텍스트 {count}건을 번역했습니다.',
  'pages.products.add.descTranslateNone': '번역할 중국어 텍스트가 없습니다.',
  'pages.products.add.descTranslateFailed': '번역에 실패했습니다. 잠시 후 다시 시도해 주세요.',
  'pages.products.add.refineTitle.button': 'AI 제목 요약',
  'pages.products.add.refineTitle.restore': '원래 제목으로',
  'pages.products.add.refineTitle.tooltip': '긴 제목에서 군말을 빼고 상품명만 남깁니다. 3개 언어가 함께 바뀝니다.',
  'pages.products.add.refineTitle.empty': '요약할 제목을 먼저 입력하세요.',
  'pages.products.add.refineTitle.unchanged': '제목을 더 줄이지 못했습니다. 원래 제목을 유지합니다.',
  'pages.products.add.refineTitle.done': '제목을 요약했습니다. 원래 제목으로 되돌릴 수 있습니다.',
  'pages.products.add.refineTitle.failed': '제목 요약에 실패했습니다. 잠시 후 다시 시도해 주세요.',
  // 공유 리베이트 (share rebate) — 설정 · 모니터링 · 주문 상세 공유 귀속 카드
  'pages.shareRebate.status.pending': '적립 예정',
  'pages.shareRebate.status.held': '보류',
  'pages.shareRebate.status.confirmed': '확정',
  'pages.shareRebate.status.paid': '지급',
  'pages.shareRebate.status.cancelled': '취소',
  'pages.shareRebate.status.reversed': '회수',
  'pages.shareRebate.source.live': '라이브',
  'pages.shareRebate.source.ownmall': '자사몰',
  'pages.shareRebate.source.1688': '1688',
  'pages.shareRebate.source.taobao': '타오바오',
  'pages.shareRebate.source.vvic': 'VVIC',
  'pages.shareRebate.tier.label': '{tier}층',
  'pages.shareRebate.tier.role.1': '공유자',
  'pages.shareRebate.tier.role.2': '공유자의 윗사람',
  'pages.shareRebate.tier.role.3': '윗사람의 윗사람',
  'pages.shareRebate.attributionStatus.awaiting_payment': '결제 대기',
  'pages.shareRebate.attributionStatus.active': '진행 중',
  'pages.shareRebate.attributionStatus.settled': '정산 끝',
  'pages.shareRebate.attributionStatus.void': '무효',
  'pages.shareRebate.attributionStatus.needs_review': '검토 필요',
  'pages.shareRebate.risk.missing_user_price': '판매가 없음',
  'pages.shareRebate.risk.failed_external_orders': '외부 주문 실패',
  'pages.shareRebate.risk.same_phone': '공유자·구매자 전화 같음',
  'pages.shareRebate.risk.recipient_is_sharer': '받는 사람 = 공유자',
  'pages.shareRebate.risk.family_too_large': '주문 가족 200건 초과',
  'pages.shareRebate.risk.marker_gap': '귀속 표시 누락',
  'pages.shareRebate.risk.refund_reason_unparsed': '환불 사유 해석 불가',
  'pages.shareRebate.risk.markers_missing': '귀속 표시 없음',
  'pages.shareRebate.reason.risk': '위험 표시',
  'pages.shareRebate.reason.admin': '관리자',
  'pages.shareRebate.reason.released': '보류 해제',
  'pages.shareRebate.reason.sharer_suspended': '공유자 정지',
  'pages.shareRebate.reason.monthly_cap': '월 상한 초과',
  'pages.shareRebate.reason.order_cancelled_or_refunded': '주문 취소·환불',
  'pages.shareRebate.reason.zero_amount': '금액 0원',
  'pages.shareRebate.reason.below_minimum': '최소 지급액 미만',
  'pages.shareRebate.skip.buyer_in_chain': '구매자 본인이 체인에 있음',
  'pages.shareRebate.skip.guest_account': '게스트 계정',
  'pages.shareRebate.skip.suspended': '정지된 공유자',
  'pages.shareRebate.skip.user_missing': '회원 없음',
  'pages.shareRebate.skip.user_deleted': '탈퇴 회원',
  'pages.shareRebate.skip.user_blacklisted': '블랙리스트 회원',
  'pages.shareRebate.relationSource.signup': '공유 방문 중 가입',
  'pages.shareRebate.relationSource.first_purchase': '공유로 귀속된 첫 결제',
  'pages.shareRebate.relationSource.admin': '관리자 지정',
  'pages.shareRebate.relationAction.sponsor_assigned': '윗사람 지정',
  'pages.shareRebate.relationAction.sponsor_changed': '윗사람 변경',
  'pages.shareRebate.relationAction.suspended': '정지',
  'pages.shareRebate.relationAction.unsuspended': '정지 해제',
  'pages.shareRebate.taskType.reconcile_order': '주문 재점검',
  'pages.shareRebate.taskType.reconcile_attribution': '귀속 재점검',
  'pages.shareRebate.taskType.checkout_incident': '체크아웃 오류 기록',
  'pages.shareRebate.scope.all_items': '귀속 주문의 모든 상품',
  'pages.shareRebate.scope.shared_product_only': '공유한 상품만',
  'pages.shareRebate.payoutMode.auto': '자동 지급',
  'pages.shareRebate.payoutMode.manual_approval': '관리자 승인 후 지급',
  'pages.shareRebate.lang.ko': '한국어',
  'pages.shareRebate.lang.en': '영어',
  'pages.shareRebate.lang.zh': '중국어',
  'pages.shareRebate.reasonModal.label': '사유',
  'pages.shareRebate.reasonModal.placeholder': '사유를 입력하세요. 활동 로그와 이력에 남습니다.',
  'pages.shareRebate.reasonModal.required': '사유를 입력해 주세요.',
  'pages.shareRebate.reasonModal.ok': '확인',
  'pages.shareRebate.settings.featureOff': '서버 기능 스위치(FEATURE_SHARE_REBATE)가 꺼져 있어 저장해도 동작하지 않습니다',
  'pages.shareRebate.settings.readOnly': '보기 전용입니다. 수정하려면 공유 리베이트 설정 편집 권한이 필요합니다.',
  'pages.shareRebate.settings.loadFailed': '공유 리베이트 설정을 불러오지 못했습니다.',
  'pages.shareRebate.settings.section.program': '프로그램',
  'pages.shareRebate.settings.section.rates': '일반 요율 — 층 × 출처 (%)',
  'pages.shareRebate.settings.section.periods': '기간·한도',
  'pages.shareRebate.settings.section.sponsor': '윗사람 지정',
  'pages.shareRebate.settings.section.disclosure': '공개 문구 (경제적 이해관계 표시)',
  'pages.shareRebate.settings.state.live': '동작 중',
  'pages.shareRebate.settings.state.off': '꺼짐',
  'pages.shareRebate.settings.lastUpdated': 'v{version} · 마지막 저장 {time} · {admin}',
  'pages.shareRebate.settings.enabled': '공유 리베이트 켜기',
  'pages.shareRebate.settings.enabledHelp': '켜면 공유 링크 방문과 결제가 리베이트로 이어집니다. 서버 기능 스위치도 켜져 있어야 합니다.',
  'pages.shareRebate.settings.payoutMode': '지급 방식',
  'pages.shareRebate.settings.payoutModeHelp': '자동: 확정되면 바로 예치금 적립. 승인: 관리자가 내역에서 지급 승인해야 적립.',
  'pages.shareRebate.settings.scope': '귀속 범위',
  'pages.shareRebate.settings.scopeHelp': '공유 링크로 들어온 구매자의 기간 내 주문 중 어떤 상품을 리베이트 대상으로 볼지 정합니다.',
  'pages.shareRebate.settings.grid.tier': '층',
  'pages.shareRebate.settings.grid.rowTotal': '행 합계',
  'pages.shareRebate.settings.grid.columnTotal': '출처 합계',
  'pages.shareRebate.settings.grid.columnTotalHint': '한 출처의 1~3층 합계 (최대 {max}%)',
  'pages.shareRebate.settings.grid.hint': '결제한 상품금액(쿠폰 할인 뒤, 배송비·수수료 제외) × %. 한 칸은 0~{max}%, 소수 둘째 자리까지, 한 출처의 1~3층 합계는 {total}%를 넘을 수 없습니다. 0%면 그 층·출처는 지급하지 않습니다.',
  'pages.shareRebate.settings.grid.legalNote': '2층 이상 지급은 방문판매법상 다단계판매로 볼 수 있어 운영 반영 전 법률 검토가 필요합니다',
  'pages.shareRebate.settings.field.rate': '{tier} · {source}',
  'pages.shareRebate.settings.field.disclosureText': '공개 문구 ({lang})',
  'pages.shareRebate.settings.windowDays': '귀속 기간',
  'pages.shareRebate.settings.windowDaysHelp': '공유 링크 방문 후 이 기간 안의 결제를 귀속합니다 (1~30일, 마지막 클릭 우선).',
  'pages.shareRebate.settings.creditOnShipmentNote': '리베이트는 주문이 출고완료되면 바로 확정·적립됩니다(배송완료 대기·보류 기간 없음). 출고 전에는 회원 화면에 \'미적립\'으로 보입니다.',
  'pages.shareRebate.settings.holdDays': '보류 기간',
  'pages.shareRebate.settings.holdDaysHelp': '배송완료 후 이 기간이 지나야 확정·지급합니다 (0~60일).',
  'pages.shareRebate.settings.deliveredFallbackDays': '배송완료 간주',
  'pages.shareRebate.settings.deliveredFallbackDaysHelp': '배송완료 기록이 없으면 출고 후 이 기간이 지나면 배송완료로 봅니다 (1~120일).',
  'pages.shareRebate.settings.perOrderCapKRW': '주문당 상한',
  'pages.shareRebate.settings.perOrderCapKRWHelp': '수령자 1명이 주문 1건에서 받을 수 있는 최대 금액. 0 = 없음.',
  'pages.shareRebate.settings.monthlyCapKRW': '월 상한',
  'pages.shareRebate.settings.monthlyCapKRWHelp': '수령자 1명이 한 달(KST)에 받을 수 있는 최대 금액. 넘는 금액은 소멸합니다. 0 = 없음.',
  'pages.shareRebate.settings.minPayoutKRW': '최소 지급액',
  'pages.shareRebate.settings.minPayoutKRWHelp': '확정 시 이보다 작은 금액은 지급하지 않습니다. 0 = 1원 이상 모두 지급.',
  'pages.shareRebate.settings.unit.days': '일',
  'pages.shareRebate.settings.unit.krw': '원',
  'pages.shareRebate.settings.sponsorOnSignup': '공유 방문 중 가입하면 윗사람 지정',
  'pages.shareRebate.settings.sponsorOnSignupHelp': '공유 링크로 들어와 가입한 회원의 윗사람을 그 공유자로 정합니다.',
  'pages.shareRebate.settings.sponsorOnFirstPurchase': '공유로 귀속된 첫 결제 때 윗사람 지정',
  'pages.shareRebate.settings.sponsorOnFirstPurchaseHelp': '윗사람이 없는 회원의 첫 귀속 결제에서 1층 공유자를 윗사람으로 정합니다. 둘 중 먼저 일어난 쪽을 따르고, 자동으로 바뀌지는 않습니다. 기본은 꺼짐 — 기존 회원은 강사 링크에서 [팀 참여]를 눌러야 팀에 들어갑니다.',
  'pages.shareRebate.settings.friendCoupon.title': '친구 첫 구매 쿠폰',
  'pages.shareRebate.settings.friendCoupon.label': '친구에게 줄 쿠폰',
  'pages.shareRebate.settings.friendCoupon.help': '공유 링크로 들어온, 결제한 적 없는 회원에게 1인 1회 자동으로 줍니다. 수량 무제한·사용 중인 일반 상품 할인 쿠폰만 고를 수 있어요. 고른 쿠폰은 공개 쿠폰 목록에 나오지 않고 코드로도 받을 수 없어요.',
  'pages.shareRebate.settings.friendCoupon.none': '사용 안 함',
  'pages.shareRebate.settings.friendCoupon.benefitFixed': '{amount}원 할인',
  'pages.shareRebate.settings.friendCoupon.benefitPercent': '{percent}% 할인',
  'pages.shareRebate.settings.friendCoupon.minPurchase': '최소 {amount}원',
  'pages.shareRebate.settings.friendCoupon.validity': '{n}일',
  'pages.shareRebate.settings.friendCoupon.unavailable': '지금 쓸 수 없는 쿠폰입니다',
  'pages.shareRebate.settings.friendCoupon.unavailableHelp': '저장된 쿠폰이 꺼졌거나 조건(수량 무제한·일반 상품 할인)이 바뀌어 친구에게 주지 않고 있습니다. 다른 쿠폰을 고르거나 [사용 안 함]으로 바꿔 저장하세요.',
  'pages.shareRebate.settings.friendCoupon.unavailableOption': '지금 쓸 수 없는 쿠폰 ({id})',
  'pages.shareRebate.settings.friendCoupon.noCandidates': '고를 수 있는 쿠폰이 없습니다. 쿠폰 관리에서 수량 무제한·사용 중인 일반 상품 할인 쿠폰(가입·추천 자동 지급 쿠폰 제외)을 먼저 만들어 주세요.',
  'pages.shareRebate.settings.friendCoupon.loadFailed': '쿠폰 목록을 불러오지 못했습니다.',
  'pages.shareRebate.settings.banner.title': '상품 상세 공유 배너',
  'pages.shareRebate.settings.banner.help': '상품 상세페지에서 공유 단추 대신 이 그림을 보이고, 누르면 공유 창이 열립니다. 공유 적립이 되는 상품(프로그램 켜짐 + 그 상품 출처의 1층 요율이 0보다 큼)에서만 보이고, 그 밖의 상품에는 기존 공유 단추가 그대로 보입니다. 저장 후 상점에 보이기까지 최대 5분 걸릴 수 있습니다.',
  'pages.shareRebate.settings.banner.enabled': '배너 보이기',
  'pages.shareRebate.settings.banner.state.on': '켜짐',
  'pages.shareRebate.settings.banner.state.off': '꺼짐',
  'pages.shareRebate.settings.banner.pcImage': 'PC 이미지 (필수)',
  'pages.shareRebate.settings.banner.mobileImage': '모바일 이미지 (선택)',
  'pages.shareRebate.settings.banner.pcHint': 'PC 구매 단추 아래(폭 약 350~366px)에 폭을 맞춰 보입니다. 잘리지 않고 높이는 그림 비율대로입니다. 올리면 투명 여백을 잘라내고 가로 최대 1200px WebP 로 바꿔 저장합니다. 권장: 가로로 긴 그림 {size} 안팎.',
  'pages.shareRebate.settings.banner.mobileHint': '휴대폰에서는 수량 아래에 화면 폭(최대 480px)에 맞춰 보입니다. 비우면 PC 이미지를 씁니다.',
  'pages.shareRebate.settings.banner.mobileFallback': 'PC 이미지를 씁니다',
  'pages.shareRebate.settings.banner.uploadInfo': '저장됨: {size} · {kb}KB WebP',
  'pages.shareRebate.settings.banner.uploadInfoTrimmed': '저장됨: {size} · {kb}KB WebP (투명 여백을 잘라냈습니다)',
  'pages.shareRebate.settings.banner.upload': '이미지 올리기',
  'pages.shareRebate.settings.banner.change': '이미지 바꾸기',
  'pages.shareRebate.settings.banner.clear': '지우기',
  'pages.shareRebate.settings.banner.uploaded': '이미지를 올렸습니다. [배너 저장]을 눌러야 반영됩니다.',
  'pages.shareRebate.settings.banner.uploadFailed': '이미지를 올리지 못했습니다.',
  'pages.shareRebate.settings.banner.notImage': 'JPG·PNG·GIF·WEBP 이미지만 올릴 수 있습니다.',
  'pages.shareRebate.settings.banner.tooLarge': '{max}MB 이하 이미지만 올릴 수 있습니다.',
  'pages.shareRebate.settings.banner.save': '배너 저장',
  'pages.shareRebate.settings.banner.reset': '되돌리기',
  'pages.shareRebate.settings.banner.saved': '배너를 저장했습니다.',
  'pages.shareRebate.settings.banner.saveFailed': '배너를 저장하지 못했습니다.',
  'pages.shareRebate.settings.banner.needPcImage': '배너를 켜려면 PC 이미지를 올려 주세요.',
  'pages.shareRebate.settings.banner.programOff': '공유 리베이트 프로그램이 꺼져 있어 지금은 상점에 배너가 보이지 않습니다. 프로그램이 켜지면 공유 적립이 되는 상품에 보입니다.',
  'pages.shareRebate.settings.banner.unsaved': '저장 안 한 배너 변경이 있습니다.',
  'pages.shareRebate.settings.banner.separateSave': '배너는 위 요율 설정과 따로 저장되며 변경 이력·사유를 남기지 않습니다.',
  'pages.shareRebate.settings.banner.lastUpdated': '마지막 저장 {time} · {admin}',
  'pages.shareRebate.settings.disclosureHelp': '공유 메시지 첫 줄에 붙는 경제적 이해관계 표시입니다(추천·보증 심사지침). "받을 수 있음" 같은 조건부 표현은 인정되지 않습니다. 최대 300자.',
  'pages.shareRebate.settings.error.intRange': '{min}~{max} 사이의 정수를 입력하세요.',
  'pages.shareRebate.settings.error.rateRange': '{cell}: 0~{max}% 사이여야 합니다.',
  'pages.shareRebate.settings.error.ratePrecision': '{cell}: 소수 둘째 자리까지 입력할 수 있습니다.',
  'pages.shareRebate.settings.error.sourceTotal': '{source}: 1~3층 합계 {total}가 {max}%를 넘습니다.',
  'pages.shareRebate.settings.error.gridInvalid': '요율 표를 고쳐 주세요.',
  'pages.shareRebate.settings.error.disclosureRequired': '공개 문구를 입력하세요.',
  'pages.shareRebate.settings.error.disclosureTooLong': '최대 {max}자까지 입력할 수 있습니다.',
  'pages.shareRebate.settings.error.fixFirst': '입력 오류를 먼저 고쳐 주세요.',
  'pages.shareRebate.settings.noChanges': '바뀐 내용이 없습니다.',
  'pages.shareRebate.settings.unsaved': '저장하지 않은 변경 {n}건',
  'pages.shareRebate.settings.noUnsaved': '변경 없음',
  'pages.shareRebate.settings.reset': '되돌리기',
  'pages.shareRebate.settings.save': '저장',
  'pages.shareRebate.settings.saveSuccess': '공유 리베이트 설정을 저장했습니다.',
  'pages.shareRebate.settings.saveFailed': '저장하지 못했습니다.',
  'pages.shareRebate.settings.confirm.title': '설정 변경 확인',
  'pages.shareRebate.settings.confirm.intro': '다음 {n}건이 바뀝니다.',
  'pages.shareRebate.settings.confirm.reason': '변경 사유',
  'pages.shareRebate.settings.confirm.reasonPlaceholder': '왜 바꾸는지 적어 주세요. 변경 이력에 남습니다.',
  'pages.shareRebate.settings.confirm.appliesToNew': '바뀐 요율은 저장 뒤 새로 귀속되는 주문부터 적용됩니다. 이미 귀속된 주문은 그때의 요율을 유지합니다.',
  'pages.shareRebate.settings.conflict.title': '다른 관리자가 먼저 저장했습니다',
  'pages.shareRebate.settings.conflict.content': '다른 관리자가 먼저 설정을 저장했습니다. 새로고침해서 최신 값을 불러온 뒤 다시 저장하세요. (지금 입력한 값은 사라집니다)',
  'pages.shareRebate.settings.conflict.reload': '새로고침',
  'pages.shareRebate.settings.change.field': '항목',
  'pages.shareRebate.settings.change.before': '이전',
  'pages.shareRebate.settings.change.after': '변경',
  'pages.shareRebate.settings.history.title': '변경 이력',
  'pages.shareRebate.settings.history.version': '버전',
  'pages.shareRebate.settings.history.changes': '바뀐 항목',
  'pages.shareRebate.settings.history.more': '외 {n}건',
  'pages.shareRebate.settings.history.noChanges': '바뀐 항목 없음',
  'pages.shareRebate.settings.history.admin': '관리자',
  'pages.shareRebate.settings.history.reason': '사유',
  'pages.shareRebate.settings.history.time': '시각 (KST)',
  'pages.shareRebate.settings.value.on': '켜짐',
  'pages.shareRebate.settings.value.off': '꺼짐',
  'pages.shareRebate.settings.value.none': '없음',
  'pages.shareRebate.settings.value.days': '{n}일',
  'pages.shareRebate.settings.value.krw': '{amount}원',
  'pages.shareRebate.monitor.tab.dashboard': '대시보드',
  'pages.shareRebate.monitor.tab.records': '내역',
  'pages.shareRebate.monitor.tab.sharers': '공유자',
  'pages.shareRebate.monitor.loadFailed': '불러오지 못했습니다.',
  'pages.shareRebate.monitor.dashboard.range': '기간',
  'pages.shareRebate.monitor.dashboard.last30': '최근 30일',
  'pages.shareRebate.monitor.dashboard.kstNote': '날짜는 한국 시간(KST) 기준입니다.',
  'pages.shareRebate.monitor.kpi.visits': '방문',
  'pages.shareRebate.monitor.kpi.uniqueVisitors': '순 방문자',
  'pages.shareRebate.monitor.kpi.attributedOrders': '귀속 주문',
  'pages.shareRebate.monitor.kpi.conversionRate': '전환율',
  'pages.shareRebate.monitor.kpi.conversionHint': '귀속 주문 ÷ 방문',
  'pages.shareRebate.monitor.kpi.attributedGmv': '귀속 매출',
  'pages.shareRebate.monitor.kpi.attributedGmvHint': '쿠폰 반영 상품금액 합계 (진행 중·정산 끝)',
  'pages.shareRebate.monitor.kpi.pending': '적립 예정 (보류 포함)',
  'pages.shareRebate.monitor.kpi.confirmed': '확정',
  'pages.shareRebate.monitor.kpi.paid': '지급 (회수 뺌)',
  'pages.shareRebate.monitor.kpi.reversed': '회수',
  'pages.shareRebate.monitor.chart.title': '일별 추이',
  'pages.shareRebate.monitor.chart.visits': '방문',
  'pages.shareRebate.monitor.chart.orders': '귀속 주문',
  'pages.shareRebate.monitor.chart.rebate': '적립액 (원)',
  'pages.shareRebate.monitor.byTier.title': '층별',
  'pages.shareRebate.monitor.byTier.tier': '층',
  'pages.shareRebate.monitor.byTier.rows': '건수',
  'pages.shareRebate.monitor.byTier.open': '미지급',
  'pages.shareRebate.monitor.byTier.paid': '지급',
  'pages.shareRebate.monitor.top.recipientsTitle': '상위 수령자',
  'pages.shareRebate.monitor.top.productsTitle': '상위 상품',
  'pages.shareRebate.monitor.top.member': '회원',
  'pages.shareRebate.monitor.top.product': '상품',
  'pages.shareRebate.monitor.top.source': '출처',
  'pages.shareRebate.monitor.top.orders': '주문',
  'pages.shareRebate.monitor.top.net': '귀속 금액',
  'pages.shareRebate.monitor.health.title': '정산 상태',
  'pages.shareRebate.monitor.health.failedTasks': '실패한 작업',
  'pages.shareRebate.monitor.health.needsReview': '검토 필요',
  'pages.shareRebate.monitor.health.awaitingPayment': '결제 대기 귀속',
  'pages.shareRebate.monitor.health.runNow': '지금 정산 실행',
  'pages.shareRebate.monitor.health.runNowConfirm': '지금 정산을 실행할까요?',
  'pages.shareRebate.monitor.health.runNowContent': '결제 확인·확정 판정·지급(자동 지급 모드)을 한 번 돌립니다. 2분마다 자동으로도 돕니다.',
  'pages.shareRebate.monitor.health.runNowDone': '정산 실행 완료 — 작업 {tasks} · 활성화 {activated} · 재점검 {reconciled} · 지급 {paid} ({ms}ms)',
  'pages.shareRebate.monitor.health.runNowSkipped': '이미 정산이 실행 중입니다. 잠시 뒤 다시 시도하세요.',
  'pages.shareRebate.monitor.health.attributionsInRange': '기간 내 귀속:',
  'pages.shareRebate.monitor.tasks.title': '실패한 작업',
  'pages.shareRebate.monitor.tasks.type': '종류',
  'pages.shareRebate.monitor.tasks.ref': '대상',
  'pages.shareRebate.monitor.tasks.attempts': '시도',
  'pages.shareRebate.monitor.tasks.lastError': '마지막 오류',
  'pages.shareRebate.monitor.tasks.updatedAt': '시각',
  'pages.shareRebate.monitor.tasks.retry': '재시도',
  'pages.shareRebate.monitor.tasks.retrySuccess': '재시도를 예약했습니다. 다음 정산 주기에 실행됩니다.',
  'pages.shareRebate.monitor.tasks.empty': '실패한 작업이 없습니다.',
  'pages.shareRebate.monitor.review.title': '검토 필요 귀속',
  'pages.shareRebate.monitor.review.order': '주문',
  'pages.shareRebate.monitor.review.riskFlags': '위험 표시',
  'pages.shareRebate.monitor.review.reconcile': '재점검',
  'pages.shareRebate.monitor.review.reconcileSuccess': '다시 점검했습니다.',
  'pages.shareRebate.monitor.review.empty': '검토할 귀속이 없습니다.',
  'pages.shareRebate.monitor.records.filter.from': '시작일 (KST)',
  'pages.shareRebate.monitor.records.filter.to': '종료일 (KST)',
  'pages.shareRebate.monitor.records.filter.statusAll': '전체 상태',
  'pages.shareRebate.monitor.records.filter.tier': '층',
  'pages.shareRebate.monitor.records.filter.source': '출처',
  'pages.shareRebate.monitor.records.filter.recipient': '수령자 (사서함·이름)',
  'pages.shareRebate.monitor.records.filter.sharer': '공유자 (사서함·이름)',
  'pages.shareRebate.monitor.records.filter.buyer': '구매자 (사서함·이름)',
  'pages.shareRebate.monitor.records.filter.orderNo': '주문번호',
  'pages.shareRebate.monitor.records.filter.code': '내역 코드',
  'pages.shareRebate.monitor.records.filter.attribution': '귀속 …{id} 의 층별 내역만',
  'pages.shareRebate.monitor.records.totals': '조건 합계',
  'pages.shareRebate.monitor.records.col.code': '코드',
  'pages.shareRebate.monitor.records.col.createdAt': '생성일시',
  'pages.shareRebate.monitor.records.col.status': '상태',
  'pages.shareRebate.monitor.records.col.tier': '층',
  'pages.shareRebate.monitor.records.col.recipient': '수령자',
  'pages.shareRebate.monitor.records.col.sharer': '공유자',
  'pages.shareRebate.monitor.records.col.buyer': '구매자',
  'pages.shareRebate.monitor.records.col.orderNo': '주문번호',
  'pages.shareRebate.monitor.records.col.sources': '출처 %',
  'pages.shareRebate.monitor.records.col.base': '기준 금액',
  'pages.shareRebate.monitor.records.col.amount': '현재 금액',
  'pages.shareRebate.monitor.records.col.paid': '지급액',
  'pages.shareRebate.monitor.records.col.forfeited': '상한 소멸',
  'pages.shareRebate.monitor.records.col.reversed': '회수액',
  'pages.shareRebate.monitor.records.col.eligibleAt': '출고완료(적립 기준)',
  'pages.shareRebate.monitor.records.col.paidAt': '지급일시',
  'pages.shareRebate.monitor.records.col.actions': '작업',
  'pages.shareRebate.monitor.records.productMore': '{title} 외 {n}건',
  'pages.shareRebate.monitor.records.amountReduced': '적립 {gross} · 차감 {reduction}',
  'pages.shareRebate.monitor.records.sourceTooltip': '기준 ₩{base} → 적립 ₩{amount}',
  'pages.shareRebate.monitor.records.deemed': '배송 간주',
  'pages.shareRebate.monitor.records.deemedHint': '배송완료 기록이 없어 출고 후 기간으로 배송완료를 간주했습니다.',
  'pages.shareRebate.monitor.records.manualConfirm': '수동 확정',
  'pages.shareRebate.monitor.records.sameAttribution': '같은 귀속의 층별 내역만 보기',
  'pages.shareRebate.monitor.records.action.hold': '보류',
  'pages.shareRebate.monitor.records.action.release': '보류 해제',
  'pages.shareRebate.monitor.records.action.cancel': '취소',
  'pages.shareRebate.monitor.records.action.confirm': '즉시 확정',
  'pages.shareRebate.monitor.records.action.reverse': '회수',
  'pages.shareRebate.monitor.records.action.pay': '지급 승인',
  'pages.shareRebate.monitor.records.action.holdDesc': '{code}을(를) 보류합니다. 보류 중에는 확정·지급되지 않습니다.',
  'pages.shareRebate.monitor.records.action.releaseDesc': '{code}의 보류를 풀고 적립 예정으로 되돌립니다. 출고완료됐으면 다음 점검에서 확정·지급됩니다.',
  'pages.shareRebate.monitor.records.action.cancelDesc': '{code}을(를) 취소합니다. 적립 예정 금액 ₩{amount}은(는) 지급되지 않으며 되돌릴 수 없습니다.',
  'pages.shareRebate.monitor.records.action.confirmDesc': '{code}이(가) 속한 귀속 전체를 출고완료를 기다리지 않고 확정합니다(자동 지급 모드면 바로 지급). 환불이 진행 중인 주문은 확정할 수 없습니다.',
  'pages.shareRebate.monitor.records.action.reverseDesc': '{code}의 지급분 중 남은 ₩{outstanding}을(를) 예치금에서 회수합니다. 되돌릴 수 없습니다.',
  'pages.shareRebate.monitor.records.action.payDesc': '{code}의 ₩{amount}을(를) 지금 예치금으로 지급합니다.',
  'pages.shareRebate.monitor.records.action.payConfirmTitle': '지급 승인',
  'pages.shareRebate.monitor.records.action.modalTitle': '{action} — {code}',
  'pages.shareRebate.monitor.records.action.success': '{code}: {action} 완료',
  'pages.shareRebate.monitor.sharers.searchPlaceholder': '사서함·아이디·닉네임·이메일',
  'pages.shareRebate.monitor.sharers.col.member': '회원',
  'pages.shareRebate.monitor.sharers.col.sponsor': '윗사람',
  'pages.shareRebate.monitor.sharers.col.suspended': '상태',
  'pages.shareRebate.monitor.sharers.col.directDownline': '직접 팀원',
  'pages.shareRebate.monitor.sharers.col.visits': '방문',
  'pages.shareRebate.monitor.sharers.col.rows': '내역',
  'pages.shareRebate.monitor.sharers.col.open': '미지급',
  'pages.shareRebate.monitor.sharers.col.paid': '지급',
  'pages.shareRebate.monitor.sharers.col.actions': '작업',
  'pages.shareRebate.monitor.sharers.noSponsor': '없음',
  'pages.shareRebate.monitor.sharers.suspendedTag': '정지',
  'pages.shareRebate.monitor.sharers.activeTag': '정상',
  'pages.shareRebate.monitor.sharers.detail': '상세',
  'pages.shareRebate.monitor.sharers.drawerTitle': '공유자 상세',
  'pages.shareRebate.monitor.sharers.member': '회원',
  'pages.shareRebate.monitor.sharers.userId': '아이디',
  'pages.shareRebate.monitor.sharers.email': '이메일',
  'pages.shareRebate.monitor.sharers.phone': '전화',
  'pages.shareRebate.monitor.sharers.joinedAt': '가입일',
  'pages.shareRebate.monitor.sharers.shareLinks': '공유 링크',
  'pages.shareRebate.monitor.sharers.visits': '방문',
  'pages.shareRebate.monitor.sharers.visitsValue': '{total} (최근 30일 {recent})',
  'pages.shareRebate.monitor.sharers.attributedOrders': '귀속 주문',
  'pages.shareRebate.monitor.sharers.cancelled': '취소',
  'pages.shareRebate.monitor.sharers.suspendedInfo': '정지됨 — {time} · {admin} · {reason}',
  'pages.shareRebate.monitor.sharers.sponsorTitle': '윗사람',
  'pages.shareRebate.monitor.sharers.sponsorCurrent': '현재 윗사람',
  'pages.shareRebate.monitor.sharers.sponsorSource': '지정 경로',
  'pages.shareRebate.monitor.sharers.sponsorAssignedAt': '지정일',
  'pages.shareRebate.monitor.sharers.sponsorPick': '새 윗사람 검색 (사서함·닉네임)',
  'pages.shareRebate.monitor.sharers.sponsorNotFound': '회원을 찾지 못했습니다',
  'pages.shareRebate.monitor.sharers.sponsorChange': '윗사람 변경',
  'pages.shareRebate.monitor.sharers.sponsorClear': '윗사람 비우기',
  'pages.shareRebate.monitor.sharers.sponsorSelf': '자기 자신을 윗사람으로 지정할 수 없습니다.',
  'pages.shareRebate.monitor.sharers.sponsorHint': '윗사람을 바꾸면 이후 귀속되는 주문부터 적용됩니다. 이미 생긴 내역은 바뀌지 않습니다. 순환 관계는 서버가 막습니다.',
  'pages.shareRebate.monitor.sharers.sponsorChangeDesc': '{member}의 윗사람을 {from}에서 {to}(으)로 바꿉니다.',
  'pages.shareRebate.monitor.sharers.sponsorClearDesc': '{member}의 윗사람({from})을 비웁니다. 이후 귀속에서 2·3층이 없어집니다.',
  'pages.shareRebate.monitor.sharers.suspend': '공유자 정지',
  'pages.shareRebate.monitor.sharers.suspendDesc': '{member}을(를) 정지합니다. 적립 예정·확정 내역이 모두 보류되고, 정지 중에는 공유 리베이트를 받지 못합니다.',
  'pages.shareRebate.monitor.sharers.unsuspend': '정지 해제',
  'pages.shareRebate.monitor.sharers.unsuspendDesc': '{member}의 정지를 풉니다. 보류된 내역은 자동으로 풀리지 않으니 내역 탭에서 하나씩 보류 해제하세요.',
  'pages.shareRebate.monitor.sharers.actionSuccess': '반영했습니다.',
  'pages.shareRebate.monitor.sharers.actionFailed': '처리하지 못했습니다.',
  'pages.shareRebate.monitor.sharers.downlineTab': '팀 ({tier1}/{tier2}/{tier3})',
  'pages.shareRebate.monitor.sharers.downlineCounts': '직접 {tier1}명 · 2단계 {tier2}명 · 3단계 {tier3}명 (아래는 직접 초대한 팀원, 최대 100명)',
  'pages.shareRebate.monitor.sharers.visitsTab': '최근 방문',
  'pages.shareRebate.monitor.sharers.visitTime': '시각',
  'pages.shareRebate.monitor.sharers.visitLanding': '착지 경로',
  'pages.shareRebate.monitor.sharers.visitChannel': '채널',
  'pages.shareRebate.monitor.sharers.visitBuyer': '구매자',
  'pages.shareRebate.monitor.sharers.visitAttributed': '귀속',
  'pages.shareRebate.monitor.sharers.rowsTab': '최근 내역',
  'pages.shareRebate.monitor.sharers.viewAllRows': '이 회원의 전체 내역 보기',
  'pages.shareRebate.monitor.sharers.historyTab': '관계 이력',
  'pages.shareRebate.monitor.sharers.historyTime': '시각',
  'pages.shareRebate.monitor.sharers.historyAction': '구분',
  'pages.shareRebate.monitor.sharers.historyChange': '변경',
  'pages.shareRebate.monitor.sharers.historySource': '경로',
  'pages.shareRebate.monitor.sharers.historyAdmin': '관리자',
  'pages.shareRebate.monitor.sharers.historyReason': '사유',
  'pages.orders.detail.shareAttribution.title': '공유 귀속',
  'pages.orders.detail.shareAttribution.sharer': '공유자',
  'pages.orders.detail.shareAttribution.buyer': '구매자',
  'pages.orders.detail.shareAttribution.attributedAt': '귀속 시각',
  'pages.orders.detail.shareAttribution.visit': '방문',
  'pages.orders.detail.shareAttribution.visitId': '방문 ID {id}',
  'pages.orders.detail.shareAttribution.delivered': '배송완료',
  'pages.orders.detail.shareAttribution.deemed': '간주',
  'pages.orders.detail.shareAttribution.eligible': '출고완료',
  'pages.orders.detail.shareAttribution.manualConfirm': '수동 확정',
  'pages.orders.detail.shareAttribution.totalNet': '귀속 금액',
  'pages.orders.detail.shareAttribution.riskFlags': '위험 표시',
  'pages.orders.detail.shareAttribution.none': '없음',
  'pages.orders.detail.shareAttribution.skipped': '빠진 층',
  'pages.orders.detail.shareAttribution.viewRecords': '공유 리베이트 내역에서 보기',
  'pages.orders.detail.shareAttribution.tier': '층',
  'pages.orders.detail.shareAttribution.recipient': '수령자',
  'pages.orders.detail.shareAttribution.rate': '요율',
  'pages.orders.detail.shareAttribution.amount': '금액',
  'pages.orders.detail.shareAttribution.paid': '지급',
  'pages.orders.detail.shareAttribution.status': '상태',
  'pages.orders.detail.shareAttribution.noRows': '아직 층별 내역이 없습니다 (결제 확인 전)',
  'pages.orders.detail.shareAttribution.lines': '귀속된 상품',
  'pages.orders.detail.shareAttribution.product': '상품',
  'pages.orders.detail.shareAttribution.source': '출처',
  'pages.orders.detail.shareAttribution.quantity': '수량',
  'pages.orders.detail.shareAttribution.net': '귀속 금액',
  'pages.orders.detail.shareAttribution.netHint': '상품금액 ₩{gross} × 쿠폰 반영 {factor}',
  // 공유 리베이트 round 2 — 강사 · 팀 · 성과(퍼널)
  'pages.orders.detail.shareAttribution.instructorRate': '강사 요율',
  'pages.orders.detail.shareAttribution.instructorRateHint': '주문 시점에 받는 사람이 강사여서 강사 요율로 계산한 층입니다.',
  'pages.shareRebate.role.member': '일반',
  'pages.shareRebate.role.instructor': '강사',
  'pages.shareRebate.relationSource.join': '강사 팀 참여',
  'pages.shareRebate.reasonModal.labelOptional': '사유 (선택)',
  'pages.shareRebate.reasonModal.memoLabel': '내부 메모',
  'pages.shareRebate.reasonModal.memoHelp': '관리자끼리만 보는 메모입니다. 회원에게는 보이지 않습니다.',
  'pages.shareRebate.reasonModal.memoPlaceholder': '심사 메모, 연락 내용 등',
  'pages.shareRebate.settings.section.instructorRates': '강사 요율 — 층 × 출처 (%)',
  'pages.shareRebate.settings.field.memberRate': '일반 요율 · {tier} · {source}',
  'pages.shareRebate.settings.field.instructorRate': '강사 요율 · {tier} · {source}',
  'pages.shareRebate.settings.instructor.hint': '받는 사람이 승인된 강사이면 그 층은 이 표로 계산합니다. 역할은 주문(체크아웃) 시점에 정해지므로 강사를 해제해도 이미 생긴 적립은 그대로입니다. 처음에는 일반 요율과 같습니다.',
  'pages.shareRebate.settings.instructor.diffCount': '일반과 다른 칸 {n}개',
  'pages.shareRebate.settings.instructor.sameAsMember': '일반 요율과 같음',
  'pages.shareRebate.settings.instructor.copyFromMember': '일반 요율 복사',
  'pages.shareRebate.settings.instructor.copyHint': '강사 표를 지금 일반 요율 표와 똑같이 맞춥니다. 저장해야 반영됩니다.',
  'pages.shareRebate.settings.instructor.cellDiff': '일반 요율 {member}',
  'pages.shareRebate.settings.instructor.tableTotal': '강사 표 합계',
  'pages.shareRebate.settings.instructor.mixedTotal': '혼합 최대 합계',
  'pages.shareRebate.settings.instructor.mixedTotalHint': '한 주문의 체인에는 일반 회원과 강사가 섞일 수 있습니다(예: 1층 일반 회원, 2층 강사). 그래서 층마다 일반·강사 요율 중 큰 값을 더한 합계도 출처마다 {max}%를 넘을 수 없습니다.',
  'pages.shareRebate.settings.instructor.legalBoth': '일반 요율과 강사 요율 두 표를 함께 봅니다.',
  'pages.shareRebate.settings.error.mixedTotal': '{source}: 혼합 최대 합계 {total}가 {max}%를 넘습니다. 강사 요율을 낮추거나 [일반 요율 복사]를 누르세요.',
  'pages.shareRebate.monitor.tab.instructors': '강사',
  'pages.shareRebate.monitor.tab.instructorsPending': '심사 대기 {n}건',
  'pages.shareRebate.monitor.instructors.title': '강사',
  'pages.shareRebate.monitor.instructors.approved': '승인된 강사',
  'pages.shareRebate.monitor.instructors.pending': '심사 대기',
  'pages.shareRebate.monitor.instructors.viewList': '강사 목록',
  'pages.shareRebate.monitor.instructors.review': '심사하기',
  'pages.shareRebate.monitor.instructors.byRoleHint': '기간에 생긴 적립을 받는 사람의 역할로 나눈 합계 (취소 제외)',
  'pages.shareRebate.monitor.instructors.role': '구분',
  'pages.shareRebate.monitor.instructors.topTitle': '상위 강사',
  'pages.shareRebate.monitor.instructors.member': '강사',
  'pages.shareRebate.monitor.instructors.rowsHint': '기간에 강사 요율로 생긴 적립 건수',
  'pages.shareRebate.monitor.instructors.teamRows': '팀 경유',
  'pages.shareRebate.monitor.instructors.teamRowsHint': '그중 팀원의 링크로 들어온 주문(2·3층) 건수',
  'pages.shareRebate.monitor.instructors.topEmpty': '기간에 강사 요율로 생긴 적립이 없습니다.',
  'pages.shareRebate.monitor.records.filter.recipientRole': '수령자 구분',
  'pages.shareRebate.monitor.records.col.recipientRole': '수령자 구분',
  'pages.shareRebate.monitor.records.col.recipientRoleHint': '주문 시점의 역할입니다. 강사면 강사 요율로 계산했습니다.',
  'pages.shareRebate.monitor.records.via': '경유',
  'pages.shareRebate.monitor.records.viaHint': '받는 사람이 직접 초대한 팀원입니다. 이 팀원(2층) 또는 이 팀원이 초대한 분(3층)의 링크로 들어온 주문입니다.',
  'pages.shareRebate.monitor.sharers.col.role': '역할',
  'pages.shareRebate.monitor.sharers.col.roleHint': '지금 승인된 강사인지 보여 줍니다.',
  'pages.shareRebate.monitor.sharers.filter.role': '역할',
  'pages.shareRebate.monitor.sharers.performanceTab': '성과',
  'pages.shareRebate.instructor.tag': '강사',
  'pages.shareRebate.instructor.tagTooltip': '강사 활동명: {name}',
  'pages.shareRebate.instructor.status.pending': '심사 대기',
  'pages.shareRebate.instructor.status.approved': '승인',
  'pages.shareRebate.instructor.status.rejected': '반려',
  'pages.shareRebate.instructor.status.revoked': '해제',
  'pages.shareRebate.instructor.status.withdrawn': '신청 취소',
  'pages.shareRebate.instructor.status.none': '신청 없음',
  'pages.shareRebate.instructor.filter.all': '전체',
  'pages.shareRebate.instructor.history.applied': '신청',
  'pages.shareRebate.instructor.history.updated': '신청 수정',
  'pages.shareRebate.instructor.history.approved': '승인',
  'pages.shareRebate.instructor.history.rejected': '반려',
  'pages.shareRebate.instructor.history.revoked': '해제',
  'pages.shareRebate.instructor.history.withdrawn': '신청 취소',
  'pages.shareRebate.instructor.history.designated': '관리자 지정',
  'pages.shareRebate.instructor.searchPlaceholder': '활동명·사서함·아이디·닉네임·이메일',
  'pages.shareRebate.instructor.pendingHint': '심사 대기는 먼저 신청한 순서로 보입니다.',
  'pages.shareRebate.instructor.empty': '해당하는 강사가 없습니다.',
  'pages.shareRebate.instructor.emptyPending': '심사할 강사 신청이 없습니다.',
  'pages.shareRebate.instructor.col.member': '회원',
  'pages.shareRebate.instructor.col.displayName': '활동명',
  'pages.shareRebate.instructor.col.application': '신청 내용',
  'pages.shareRebate.instructor.col.status': '상태',
  'pages.shareRebate.instructor.col.team': '팀 (직접/2단계/3단계)',
  'pages.shareRebate.instructor.col.teamHint': '이 강사의 팀원 수 — 직접 초대한 분 / 그분들이 초대한 분 / 그다음 단계',
  'pages.shareRebate.instructor.col.mine30': '30일 내 링크',
  'pages.shareRebate.instructor.col.mine30Hint': '최근 30일 동안 이 강사의 링크를 연 사람, 그중 결제한 사람, 이 강사의 1층 적립',
  'pages.shareRebate.instructor.col.team30': '30일 팀',
  'pages.shareRebate.instructor.col.team30Hint': '최근 30일 동안 팀원(직접·2단계)의 링크를 연 사람, 그중 결제한 사람, 이 강사의 2·3층 적립',
  'pages.shareRebate.instructor.col.totals': '누적 적립',
  'pages.shareRebate.instructor.col.totalsHint': '전체 기간 — 지급(회수 뺌)과 미지급(적립 예정·보류·확정)',
  'pages.shareRebate.instructor.col.actions': '처리',
  'pages.shareRebate.instructor.perf.counts': '방문 {visitors} · 결제 {payers}',
  'pages.shareRebate.instructor.perf.rebate': '적립',
  'pages.shareRebate.instructor.perf.activeSharers': '활동 팀원 {n}명',
  'pages.shareRebate.instructor.teamTooltip': '직접 {tier1}명 · 2단계 {tier2}명 · 3단계 {tier3}명',
  'pages.shareRebate.instructor.displayNamePreview': '링크로 들어온 분들에게 “{name} 강사님”으로 보입니다.',
  'pages.shareRebate.instructor.noIntro': '소개 없음',
  'pages.shareRebate.instructor.appliedAt': '신청 {time}',
  'pages.shareRebate.instructor.decidedAt': '{time} · {admin}',
  'pages.shareRebate.instructor.memberReason': '회원에게 보인 사유: {reason}',
  'pages.shareRebate.instructor.memoTooltip': '내부 메모: {memo}',
  'pages.shareRebate.instructor.memberVisibleNotice': '이 사유는 회원 마이페이지에 표시됩니다.',
  'pages.shareRebate.instructor.action.approve': '승인',
  'pages.shareRebate.instructor.action.reject': '반려',
  'pages.shareRebate.instructor.action.revoke': '강사 해제',
  'pages.shareRebate.instructor.action.designate': '강사로 지정',
  'pages.shareRebate.instructor.action.designateNew': '강사 바로 지정',
  'pages.shareRebate.instructor.action.memo': '메모',
  'pages.shareRebate.instructor.action.failed': '처리하지 못했습니다.',
  'pages.shareRebate.instructor.approve.title': '강사 승인 — {member}',
  'pages.shareRebate.instructor.approve.desc': '{member}님을 강사로 승인합니다. 이후 새 주문부터 강사 요율을 적용하고, 링크로 들어온 분들에게는 “{name} 강사님”으로 보입니다. 초대한 분이 없는 기존 회원이 이 링크를 열면 팀 참여 안내도 보입니다.',
  'pages.shareRebate.instructor.approve.reasonPlaceholder': '승인 메모(선택). 처리 이력에만 남고 회원에게는 보이지 않습니다.',
  'pages.shareRebate.instructor.approve.success': '{member}님을 강사로 승인했습니다.',
  'pages.shareRebate.instructor.reject.title': '강사 신청 반려 — {member}',
  'pages.shareRebate.instructor.reject.desc': '{member}님의 강사 신청을 반려합니다. 회원은 사유를 보고 다시 신청할 수 있습니다.',
  'pages.shareRebate.instructor.reject.reasonPlaceholder': '회원이 읽을 사유를 적어 주세요. 예: 채널 주소를 확인할 수 없습니다.',
  'pages.shareRebate.instructor.reject.success': '{member}님의 강사 신청을 반려했습니다.',
  'pages.shareRebate.instructor.revoke.title': '강사 해제 — {member}',
  'pages.shareRebate.instructor.revoke.desc': '“{name}” 강사를 해제합니다. 새 주문부터 일반 요율을 적용하고, 링크의 팀 참여 안내도 더 이상 보이지 않습니다. 이미 생긴 적립과 팀(초대한 분 관계)은 그대로 둡니다.',
  'pages.shareRebate.instructor.revoke.reasonPlaceholder': '회원이 읽을 사유를 적어 주세요.',
  'pages.shareRebate.instructor.revoke.success': '{member}님의 강사를 해제했습니다.',
  'pages.shareRebate.instructor.memo.title': '내부 메모 — {member}',
  'pages.shareRebate.instructor.memo.help': '회원에게 보이지 않습니다. 비우고 저장하면 메모를 지웁니다.',
  'pages.shareRebate.instructor.memo.success': '내부 메모를 저장했습니다.',
  'pages.shareRebate.instructor.designate.title': '강사 바로 지정',
  'pages.shareRebate.instructor.designate.ok': '강사로 지정',
  'pages.shareRebate.instructor.designate.intro': '신청 없이 바로 승인합니다. 예전 신청·반려 기록은 이 내용으로 바뀌고, 이후 새 주문부터 강사 요율을 적용합니다.',
  'pages.shareRebate.instructor.designate.member': '회원',
  'pages.shareRebate.instructor.designate.memberPlaceholder': '사서함·닉네임·아이디로 검색',
  'pages.shareRebate.instructor.designate.memberRequired': '회원을 고르세요.',
  'pages.shareRebate.instructor.designate.reasonHelp': '처리 이력에만 남습니다.',
  'pages.shareRebate.instructor.designate.success': '강사로 지정했습니다.',
  'pages.shareRebate.instructor.designate.footnote': '이미 승인된 강사는 다시 지정할 수 없습니다.',
  'pages.shareRebate.instructor.field.displayName': '활동명',
  'pages.shareRebate.instructor.field.displayNameHelp': '링크로 들어온 분들에게 “OOO 강사님”으로 보이는 공개 이름입니다. 2~20자로 적고, 끝에 ‘강사’·‘강사님’은 붙이지 마세요.',
  'pages.shareRebate.instructor.field.intro': '소개',
  'pages.shareRebate.instructor.field.introOptional': '소개 (선택)',
  'pages.shareRebate.instructor.field.channel': '채널',
  'pages.shareRebate.instructor.field.channelOptional': '채널 주소 (선택)',
  'pages.shareRebate.instructor.field.phone': '연락처',
  'pages.shareRebate.instructor.field.phoneOptional': '연락처 (선택)',
  'pages.shareRebate.instructor.field.phoneHelp': '관리자만 봅니다.',
  'pages.shareRebate.instructor.field.appliedAt': '신청일',
  'pages.shareRebate.instructor.field.decided': '처리',
  'pages.shareRebate.instructor.field.memberReason': '회원에게 보인 사유',
  'pages.shareRebate.instructor.error.displayNameLength': '활동명은 {min}~{max}자로 적어 주세요.',
  'pages.shareRebate.instructor.error.displayNameSuffix': '활동명 끝에 ‘강사’·‘강사님’을 붙이지 마세요. 화면에 “강사님”이 자동으로 붙습니다.',
  'pages.shareRebate.instructor.error.introLength': '소개는 {min}~{max}자로 적어 주세요.',
  'pages.shareRebate.instructor.error.channel': 'http:// 또는 https:// 로 시작하는 주소를 {max}자 이내로 적어 주세요.',
  'pages.shareRebate.instructor.error.phone': '숫자와 하이픈(-)으로 {min}~{max}자를 적어 주세요.',
  'pages.shareRebate.instructor.card.title': '강사',
  'pages.shareRebate.instructor.card.none': '강사 신청 기록이 없습니다.',
  'pages.shareRebate.instructor.card.history': '처리 이력',
  'pages.shareRebate.funnel.period.today': '오늘',
  'pages.shareRebate.funnel.period.7d': '7일',
  'pages.shareRebate.funnel.period.30d': '30일',
  'pages.shareRebate.funnel.period.90d': '90일',
  'pages.shareRebate.funnel.period.all': '전체',
  'pages.shareRebate.funnel.scope.mine': '내 링크',
  'pages.shareRebate.funnel.scope.team': '팀',
  'pages.shareRebate.funnel.scope.mineHint': '기간 안에 이 회원의 링크를 연 사람들이 남긴 가입·주문·결제와 이 회원의 1층 적립입니다. 기간이 끝난 뒤에 생긴 주문도 그 방문에 포함합니다.',
  'pages.shareRebate.funnel.scope.teamHint': '기간 안에 직접 초대한 팀원과 그 팀원이 초대한 분들의 링크를 연 사람들이 남긴 주문·결제와 이 회원의 2·3층 적립입니다.',
  'pages.shareRebate.funnel.range': '{from} ~ {to} (KST)',
  'pages.shareRebate.funnel.rangeAll': '전체 기간 ~ {to} (KST)',
  'pages.shareRebate.funnel.team.counts': '팀원: 직접 {tier1}명 · 2단계 {tier2}명 · 3단계 {tier3}명 · 기간 중 링크 방문이 있었던 팀원 {active}명',
  'pages.shareRebate.funnel.step.visitors': '방문자',
  'pages.shareRebate.funnel.step.visitsSub': '방문 {n}회',
  'pages.shareRebate.funnel.step.orderers': '주문자',
  'pages.shareRebate.funnel.step.ordersSub': '주문 {n}건',
  'pages.shareRebate.funnel.step.payers': '결제자',
  'pages.shareRebate.funnel.step.paidSub': '결제 {n}건',
  'pages.shareRebate.funnel.step.paidGmvSub': '결제 {n}건 · ₩{amount}',
  'pages.shareRebate.funnel.orderRate': '주문 전환',
  'pages.shareRebate.funnel.orderRateHint': '주문자 ÷ 방문자',
  'pages.shareRebate.funnel.payRate': '결제 전환',
  'pages.shareRebate.funnel.payRateHint': '결제자 ÷ 주문자',
  'pages.shareRebate.funnel.joins': '이 방문으로 신규 가입 {signups}명 · 팀 참여 {joins}명',
  'pages.shareRebate.funnel.rebate.total': '적립 합계',
  'pages.shareRebate.funnel.rebate.totalHint': '적립 예정 + 확정 + 지급(회수 뺌). 취소된 적립은 빠집니다.',
  'pages.shareRebate.funnel.rebate.pending': '적립 예정',
  'pages.shareRebate.funnel.rebate.confirmed': '확정',
  'pages.shareRebate.funnel.rebate.paid': '지급',
  'pages.shareRebate.funnel.rebate.reversed': '회수 ₩{amount}',
  'pages.shareRebate.funnel.chart.daily': '일별 추이',
  'pages.shareRebate.funnel.chart.monthly': '월별 추이',
  'pages.shareRebate.funnel.chart.rebate': '적립 (원)',
  'pages.shareRebate.funnel.empty': '이 기간에 링크로 들어온 방문이 없습니다.',
  'pages.shareRebate.funnel.emptyTeam': '이 기간에 팀원의 링크로 들어온 방문이 없습니다.',
  'pages.shareRebate.funnel.cohortNote': '방문한 날을 기준으로 묶은 숫자입니다(나중에 생긴 주문·적립도 그 방문에 포함). {time} 기준',
  'pages.shareRebate.funnel.notSupported': '서버가 아직 성과 집계를 지원하지 않습니다.',
  'pages.shareRebate.picks.tab': '추천 상품',
  'pages.shareRebate.picks.notSupported': '서버가 아직 추천 상품 페이지를 지원하지 않습니다.',
  'pages.shareRebate.picks.empty': '아직 추천 상품 페이지를 만들지 않았습니다.',
  'pages.shareRebate.picks.emptyHint': '강사가 마이페이지에서 추천 상품을 처음 열면 페이지가 만들어집니다.',
  'pages.shareRebate.picks.visible': '지금 링크로 누구나 이 페이지를 볼 수 있습니다.',
  'pages.shareRebate.picks.notVisible': '지금은 링크로 이 페이지를 볼 수 없습니다.',
  'pages.shareRebate.picks.visibilityRule': '강사가 공개로 두고 관리자가 숨기지 않았을 때만 보입니다. 아니면 링크로 들어온 사람에게 “볼 수 없는 페이지”가 보입니다.',
  'pages.shareRebate.picks.field.link': '페이지 링크',
  'pages.shareRebate.picks.field.published': '공개 상태',
  'pages.shareRebate.picks.published': '공개',
  'pages.shareRebate.picks.unpublished': '비공개 (강사 설정)',
  'pages.shareRebate.picks.field.adminHidden': '관리자 숨김',
  'pages.shareRebate.picks.adminHiddenOn': '숨김',
  'pages.shareRebate.picks.adminHiddenOff': '숨기지 않음',
  'pages.shareRebate.picks.adminHiddenSwitchHint': '켜면 공개 페이지를 숨깁니다(사유 필수). 끄면 숨김을 풉니다.',
  'pages.shareRebate.picks.adminHiddenInfo': '{time} · {admin} · 사유: {reason}',
  'pages.shareRebate.picks.field.title': '페이지 제목',
  'pages.shareRebate.picks.defaultTitle': '{name} 강사님의 추천 상품',
  'pages.shareRebate.picks.defaultTitleTag': '기본 제목',
  'pages.shareRebate.picks.field.intro': '소개',
  'pages.shareRebate.picks.field.items': '담긴 상품',
  'pages.shareRebate.picks.counts': '고정 {pinned} · 자동 {auto} · 페이지에서 빠짐 {off}',
  'pages.shareRebate.picks.field.autoSyncedAt': '자동 목록 계산',
  'pages.shareRebate.picks.field.autoSyncedAtHint': '강사가 공유한 상품의 순위(최근 180일 결제자 → 방문자 → 최근 공유 순)는 마지막 계산 뒤 10분이 지나 페이지를 열 때 다시 계산합니다.',
  'pages.shareRebate.picks.itemsTitle': '상품 목록',
  'pages.shareRebate.picks.itemsHint': '고정 상품(강사가 정한 순서) 다음에 자동 상품(순위 순)이 옵니다. 강사 숨김·관리자 숨김·판매 종료 상품은 공개 페이지에서 빠집니다.',
  'pages.shareRebate.picks.itemsEmpty': '담긴 상품이 없습니다.',
  'pages.shareRebate.picks.col.image': '사진',
  'pages.shareRebate.picks.col.source': '출처',
  'pages.shareRebate.picks.col.title': '상품',
  'pages.shareRebate.picks.col.price': '가격',
  'pages.shareRebate.picks.col.origin': '구분',
  'pages.shareRebate.picks.col.status': '상태',
  'pages.shareRebate.picks.col.stats': '방문자 · 결제자',
  'pages.shareRebate.picks.col.statsHint': '자동 상품의 순위 근거 — 최근 180일 동안 이 상품 공유 링크로 들어온 사람과 결제한 사람 수',
  'pages.shareRebate.picks.col.adminHidden': '관리자 숨김',
  'pages.shareRebate.picks.col.adminHiddenHint': '켜면 이 상품이 공개 페이지에서 빠집니다. 강사 화면에는 그대로 남습니다.',
  'pages.shareRebate.picks.openProduct': '상품 페이지 열기',
  'pages.shareRebate.picks.price.unknown': '미확인',
  'pages.shareRebate.picks.price.unknownHint': '가격 정보가 아직 없어 공개 페이지에는 “상품 페이지에서 확인”으로 보입니다.',
  'pages.shareRebate.picks.price.at': '{time} 기준',
  'pages.shareRebate.picks.origin.pinned': '고정',
  'pages.shareRebate.picks.origin.auto': '자동',
  'pages.shareRebate.picks.tag.instructorHidden': '강사 숨김',
  'pages.shareRebate.picks.tag.soldOut': '판매 종료',
  'pages.shareRebate.picks.tag.adminHidden': '관리자 숨김',
  'pages.shareRebate.picks.tag.shown': '노출',
  'pages.shareRebate.picks.stats': '방문 {visitors} · 결제 {payers}',
  'pages.shareRebate.picks.hide.title': '추천 상품 페이지 숨기기',
  'pages.shareRebate.picks.hide.desc': '{name} 강사님의 추천 상품 페이지를 숨깁니다. 링크로 들어온 사람에게는 “볼 수 없는 페이지”가 보입니다. 담긴 상품과 강사 설정은 그대로 남아 숨김을 풀면 되살아납니다.',
  'pages.shareRebate.picks.hide.notice': '사유는 관리자 기록에만 남고 강사 화면에는 보이지 않습니다.',
  'pages.shareRebate.picks.hide.ok': '숨기기',
  'pages.shareRebate.picks.hide.success': '추천 상품 페이지를 숨겼습니다.',
  'pages.shareRebate.picks.unhide.title': '추천 상품 페이지 숨김 해제',
  'pages.shareRebate.picks.unhide.desc': '{name} 강사님의 추천 상품 페이지 숨김을 풉니다. 링크로 다시 볼 수 있게 됩니다.',
  'pages.shareRebate.picks.unhide.descUnpublished': '{name} 강사님의 추천 상품 페이지 숨김을 풉니다. 강사가 비공개로 두어 풀어도 링크로는 볼 수 없습니다.',
  'pages.shareRebate.picks.unhide.ok': '숨김 해제',
  'pages.shareRebate.picks.unhide.success': '추천 상품 페이지 숨김을 해제했습니다.',
  'pages.shareRebate.picks.item.hideSuccess': '이 상품을 공개 페이지에서 뺐습니다.',
  'pages.shareRebate.picks.item.unhideSuccess': '이 상품을 공개 페이지에 다시 보이게 했습니다.',
  'pages.shareRebate.picks.actionFailed': '처리하지 못했습니다.',
};

